// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

/**
 * AccessibilityDeclarationUpdateRequest
 */
export const zAccessibilityDeclarationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['accessibilityDeclarations']),
        id: z.string(),
        attributes: z.optional(z.object({
            publish: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsAudioDescriptions: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsCaptions: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsDarkInterface: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsDifferentiateWithoutColorAlone: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsLargerText: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsReducedMotion: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsSufficientContrast: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsVoiceControl: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsVoiceover: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * AlternativeDistributionDomainCreateRequest
 */
export const zAlternativeDistributionDomainCreateRequest = z.object({
    data: z.object({
        type: z.enum(['alternativeDistributionDomains']),
        attributes: z.object({
            domain: z.string(),
            referenceName: z.string()
        })
    })
});

/**
 * AlternativeDistributionKeyCreateRequest
 */
export const zAlternativeDistributionKeyCreateRequest = z.object({
    data: z.object({
        type: z.enum(['alternativeDistributionKeys']),
        attributes: z.object({
            publicKey: z.string()
        }),
        relationships: z.optional(z.object({
            app: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * AlternativeDistributionPackageCreateRequest
 */
export const zAlternativeDistributionPackageCreateRequest = z.object({
    data: z.object({
        type: z.enum(['alternativeDistributionPackages']),
        relationships: z.object({
            appStoreVersion: z.object({
                data: z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AnalyticsReportRequestCreateRequest
 */
export const zAnalyticsReportRequestCreateRequest = z.object({
    data: z.object({
        type: z.enum(['analyticsReportRequests']),
        attributes: z.object({
            accessType: z.enum(['ONE_TIME_SNAPSHOT', 'ONGOING'])
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AndroidToIosAppMappingDetailCreateRequest
 */
export const zAndroidToIosAppMappingDetailCreateRequest = z.object({
    data: z.object({
        type: z.enum(['androidToIosAppMappingDetails']),
        attributes: z.object({
            packageName: z.string(),
            appSigningKeyPublicCertificateSha256Fingerprints: z.array(z.string())
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AndroidToIosAppMappingDetailUpdateRequest
 */
export const zAndroidToIosAppMappingDetailUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['androidToIosAppMappingDetails']),
        id: z.string(),
        attributes: z.optional(z.object({
            packageName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            appSigningKeyPublicCertificateSha256Fingerprints: z.optional(z.union([
                z.array(z.string()),
                z.null()
            ]))
        }))
    })
});

/**
 * AppClipAdvancedExperienceImageCreateRequest
 */
export const zAppClipAdvancedExperienceImageCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appClipAdvancedExperienceImages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        })
    })
});

/**
 * AppClipAdvancedExperienceImageUpdateRequest
 */
export const zAppClipAdvancedExperienceImageUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appClipAdvancedExperienceImages']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksum: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppClipAppStoreReviewDetailCreateRequest
 */
export const zAppClipAppStoreReviewDetailCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appClipAppStoreReviewDetails']),
        attributes: z.optional(z.object({
            invocationUrls: z.optional(z.union([
                z.array(z.url()),
                z.null()
            ]))
        })),
        relationships: z.object({
            appClipDefaultExperience: z.object({
                data: z.object({
                    type: z.enum(['appClipDefaultExperiences']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppClipAppStoreReviewDetailUpdateRequest
 */
export const zAppClipAppStoreReviewDetailUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appClipAppStoreReviewDetails']),
        id: z.string(),
        attributes: z.optional(z.object({
            invocationUrls: z.optional(z.union([
                z.array(z.url()),
                z.null()
            ]))
        }))
    })
});

/**
 * AppClipDefaultExperienceLocalizationCreateRequest
 */
export const zAppClipDefaultExperienceLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appClipDefaultExperienceLocalizations']),
        attributes: z.object({
            locale: z.string(),
            subtitle: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.object({
            appClipDefaultExperience: z.object({
                data: z.object({
                    type: z.enum(['appClipDefaultExperiences']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppClipDefaultExperienceLocalizationUpdateRequest
 */
export const zAppClipDefaultExperienceLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appClipDefaultExperienceLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            subtitle: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppClipHeaderImageCreateRequest
 */
export const zAppClipHeaderImageCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appClipHeaderImages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            appClipDefaultExperienceLocalization: z.object({
                data: z.object({
                    type: z.enum(['appClipDefaultExperienceLocalizations']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppClipHeaderImageUpdateRequest
 */
export const zAppClipHeaderImageUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appClipHeaderImages']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksum: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

export const zAppCustomProductPageLocalizationInlineCreate = z.object({
    type: z.enum(['appCustomProductPageLocalizations']),
    id: z.optional(z.string()),
    attributes: z.object({
        locale: z.string(),
        promotionalText: z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }),
    relationships: z.optional(z.object({
        appCustomProductPageVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appCustomProductPageVersions']),
                id: z.string()
            }))
        }))
    }))
});

/**
 * AppCustomProductPageLocalizationCreateRequest
 */
export const zAppCustomProductPageLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appCustomProductPageLocalizations']),
        attributes: z.object({
            locale: z.string(),
            promotionalText: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.object({
            appCustomProductPageVersion: z.object({
                data: z.object({
                    type: z.enum(['appCustomProductPageVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppCustomProductPageLocalizationUpdateRequest
 */
export const zAppCustomProductPageLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appCustomProductPageLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            promotionalText: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

export const zAppCustomProductPageVersionInlineCreate = z.object({
    type: z.enum(['appCustomProductPageVersions']),
    id: z.optional(z.string()),
    attributes: z.optional(z.object({
        deepLink: z.optional(z.union([
            z.url(),
            z.null()
        ]))
    })),
    relationships: z.optional(z.object({
        appCustomProductPage: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appCustomProductPages']),
                id: z.string()
            }))
        })),
        appCustomProductPageLocalizations: z.optional(z.object({
            data: z.optional(z.array(z.object({
                type: z.enum(['appCustomProductPageLocalizations']),
                id: z.string()
            })))
        }))
    }))
});

/**
 * AppCustomProductPageVersionCreateRequest
 */
export const zAppCustomProductPageVersionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appCustomProductPageVersions']),
        attributes: z.optional(z.object({
            deepLink: z.optional(z.union([
                z.url(),
                z.null()
            ]))
        })),
        relationships: z.object({
            appCustomProductPage: z.object({
                data: z.object({
                    type: z.enum(['appCustomProductPages']),
                    id: z.string()
                })
            }),
            appCustomProductPageLocalizations: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['appCustomProductPageLocalizations']),
                    id: z.string()
                })))
            }))
        })
    })
});

/**
 * AppCustomProductPageVersionUpdateRequest
 */
export const zAppCustomProductPageVersionUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appCustomProductPageVersions']),
        id: z.string(),
        attributes: z.optional(z.object({
            deepLink: z.optional(z.union([
                z.url(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppCustomProductPageCreateRequest
 */
export const zAppCustomProductPageCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appCustomProductPages']),
        attributes: z.object({
            name: z.string()
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            }),
            appCustomProductPageVersions: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['appCustomProductPageVersions']),
                    id: z.string()
                })))
            })),
            appStoreVersionTemplate: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                }))
            })),
            customProductPageTemplate: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appCustomProductPages']),
                    id: z.string()
                }))
            }))
        })
    }),
    included: z.optional(z.array(z.union([zAppCustomProductPageLocalizationInlineCreate, zAppCustomProductPageVersionInlineCreate])))
});

/**
 * AppCustomProductPageUpdateRequest
 */
export const zAppCustomProductPageUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appCustomProductPages']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            visible: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppEncryptionDeclarationDocumentCreateRequest
 */
export const zAppEncryptionDeclarationDocumentCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appEncryptionDeclarationDocuments']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            appEncryptionDeclaration: z.object({
                data: z.object({
                    type: z.enum(['appEncryptionDeclarations']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppEncryptionDeclarationDocumentUpdateRequest
 */
export const zAppEncryptionDeclarationDocumentUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appEncryptionDeclarationDocuments']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksum: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppEncryptionDeclarationCreateRequest
 */
export const zAppEncryptionDeclarationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appEncryptionDeclarations']),
        attributes: z.object({
            appDescription: z.string(),
            containsProprietaryCryptography: z.boolean(),
            containsThirdPartyCryptography: z.boolean(),
            availableOnFrenchStore: z.boolean()
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppEventLocalizationCreateRequest
 */
export const zAppEventLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appEventLocalizations']),
        attributes: z.object({
            locale: z.string(),
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            shortDescription: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            longDescription: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.object({
            appEvent: z.object({
                data: z.object({
                    type: z.enum(['appEvents']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppEventLocalizationUpdateRequest
 */
export const zAppEventLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appEventLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            shortDescription: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            longDescription: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppEventScreenshotUpdateRequest
 */
export const zAppEventScreenshotUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appEventScreenshots']),
        id: z.string(),
        attributes: z.optional(z.object({
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppEventVideoClipUpdateRequest
 */
export const zAppEventVideoClipUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appEventVideoClips']),
        id: z.string(),
        attributes: z.optional(z.object({
            previewFrameTimeCode: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppEventCreateRequest
 */
export const zAppEventCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appEvents']),
        attributes: z.object({
            referenceName: z.string(),
            badge: z.optional(z.enum([
                'LIVE_EVENT',
                'PREMIERE',
                'CHALLENGE',
                'COMPETITION',
                'NEW_SEASON',
                'MAJOR_UPDATE',
                'SPECIAL_EVENT'
            ])),
            deepLink: z.optional(z.union([
                z.url(),
                z.null()
            ])),
            purchaseRequirement: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            primaryLocale: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            priority: z.optional(z.enum(['HIGH', 'NORMAL'])),
            purpose: z.optional(z.enum([
                'APPROPRIATE_FOR_ALL_USERS',
                'ATTRACT_NEW_USERS',
                'KEEP_ACTIVE_USERS_INFORMED',
                'BRING_BACK_LAPSED_USERS'
            ])),
            territorySchedules: z.optional(z.union([
                z.array(z.object({
                    territories: z.optional(z.array(z.string())),
                    publishStart: z.optional(z.iso.datetime()),
                    eventStart: z.optional(z.iso.datetime()),
                    eventEnd: z.optional(z.iso.datetime())
                })),
                z.null()
            ]))
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppEventUpdateRequest
 */
export const zAppEventUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appEvents']),
        id: z.string(),
        attributes: z.optional(z.object({
            referenceName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            badge: z.optional(z.enum([
                'LIVE_EVENT',
                'PREMIERE',
                'CHALLENGE',
                'COMPETITION',
                'NEW_SEASON',
                'MAJOR_UPDATE',
                'SPECIAL_EVENT'
            ])),
            deepLink: z.optional(z.union([
                z.url(),
                z.null()
            ])),
            purchaseRequirement: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            primaryLocale: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            priority: z.optional(z.enum(['HIGH', 'NORMAL'])),
            purpose: z.optional(z.enum([
                'APPROPRIATE_FOR_ALL_USERS',
                'ATTRACT_NEW_USERS',
                'KEEP_ACTIVE_USERS_INFORMED',
                'BRING_BACK_LAPSED_USERS'
            ])),
            territorySchedules: z.optional(z.union([
                z.array(z.object({
                    territories: z.optional(z.array(z.string())),
                    publishStart: z.optional(z.iso.datetime()),
                    eventStart: z.optional(z.iso.datetime()),
                    eventEnd: z.optional(z.iso.datetime())
                })),
                z.null()
            ]))
        }))
    })
});

/**
 * AppInfoLocalizationCreateRequest
 */
export const zAppInfoLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appInfoLocalizations']),
        attributes: z.object({
            locale: z.string(),
            name: z.string(),
            subtitle: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            privacyPolicyUrl: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            privacyChoicesUrl: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            privacyPolicyText: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.object({
            appInfo: z.object({
                data: z.object({
                    type: z.enum(['appInfos']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppInfoLocalizationUpdateRequest
 */
export const zAppInfoLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appInfoLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            subtitle: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            privacyPolicyUrl: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            privacyChoicesUrl: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            privacyPolicyText: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppInfoUpdateRequest
 */
export const zAppInfoUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appInfos']),
        id: z.string(),
        relationships: z.optional(z.object({
            primaryCategory: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appCategories']),
                    id: z.string()
                }))
            })),
            primarySubcategoryOne: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appCategories']),
                    id: z.string()
                }))
            })),
            primarySubcategoryTwo: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appCategories']),
                    id: z.string()
                }))
            })),
            secondaryCategory: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appCategories']),
                    id: z.string()
                }))
            })),
            secondarySubcategoryOne: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appCategories']),
                    id: z.string()
                }))
            })),
            secondarySubcategoryTwo: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appCategories']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * AppPreviewCreateRequest
 */
export const zAppPreviewCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appPreviews']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string(),
            previewFrameTimeCode: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            mimeType: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.object({
            appPreviewSet: z.object({
                data: z.object({
                    type: z.enum(['appPreviewSets']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppPreviewUpdateRequest
 */
export const zAppPreviewUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appPreviews']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksum: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            previewFrameTimeCode: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

export const zAppPriceV2InlineCreate = z.object({
    type: z.enum(['appPrices']),
    id: z.optional(z.string())
});

/**
 * AppScreenshotCreateRequest
 */
export const zAppScreenshotCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appScreenshots']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            appScreenshotSet: z.object({
                data: z.object({
                    type: z.enum(['appScreenshotSets']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppScreenshotUpdateRequest
 */
export const zAppScreenshotUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appScreenshots']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksum: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppStoreReviewAttachmentCreateRequest
 */
export const zAppStoreReviewAttachmentCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreReviewAttachments']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            appStoreReviewDetail: z.object({
                data: z.object({
                    type: z.enum(['appStoreReviewDetails']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppStoreReviewAttachmentUpdateRequest
 */
export const zAppStoreReviewAttachmentUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreReviewAttachments']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksum: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppStoreReviewDetailCreateRequest
 */
export const zAppStoreReviewDetailCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreReviewDetails']),
        attributes: z.optional(z.object({
            contactFirstName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            contactLastName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            contactPhone: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            contactEmail: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            demoAccountName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            demoAccountPassword: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            demoAccountRequired: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            notes: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        })),
        relationships: z.object({
            appStoreVersion: z.object({
                data: z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppStoreReviewDetailUpdateRequest
 */
export const zAppStoreReviewDetailUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreReviewDetails']),
        id: z.string(),
        attributes: z.optional(z.object({
            contactFirstName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            contactLastName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            contactPhone: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            contactEmail: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            demoAccountName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            demoAccountPassword: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            demoAccountRequired: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            notes: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppStoreVersionExperimentTreatmentLocalizationCreateRequest
 */
export const zAppStoreVersionExperimentTreatmentLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionExperimentTreatmentLocalizations']),
        attributes: z.object({
            locale: z.string()
        }),
        relationships: z.object({
            appStoreVersionExperimentTreatment: z.object({
                data: z.object({
                    type: z.enum(['appStoreVersionExperimentTreatments']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppStoreVersionExperimentTreatmentCreateRequest
 */
export const zAppStoreVersionExperimentTreatmentCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionExperimentTreatments']),
        attributes: z.object({
            name: z.string(),
            appIconName: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.optional(z.object({
            appStoreVersionExperiment: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appStoreVersionExperiments']),
                    id: z.string()
                }))
            })),
            appStoreVersionExperimentV2: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appStoreVersionExperiments']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * AppStoreVersionExperimentTreatmentUpdateRequest
 */
export const zAppStoreVersionExperimentTreatmentUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionExperimentTreatments']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            appIconName: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppStoreVersionExperimentV2UpdateRequest
 */
export const zAppStoreVersionExperimentV2UpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionExperiments']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            trafficProportion: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            started: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppStoreVersionExperimentCreateRequest
 *
 * @deprecated
 */
export const zAppStoreVersionExperimentCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionExperiments']),
        attributes: z.object({
            name: z.string(),
            trafficProportion: z.int()
        }),
        relationships: z.object({
            appStoreVersion: z.object({
                data: z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppStoreVersionExperimentUpdateRequest
 *
 * @deprecated
 */
export const zAppStoreVersionExperimentUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionExperiments']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            trafficProportion: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            started: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppStoreVersionLocalizationCreateRequest
 */
export const zAppStoreVersionLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionLocalizations']),
        attributes: z.object({
            description: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            locale: z.string(),
            keywords: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            marketingUrl: z.optional(z.union([
                z.url(),
                z.null()
            ])),
            promotionalText: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            supportUrl: z.optional(z.union([
                z.url(),
                z.null()
            ])),
            whatsNew: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.object({
            appStoreVersion: z.object({
                data: z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppStoreVersionLocalizationUpdateRequest
 */
export const zAppStoreVersionLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            description: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            keywords: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            marketingUrl: z.optional(z.union([
                z.url(),
                z.null()
            ])),
            promotionalText: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            supportUrl: z.optional(z.union([
                z.url(),
                z.null()
            ])),
            whatsNew: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppStoreVersionPromotionCreateRequest
 */
export const zAppStoreVersionPromotionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionPromotions']),
        relationships: z.object({
            appStoreVersion: z.object({
                data: z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                })
            }),
            appStoreVersionExperimentTreatment: z.object({
                data: z.object({
                    type: z.enum(['appStoreVersionExperimentTreatments']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppStoreVersionReleaseRequestCreateRequest
 */
export const zAppStoreVersionReleaseRequestCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionReleaseRequests']),
        relationships: z.object({
            appStoreVersion: z.object({
                data: z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppStoreVersionUpdateRequest
 */
export const zAppStoreVersionUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersions']),
        id: z.string(),
        attributes: z.optional(z.object({
            versionString: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            copyright: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            reviewType: z.optional(z.enum(['APP_STORE', 'NOTARIZATION'])),
            releaseType: z.optional(z.enum([
                'MANUAL',
                'AFTER_APPROVAL',
                'SCHEDULED'
            ])),
            earliestReleaseDate: z.optional(z.union([
                z.iso.datetime(),
                z.null()
            ])),
            usesIdfa: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            downloadable: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        })),
        relationships: z.optional(z.object({
            build: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['builds']),
                    id: z.string()
                }))
            })),
            appClipDefaultExperience: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appClipDefaultExperiences']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * AppTagUpdateRequest
 */
export const zAppTagUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appTags']),
        id: z.string(),
        attributes: z.optional(z.object({
            visibleInAppStore: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * BackgroundAssetUploadFileCreateRequest
 */
export const zBackgroundAssetUploadFileCreateRequest = z.object({
    data: z.object({
        type: z.enum(['backgroundAssetUploadFiles']),
        attributes: z.object({
            assetType: z.enum(['ASSET', 'MANIFEST']),
            fileName: z.string(),
            fileSize: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991))
        }),
        relationships: z.object({
            backgroundAssetVersion: z.object({
                data: z.object({
                    type: z.enum(['backgroundAssetVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BackgroundAssetVersionCreateRequest
 */
export const zBackgroundAssetVersionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['backgroundAssetVersions']),
        relationships: z.object({
            backgroundAsset: z.object({
                data: z.object({
                    type: z.enum(['backgroundAssets']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BackgroundAssetCreateRequest
 */
export const zBackgroundAssetCreateRequest = z.object({
    data: z.object({
        type: z.enum(['backgroundAssets']),
        attributes: z.object({
            assetPackIdentifier: z.string()
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BackgroundAssetUpdateRequest
 */
export const zBackgroundAssetUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['backgroundAssets']),
        id: z.string(),
        attributes: z.optional(z.object({
            archived: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

export const zBetaAppClipInvocationLocalizationInlineCreate = z.object({
    type: z.enum(['betaAppClipInvocationLocalizations']),
    id: z.optional(z.string()),
    attributes: z.object({
        title: z.string(),
        locale: z.string()
    }),
    relationships: z.optional(z.object({
        betaAppClipInvocation: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['betaAppClipInvocations']),
                id: z.string()
            }))
        }))
    }))
});

/**
 * BetaAppClipInvocationLocalizationCreateRequest
 */
export const zBetaAppClipInvocationLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['betaAppClipInvocationLocalizations']),
        attributes: z.object({
            title: z.string(),
            locale: z.string()
        }),
        relationships: z.object({
            betaAppClipInvocation: z.object({
                data: z.object({
                    type: z.enum(['betaAppClipInvocations']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BetaAppClipInvocationLocalizationUpdateRequest
 */
export const zBetaAppClipInvocationLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['betaAppClipInvocationLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            title: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * BetaAppClipInvocationCreateRequest
 */
export const zBetaAppClipInvocationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['betaAppClipInvocations']),
        attributes: z.object({
            url: z.url()
        }),
        relationships: z.object({
            buildBundle: z.object({
                data: z.object({
                    type: z.enum(['buildBundles']),
                    id: z.string()
                })
            }),
            betaAppClipInvocationLocalizations: z.object({
                data: z.array(z.object({
                    type: z.enum(['betaAppClipInvocationLocalizations']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(zBetaAppClipInvocationLocalizationInlineCreate))
});

/**
 * BetaAppClipInvocationUpdateRequest
 */
export const zBetaAppClipInvocationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['betaAppClipInvocations']),
        id: z.string(),
        attributes: z.optional(z.object({
            url: z.optional(z.union([
                z.url(),
                z.null()
            ]))
        }))
    })
});

/**
 * BetaAppLocalizationCreateRequest
 */
export const zBetaAppLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['betaAppLocalizations']),
        attributes: z.object({
            feedbackEmail: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            marketingUrl: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            privacyPolicyUrl: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            tvOsPrivacyPolicy: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            locale: z.string()
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BetaAppLocalizationUpdateRequest
 */
export const zBetaAppLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['betaAppLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            feedbackEmail: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            marketingUrl: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            privacyPolicyUrl: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            tvOsPrivacyPolicy: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * BetaAppReviewDetailUpdateRequest
 */
export const zBetaAppReviewDetailUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['betaAppReviewDetails']),
        id: z.string(),
        attributes: z.optional(z.object({
            contactFirstName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            contactLastName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            contactPhone: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            contactEmail: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            demoAccountName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            demoAccountPassword: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            demoAccountRequired: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            notes: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * BetaAppReviewSubmissionCreateRequest
 */
export const zBetaAppReviewSubmissionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['betaAppReviewSubmissions']),
        relationships: z.object({
            build: z.object({
                data: z.object({
                    type: z.enum(['builds']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BetaBuildLocalizationCreateRequest
 */
export const zBetaBuildLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['betaBuildLocalizations']),
        attributes: z.object({
            whatsNew: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            locale: z.string()
        }),
        relationships: z.object({
            build: z.object({
                data: z.object({
                    type: z.enum(['builds']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BetaBuildLocalizationUpdateRequest
 */
export const zBetaBuildLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['betaBuildLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            whatsNew: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * BetaGroupCreateRequest
 */
export const zBetaGroupCreateRequest = z.object({
    data: z.object({
        type: z.enum(['betaGroups']),
        attributes: z.object({
            name: z.string(),
            isInternalGroup: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            hasAccessToAllBuilds: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            publicLinkEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            publicLinkLimitEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            publicLinkLimit: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            feedbackEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            }),
            builds: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['builds']),
                    id: z.string()
                })))
            })),
            betaTesters: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['betaTesters']),
                    id: z.string()
                })))
            }))
        })
    })
});

/**
 * BetaGroupUpdateRequest
 */
export const zBetaGroupUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['betaGroups']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            publicLinkEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            publicLinkLimitEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            publicLinkLimit: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            feedbackEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            iosBuildsAvailableForAppleSiliconMac: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            iosBuildsAvailableForAppleVision: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * BetaLicenseAgreementUpdateRequest
 */
export const zBetaLicenseAgreementUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['betaLicenseAgreements']),
        id: z.string(),
        attributes: z.optional(z.object({
            agreementText: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * BetaTesterInvitationCreateRequest
 */
export const zBetaTesterInvitationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['betaTesterInvitations']),
        relationships: z.object({
            betaTester: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['betaTesters']),
                    id: z.string()
                }))
            })),
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BetaTesterCreateRequest
 */
export const zBetaTesterCreateRequest = z.object({
    data: z.object({
        type: z.enum(['betaTesters']),
        attributes: z.object({
            firstName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            lastName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            email: z.email()
        }),
        relationships: z.optional(z.object({
            betaGroups: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['betaGroups']),
                    id: z.string()
                })))
            })),
            builds: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['builds']),
                    id: z.string()
                })))
            }))
        }))
    })
});

/**
 * BuildBetaDetailUpdateRequest
 */
export const zBuildBetaDetailUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['buildBetaDetails']),
        id: z.string(),
        attributes: z.optional(z.object({
            autoNotifyEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * BuildBetaNotificationCreateRequest
 */
export const zBuildBetaNotificationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['buildBetaNotifications']),
        relationships: z.object({
            build: z.object({
                data: z.object({
                    type: z.enum(['builds']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BuildUploadFileCreateRequest
 */
export const zBuildUploadFileCreateRequest = z.object({
    data: z.object({
        type: z.enum(['buildUploadFiles']),
        attributes: z.object({
            assetType: z.enum([
                'ASSET',
                'ASSET_DESCRIPTION',
                'ASSET_SPI'
            ]),
            fileName: z.string(),
            fileSize: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991)),
            uti: z.enum([
                'com.apple.binary-property-list',
                'com.apple.ipa',
                'com.apple.pkg',
                'com.apple.xml-property-list',
                'com.pkware.zip-archive'
            ])
        }),
        relationships: z.object({
            buildUpload: z.object({
                data: z.object({
                    type: z.enum(['buildUploads']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BuildUpdateRequest
 */
export const zBuildUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['builds']),
        id: z.string(),
        attributes: z.optional(z.object({
            expired: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            usesNonExemptEncryption: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        })),
        relationships: z.optional(z.object({
            appEncryptionDeclaration: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appEncryptionDeclarations']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * BundleIdUpdateRequest
 */
export const zBundleIdUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['bundleIds']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * CertificateUpdateRequest
 */
export const zCertificateUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['certificates']),
        id: z.string(),
        attributes: z.optional(z.object({
            activated: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * CiBuildRunCreateRequest
 */
export const zCiBuildRunCreateRequest = z.object({
    data: z.object({
        type: z.enum(['ciBuildRuns']),
        attributes: z.optional(z.object({
            clean: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        })),
        relationships: z.optional(z.object({
            buildRun: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['ciBuildRuns']),
                    id: z.string()
                }))
            })),
            workflow: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['ciWorkflows']),
                    id: z.string()
                }))
            })),
            sourceBranchOrTag: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['scmGitReferences']),
                    id: z.string()
                }))
            })),
            pullRequest: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['scmPullRequests']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * CustomerReviewResponseV1CreateRequest
 */
export const zCustomerReviewResponseV1CreateRequest = z.object({
    data: z.object({
        type: z.enum(['customerReviewResponses']),
        attributes: z.object({
            responseBody: z.string()
        }),
        relationships: z.object({
            review: z.object({
                data: z.object({
                    type: z.enum(['customerReviews']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * DeviceUpdateRequest
 */
export const zDeviceUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['devices']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            status: z.optional(z.enum(['ENABLED', 'DISABLED']))
        }))
    })
});

/**
 * EndAppAvailabilityPreOrderCreateRequest
 */
export const zEndAppAvailabilityPreOrderCreateRequest = z.object({
    data: z.object({
        type: z.enum(['endAppAvailabilityPreOrders']),
        relationships: z.object({
            territoryAvailabilities: z.object({
                data: z.array(z.object({
                    type: z.enum(['territoryAvailabilities']),
                    id: z.string()
                }))
            })
        })
    })
});

/**
 * EndUserLicenseAgreementCreateRequest
 */
export const zEndUserLicenseAgreementCreateRequest = z.object({
    data: z.object({
        type: z.enum(['endUserLicenseAgreements']),
        attributes: z.object({
            agreementText: z.string()
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            }),
            territories: z.object({
                data: z.array(z.object({
                    type: z.enum(['territories']),
                    id: z.string()
                }))
            })
        })
    })
});

/**
 * EndUserLicenseAgreementUpdateRequest
 */
export const zEndUserLicenseAgreementUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['endUserLicenseAgreements']),
        id: z.string(),
        attributes: z.optional(z.object({
            agreementText: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        })),
        relationships: z.optional(z.object({
            territories: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['territories']),
                    id: z.string()
                })))
            }))
        }))
    })
});

/**
 * GameCenterAchievementImageCreateRequest
 */
export const zGameCenterAchievementImageCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievementImages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            gameCenterAchievementLocalization: z.object({
                data: z.object({
                    type: z.enum(['gameCenterAchievementLocalizations']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterAchievementImageUpdateRequest
 */
export const zGameCenterAchievementImageUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievementImages']),
        id: z.string(),
        attributes: z.optional(z.object({
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterAchievementImageV2CreateRequest
 */
export const zGameCenterAchievementImageV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievementImages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            localization: z.object({
                data: z.object({
                    type: z.enum(['gameCenterAchievementLocalizations']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterAchievementImageV2UpdateRequest
 */
export const zGameCenterAchievementImageV2UpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievementImages']),
        id: z.string(),
        attributes: z.optional(z.object({
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterAchievementLocalizationV2CreateRequest
 */
export const zGameCenterAchievementLocalizationV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievementLocalizations']),
        attributes: z.object({
            locale: z.string(),
            name: z.string(),
            beforeEarnedDescription: z.string(),
            afterEarnedDescription: z.string()
        }),
        relationships: z.object({
            version: z.object({
                data: z.object({
                    type: z.enum(['gameCenterAchievementVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterAchievementLocalizationV2UpdateRequest
 */
export const zGameCenterAchievementLocalizationV2UpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievementLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            beforeEarnedDescription: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            afterEarnedDescription: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterAchievementLocalizationCreateRequest
 */
export const zGameCenterAchievementLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievementLocalizations']),
        attributes: z.object({
            locale: z.string(),
            name: z.string(),
            beforeEarnedDescription: z.string(),
            afterEarnedDescription: z.string()
        }),
        relationships: z.object({
            gameCenterAchievement: z.object({
                data: z.object({
                    type: z.enum(['gameCenterAchievements']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterAchievementLocalizationUpdateRequest
 */
export const zGameCenterAchievementLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievementLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            beforeEarnedDescription: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            afterEarnedDescription: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterAchievementReleaseCreateRequest
 */
export const zGameCenterAchievementReleaseCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievementReleases']),
        relationships: z.object({
            gameCenterDetail: z.object({
                data: z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                })
            }),
            gameCenterAchievement: z.object({
                data: z.object({
                    type: z.enum(['gameCenterAchievements']),
                    id: z.string()
                })
            })
        })
    })
});

export const zGameCenterAchievementVersionV2InlineCreate = z.object({
    type: z.enum(['gameCenterAchievementVersions']),
    id: z.optional(z.string()),
    relationships: z.optional(z.object({
        achievement: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterAchievements']),
                id: z.string()
            }))
        }))
    }))
});

/**
 * GameCenterAchievementVersionV2CreateRequest
 */
export const zGameCenterAchievementVersionV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievementVersions']),
        relationships: z.object({
            achievement: z.object({
                data: z.object({
                    type: z.enum(['gameCenterAchievements']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterActivityImageCreateRequest
 */
export const zGameCenterActivityImageCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivityImages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.optional(z.object({
            localization: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterActivityLocalizations']),
                    id: z.string()
                }))
            })),
            version: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterActivityVersions']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * GameCenterActivityImageUpdateRequest
 */
export const zGameCenterActivityImageUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivityImages']),
        id: z.string(),
        attributes: z.optional(z.object({
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterActivityLocalizationCreateRequest
 */
export const zGameCenterActivityLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivityLocalizations']),
        attributes: z.object({
            locale: z.string(),
            name: z.string(),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.object({
            version: z.object({
                data: z.object({
                    type: z.enum(['gameCenterActivityVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterActivityLocalizationUpdateRequest
 */
export const zGameCenterActivityLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivityLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterActivityVersionReleaseCreateRequest
 */
export const zGameCenterActivityVersionReleaseCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivityVersionReleases']),
        relationships: z.object({
            gameCenterDetail: z.object({
                data: z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                })
            }),
            version: z.object({
                data: z.object({
                    type: z.enum(['gameCenterActivityVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterActivityVersionCreateRequest
 */
export const zGameCenterActivityVersionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivityVersions']),
        attributes: z.optional(z.object({
            fallbackUrl: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        })),
        relationships: z.object({
            activity: z.object({
                data: z.object({
                    type: z.enum(['gameCenterActivities']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterActivityVersionUpdateRequest
 */
export const zGameCenterActivityVersionUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivityVersions']),
        id: z.string(),
        attributes: z.optional(z.object({
            fallbackUrl: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterAppVersionCreateRequest
 */
export const zGameCenterAppVersionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAppVersions']),
        relationships: z.object({
            appStoreVersion: z.object({
                data: z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterAppVersionUpdateRequest
 */
export const zGameCenterAppVersionUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAppVersions']),
        id: z.string(),
        attributes: z.optional(z.object({
            enabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterChallengeImageCreateRequest
 */
export const zGameCenterChallengeImageCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterChallengeImages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.optional(z.object({
            localization: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterChallengeLocalizations']),
                    id: z.string()
                }))
            })),
            version: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterChallengeVersions']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * GameCenterChallengeImageUpdateRequest
 */
export const zGameCenterChallengeImageUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterChallengeImages']),
        id: z.string(),
        attributes: z.optional(z.object({
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterChallengeLocalizationCreateRequest
 */
export const zGameCenterChallengeLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterChallengeLocalizations']),
        attributes: z.object({
            locale: z.string(),
            name: z.string(),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.object({
            version: z.object({
                data: z.object({
                    type: z.enum(['gameCenterChallengeVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterChallengeLocalizationUpdateRequest
 */
export const zGameCenterChallengeLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterChallengeLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterChallengeVersionReleaseCreateRequest
 */
export const zGameCenterChallengeVersionReleaseCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterChallengeVersionReleases']),
        relationships: z.object({
            gameCenterDetail: z.object({
                data: z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                })
            }),
            version: z.object({
                data: z.object({
                    type: z.enum(['gameCenterChallengeVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterChallengeVersionCreateRequest
 */
export const zGameCenterChallengeVersionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterChallengeVersions']),
        relationships: z.object({
            challenge: z.object({
                data: z.object({
                    type: z.enum(['gameCenterChallenges']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterChallengeCreateRequest
 */
export const zGameCenterChallengeCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterChallenges']),
        attributes: z.object({
            referenceName: z.string(),
            vendorIdentifier: z.string(),
            challengeType: z.enum(['LEADERBOARD']),
            repeatable: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }),
        relationships: z.optional(z.object({
            gameCenterDetail: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                }))
            })),
            gameCenterGroup: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterGroups']),
                    id: z.string()
                }))
            })),
            leaderboard: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                }))
            })),
            leaderboardV2: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * GameCenterChallengeUpdateRequest
 */
export const zGameCenterChallengeUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterChallenges']),
        id: z.string(),
        attributes: z.optional(z.object({
            referenceName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            archived: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            repeatable: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        })),
        relationships: z.optional(z.object({
            leaderboard: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                }))
            })),
            leaderboardV2: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * GameCenterDetailCreateRequest
 */
export const zGameCenterDetailCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterDetails']),
        attributes: z.optional(z.object({
            challengeEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        })),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterDetailUpdateRequest
 */
export const zGameCenterDetailUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterDetails']),
        id: z.string(),
        attributes: z.optional(z.object({
            challengeEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        })),
        relationships: z.optional(z.object({
            gameCenterGroup: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterGroups']),
                    id: z.string()
                }))
            })),
            defaultLeaderboard: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                }))
            })),
            defaultLeaderboardV2: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                }))
            })),
            defaultGroupLeaderboard: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                }))
            })),
            defaultGroupLeaderboardV2: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * GameCenterGroupCreateRequest
 */
export const zGameCenterGroupCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterGroups']),
        attributes: z.optional(z.object({
            referenceName: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterGroupUpdateRequest
 */
export const zGameCenterGroupUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterGroups']),
        id: z.string(),
        attributes: z.optional(z.object({
            referenceName: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterLeaderboardEntrySubmissionCreateRequest
 */
export const zGameCenterLeaderboardEntrySubmissionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardEntrySubmissions']),
        attributes: z.object({
            bundleId: z.string(),
            challengeIds: z.optional(z.union([
                z.array(z.string()),
                z.null()
            ])),
            context: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            scopedPlayerId: z.string(),
            score: z.string(),
            submittedDate: z.optional(z.union([
                z.iso.datetime(),
                z.null()
            ])),
            vendorIdentifier: z.string()
        })
    })
});

/**
 * GameCenterLeaderboardImageCreateRequest
 */
export const zGameCenterLeaderboardImageCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardImages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            gameCenterLeaderboardLocalization: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboardLocalizations']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterLeaderboardImageUpdateRequest
 */
export const zGameCenterLeaderboardImageUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardImages']),
        id: z.string(),
        attributes: z.optional(z.object({
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterLeaderboardImageV2CreateRequest
 */
export const zGameCenterLeaderboardImageV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardImages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            localization: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboardLocalizations']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterLeaderboardImageV2UpdateRequest
 */
export const zGameCenterLeaderboardImageV2UpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardImages']),
        id: z.string(),
        attributes: z.optional(z.object({
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterLeaderboardReleaseCreateRequest
 */
export const zGameCenterLeaderboardReleaseCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardReleases']),
        relationships: z.object({
            gameCenterDetail: z.object({
                data: z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                })
            }),
            gameCenterLeaderboard: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterLeaderboardSetImageCreateRequest
 */
export const zGameCenterLeaderboardSetImageCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetImages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            gameCenterLeaderboardSetLocalization: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboardSetLocalizations']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterLeaderboardSetImageUpdateRequest
 */
export const zGameCenterLeaderboardSetImageUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetImages']),
        id: z.string(),
        attributes: z.optional(z.object({
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterLeaderboardSetImageV2CreateRequest
 */
export const zGameCenterLeaderboardSetImageV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetImages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            localization: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboardSetLocalizations']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterLeaderboardSetImageV2UpdateRequest
 */
export const zGameCenterLeaderboardSetImageV2UpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetImages']),
        id: z.string(),
        attributes: z.optional(z.object({
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterLeaderboardSetLocalizationCreateRequest
 */
export const zGameCenterLeaderboardSetLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetLocalizations']),
        attributes: z.object({
            locale: z.string(),
            name: z.string()
        }),
        relationships: z.object({
            gameCenterLeaderboardSet: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboardSets']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterLeaderboardSetLocalizationUpdateRequest
 */
export const zGameCenterLeaderboardSetLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterLeaderboardSetLocalizationV2CreateRequest
 */
export const zGameCenterLeaderboardSetLocalizationV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetLocalizations']),
        attributes: z.object({
            locale: z.string(),
            name: z.string()
        }),
        relationships: z.object({
            version: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboardSetVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterLeaderboardSetLocalizationV2UpdateRequest
 */
export const zGameCenterLeaderboardSetLocalizationV2UpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterLeaderboardSetMemberLocalizationCreateRequest
 */
export const zGameCenterLeaderboardSetMemberLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetMemberLocalizations']),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            locale: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        })),
        relationships: z.object({
            gameCenterLeaderboardSet: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboardSets']),
                    id: z.string()
                })
            }),
            gameCenterLeaderboard: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterLeaderboardSetMemberLocalizationUpdateRequest
 */
export const zGameCenterLeaderboardSetMemberLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetMemberLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterLeaderboardSetReleaseCreateRequest
 */
export const zGameCenterLeaderboardSetReleaseCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetReleases']),
        relationships: z.object({
            gameCenterDetail: z.object({
                data: z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                })
            }),
            gameCenterLeaderboardSet: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboardSets']),
                    id: z.string()
                })
            })
        })
    })
});

export const zGameCenterLeaderboardSetVersionV2InlineCreate = z.object({
    type: z.enum(['gameCenterLeaderboardSetVersions']),
    id: z.optional(z.string()),
    relationships: z.optional(z.object({
        leaderboardSet: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardSets']),
                id: z.string()
            }))
        }))
    }))
});

/**
 * GameCenterLeaderboardSetVersionV2CreateRequest
 */
export const zGameCenterLeaderboardSetVersionV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetVersions']),
        relationships: z.object({
            leaderboardSet: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboardSets']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterLeaderboardSetV2CreateRequest
 */
export const zGameCenterLeaderboardSetV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        attributes: z.object({
            referenceName: z.string(),
            vendorIdentifier: z.string()
        }),
        relationships: z.object({
            gameCenterDetail: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                }))
            })),
            gameCenterGroup: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterGroups']),
                    id: z.string()
                }))
            })),
            gameCenterLeaderboards: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                })))
            })),
            versions: z.object({
                data: z.array(z.object({
                    type: z.enum(['gameCenterLeaderboardSetVersions']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(zGameCenterLeaderboardSetVersionV2InlineCreate))
});

/**
 * GameCenterLeaderboardSetV2UpdateRequest
 */
export const zGameCenterLeaderboardSetV2UpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string(),
        attributes: z.optional(z.object({
            referenceName: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterLeaderboardSetCreateRequest
 */
export const zGameCenterLeaderboardSetCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        attributes: z.object({
            referenceName: z.string(),
            vendorIdentifier: z.string()
        }),
        relationships: z.optional(z.object({
            gameCenterDetail: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                }))
            })),
            gameCenterGroup: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterGroups']),
                    id: z.string()
                }))
            })),
            gameCenterLeaderboards: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                })))
            }))
        }))
    })
});

/**
 * GameCenterLeaderboardSetUpdateRequest
 */
export const zGameCenterLeaderboardSetUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string(),
        attributes: z.optional(z.object({
            referenceName: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

export const zGameCenterLeaderboardVersionV2InlineCreate = z.object({
    type: z.enum(['gameCenterLeaderboardVersions']),
    id: z.optional(z.string()),
    relationships: z.optional(z.object({
        leaderboard: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            }))
        }))
    }))
});

/**
 * GameCenterLeaderboardVersionV2CreateRequest
 */
export const zGameCenterLeaderboardVersionV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardVersions']),
        relationships: z.object({
            leaderboard: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterMatchmakingQueueCreateRequest
 */
export const zGameCenterMatchmakingQueueCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterMatchmakingQueues']),
        attributes: z.object({
            referenceName: z.string(),
            classicMatchmakingBundleIds: z.optional(z.union([
                z.array(z.string()),
                z.null()
            ]))
        }),
        relationships: z.object({
            ruleSet: z.object({
                data: z.object({
                    type: z.enum(['gameCenterMatchmakingRuleSets']),
                    id: z.string()
                })
            }),
            experimentRuleSet: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterMatchmakingRuleSets']),
                    id: z.string()
                }))
            }))
        })
    })
});

/**
 * GameCenterMatchmakingQueueUpdateRequest
 */
export const zGameCenterMatchmakingQueueUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterMatchmakingQueues']),
        id: z.string(),
        attributes: z.optional(z.object({
            classicMatchmakingBundleIds: z.optional(z.union([
                z.array(z.string()),
                z.null()
            ]))
        })),
        relationships: z.optional(z.object({
            ruleSet: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterMatchmakingRuleSets']),
                    id: z.string()
                }))
            })),
            experimentRuleSet: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterMatchmakingRuleSets']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * GameCenterMatchmakingRuleSetCreateRequest
 */
export const zGameCenterMatchmakingRuleSetCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterMatchmakingRuleSets']),
        attributes: z.object({
            referenceName: z.string(),
            ruleLanguageVersion: z.int(),
            minPlayers: z.int(),
            maxPlayers: z.int()
        })
    })
});

/**
 * GameCenterMatchmakingRuleSetUpdateRequest
 */
export const zGameCenterMatchmakingRuleSetUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterMatchmakingRuleSets']),
        id: z.string(),
        attributes: z.optional(z.object({
            minPlayers: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            maxPlayers: z.optional(z.union([
                z.int(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterMatchmakingRuleCreateRequest
 */
export const zGameCenterMatchmakingRuleCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterMatchmakingRules']),
        attributes: z.object({
            referenceName: z.string(),
            description: z.string(),
            type: z.enum([
                'COMPATIBLE',
                'DISTANCE',
                'MATCH',
                'TEAM'
            ]),
            expression: z.string(),
            weight: z.optional(z.union([
                z.number(),
                z.null()
            ]))
        }),
        relationships: z.object({
            ruleSet: z.object({
                data: z.object({
                    type: z.enum(['gameCenterMatchmakingRuleSets']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterMatchmakingRuleUpdateRequest
 */
export const zGameCenterMatchmakingRuleUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterMatchmakingRules']),
        id: z.string(),
        attributes: z.optional(z.object({
            description: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            expression: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            weight: z.optional(z.union([
                z.number(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterMatchmakingTeamCreateRequest
 */
export const zGameCenterMatchmakingTeamCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterMatchmakingTeams']),
        attributes: z.object({
            referenceName: z.string(),
            minPlayers: z.int(),
            maxPlayers: z.int()
        }),
        relationships: z.object({
            ruleSet: z.object({
                data: z.object({
                    type: z.enum(['gameCenterMatchmakingRuleSets']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterMatchmakingTeamUpdateRequest
 */
export const zGameCenterMatchmakingTeamUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterMatchmakingTeams']),
        id: z.string(),
        attributes: z.optional(z.object({
            minPlayers: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            maxPlayers: z.optional(z.union([
                z.int(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterPlayerAchievementSubmissionCreateRequest
 */
export const zGameCenterPlayerAchievementSubmissionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterPlayerAchievementSubmissions']),
        attributes: z.object({
            bundleId: z.string(),
            challengeIds: z.optional(z.union([
                z.array(z.string()),
                z.null()
            ])),
            percentageAchieved: z.int(),
            scopedPlayerId: z.string(),
            submittedDate: z.optional(z.union([
                z.iso.datetime(),
                z.null()
            ])),
            vendorIdentifier: z.string()
        })
    })
});

/**
 * InAppPurchaseAppStoreReviewScreenshotCreateRequest
 */
export const zInAppPurchaseAppStoreReviewScreenshotCreateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseAppStoreReviewScreenshots']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            inAppPurchaseV2: z.object({
                data: z.object({
                    type: z.enum(['inAppPurchases']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * InAppPurchaseAppStoreReviewScreenshotUpdateRequest
 */
export const zInAppPurchaseAppStoreReviewScreenshotUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseAppStoreReviewScreenshots']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksum: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * InAppPurchaseAvailabilityCreateRequest
 */
export const zInAppPurchaseAvailabilityCreateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseAvailabilities']),
        attributes: z.object({
            availableInNewTerritories: z.boolean()
        }),
        relationships: z.object({
            inAppPurchase: z.object({
                data: z.object({
                    type: z.enum(['inAppPurchases']),
                    id: z.string()
                })
            }),
            availableTerritories: z.object({
                data: z.array(z.object({
                    type: z.enum(['territories']),
                    id: z.string()
                }))
            })
        })
    })
});

/**
 * InAppPurchaseImageCreateRequest
 */
export const zInAppPurchaseImageCreateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseImages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            inAppPurchase: z.object({
                data: z.object({
                    type: z.enum(['inAppPurchases']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * InAppPurchaseImageUpdateRequest
 */
export const zInAppPurchaseImageUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseImages']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksum: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * InAppPurchaseLocalizationCreateRequest
 */
export const zInAppPurchaseLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseLocalizations']),
        attributes: z.object({
            name: z.string(),
            locale: z.string(),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.object({
            inAppPurchaseV2: z.object({
                data: z.object({
                    type: z.enum(['inAppPurchases']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * InAppPurchaseLocalizationUpdateRequest
 */
export const zInAppPurchaseLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * InAppPurchaseOfferCodeCustomCodeCreateRequest
 */
export const zInAppPurchaseOfferCodeCustomCodeCreateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseOfferCodeCustomCodes']),
        attributes: z.object({
            customCode: z.string(),
            numberOfCodes: z.int(),
            expirationDate: z.optional(z.union([
                z.iso.date(),
                z.null()
            ]))
        }),
        relationships: z.object({
            offerCode: z.object({
                data: z.object({
                    type: z.enum(['inAppPurchaseOfferCodes']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * InAppPurchaseOfferCodeCustomCodeUpdateRequest
 */
export const zInAppPurchaseOfferCodeCustomCodeUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseOfferCodeCustomCodes']),
        id: z.string(),
        attributes: z.optional(z.object({
            active: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * InAppPurchaseOfferCodeOneTimeUseCodeUpdateRequest
 */
export const zInAppPurchaseOfferCodeOneTimeUseCodeUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseOfferCodeOneTimeUseCodes']),
        id: z.string(),
        attributes: z.optional(z.object({
            active: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * InAppPurchaseOfferCodeUpdateRequest
 */
export const zInAppPurchaseOfferCodeUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseOfferCodes']),
        id: z.string(),
        attributes: z.optional(z.object({
            active: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

export const zInAppPurchaseOfferPriceInlineCreate = z.object({
    type: z.enum(['inAppPurchaseOfferPrices']),
    id: z.optional(z.string()),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        pricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['inAppPurchasePricePoints']),
                id: z.string()
            }))
        }))
    }))
});

/**
 * InAppPurchaseOfferCodeCreateRequest
 */
export const zInAppPurchaseOfferCodeCreateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseOfferCodes']),
        attributes: z.object({
            name: z.string(),
            customerEligibilities: z.array(z.enum([
                'NON_SPENDER',
                'ACTIVE_SPENDER',
                'CHURNED_SPENDER'
            ]))
        }),
        relationships: z.object({
            inAppPurchase: z.object({
                data: z.object({
                    type: z.enum(['inAppPurchases']),
                    id: z.string()
                })
            }),
            prices: z.object({
                data: z.array(z.object({
                    type: z.enum(['inAppPurchaseOfferPrices']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(zInAppPurchaseOfferPriceInlineCreate))
});

export const zInAppPurchasePriceInlineCreate = z.object({
    type: z.enum(['inAppPurchasePrices']),
    id: z.optional(z.string()),
    attributes: z.optional(z.object({
        startDate: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        endDate: z.optional(z.union([
            z.iso.date(),
            z.null()
        ]))
    })),
    relationships: z.optional(z.object({
        inAppPurchaseV2: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['inAppPurchases']),
                id: z.string()
            }))
        })),
        inAppPurchasePricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['inAppPurchasePricePoints']),
                id: z.string()
            }))
        }))
    }))
});

/**
 * InAppPurchaseSubmissionCreateRequest
 */
export const zInAppPurchaseSubmissionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseSubmissions']),
        relationships: z.object({
            inAppPurchaseV2: z.object({
                data: z.object({
                    type: z.enum(['inAppPurchases']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * InAppPurchaseV2UpdateRequest
 */
export const zInAppPurchaseV2UpdateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchases']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            reviewNote: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            familySharable: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * MarketplaceSearchDetailCreateRequest
 */
export const zMarketplaceSearchDetailCreateRequest = z.object({
    data: z.object({
        type: z.enum(['marketplaceSearchDetails']),
        attributes: z.object({
            catalogUrl: z.url()
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * MarketplaceSearchDetailUpdateRequest
 */
export const zMarketplaceSearchDetailUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['marketplaceSearchDetails']),
        id: z.string(),
        attributes: z.optional(z.object({
            catalogUrl: z.optional(z.union([
                z.url(),
                z.null()
            ]))
        }))
    })
});

/**
 * MarketplaceWebhookCreateRequest
 *
 * @deprecated
 */
export const zMarketplaceWebhookCreateRequest = z.object({
    data: z.object({
        type: z.enum(['marketplaceWebhooks']),
        attributes: z.object({
            endpointUrl: z.url(),
            secret: z.string()
        })
    })
});

/**
 * MarketplaceWebhookUpdateRequest
 *
 * @deprecated
 */
export const zMarketplaceWebhookUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['marketplaceWebhooks']),
        id: z.string(),
        attributes: z.optional(z.object({
            endpointUrl: z.optional(z.union([
                z.url(),
                z.null()
            ])),
            secret: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * MerchantIdCreateRequest
 */
export const zMerchantIdCreateRequest = z.object({
    data: z.object({
        type: z.enum(['merchantIds']),
        attributes: z.object({
            name: z.string(),
            identifier: z.string()
        })
    })
});

/**
 * MerchantIdUpdateRequest
 */
export const zMerchantIdUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['merchantIds']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * PassTypeIdCreateRequest
 */
export const zPassTypeIdCreateRequest = z.object({
    data: z.object({
        type: z.enum(['passTypeIds']),
        attributes: z.object({
            name: z.string(),
            identifier: z.string()
        })
    })
});

/**
 * PassTypeIdUpdateRequest
 */
export const zPassTypeIdUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['passTypeIds']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * ProfileCreateRequest
 */
export const zProfileCreateRequest = z.object({
    data: z.object({
        type: z.enum(['profiles']),
        attributes: z.object({
            name: z.string(),
            profileType: z.enum([
                'IOS_APP_DEVELOPMENT',
                'IOS_APP_STORE',
                'IOS_APP_ADHOC',
                'IOS_APP_INHOUSE',
                'MAC_APP_DEVELOPMENT',
                'MAC_APP_STORE',
                'MAC_APP_DIRECT',
                'TVOS_APP_DEVELOPMENT',
                'TVOS_APP_STORE',
                'TVOS_APP_ADHOC',
                'TVOS_APP_INHOUSE',
                'MAC_CATALYST_APP_DEVELOPMENT',
                'MAC_CATALYST_APP_STORE',
                'MAC_CATALYST_APP_DIRECT'
            ])
        }),
        relationships: z.object({
            bundleId: z.object({
                data: z.object({
                    type: z.enum(['bundleIds']),
                    id: z.string()
                })
            }),
            devices: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['devices']),
                    id: z.string()
                })))
            })),
            certificates: z.object({
                data: z.array(z.object({
                    type: z.enum(['certificates']),
                    id: z.string()
                }))
            })
        })
    })
});

/**
 * PromotedPurchaseCreateRequest
 */
export const zPromotedPurchaseCreateRequest = z.object({
    data: z.object({
        type: z.enum(['promotedPurchases']),
        attributes: z.object({
            visibleForAllUsers: z.boolean(),
            enabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            }),
            inAppPurchaseV2: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['inAppPurchases']),
                    id: z.string()
                }))
            })),
            subscription: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['subscriptions']),
                    id: z.string()
                }))
            }))
        })
    })
});

/**
 * PromotedPurchaseUpdateRequest
 */
export const zPromotedPurchaseUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['promotedPurchases']),
        id: z.string(),
        attributes: z.optional(z.object({
            visibleForAllUsers: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            enabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * ReviewSubmissionItemCreateRequest
 */
export const zReviewSubmissionItemCreateRequest = z.object({
    data: z.object({
        type: z.enum(['reviewSubmissionItems']),
        relationships: z.object({
            reviewSubmission: z.object({
                data: z.object({
                    type: z.enum(['reviewSubmissions']),
                    id: z.string()
                })
            }),
            appStoreVersion: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                }))
            })),
            appCustomProductPageVersion: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appCustomProductPageVersions']),
                    id: z.string()
                }))
            })),
            appStoreVersionExperiment: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appStoreVersionExperiments']),
                    id: z.string()
                }))
            })),
            appStoreVersionExperimentV2: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appStoreVersionExperiments']),
                    id: z.string()
                }))
            })),
            appEvent: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appEvents']),
                    id: z.string()
                }))
            })),
            backgroundAssetVersion: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['backgroundAssetVersions']),
                    id: z.string()
                }))
            })),
            gameCenterAchievementVersion: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterAchievementVersions']),
                    id: z.string()
                }))
            })),
            gameCenterActivityVersion: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterActivityVersions']),
                    id: z.string()
                }))
            })),
            gameCenterChallengeVersion: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterChallengeVersions']),
                    id: z.string()
                }))
            })),
            gameCenterLeaderboardSetVersion: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterLeaderboardSetVersions']),
                    id: z.string()
                }))
            })),
            gameCenterLeaderboardVersion: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterLeaderboardVersions']),
                    id: z.string()
                }))
            }))
        })
    })
});

/**
 * ReviewSubmissionItemUpdateRequest
 */
export const zReviewSubmissionItemUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['reviewSubmissionItems']),
        id: z.string(),
        attributes: z.optional(z.object({
            resolved: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            removed: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * RoutingAppCoverageCreateRequest
 */
export const zRoutingAppCoverageCreateRequest = z.object({
    data: z.object({
        type: z.enum(['routingAppCoverages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            appStoreVersion: z.object({
                data: z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * RoutingAppCoverageUpdateRequest
 */
export const zRoutingAppCoverageUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['routingAppCoverages']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksum: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * SandboxTestersClearPurchaseHistoryRequestV2CreateRequest
 */
export const zSandboxTestersClearPurchaseHistoryRequestV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['sandboxTestersClearPurchaseHistoryRequest']),
        relationships: z.object({
            sandboxTesters: z.object({
                data: z.array(z.object({
                    type: z.enum(['sandboxTesters']),
                    id: z.string()
                }))
            })
        })
    })
});

/**
 * SubscriptionAppStoreReviewScreenshotCreateRequest
 */
export const zSubscriptionAppStoreReviewScreenshotCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionAppStoreReviewScreenshots']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            subscription: z.object({
                data: z.object({
                    type: z.enum(['subscriptions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * SubscriptionAppStoreReviewScreenshotUpdateRequest
 */
export const zSubscriptionAppStoreReviewScreenshotUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionAppStoreReviewScreenshots']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksum: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * SubscriptionAvailabilityCreateRequest
 */
export const zSubscriptionAvailabilityCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionAvailabilities']),
        attributes: z.object({
            availableInNewTerritories: z.boolean()
        }),
        relationships: z.object({
            subscription: z.object({
                data: z.object({
                    type: z.enum(['subscriptions']),
                    id: z.string()
                })
            }),
            availableTerritories: z.object({
                data: z.array(z.object({
                    type: z.enum(['territories']),
                    id: z.string()
                }))
            })
        })
    })
});

/**
 * SubscriptionGroupLocalizationCreateRequest
 */
export const zSubscriptionGroupLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionGroupLocalizations']),
        attributes: z.object({
            name: z.string(),
            customAppName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            locale: z.string()
        }),
        relationships: z.object({
            subscriptionGroup: z.object({
                data: z.object({
                    type: z.enum(['subscriptionGroups']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * SubscriptionGroupLocalizationUpdateRequest
 */
export const zSubscriptionGroupLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionGroupLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            customAppName: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * SubscriptionGroupSubmissionCreateRequest
 */
export const zSubscriptionGroupSubmissionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionGroupSubmissions']),
        relationships: z.object({
            subscriptionGroup: z.object({
                data: z.object({
                    type: z.enum(['subscriptionGroups']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * SubscriptionGroupCreateRequest
 */
export const zSubscriptionGroupCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionGroups']),
        attributes: z.object({
            referenceName: z.string()
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * SubscriptionGroupUpdateRequest
 */
export const zSubscriptionGroupUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionGroups']),
        id: z.string(),
        attributes: z.optional(z.object({
            referenceName: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * SubscriptionImageCreateRequest
 */
export const zSubscriptionImageCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionImages']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string()
        }),
        relationships: z.object({
            subscription: z.object({
                data: z.object({
                    type: z.enum(['subscriptions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * SubscriptionImageUpdateRequest
 */
export const zSubscriptionImageUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionImages']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksum: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * SubscriptionIntroductoryOfferUpdateRequest
 */
export const zSubscriptionIntroductoryOfferUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionIntroductoryOffers']),
        id: z.string(),
        attributes: z.optional(z.object({
            endDate: z.optional(z.union([
                z.iso.date(),
                z.null()
            ]))
        }))
    })
});

/**
 * SubscriptionLocalizationCreateRequest
 */
export const zSubscriptionLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionLocalizations']),
        attributes: z.object({
            name: z.string(),
            locale: z.string(),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.object({
            subscription: z.object({
                data: z.object({
                    type: z.enum(['subscriptions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * SubscriptionLocalizationUpdateRequest
 */
export const zSubscriptionLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * SubscriptionOfferCodeCustomCodeCreateRequest
 */
export const zSubscriptionOfferCodeCustomCodeCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionOfferCodeCustomCodes']),
        attributes: z.object({
            customCode: z.string(),
            numberOfCodes: z.int(),
            expirationDate: z.optional(z.union([
                z.iso.date(),
                z.null()
            ]))
        }),
        relationships: z.object({
            offerCode: z.object({
                data: z.object({
                    type: z.enum(['subscriptionOfferCodes']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * SubscriptionOfferCodeCustomCodeUpdateRequest
 */
export const zSubscriptionOfferCodeCustomCodeUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionOfferCodeCustomCodes']),
        id: z.string(),
        attributes: z.optional(z.object({
            active: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * SubscriptionOfferCodeOneTimeUseCodeUpdateRequest
 */
export const zSubscriptionOfferCodeOneTimeUseCodeUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionOfferCodeOneTimeUseCodes']),
        id: z.string(),
        attributes: z.optional(z.object({
            active: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

export const zSubscriptionOfferCodePriceInlineCreate = z.object({
    type: z.enum(['subscriptionOfferCodePrices']),
    id: z.optional(z.string()),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        subscriptionPricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionPricePoints']),
                id: z.string()
            }))
        }))
    }))
});

/**
 * SubscriptionOfferCodeUpdateRequest
 */
export const zSubscriptionOfferCodeUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionOfferCodes']),
        id: z.string(),
        attributes: z.optional(z.object({
            active: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

export const zSubscriptionPricePointInlineCreate = z.object({
    type: z.enum(['subscriptionPricePoints']),
    id: z.optional(z.string())
});

export const zSubscriptionPriceInlineCreate = z.object({
    type: z.enum(['subscriptionPrices']),
    id: z.optional(z.string()),
    attributes: z.optional(z.object({
        startDate: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        preserveCurrentPrice: z.optional(z.union([
            z.boolean(),
            z.null()
        ]))
    })),
    relationships: z.optional(z.object({
        subscription: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptions']),
                id: z.string()
            }))
        })),
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        subscriptionPricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionPricePoints']),
                id: z.string()
            }))
        }))
    }))
});

/**
 * SubscriptionPriceCreateRequest
 */
export const zSubscriptionPriceCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionPrices']),
        attributes: z.optional(z.object({
            startDate: z.optional(z.union([
                z.iso.date(),
                z.null()
            ])),
            preserveCurrentPrice: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        })),
        relationships: z.object({
            subscription: z.object({
                data: z.object({
                    type: z.enum(['subscriptions']),
                    id: z.string()
                })
            }),
            territory: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['territories']),
                    id: z.string()
                }))
            })),
            subscriptionPricePoint: z.object({
                data: z.object({
                    type: z.enum(['subscriptionPricePoints']),
                    id: z.string()
                })
            })
        })
    })
});

export const zSubscriptionPromotionalOfferPriceInlineCreate = z.object({
    type: z.enum(['subscriptionPromotionalOfferPrices']),
    id: z.optional(z.string()),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        subscriptionPricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionPricePoints']),
                id: z.string()
            }))
        }))
    }))
});

/**
 * SubscriptionPromotionalOfferUpdateRequest
 */
export const zSubscriptionPromotionalOfferUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionPromotionalOffers']),
        id: z.string(),
        relationships: z.optional(z.object({
            prices: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['subscriptionPromotionalOfferPrices']),
                    id: z.string()
                })))
            }))
        }))
    }),
    included: z.optional(z.array(zSubscriptionPromotionalOfferPriceInlineCreate))
});

/**
 * SubscriptionSubmissionCreateRequest
 */
export const zSubscriptionSubmissionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionSubmissions']),
        relationships: z.object({
            subscription: z.object({
                data: z.object({
                    type: z.enum(['subscriptions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * SubscriptionCreateRequest
 */
export const zSubscriptionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptions']),
        attributes: z.object({
            name: z.string(),
            productId: z.string(),
            familySharable: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            subscriptionPeriod: z.optional(z.enum([
                'ONE_WEEK',
                'ONE_MONTH',
                'TWO_MONTHS',
                'THREE_MONTHS',
                'SIX_MONTHS',
                'ONE_YEAR'
            ])),
            reviewNote: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            groupLevel: z.optional(z.union([
                z.int(),
                z.null()
            ]))
        }),
        relationships: z.object({
            group: z.object({
                data: z.object({
                    type: z.enum(['subscriptionGroups']),
                    id: z.string()
                })
            })
        })
    })
});

export const zTerritoryInlineCreate = z.object({
    type: z.enum(['territories']),
    id: z.optional(z.string())
});

/**
 * AppPriceScheduleCreateRequest
 */
export const zAppPriceScheduleCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appPriceSchedules']),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            }),
            baseTerritory: z.object({
                data: z.object({
                    type: z.enum(['territories']),
                    id: z.string()
                })
            }),
            manualPrices: z.object({
                data: z.array(z.object({
                    type: z.enum(['appPrices']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(z.union([zAppPriceV2InlineCreate, zTerritoryInlineCreate])))
});

/**
 * InAppPurchasePriceScheduleCreateRequest
 */
export const zInAppPurchasePriceScheduleCreateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchasePriceSchedules']),
        relationships: z.object({
            inAppPurchase: z.object({
                data: z.object({
                    type: z.enum(['inAppPurchases']),
                    id: z.string()
                })
            }),
            baseTerritory: z.object({
                data: z.object({
                    type: z.enum(['territories']),
                    id: z.string()
                })
            }),
            manualPrices: z.object({
                data: z.array(z.object({
                    type: z.enum(['inAppPurchasePrices']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(z.union([zInAppPurchasePriceInlineCreate, zTerritoryInlineCreate])))
});

export const zTerritoryAvailabilityInlineCreate = z.object({
    type: z.enum(['territoryAvailabilities']),
    id: z.optional(z.string())
});

/**
 * AppAvailabilityV2CreateRequest
 */
export const zAppAvailabilityV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['appAvailabilities']),
        attributes: z.object({
            availableInNewTerritories: z.boolean()
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            }),
            territoryAvailabilities: z.object({
                data: z.array(z.object({
                    type: z.enum(['territoryAvailabilities']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(zTerritoryAvailabilityInlineCreate))
});

/**
 * TerritoryAvailabilityUpdateRequest
 */
export const zTerritoryAvailabilityUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['territoryAvailabilities']),
        id: z.string(),
        attributes: z.optional(z.object({
            available: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            releaseDate: z.optional(z.union([
                z.iso.date(),
                z.null()
            ])),
            preOrderEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * WebhookDeliveryCreateRequest
 */
export const zWebhookDeliveryCreateRequest = z.object({
    data: z.object({
        type: z.enum(['webhookDeliveries']),
        relationships: z.object({
            template: z.object({
                data: z.object({
                    type: z.enum(['webhookDeliveries']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * WebhookPingCreateRequest
 */
export const zWebhookPingCreateRequest = z.object({
    data: z.object({
        type: z.enum(['webhookPings']),
        relationships: z.object({
            webhook: z.object({
                data: z.object({
                    type: z.enum(['webhooks']),
                    id: z.string()
                })
            })
        })
    })
});

export const zWinBackOfferPriceInlineCreate = z.object({
    type: z.enum(['winBackOfferPrices']),
    id: z.optional(z.string())
});

export const zAppClipDefaultExperienceReleaseWithAppStoreVersionLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersions']),
        id: z.string()
    })
});

export const zAppCustomProductPageLocalizationSearchKeywordsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['appKeywords']),
        id: z.string()
    }))
});

/**
 * @deprecated
 */
export const zAppEncryptionDeclarationBuildsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['builds']),
        id: z.string()
    }))
});

export const zAppPreviewSetAppPreviewsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['appPreviews']),
        id: z.string()
    }))
});

export const zAppScreenshotSetAppScreenshotsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['appScreenshots']),
        id: z.string()
    }))
});

export const zAppStoreVersionLocalizationSearchKeywordsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['appKeywords']),
        id: z.string()
    }))
});

export const zAppStoreVersionAppClipDefaultExperienceLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['appClipDefaultExperiences']),
        id: z.string()
    })
});

export const zAppStoreVersionBuildLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['builds']),
        id: z.string()
    })
});

export const zAppBetaTestersLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['betaTesters']),
        id: z.string()
    }))
});

export const zAppPromotedPurchasesLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['promotedPurchases']),
        id: z.string()
    }))
});

export const zBetaGroupBetaTestersLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['betaTesters']),
        id: z.string()
    }))
});

export const zBetaGroupBuildsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['builds']),
        id: z.string()
    }))
});

export const zBetaTesterAppsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['apps']),
        id: z.string()
    }))
});

export const zBetaTesterBetaGroupsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['betaGroups']),
        id: z.string()
    }))
});

export const zBetaTesterBuildsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['builds']),
        id: z.string()
    }))
});

export const zBuildAppEncryptionDeclarationLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['appEncryptionDeclarations']),
        id: z.string()
    })
});

export const zBuildBetaGroupsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['betaGroups']),
        id: z.string()
    }))
});

export const zBuildIndividualTestersLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['betaTesters']),
        id: z.string()
    }))
});

export const zGameCenterAchievementV2ActivityLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivities']),
        id: z.string()
    })
});

export const zGameCenterAchievementActivityLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivities']),
        id: z.string()
    })
});

/**
 * @deprecated
 */
export const zGameCenterAchievementGroupAchievementLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    })
});

export const zGameCenterActivityAchievementsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    }))
});

export const zGameCenterActivityAchievementsV2LinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    }))
});

export const zGameCenterActivityLeaderboardsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    }))
});

export const zGameCenterActivityLeaderboardsV2LinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    }))
});

export const zGameCenterAppVersionCompatibilityVersionsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAppVersions']),
        id: z.string()
    }))
});

export const zGameCenterChallengeLeaderboardLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    })
});

export const zGameCenterChallengeLeaderboardV2LinkageRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    })
});

export const zGameCenterDetailChallengesMinimumPlatformVersionsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['appStoreVersions']),
        id: z.string()
    }))
});

export const zGameCenterDetailGameCenterAchievementsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    }))
});

export const zGameCenterDetailGameCenterAchievementsV2LinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    }))
});

export const zGameCenterDetailGameCenterLeaderboardSetsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string()
    }))
});

export const zGameCenterDetailGameCenterLeaderboardSetsV2LinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string()
    }))
});

export const zGameCenterDetailGameCenterLeaderboardsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    }))
});

export const zGameCenterDetailGameCenterLeaderboardsV2LinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    }))
});

/**
 * @deprecated
 */
export const zGameCenterEnabledVersionCompatibleVersionsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterEnabledVersions']),
        id: z.string()
    }))
});

export const zGameCenterGroupGameCenterAchievementsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    }))
});

export const zGameCenterGroupGameCenterAchievementsV2LinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    }))
});

export const zGameCenterGroupGameCenterLeaderboardSetsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string()
    }))
});

export const zGameCenterGroupGameCenterLeaderboardSetsV2LinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string()
    }))
});

export const zGameCenterGroupGameCenterLeaderboardsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    }))
});

export const zGameCenterGroupGameCenterLeaderboardsV2LinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    }))
});

export const zGameCenterLeaderboardSetV2GameCenterLeaderboardsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    }))
});

export const zGameCenterLeaderboardSetGameCenterLeaderboardsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    }))
});

/**
 * @deprecated
 */
export const zGameCenterLeaderboardSetGroupLeaderboardSetLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string()
    })
});

export const zGameCenterLeaderboardActivityLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivities']),
        id: z.string()
    })
});

export const zGameCenterLeaderboardChallengeLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterChallenges']),
        id: z.string()
    })
});

/**
 * @deprecated
 */
export const zGameCenterLeaderboardGroupLeaderboardLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    })
});

export const zGameCenterLeaderboardV2ActivityLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivities']),
        id: z.string()
    })
});

export const zGameCenterLeaderboardV2ChallengeLinkageRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterChallenges']),
        id: z.string()
    })
});

export const zSubscriptionIntroductoryOffersLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionIntroductoryOffers']),
        id: z.string()
    }))
});

export const zSubscriptionPricesLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionPrices']),
        id: z.string()
    }))
});

export const zUserVisibleAppsLinkagesRequest = z.object({
    data: z.array(z.object({
        type: z.enum(['apps']),
        id: z.string()
    }))
});

/**
 * Parameter
 */
export const zErrorSourceParameter = z.object({
    parameter: z.string()
});

/**
 * JsonPointer
 */
export const zErrorSourcePointer = z.object({
    pointer: z.string()
});

export const zErrorLinks = z.object({
    about: z.optional(z.string()),
    associated: z.optional(z.union([
        z.string(),
        z.object({
            href: z.optional(z.string()),
            meta: z.optional(z.object({
                source: z.optional(z.string())
            }))
        })
    ]))
});

export const zErrorResponse = z.object({
    errors: z.optional(z.array(z.object({
        id: z.optional(z.string()),
        status: z.string(),
        code: z.string(),
        title: z.string(),
        detail: z.string(),
        source: z.optional(z.union([
            zErrorSourcePointer,
            zErrorSourceParameter
        ])),
        links: z.optional(zErrorLinks),
        meta: z.optional(z.record(z.string(), z.unknown()))
    })))
});

export const zPagedDocumentLinks = z.object({
    self: z.string(),
    first: z.optional(z.string()),
    next: z.optional(z.string())
});

export const zPagingInformation = z.object({
    paging: z.object({
        total: z.optional(z.int()),
        limit: z.int(),
        nextCursor: z.optional(z.string())
    })
});

export const zAlternativeDistributionPackageVersionDeltasLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['alternativeDistributionPackageDeltas']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAlternativeDistributionPackageVersionVariantsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['alternativeDistributionPackageVariants']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAlternativeDistributionPackageVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['alternativeDistributionPackageVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAnalyticsReportInstanceSegmentsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['analyticsReportSegments']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAnalyticsReportRequestReportsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['analyticsReports']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAnalyticsReportInstancesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['analyticsReportInstances']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAvailabilityV2TerritoryAvailabilitiesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['territoryAvailabilities']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppCategorySubcategoriesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appCategories']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppClipDefaultExperienceAppClipDefaultExperienceLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appClipDefaultExperienceLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppClipAppClipAdvancedExperiencesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appClipAdvancedExperiences']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppClipAppClipDefaultExperiencesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appClipDefaultExperiences']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppCustomProductPageLocalizationAppPreviewSetsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appPreviewSets']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppCustomProductPageLocalizationAppScreenshotSetsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appScreenshotSets']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppCustomProductPageLocalizationSearchKeywordsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appKeywords']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppCustomProductPageVersionAppCustomProductPageLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appCustomProductPageLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppCustomProductPageAppCustomProductPageVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appCustomProductPageVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppEventLocalizationAppEventScreenshotsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appEventScreenshots']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppEventLocalizationAppEventVideoClipsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appEventVideoClips']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppEventLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appEventLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppInfoAppInfoLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appInfoLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppInfoTerritoryAgeRatingsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['territoryAgeRatings']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppPreviewSetAppPreviewsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appPreviews']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppPricePointV3EqualizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appPricePoints']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppPriceScheduleAutomaticPricesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appPrices']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppPriceScheduleManualPricesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appPrices']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppScreenshotSetAppScreenshotsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appScreenshots']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppStoreReviewDetailAppStoreReviewAttachmentsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appStoreReviewAttachments']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppStoreVersionExperimentTreatmentLocalizationAppPreviewSetsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appPreviewSets']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppStoreVersionExperimentTreatmentLocalizationAppScreenshotSetsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appScreenshotSets']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppStoreVersionExperimentTreatmentAppStoreVersionExperimentTreatmentLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appStoreVersionExperimentTreatmentLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppStoreVersionExperimentV2AppStoreVersionExperimentTreatmentsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appStoreVersionExperimentTreatments']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * @deprecated
 */
export const zAppStoreVersionExperimentAppStoreVersionExperimentTreatmentsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appStoreVersionExperimentTreatments']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppStoreVersionLocalizationAppPreviewSetsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appPreviewSets']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppStoreVersionLocalizationAppScreenshotSetsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appScreenshotSets']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppStoreVersionLocalizationSearchKeywordsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appKeywords']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * @deprecated
 */
export const zAppStoreVersionAppStoreVersionExperimentsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appStoreVersionExperiments']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppStoreVersionAppStoreVersionExperimentsV2LinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appStoreVersionExperiments']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppStoreVersionAppStoreVersionLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appStoreVersionLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppStoreVersionCustomerReviewsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['customerReviews']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppTagTerritoriesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['territories']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAccessibilityDeclarationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['accessibilityDeclarations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAnalyticsReportRequestsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['analyticsReportRequests']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAndroidToIosAppMappingDetailsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['androidToIosAppMappingDetails']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAppClipsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appClips']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAppCustomProductPagesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appCustomProductPages']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAppEncryptionDeclarationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appEncryptionDeclarations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAppEventsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appEvents']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAppInfosLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appInfos']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAppPricePointsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appPricePoints']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAppStoreVersionExperimentsV2LinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appStoreVersionExperiments']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAppStoreVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appStoreVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppAppTagsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appTags']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppBackgroundAssetsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['backgroundAssets']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppBetaAppLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['betaAppLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppBetaFeedbackCrashSubmissionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['betaFeedbackCrashSubmissions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppBetaFeedbackScreenshotSubmissionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['betaFeedbackScreenshotSubmissions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppBetaGroupsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['betaGroups']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppBuildUploadsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['buildUploads']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppBuildsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['builds']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppCustomerReviewsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['customerReviews']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * @deprecated
 */
export const zAppGameCenterEnabledVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterEnabledVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * @deprecated
 */
export const zAppInAppPurchasesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['inAppPurchases']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppInAppPurchasesV2LinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['inAppPurchases']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppPerfPowerMetricsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['perfPowerMetrics']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppPreReleaseVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['preReleaseVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppPromotedPurchasesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['promotedPurchases']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppReviewSubmissionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['reviewSubmissions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppSearchKeywordsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['appKeywords']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppSubscriptionGroupsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionGroups']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppWebhooksLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['webhooks']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBackgroundAssetVersionBackgroundAssetUploadFilesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['backgroundAssetUploadFiles']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBackgroundAssetVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['backgroundAssetVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBetaGroupBetaTestersLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['betaTesters']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBetaGroupBuildsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['builds']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBetaTesterAppsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['apps']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBetaTesterBetaGroupsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['betaGroups']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBetaTesterBuildsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['builds']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBuildBundleBetaAppClipInvocationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['betaAppClipInvocations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBuildBundleBuildBundleFileSizesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['buildBundleFileSizes']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBuildUploadBuildUploadFilesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['buildUploadFiles']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBuildBetaBuildLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['betaBuildLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBuildDiagnosticSignaturesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['diagnosticSignatures']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBuildIconsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['buildIcons']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBuildIndividualTestersLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['betaTesters']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBuildPerfPowerMetricsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['perfPowerMetrics']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBundleIdBundleIdCapabilitiesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['bundleIdCapabilities']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBundleIdProfilesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['profiles']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCiBuildActionArtifactsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['ciArtifacts']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCiBuildActionIssuesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['ciIssues']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCiBuildActionTestResultsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['ciTestResults']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCiBuildRunActionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['ciBuildActions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCiBuildRunBuildsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['builds']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCiMacOsVersionXcodeVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['ciXcodeVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCiProductAdditionalRepositoriesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['scmRepositories']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCiProductBuildRunsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['ciBuildRuns']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCiProductPrimaryRepositoriesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['scmRepositories']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCiProductWorkflowsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['ciWorkflows']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCiWorkflowBuildRunsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['ciBuildRuns']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCiXcodeVersionMacOsVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['ciMacOsVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zDiagnosticSignatureLogsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['diagnosticLogs']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zEndUserLicenseAgreementTerritoriesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['territories']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterAchievementVersionV2LocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievementLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterAchievementV2VersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievementVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterAchievementLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievementLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterAchievementReleasesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievementReleases']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterActivityVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterActivityVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterActivityVersionLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterActivityLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterAppVersionCompatibilityVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAppVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterChallengeVersionLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterChallengeLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterChallengeVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterChallengeVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailAchievementReleasesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievementReleases']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailActivityReleasesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterActivityVersionReleases']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailChallengeReleasesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterChallengeVersionReleases']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailGameCenterAchievementsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailGameCenterAchievementsV2LinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailGameCenterActivitiesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterActivities']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailGameCenterAppVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAppVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailGameCenterChallengesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterChallenges']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailGameCenterLeaderboardSetsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailGameCenterLeaderboardSetsV2LinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailGameCenterLeaderboardsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailGameCenterLeaderboardsV2LinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailLeaderboardReleasesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardReleases']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterDetailLeaderboardSetReleasesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSetReleases']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * @deprecated
 */
export const zGameCenterEnabledVersionCompatibleVersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterEnabledVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterGroupGameCenterAchievementsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterGroupGameCenterAchievementsV2LinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterGroupGameCenterActivitiesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterActivities']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterGroupGameCenterChallengesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterChallenges']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterGroupGameCenterDetailsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterDetails']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterGroupGameCenterLeaderboardSetsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterGroupGameCenterLeaderboardSetsV2LinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterGroupGameCenterLeaderboardsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterGroupGameCenterLeaderboardsV2LinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterLeaderboardSetVersionV2LocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSetLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterLeaderboardSetV2GameCenterLeaderboardsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterLeaderboardSetV2VersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSetVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterLeaderboardSetGameCenterLeaderboardsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterLeaderboardSetLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSetLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterLeaderboardSetReleasesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardSetReleases']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterLeaderboardVersionV2LocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterLeaderboardLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterLeaderboardReleasesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardReleases']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterLeaderboardV2VersionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterLeaderboardVersions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterMatchmakingRuleSetMatchmakingQueuesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterMatchmakingQueues']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterMatchmakingRuleSetRulesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterMatchmakingRules']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterMatchmakingRuleSetTeamsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['gameCenterMatchmakingTeams']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zInAppPurchaseAvailabilityAvailableTerritoriesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['territories']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zInAppPurchaseOfferCodeCustomCodesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['inAppPurchaseOfferCodeCustomCodes']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zInAppPurchaseOfferCodeOneTimeUseCodesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['inAppPurchaseOfferCodeOneTimeUseCodes']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zInAppPurchaseOfferCodePricesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['inAppPurchaseOfferPrices']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zInAppPurchasePricePointEqualizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['inAppPurchasePricePoints']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zInAppPurchasePriceScheduleAutomaticPricesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['inAppPurchasePrices']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zInAppPurchasePriceScheduleManualPricesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['inAppPurchasePrices']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zInAppPurchaseV2ImagesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['inAppPurchaseImages']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zInAppPurchaseV2InAppPurchaseLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['inAppPurchaseLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zInAppPurchaseV2OfferCodesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['inAppPurchaseOfferCodes']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zInAppPurchaseV2PricePointsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['inAppPurchasePricePoints']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zMerchantIdCertificatesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['certificates']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zPassTypeIdCertificatesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['certificates']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zPrereleaseVersionBuildsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['builds']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zProfileCertificatesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['certificates']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zProfileDevicesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['devices']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zReviewSubmissionItemsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['reviewSubmissionItems']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zScmProviderRepositoriesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['scmRepositories']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zScmRepositoryGitReferencesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['scmGitReferences']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zScmRepositoryPullRequestsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['scmPullRequests']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionAvailabilityAvailableTerritoriesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['territories']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionGroupSubscriptionGroupLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionGroupLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionGroupSubscriptionsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptions']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionOfferCodeCustomCodesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionOfferCodeCustomCodes']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionOfferCodeOneTimeUseCodesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionOfferCodeOneTimeUseCodes']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionOfferCodePricesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionOfferCodePrices']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionPricePointEqualizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionPricePoints']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionPromotionalOfferPricesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionPromotionalOfferPrices']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionImagesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionImages']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionIntroductoryOffersLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionIntroductoryOffers']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionOfferCodesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionOfferCodes']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionPricePointsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionPricePoints']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionPricesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionPrices']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionPromotionalOffersLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionPromotionalOffers']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionSubscriptionLocalizationsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['subscriptionLocalizations']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zSubscriptionWinBackOffersLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['winBackOffers']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zUserInvitationVisibleAppsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['apps']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zUserVisibleAppsLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['apps']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zWebhookDeliveriesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['webhookDeliveries']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zWinBackOfferPricesLinkagesResponse = z.object({
    data: z.array(z.object({
        type: z.enum(['winBackOfferPrices']),
        id: z.string()
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBetaPublicLinkUsagesV1MetricResponse = z.object({
    data: z.array(z.object({
        dataPoints: z.optional(z.object({
            start: z.optional(z.iso.datetime()),
            end: z.optional(z.iso.datetime()),
            values: z.optional(z.object({
                viewCount: z.optional(z.int()),
                acceptedCount: z.optional(z.int()),
                didNotAcceptCount: z.optional(z.int()),
                didNotMeetCriteriaCount: z.optional(z.int()),
                notRelevantRatio: z.optional(z.number()),
                notClearRatio: z.optional(z.number()),
                notInterestingRatio: z.optional(z.number())
            }))
        }))
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBetaTesterUsagesV1MetricResponse = z.object({
    data: z.array(z.object({
        dataPoints: z.optional(z.object({
            start: z.optional(z.iso.datetime()),
            end: z.optional(z.iso.datetime()),
            values: z.optional(z.object({
                crashCount: z.optional(z.int()),
                sessionCount: z.optional(z.int()),
                feedbackCount: z.optional(z.int())
            }))
        })),
        dimensions: z.optional(z.object({
            apps: z.optional(z.object({
                links: z.optional(z.object({
                    groupBy: z.optional(z.string()),
                    related: z.optional(z.string())
                })),
                data: z.optional(z.string())
            }))
        }))
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zBetaBuildUsagesV1MetricResponse = z.object({
    data: z.array(z.object({
        dataPoints: z.optional(z.object({
            start: z.optional(z.iso.datetime()),
            end: z.optional(z.iso.datetime()),
            values: z.optional(z.object({
                crashCount: z.optional(z.int()),
                installCount: z.optional(z.int()),
                sessionCount: z.optional(z.int()),
                feedbackCount: z.optional(z.int()),
                inviteCount: z.optional(z.int())
            }))
        }))
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterMatchmakingAppRequestsV1MetricResponse = z.object({
    data: z.array(z.object({
        dataPoints: z.optional(z.object({
            start: z.optional(z.iso.datetime()),
            end: z.optional(z.iso.datetime()),
            values: z.optional(z.object({
                count: z.optional(z.int()),
                averageSecondsInQueue: z.optional(z.number()),
                p50SecondsInQueue: z.optional(z.number()),
                p95SecondsInQueue: z.optional(z.number())
            }))
        })),
        dimensions: z.optional(z.object({
            result: z.optional(z.object({
                links: z.optional(z.object({
                    groupBy: z.optional(z.string())
                })),
                data: z.optional(z.enum([
                    'MATCHED',
                    'CANCELED',
                    'EXPIRED'
                ]))
            }))
        })),
        granularity: z.optional(z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]))
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterMatchmakingQueueSizesV1MetricResponse = z.object({
    data: z.array(z.object({
        dataPoints: z.optional(z.object({
            start: z.optional(z.iso.datetime()),
            end: z.optional(z.iso.datetime()),
            values: z.optional(z.object({
                count: z.optional(z.int()),
                averageNumberOfRequests: z.optional(z.number()),
                p50NumberOfRequests: z.optional(z.number()),
                p95NumberOfRequests: z.optional(z.number())
            }))
        })),
        granularity: z.optional(z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]))
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterMatchmakingQueueRequestsV1MetricResponse = z.object({
    data: z.array(z.object({
        dataPoints: z.optional(z.object({
            start: z.optional(z.iso.datetime()),
            end: z.optional(z.iso.datetime()),
            values: z.optional(z.object({
                count: z.optional(z.int()),
                averageSecondsInQueue: z.optional(z.number()),
                p50SecondsInQueue: z.optional(z.number()),
                p95SecondsInQueue: z.optional(z.number())
            }))
        })),
        dimensions: z.optional(z.object({
            result: z.optional(z.object({
                links: z.optional(z.object({
                    groupBy: z.optional(z.string())
                })),
                data: z.optional(z.enum([
                    'MATCHED',
                    'CANCELED',
                    'EXPIRED'
                ]))
            })),
            gameCenterDetail: z.optional(z.object({
                links: z.optional(z.object({
                    groupBy: z.optional(z.string()),
                    related: z.optional(z.string())
                })),
                data: z.optional(z.string())
            }))
        })),
        granularity: z.optional(z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]))
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterMatchmakingSessionsV1MetricResponse = z.object({
    data: z.array(z.object({
        dataPoints: z.optional(z.object({
            start: z.optional(z.iso.datetime()),
            end: z.optional(z.iso.datetime()),
            values: z.optional(z.object({
                count: z.optional(z.int()),
                averagePlayerCount: z.optional(z.number()),
                p50PlayerCount: z.optional(z.number()),
                p95PlayerCount: z.optional(z.number())
            }))
        })),
        granularity: z.optional(z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]))
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterMatchmakingBooleanRuleResultsV1MetricResponse = z.object({
    data: z.array(z.object({
        dataPoints: z.optional(z.object({
            start: z.optional(z.iso.datetime()),
            end: z.optional(z.iso.datetime()),
            values: z.optional(z.object({
                count: z.optional(z.int())
            }))
        })),
        dimensions: z.optional(z.object({
            result: z.optional(z.object({
                links: z.optional(z.object({
                    groupBy: z.optional(z.string())
                })),
                data: z.optional(z.string())
            })),
            gameCenterMatchmakingQueue: z.optional(z.object({
                links: z.optional(z.object({
                    groupBy: z.optional(z.string()),
                    related: z.optional(z.string())
                })),
                data: z.optional(z.string())
            }))
        })),
        granularity: z.optional(z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]))
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterMatchmakingNumberRuleResultsV1MetricResponse = z.object({
    data: z.array(z.object({
        dataPoints: z.optional(z.object({
            start: z.optional(z.iso.datetime()),
            end: z.optional(z.iso.datetime()),
            values: z.optional(z.object({
                count: z.optional(z.int()),
                averageResult: z.optional(z.number()),
                p50Result: z.optional(z.number()),
                p95Result: z.optional(z.number())
            }))
        })),
        dimensions: z.optional(z.object({
            gameCenterMatchmakingQueue: z.optional(z.object({
                links: z.optional(z.object({
                    groupBy: z.optional(z.string()),
                    related: z.optional(z.string())
                })),
                data: z.optional(z.string())
            }))
        })),
        granularity: z.optional(z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]))
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zGameCenterMatchmakingRuleErrorsV1MetricResponse = z.object({
    data: z.array(z.object({
        dataPoints: z.optional(z.object({
            start: z.optional(z.iso.datetime()),
            end: z.optional(z.iso.datetime()),
            values: z.optional(z.object({
                count: z.optional(z.int())
            }))
        })),
        dimensions: z.optional(z.object({
            gameCenterMatchmakingQueue: z.optional(z.object({
                links: z.optional(z.object({
                    groupBy: z.optional(z.string()),
                    related: z.optional(z.string())
                })),
                data: z.optional(z.string())
            }))
        })),
        granularity: z.optional(z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]))
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zDocumentLinks = z.object({
    self: z.string()
});

export const zAppCategoryParentLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appCategories']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppClipDefaultExperienceLocalizationAppClipHeaderImageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appClipHeaderImages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppClipDefaultExperienceAppClipAppStoreReviewDetailLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appClipAppStoreReviewDetails']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppClipDefaultExperienceReleaseWithAppStoreVersionLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appStoreVersions']),
        id: z.string()
    }),
    links: zDocumentLinks
});

/**
 * @deprecated
 */
export const zAppEncryptionDeclarationAppLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['apps']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppEncryptionDeclarationAppEncryptionDeclarationDocumentLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appEncryptionDeclarationDocuments']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppInfoAgeRatingDeclarationLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['ageRatingDeclarations']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppInfoPrimaryCategoryLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appCategories']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppInfoPrimarySubcategoryOneLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appCategories']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppInfoPrimarySubcategoryTwoLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appCategories']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppInfoSecondaryCategoryLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appCategories']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppInfoSecondarySubcategoryOneLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appCategories']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppInfoSecondarySubcategoryTwoLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appCategories']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppPriceScheduleBaseTerritoryLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['territories']),
        id: z.string()
    }),
    links: zDocumentLinks
});

/**
 * @deprecated
 */
export const zAppStoreVersionAgeRatingDeclarationLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['ageRatingDeclarations']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppStoreVersionAlternativeDistributionPackageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['alternativeDistributionPackages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppStoreVersionAppClipDefaultExperienceLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appClipDefaultExperiences']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppStoreVersionAppStoreReviewDetailLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appStoreReviewDetails']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppStoreVersionAppStoreVersionPhasedReleaseLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionPhasedReleases']),
        id: z.string()
    }),
    links: zDocumentLinks
});

/**
 * @deprecated
 */
export const zAppStoreVersionAppStoreVersionSubmissionLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionSubmissions']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppStoreVersionBuildLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['builds']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppStoreVersionGameCenterAppVersionLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterAppVersions']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppStoreVersionRoutingAppCoverageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['routingAppCoverages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppAlternativeDistributionKeyLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['alternativeDistributionKeys']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppAppAvailabilityV2LinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appAvailabilities']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppAppPriceScheduleLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appPriceSchedules']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppBetaAppReviewDetailLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['betaAppReviewDetails']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppBetaLicenseAgreementLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['betaLicenseAgreements']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppCiProductLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['ciProducts']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppEndUserLicenseAgreementLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['endUserLicenseAgreements']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppGameCenterDetailLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterDetails']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppMarketplaceSearchDetailLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['marketplaceSearchDetails']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zAppSubscriptionGracePeriodLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['subscriptionGracePeriods']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBetaAppLocalizationAppLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['apps']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBetaAppReviewDetailAppLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['apps']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBetaAppReviewSubmissionBuildLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['builds']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBetaBuildLocalizationBuildLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['builds']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBetaFeedbackCrashSubmissionCrashLogLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['betaCrashLogs']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBetaGroupAppLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['apps']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBetaGroupBetaRecruitmentCriteriaLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['betaRecruitmentCriteria']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBetaGroupBetaRecruitmentCriterionCompatibleBuildCheckLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['betaRecruitmentCriterionCompatibleBuildChecks']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBetaLicenseAgreementAppLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['apps']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBuildBetaDetailBuildLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['builds']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBuildBundleAppClipDomainCacheStatusLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appClipDomainStatuses']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBuildBundleAppClipDomainDebugStatusLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appClipDomainStatuses']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBuildAppLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['apps']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBuildAppEncryptionDeclarationLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appEncryptionDeclarations']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBuildAppStoreVersionLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appStoreVersions']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBuildBetaAppReviewSubmissionLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['betaAppReviewSubmissions']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBuildBuildBetaDetailLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['buildBetaDetails']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBuildPreReleaseVersionLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['preReleaseVersions']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zBundleIdAppLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['apps']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zCertificatePassTypeIdLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['passTypeIds']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zCiBuildActionBuildRunLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['ciBuildRuns']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zCiProductAppLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['apps']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zCiWorkflowRepositoryLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['scmRepositories']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zCustomerReviewResponseLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['customerReviewResponses']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterAchievementLocalizationV2ImageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievementImages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterAchievementLocalizationGameCenterAchievementLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterAchievementLocalizationGameCenterAchievementImageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievementImages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

/**
 * @deprecated
 */
export const zGameCenterAchievementGroupAchievementLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterActivityLocalizationImageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivityImages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterActivityVersionDefaultImageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivityImages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterAppVersionAppStoreVersionLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['appStoreVersions']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterChallengeLocalizationImageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterChallengeImages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterChallengeVersionDefaultImageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterChallengeImages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterDetailGameCenterGroupLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterGroups']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterLeaderboardLocalizationGameCenterLeaderboardImageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardImages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterLeaderboardLocalizationV2ImageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardImages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterLeaderboardSetLocalizationGameCenterLeaderboardSetImageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetImages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterLeaderboardSetLocalizationV2ImageLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSetImages']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterLeaderboardSetMemberLocalizationGameCenterLeaderboardLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zGameCenterLeaderboardSetMemberLocalizationGameCenterLeaderboardSetLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string()
    }),
    links: zDocumentLinks
});

/**
 * @deprecated
 */
export const zGameCenterLeaderboardSetGroupLeaderboardSetLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardSets']),
        id: z.string()
    }),
    links: zDocumentLinks
});

/**
 * @deprecated
 */
export const zGameCenterLeaderboardGroupLeaderboardLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zInAppPurchaseOfferCodeOneTimeUseCodeValuesLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseOfferCodeOneTimeUseCodeValues']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zInAppPurchasePriceScheduleBaseTerritoryLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['territories']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zInAppPurchaseV2AppStoreReviewScreenshotLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseAppStoreReviewScreenshots']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zInAppPurchaseV2ContentLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseContents']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zInAppPurchaseV2IapPriceScheduleLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['inAppPurchasePriceSchedules']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zInAppPurchaseV2InAppPurchaseAvailabilityLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseAvailabilities']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zInAppPurchaseV2PromotedPurchaseLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['promotedPurchases']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zPrereleaseVersionAppLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['apps']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zProfileBundleIdLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['bundleIds']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zSubscriptionOfferCodeOneTimeUseCodeValuesLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['subscriptionOfferCodeOneTimeUseCodeValues']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zSubscriptionAppStoreReviewScreenshotLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['subscriptionAppStoreReviewScreenshots']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zSubscriptionPromotedPurchaseLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['promotedPurchases']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zSubscriptionSubscriptionAvailabilityLinkageResponse = z.object({
    data: z.object({
        type: z.enum(['subscriptionAvailabilities']),
        id: z.string()
    }),
    links: zDocumentLinks
});

export const zResourceLinks = z.object({
    self: z.optional(z.string())
});

/**
 * Actor
 */
export const zActor = z.object({
    type: z.enum(['actors']),
    id: z.string(),
    attributes: z.optional(z.object({
        actorType: z.optional(z.enum([
            'USER',
            'API_KEY',
            'XCODE_CLOUD',
            'APPLE'
        ])),
        userFirstName: z.optional(z.string()),
        userLastName: z.optional(z.string()),
        userEmail: z.optional(z.string()),
        apiKeyId: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * ActorsResponse
 */
export const zActorsResponse = z.object({
    data: z.array(zActor),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * ActorResponse
 */
export const zActorResponse = z.object({
    data: zActor,
    links: zDocumentLinks
});

/**
 * AlternativeDistributionDomain
 */
export const zAlternativeDistributionDomain = z.object({
    type: z.enum(['alternativeDistributionDomains']),
    id: z.string(),
    attributes: z.optional(z.object({
        domain: z.optional(z.string()),
        referenceName: z.optional(z.string()),
        createdDate: z.optional(z.iso.datetime())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AlternativeDistributionDomainsResponse
 */
export const zAlternativeDistributionDomainsResponse = z.object({
    data: z.array(zAlternativeDistributionDomain),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AlternativeDistributionDomainResponse
 */
export const zAlternativeDistributionDomainResponse = z.object({
    data: zAlternativeDistributionDomain,
    links: zDocumentLinks
});

/**
 * AlternativeDistributionKey
 */
export const zAlternativeDistributionKey = z.object({
    type: z.enum(['alternativeDistributionKeys']),
    id: z.string(),
    attributes: z.optional(z.object({
        publicKey: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AlternativeDistributionKeysResponse
 */
export const zAlternativeDistributionKeysResponse = z.object({
    data: z.array(zAlternativeDistributionKey),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AlternativeDistributionKeyResponse
 */
export const zAlternativeDistributionKeyResponse = z.object({
    data: zAlternativeDistributionKey,
    links: zDocumentLinks
});

/**
 * AlternativeDistributionPackageDelta
 */
export const zAlternativeDistributionPackageDelta = z.object({
    type: z.enum(['alternativeDistributionPackageDeltas']),
    id: z.string(),
    attributes: z.optional(z.object({
        url: z.optional(z.url()),
        urlExpirationDate: z.optional(z.iso.datetime()),
        alternativeDistributionKeyBlob: z.optional(z.string()),
        fileChecksum: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AlternativeDistributionPackageDeltasResponse
 */
export const zAlternativeDistributionPackageDeltasResponse = z.object({
    data: z.array(zAlternativeDistributionPackageDelta),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AlternativeDistributionPackageDeltaResponse
 */
export const zAlternativeDistributionPackageDeltaResponse = z.object({
    data: zAlternativeDistributionPackageDelta,
    links: zDocumentLinks
});

/**
 * AlternativeDistributionPackageVariant
 */
export const zAlternativeDistributionPackageVariant = z.object({
    type: z.enum(['alternativeDistributionPackageVariants']),
    id: z.string(),
    attributes: z.optional(z.object({
        url: z.optional(z.url()),
        urlExpirationDate: z.optional(z.iso.datetime()),
        alternativeDistributionKeyBlob: z.optional(z.string()),
        fileChecksum: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AlternativeDistributionPackageVariantsResponse
 */
export const zAlternativeDistributionPackageVariantsResponse = z.object({
    data: z.array(zAlternativeDistributionPackageVariant),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AlternativeDistributionPackageVariantResponse
 */
export const zAlternativeDistributionPackageVariantResponse = z.object({
    data: zAlternativeDistributionPackageVariant,
    links: zDocumentLinks
});

/**
 * AnalyticsReportSegment
 */
export const zAnalyticsReportSegment = z.object({
    type: z.enum(['analyticsReportSegments']),
    id: z.string(),
    attributes: z.optional(z.object({
        checksum: z.optional(z.string()),
        sizeInBytes: z.optional(z.int()),
        url: z.optional(z.url())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AnalyticsReportSegmentsResponse
 */
export const zAnalyticsReportSegmentsResponse = z.object({
    data: z.array(zAnalyticsReportSegment),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AnalyticsReportSegmentResponse
 */
export const zAnalyticsReportSegmentResponse = z.object({
    data: zAnalyticsReportSegment,
    links: zDocumentLinks
});

/**
 * AndroidToIosAppMappingDetail
 */
export const zAndroidToIosAppMappingDetail = z.object({
    type: z.enum(['androidToIosAppMappingDetails']),
    id: z.string(),
    attributes: z.optional(z.object({
        packageName: z.optional(z.string()),
        appSigningKeyPublicCertificateSha256Fingerprints: z.optional(z.array(z.string()))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AndroidToIosAppMappingDetailsResponse
 */
export const zAndroidToIosAppMappingDetailsResponse = z.object({
    data: z.array(zAndroidToIosAppMappingDetail),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AndroidToIosAppMappingDetailResponse
 */
export const zAndroidToIosAppMappingDetailResponse = z.object({
    data: zAndroidToIosAppMappingDetail,
    links: zDocumentLinks
});

/**
 * AppClipAppStoreReviewDetail
 */
export const zAppClipAppStoreReviewDetail = z.object({
    type: z.enum(['appClipAppStoreReviewDetails']),
    id: z.string(),
    attributes: z.optional(z.object({
        invocationUrls: z.optional(z.array(z.url()))
    })),
    relationships: z.optional(z.object({
        appClipDefaultExperience: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appClipDefaultExperiences']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppClipDomainStatus
 */
export const zAppClipDomainStatus = z.object({
    type: z.enum(['appClipDomainStatuses']),
    id: z.string(),
    attributes: z.optional(z.object({
        domains: z.optional(z.array(z.object({
            domain: z.optional(z.string()),
            isValid: z.optional(z.boolean()),
            lastUpdatedDate: z.optional(z.iso.datetime()),
            errorCode: z.optional(z.enum([
                'BAD_HTTP_RESPONSE',
                'BAD_JSON_CONTENT',
                'BAD_PKCS7_SIGNATURE',
                'CANNOT_REACH_AASA_FILE',
                'CROSS_SITE_REDIRECTS_FORBIDDEN',
                'DNS_ERROR',
                'INSECURE_REDIRECTS_FORBIDDEN',
                'INVALID_ENTITLEMENT_MISSING_SECTION',
                'INVALID_ENTITLEMENT_SYNTAX_ERROR',
                'INVALID_ENTITLEMENT_UNHANDLED_SECTION',
                'INVALID_ENTITLEMENT_UNKNOWN_ID',
                'NETWORK_ERROR',
                'NETWORK_ERROR_TEMPORARY',
                'OTHER_ERROR',
                'TIMEOUT',
                'TLS_ERROR',
                'TOO_MANY_REDIRECTS',
                'UNEXPECTED_ERROR'
            ]))
        }))),
        lastUpdatedDate: z.optional(z.iso.datetime())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppClipDomainStatusResponse
 */
export const zAppClipDomainStatusResponse = z.object({
    data: zAppClipDomainStatus,
    links: zDocumentLinks
});

/**
 * AppInfoLocalization
 */
export const zAppInfoLocalization = z.object({
    type: z.enum(['appInfoLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string()),
        name: z.optional(z.string()),
        subtitle: z.optional(z.string()),
        privacyPolicyUrl: z.optional(z.string()),
        privacyChoicesUrl: z.optional(z.string()),
        privacyPolicyText: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        appInfo: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appInfos']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppKeyword
 */
export const zAppKeyword = z.object({
    type: z.enum(['appKeywords']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * AppKeywordsResponse
 */
export const zAppKeywordsResponse = z.object({
    data: z.array(zAppKeyword),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppPriceV2
 */
export const zAppPriceV2 = z.object({
    type: z.enum(['appPrices']),
    id: z.string(),
    attributes: z.optional(z.object({
        manual: z.optional(z.boolean()),
        startDate: z.optional(z.iso.date()),
        endDate: z.optional(z.iso.date())
    })),
    relationships: z.optional(z.object({
        appPricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appPricePoints']),
                id: z.string()
            }))
        })),
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppStoreVersionPromotion
 */
export const zAppStoreVersionPromotion = z.object({
    type: z.enum(['appStoreVersionPromotions']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * AppStoreVersionPromotionResponse
 */
export const zAppStoreVersionPromotionResponse = z.object({
    data: zAppStoreVersionPromotion,
    links: zDocumentLinks
});

/**
 * AppStoreVersionReleaseRequest
 */
export const zAppStoreVersionReleaseRequest = z.object({
    type: z.enum(['appStoreVersionReleaseRequests']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * AppStoreVersionReleaseRequestResponse
 */
export const zAppStoreVersionReleaseRequestResponse = z.object({
    data: zAppStoreVersionReleaseRequest,
    links: zDocumentLinks
});

/**
 * AppStoreVersionSubmission
 *
 * @deprecated
 */
export const zAppStoreVersionSubmission = z.object({
    type: z.enum(['appStoreVersionSubmissions']),
    id: z.string(),
    relationships: z.optional(z.object({
        appStoreVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BackgroundAssetVersionInternalBetaRelease
 */
export const zBackgroundAssetVersionInternalBetaRelease = z.object({
    type: z.enum(['backgroundAssetVersionInternalBetaReleases']),
    id: z.string(),
    attributes: z.optional(z.object({
        state: z.optional(z.enum(['READY_FOR_TESTING', 'SUPERSEDED']))
    })),
    relationships: z.optional(z.object({
        backgroundAssetVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssetVersions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaAppClipInvocationLocalization
 */
export const zBetaAppClipInvocationLocalization = z.object({
    type: z.enum(['betaAppClipInvocationLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        title: z.optional(z.string()),
        locale: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaAppClipInvocationLocalizationResponse
 */
export const zBetaAppClipInvocationLocalizationResponse = z.object({
    data: zBetaAppClipInvocationLocalization,
    links: zDocumentLinks
});

/**
 * BetaAppClipInvocation
 */
export const zBetaAppClipInvocation = z.object({
    type: z.enum(['betaAppClipInvocations']),
    id: z.string(),
    attributes: z.optional(z.object({
        url: z.optional(z.url())
    })),
    relationships: z.optional(z.object({
        betaAppClipInvocationLocalizations: z.optional(z.object({
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['betaAppClipInvocationLocalizations']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaAppClipInvocationsResponse
 */
export const zBetaAppClipInvocationsResponse = z.object({
    data: z.array(zBetaAppClipInvocation),
    included: z.optional(z.array(zBetaAppClipInvocationLocalization)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaAppClipInvocationResponse
 */
export const zBetaAppClipInvocationResponse = z.object({
    data: zBetaAppClipInvocation,
    included: z.optional(z.array(zBetaAppClipInvocationLocalization)),
    links: zDocumentLinks
});

/**
 * BetaCrashLog
 */
export const zBetaCrashLog = z.object({
    type: z.enum(['betaCrashLogs']),
    id: z.string(),
    attributes: z.optional(z.object({
        logText: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaCrashLogResponse
 */
export const zBetaCrashLogResponse = z.object({
    data: zBetaCrashLog,
    links: zDocumentLinks
});

/**
 * BetaRecruitmentCriterionCompatibleBuildCheck
 */
export const zBetaRecruitmentCriterionCompatibleBuildCheck = z.object({
    type: z.enum(['betaRecruitmentCriterionCompatibleBuildChecks']),
    id: z.string(),
    attributes: z.optional(z.object({
        hasCompatibleBuild: z.optional(z.boolean())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaRecruitmentCriterionCompatibleBuildCheckResponse
 */
export const zBetaRecruitmentCriterionCompatibleBuildCheckResponse = z.object({
    data: zBetaRecruitmentCriterionCompatibleBuildCheck,
    links: zDocumentLinks
});

/**
 * BetaTesterInvitation
 */
export const zBetaTesterInvitation = z.object({
    type: z.enum(['betaTesterInvitations']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * BetaTesterInvitationResponse
 */
export const zBetaTesterInvitationResponse = z.object({
    data: zBetaTesterInvitation,
    links: zDocumentLinks
});

/**
 * BuildBetaNotification
 */
export const zBuildBetaNotification = z.object({
    type: z.enum(['buildBetaNotifications']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * BuildBetaNotificationResponse
 */
export const zBuildBetaNotificationResponse = z.object({
    data: zBuildBetaNotification,
    links: zDocumentLinks
});

/**
 * BuildBundleFileSize
 */
export const zBuildBundleFileSize = z.object({
    type: z.enum(['buildBundleFileSizes']),
    id: z.string(),
    attributes: z.optional(z.object({
        deviceModel: z.optional(z.string()),
        osVersion: z.optional(z.string()),
        downloadBytes: z.optional(z.int()),
        installBytes: z.optional(z.int())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BuildBundleFileSizesResponse
 */
export const zBuildBundleFileSizesResponse = z.object({
    data: z.array(zBuildBundleFileSize),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * CiArtifact
 */
export const zCiArtifact = z.object({
    type: z.enum(['ciArtifacts']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileType: z.optional(z.enum([
            'ARCHIVE',
            'ARCHIVE_EXPORT',
            'LOG_BUNDLE',
            'RESULT_BUNDLE',
            'TEST_PRODUCTS',
            'XCODEBUILD_PRODUCTS',
            'STAPLED_NOTARIZED_ARCHIVE'
        ])),
        fileName: z.optional(z.string()),
        fileSize: z.optional(z.int()),
        downloadUrl: z.optional(z.url())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * CiArtifactsResponse
 */
export const zCiArtifactsResponse = z.object({
    data: z.array(zCiArtifact),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * CiArtifactResponse
 */
export const zCiArtifactResponse = z.object({
    data: zCiArtifact,
    links: zDocumentLinks
});

/**
 * CustomerReviewResponseV1
 */
export const zCustomerReviewResponseV1 = z.object({
    type: z.enum(['customerReviewResponses']),
    id: z.string(),
    attributes: z.optional(z.object({
        responseBody: z.optional(z.string()),
        lastModifiedDate: z.optional(z.iso.datetime()),
        state: z.optional(z.enum(['PUBLISHED', 'PENDING_PUBLISH']))
    })),
    relationships: z.optional(z.object({
        review: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['customerReviews']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * DiagnosticLog
 */
export const zDiagnosticLog = z.object({
    type: z.enum(['diagnosticLogs']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * EndAppAvailabilityPreOrder
 */
export const zEndAppAvailabilityPreOrder = z.object({
    type: z.enum(['endAppAvailabilityPreOrders']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * EndAppAvailabilityPreOrderResponse
 */
export const zEndAppAvailabilityPreOrderResponse = z.object({
    data: zEndAppAvailabilityPreOrder,
    links: zDocumentLinks
});

/**
 * GameCenterAchievementRelease
 */
export const zGameCenterAchievementRelease = z.object({
    type: z.enum(['gameCenterAchievementReleases']),
    id: z.string(),
    attributes: z.optional(z.object({
        live: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        gameCenterDetail: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            }))
        })),
        gameCenterAchievement: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterAchievements']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterActivityVersionRelease
 */
export const zGameCenterActivityVersionRelease = z.object({
    type: z.enum(['gameCenterActivityVersionReleases']),
    id: z.string(),
    relationships: z.optional(z.object({
        version: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterActivityVersions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterChallengeVersionRelease
 */
export const zGameCenterChallengeVersionRelease = z.object({
    type: z.enum(['gameCenterChallengeVersionReleases']),
    id: z.string(),
    relationships: z.optional(z.object({
        version: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterChallengeVersions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardEntrySubmission
 */
export const zGameCenterLeaderboardEntrySubmission = z.object({
    type: z.enum(['gameCenterLeaderboardEntrySubmissions']),
    id: z.string(),
    attributes: z.optional(z.object({
        bundleId: z.optional(z.string()),
        challengeIds: z.optional(z.array(z.string())),
        context: z.optional(z.string()),
        scopedPlayerId: z.optional(z.string()),
        score: z.optional(z.string()),
        submittedDate: z.optional(z.iso.datetime()),
        vendorIdentifier: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardEntrySubmissionResponse
 */
export const zGameCenterLeaderboardEntrySubmissionResponse = z.object({
    data: zGameCenterLeaderboardEntrySubmission,
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardRelease
 */
export const zGameCenterLeaderboardRelease = z.object({
    type: z.enum(['gameCenterLeaderboardReleases']),
    id: z.string(),
    attributes: z.optional(z.object({
        live: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        gameCenterDetail: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            }))
        })),
        gameCenterLeaderboard: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardSetRelease
 */
export const zGameCenterLeaderboardSetRelease = z.object({
    type: z.enum(['gameCenterLeaderboardSetReleases']),
    id: z.string(),
    attributes: z.optional(z.object({
        live: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        gameCenterDetail: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            }))
        })),
        gameCenterLeaderboardSet: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardSets']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterMatchmakingQueue
 */
export const zGameCenterMatchmakingQueue = z.object({
    type: z.enum(['gameCenterMatchmakingQueues']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        classicMatchmakingBundleIds: z.optional(z.array(z.string()))
    })),
    relationships: z.optional(z.object({
        ruleSet: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterMatchmakingRuleSets']),
                id: z.string()
            }))
        })),
        experimentRuleSet: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterMatchmakingRuleSets']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterMatchmakingRule
 */
export const zGameCenterMatchmakingRule = z.object({
    type: z.enum(['gameCenterMatchmakingRules']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        description: z.optional(z.string()),
        type: z.optional(z.enum([
            'COMPATIBLE',
            'DISTANCE',
            'MATCH',
            'TEAM'
        ])),
        expression: z.optional(z.string()),
        weight: z.optional(z.number())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterMatchmakingRulesResponse
 */
export const zGameCenterMatchmakingRulesResponse = z.object({
    data: z.array(zGameCenterMatchmakingRule),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterMatchmakingRuleResponse
 */
export const zGameCenterMatchmakingRuleResponse = z.object({
    data: zGameCenterMatchmakingRule,
    links: zDocumentLinks
});

/**
 * GameCenterMatchmakingTeam
 */
export const zGameCenterMatchmakingTeam = z.object({
    type: z.enum(['gameCenterMatchmakingTeams']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        minPlayers: z.optional(z.int()),
        maxPlayers: z.optional(z.int())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterMatchmakingTeamsResponse
 */
export const zGameCenterMatchmakingTeamsResponse = z.object({
    data: z.array(zGameCenterMatchmakingTeam),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterMatchmakingTeamResponse
 */
export const zGameCenterMatchmakingTeamResponse = z.object({
    data: zGameCenterMatchmakingTeam,
    links: zDocumentLinks
});

/**
 * GameCenterMatchmakingTestPlayerProperty
 */
export const zGameCenterMatchmakingTestPlayerProperty = z.object({
    type: z.enum(['gameCenterMatchmakingTestPlayerProperties']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterMatchmakingTestRequest
 */
export const zGameCenterMatchmakingTestRequest = z.object({
    type: z.enum(['gameCenterMatchmakingTestRequests']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterPlayerAchievementSubmission
 */
export const zGameCenterPlayerAchievementSubmission = z.object({
    type: z.enum(['gameCenterPlayerAchievementSubmissions']),
    id: z.string(),
    attributes: z.optional(z.object({
        bundleId: z.optional(z.string()),
        challengeIds: z.optional(z.array(z.string())),
        percentageAchieved: z.optional(z.int()),
        scopedPlayerId: z.optional(z.string()),
        submittedDate: z.optional(z.iso.datetime()),
        vendorIdentifier: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterPlayerAchievementSubmissionResponse
 */
export const zGameCenterPlayerAchievementSubmissionResponse = z.object({
    data: zGameCenterPlayerAchievementSubmission,
    links: zDocumentLinks
});

/**
 * InAppPurchaseContent
 */
export const zInAppPurchaseContent = z.object({
    type: z.enum(['inAppPurchaseContents']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileName: z.optional(z.string()),
        fileSize: z.optional(z.int()),
        url: z.optional(z.url()),
        lastModifiedDate: z.optional(z.iso.datetime())
    })),
    relationships: z.optional(z.object({
        inAppPurchaseV2: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['inAppPurchases']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchaseLocalization
 */
export const zInAppPurchaseLocalization = z.object({
    type: z.enum(['inAppPurchaseLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        locale: z.optional(z.string()),
        description: z.optional(z.string()),
        state: z.optional(z.enum([
            'PREPARE_FOR_SUBMISSION',
            'WAITING_FOR_REVIEW',
            'APPROVED',
            'REJECTED'
        ]))
    })),
    relationships: z.optional(z.object({
        inAppPurchaseV2: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['inAppPurchases']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchaseOfferCodeCustomCode
 */
export const zInAppPurchaseOfferCodeCustomCode = z.object({
    type: z.enum(['inAppPurchaseOfferCodeCustomCodes']),
    id: z.string(),
    attributes: z.optional(z.object({
        customCode: z.optional(z.string()),
        numberOfCodes: z.optional(z.int()),
        createdDate: z.optional(z.iso.datetime()),
        expirationDate: z.optional(z.iso.date()),
        active: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        createdByActor: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['actors']),
                id: z.string()
            }))
        })),
        deactivatedByActor: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['actors']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchaseOfferCodeCustomCodesResponse
 */
export const zInAppPurchaseOfferCodeCustomCodesResponse = z.object({
    data: z.array(zInAppPurchaseOfferCodeCustomCode),
    included: z.optional(z.array(zActor)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * InAppPurchaseOfferCodeCustomCodeResponse
 */
export const zInAppPurchaseOfferCodeCustomCodeResponse = z.object({
    data: zInAppPurchaseOfferCodeCustomCode,
    included: z.optional(z.array(zActor)),
    links: zDocumentLinks
});

/**
 * InAppPurchaseOfferCodeOneTimeUseCodeValue
 */
export const zInAppPurchaseOfferCodeOneTimeUseCodeValue = z.object({
    type: z.enum(['inAppPurchaseOfferCodeOneTimeUseCodeValues']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchaseOfferPrice
 */
export const zInAppPurchaseOfferPrice = z.object({
    type: z.enum(['inAppPurchaseOfferPrices']),
    id: z.string(),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        pricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['inAppPurchasePricePoints']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchasePrice
 */
export const zInAppPurchasePrice = z.object({
    type: z.enum(['inAppPurchasePrices']),
    id: z.string(),
    attributes: z.optional(z.object({
        startDate: z.optional(z.iso.date()),
        endDate: z.optional(z.iso.date()),
        manual: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        inAppPurchasePricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['inAppPurchasePricePoints']),
                id: z.string()
            }))
        })),
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchaseSubmission
 */
export const zInAppPurchaseSubmission = z.object({
    type: z.enum(['inAppPurchaseSubmissions']),
    id: z.string(),
    relationships: z.optional(z.object({
        inAppPurchaseV2: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['inAppPurchases']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchase
 *
 * @deprecated
 */
export const zInAppPurchase = z.object({
    type: z.enum(['inAppPurchases']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        productId: z.optional(z.string()),
        inAppPurchaseType: z.optional(z.enum([
            'AUTOMATICALLY_RENEWABLE_SUBSCRIPTION',
            'NON_CONSUMABLE',
            'CONSUMABLE',
            'NON_RENEWING_SUBSCRIPTION',
            'FREE_SUBSCRIPTION'
        ])),
        state: z.optional(z.enum([
            'CREATED',
            'DEVELOPER_SIGNED_OFF',
            'DEVELOPER_ACTION_NEEDED',
            'DELETION_IN_PROGRESS',
            'APPROVED',
            'DELETED',
            'REMOVED_FROM_SALE',
            'DEVELOPER_REMOVED_FROM_SALE',
            'WAITING_FOR_UPLOAD',
            'PROCESSING_CONTENT',
            'REPLACED',
            'REJECTED',
            'WAITING_FOR_SCREENSHOT',
            'PREPARE_FOR_SUBMISSION',
            'MISSING_METADATA',
            'READY_TO_SUBMIT',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'PENDING_DEVELOPER_RELEASE'
        ]))
    })),
    relationships: z.optional(z.object({
        apps: z.optional(z.object({
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['apps']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * MarketplaceSearchDetail
 */
export const zMarketplaceSearchDetail = z.object({
    type: z.enum(['marketplaceSearchDetails']),
    id: z.string(),
    attributes: z.optional(z.object({
        catalogUrl: z.optional(z.url())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * MarketplaceSearchDetailResponse
 */
export const zMarketplaceSearchDetailResponse = z.object({
    data: zMarketplaceSearchDetail,
    links: zDocumentLinks
});

/**
 * MarketplaceWebhook
 *
 * @deprecated
 */
export const zMarketplaceWebhook = z.object({
    type: z.enum(['marketplaceWebhooks']),
    id: z.string(),
    attributes: z.optional(z.object({
        endpointUrl: z.optional(z.url())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * MarketplaceWebhooksResponse
 *
 * @deprecated
 */
export const zMarketplaceWebhooksResponse = z.object({
    data: z.array(zMarketplaceWebhook),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * MarketplaceWebhookResponse
 *
 * @deprecated
 */
export const zMarketplaceWebhookResponse = z.object({
    data: zMarketplaceWebhook,
    links: zDocumentLinks
});

/**
 * PerfPowerMetric
 */
export const zPerfPowerMetric = z.object({
    type: z.enum(['perfPowerMetrics']),
    id: z.string(),
    attributes: z.optional(z.object({
        platform: z.optional(z.enum(['IOS'])),
        metricType: z.optional(z.enum([
            'DISK',
            'HANG',
            'BATTERY',
            'LAUNCH',
            'MEMORY',
            'ANIMATION',
            'TERMINATION'
        ])),
        deviceType: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * PromotedPurchase
 */
export const zPromotedPurchase = z.object({
    type: z.enum(['promotedPurchases']),
    id: z.string(),
    attributes: z.optional(z.object({
        visibleForAllUsers: z.optional(z.boolean()),
        enabled: z.optional(z.boolean()),
        state: z.optional(z.enum([
            'APPROVED',
            'IN_REVIEW',
            'PREPARE_FOR_SUBMISSION',
            'REJECTED'
        ]))
    })),
    relationships: z.optional(z.object({
        inAppPurchaseV2: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['inAppPurchases']),
                id: z.string()
            }))
        })),
        subscription: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * ReviewSubmissionItem
 */
export const zReviewSubmissionItem = z.object({
    type: z.enum(['reviewSubmissionItems']),
    id: z.string(),
    attributes: z.optional(z.object({
        state: z.optional(z.enum([
            'READY_FOR_REVIEW',
            'ACCEPTED',
            'APPROVED',
            'REJECTED',
            'REMOVED'
        ]))
    })),
    relationships: z.optional(z.object({
        appStoreVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            }))
        })),
        appCustomProductPageVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appCustomProductPageVersions']),
                id: z.string()
            }))
        })),
        appStoreVersionExperiment: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersionExperiments']),
                id: z.string()
            }))
        })),
        appStoreVersionExperimentV2: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersionExperiments']),
                id: z.string()
            }))
        })),
        appEvent: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appEvents']),
                id: z.string()
            }))
        })),
        backgroundAssetVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssetVersions']),
                id: z.string()
            }))
        })),
        gameCenterAchievementVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterAchievementVersions']),
                id: z.string()
            }))
        })),
        gameCenterActivityVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterActivityVersions']),
                id: z.string()
            }))
        })),
        gameCenterChallengeVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterChallengeVersions']),
                id: z.string()
            }))
        })),
        gameCenterLeaderboardSetVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardSetVersions']),
                id: z.string()
            }))
        })),
        gameCenterLeaderboardVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardVersions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SandboxTestersClearPurchaseHistoryRequestV2
 */
export const zSandboxTestersClearPurchaseHistoryRequestV2 = z.object({
    type: z.enum(['sandboxTestersClearPurchaseHistoryRequest']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * SandboxTestersClearPurchaseHistoryRequestV2Response
 */
export const zSandboxTestersClearPurchaseHistoryRequestV2Response = z.object({
    data: zSandboxTestersClearPurchaseHistoryRequestV2,
    links: zDocumentLinks
});

/**
 * ScmPullRequest
 */
export const zScmPullRequest = z.object({
    type: z.enum(['scmPullRequests']),
    id: z.string(),
    attributes: z.optional(z.object({
        title: z.optional(z.string()),
        number: z.optional(z.int()),
        webUrl: z.optional(z.url()),
        sourceRepositoryOwner: z.optional(z.string()),
        sourceRepositoryName: z.optional(z.string()),
        sourceBranchName: z.optional(z.string()),
        destinationRepositoryOwner: z.optional(z.string()),
        destinationRepositoryName: z.optional(z.string()),
        destinationBranchName: z.optional(z.string()),
        isClosed: z.optional(z.boolean()),
        isCrossRepository: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        repository: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['scmRepositories']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionGroupLocalization
 */
export const zSubscriptionGroupLocalization = z.object({
    type: z.enum(['subscriptionGroupLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        customAppName: z.optional(z.string()),
        locale: z.optional(z.string()),
        state: z.optional(z.enum([
            'PREPARE_FOR_SUBMISSION',
            'WAITING_FOR_REVIEW',
            'APPROVED',
            'REJECTED'
        ]))
    })),
    relationships: z.optional(z.object({
        subscriptionGroup: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionGroups']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionGroupSubmission
 */
export const zSubscriptionGroupSubmission = z.object({
    type: z.enum(['subscriptionGroupSubmissions']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionGroupSubmissionResponse
 */
export const zSubscriptionGroupSubmissionResponse = z.object({
    data: zSubscriptionGroupSubmission,
    links: zDocumentLinks
});

/**
 * SubscriptionLocalization
 */
export const zSubscriptionLocalization = z.object({
    type: z.enum(['subscriptionLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        locale: z.optional(z.string()),
        description: z.optional(z.string()),
        state: z.optional(z.enum([
            'PREPARE_FOR_SUBMISSION',
            'WAITING_FOR_REVIEW',
            'APPROVED',
            'REJECTED'
        ]))
    })),
    relationships: z.optional(z.object({
        subscription: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionOfferCodeCustomCode
 */
export const zSubscriptionOfferCodeCustomCode = z.object({
    type: z.enum(['subscriptionOfferCodeCustomCodes']),
    id: z.string(),
    attributes: z.optional(z.object({
        customCode: z.optional(z.string()),
        numberOfCodes: z.optional(z.int()),
        createdDate: z.optional(z.iso.datetime()),
        expirationDate: z.optional(z.iso.date()),
        active: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        offerCode: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionOfferCodes']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionOfferCodeOneTimeUseCodeValue
 */
export const zSubscriptionOfferCodeOneTimeUseCodeValue = z.object({
    type: z.enum(['subscriptionOfferCodeOneTimeUseCodeValues']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionOfferCodePrice
 */
export const zSubscriptionOfferCodePrice = z.object({
    type: z.enum(['subscriptionOfferCodePrices']),
    id: z.string(),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        subscriptionPricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionPricePoints']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionPrice
 */
export const zSubscriptionPrice = z.object({
    type: z.enum(['subscriptionPrices']),
    id: z.string(),
    attributes: z.optional(z.object({
        startDate: z.optional(z.iso.date()),
        preserved: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        subscriptionPricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionPricePoints']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionPromotionalOfferPrice
 */
export const zSubscriptionPromotionalOfferPrice = z.object({
    type: z.enum(['subscriptionPromotionalOfferPrices']),
    id: z.string(),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        subscriptionPricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionPricePoints']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionSubmission
 */
export const zSubscriptionSubmission = z.object({
    type: z.enum(['subscriptionSubmissions']),
    id: z.string(),
    relationships: z.optional(z.object({
        subscription: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * Territory
 */
export const zTerritory = z.object({
    type: z.enum(['territories']),
    id: z.string(),
    attributes: z.optional(z.object({
        currency: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * TerritoriesResponse
 */
export const zTerritoriesResponse = z.object({
    data: z.array(zTerritory),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * TerritoryResponse
 */
export const zTerritoryResponse = z.object({
    data: zTerritory,
    links: zDocumentLinks
});

/**
 * TerritoryAvailability
 */
export const zTerritoryAvailability = z.object({
    type: z.enum(['territoryAvailabilities']),
    id: z.string(),
    attributes: z.optional(z.object({
        available: z.optional(z.boolean()),
        releaseDate: z.optional(z.iso.date()),
        preOrderEnabled: z.optional(z.boolean()),
        preOrderPublishDate: z.optional(z.iso.date()),
        contentStatuses: z.optional(z.array(z.enum([
            'AVAILABLE',
            'AVAILABLE_FOR_PREORDER_ON_DATE',
            'PROCESSING_TO_NOT_AVAILABLE',
            'PROCESSING_TO_AVAILABLE',
            'PROCESSING_TO_PRE_ORDER',
            'AVAILABLE_FOR_SALE_UNRELEASED_APP',
            'PREORDER_ON_UNRELEASED_APP',
            'AVAILABLE_FOR_PREORDER',
            'MISSING_RATING',
            'CANNOT_SELL_RESTRICTED_RATING',
            'BRAZIL_REQUIRED_TAX_ID',
            'MISSING_GRN',
            'UNVERIFIED_GRN',
            'ICP_NUMBER_INVALID',
            'ICP_NUMBER_MISSING',
            'TRADER_STATUS_NOT_PROVIDED',
            'TRADER_STATUS_VERIFICATION_FAILED',
            'TRADER_STATUS_VERIFICATION_STATUS_MISSING',
            'CANNOT_SELL_SEVENTEEN_PLUS_APPS',
            'CANNOT_SELL_SEXUALLY_EXPLICIT',
            'CANNOT_SELL_NON_IOS_GAMES',
            'CANNOT_SELL_SEVENTEEN_PLUS_GAMES',
            'CANNOT_SELL_CASINO',
            'CANNOT_SELL_CASINO_WITHOUT_GRAC',
            'CANNOT_SELL_CASINO_WITHOUT_AGE_VERIFICATION',
            'CANNOT_SELL_ADULT_ONLY',
            'CANNOT_SELL_GAMBLING_CONTESTS',
            'CANNOT_SELL_GAMBLING',
            'CANNOT_SELL_CONTESTS',
            'CANNOT_SELL_NINETEEN_PLUS_WITHOUT_GRAC',
            'CANNOT_SELL',
            'CANNOT_SELL_FREQUENT_INTENSE_GAMBLING',
            'CANNOT_SELL_FREQUENT_INTENSE_ALCOHOL_TOBACCO_DRUGS',
            'CANNOT_SELL_FREQUENT_INTENSE_VIOLENCE',
            'CANNOT_SELL_FREQUENT_INTENSE_SEXUAL_CONTENT_NUDITY',
            'CANNOT_SELL_INFREQUENT_MILD_ALCOHOL_TOBACCO_DRUGS',
            'CANNOT_SELL_INFREQUENT_MILD_SEXUAL_CONTENT_NUDITY',
            'CANNOT_SELL_FREQUENT_INTENSE',
            'CANNOT_SELL_FREQUENT_INTENSE_WITHOUT_GRAC',
            'CANNOT_SELL_FREQUENT_GAMBLING',
            'CANNOT_SELL_FREQUENT_ALCOHOL_TOBACCO_DRUGS',
            'CANNOT_SELL_FREQUENT_VIOLENCE',
            'CANNOT_SELL_FREQUENT_SEXUAL_CONTENT_NUDITY',
            'CANNOT_SELL_INFREQUENT_ALCOHOL_TOBACCO_DRUGS',
            'CANNOT_SELL_INFREQUENT_SEXUAL_CONTENT_NUDITY',
            'CANNOT_SELL_FREQUENT',
            'CANNOT_SELL_FREQUENT_WITHOUT_GRAC'
        ])))
    })),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * TerritoryAvailabilitiesResponse
 */
export const zTerritoryAvailabilitiesResponse = z.object({
    data: z.array(zTerritoryAvailability),
    included: z.optional(z.array(zTerritory)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * TerritoryAvailabilityResponse
 */
export const zTerritoryAvailabilityResponse = z.object({
    data: zTerritoryAvailability,
    included: z.optional(z.array(zTerritory)),
    links: zDocumentLinks
});

/**
 * WebhookDelivery
 */
export const zWebhookDelivery = z.object({
    type: z.enum(['webhookDeliveries']),
    id: z.string(),
    attributes: z.optional(z.object({
        createdDate: z.optional(z.iso.datetime()),
        deliveryState: z.optional(z.enum([
            'SUCCEEDED',
            'FAILED',
            'PENDING'
        ])),
        errorMessage: z.optional(z.string()),
        redelivery: z.optional(z.boolean()),
        sentDate: z.optional(z.iso.datetime()),
        request: z.optional(z.object({
            url: z.optional(z.url())
        })),
        response: z.optional(z.object({
            httpStatusCode: z.optional(z.int()),
            body: z.optional(z.string())
        }))
    })),
    relationships: z.optional(z.object({
        event: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['webhookEvents']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * WebhookPing
 */
export const zWebhookPing = z.object({
    type: z.enum(['webhookPings']),
    id: z.string(),
    links: z.optional(zResourceLinks)
});

/**
 * WebhookPingResponse
 */
export const zWebhookPingResponse = z.object({
    data: zWebhookPing,
    links: zDocumentLinks
});

/**
 * WinBackOfferPrice
 */
export const zWinBackOfferPrice = z.object({
    type: z.enum(['winBackOfferPrices']),
    id: z.string(),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        subscriptionPricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionPricePoints']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * TerritoriesWithoutIncludesResponse
 */
export const zTerritoriesWithoutIncludesResponse = z.object({
    data: z.array(zTerritory),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zRelationshipLinks = z.object({
    self: z.optional(z.string()),
    related: z.optional(z.string())
});

/**
 * AlternativeDistributionPackageVersion
 */
export const zAlternativeDistributionPackageVersion = z.object({
    type: z.enum(['alternativeDistributionPackageVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        url: z.optional(z.url()),
        urlExpirationDate: z.optional(z.iso.datetime()),
        version: z.optional(z.string()),
        fileChecksum: z.optional(z.string()),
        state: z.optional(z.enum(['COMPLETED', 'REPLACED']))
    })),
    relationships: z.optional(z.object({
        variants: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['alternativeDistributionPackageVariants']),
                id: z.string()
            })))
        })),
        deltas: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['alternativeDistributionPackageDeltas']),
                id: z.string()
            })))
        })),
        alternativeDistributionPackage: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['alternativeDistributionPackages']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AnalyticsReportInstance
 */
export const zAnalyticsReportInstance = z.object({
    type: z.enum(['analyticsReportInstances']),
    id: z.string(),
    attributes: z.optional(z.object({
        granularity: z.optional(z.enum([
            'DAILY',
            'WEEKLY',
            'MONTHLY'
        ])),
        processingDate: z.optional(z.iso.date())
    })),
    relationships: z.optional(z.object({
        segments: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AnalyticsReportInstancesResponse
 */
export const zAnalyticsReportInstancesResponse = z.object({
    data: z.array(zAnalyticsReportInstance),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AnalyticsReportInstanceResponse
 */
export const zAnalyticsReportInstanceResponse = z.object({
    data: zAnalyticsReportInstance,
    links: zDocumentLinks
});

/**
 * AnalyticsReportRequest
 */
export const zAnalyticsReportRequest = z.object({
    type: z.enum(['analyticsReportRequests']),
    id: z.string(),
    attributes: z.optional(z.object({
        accessType: z.optional(z.enum(['ONE_TIME_SNAPSHOT', 'ONGOING'])),
        stoppedDueToInactivity: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        reports: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['analyticsReports']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AnalyticsReport
 */
export const zAnalyticsReport = z.object({
    type: z.enum(['analyticsReports']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        category: z.optional(z.enum([
            'APP_USAGE',
            'APP_STORE_ENGAGEMENT',
            'COMMERCE',
            'FRAMEWORK_USAGE',
            'PERFORMANCE'
        ]))
    })),
    relationships: z.optional(z.object({
        instances: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AnalyticsReportRequestsResponse
 */
export const zAnalyticsReportRequestsResponse = z.object({
    data: z.array(zAnalyticsReportRequest),
    included: z.optional(z.array(zAnalyticsReport)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AnalyticsReportRequestResponse
 */
export const zAnalyticsReportRequestResponse = z.object({
    data: zAnalyticsReportRequest,
    included: z.optional(z.array(zAnalyticsReport)),
    links: zDocumentLinks
});

/**
 * AnalyticsReportsResponse
 */
export const zAnalyticsReportsResponse = z.object({
    data: z.array(zAnalyticsReport),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AnalyticsReportResponse
 */
export const zAnalyticsReportResponse = z.object({
    data: zAnalyticsReport,
    links: zDocumentLinks
});

/**
 * AppAvailabilityV2
 */
export const zAppAvailabilityV2 = z.object({
    type: z.enum(['appAvailabilities']),
    id: z.string(),
    attributes: z.optional(z.object({
        availableInNewTerritories: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        territoryAvailabilities: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['territoryAvailabilities']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppAvailabilityV2Response
 */
export const zAppAvailabilityV2Response = z.object({
    data: zAppAvailabilityV2,
    included: z.optional(z.array(zTerritoryAvailability)),
    links: zDocumentLinks
});

/**
 * AppClipDefaultExperienceLocalization
 */
export const zAppClipDefaultExperienceLocalization = z.object({
    type: z.enum(['appClipDefaultExperienceLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string()),
        subtitle: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        appClipDefaultExperience: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appClipDefaultExperiences']),
                id: z.string()
            }))
        })),
        appClipHeaderImage: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appClipHeaderImages']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppClip
 */
export const zAppClip = z.object({
    type: z.enum(['appClips']),
    id: z.string(),
    attributes: z.optional(z.object({
        bundleId: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        appClipDefaultExperiences: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appClipDefaultExperiences']),
                id: z.string()
            })))
        })),
        appClipAdvancedExperiences: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppCustomProductPageLocalization
 */
export const zAppCustomProductPageLocalization = z.object({
    type: z.enum(['appCustomProductPageLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string()),
        promotionalText: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        appCustomProductPageVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appCustomProductPageVersions']),
                id: z.string()
            }))
        })),
        appScreenshotSets: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appScreenshotSets']),
                id: z.string()
            })))
        })),
        appPreviewSets: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appPreviewSets']),
                id: z.string()
            })))
        })),
        searchKeywords: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appKeywords']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppCustomProductPageVersion
 */
export const zAppCustomProductPageVersion = z.object({
    type: z.enum(['appCustomProductPageVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        version: z.optional(z.string()),
        state: z.optional(z.enum([
            'PREPARE_FOR_SUBMISSION',
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'ACCEPTED',
            'APPROVED',
            'REPLACED_WITH_NEW_VERSION',
            'REJECTED'
        ])),
        deepLink: z.optional(z.url())
    })),
    relationships: z.optional(z.object({
        appCustomProductPage: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appCustomProductPages']),
                id: z.string()
            }))
        })),
        appCustomProductPageLocalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appCustomProductPageLocalizations']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppCustomProductPage
 */
export const zAppCustomProductPage = z.object({
    type: z.enum(['appCustomProductPages']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        url: z.optional(z.url()),
        visible: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        appCustomProductPageVersions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appCustomProductPageVersions']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppCustomProductPageVersionsResponse
 */
export const zAppCustomProductPageVersionsResponse = z.object({
    data: z.array(zAppCustomProductPageVersion),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appCustomProductPageLocalizations')
        }).and(zAppCustomProductPageLocalization), z.object({
            type: z.literal('appCustomProductPages')
        }).and(zAppCustomProductPage)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppCustomProductPageVersionResponse
 */
export const zAppCustomProductPageVersionResponse = z.object({
    data: zAppCustomProductPageVersion,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appCustomProductPageLocalizations')
        }).and(zAppCustomProductPageLocalization), z.object({
            type: z.literal('appCustomProductPages')
        }).and(zAppCustomProductPage)]))),
    links: zDocumentLinks
});

/**
 * AppEventLocalization
 */
export const zAppEventLocalization = z.object({
    type: z.enum(['appEventLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string()),
        name: z.optional(z.string()),
        shortDescription: z.optional(z.string()),
        longDescription: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        appEvent: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appEvents']),
                id: z.string()
            }))
        })),
        appEventScreenshots: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appEventScreenshots']),
                id: z.string()
            })))
        })),
        appEventVideoClips: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appEventVideoClips']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppEvent
 */
export const zAppEvent = z.object({
    type: z.enum(['appEvents']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        badge: z.optional(z.enum([
            'LIVE_EVENT',
            'PREMIERE',
            'CHALLENGE',
            'COMPETITION',
            'NEW_SEASON',
            'MAJOR_UPDATE',
            'SPECIAL_EVENT'
        ])),
        eventState: z.optional(z.enum([
            'DRAFT',
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'REJECTED',
            'ACCEPTED',
            'APPROVED',
            'PUBLISHED',
            'PAST',
            'ARCHIVED'
        ])),
        deepLink: z.optional(z.url()),
        purchaseRequirement: z.optional(z.string()),
        primaryLocale: z.optional(z.string()),
        priority: z.optional(z.enum(['HIGH', 'NORMAL'])),
        purpose: z.optional(z.enum([
            'APPROPRIATE_FOR_ALL_USERS',
            'ATTRACT_NEW_USERS',
            'KEEP_ACTIVE_USERS_INFORMED',
            'BRING_BACK_LAPSED_USERS'
        ])),
        territorySchedules: z.optional(z.array(z.object({
            territories: z.optional(z.array(z.string())),
            publishStart: z.optional(z.iso.datetime()),
            eventStart: z.optional(z.iso.datetime()),
            eventEnd: z.optional(z.iso.datetime())
        }))),
        archivedTerritorySchedules: z.optional(z.array(z.object({
            territories: z.optional(z.array(z.string())),
            publishStart: z.optional(z.iso.datetime()),
            eventStart: z.optional(z.iso.datetime()),
            eventEnd: z.optional(z.iso.datetime())
        })))
    })),
    relationships: z.optional(z.object({
        localizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appEventLocalizations']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppEventsResponse
 */
export const zAppEventsResponse = z.object({
    data: z.array(zAppEvent),
    included: z.optional(z.array(zAppEventLocalization)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppEventResponse
 */
export const zAppEventResponse = z.object({
    data: zAppEvent,
    included: z.optional(z.array(zAppEventLocalization)),
    links: zDocumentLinks
});

/**
 * AppPricePointV3
 */
export const zAppPricePointV3 = z.object({
    type: z.enum(['appPricePoints']),
    id: z.string(),
    attributes: z.optional(z.object({
        customerPrice: z.optional(z.string()),
        proceeds: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        equalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppPriceSchedule
 */
export const zAppPriceSchedule = z.object({
    type: z.enum(['appPriceSchedules']),
    id: z.string(),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        baseTerritory: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        manualPrices: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appPrices']),
                id: z.string()
            })))
        })),
        automaticPrices: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appPrices']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppPricesV2Response
 */
export const zAppPricesV2Response = z.object({
    data: z.array(zAppPriceV2),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appPricePoints')
        }).and(zAppPricePointV3), z.object({
            type: z.literal('territories')
        }).and(zTerritory)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppStoreReviewDetail
 */
export const zAppStoreReviewDetail = z.object({
    type: z.enum(['appStoreReviewDetails']),
    id: z.string(),
    attributes: z.optional(z.object({
        contactFirstName: z.optional(z.string()),
        contactLastName: z.optional(z.string()),
        contactPhone: z.optional(z.string()),
        contactEmail: z.optional(z.string()),
        demoAccountName: z.optional(z.string()),
        demoAccountPassword: z.optional(z.string()),
        demoAccountRequired: z.optional(z.boolean()),
        notes: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        appStoreVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            }))
        })),
        appStoreReviewAttachments: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appStoreReviewAttachments']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppStoreVersionExperimentTreatmentLocalization
 */
export const zAppStoreVersionExperimentTreatmentLocalization = z.object({
    type: z.enum(['appStoreVersionExperimentTreatmentLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        appStoreVersionExperimentTreatment: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersionExperimentTreatments']),
                id: z.string()
            }))
        })),
        appScreenshotSets: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appScreenshotSets']),
                id: z.string()
            })))
        })),
        appPreviewSets: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appPreviewSets']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppStoreVersionExperiment
 *
 * @deprecated
 */
export const zAppStoreVersionExperiment = z.object({
    type: z.enum(['appStoreVersionExperiments']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        trafficProportion: z.optional(z.int()),
        state: z.optional(z.enum([
            'PREPARE_FOR_SUBMISSION',
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'ACCEPTED',
            'APPROVED',
            'REJECTED',
            'COMPLETED',
            'STOPPED'
        ])),
        reviewRequired: z.optional(z.boolean()),
        startDate: z.optional(z.iso.datetime()),
        endDate: z.optional(z.iso.datetime())
    })),
    relationships: z.optional(z.object({
        appStoreVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            }))
        })),
        appStoreVersionExperimentTreatments: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appStoreVersionExperimentTreatments']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppStoreVersionLocalization
 */
export const zAppStoreVersionLocalization = z.object({
    type: z.enum(['appStoreVersionLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        description: z.optional(z.string()),
        locale: z.optional(z.string()),
        keywords: z.optional(z.string()),
        marketingUrl: z.optional(z.url()),
        promotionalText: z.optional(z.string()),
        supportUrl: z.optional(z.url()),
        whatsNew: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        appStoreVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            }))
        })),
        appScreenshotSets: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appScreenshotSets']),
                id: z.string()
            })))
        })),
        appPreviewSets: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appPreviewSets']),
                id: z.string()
            })))
        })),
        searchKeywords: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appKeywords']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppTag
 */
export const zAppTag = z.object({
    type: z.enum(['appTags']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        visibleInAppStore: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        territories: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['territories']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppTagsResponse
 */
export const zAppTagsResponse = z.object({
    data: z.array(zAppTag),
    included: z.optional(z.array(zTerritory)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppTagResponse
 */
export const zAppTagResponse = z.object({
    data: zAppTag,
    included: z.optional(z.array(zTerritory)),
    links: zDocumentLinks
});

/**
 * BackgroundAsset
 */
export const zBackgroundAsset = z.object({
    type: z.enum(['backgroundAssets']),
    id: z.string(),
    attributes: z.optional(z.object({
        archived: z.optional(z.boolean()),
        assetPackIdentifier: z.optional(z.string()),
        createdDate: z.optional(z.iso.datetime())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        versions: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        appStoreVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssetVersions']),
                id: z.string()
            }))
        })),
        internalBetaVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssetVersions']),
                id: z.string()
            }))
        })),
        externalBetaVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssetVersions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaAppLocalization
 */
export const zBetaAppLocalization = z.object({
    type: z.enum(['betaAppLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        feedbackEmail: z.optional(z.string()),
        marketingUrl: z.optional(z.string()),
        privacyPolicyUrl: z.optional(z.string()),
        tvOsPrivacyPolicy: z.optional(z.string()),
        description: z.optional(z.string()),
        locale: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaAppReviewDetail
 */
export const zBetaAppReviewDetail = z.object({
    type: z.enum(['betaAppReviewDetails']),
    id: z.string(),
    attributes: z.optional(z.object({
        contactFirstName: z.optional(z.string()),
        contactLastName: z.optional(z.string()),
        contactPhone: z.optional(z.string()),
        contactEmail: z.optional(z.string()),
        demoAccountName: z.optional(z.string()),
        demoAccountPassword: z.optional(z.string()),
        demoAccountRequired: z.optional(z.boolean()),
        notes: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaBuildLocalization
 */
export const zBetaBuildLocalization = z.object({
    type: z.enum(['betaBuildLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        whatsNew: z.optional(z.string()),
        locale: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        build: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['builds']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaGroup
 */
export const zBetaGroup = z.object({
    type: z.enum(['betaGroups']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        createdDate: z.optional(z.iso.datetime()),
        isInternalGroup: z.optional(z.boolean()),
        hasAccessToAllBuilds: z.optional(z.boolean()),
        publicLinkEnabled: z.optional(z.boolean()),
        publicLinkId: z.optional(z.string()),
        publicLinkLimitEnabled: z.optional(z.boolean()),
        publicLinkLimit: z.optional(z.int()),
        publicLink: z.optional(z.string()),
        feedbackEnabled: z.optional(z.boolean()),
        iosBuildsAvailableForAppleSiliconMac: z.optional(z.boolean()),
        iosBuildsAvailableForAppleVision: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        builds: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['builds']),
                id: z.string()
            })))
        })),
        betaTesters: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['betaTesters']),
                id: z.string()
            })))
        })),
        betaRecruitmentCriteria: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['betaRecruitmentCriteria']),
                id: z.string()
            }))
        })),
        betaRecruitmentCriterionCompatibleBuildCheck: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaLicenseAgreement
 */
export const zBetaLicenseAgreement = z.object({
    type: z.enum(['betaLicenseAgreements']),
    id: z.string(),
    attributes: z.optional(z.object({
        agreementText: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * CiMacOsVersion
 */
export const zCiMacOsVersion = z.object({
    type: z.enum(['ciMacOsVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        version: z.optional(z.string()),
        name: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        xcodeVersions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['ciXcodeVersions']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * CiProduct
 */
export const zCiProduct = z.object({
    type: z.enum(['ciProducts']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        createdDate: z.optional(z.iso.datetime()),
        productType: z.optional(z.enum(['APP', 'FRAMEWORK']))
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        bundleId: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['bundleIds']),
                id: z.string()
            }))
        })),
        workflows: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        primaryRepositories: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['scmRepositories']),
                id: z.string()
            })))
        })),
        additionalRepositories: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        buildRuns: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * EndUserLicenseAgreement
 */
export const zEndUserLicenseAgreement = z.object({
    type: z.enum(['endUserLicenseAgreements']),
    id: z.string(),
    attributes: z.optional(z.object({
        agreementText: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        territories: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['territories']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterAchievementLocalizationV2
 */
export const zGameCenterAchievementLocalizationV2 = z.object({
    type: z.enum(['gameCenterAchievementLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string()),
        name: z.optional(z.string()),
        beforeEarnedDescription: z.optional(z.string()),
        afterEarnedDescription: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        version: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterAchievementVersions']),
                id: z.string()
            }))
        })),
        image: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterAchievementImages']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterAchievementLocalization
 */
export const zGameCenterAchievementLocalization = z.object({
    type: z.enum(['gameCenterAchievementLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string()),
        name: z.optional(z.string()),
        beforeEarnedDescription: z.optional(z.string()),
        afterEarnedDescription: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        gameCenterAchievement: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterAchievements']),
                id: z.string()
            }))
        })),
        gameCenterAchievementImage: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterAchievementImages']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterActivityLocalization
 */
export const zGameCenterActivityLocalization = z.object({
    type: z.enum(['gameCenterActivityLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string()),
        name: z.optional(z.string()),
        description: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        version: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterActivityVersions']),
                id: z.string()
            }))
        })),
        image: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterActivityImages']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterAppVersion
 */
export const zGameCenterAppVersion = z.object({
    type: z.enum(['gameCenterAppVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        enabled: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        compatibilityVersions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAppVersions']),
                id: z.string()
            })))
        })),
        appStoreVersion: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterChallengeLocalization
 */
export const zGameCenterChallengeLocalization = z.object({
    type: z.enum(['gameCenterChallengeLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string()),
        name: z.optional(z.string()),
        description: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        version: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterChallengeVersions']),
                id: z.string()
            }))
        })),
        image: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterChallengeImages']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterChallenge
 */
export const zGameCenterChallenge = z.object({
    type: z.enum(['gameCenterChallenges']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        vendorIdentifier: z.optional(z.string()),
        archived: z.optional(z.boolean()),
        challengeType: z.optional(z.enum(['LEADERBOARD'])),
        repeatable: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        gameCenterDetail: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            }))
        })),
        gameCenterGroup: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterGroups']),
                id: z.string()
            }))
        })),
        versions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterChallengeVersions']),
                id: z.string()
            })))
        })),
        leaderboard: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            }))
        })),
        leaderboardV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterDetail
 */
export const zGameCenterDetail = z.object({
    type: z.enum(['gameCenterDetails']),
    id: z.string(),
    attributes: z.optional(z.object({
        arcadeEnabled: z.optional(z.boolean()),
        challengeEnabled: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        gameCenterAppVersions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAppVersions']),
                id: z.string()
            })))
        })),
        gameCenterGroup: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterGroups']),
                id: z.string()
            }))
        })),
        gameCenterLeaderboards: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            })))
        })),
        gameCenterLeaderboardsV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            })))
        })),
        gameCenterLeaderboardSets: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardSets']),
                id: z.string()
            })))
        })),
        gameCenterLeaderboardSetsV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardSets']),
                id: z.string()
            })))
        })),
        gameCenterAchievements: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAchievements']),
                id: z.string()
            })))
        })),
        gameCenterAchievementsV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAchievements']),
                id: z.string()
            })))
        })),
        gameCenterActivities: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterActivities']),
                id: z.string()
            })))
        })),
        gameCenterChallenges: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterChallenges']),
                id: z.string()
            })))
        })),
        defaultLeaderboard: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            }))
        })),
        defaultLeaderboardV2: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            }))
        })),
        defaultGroupLeaderboard: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            }))
        })),
        defaultGroupLeaderboardV2: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            }))
        })),
        achievementReleases: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAchievementReleases']),
                id: z.string()
            })))
        })),
        activityReleases: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterActivityVersionReleases']),
                id: z.string()
            })))
        })),
        challengeReleases: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterChallengeVersionReleases']),
                id: z.string()
            })))
        })),
        leaderboardReleases: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardReleases']),
                id: z.string()
            })))
        })),
        leaderboardSetReleases: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardSetReleases']),
                id: z.string()
            })))
        })),
        challengesMinimumPlatformVersions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterGroup
 */
export const zGameCenterGroup = z.object({
    type: z.enum(['gameCenterGroups']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        gameCenterDetails: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            })))
        })),
        gameCenterLeaderboards: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            })))
        })),
        gameCenterLeaderboardsV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            })))
        })),
        gameCenterLeaderboardSets: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardSets']),
                id: z.string()
            })))
        })),
        gameCenterLeaderboardSetsV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardSets']),
                id: z.string()
            })))
        })),
        gameCenterAchievements: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAchievements']),
                id: z.string()
            })))
        })),
        gameCenterAchievementsV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAchievements']),
                id: z.string()
            })))
        })),
        gameCenterActivities: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterActivities']),
                id: z.string()
            })))
        })),
        gameCenterChallenges: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterChallenges']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardSetLocalization
 */
export const zGameCenterLeaderboardSetLocalization = z.object({
    type: z.enum(['gameCenterLeaderboardSetLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string()),
        name: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        gameCenterLeaderboardSet: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardSets']),
                id: z.string()
            }))
        })),
        gameCenterLeaderboardSetImage: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardSetImages']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardSetLocalizationV2
 */
export const zGameCenterLeaderboardSetLocalizationV2 = z.object({
    type: z.enum(['gameCenterLeaderboardSetLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string()),
        name: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        version: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardSetVersions']),
                id: z.string()
            }))
        })),
        image: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardSetImages']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardSetMemberLocalization
 */
export const zGameCenterLeaderboardSetMemberLocalization = z.object({
    type: z.enum(['gameCenterLeaderboardSetMemberLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        locale: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        gameCenterLeaderboardSet: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardSets']),
                id: z.string()
            }))
        })),
        gameCenterLeaderboard: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardSetV2
 */
export const zGameCenterLeaderboardSetV2 = z.object({
    type: z.enum(['gameCenterLeaderboardSets']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        vendorIdentifier: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        gameCenterDetail: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            }))
        })),
        gameCenterGroup: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterGroups']),
                id: z.string()
            }))
        })),
        gameCenterLeaderboards: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            })))
        })),
        versions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardSetVersions']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardSet
 */
export const zGameCenterLeaderboardSet = z.object({
    type: z.enum(['gameCenterLeaderboardSets']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        vendorIdentifier: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        gameCenterDetail: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            }))
        })),
        gameCenterGroup: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterGroups']),
                id: z.string()
            }))
        })),
        groupLeaderboardSet: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardSets']),
                id: z.string()
            }))
        })),
        localizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardSetLocalizations']),
                id: z.string()
            })))
        })),
        gameCenterLeaderboards: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            })))
        })),
        releases: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardSetReleases']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardSetReleasesResponse
 */
export const zGameCenterLeaderboardSetReleasesResponse = z.object({
    data: z.array(zGameCenterLeaderboardSetRelease),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail), z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardSetReleaseResponse
 */
export const zGameCenterLeaderboardSetReleaseResponse = z.object({
    data: zGameCenterLeaderboardSetRelease,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail), z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet)]))),
    links: zDocumentLinks
});

/**
 * GameCenterMatchmakingRuleSet
 */
export const zGameCenterMatchmakingRuleSet = z.object({
    type: z.enum(['gameCenterMatchmakingRuleSets']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        ruleLanguageVersion: z.optional(z.int()),
        minPlayers: z.optional(z.int()),
        maxPlayers: z.optional(z.int())
    })),
    relationships: z.optional(z.object({
        teams: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterMatchmakingTeams']),
                id: z.string()
            })))
        })),
        rules: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterMatchmakingRules']),
                id: z.string()
            })))
        })),
        matchmakingQueues: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterMatchmakingQueues']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterMatchmakingQueuesResponse
 */
export const zGameCenterMatchmakingQueuesResponse = z.object({
    data: z.array(zGameCenterMatchmakingQueue),
    included: z.optional(z.array(zGameCenterMatchmakingRuleSet)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterMatchmakingQueueResponse
 */
export const zGameCenterMatchmakingQueueResponse = z.object({
    data: zGameCenterMatchmakingQueue,
    included: z.optional(z.array(zGameCenterMatchmakingRuleSet)),
    links: zDocumentLinks
});

/**
 * GameCenterMatchmakingRuleSetsResponse
 */
export const zGameCenterMatchmakingRuleSetsResponse = z.object({
    data: z.array(zGameCenterMatchmakingRuleSet),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterMatchmakingQueues')
        }).and(zGameCenterMatchmakingQueue),
        z.object({
            type: z.literal('gameCenterMatchmakingRules')
        }).and(zGameCenterMatchmakingRule),
        z.object({
            type: z.literal('gameCenterMatchmakingTeams')
        }).and(zGameCenterMatchmakingTeam)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterMatchmakingRuleSetResponse
 */
export const zGameCenterMatchmakingRuleSetResponse = z.object({
    data: zGameCenterMatchmakingRuleSet,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterMatchmakingQueues')
        }).and(zGameCenterMatchmakingQueue),
        z.object({
            type: z.literal('gameCenterMatchmakingRules')
        }).and(zGameCenterMatchmakingRule),
        z.object({
            type: z.literal('gameCenterMatchmakingTeams')
        }).and(zGameCenterMatchmakingTeam)
    ]))),
    links: zDocumentLinks
});

/**
 * InAppPurchaseAvailability
 */
export const zInAppPurchaseAvailability = z.object({
    type: z.enum(['inAppPurchaseAvailabilities']),
    id: z.string(),
    attributes: z.optional(z.object({
        availableInNewTerritories: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        availableTerritories: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['territories']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchaseAvailabilityResponse
 */
export const zInAppPurchaseAvailabilityResponse = z.object({
    data: zInAppPurchaseAvailability,
    included: z.optional(z.array(zTerritory)),
    links: zDocumentLinks
});

/**
 * InAppPurchaseOfferCode
 */
export const zInAppPurchaseOfferCode = z.object({
    type: z.enum(['inAppPurchaseOfferCodes']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        customerEligibilities: z.optional(z.array(z.enum([
            'NON_SPENDER',
            'ACTIVE_SPENDER',
            'CHURNED_SPENDER'
        ]))),
        productionCodeCount: z.optional(z.int()),
        sandboxCodeCount: z.optional(z.int()),
        active: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        oneTimeUseCodes: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['inAppPurchaseOfferCodeOneTimeUseCodes']),
                id: z.string()
            })))
        })),
        customCodes: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['inAppPurchaseOfferCodeCustomCodes']),
                id: z.string()
            })))
        })),
        prices: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['inAppPurchaseOfferPrices']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchasePricePoint
 */
export const zInAppPurchasePricePoint = z.object({
    type: z.enum(['inAppPurchasePricePoints']),
    id: z.string(),
    attributes: z.optional(z.object({
        customerPrice: z.optional(z.string()),
        proceeds: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        equalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchaseOfferPricesResponse
 */
export const zInAppPurchaseOfferPricesResponse = z.object({
    data: z.array(zInAppPurchaseOfferPrice),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('inAppPurchasePricePoints')
        }).and(zInAppPurchasePricePoint), z.object({
            type: z.literal('territories')
        }).and(zTerritory)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * InAppPurchasePricePointsResponse
 */
export const zInAppPurchasePricePointsResponse = z.object({
    data: z.array(zInAppPurchasePricePoint),
    included: z.optional(z.array(zTerritory)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * InAppPurchasePriceSchedule
 */
export const zInAppPurchasePriceSchedule = z.object({
    type: z.enum(['inAppPurchasePriceSchedules']),
    id: z.string(),
    relationships: z.optional(z.object({
        baseTerritory: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        manualPrices: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['inAppPurchasePrices']),
                id: z.string()
            })))
        })),
        automaticPrices: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['inAppPurchasePrices']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchasePriceScheduleResponse
 */
export const zInAppPurchasePriceScheduleResponse = z.object({
    data: zInAppPurchasePriceSchedule,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('inAppPurchasePrices')
        }).and(zInAppPurchasePrice), z.object({
            type: z.literal('territories')
        }).and(zTerritory)]))),
    links: zDocumentLinks
});

/**
 * InAppPurchasePricesResponse
 */
export const zInAppPurchasePricesResponse = z.object({
    data: z.array(zInAppPurchasePrice),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('inAppPurchasePricePoints')
        }).and(zInAppPurchasePricePoint), z.object({
            type: z.literal('territories')
        }).and(zTerritory)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * MerchantId
 */
export const zMerchantId = z.object({
    type: z.enum(['merchantIds']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        identifier: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        certificates: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['certificates']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * PassTypeId
 */
export const zPassTypeId = z.object({
    type: z.enum(['passTypeIds']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        identifier: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        certificates: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['certificates']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * ScmRepository
 */
export const zScmRepository = z.object({
    type: z.enum(['scmRepositories']),
    id: z.string(),
    attributes: z.optional(z.object({
        lastAccessedDate: z.optional(z.iso.datetime()),
        httpCloneUrl: z.optional(z.url()),
        sshCloneUrl: z.optional(z.url()),
        ownerName: z.optional(z.string()),
        repositoryName: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        scmProvider: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['scmProviders']),
                id: z.string()
            }))
        })),
        defaultBranch: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['scmGitReferences']),
                id: z.string()
            }))
        })),
        gitReferences: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        pullRequests: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * ScmPullRequestsResponse
 */
export const zScmPullRequestsResponse = z.object({
    data: z.array(zScmPullRequest),
    included: z.optional(z.array(zScmRepository)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * ScmPullRequestResponse
 */
export const zScmPullRequestResponse = z.object({
    data: zScmPullRequest,
    included: z.optional(z.array(zScmRepository)),
    links: zDocumentLinks
});

/**
 * SubscriptionAvailability
 */
export const zSubscriptionAvailability = z.object({
    type: z.enum(['subscriptionAvailabilities']),
    id: z.string(),
    attributes: z.optional(z.object({
        availableInNewTerritories: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        availableTerritories: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['territories']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionAvailabilityResponse
 */
export const zSubscriptionAvailabilityResponse = z.object({
    data: zSubscriptionAvailability,
    included: z.optional(z.array(zTerritory)),
    links: zDocumentLinks
});

/**
 * SubscriptionGroup
 */
export const zSubscriptionGroup = z.object({
    type: z.enum(['subscriptionGroups']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        subscriptions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptions']),
                id: z.string()
            })))
        })),
        subscriptionGroupLocalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionGroupLocalizations']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionGroupLocalizationsResponse
 */
export const zSubscriptionGroupLocalizationsResponse = z.object({
    data: z.array(zSubscriptionGroupLocalization),
    included: z.optional(z.array(zSubscriptionGroup)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionGroupLocalizationResponse
 */
export const zSubscriptionGroupLocalizationResponse = z.object({
    data: zSubscriptionGroupLocalization,
    included: z.optional(z.array(zSubscriptionGroup)),
    links: zDocumentLinks
});

/**
 * SubscriptionPricePoint
 */
export const zSubscriptionPricePoint = z.object({
    type: z.enum(['subscriptionPricePoints']),
    id: z.string(),
    attributes: z.optional(z.object({
        customerPrice: z.optional(z.string()),
        proceeds: z.optional(z.string()),
        proceedsYear2: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        equalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionOfferCodePricesResponse
 */
export const zSubscriptionOfferCodePricesResponse = z.object({
    data: z.array(zSubscriptionOfferCodePrice),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('subscriptionPricePoints')
        }).and(zSubscriptionPricePoint), z.object({
            type: z.literal('territories')
        }).and(zTerritory)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionPricePointsResponse
 */
export const zSubscriptionPricePointsResponse = z.object({
    data: z.array(zSubscriptionPricePoint),
    included: z.optional(z.array(zTerritory)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionPricePointResponse
 */
export const zSubscriptionPricePointResponse = z.object({
    data: zSubscriptionPricePoint,
    included: z.optional(z.array(zTerritory)),
    links: zDocumentLinks
});

/**
 * SubscriptionPricesResponse
 */
export const zSubscriptionPricesResponse = z.object({
    data: z.array(zSubscriptionPrice),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('subscriptionPricePoints')
        }).and(zSubscriptionPricePoint), z.object({
            type: z.literal('territories')
        }).and(zTerritory)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionPriceResponse
 */
export const zSubscriptionPriceResponse = z.object({
    data: zSubscriptionPrice,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('subscriptionPricePoints')
        }).and(zSubscriptionPricePoint), z.object({
            type: z.literal('territories')
        }).and(zTerritory)]))),
    links: zDocumentLinks
});

/**
 * SubscriptionPromotionalOfferPricesResponse
 */
export const zSubscriptionPromotionalOfferPricesResponse = z.object({
    data: z.array(zSubscriptionPromotionalOfferPrice),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('subscriptionPricePoints')
        }).and(zSubscriptionPricePoint), z.object({
            type: z.literal('territories')
        }).and(zTerritory)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * Subscription
 */
export const zSubscription = z.object({
    type: z.enum(['subscriptions']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        productId: z.optional(z.string()),
        familySharable: z.optional(z.boolean()),
        state: z.optional(z.enum([
            'MISSING_METADATA',
            'READY_TO_SUBMIT',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'DEVELOPER_ACTION_NEEDED',
            'PENDING_BINARY_APPROVAL',
            'APPROVED',
            'DEVELOPER_REMOVED_FROM_SALE',
            'REMOVED_FROM_SALE',
            'REJECTED'
        ])),
        subscriptionPeriod: z.optional(z.enum([
            'ONE_WEEK',
            'ONE_MONTH',
            'TWO_MONTHS',
            'THREE_MONTHS',
            'SIX_MONTHS',
            'ONE_YEAR'
        ])),
        reviewNote: z.optional(z.string()),
        groupLevel: z.optional(z.int())
    })),
    relationships: z.optional(z.object({
        subscriptionLocalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionLocalizations']),
                id: z.string()
            })))
        })),
        appStoreReviewScreenshot: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['subscriptionAppStoreReviewScreenshots']),
                id: z.string()
            }))
        })),
        group: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionGroups']),
                id: z.string()
            }))
        })),
        introductoryOffers: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionIntroductoryOffers']),
                id: z.string()
            })))
        })),
        promotionalOffers: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionPromotionalOffers']),
                id: z.string()
            })))
        })),
        offerCodes: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionOfferCodes']),
                id: z.string()
            })))
        })),
        prices: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionPrices']),
                id: z.string()
            })))
        })),
        pricePoints: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        promotedPurchase: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['promotedPurchases']),
                id: z.string()
            }))
        })),
        subscriptionAvailability: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['subscriptionAvailabilities']),
                id: z.string()
            }))
        })),
        winBackOffers: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['winBackOffers']),
                id: z.string()
            })))
        })),
        images: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionImages']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionGroupsResponse
 */
export const zSubscriptionGroupsResponse = z.object({
    data: z.array(zSubscriptionGroup),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('subscriptionGroupLocalizations')
        }).and(zSubscriptionGroupLocalization), z.object({
            type: z.literal('subscriptions')
        }).and(zSubscription)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionGroupResponse
 */
export const zSubscriptionGroupResponse = z.object({
    data: zSubscriptionGroup,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('subscriptionGroupLocalizations')
        }).and(zSubscriptionGroupLocalization), z.object({
            type: z.literal('subscriptions')
        }).and(zSubscription)]))),
    links: zDocumentLinks
});

/**
 * SubscriptionLocalizationsResponse
 */
export const zSubscriptionLocalizationsResponse = z.object({
    data: z.array(zSubscriptionLocalization),
    included: z.optional(z.array(zSubscription)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionLocalizationResponse
 */
export const zSubscriptionLocalizationResponse = z.object({
    data: zSubscriptionLocalization,
    included: z.optional(z.array(zSubscription)),
    links: zDocumentLinks
});

/**
 * SubscriptionSubmissionResponse
 */
export const zSubscriptionSubmissionResponse = z.object({
    data: zSubscriptionSubmission,
    included: z.optional(z.array(zSubscription)),
    links: zDocumentLinks
});

/**
 * WinBackOfferPricesResponse
 */
export const zWinBackOfferPricesResponse = z.object({
    data: z.array(zWinBackOfferPrice),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('subscriptionPricePoints')
        }).and(zSubscriptionPricePoint), z.object({
            type: z.literal('territories')
        }).and(zTerritory)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaAppLocalizationsWithoutIncludesResponse
 */
export const zBetaAppLocalizationsWithoutIncludesResponse = z.object({
    data: z.array(zBetaAppLocalization),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaAppReviewDetailWithoutIncludesResponse
 */
export const zBetaAppReviewDetailWithoutIncludesResponse = z.object({
    data: zBetaAppReviewDetail,
    links: zDocumentLinks
});

/**
 * BetaGroupsWithoutIncludesResponse
 */
export const zBetaGroupsWithoutIncludesResponse = z.object({
    data: z.array(zBetaGroup),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaLicenseAgreementWithoutIncludesResponse
 */
export const zBetaLicenseAgreementWithoutIncludesResponse = z.object({
    data: zBetaLicenseAgreement,
    links: zDocumentLinks
});

/**
 * EndUserLicenseAgreementWithoutIncludesResponse
 */
export const zEndUserLicenseAgreementWithoutIncludesResponse = z.object({
    data: zEndUserLicenseAgreement,
    links: zDocumentLinks
});

/**
 * BetaBuildLocalizationsWithoutIncludesResponse
 */
export const zBetaBuildLocalizationsWithoutIncludesResponse = z.object({
    data: z.array(zBetaBuildLocalization),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppClipAction = z.enum([
    'OPEN',
    'VIEW',
    'PLAY'
]);

/**
 * AppClipDefaultExperience
 */
export const zAppClipDefaultExperience = z.object({
    type: z.enum(['appClipDefaultExperiences']),
    id: z.string(),
    attributes: z.optional(z.object({
        action: z.optional(zAppClipAction)
    })),
    relationships: z.optional(z.object({
        appClip: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appClips']),
                id: z.string()
            }))
        })),
        releaseWithAppStoreVersion: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            }))
        })),
        appClipDefaultExperienceLocalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appClipDefaultExperienceLocalizations']),
                id: z.string()
            })))
        })),
        appClipAppStoreReviewDetail: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appClipAppStoreReviewDetails']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppClipAppStoreReviewDetailResponse
 */
export const zAppClipAppStoreReviewDetailResponse = z.object({
    data: zAppClipAppStoreReviewDetail,
    included: z.optional(z.array(zAppClipDefaultExperience)),
    links: zDocumentLinks
});

/**
 * AppClipDefaultExperienceCreateRequest
 */
export const zAppClipDefaultExperienceCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appClipDefaultExperiences']),
        attributes: z.optional(z.object({
            action: z.optional(zAppClipAction)
        })),
        relationships: z.object({
            appClip: z.object({
                data: z.object({
                    type: z.enum(['appClips']),
                    id: z.string()
                })
            }),
            releaseWithAppStoreVersion: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                }))
            })),
            appClipDefaultExperienceTemplate: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appClipDefaultExperiences']),
                    id: z.string()
                }))
            }))
        })
    })
});

/**
 * AppClipDefaultExperienceUpdateRequest
 */
export const zAppClipDefaultExperienceUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appClipDefaultExperiences']),
        id: z.string(),
        attributes: z.optional(z.object({
            action: z.optional(zAppClipAction)
        })),
        relationships: z.optional(z.object({
            releaseWithAppStoreVersion: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                }))
            }))
        }))
    })
});

export const zAppClipAdvancedExperienceLanguage = z.enum([
    'AR',
    'CA',
    'CS',
    'DA',
    'DE',
    'EL',
    'EN',
    'ES',
    'FI',
    'FR',
    'HE',
    'HI',
    'HR',
    'HU',
    'ID',
    'IT',
    'JA',
    'KO',
    'MS',
    'NL',
    'NO',
    'PL',
    'PT',
    'RO',
    'RU',
    'SK',
    'SV',
    'TH',
    'TR',
    'UK',
    'VI',
    'ZH'
]);

/**
 * AppClipAdvancedExperienceLocalization
 */
export const zAppClipAdvancedExperienceLocalization = z.object({
    type: z.enum(['appClipAdvancedExperienceLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        language: z.optional(zAppClipAdvancedExperienceLanguage),
        title: z.optional(z.string()),
        subtitle: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

export const zAppClipAdvancedExperienceLocalizationInlineCreate = z.object({
    type: z.enum(['appClipAdvancedExperienceLocalizations']),
    id: z.optional(z.string()),
    attributes: z.optional(z.object({
        language: z.optional(zAppClipAdvancedExperienceLanguage),
        title: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        subtitle: z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }))
});

/**
 * AppClipAdvancedExperience
 */
export const zAppClipAdvancedExperience = z.object({
    type: z.enum(['appClipAdvancedExperiences']),
    id: z.string(),
    attributes: z.optional(z.object({
        link: z.optional(z.url()),
        version: z.optional(z.int()),
        status: z.optional(z.enum([
            'RECEIVED',
            'DEACTIVATED',
            'APP_TRANSFER_IN_PROGRESS'
        ])),
        action: z.optional(zAppClipAction),
        isPoweredBy: z.optional(z.boolean()),
        place: z.optional(z.object({
            placeId: z.optional(z.string()),
            names: z.optional(z.array(z.string())),
            mainAddress: z.optional(z.object({
                fullAddress: z.optional(z.string()),
                structuredAddress: z.optional(z.object({
                    streetAddress: z.optional(z.array(z.string())),
                    floor: z.optional(z.string()),
                    neighborhood: z.optional(z.string()),
                    locality: z.optional(z.string()),
                    stateProvince: z.optional(z.string()),
                    postalCode: z.optional(z.string()),
                    countryCode: z.optional(z.string())
                }))
            })),
            displayPoint: z.optional(z.object({
                coordinates: z.optional(z.object({
                    latitude: z.optional(z.number()),
                    longitude: z.optional(z.number())
                })),
                source: z.optional(z.enum(['CALCULATED', 'MANUALLY_PLACED']))
            })),
            mapAction: z.optional(z.enum([
                'BUY_TICKETS',
                'VIEW_AVAILABILITY',
                'VIEW_PRICING',
                'HOTEL_BOOK_ROOM',
                'PARKING_RESERVE_PARKING',
                'RESTAURANT_JOIN_WAITLIST',
                'RESTAURANT_ORDER_DELIVERY',
                'RESTAURANT_ORDER_FOOD',
                'RESTAURANT_ORDER_TAKEOUT',
                'RESTAURANT_RESERVATION',
                'SCHEDULE_APPOINTMENT',
                'RESTAURANT_VIEW_MENU',
                'THEATER_NOW_PLAYING',
                'AIRLINE_BOOK_TRAVEL',
                'AIRLINE_CHECK_IN',
                'AIRLINE_FLIGHT_STATUS',
                'APPLY',
                'BOOK',
                'BOOK_ACTIVITIES',
                'BOOK_RIDES',
                'BOOK_TEETIMES',
                'BOOK_TOURS',
                'CAREERS',
                'CHARGE_EV',
                'COUPONS',
                'DONATE',
                'EVENTS',
                'EVENTS_SHOWS',
                'EVENTS_SPORTS',
                'GIFT_CARD',
                'HOTEL_AMENITIES',
                'JOIN',
                'PARKING_AVAILABLE',
                'RESTAURANT_PICKUP',
                'RETAIL_SERVICE_QUOTE',
                'RETAIL_STORE_DELIVERY',
                'RETAIL_STORE_PICKUP',
                'RETAIL_STORE_SHOP',
                'SERVICES',
                'SUPPORT',
                'PAY_TO_PARK'
            ])),
            relationship: z.optional(z.enum([
                'OWNER',
                'AUTHORIZED',
                'OTHER'
            ])),
            phoneNumber: z.optional(z.object({
                number: z.optional(z.string()),
                type: z.optional(z.enum([
                    'FAX',
                    'LANDLINE',
                    'MOBILE',
                    'TOLLFREE'
                ])),
                intent: z.optional(z.string())
            })),
            homePage: z.optional(z.string()),
            categories: z.optional(z.array(z.string()))
        })),
        placeStatus: z.optional(z.enum([
            'PENDING',
            'MATCHED',
            'NO_MATCH'
        ])),
        businessCategory: z.optional(z.enum([
            'AUTOMOTIVE',
            'BEAUTY',
            'BIKES',
            'BOOKS',
            'CASINO',
            'EDUCATION',
            'EDUCATION_JAPAN',
            'ENTERTAINMENT',
            'EV_CHARGER',
            'FINANCIAL_USD',
            'FINANCIAL_CNY',
            'FINANCIAL_GBP',
            'FINANCIAL_JPY',
            'FINANCIAL_EUR',
            'FITNESS',
            'FOOD_AND_DRINK',
            'GAS',
            'GROCERY',
            'HEALTH_AND_MEDICAL',
            'HOTEL_AND_TRAVEL',
            'MUSIC',
            'PARKING',
            'PET_SERVICES',
            'PROFESSIONAL_SERVICES',
            'SHOPPING',
            'TICKETING',
            'TRANSIT'
        ])),
        defaultLanguage: z.optional(zAppClipAdvancedExperienceLanguage)
    })),
    relationships: z.optional(z.object({
        appClip: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appClips']),
                id: z.string()
            }))
        })),
        headerImage: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appClipAdvancedExperienceImages']),
                id: z.string()
            }))
        })),
        localizations: z.optional(z.object({
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appClipAdvancedExperienceLocalizations']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppClipAdvancedExperienceCreateRequest
 */
export const zAppClipAdvancedExperienceCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appClipAdvancedExperiences']),
        attributes: z.object({
            link: z.url(),
            action: z.optional(zAppClipAction),
            isPoweredBy: z.boolean(),
            place: z.optional(z.union([
                z.object({
                    placeId: z.optional(z.string()),
                    names: z.optional(z.array(z.string())),
                    mainAddress: z.optional(z.object({
                        fullAddress: z.optional(z.string()),
                        structuredAddress: z.optional(z.object({
                            streetAddress: z.optional(z.array(z.string())),
                            floor: z.optional(z.string()),
                            neighborhood: z.optional(z.string()),
                            locality: z.optional(z.string()),
                            stateProvince: z.optional(z.string()),
                            postalCode: z.optional(z.string()),
                            countryCode: z.optional(z.string())
                        }))
                    })),
                    displayPoint: z.optional(z.object({
                        coordinates: z.optional(z.object({
                            latitude: z.optional(z.number()),
                            longitude: z.optional(z.number())
                        })),
                        source: z.optional(z.enum(['CALCULATED', 'MANUALLY_PLACED']))
                    })),
                    mapAction: z.optional(z.enum([
                        'BUY_TICKETS',
                        'VIEW_AVAILABILITY',
                        'VIEW_PRICING',
                        'HOTEL_BOOK_ROOM',
                        'PARKING_RESERVE_PARKING',
                        'RESTAURANT_JOIN_WAITLIST',
                        'RESTAURANT_ORDER_DELIVERY',
                        'RESTAURANT_ORDER_FOOD',
                        'RESTAURANT_ORDER_TAKEOUT',
                        'RESTAURANT_RESERVATION',
                        'SCHEDULE_APPOINTMENT',
                        'RESTAURANT_VIEW_MENU',
                        'THEATER_NOW_PLAYING',
                        'AIRLINE_BOOK_TRAVEL',
                        'AIRLINE_CHECK_IN',
                        'AIRLINE_FLIGHT_STATUS',
                        'APPLY',
                        'BOOK',
                        'BOOK_ACTIVITIES',
                        'BOOK_RIDES',
                        'BOOK_TEETIMES',
                        'BOOK_TOURS',
                        'CAREERS',
                        'CHARGE_EV',
                        'COUPONS',
                        'DONATE',
                        'EVENTS',
                        'EVENTS_SHOWS',
                        'EVENTS_SPORTS',
                        'GIFT_CARD',
                        'HOTEL_AMENITIES',
                        'JOIN',
                        'PARKING_AVAILABLE',
                        'RESTAURANT_PICKUP',
                        'RETAIL_SERVICE_QUOTE',
                        'RETAIL_STORE_DELIVERY',
                        'RETAIL_STORE_PICKUP',
                        'RETAIL_STORE_SHOP',
                        'SERVICES',
                        'SUPPORT',
                        'PAY_TO_PARK'
                    ])),
                    relationship: z.optional(z.enum([
                        'OWNER',
                        'AUTHORIZED',
                        'OTHER'
                    ])),
                    phoneNumber: z.optional(z.object({
                        number: z.optional(z.string()),
                        type: z.optional(z.enum([
                            'FAX',
                            'LANDLINE',
                            'MOBILE',
                            'TOLLFREE'
                        ])),
                        intent: z.optional(z.string())
                    })),
                    homePage: z.optional(z.string()),
                    categories: z.optional(z.array(z.string()))
                }),
                z.null()
            ])),
            businessCategory: z.optional(z.enum([
                'AUTOMOTIVE',
                'BEAUTY',
                'BIKES',
                'BOOKS',
                'CASINO',
                'EDUCATION',
                'EDUCATION_JAPAN',
                'ENTERTAINMENT',
                'EV_CHARGER',
                'FINANCIAL_USD',
                'FINANCIAL_CNY',
                'FINANCIAL_GBP',
                'FINANCIAL_JPY',
                'FINANCIAL_EUR',
                'FITNESS',
                'FOOD_AND_DRINK',
                'GAS',
                'GROCERY',
                'HEALTH_AND_MEDICAL',
                'HOTEL_AND_TRAVEL',
                'MUSIC',
                'PARKING',
                'PET_SERVICES',
                'PROFESSIONAL_SERVICES',
                'SHOPPING',
                'TICKETING',
                'TRANSIT'
            ])),
            defaultLanguage: zAppClipAdvancedExperienceLanguage
        }),
        relationships: z.object({
            appClip: z.object({
                data: z.object({
                    type: z.enum(['appClips']),
                    id: z.string()
                })
            }),
            headerImage: z.object({
                data: z.object({
                    type: z.enum(['appClipAdvancedExperienceImages']),
                    id: z.string()
                })
            }),
            localizations: z.object({
                data: z.array(z.object({
                    type: z.enum(['appClipAdvancedExperienceLocalizations']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(zAppClipAdvancedExperienceLocalizationInlineCreate))
});

/**
 * AppClipAdvancedExperienceUpdateRequest
 */
export const zAppClipAdvancedExperienceUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appClipAdvancedExperiences']),
        id: z.string(),
        attributes: z.optional(z.object({
            action: z.optional(zAppClipAction),
            isPoweredBy: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            place: z.optional(z.union([
                z.object({
                    placeId: z.optional(z.string()),
                    names: z.optional(z.array(z.string())),
                    mainAddress: z.optional(z.object({
                        fullAddress: z.optional(z.string()),
                        structuredAddress: z.optional(z.object({
                            streetAddress: z.optional(z.array(z.string())),
                            floor: z.optional(z.string()),
                            neighborhood: z.optional(z.string()),
                            locality: z.optional(z.string()),
                            stateProvince: z.optional(z.string()),
                            postalCode: z.optional(z.string()),
                            countryCode: z.optional(z.string())
                        }))
                    })),
                    displayPoint: z.optional(z.object({
                        coordinates: z.optional(z.object({
                            latitude: z.optional(z.number()),
                            longitude: z.optional(z.number())
                        })),
                        source: z.optional(z.enum(['CALCULATED', 'MANUALLY_PLACED']))
                    })),
                    mapAction: z.optional(z.enum([
                        'BUY_TICKETS',
                        'VIEW_AVAILABILITY',
                        'VIEW_PRICING',
                        'HOTEL_BOOK_ROOM',
                        'PARKING_RESERVE_PARKING',
                        'RESTAURANT_JOIN_WAITLIST',
                        'RESTAURANT_ORDER_DELIVERY',
                        'RESTAURANT_ORDER_FOOD',
                        'RESTAURANT_ORDER_TAKEOUT',
                        'RESTAURANT_RESERVATION',
                        'SCHEDULE_APPOINTMENT',
                        'RESTAURANT_VIEW_MENU',
                        'THEATER_NOW_PLAYING',
                        'AIRLINE_BOOK_TRAVEL',
                        'AIRLINE_CHECK_IN',
                        'AIRLINE_FLIGHT_STATUS',
                        'APPLY',
                        'BOOK',
                        'BOOK_ACTIVITIES',
                        'BOOK_RIDES',
                        'BOOK_TEETIMES',
                        'BOOK_TOURS',
                        'CAREERS',
                        'CHARGE_EV',
                        'COUPONS',
                        'DONATE',
                        'EVENTS',
                        'EVENTS_SHOWS',
                        'EVENTS_SPORTS',
                        'GIFT_CARD',
                        'HOTEL_AMENITIES',
                        'JOIN',
                        'PARKING_AVAILABLE',
                        'RESTAURANT_PICKUP',
                        'RETAIL_SERVICE_QUOTE',
                        'RETAIL_STORE_DELIVERY',
                        'RETAIL_STORE_PICKUP',
                        'RETAIL_STORE_SHOP',
                        'SERVICES',
                        'SUPPORT',
                        'PAY_TO_PARK'
                    ])),
                    relationship: z.optional(z.enum([
                        'OWNER',
                        'AUTHORIZED',
                        'OTHER'
                    ])),
                    phoneNumber: z.optional(z.object({
                        number: z.optional(z.string()),
                        type: z.optional(z.enum([
                            'FAX',
                            'LANDLINE',
                            'MOBILE',
                            'TOLLFREE'
                        ])),
                        intent: z.optional(z.string())
                    })),
                    homePage: z.optional(z.string()),
                    categories: z.optional(z.array(z.string()))
                }),
                z.null()
            ])),
            businessCategory: z.optional(z.enum([
                'AUTOMOTIVE',
                'BEAUTY',
                'BIKES',
                'BOOKS',
                'CASINO',
                'EDUCATION',
                'EDUCATION_JAPAN',
                'ENTERTAINMENT',
                'EV_CHARGER',
                'FINANCIAL_USD',
                'FINANCIAL_CNY',
                'FINANCIAL_GBP',
                'FINANCIAL_JPY',
                'FINANCIAL_EUR',
                'FITNESS',
                'FOOD_AND_DRINK',
                'GAS',
                'GROCERY',
                'HEALTH_AND_MEDICAL',
                'HOTEL_AND_TRAVEL',
                'MUSIC',
                'PARKING',
                'PET_SERVICES',
                'PROFESSIONAL_SERVICES',
                'SHOPPING',
                'TICKETING',
                'TRANSIT'
            ])),
            defaultLanguage: z.optional(zAppClipAdvancedExperienceLanguage),
            removed: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        })),
        relationships: z.optional(z.object({
            appClip: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appClips']),
                    id: z.string()
                }))
            })),
            headerImage: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appClipAdvancedExperienceImages']),
                    id: z.string()
                }))
            })),
            localizations: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['appClipAdvancedExperienceLocalizations']),
                    id: z.string()
                })))
            }))
        }))
    }),
    included: z.optional(z.array(zAppClipAdvancedExperienceLocalizationInlineCreate))
});

export const zAppEncryptionDeclarationState = z.enum([
    'CREATED',
    'IN_REVIEW',
    'APPROVED',
    'REJECTED',
    'INVALID',
    'EXPIRED'
]);

export const zAppEventAssetType = z.enum(['EVENT_CARD', 'EVENT_DETAILS_PAGE']);

/**
 * AppEventScreenshotCreateRequest
 */
export const zAppEventScreenshotCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appEventScreenshots']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string(),
            appEventAssetType: zAppEventAssetType
        }),
        relationships: z.object({
            appEventLocalization: z.object({
                data: z.object({
                    type: z.enum(['appEventLocalizations']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppEventVideoClipCreateRequest
 */
export const zAppEventVideoClipCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appEventVideoClips']),
        attributes: z.object({
            fileSize: z.int(),
            fileName: z.string(),
            previewFrameTimeCode: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            appEventAssetType: zAppEventAssetType
        }),
        relationships: z.object({
            appEventLocalization: z.object({
                data: z.object({
                    type: z.enum(['appEventLocalizations']),
                    id: z.string()
                })
            })
        })
    })
});

export const zAppMediaStateError = z.object({
    code: z.optional(z.string()),
    description: z.optional(z.string())
});

export const zAppMediaAssetState = z.object({
    errors: z.optional(z.array(zAppMediaStateError)),
    warnings: z.optional(z.array(zAppMediaStateError)),
    state: z.optional(z.enum([
        'AWAITING_UPLOAD',
        'UPLOAD_COMPLETE',
        'COMPLETE',
        'FAILED'
    ]))
});

export const zAppMediaPreviewFrameImageState = z.object({
    errors: z.optional(z.array(zAppMediaStateError)),
    warnings: z.optional(z.array(zAppMediaStateError)),
    state: z.optional(z.enum([
        'PROCESSING',
        'COMPLETE',
        'FAILED'
    ]))
});

export const zAppMediaVideoState = z.object({
    errors: z.optional(z.array(zAppMediaStateError)),
    warnings: z.optional(z.array(zAppMediaStateError)),
    state: z.optional(z.enum([
        'AWAITING_UPLOAD',
        'UPLOAD_COMPLETE',
        'PROCESSING',
        'COMPLETE',
        'FAILED'
    ]))
});

export const zAppStoreAgeRating = z.enum([
    'L',
    'ALL',
    'ONE_PLUS',
    'TWO_PLUS',
    'THREE_PLUS',
    'FOUR_PLUS',
    'FIVE_PLUS',
    'SIX_PLUS',
    'SEVEN_PLUS',
    'EIGHT_PLUS',
    'NINE_PLUS',
    'TEN_PLUS',
    'ELEVEN_PLUS',
    'TWELVE_PLUS',
    'THIRTEEN_PLUS',
    'FOURTEEN_PLUS',
    'FIFTEEN_PLUS',
    'SIXTEEN_PLUS',
    'SEVENTEEN_PLUS',
    'EIGHTEEN_PLUS',
    'NINETEEN_PLUS',
    'TWENTY_PLUS',
    'TWENTY_ONE_PLUS',
    'UNRATED'
]);

/**
 * TerritoryAgeRating
 */
export const zTerritoryAgeRating = z.object({
    type: z.enum(['territoryAgeRatings']),
    id: z.string(),
    attributes: z.optional(z.object({
        appStoreAgeRating: z.optional(zAppStoreAgeRating)
    })),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * TerritoryAgeRatingsResponse
 */
export const zTerritoryAgeRatingsResponse = z.object({
    data: z.array(zTerritoryAgeRating),
    included: z.optional(z.array(zTerritory)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppStoreVersionState = z.enum([
    'ACCEPTED',
    'DEVELOPER_REMOVED_FROM_SALE',
    'DEVELOPER_REJECTED',
    'IN_REVIEW',
    'INVALID_BINARY',
    'METADATA_REJECTED',
    'PENDING_APPLE_RELEASE',
    'PENDING_CONTRACT',
    'PENDING_DEVELOPER_RELEASE',
    'PREPARE_FOR_SUBMISSION',
    'PREORDER_READY_FOR_SALE',
    'PROCESSING_FOR_APP_STORE',
    'READY_FOR_REVIEW',
    'READY_FOR_SALE',
    'REJECTED',
    'REMOVED_FROM_SALE',
    'WAITING_FOR_EXPORT_COMPLIANCE',
    'WAITING_FOR_REVIEW',
    'REPLACED_WITH_NEW_VERSION',
    'NOT_APPLICABLE'
]);

export const zAppVersionState = z.enum([
    'ACCEPTED',
    'DEVELOPER_REJECTED',
    'IN_REVIEW',
    'INVALID_BINARY',
    'METADATA_REJECTED',
    'PENDING_APPLE_RELEASE',
    'PENDING_DEVELOPER_RELEASE',
    'PREPARE_FOR_SUBMISSION',
    'PROCESSING_FOR_DISTRIBUTION',
    'READY_FOR_DISTRIBUTION',
    'READY_FOR_REVIEW',
    'REJECTED',
    'REPLACED_WITH_NEW_VERSION',
    'WAITING_FOR_EXPORT_COMPLIANCE',
    'WAITING_FOR_REVIEW'
]);

export const zBackgroundAssetVersionAppStoreReleaseState = z.enum([
    'PREPARE_FOR_SUBMISSION',
    'READY_FOR_REVIEW',
    'WAITING_FOR_REVIEW',
    'IN_REVIEW',
    'ACCEPTED',
    'REJECTED',
    'PROCESSING_FOR_DISTRIBUTION',
    'READY_FOR_DISTRIBUTION',
    'SUPERSEDED'
]);

/**
 * BackgroundAssetVersionAppStoreRelease
 */
export const zBackgroundAssetVersionAppStoreRelease = z.object({
    type: z.enum(['backgroundAssetVersionAppStoreReleases']),
    id: z.string(),
    attributes: z.optional(z.object({
        state: z.optional(zBackgroundAssetVersionAppStoreReleaseState)
    })),
    relationships: z.optional(z.object({
        backgroundAssetVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssetVersions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

export const zBackgroundAssetVersionExternalBetaReleaseState = z.enum([
    'READY_FOR_BETA_SUBMISSION',
    'WAITING_FOR_REVIEW',
    'IN_REVIEW',
    'REJECTED',
    'PROCESSING_FOR_TESTING',
    'READY_FOR_TESTING',
    'SUPERSEDED'
]);

/**
 * BackgroundAssetVersionExternalBetaRelease
 */
export const zBackgroundAssetVersionExternalBetaRelease = z.object({
    type: z.enum(['backgroundAssetVersionExternalBetaReleases']),
    id: z.string(),
    attributes: z.optional(z.object({
        state: z.optional(zBackgroundAssetVersionExternalBetaReleaseState)
    })),
    relationships: z.optional(z.object({
        backgroundAssetVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssetVersions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

export const zBackgroundAssetVersionState = z.enum([
    'AWAITING_UPLOAD',
    'PROCESSING',
    'FAILED',
    'COMPLETE'
]);

export const zBetaFeedbackScreenshotImage = z.object({
    url: z.optional(z.string()),
    width: z.optional(z.int()),
    height: z.optional(z.int()),
    expirationDate: z.optional(z.iso.datetime())
});

export const zBetaInviteType = z.enum(['EMAIL', 'PUBLIC_LINK']);

export const zBetaReviewState = z.enum([
    'WAITING_FOR_REVIEW',
    'IN_REVIEW',
    'REJECTED',
    'APPROVED'
]);

/**
 * BetaAppReviewSubmission
 */
export const zBetaAppReviewSubmission = z.object({
    type: z.enum(['betaAppReviewSubmissions']),
    id: z.string(),
    attributes: z.optional(z.object({
        betaReviewState: z.optional(zBetaReviewState),
        submittedDate: z.optional(z.iso.datetime())
    })),
    relationships: z.optional(z.object({
        build: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['builds']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaAppReviewSubmissionWithoutIncludesResponse
 */
export const zBetaAppReviewSubmissionWithoutIncludesResponse = z.object({
    data: zBetaAppReviewSubmission,
    links: zDocumentLinks
});

export const zBetaTesterState = z.enum([
    'NOT_INVITED',
    'INVITED',
    'ACCEPTED',
    'INSTALLED',
    'REVOKED'
]);

/**
 * BetaTester
 */
export const zBetaTester = z.object({
    type: z.enum(['betaTesters']),
    id: z.string(),
    attributes: z.optional(z.object({
        firstName: z.optional(z.string()),
        lastName: z.optional(z.string()),
        email: z.optional(z.email()),
        inviteType: z.optional(zBetaInviteType),
        state: z.optional(zBetaTesterState),
        appDevices: z.optional(z.array(z.object({
            model: z.optional(z.string()),
            platform: z.optional(z.enum([
                'IOS',
                'MAC_OS',
                'TV_OS',
                'WATCH_OS',
                'VISION_OS'
            ])),
            osVersion: z.optional(z.string()),
            appBuildVersion: z.optional(z.string())
        })))
    })),
    relationships: z.optional(z.object({
        apps: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['apps']),
                id: z.string()
            })))
        })),
        betaGroups: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['betaGroups']),
                id: z.string()
            })))
        })),
        builds: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['builds']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaTestersWithoutIncludesResponse
 */
export const zBetaTestersWithoutIncludesResponse = z.object({
    data: z.array(zBetaTester),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zAppsBetaTesterUsagesV1MetricResponse = z.object({
    data: z.array(z.object({
        dataPoints: z.optional(z.object({
            start: z.optional(z.iso.datetime()),
            end: z.optional(z.iso.datetime()),
            values: z.optional(z.object({
                crashCount: z.optional(z.int()),
                sessionCount: z.optional(z.int()),
                feedbackCount: z.optional(z.int())
            }))
        })),
        dimensions: z.optional(z.object({
            betaTesters: z.optional(z.object({
                links: z.optional(z.object({
                    groupBy: z.optional(z.string()),
                    related: z.optional(z.string())
                })),
                data: z.optional(z.string())
            }))
        }))
    })),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation),
    included: z.optional(z.array(zBetaTester))
});

export const zBrazilAgeRating = z.enum([
    'L',
    'TEN',
    'TWELVE',
    'FOURTEEN',
    'SIXTEEN',
    'EIGHTEEN'
]);

export const zBuildAudienceType = z.enum(['INTERNAL_ONLY', 'APP_STORE_ELIGIBLE']);

export const zBuildBundleType = z.enum(['APP', 'APP_CLIP']);

/**
 * BuildBundle
 */
export const zBuildBundle = z.object({
    type: z.enum(['buildBundles']),
    id: z.string(),
    attributes: z.optional(z.object({
        bundleId: z.optional(z.string()),
        bundleType: z.optional(zBuildBundleType),
        sdkBuild: z.optional(z.string()),
        platformBuild: z.optional(z.string()),
        fileName: z.optional(z.string()),
        hasSirikit: z.optional(z.boolean()),
        hasOnDemandResources: z.optional(z.boolean()),
        hasPrerenderedIcon: z.optional(z.boolean()),
        usesLocationServices: z.optional(z.boolean()),
        isIosBuildMacAppStoreCompatible: z.optional(z.boolean()),
        includesSymbols: z.optional(z.boolean()),
        dSYMUrl: z.optional(z.url()),
        supportedArchitectures: z.optional(z.array(z.string())),
        requiredCapabilities: z.optional(z.array(z.string())),
        deviceProtocols: z.optional(z.array(z.string())),
        locales: z.optional(z.array(z.string())),
        entitlements: z.optional(z.record(z.string(), z.record(z.string(), z.string()))),
        baDownloadAllowance: z.optional(z.int()),
        baMaxInstallSize: z.optional(z.int())
    })),
    relationships: z.optional(z.object({
        appClipDomainCacheStatus: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appClipDomainStatuses']),
                id: z.string()
            }))
        })),
        appClipDomainDebugStatus: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appClipDomainStatuses']),
                id: z.string()
            }))
        })),
        betaAppClipInvocations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['betaAppClipInvocations']),
                id: z.string()
            })))
        })),
        buildBundleFileSizes: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['buildBundleFileSizes']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

export const zBuildUploadState = z.enum([
    'AWAITING_UPLOAD',
    'PROCESSING',
    'FAILED',
    'COMPLETE'
]);

export const zBundleIdPlatform = z.enum([
    'IOS',
    'MAC_OS',
    'UNIVERSAL'
]);

/**
 * BundleId
 */
export const zBundleId = z.object({
    type: z.enum(['bundleIds']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        platform: z.optional(zBundleIdPlatform),
        identifier: z.optional(z.string()),
        seedId: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        profiles: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['profiles']),
                id: z.string()
            })))
        })),
        bundleIdCapabilities: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['bundleIdCapabilities']),
                id: z.string()
            })))
        })),
        app: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BundleIdCreateRequest
 */
export const zBundleIdCreateRequest = z.object({
    data: z.object({
        type: z.enum(['bundleIds']),
        attributes: z.object({
            name: z.string(),
            platform: zBundleIdPlatform,
            identifier: z.string(),
            seedId: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        })
    })
});

/**
 * Device
 */
export const zDevice = z.object({
    type: z.enum(['devices']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        platform: z.optional(zBundleIdPlatform),
        udid: z.optional(z.string()),
        deviceClass: z.optional(z.enum([
            'APPLE_VISION_PRO',
            'APPLE_WATCH',
            'IPAD',
            'IPHONE',
            'IPOD',
            'APPLE_TV',
            'MAC'
        ])),
        status: z.optional(z.enum(['ENABLED', 'DISABLED'])),
        model: z.optional(z.string()),
        addedDate: z.optional(z.iso.datetime())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * DevicesResponse
 */
export const zDevicesResponse = z.object({
    data: z.array(zDevice),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * DeviceResponse
 */
export const zDeviceResponse = z.object({
    data: zDevice,
    links: zDocumentLinks
});

/**
 * DeviceCreateRequest
 */
export const zDeviceCreateRequest = z.object({
    data: z.object({
        type: z.enum(['devices']),
        attributes: z.object({
            name: z.string(),
            platform: zBundleIdPlatform,
            udid: z.string()
        })
    })
});

/**
 * Profile
 */
export const zProfile = z.object({
    type: z.enum(['profiles']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        platform: z.optional(zBundleIdPlatform),
        profileType: z.optional(z.enum([
            'IOS_APP_DEVELOPMENT',
            'IOS_APP_STORE',
            'IOS_APP_ADHOC',
            'IOS_APP_INHOUSE',
            'MAC_APP_DEVELOPMENT',
            'MAC_APP_STORE',
            'MAC_APP_DIRECT',
            'TVOS_APP_DEVELOPMENT',
            'TVOS_APP_STORE',
            'TVOS_APP_ADHOC',
            'TVOS_APP_INHOUSE',
            'MAC_CATALYST_APP_DEVELOPMENT',
            'MAC_CATALYST_APP_STORE',
            'MAC_CATALYST_APP_DIRECT'
        ])),
        profileState: z.optional(z.enum(['ACTIVE', 'INVALID'])),
        profileContent: z.optional(z.string()),
        uuid: z.optional(z.string()),
        createdDate: z.optional(z.iso.datetime()),
        expirationDate: z.optional(z.iso.datetime())
    })),
    relationships: z.optional(z.object({
        bundleId: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['bundleIds']),
                id: z.string()
            }))
        })),
        devices: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['devices']),
                id: z.string()
            })))
        })),
        certificates: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['certificates']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * ProfilesWithoutIncludesResponse
 */
export const zProfilesWithoutIncludesResponse = z.object({
    data: z.array(zProfile),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BundleIdWithoutIncludesResponse
 */
export const zBundleIdWithoutIncludesResponse = z.object({
    data: zBundleId,
    links: zDocumentLinks
});

/**
 * DevicesWithoutIncludesResponse
 */
export const zDevicesWithoutIncludesResponse = z.object({
    data: z.array(zDevice),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCapabilityOption = z.object({
    key: z.optional(z.enum([
        'XCODE_5',
        'XCODE_6',
        'COMPLETE_PROTECTION',
        'PROTECTED_UNLESS_OPEN',
        'PROTECTED_UNTIL_FIRST_USER_AUTH',
        'PRIMARY_APP_CONSENT'
    ])),
    name: z.optional(z.string()),
    description: z.optional(z.string()),
    enabledByDefault: z.optional(z.boolean()),
    enabled: z.optional(z.boolean()),
    supportsWildcard: z.optional(z.boolean())
});

export const zCapabilitySetting = z.object({
    key: z.optional(z.enum([
        'ICLOUD_VERSION',
        'DATA_PROTECTION_PERMISSION_LEVEL',
        'APPLE_ID_AUTH_APP_CONSENT'
    ])),
    name: z.optional(z.string()),
    description: z.optional(z.string()),
    enabledByDefault: z.optional(z.boolean()),
    visible: z.optional(z.boolean()),
    allowedInstances: z.optional(z.enum([
        'ENTRY',
        'SINGLE',
        'MULTIPLE'
    ])),
    minInstances: z.optional(z.int()),
    options: z.optional(z.array(zCapabilityOption))
});

export const zCapabilityType = z.enum([
    'ICLOUD',
    'IN_APP_PURCHASE',
    'GAME_CENTER',
    'PUSH_NOTIFICATIONS',
    'WALLET',
    'INTER_APP_AUDIO',
    'MAPS',
    'ASSOCIATED_DOMAINS',
    'PERSONAL_VPN',
    'APP_GROUPS',
    'HEALTHKIT',
    'HOMEKIT',
    'WIRELESS_ACCESSORY_CONFIGURATION',
    'APPLE_PAY',
    'DATA_PROTECTION',
    'SIRIKIT',
    'NETWORK_EXTENSIONS',
    'MULTIPATH',
    'HOT_SPOT',
    'NFC_TAG_READING',
    'CLASSKIT',
    'AUTOFILL_CREDENTIAL_PROVIDER',
    'ACCESS_WIFI_INFORMATION',
    'NETWORK_CUSTOM_PROTOCOL',
    'COREMEDIA_HLS_LOW_LATENCY',
    'SYSTEM_EXTENSION_INSTALL',
    'USER_MANAGEMENT',
    'APPLE_ID_AUTH'
]);

/**
 * BundleIdCapability
 */
export const zBundleIdCapability = z.object({
    type: z.enum(['bundleIdCapabilities']),
    id: z.string(),
    attributes: z.optional(z.object({
        capabilityType: z.optional(zCapabilityType),
        settings: z.optional(z.array(zCapabilitySetting))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BundleIdCapabilitiesResponse
 */
export const zBundleIdCapabilitiesResponse = z.object({
    data: z.array(zBundleIdCapability),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BundleIdCapabilityResponse
 */
export const zBundleIdCapabilityResponse = z.object({
    data: zBundleIdCapability,
    links: zDocumentLinks
});

/**
 * BundleIdCapabilityCreateRequest
 */
export const zBundleIdCapabilityCreateRequest = z.object({
    data: z.object({
        type: z.enum(['bundleIdCapabilities']),
        attributes: z.object({
            capabilityType: zCapabilityType,
            settings: z.optional(z.union([
                z.array(zCapabilitySetting),
                z.null()
            ]))
        }),
        relationships: z.object({
            bundleId: z.object({
                data: z.object({
                    type: z.enum(['bundleIds']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BundleIdCapabilityUpdateRequest
 */
export const zBundleIdCapabilityUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['bundleIdCapabilities']),
        id: z.string(),
        attributes: z.optional(z.object({
            capabilityType: z.optional(zCapabilityType),
            settings: z.optional(z.union([
                z.array(zCapabilitySetting),
                z.null()
            ]))
        }))
    })
});

/**
 * BundleIdCapabilitiesWithoutIncludesResponse
 */
export const zBundleIdCapabilitiesWithoutIncludesResponse = z.object({
    data: z.array(zBundleIdCapability),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zCertificateType = z.enum([
    'APPLE_PAY',
    'APPLE_PAY_MERCHANT_IDENTITY',
    'APPLE_PAY_PSP_IDENTITY',
    'APPLE_PAY_RSA',
    'DEVELOPER_ID_KEXT',
    'DEVELOPER_ID_KEXT_G2',
    'DEVELOPER_ID_APPLICATION',
    'DEVELOPER_ID_APPLICATION_G2',
    'DEVELOPMENT',
    'DISTRIBUTION',
    'IDENTITY_ACCESS',
    'IOS_DEVELOPMENT',
    'IOS_DISTRIBUTION',
    'MAC_APP_DISTRIBUTION',
    'MAC_INSTALLER_DISTRIBUTION',
    'MAC_APP_DEVELOPMENT',
    'PASS_TYPE_ID',
    'PASS_TYPE_ID_WITH_NFC'
]);

/**
 * Certificate
 */
export const zCertificate = z.object({
    type: z.enum(['certificates']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        certificateType: z.optional(zCertificateType),
        displayName: z.optional(z.string()),
        serialNumber: z.optional(z.string()),
        platform: z.optional(zBundleIdPlatform),
        expirationDate: z.optional(z.iso.datetime()),
        certificateContent: z.optional(z.string()),
        activated: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        passTypeId: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['passTypeIds']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * CertificatesResponse
 */
export const zCertificatesResponse = z.object({
    data: z.array(zCertificate),
    included: z.optional(z.array(zPassTypeId)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * CertificateResponse
 */
export const zCertificateResponse = z.object({
    data: zCertificate,
    included: z.optional(z.array(zPassTypeId)),
    links: zDocumentLinks
});

/**
 * CertificateCreateRequest
 */
export const zCertificateCreateRequest = z.object({
    data: z.object({
        type: z.enum(['certificates']),
        attributes: z.object({
            csrContent: z.string(),
            certificateType: zCertificateType
        }),
        relationships: z.optional(z.object({
            merchantId: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['merchantIds']),
                    id: z.string()
                }))
            })),
            passTypeId: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['passTypeIds']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * MerchantIdsResponse
 */
export const zMerchantIdsResponse = z.object({
    data: z.array(zMerchantId),
    included: z.optional(z.array(zCertificate)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * MerchantIdResponse
 */
export const zMerchantIdResponse = z.object({
    data: zMerchantId,
    included: z.optional(z.array(zCertificate)),
    links: zDocumentLinks
});

/**
 * PassTypeIdsResponse
 */
export const zPassTypeIdsResponse = z.object({
    data: z.array(zPassTypeId),
    included: z.optional(z.array(zCertificate)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * PassTypeIdResponse
 */
export const zPassTypeIdResponse = z.object({
    data: zPassTypeId,
    included: z.optional(z.array(zCertificate)),
    links: zDocumentLinks
});

/**
 * ProfilesResponse
 */
export const zProfilesResponse = z.object({
    data: z.array(zProfile),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('bundleIds')
        }).and(zBundleId),
        z.object({
            type: z.literal('certificates')
        }).and(zCertificate),
        z.object({
            type: z.literal('devices')
        }).and(zDevice)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * ProfileResponse
 */
export const zProfileResponse = z.object({
    data: zProfile,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('bundleIds')
        }).and(zBundleId),
        z.object({
            type: z.literal('certificates')
        }).and(zCertificate),
        z.object({
            type: z.literal('devices')
        }).and(zDevice)
    ]))),
    links: zDocumentLinks
});

/**
 * CertificatesWithoutIncludesResponse
 */
export const zCertificatesWithoutIncludesResponse = z.object({
    data: z.array(zCertificate),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zChecksumAlgorithm = z.enum(['MD5', 'SHA_256']);

export const zChecksums = z.object({
    file: z.optional(z.object({
        hash: z.optional(z.string()),
        algorithm: z.optional(zChecksumAlgorithm)
    })),
    composite: z.optional(z.object({
        hash: z.optional(z.string()),
        algorithm: z.optional(z.enum(['MD5']))
    }))
});

/**
 * AlternativeDistributionPackage
 */
export const zAlternativeDistributionPackage = z.object({
    type: z.enum(['alternativeDistributionPackages']),
    id: z.string(),
    attributes: z.optional(z.object({
        sourceFileChecksum: z.optional(zChecksums)
    })),
    relationships: z.optional(z.object({
        versions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['alternativeDistributionPackageVersions']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AlternativeDistributionPackageVersionsResponse
 */
export const zAlternativeDistributionPackageVersionsResponse = z.object({
    data: z.array(zAlternativeDistributionPackageVersion),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('alternativeDistributionPackageDeltas')
        }).and(zAlternativeDistributionPackageDelta),
        z.object({
            type: z.literal('alternativeDistributionPackageVariants')
        }).and(zAlternativeDistributionPackageVariant),
        z.object({
            type: z.literal('alternativeDistributionPackages')
        }).and(zAlternativeDistributionPackage)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AlternativeDistributionPackageVersionResponse
 */
export const zAlternativeDistributionPackageVersionResponse = z.object({
    data: zAlternativeDistributionPackageVersion,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('alternativeDistributionPackageDeltas')
        }).and(zAlternativeDistributionPackageDelta),
        z.object({
            type: z.literal('alternativeDistributionPackageVariants')
        }).and(zAlternativeDistributionPackageVariant),
        z.object({
            type: z.literal('alternativeDistributionPackages')
        }).and(zAlternativeDistributionPackage)
    ]))),
    links: zDocumentLinks
});

/**
 * AlternativeDistributionPackageResponse
 */
export const zAlternativeDistributionPackageResponse = z.object({
    data: zAlternativeDistributionPackage,
    included: z.optional(z.array(zAlternativeDistributionPackageVersion)),
    links: zDocumentLinks
});

/**
 * BackgroundAssetUploadFileUpdateRequest
 */
export const zBackgroundAssetUploadFileUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['backgroundAssetUploadFiles']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksum: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            sourceFileChecksums: z.optional(zChecksums),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * BuildUploadFileUpdateRequest
 */
export const zBuildUploadFileUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['buildUploadFiles']),
        id: z.string(),
        attributes: z.optional(z.object({
            sourceFileChecksums: z.optional(zChecksums),
            uploaded: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

export const zCiActionType = z.enum([
    'BUILD',
    'ANALYZE',
    'TEST',
    'ARCHIVE'
]);

export const zCiBranchPatterns = z.object({
    isAllMatch: z.optional(z.boolean()),
    patterns: z.optional(z.array(z.object({
        pattern: z.optional(z.string()),
        isPrefix: z.optional(z.boolean())
    })))
});

export const zCiCompletionStatus = z.enum([
    'SUCCEEDED',
    'FAILED',
    'ERRORED',
    'CANCELED',
    'SKIPPED'
]);

export const zCiExecutionProgress = z.enum([
    'PENDING',
    'RUNNING',
    'COMPLETE'
]);

export const zCiGitRefKind = z.enum(['BRANCH', 'TAG']);

/**
 * ScmGitReference
 */
export const zScmGitReference = z.object({
    type: z.enum(['scmGitReferences']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        canonicalName: z.optional(z.string()),
        isDeleted: z.optional(z.boolean()),
        kind: z.optional(zCiGitRefKind)
    })),
    relationships: z.optional(z.object({
        repository: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['scmRepositories']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * ScmGitReferencesResponse
 */
export const zScmGitReferencesResponse = z.object({
    data: z.array(zScmGitReference),
    included: z.optional(z.array(zScmRepository)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * ScmGitReferenceResponse
 */
export const zScmGitReferenceResponse = z.object({
    data: zScmGitReference,
    included: z.optional(z.array(zScmRepository)),
    links: zDocumentLinks
});

export const zCiGitUser = z.object({
    displayName: z.optional(z.string()),
    avatarUrl: z.optional(z.url())
});

export const zCiIssueCounts = z.object({
    analyzerWarnings: z.optional(z.int()),
    errors: z.optional(z.int()),
    testFailures: z.optional(z.int()),
    warnings: z.optional(z.int())
});

/**
 * CiBuildAction
 */
export const zCiBuildAction = z.object({
    type: z.enum(['ciBuildActions']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        actionType: z.optional(zCiActionType),
        startedDate: z.optional(z.iso.datetime()),
        finishedDate: z.optional(z.iso.datetime()),
        issueCounts: z.optional(zCiIssueCounts),
        executionProgress: z.optional(zCiExecutionProgress),
        completionStatus: z.optional(zCiCompletionStatus),
        isRequiredToPass: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        buildRun: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['ciBuildRuns']),
                id: z.string()
            }))
        })),
        artifacts: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        issues: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        testResults: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * CiBuildRun
 */
export const zCiBuildRun = z.object({
    type: z.enum(['ciBuildRuns']),
    id: z.string(),
    attributes: z.optional(z.object({
        number: z.optional(z.int()),
        createdDate: z.optional(z.iso.datetime()),
        startedDate: z.optional(z.iso.datetime()),
        finishedDate: z.optional(z.iso.datetime()),
        sourceCommit: z.optional(z.object({
            commitSha: z.optional(z.string()),
            message: z.optional(z.string()),
            author: z.optional(zCiGitUser),
            committer: z.optional(zCiGitUser),
            webUrl: z.optional(z.url())
        })),
        destinationCommit: z.optional(z.object({
            commitSha: z.optional(z.string()),
            message: z.optional(z.string()),
            author: z.optional(zCiGitUser),
            committer: z.optional(zCiGitUser),
            webUrl: z.optional(z.url())
        })),
        isPullRequestBuild: z.optional(z.boolean()),
        issueCounts: z.optional(zCiIssueCounts),
        executionProgress: z.optional(zCiExecutionProgress),
        completionStatus: z.optional(zCiCompletionStatus),
        startReason: z.optional(z.enum([
            'GIT_REF_CHANGE',
            'MANUAL',
            'MANUAL_REBUILD',
            'PULL_REQUEST_OPEN',
            'PULL_REQUEST_UPDATE',
            'SCHEDULE'
        ])),
        cancelReason: z.optional(z.enum(['AUTOMATICALLY_BY_NEWER_BUILD', 'MANUALLY_BY_USER']))
    })),
    relationships: z.optional(z.object({
        builds: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['builds']),
                id: z.string()
            })))
        })),
        workflow: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['ciWorkflows']),
                id: z.string()
            }))
        })),
        product: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['ciProducts']),
                id: z.string()
            }))
        })),
        sourceBranchOrTag: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['scmGitReferences']),
                id: z.string()
            }))
        })),
        destinationBranch: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['scmGitReferences']),
                id: z.string()
            }))
        })),
        actions: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        pullRequest: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['scmPullRequests']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * CiBuildActionsResponse
 */
export const zCiBuildActionsResponse = z.object({
    data: z.array(zCiBuildAction),
    included: z.optional(z.array(zCiBuildRun)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * CiBuildActionResponse
 */
export const zCiBuildActionResponse = z.object({
    data: zCiBuildAction,
    included: z.optional(z.array(zCiBuildRun)),
    links: zDocumentLinks
});

export const zCiManualBranchStartCondition = z.object({
    source: z.optional(zCiBranchPatterns)
});

export const zCiManualPullRequestStartCondition = z.object({
    source: z.optional(zCiBranchPatterns),
    destination: z.optional(zCiBranchPatterns)
});

export const zCiScheduledStartCondition = z.object({
    source: z.optional(zCiBranchPatterns),
    schedule: z.optional(z.object({
        frequency: z.optional(z.enum([
            'WEEKLY',
            'DAILY',
            'HOURLY'
        ])),
        days: z.optional(z.array(z.enum([
            'SUNDAY',
            'MONDAY',
            'TUESDAY',
            'WEDNESDAY',
            'THURSDAY',
            'FRIDAY',
            'SATURDAY'
        ]))),
        hour: z.optional(z.int()),
        minute: z.optional(z.int()),
        timezone: z.optional(z.string())
    }))
});

export const zCiStartConditionFileMatcher = z.object({
    directory: z.optional(z.string()),
    fileExtension: z.optional(z.string()),
    fileName: z.optional(z.string())
});

export const zCiFilesAndFoldersRule = z.object({
    mode: z.optional(z.enum(['START_IF_ANY_FILE_MATCHES', 'DO_NOT_START_IF_ALL_FILES_MATCH'])),
    matchers: z.optional(z.array(zCiStartConditionFileMatcher))
});

export const zCiBranchStartCondition = z.object({
    source: z.optional(zCiBranchPatterns),
    filesAndFoldersRule: z.optional(zCiFilesAndFoldersRule),
    autoCancel: z.optional(z.boolean())
});

export const zCiPullRequestStartCondition = z.object({
    source: z.optional(zCiBranchPatterns),
    destination: z.optional(zCiBranchPatterns),
    filesAndFoldersRule: z.optional(zCiFilesAndFoldersRule),
    autoCancel: z.optional(z.boolean())
});

export const zCiTagPatterns = z.object({
    isAllMatch: z.optional(z.boolean()),
    patterns: z.optional(z.array(z.object({
        pattern: z.optional(z.string()),
        isPrefix: z.optional(z.boolean())
    })))
});

export const zCiManualTagStartCondition = z.object({
    source: z.optional(zCiTagPatterns)
});

export const zCiTagStartCondition = z.object({
    source: z.optional(zCiTagPatterns),
    filesAndFoldersRule: z.optional(zCiFilesAndFoldersRule),
    autoCancel: z.optional(z.boolean())
});

export const zCiTestDestinationKind = z.enum(['SIMULATOR', 'MAC']);

/**
 * CiXcodeVersion
 */
export const zCiXcodeVersion = z.object({
    type: z.enum(['ciXcodeVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        version: z.optional(z.string()),
        name: z.optional(z.string()),
        testDestinations: z.optional(z.array(z.object({
            deviceTypeName: z.optional(z.string()),
            deviceTypeIdentifier: z.optional(z.string()),
            availableRuntimes: z.optional(z.array(z.object({
                runtimeName: z.optional(z.string()),
                runtimeIdentifier: z.optional(z.string())
            }))),
            kind: z.optional(zCiTestDestinationKind)
        })))
    })),
    relationships: z.optional(z.object({
        macOsVersions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['ciMacOsVersions']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * CiMacOsVersionsResponse
 */
export const zCiMacOsVersionsResponse = z.object({
    data: z.array(zCiMacOsVersion),
    included: z.optional(z.array(zCiXcodeVersion)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * CiMacOsVersionResponse
 */
export const zCiMacOsVersionResponse = z.object({
    data: zCiMacOsVersion,
    included: z.optional(z.array(zCiXcodeVersion)),
    links: zDocumentLinks
});

/**
 * CiXcodeVersionsResponse
 */
export const zCiXcodeVersionsResponse = z.object({
    data: z.array(zCiXcodeVersion),
    included: z.optional(z.array(zCiMacOsVersion)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * CiXcodeVersionResponse
 */
export const zCiXcodeVersionResponse = z.object({
    data: zCiXcodeVersion,
    included: z.optional(z.array(zCiMacOsVersion)),
    links: zDocumentLinks
});

export const zCiTestDestination = z.object({
    deviceTypeName: z.optional(z.string()),
    deviceTypeIdentifier: z.optional(z.string()),
    runtimeName: z.optional(z.string()),
    runtimeIdentifier: z.optional(z.string()),
    kind: z.optional(zCiTestDestinationKind)
});

export const zCiAction = z.object({
    name: z.optional(z.string()),
    actionType: z.optional(zCiActionType),
    destination: z.optional(z.enum([
        'ANY_IOS_DEVICE',
        'ANY_IOS_SIMULATOR',
        'ANY_TVOS_DEVICE',
        'ANY_TVOS_SIMULATOR',
        'ANY_WATCHOS_DEVICE',
        'ANY_WATCHOS_SIMULATOR',
        'ANY_MAC',
        'ANY_MAC_CATALYST',
        'ANY_VISIONOS_DEVICE',
        'ANY_VISIONOS_SIMULATOR'
    ])),
    buildDistributionAudience: z.optional(zBuildAudienceType),
    testConfiguration: z.optional(z.object({
        kind: z.optional(z.enum(['USE_SCHEME_SETTINGS', 'SPECIFIC_TEST_PLANS'])),
        testPlanName: z.optional(z.string()),
        testDestinations: z.optional(z.array(zCiTestDestination))
    })),
    scheme: z.optional(z.string()),
    platform: z.optional(z.enum([
        'MACOS',
        'IOS',
        'TVOS',
        'WATCHOS',
        'VISIONOS'
    ])),
    isRequiredToPass: z.optional(z.boolean())
});

/**
 * CiWorkflow
 */
export const zCiWorkflow = z.object({
    type: z.enum(['ciWorkflows']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        description: z.optional(z.string()),
        branchStartCondition: z.optional(zCiBranchStartCondition),
        tagStartCondition: z.optional(zCiTagStartCondition),
        pullRequestStartCondition: z.optional(zCiPullRequestStartCondition),
        scheduledStartCondition: z.optional(zCiScheduledStartCondition),
        manualBranchStartCondition: z.optional(zCiManualBranchStartCondition),
        manualTagStartCondition: z.optional(zCiManualTagStartCondition),
        manualPullRequestStartCondition: z.optional(zCiManualPullRequestStartCondition),
        actions: z.optional(z.array(zCiAction)),
        isEnabled: z.optional(z.boolean()),
        isLockedForEditing: z.optional(z.boolean()),
        clean: z.optional(z.boolean()),
        containerFilePath: z.optional(z.string()),
        lastModifiedDate: z.optional(z.iso.datetime())
    })),
    relationships: z.optional(z.object({
        product: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['ciProducts']),
                id: z.string()
            }))
        })),
        repository: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['scmRepositories']),
                id: z.string()
            }))
        })),
        xcodeVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['ciXcodeVersions']),
                id: z.string()
            }))
        })),
        macOsVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['ciMacOsVersions']),
                id: z.string()
            }))
        })),
        buildRuns: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * CiWorkflowsResponse
 */
export const zCiWorkflowsResponse = z.object({
    data: z.array(zCiWorkflow),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('ciMacOsVersions')
        }).and(zCiMacOsVersion),
        z.object({
            type: z.literal('ciProducts')
        }).and(zCiProduct),
        z.object({
            type: z.literal('ciXcodeVersions')
        }).and(zCiXcodeVersion),
        z.object({
            type: z.literal('scmRepositories')
        }).and(zScmRepository)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * CiWorkflowResponse
 */
export const zCiWorkflowResponse = z.object({
    data: zCiWorkflow,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('ciMacOsVersions')
        }).and(zCiMacOsVersion),
        z.object({
            type: z.literal('ciProducts')
        }).and(zCiProduct),
        z.object({
            type: z.literal('ciXcodeVersions')
        }).and(zCiXcodeVersion),
        z.object({
            type: z.literal('scmRepositories')
        }).and(zScmRepository)
    ]))),
    links: zDocumentLinks
});

/**
 * CiWorkflowCreateRequest
 */
export const zCiWorkflowCreateRequest = z.object({
    data: z.object({
        type: z.enum(['ciWorkflows']),
        attributes: z.object({
            name: z.string(),
            description: z.string(),
            branchStartCondition: z.optional(zCiBranchStartCondition),
            tagStartCondition: z.optional(zCiTagStartCondition),
            pullRequestStartCondition: z.optional(zCiPullRequestStartCondition),
            scheduledStartCondition: z.optional(zCiScheduledStartCondition),
            manualBranchStartCondition: z.optional(zCiManualBranchStartCondition),
            manualTagStartCondition: z.optional(zCiManualTagStartCondition),
            manualPullRequestStartCondition: z.optional(zCiManualPullRequestStartCondition),
            actions: z.array(zCiAction),
            isEnabled: z.boolean(),
            isLockedForEditing: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            clean: z.boolean(),
            containerFilePath: z.string()
        }),
        relationships: z.object({
            product: z.object({
                data: z.object({
                    type: z.enum(['ciProducts']),
                    id: z.string()
                })
            }),
            repository: z.object({
                data: z.object({
                    type: z.enum(['scmRepositories']),
                    id: z.string()
                })
            }),
            xcodeVersion: z.object({
                data: z.object({
                    type: z.enum(['ciXcodeVersions']),
                    id: z.string()
                })
            }),
            macOsVersion: z.object({
                data: z.object({
                    type: z.enum(['ciMacOsVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * CiWorkflowUpdateRequest
 */
export const zCiWorkflowUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['ciWorkflows']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            branchStartCondition: z.optional(zCiBranchStartCondition),
            tagStartCondition: z.optional(zCiTagStartCondition),
            pullRequestStartCondition: z.optional(zCiPullRequestStartCondition),
            scheduledStartCondition: z.optional(zCiScheduledStartCondition),
            manualBranchStartCondition: z.optional(zCiManualBranchStartCondition),
            manualTagStartCondition: z.optional(zCiManualTagStartCondition),
            manualPullRequestStartCondition: z.optional(zCiManualPullRequestStartCondition),
            actions: z.optional(z.union([
                z.array(zCiAction),
                z.null()
            ])),
            isEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            isLockedForEditing: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            clean: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            containerFilePath: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        })),
        relationships: z.optional(z.object({
            xcodeVersion: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['ciXcodeVersions']),
                    id: z.string()
                }))
            })),
            macOsVersion: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['ciMacOsVersions']),
                    id: z.string()
                }))
            }))
        }))
    })
});

export const zCiTestStatus = z.enum([
    'SUCCESS',
    'FAILURE',
    'MIXED',
    'SKIPPED',
    'EXPECTED_FAILURE'
]);

export const zDeviceConnectionType = z.enum([
    'WIFI',
    'MOBILE_DATA',
    'WIRE',
    'UNKNOWN',
    'NONE'
]);

export const zDeviceFamily = z.enum([
    'IPHONE',
    'IPAD',
    'APPLE_TV',
    'APPLE_WATCH',
    'MAC',
    'VISION'
]);

/**
 * AccessibilityDeclaration
 */
export const zAccessibilityDeclaration = z.object({
    type: z.enum(['accessibilityDeclarations']),
    id: z.string(),
    attributes: z.optional(z.object({
        deviceFamily: z.optional(zDeviceFamily),
        state: z.optional(z.enum([
            'DRAFT',
            'PUBLISHED',
            'REPLACED'
        ])),
        supportsAudioDescriptions: z.optional(z.boolean()),
        supportsCaptions: z.optional(z.boolean()),
        supportsDarkInterface: z.optional(z.boolean()),
        supportsDifferentiateWithoutColorAlone: z.optional(z.boolean()),
        supportsLargerText: z.optional(z.boolean()),
        supportsReducedMotion: z.optional(z.boolean()),
        supportsSufficientContrast: z.optional(z.boolean()),
        supportsVoiceControl: z.optional(z.boolean()),
        supportsVoiceover: z.optional(z.boolean())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AccessibilityDeclarationsResponse
 */
export const zAccessibilityDeclarationsResponse = z.object({
    data: z.array(zAccessibilityDeclaration),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AccessibilityDeclarationResponse
 */
export const zAccessibilityDeclarationResponse = z.object({
    data: zAccessibilityDeclaration,
    links: zDocumentLinks
});

/**
 * AccessibilityDeclarationCreateRequest
 */
export const zAccessibilityDeclarationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['accessibilityDeclarations']),
        attributes: z.object({
            deviceFamily: zDeviceFamily,
            supportsAudioDescriptions: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsCaptions: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsDarkInterface: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsDifferentiateWithoutColorAlone: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsLargerText: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsReducedMotion: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsSufficientContrast: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsVoiceControl: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            supportsVoiceover: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BetaRecruitmentCriterionOption
 */
export const zBetaRecruitmentCriterionOption = z.object({
    type: z.enum(['betaRecruitmentCriterionOptions']),
    id: z.string(),
    attributes: z.optional(z.object({
        deviceFamilyOsVersions: z.optional(z.array(z.object({
            deviceFamily: z.optional(zDeviceFamily),
            osVersions: z.optional(z.array(z.string()))
        })))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaRecruitmentCriterionOptionsResponse
 */
export const zBetaRecruitmentCriterionOptionsResponse = z.object({
    data: z.array(zBetaRecruitmentCriterionOption),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * Nomination
 */
export const zNomination = z.object({
    type: z.enum(['nominations']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        type: z.optional(z.enum([
            'APP_LAUNCH',
            'APP_ENHANCEMENTS',
            'NEW_CONTENT'
        ])),
        description: z.optional(z.string()),
        createdDate: z.optional(z.iso.datetime()),
        lastModifiedDate: z.optional(z.iso.datetime()),
        submittedDate: z.optional(z.iso.datetime()),
        state: z.optional(z.enum([
            'DRAFT',
            'SUBMITTED',
            'ARCHIVED'
        ])),
        publishStartDate: z.optional(z.iso.datetime()),
        publishEndDate: z.optional(z.iso.datetime()),
        deviceFamilies: z.optional(z.array(zDeviceFamily)),
        locales: z.optional(z.array(z.string())),
        supplementalMaterialsUris: z.optional(z.array(z.url())),
        hasInAppEvents: z.optional(z.boolean()),
        launchInSelectMarketsFirst: z.optional(z.boolean()),
        notes: z.optional(z.string()),
        preOrderEnabled: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        relatedApps: z.optional(z.object({
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['apps']),
                id: z.string()
            })))
        })),
        createdByActor: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['actors']),
                id: z.string()
            }))
        })),
        lastModifiedByActor: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['actors']),
                id: z.string()
            }))
        })),
        submittedByActor: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['actors']),
                id: z.string()
            }))
        })),
        inAppEvents: z.optional(z.object({
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appEvents']),
                id: z.string()
            })))
        })),
        supportedTerritories: z.optional(z.object({
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['territories']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * NominationCreateRequest
 */
export const zNominationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['nominations']),
        attributes: z.object({
            name: z.string(),
            type: z.enum([
                'APP_LAUNCH',
                'APP_ENHANCEMENTS',
                'NEW_CONTENT'
            ]),
            description: z.string(),
            submitted: z.boolean(),
            publishStartDate: z.iso.datetime(),
            publishEndDate: z.optional(z.union([
                z.iso.datetime(),
                z.null()
            ])),
            deviceFamilies: z.optional(z.union([
                z.array(zDeviceFamily),
                z.null()
            ])),
            locales: z.optional(z.union([
                z.array(z.string()),
                z.null()
            ])),
            supplementalMaterialsUris: z.optional(z.union([
                z.array(z.url()),
                z.null()
            ])),
            hasInAppEvents: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            launchInSelectMarketsFirst: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            notes: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            preOrderEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }),
        relationships: z.object({
            relatedApps: z.object({
                data: z.array(z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                }))
            }),
            inAppEvents: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['appEvents']),
                    id: z.string()
                })))
            })),
            supportedTerritories: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['territories']),
                    id: z.string()
                })))
            }))
        })
    })
});

/**
 * NominationUpdateRequest
 */
export const zNominationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['nominations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            type: z.optional(z.enum([
                'APP_LAUNCH',
                'APP_ENHANCEMENTS',
                'NEW_CONTENT'
            ])),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            submitted: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            archived: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            publishStartDate: z.optional(z.union([
                z.iso.datetime(),
                z.null()
            ])),
            publishEndDate: z.optional(z.union([
                z.iso.datetime(),
                z.null()
            ])),
            deviceFamilies: z.optional(z.union([
                z.array(zDeviceFamily),
                z.null()
            ])),
            locales: z.optional(z.union([
                z.array(z.string()),
                z.null()
            ])),
            supplementalMaterialsUris: z.optional(z.union([
                z.array(z.url()),
                z.null()
            ])),
            hasInAppEvents: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            launchInSelectMarketsFirst: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            notes: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            preOrderEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        })),
        relationships: z.optional(z.object({
            relatedApps: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })))
            })),
            inAppEvents: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['appEvents']),
                    id: z.string()
                })))
            })),
            supportedTerritories: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['territories']),
                    id: z.string()
                })))
            }))
        }))
    })
});

export const zDeviceFamilyOsVersionFilter = z.object({
    deviceFamily: z.optional(zDeviceFamily),
    minimumOsInclusive: z.optional(z.string()),
    maximumOsInclusive: z.optional(z.string())
});

/**
 * BetaRecruitmentCriterion
 */
export const zBetaRecruitmentCriterion = z.object({
    type: z.enum(['betaRecruitmentCriteria']),
    id: z.string(),
    attributes: z.optional(z.object({
        lastModifiedDate: z.optional(z.iso.datetime()),
        deviceFamilyOsVersionFilters: z.optional(z.array(zDeviceFamilyOsVersionFilter))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaRecruitmentCriterionResponse
 */
export const zBetaRecruitmentCriterionResponse = z.object({
    data: zBetaRecruitmentCriterion,
    links: zDocumentLinks
});

/**
 * BetaRecruitmentCriterionCreateRequest
 */
export const zBetaRecruitmentCriterionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['betaRecruitmentCriteria']),
        attributes: z.object({
            deviceFamilyOsVersionFilters: z.array(zDeviceFamilyOsVersionFilter)
        }),
        relationships: z.object({
            betaGroup: z.object({
                data: z.object({
                    type: z.enum(['betaGroups']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * BetaRecruitmentCriterionUpdateRequest
 */
export const zBetaRecruitmentCriterionUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['betaRecruitmentCriteria']),
        id: z.string(),
        attributes: z.optional(z.object({
            deviceFamilyOsVersionFilters: z.optional(z.union([
                z.array(zDeviceFamilyOsVersionFilter),
                z.null()
            ]))
        }))
    })
});

export const zDiagnosticInsightDirection = z.enum([
    'UP',
    'DOWN',
    'UNDEFINED'
]);

export const zDiagnosticInsightType = z.enum(['TREND']);

export const zDiagnosticInsight = z.object({
    insightType: z.optional(zDiagnosticInsightType),
    direction: z.optional(zDiagnosticInsightDirection),
    referenceVersions: z.optional(z.array(z.object({
        version: z.optional(z.string()),
        value: z.optional(z.number())
    })))
});

/**
 * DiagnosticSignature
 */
export const zDiagnosticSignature = z.object({
    type: z.enum(['diagnosticSignatures']),
    id: z.string(),
    attributes: z.optional(z.object({
        diagnosticType: z.optional(z.enum([
            'DISK_WRITES',
            'HANGS',
            'LAUNCHES'
        ])),
        signature: z.optional(z.string()),
        weight: z.optional(z.number()),
        insight: z.optional(zDiagnosticInsight)
    })),
    relationships: z.optional(z.object({
        logs: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * DiagnosticSignaturesResponse
 */
export const zDiagnosticSignaturesResponse = z.object({
    data: z.array(zDiagnosticSignature),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zDiagnosticLogCallStackNode = z.object({
    sampleCount: z.optional(z.int()),
    isBlameFrame: z.optional(z.boolean()),
    symbolName: z.optional(z.string()),
    insightsCategory: z.optional(z.string()),
    offsetIntoSymbol: z.optional(z.string()),
    binaryName: z.optional(z.string()),
    fileName: z.optional(z.string()),
    binaryUUID: z.optional(z.string()),
    lineNumber: z.optional(z.string()),
    address: z.optional(z.string()),
    offsetIntoBinaryTextSegment: z.optional(z.string()),
    rawFrame: z.optional(z.string()),
    get subFrames() {
        return z.optional(z.array(z.lazy((): any => zDiagnosticLogCallStackNode)));
    }
});

export const zExternalBetaState = z.enum([
    'PROCESSING',
    'PROCESSING_EXCEPTION',
    'MISSING_EXPORT_COMPLIANCE',
    'READY_FOR_BETA_TESTING',
    'IN_BETA_TESTING',
    'EXPIRED',
    'READY_FOR_BETA_SUBMISSION',
    'IN_EXPORT_COMPLIANCE_REVIEW',
    'WAITING_FOR_BETA_REVIEW',
    'IN_BETA_REVIEW',
    'BETA_REJECTED',
    'BETA_APPROVED',
    'NOT_APPLICABLE'
]);

export const zFileLocation = z.object({
    path: z.optional(z.string()),
    lineNumber: z.optional(z.int())
});

/**
 * CiIssue
 */
export const zCiIssue = z.object({
    type: z.enum(['ciIssues']),
    id: z.string(),
    attributes: z.optional(z.object({
        issueType: z.optional(z.enum([
            'ANALYZER_WARNING',
            'ERROR',
            'TEST_FAILURE',
            'WARNING'
        ])),
        message: z.optional(z.string()),
        fileSource: z.optional(zFileLocation),
        category: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * CiIssuesResponse
 */
export const zCiIssuesResponse = z.object({
    data: z.array(zCiIssue),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * CiIssueResponse
 */
export const zCiIssueResponse = z.object({
    data: zCiIssue,
    links: zDocumentLinks
});

/**
 * CiTestResult
 */
export const zCiTestResult = z.object({
    type: z.enum(['ciTestResults']),
    id: z.string(),
    attributes: z.optional(z.object({
        className: z.optional(z.string()),
        name: z.optional(z.string()),
        status: z.optional(zCiTestStatus),
        fileSource: z.optional(zFileLocation),
        message: z.optional(z.string()),
        destinationTestResults: z.optional(z.array(z.object({
            uuid: z.optional(z.string()),
            deviceName: z.optional(z.string()),
            osVersion: z.optional(z.string()),
            status: z.optional(zCiTestStatus),
            duration: z.optional(z.number())
        })))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * CiTestResultsResponse
 */
export const zCiTestResultsResponse = z.object({
    data: z.array(zCiTestResult),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * CiTestResultResponse
 */
export const zCiTestResultResponse = z.object({
    data: zCiTestResult,
    links: zDocumentLinks
});

export const zGameCenterLeaderboardFormatter = z.enum([
    'INTEGER',
    'DECIMAL_POINT_1_PLACE',
    'DECIMAL_POINT_2_PLACE',
    'DECIMAL_POINT_3_PLACE',
    'ELAPSED_TIME_CENTISECOND',
    'ELAPSED_TIME_MINUTE',
    'ELAPSED_TIME_SECOND',
    'MONEY_POUND_DECIMAL',
    'MONEY_POUND',
    'MONEY_DOLLAR_DECIMAL',
    'MONEY_DOLLAR',
    'MONEY_EURO_DECIMAL',
    'MONEY_EURO',
    'MONEY_FRANC_DECIMAL',
    'MONEY_FRANC',
    'MONEY_KRONER_DECIMAL',
    'MONEY_KRONER',
    'MONEY_YEN'
]);

/**
 * GameCenterLeaderboardLocalization
 */
export const zGameCenterLeaderboardLocalization = z.object({
    type: z.enum(['gameCenterLeaderboardLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string()),
        name: z.optional(z.string()),
        formatterOverride: z.optional(zGameCenterLeaderboardFormatter),
        formatterSuffix: z.optional(z.string()),
        formatterSuffixSingular: z.optional(z.string()),
        description: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        gameCenterLeaderboard: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            }))
        })),
        gameCenterLeaderboardImage: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardImages']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardLocalizationCreateRequest
 */
export const zGameCenterLeaderboardLocalizationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardLocalizations']),
        attributes: z.object({
            locale: z.string(),
            name: z.string(),
            formatterOverride: z.optional(zGameCenterLeaderboardFormatter),
            formatterSuffix: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            formatterSuffixSingular: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.object({
            gameCenterLeaderboard: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboards']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterLeaderboardLocalizationUpdateRequest
 */
export const zGameCenterLeaderboardLocalizationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            formatterOverride: z.optional(zGameCenterLeaderboardFormatter),
            formatterSuffix: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            formatterSuffixSingular: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

/**
 * GameCenterLeaderboardLocalizationV2
 */
export const zGameCenterLeaderboardLocalizationV2 = z.object({
    type: z.enum(['gameCenterLeaderboardLocalizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        locale: z.optional(z.string()),
        name: z.optional(z.string()),
        formatterOverride: z.optional(zGameCenterLeaderboardFormatter),
        formatterSuffix: z.optional(z.string()),
        formatterSuffixSingular: z.optional(z.string()),
        description: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        version: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardVersions']),
                id: z.string()
            }))
        })),
        image: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardImages']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardLocalizationV2CreateRequest
 */
export const zGameCenterLeaderboardLocalizationV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardLocalizations']),
        attributes: z.object({
            locale: z.string(),
            name: z.string(),
            formatterOverride: z.optional(zGameCenterLeaderboardFormatter),
            formatterSuffix: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            formatterSuffixSingular: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }),
        relationships: z.object({
            version: z.object({
                data: z.object({
                    type: z.enum(['gameCenterLeaderboardVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * GameCenterLeaderboardLocalizationV2UpdateRequest
 */
export const zGameCenterLeaderboardLocalizationV2UpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboardLocalizations']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            formatterOverride: z.optional(zGameCenterLeaderboardFormatter),
            formatterSuffix: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            formatterSuffixSingular: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            description: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        }))
    })
});

export const zGameCenterMatchmakingTeamAssignment = z.object({
    playerId: z.optional(z.string()),
    team: z.optional(z.string())
});

/**
 * GameCenterMatchmakingRuleSetTest
 */
export const zGameCenterMatchmakingRuleSetTest = z.object({
    type: z.enum(['gameCenterMatchmakingRuleSetTests']),
    id: z.string(),
    attributes: z.optional(z.object({
        matchmakingResults: z.optional(z.array(z.array(z.object({
            requestName: z.optional(z.string()),
            teamAssignments: z.optional(z.array(zGameCenterMatchmakingTeamAssignment))
        }))))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterMatchmakingRuleSetTestResponse
 */
export const zGameCenterMatchmakingRuleSetTestResponse = z.object({
    data: zGameCenterMatchmakingRuleSetTest,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterMatchmakingTestPlayerProperties')
        }).and(zGameCenterMatchmakingTestPlayerProperty), z.object({
            type: z.literal('gameCenterMatchmakingTestRequests')
        }).and(zGameCenterMatchmakingTestRequest)]))),
    links: zDocumentLinks
});

export const zGameCenterVersionState = z.enum([
    'PREPARE_FOR_SUBMISSION',
    'READY_FOR_REVIEW',
    'WAITING_FOR_REVIEW',
    'IN_REVIEW',
    'DEVELOPER_REJECTED',
    'REJECTED',
    'ACCEPTED',
    'PENDING_RELEASE',
    'LIVE',
    'REPLACED_WITH_NEW_VERSION'
]);

/**
 * GameCenterAchievementVersionV2
 */
export const zGameCenterAchievementVersionV2 = z.object({
    type: z.enum(['gameCenterAchievementVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        version: z.optional(z.int()),
        state: z.optional(zGameCenterVersionState)
    })),
    relationships: z.optional(z.object({
        achievement: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterAchievements']),
                id: z.string()
            }))
        })),
        localizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAchievementLocalizations']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterActivityVersion
 */
export const zGameCenterActivityVersion = z.object({
    type: z.enum(['gameCenterActivityVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        version: z.optional(z.int()),
        state: z.optional(zGameCenterVersionState),
        fallbackUrl: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        activity: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterActivities']),
                id: z.string()
            }))
        })),
        localizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterActivityLocalizations']),
                id: z.string()
            })))
        })),
        defaultImage: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterActivityImages']),
                id: z.string()
            }))
        })),
        releases: z.optional(z.object({
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterActivityVersionReleases']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterActivityVersionReleasesResponse
 */
export const zGameCenterActivityVersionReleasesResponse = z.object({
    data: z.array(zGameCenterActivityVersionRelease),
    included: z.optional(z.array(zGameCenterActivityVersion)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterActivityVersionReleaseResponse
 */
export const zGameCenterActivityVersionReleaseResponse = z.object({
    data: zGameCenterActivityVersionRelease,
    included: z.optional(z.array(zGameCenterActivityVersion)),
    links: zDocumentLinks
});

/**
 * GameCenterChallengeVersion
 */
export const zGameCenterChallengeVersion = z.object({
    type: z.enum(['gameCenterChallengeVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        version: z.optional(z.int()),
        state: z.optional(zGameCenterVersionState)
    })),
    relationships: z.optional(z.object({
        challenge: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterChallenges']),
                id: z.string()
            }))
        })),
        localizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterChallengeLocalizations']),
                id: z.string()
            })))
        })),
        releases: z.optional(z.object({
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterChallengeVersionReleases']),
                id: z.string()
            })))
        })),
        defaultImage: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterChallengeImages']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterChallengeVersionReleasesResponse
 */
export const zGameCenterChallengeVersionReleasesResponse = z.object({
    data: z.array(zGameCenterChallengeVersionRelease),
    included: z.optional(z.array(zGameCenterChallengeVersion)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterChallengeVersionReleaseResponse
 */
export const zGameCenterChallengeVersionReleaseResponse = z.object({
    data: zGameCenterChallengeVersionRelease,
    included: z.optional(z.array(zGameCenterChallengeVersion)),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardSetVersionV2
 */
export const zGameCenterLeaderboardSetVersionV2 = z.object({
    type: z.enum(['gameCenterLeaderboardSetVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        version: z.optional(z.int()),
        state: z.optional(zGameCenterVersionState)
    })),
    relationships: z.optional(z.object({
        leaderboardSet: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardSets']),
                id: z.string()
            }))
        })),
        localizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardSetLocalizations']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardSetVersionsV2Response
 */
export const zGameCenterLeaderboardSetVersionsV2Response = z.object({
    data: z.array(zGameCenterLeaderboardSetVersionV2),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardSetLocalizations')
        }).and(zGameCenterLeaderboardSetLocalizationV2), z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSetV2)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardSetVersionV2Response
 */
export const zGameCenterLeaderboardSetVersionV2Response = z.object({
    data: zGameCenterLeaderboardSetVersionV2,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardSetLocalizations')
        }).and(zGameCenterLeaderboardSetLocalizationV2), z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSetV2)]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardVersionV2
 */
export const zGameCenterLeaderboardVersionV2 = z.object({
    type: z.enum(['gameCenterLeaderboardVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        version: z.optional(z.int()),
        state: z.optional(zGameCenterVersionState)
    })),
    relationships: z.optional(z.object({
        leaderboard: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            }))
        })),
        localizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardLocalizations']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

export const zHttpHeader = z.object({
    name: z.optional(z.string()),
    value: z.optional(z.string())
});

export const zDeliveryFileUploadOperation = z.object({
    method: z.optional(z.string()),
    url: z.optional(z.string()),
    length: z.optional(z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991))),
    offset: z.optional(z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991))),
    requestHeaders: z.optional(z.array(zHttpHeader)),
    expiration: z.optional(z.iso.datetime()),
    partNumber: z.optional(z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991))),
    entityTag: z.optional(z.string())
});

/**
 * BackgroundAssetUploadFile
 */
export const zBackgroundAssetUploadFile = z.object({
    type: z.enum(['backgroundAssetUploadFiles']),
    id: z.string(),
    attributes: z.optional(z.object({
        assetDeliveryState: z.optional(zAppMediaAssetState),
        assetToken: z.optional(z.string()),
        assetType: z.optional(z.enum(['ASSET', 'MANIFEST'])),
        fileName: z.optional(z.string()),
        fileSize: z.optional(z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991))),
        sourceFileChecksum: z.optional(z.string()),
        sourceFileChecksums: z.optional(zChecksums),
        uploadOperations: z.optional(z.array(zDeliveryFileUploadOperation))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BackgroundAssetUploadFilesResponse
 */
export const zBackgroundAssetUploadFilesResponse = z.object({
    data: z.array(zBackgroundAssetUploadFile),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BackgroundAssetUploadFileResponse
 */
export const zBackgroundAssetUploadFileResponse = z.object({
    data: zBackgroundAssetUploadFile,
    links: zDocumentLinks
});

/**
 * BuildUploadFile
 */
export const zBuildUploadFile = z.object({
    type: z.enum(['buildUploadFiles']),
    id: z.string(),
    attributes: z.optional(z.object({
        assetDeliveryState: z.optional(zAppMediaAssetState),
        assetToken: z.optional(z.string()),
        assetType: z.optional(z.enum([
            'ASSET',
            'ASSET_DESCRIPTION',
            'ASSET_SPI'
        ])),
        fileName: z.optional(z.string()),
        fileSize: z.optional(z.coerce.bigint().gte(BigInt(1)).lte(BigInt(9007199254740991))),
        sourceFileChecksums: z.optional(zChecksums),
        uploadOperations: z.optional(z.array(zDeliveryFileUploadOperation)),
        uti: z.optional(z.enum([
            'com.apple.binary-property-list',
            'com.apple.ipa',
            'com.apple.pkg',
            'com.apple.xml-property-list',
            'com.pkware.zip-archive'
        ]))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BuildUploadFilesResponse
 */
export const zBuildUploadFilesResponse = z.object({
    data: z.array(zBuildUploadFile),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BuildUploadFileResponse
 */
export const zBuildUploadFileResponse = z.object({
    data: zBuildUploadFile,
    links: zDocumentLinks
});

export const zIconAssetType = z.enum([
    'APP_STORE',
    'MESSAGES_APP_STORE',
    'WATCH_APP_STORE',
    'TV_OS_HOME_SCREEN',
    'TV_OS_TOP_SHELF',
    'ALTERNATE_EXPERIMENT'
]);

export const zImageAsset = z.object({
    templateUrl: z.optional(z.string()),
    width: z.optional(z.int()),
    height: z.optional(z.int())
});

/**
 * AppStoreVersionExperimentTreatment
 */
export const zAppStoreVersionExperimentTreatment = z.object({
    type: z.enum(['appStoreVersionExperimentTreatments']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        appIcon: z.optional(zImageAsset),
        appIconName: z.optional(z.string()),
        promotedDate: z.optional(z.iso.datetime())
    })),
    relationships: z.optional(z.object({
        appStoreVersionExperiment: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersionExperiments']),
                id: z.string()
            }))
        })),
        appStoreVersionExperimentV2: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersionExperiments']),
                id: z.string()
            }))
        })),
        appStoreVersionExperimentTreatmentLocalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appStoreVersionExperimentTreatmentLocalizations']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppStoreVersionExperimentTreatmentsResponse
 */
export const zAppStoreVersionExperimentTreatmentsResponse = z.object({
    data: z.array(zAppStoreVersionExperimentTreatment),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appStoreVersionExperimentTreatmentLocalizations')
        }).and(zAppStoreVersionExperimentTreatmentLocalization), z.object({
            type: z.literal('appStoreVersionExperiments')
        }).and(zAppStoreVersionExperiment)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppStoreVersionExperimentTreatmentResponse
 */
export const zAppStoreVersionExperimentTreatmentResponse = z.object({
    data: zAppStoreVersionExperimentTreatment,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appStoreVersionExperimentTreatmentLocalizations')
        }).and(zAppStoreVersionExperimentTreatmentLocalization), z.object({
            type: z.literal('appStoreVersionExperiments')
        }).and(zAppStoreVersionExperiment)]))),
    links: zDocumentLinks
});

/**
 * BuildIcon
 */
export const zBuildIcon = z.object({
    type: z.enum(['buildIcons']),
    id: z.string(),
    attributes: z.optional(z.object({
        iconAsset: z.optional(zImageAsset),
        iconType: z.optional(zIconAssetType),
        masked: z.optional(z.boolean()),
        name: z.optional(z.string())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BuildIconsResponse
 */
export const zBuildIconsResponse = z.object({
    data: z.array(zBuildIcon),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * Build
 */
export const zBuild = z.object({
    type: z.enum(['builds']),
    id: z.string(),
    attributes: z.optional(z.object({
        version: z.optional(z.string()),
        uploadedDate: z.optional(z.iso.datetime()),
        expirationDate: z.optional(z.iso.datetime()),
        expired: z.optional(z.boolean()),
        minOsVersion: z.optional(z.string()),
        lsMinimumSystemVersion: z.optional(z.string()),
        computedMinMacOsVersion: z.optional(z.string()),
        computedMinVisionOsVersion: z.optional(z.string()),
        iconAssetToken: z.optional(zImageAsset),
        processingState: z.optional(z.enum([
            'PROCESSING',
            'FAILED',
            'INVALID',
            'VALID'
        ])),
        buildAudienceType: z.optional(zBuildAudienceType),
        usesNonExemptEncryption: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        preReleaseVersion: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['preReleaseVersions']),
                id: z.string()
            }))
        })),
        individualTesters: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['betaTesters']),
                id: z.string()
            })))
        })),
        betaGroups: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['betaGroups']),
                id: z.string()
            })))
        })),
        betaBuildLocalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['betaBuildLocalizations']),
                id: z.string()
            })))
        })),
        appEncryptionDeclaration: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appEncryptionDeclarations']),
                id: z.string()
            }))
        })),
        betaAppReviewSubmission: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['betaAppReviewSubmissions']),
                id: z.string()
            }))
        })),
        app: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        buildBetaDetail: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['buildBetaDetails']),
                id: z.string()
            }))
        })),
        appStoreVersion: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            }))
        })),
        icons: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['buildIcons']),
                id: z.string()
            })))
        })),
        buildBundles: z.optional(z.object({
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['buildBundles']),
                id: z.string()
            })))
        })),
        buildUpload: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['buildUploads']),
                id: z.string()
            }))
        })),
        perfPowerMetrics: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        diagnosticSignatures: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaAppReviewSubmissionsResponse
 */
export const zBetaAppReviewSubmissionsResponse = z.object({
    data: z.array(zBetaAppReviewSubmission),
    included: z.optional(z.array(zBuild)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaAppReviewSubmissionResponse
 */
export const zBetaAppReviewSubmissionResponse = z.object({
    data: zBetaAppReviewSubmission,
    included: z.optional(z.array(zBuild)),
    links: zDocumentLinks
});

/**
 * BetaBuildLocalizationsResponse
 */
export const zBetaBuildLocalizationsResponse = z.object({
    data: z.array(zBetaBuildLocalization),
    included: z.optional(z.array(zBuild)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaBuildLocalizationResponse
 */
export const zBetaBuildLocalizationResponse = z.object({
    data: zBetaBuildLocalization,
    included: z.optional(z.array(zBuild)),
    links: zDocumentLinks
});

/**
 * CiBuildRunsResponse
 */
export const zCiBuildRunsResponse = z.object({
    data: z.array(zCiBuildRun),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('builds')
        }).and(zBuild),
        z.object({
            type: z.literal('ciProducts')
        }).and(zCiProduct),
        z.object({
            type: z.literal('ciWorkflows')
        }).and(zCiWorkflow),
        z.object({
            type: z.literal('scmGitReferences')
        }).and(zScmGitReference),
        z.object({
            type: z.literal('scmPullRequests')
        }).and(zScmPullRequest)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * CiBuildRunResponse
 */
export const zCiBuildRunResponse = z.object({
    data: zCiBuildRun,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('builds')
        }).and(zBuild),
        z.object({
            type: z.literal('ciProducts')
        }).and(zCiProduct),
        z.object({
            type: z.literal('ciWorkflows')
        }).and(zCiWorkflow),
        z.object({
            type: z.literal('scmGitReferences')
        }).and(zScmGitReference),
        z.object({
            type: z.literal('scmPullRequests')
        }).and(zScmPullRequest)
    ]))),
    links: zDocumentLinks
});

/**
 * BuildWithoutIncludesResponse
 */
export const zBuildWithoutIncludesResponse = z.object({
    data: zBuild,
    links: zDocumentLinks
});

/**
 * BuildsWithoutIncludesResponse
 */
export const zBuildsWithoutIncludesResponse = z.object({
    data: z.array(zBuild),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BuildIconsWithoutIncludesResponse
 */
export const zBuildIconsWithoutIncludesResponse = z.object({
    data: z.array(zBuildIcon),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zInAppPurchaseState = z.enum([
    'MISSING_METADATA',
    'WAITING_FOR_UPLOAD',
    'PROCESSING_CONTENT',
    'READY_TO_SUBMIT',
    'WAITING_FOR_REVIEW',
    'IN_REVIEW',
    'DEVELOPER_ACTION_NEEDED',
    'PENDING_BINARY_APPROVAL',
    'APPROVED',
    'DEVELOPER_REMOVED_FROM_SALE',
    'REMOVED_FROM_SALE',
    'REJECTED'
]);

export const zInAppPurchaseType = z.enum([
    'CONSUMABLE',
    'NON_CONSUMABLE',
    'NON_RENEWING_SUBSCRIPTION'
]);

/**
 * InAppPurchaseV2
 */
export const zInAppPurchaseV2 = z.object({
    type: z.enum(['inAppPurchases']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        productId: z.optional(z.string()),
        inAppPurchaseType: z.optional(zInAppPurchaseType),
        state: z.optional(zInAppPurchaseState),
        reviewNote: z.optional(z.string()),
        familySharable: z.optional(z.boolean()),
        contentHosting: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        inAppPurchaseLocalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['inAppPurchaseLocalizations']),
                id: z.string()
            })))
        })),
        pricePoints: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['inAppPurchasePricePoints']),
                id: z.string()
            })))
        })),
        content: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['inAppPurchaseContents']),
                id: z.string()
            }))
        })),
        appStoreReviewScreenshot: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['inAppPurchaseAppStoreReviewScreenshots']),
                id: z.string()
            }))
        })),
        promotedPurchase: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['promotedPurchases']),
                id: z.string()
            }))
        })),
        iapPriceSchedule: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['inAppPurchasePriceSchedules']),
                id: z.string()
            }))
        })),
        inAppPurchaseAvailability: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['inAppPurchaseAvailabilities']),
                id: z.string()
            }))
        })),
        images: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['inAppPurchaseImages']),
                id: z.string()
            })))
        })),
        offerCodes: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['inAppPurchaseOfferCodes']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchaseContentResponse
 */
export const zInAppPurchaseContentResponse = z.object({
    data: zInAppPurchaseContent,
    included: z.optional(z.array(zInAppPurchaseV2)),
    links: zDocumentLinks
});

/**
 * InAppPurchaseLocalizationsResponse
 */
export const zInAppPurchaseLocalizationsResponse = z.object({
    data: z.array(zInAppPurchaseLocalization),
    included: z.optional(z.array(zInAppPurchaseV2)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * InAppPurchaseLocalizationResponse
 */
export const zInAppPurchaseLocalizationResponse = z.object({
    data: zInAppPurchaseLocalization,
    included: z.optional(z.array(zInAppPurchaseV2)),
    links: zDocumentLinks
});

/**
 * InAppPurchaseSubmissionResponse
 */
export const zInAppPurchaseSubmissionResponse = z.object({
    data: zInAppPurchaseSubmission,
    included: z.optional(z.array(zInAppPurchaseV2)),
    links: zDocumentLinks
});

/**
 * InAppPurchaseV2CreateRequest
 */
export const zInAppPurchaseV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchases']),
        attributes: z.object({
            name: z.string(),
            productId: z.string(),
            inAppPurchaseType: zInAppPurchaseType,
            reviewNote: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            familySharable: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * PromotedPurchasesResponse
 */
export const zPromotedPurchasesResponse = z.object({
    data: z.array(zPromotedPurchase),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('inAppPurchases')
        }).and(zInAppPurchaseV2), z.object({
            type: z.literal('subscriptions')
        }).and(zSubscription)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * PromotedPurchaseResponse
 */
export const zPromotedPurchaseResponse = z.object({
    data: zPromotedPurchase,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('inAppPurchases')
        }).and(zInAppPurchaseV2), z.object({
            type: z.literal('subscriptions')
        }).and(zSubscription)]))),
    links: zDocumentLinks
});

export const zIntegerRange = z.object({
    minimum: z.optional(z.int()),
    maximum: z.optional(z.int())
});

/**
 * WinBackOfferUpdateRequest
 */
export const zWinBackOfferUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['winBackOffers']),
        id: z.string(),
        attributes: z.optional(z.object({
            customerEligibilityPaidSubscriptionDurationInMonths: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            customerEligibilityTimeSinceLastSubscribedInMonths: z.optional(zIntegerRange),
            customerEligibilityWaitBetweenOffersInMonths: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            startDate: z.optional(z.union([
                z.iso.date(),
                z.null()
            ])),
            endDate: z.optional(z.union([
                z.iso.date(),
                z.null()
            ])),
            priority: z.optional(z.enum(['HIGH', 'NORMAL'])),
            promotionIntent: z.optional(z.enum(['NOT_PROMOTED', 'USE_AUTO_GENERATED_ASSETS']))
        }))
    })
});

export const zInternalBetaState = z.enum([
    'PROCESSING',
    'PROCESSING_EXCEPTION',
    'MISSING_EXPORT_COMPLIANCE',
    'READY_FOR_BETA_TESTING',
    'IN_BETA_TESTING',
    'EXPIRED',
    'IN_EXPORT_COMPLIANCE_REVIEW'
]);

/**
 * BuildBetaDetail
 */
export const zBuildBetaDetail = z.object({
    type: z.enum(['buildBetaDetails']),
    id: z.string(),
    attributes: z.optional(z.object({
        autoNotifyEnabled: z.optional(z.boolean()),
        internalBuildState: z.optional(zInternalBetaState),
        externalBuildState: z.optional(zExternalBetaState)
    })),
    relationships: z.optional(z.object({
        build: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['builds']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BuildBetaDetailsResponse
 */
export const zBuildBetaDetailsResponse = z.object({
    data: z.array(zBuildBetaDetail),
    included: z.optional(z.array(zBuild)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BuildBetaDetailResponse
 */
export const zBuildBetaDetailResponse = z.object({
    data: zBuildBetaDetail,
    included: z.optional(z.array(zBuild)),
    links: zDocumentLinks
});

export const zKidsAgeBand = z.enum([
    'FIVE_AND_UNDER',
    'SIX_TO_EIGHT',
    'NINE_TO_ELEVEN'
]);

/**
 * AgeRatingDeclaration
 */
export const zAgeRatingDeclaration = z.object({
    type: z.enum(['ageRatingDeclarations']),
    id: z.string(),
    attributes: z.optional(z.object({
        advertising: z.optional(z.boolean()),
        alcoholTobaccoOrDrugUseOrReferences: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        contests: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        gambling: z.optional(z.boolean()),
        gamblingSimulated: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        gunsOrOtherWeapons: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        healthOrWellnessTopics: z.optional(z.boolean()),
        kidsAgeBand: z.optional(zKidsAgeBand),
        lootBox: z.optional(z.boolean()),
        medicalOrTreatmentInformation: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        messagingAndChat: z.optional(z.boolean()),
        parentalControls: z.optional(z.boolean()),
        profanityOrCrudeHumor: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        ageAssurance: z.optional(z.boolean()),
        sexualContentGraphicAndNudity: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        sexualContentOrNudity: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        horrorOrFearThemes: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        matureOrSuggestiveThemes: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        unrestrictedWebAccess: z.optional(z.boolean()),
        userGeneratedContent: z.optional(z.boolean()),
        violenceCartoonOrFantasy: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        violenceRealisticProlongedGraphicOrSadistic: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        violenceRealistic: z.optional(z.enum([
            'NONE',
            'INFREQUENT_OR_MILD',
            'FREQUENT_OR_INTENSE',
            'INFREQUENT',
            'FREQUENT'
        ])),
        ageRatingOverride: z.optional(z.enum([
            'NONE',
            'NINE_PLUS',
            'THIRTEEN_PLUS',
            'SIXTEEN_PLUS',
            'SEVENTEEN_PLUS',
            'UNRATED'
        ])),
        ageRatingOverrideV2: z.optional(z.enum([
            'NONE',
            'NINE_PLUS',
            'THIRTEEN_PLUS',
            'SIXTEEN_PLUS',
            'EIGHTEEN_PLUS',
            'UNRATED'
        ])),
        koreaAgeRatingOverride: z.optional(z.enum([
            'NONE',
            'FIFTEEN_PLUS',
            'NINETEEN_PLUS'
        ])),
        developerAgeRatingInfoUrl: z.optional(z.url())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AgeRatingDeclarationResponse
 */
export const zAgeRatingDeclarationResponse = z.object({
    data: zAgeRatingDeclaration,
    links: zDocumentLinks
});

/**
 * AgeRatingDeclarationUpdateRequest
 */
export const zAgeRatingDeclarationUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['ageRatingDeclarations']),
        id: z.string(),
        attributes: z.optional(z.object({
            advertising: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            alcoholTobaccoOrDrugUseOrReferences: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            contests: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            gambling: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            gamblingSimulated: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            gunsOrOtherWeapons: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            healthOrWellnessTopics: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            kidsAgeBand: z.optional(zKidsAgeBand),
            lootBox: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            medicalOrTreatmentInformation: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            messagingAndChat: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            parentalControls: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            profanityOrCrudeHumor: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            ageAssurance: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            sexualContentGraphicAndNudity: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            sexualContentOrNudity: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            horrorOrFearThemes: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            matureOrSuggestiveThemes: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            unrestrictedWebAccess: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            userGeneratedContent: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            violenceCartoonOrFantasy: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            violenceRealisticProlongedGraphicOrSadistic: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            violenceRealistic: z.optional(z.enum([
                'NONE',
                'INFREQUENT_OR_MILD',
                'FREQUENT_OR_INTENSE',
                'INFREQUENT',
                'FREQUENT'
            ])),
            ageRatingOverride: z.optional(z.enum([
                'NONE',
                'NINE_PLUS',
                'THIRTEEN_PLUS',
                'SIXTEEN_PLUS',
                'SEVENTEEN_PLUS',
                'UNRATED'
            ])),
            ageRatingOverrideV2: z.optional(z.enum([
                'NONE',
                'NINE_PLUS',
                'THIRTEEN_PLUS',
                'SIXTEEN_PLUS',
                'EIGHTEEN_PLUS',
                'UNRATED'
            ])),
            koreaAgeRatingOverride: z.optional(z.enum([
                'NONE',
                'FIFTEEN_PLUS',
                'NINETEEN_PLUS'
            ])),
            developerAgeRatingInfoUrl: z.optional(z.union([
                z.url(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppInfo
 */
export const zAppInfo = z.object({
    type: z.enum(['appInfos']),
    id: z.string(),
    attributes: z.optional(z.object({
        appStoreState: z.optional(zAppStoreVersionState),
        state: z.optional(z.enum([
            'ACCEPTED',
            'DEVELOPER_REJECTED',
            'IN_REVIEW',
            'PENDING_RELEASE',
            'PREPARE_FOR_SUBMISSION',
            'READY_FOR_DISTRIBUTION',
            'READY_FOR_REVIEW',
            'REJECTED',
            'REPLACED_WITH_NEW_INFO',
            'WAITING_FOR_REVIEW'
        ])),
        appStoreAgeRating: z.optional(zAppStoreAgeRating),
        australiaAgeRating: z.optional(z.enum(['FIFTEEN', 'EIGHTEEN'])),
        brazilAgeRating: z.optional(zBrazilAgeRating),
        brazilAgeRatingV2: z.optional(z.enum([
            'SELF_RATED_L',
            'SELF_RATED_TEN',
            'SELF_RATED_TWELVE',
            'SELF_RATED_FOURTEEN',
            'SELF_RATED_SIXTEEN',
            'SELF_RATED_EIGHTEEN',
            'OFFICIAL_L',
            'OFFICIAL_TEN',
            'OFFICIAL_TWELVE',
            'OFFICIAL_FOURTEEN',
            'OFFICIAL_SIXTEEN',
            'OFFICIAL_EIGHTEEN'
        ])),
        franceAgeRating: z.optional(z.enum(['EIGHTEEN'])),
        koreaAgeRating: z.optional(z.enum([
            'ALL',
            'TWELVE',
            'FIFTEEN',
            'NINETEEN',
            'NOT_APPLICABLE'
        ])),
        kidsAgeBand: z.optional(zKidsAgeBand)
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        ageRatingDeclaration: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['ageRatingDeclarations']),
                id: z.string()
            }))
        })),
        appInfoLocalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appInfoLocalizations']),
                id: z.string()
            })))
        })),
        primaryCategory: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appCategories']),
                id: z.string()
            }))
        })),
        primarySubcategoryOne: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appCategories']),
                id: z.string()
            }))
        })),
        primarySubcategoryTwo: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appCategories']),
                id: z.string()
            }))
        })),
        secondaryCategory: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appCategories']),
                id: z.string()
            }))
        })),
        secondarySubcategoryOne: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appCategories']),
                id: z.string()
            }))
        })),
        secondarySubcategoryTwo: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appCategories']),
                id: z.string()
            }))
        })),
        territoryAgeRatings: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppInfoLocalizationsResponse
 */
export const zAppInfoLocalizationsResponse = z.object({
    data: z.array(zAppInfoLocalization),
    included: z.optional(z.array(zAppInfo)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppInfoLocalizationResponse
 */
export const zAppInfoLocalizationResponse = z.object({
    data: zAppInfoLocalization,
    included: z.optional(z.array(zAppInfo)),
    links: zDocumentLinks
});

/**
 * AgeRatingDeclarationWithoutIncludesResponse
 */
export const zAgeRatingDeclarationWithoutIncludesResponse = z.object({
    data: zAgeRatingDeclaration,
    links: zDocumentLinks
});

export const zLocation = z.object({
    latitude: z.optional(z.number()),
    longitude: z.optional(z.number())
});

export const zMetricCategory = z.enum([
    'HANG',
    'LAUNCH',
    'MEMORY',
    'DISK',
    'BATTERY',
    'TERMINATION',
    'ANIMATION'
]);

export const zMetricsInsight = z.object({
    metricCategory: z.optional(zMetricCategory),
    latestVersion: z.optional(z.string()),
    metric: z.optional(z.string()),
    summaryString: z.optional(z.string()),
    referenceVersions: z.optional(z.string()),
    maxLatestVersionValue: z.optional(z.number()),
    subSystemLabel: z.optional(z.string()),
    highImpact: z.optional(z.boolean()),
    populations: z.optional(z.array(z.object({
        deltaPercentage: z.optional(z.number()),
        percentile: z.optional(z.string()),
        summaryString: z.optional(z.string()),
        referenceAverageValue: z.optional(z.number()),
        latestVersionValue: z.optional(z.number()),
        device: z.optional(z.string())
    })))
});

export const zOfferCodeEnvironment = z.enum(['PRODUCTION', 'SANDBOX']);

/**
 * InAppPurchaseOfferCodeOneTimeUseCode
 */
export const zInAppPurchaseOfferCodeOneTimeUseCode = z.object({
    type: z.enum(['inAppPurchaseOfferCodeOneTimeUseCodes']),
    id: z.string(),
    attributes: z.optional(z.object({
        numberOfCodes: z.optional(z.int()),
        createdDate: z.optional(z.iso.datetime()),
        expirationDate: z.optional(z.iso.date()),
        active: z.optional(z.boolean()),
        environment: z.optional(zOfferCodeEnvironment)
    })),
    relationships: z.optional(z.object({
        values: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        createdByActor: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['actors']),
                id: z.string()
            }))
        })),
        deactivatedByActor: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['actors']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchaseOfferCodeOneTimeUseCodesResponse
 */
export const zInAppPurchaseOfferCodeOneTimeUseCodesResponse = z.object({
    data: z.array(zInAppPurchaseOfferCodeOneTimeUseCode),
    included: z.optional(z.array(zActor)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * InAppPurchaseOfferCodeOneTimeUseCodeResponse
 */
export const zInAppPurchaseOfferCodeOneTimeUseCodeResponse = z.object({
    data: zInAppPurchaseOfferCodeOneTimeUseCode,
    included: z.optional(z.array(zActor)),
    links: zDocumentLinks
});

/**
 * InAppPurchaseOfferCodeOneTimeUseCodeCreateRequest
 */
export const zInAppPurchaseOfferCodeOneTimeUseCodeCreateRequest = z.object({
    data: z.object({
        type: z.enum(['inAppPurchaseOfferCodeOneTimeUseCodes']),
        attributes: z.object({
            numberOfCodes: z.int(),
            expirationDate: z.iso.date(),
            environment: z.optional(zOfferCodeEnvironment)
        }),
        relationships: z.object({
            offerCode: z.object({
                data: z.object({
                    type: z.enum(['inAppPurchaseOfferCodes']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * InAppPurchaseOfferCodesResponse
 */
export const zInAppPurchaseOfferCodesResponse = z.object({
    data: z.array(zInAppPurchaseOfferCode),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('inAppPurchaseOfferCodeCustomCodes')
        }).and(zInAppPurchaseOfferCodeCustomCode),
        z.object({
            type: z.literal('inAppPurchaseOfferCodeOneTimeUseCodes')
        }).and(zInAppPurchaseOfferCodeOneTimeUseCode),
        z.object({
            type: z.literal('inAppPurchaseOfferPrices')
        }).and(zInAppPurchaseOfferPrice)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * InAppPurchaseOfferCodeResponse
 */
export const zInAppPurchaseOfferCodeResponse = z.object({
    data: zInAppPurchaseOfferCode,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('inAppPurchaseOfferCodeCustomCodes')
        }).and(zInAppPurchaseOfferCodeCustomCode),
        z.object({
            type: z.literal('inAppPurchaseOfferCodeOneTimeUseCodes')
        }).and(zInAppPurchaseOfferCodeOneTimeUseCode),
        z.object({
            type: z.literal('inAppPurchaseOfferPrices')
        }).and(zInAppPurchaseOfferPrice)
    ]))),
    links: zDocumentLinks
});

/**
 * SubscriptionOfferCodeOneTimeUseCode
 */
export const zSubscriptionOfferCodeOneTimeUseCode = z.object({
    type: z.enum(['subscriptionOfferCodeOneTimeUseCodes']),
    id: z.string(),
    attributes: z.optional(z.object({
        numberOfCodes: z.optional(z.int()),
        createdDate: z.optional(z.iso.datetime()),
        expirationDate: z.optional(z.iso.date()),
        active: z.optional(z.boolean()),
        environment: z.optional(zOfferCodeEnvironment)
    })),
    relationships: z.optional(z.object({
        offerCode: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionOfferCodes']),
                id: z.string()
            }))
        })),
        values: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionOfferCodeOneTimeUseCodeCreateRequest
 */
export const zSubscriptionOfferCodeOneTimeUseCodeCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionOfferCodeOneTimeUseCodes']),
        attributes: z.object({
            numberOfCodes: z.int(),
            expirationDate: z.iso.date(),
            environment: z.optional(zOfferCodeEnvironment)
        }),
        relationships: z.object({
            offerCode: z.object({
                data: z.object({
                    type: z.enum(['subscriptionOfferCodes']),
                    id: z.string()
                })
            })
        })
    })
});

export const zPhasedReleaseState = z.enum([
    'INACTIVE',
    'ACTIVE',
    'PAUSED',
    'COMPLETE'
]);

/**
 * AppStoreVersionPhasedRelease
 */
export const zAppStoreVersionPhasedRelease = z.object({
    type: z.enum(['appStoreVersionPhasedReleases']),
    id: z.string(),
    attributes: z.optional(z.object({
        phasedReleaseState: z.optional(zPhasedReleaseState),
        startDate: z.optional(z.iso.datetime()),
        totalPauseDuration: z.optional(z.int()),
        currentDayNumber: z.optional(z.int())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppStoreVersionPhasedReleaseResponse
 */
export const zAppStoreVersionPhasedReleaseResponse = z.object({
    data: zAppStoreVersionPhasedRelease,
    links: zDocumentLinks
});

/**
 * AppStoreVersionPhasedReleaseCreateRequest
 */
export const zAppStoreVersionPhasedReleaseCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionPhasedReleases']),
        attributes: z.optional(z.object({
            phasedReleaseState: z.optional(zPhasedReleaseState)
        })),
        relationships: z.object({
            appStoreVersion: z.object({
                data: z.object({
                    type: z.enum(['appStoreVersions']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppStoreVersionPhasedReleaseUpdateRequest
 */
export const zAppStoreVersionPhasedReleaseUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionPhasedReleases']),
        id: z.string(),
        attributes: z.optional(z.object({
            phasedReleaseState: z.optional(zPhasedReleaseState)
        }))
    })
});

/**
 * AppStoreVersionPhasedReleaseWithoutIncludesResponse
 */
export const zAppStoreVersionPhasedReleaseWithoutIncludesResponse = z.object({
    data: zAppStoreVersionPhasedRelease,
    links: zDocumentLinks
});

export const zPlatform = z.enum([
    'IOS',
    'MAC_OS',
    'TV_OS',
    'VISION_OS'
]);

/**
 * AppCategory
 */
export const zAppCategory = z.object({
    type: z.enum(['appCategories']),
    id: z.string(),
    attributes: z.optional(z.object({
        platforms: z.optional(z.array(zPlatform))
    })),
    relationships: z.optional(z.object({
        subcategories: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appCategories']),
                id: z.string()
            })))
        })),
        parent: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appCategories']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppCategoriesResponse
 */
export const zAppCategoriesResponse = z.object({
    data: z.array(zAppCategory),
    included: z.optional(z.array(zAppCategory)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppCategoryResponse
 */
export const zAppCategoryResponse = z.object({
    data: zAppCategory,
    included: z.optional(z.array(zAppCategory)),
    links: zDocumentLinks
});

/**
 * AppEncryptionDeclaration
 */
export const zAppEncryptionDeclaration = z.object({
    type: z.enum(['appEncryptionDeclarations']),
    id: z.string(),
    attributes: z.optional(z.object({
        appDescription: z.optional(z.string()),
        createdDate: z.optional(z.iso.datetime()),
        usesEncryption: z.optional(z.boolean()),
        exempt: z.optional(z.boolean()),
        containsProprietaryCryptography: z.optional(z.boolean()),
        containsThirdPartyCryptography: z.optional(z.boolean()),
        availableOnFrenchStore: z.optional(z.boolean()),
        platform: z.optional(zPlatform),
        uploadedDate: z.optional(z.iso.datetime()),
        documentUrl: z.optional(z.string()),
        documentName: z.optional(z.string()),
        documentType: z.optional(z.string()),
        appEncryptionDeclarationState: z.optional(zAppEncryptionDeclarationState),
        codeValue: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        builds: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['builds']),
                id: z.string()
            })))
        })),
        appEncryptionDeclarationDocument: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appEncryptionDeclarationDocuments']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppStoreVersionExperimentV2
 */
export const zAppStoreVersionExperimentV2 = z.object({
    type: z.enum(['appStoreVersionExperiments']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        platform: z.optional(zPlatform),
        trafficProportion: z.optional(z.int()),
        state: z.optional(z.enum([
            'PREPARE_FOR_SUBMISSION',
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'ACCEPTED',
            'APPROVED',
            'REJECTED',
            'COMPLETED',
            'STOPPED'
        ])),
        reviewRequired: z.optional(z.boolean()),
        startDate: z.optional(z.iso.datetime()),
        endDate: z.optional(z.iso.datetime())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        latestControlVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            }))
        })),
        controlVersions: z.optional(z.object({
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            })))
        })),
        appStoreVersionExperimentTreatments: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appStoreVersionExperimentTreatments']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppStoreVersionExperimentV2CreateRequest
 */
export const zAppStoreVersionExperimentV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersionExperiments']),
        attributes: z.object({
            name: z.string(),
            platform: zPlatform,
            trafficProportion: z.int()
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * AppStoreVersion
 */
export const zAppStoreVersion = z.object({
    type: z.enum(['appStoreVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        platform: z.optional(zPlatform),
        versionString: z.optional(z.string()),
        appStoreState: z.optional(zAppStoreVersionState),
        appVersionState: z.optional(zAppVersionState),
        copyright: z.optional(z.string()),
        reviewType: z.optional(z.enum(['APP_STORE', 'NOTARIZATION'])),
        releaseType: z.optional(z.enum([
            'MANUAL',
            'AFTER_APPROVAL',
            'SCHEDULED'
        ])),
        earliestReleaseDate: z.optional(z.iso.datetime()),
        usesIdfa: z.optional(z.boolean()),
        downloadable: z.optional(z.boolean()),
        createdDate: z.optional(z.iso.datetime())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        ageRatingDeclaration: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['ageRatingDeclarations']),
                id: z.string()
            }))
        })),
        appStoreVersionLocalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appStoreVersionLocalizations']),
                id: z.string()
            })))
        })),
        build: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['builds']),
                id: z.string()
            }))
        })),
        appStoreVersionPhasedRelease: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appStoreVersionPhasedReleases']),
                id: z.string()
            }))
        })),
        gameCenterAppVersion: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterAppVersions']),
                id: z.string()
            }))
        })),
        routingAppCoverage: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['routingAppCoverages']),
                id: z.string()
            }))
        })),
        appStoreReviewDetail: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appStoreReviewDetails']),
                id: z.string()
            }))
        })),
        appStoreVersionSubmission: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appStoreVersionSubmissions']),
                id: z.string()
            }))
        })),
        appClipDefaultExperience: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['appClipDefaultExperiences']),
                id: z.string()
            }))
        })),
        appStoreVersionExperiments: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appStoreVersionExperiments']),
                id: z.string()
            })))
        })),
        appStoreVersionExperimentsV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appStoreVersionExperiments']),
                id: z.string()
            })))
        })),
        customerReviews: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        alternativeDistributionPackage: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['alternativeDistributionPackages']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppClipDefaultExperiencesResponse
 */
export const zAppClipDefaultExperiencesResponse = z.object({
    data: z.array(zAppClipDefaultExperience),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appClipAppStoreReviewDetails')
        }).and(zAppClipAppStoreReviewDetail),
        z.object({
            type: z.literal('appClipDefaultExperienceLocalizations')
        }).and(zAppClipDefaultExperienceLocalization),
        z.object({
            type: z.literal('appClips')
        }).and(zAppClip),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppClipDefaultExperienceResponse
 */
export const zAppClipDefaultExperienceResponse = z.object({
    data: zAppClipDefaultExperience,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appClipAppStoreReviewDetails')
        }).and(zAppClipAppStoreReviewDetail),
        z.object({
            type: z.literal('appClipDefaultExperienceLocalizations')
        }).and(zAppClipDefaultExperienceLocalization),
        z.object({
            type: z.literal('appClips')
        }).and(zAppClip),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion)
    ]))),
    links: zDocumentLinks
});

/**
 * AppStoreVersionExperimentsResponse
 *
 * @deprecated
 */
export const zAppStoreVersionExperimentsResponse = z.object({
    data: z.array(zAppStoreVersionExperiment),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appStoreVersionExperimentTreatments')
        }).and(zAppStoreVersionExperimentTreatment), z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppStoreVersionExperimentResponse
 *
 * @deprecated
 */
export const zAppStoreVersionExperimentResponse = z.object({
    data: zAppStoreVersionExperiment,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appStoreVersionExperimentTreatments')
        }).and(zAppStoreVersionExperimentTreatment), z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion)]))),
    links: zDocumentLinks
});

/**
 * AppStoreVersionSubmissionResponse
 *
 * @deprecated
 */
export const zAppStoreVersionSubmissionResponse = z.object({
    data: zAppStoreVersionSubmission,
    included: z.optional(z.array(zAppStoreVersion)),
    links: zDocumentLinks
});

/**
 * AppStoreVersionCreateRequest
 */
export const zAppStoreVersionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appStoreVersions']),
        attributes: z.object({
            platform: zPlatform,
            versionString: z.string(),
            copyright: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            reviewType: z.optional(z.enum(['APP_STORE', 'NOTARIZATION'])),
            releaseType: z.optional(z.enum([
                'MANUAL',
                'AFTER_APPROVAL',
                'SCHEDULED'
            ])),
            earliestReleaseDate: z.optional(z.union([
                z.iso.datetime(),
                z.null()
            ])),
            usesIdfa: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            }),
            appStoreVersionLocalizations: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['appStoreVersionLocalizations']),
                    id: z.string()
                })))
            })),
            build: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['builds']),
                    id: z.string()
                }))
            }))
        })
    })
});

/**
 * BetaFeedbackCrashSubmission
 */
export const zBetaFeedbackCrashSubmission = z.object({
    type: z.enum(['betaFeedbackCrashSubmissions']),
    id: z.string(),
    attributes: z.optional(z.object({
        createdDate: z.optional(z.iso.datetime()),
        comment: z.optional(z.string()),
        email: z.optional(z.string()),
        deviceModel: z.optional(z.string()),
        osVersion: z.optional(z.string()),
        locale: z.optional(z.string()),
        timeZone: z.optional(z.string()),
        architecture: z.optional(z.string()),
        connectionType: z.optional(zDeviceConnectionType),
        pairedAppleWatch: z.optional(z.string()),
        appUptimeInMilliseconds: z.optional(z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991))),
        diskBytesAvailable: z.optional(z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991))),
        diskBytesTotal: z.optional(z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991))),
        batteryPercentage: z.optional(z.int()),
        screenWidthInPoints: z.optional(z.int()),
        screenHeightInPoints: z.optional(z.int()),
        appPlatform: z.optional(zPlatform),
        devicePlatform: z.optional(zPlatform),
        deviceFamily: z.optional(zDeviceFamily),
        buildBundleId: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        crashLog: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        build: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['builds']),
                id: z.string()
            }))
        })),
        tester: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['betaTesters']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaFeedbackCrashSubmissionsResponse
 */
export const zBetaFeedbackCrashSubmissionsResponse = z.object({
    data: z.array(zBetaFeedbackCrashSubmission),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('betaTesters')
        }).and(zBetaTester), z.object({
            type: z.literal('builds')
        }).and(zBuild)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaFeedbackCrashSubmissionResponse
 */
export const zBetaFeedbackCrashSubmissionResponse = z.object({
    data: zBetaFeedbackCrashSubmission,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('betaTesters')
        }).and(zBetaTester), z.object({
            type: z.literal('builds')
        }).and(zBuild)]))),
    links: zDocumentLinks
});

/**
 * BetaFeedbackScreenshotSubmission
 */
export const zBetaFeedbackScreenshotSubmission = z.object({
    type: z.enum(['betaFeedbackScreenshotSubmissions']),
    id: z.string(),
    attributes: z.optional(z.object({
        createdDate: z.optional(z.iso.datetime()),
        comment: z.optional(z.string()),
        email: z.optional(z.string()),
        deviceModel: z.optional(z.string()),
        osVersion: z.optional(z.string()),
        locale: z.optional(z.string()),
        timeZone: z.optional(z.string()),
        architecture: z.optional(z.string()),
        connectionType: z.optional(zDeviceConnectionType),
        pairedAppleWatch: z.optional(z.string()),
        appUptimeInMilliseconds: z.optional(z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991))),
        diskBytesAvailable: z.optional(z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991))),
        diskBytesTotal: z.optional(z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9007199254740991))),
        batteryPercentage: z.optional(z.int()),
        screenWidthInPoints: z.optional(z.int()),
        screenHeightInPoints: z.optional(z.int()),
        appPlatform: z.optional(zPlatform),
        devicePlatform: z.optional(zPlatform),
        deviceFamily: z.optional(zDeviceFamily),
        buildBundleId: z.optional(z.string()),
        screenshots: z.optional(z.array(zBetaFeedbackScreenshotImage))
    })),
    relationships: z.optional(z.object({
        build: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['builds']),
                id: z.string()
            }))
        })),
        tester: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['betaTesters']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BetaFeedbackScreenshotSubmissionsResponse
 */
export const zBetaFeedbackScreenshotSubmissionsResponse = z.object({
    data: z.array(zBetaFeedbackScreenshotSubmission),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('betaTesters')
        }).and(zBetaTester), z.object({
            type: z.literal('builds')
        }).and(zBuild)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaFeedbackScreenshotSubmissionResponse
 */
export const zBetaFeedbackScreenshotSubmissionResponse = z.object({
    data: zBetaFeedbackScreenshotSubmission,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('betaTesters')
        }).and(zBetaTester), z.object({
            type: z.literal('builds')
        }).and(zBuild)]))),
    links: zDocumentLinks
});

/**
 * BuildUploadCreateRequest
 */
export const zBuildUploadCreateRequest = z.object({
    data: z.object({
        type: z.enum(['buildUploads']),
        attributes: z.object({
            cfBundleShortVersionString: z.string(),
            cfBundleVersion: z.string(),
            platform: zPlatform
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * CustomerReviewSummarization
 */
export const zCustomerReviewSummarization = z.object({
    type: z.enum(['customerReviewSummarizations']),
    id: z.string(),
    attributes: z.optional(z.object({
        createdDate: z.optional(z.iso.datetime()),
        locale: z.optional(z.string()),
        platform: z.optional(zPlatform),
        text: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * CustomerReviewSummarizationsResponse
 */
export const zCustomerReviewSummarizationsResponse = z.object({
    data: z.array(zCustomerReviewSummarization),
    included: z.optional(z.array(zTerritory)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterAppVersionsResponse
 */
export const zGameCenterAppVersionsResponse = z.object({
    data: z.array(zGameCenterAppVersion),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion), z.object({
            type: z.literal('gameCenterAppVersions')
        }).and(zGameCenterAppVersion)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterAppVersionResponse
 */
export const zGameCenterAppVersionResponse = z.object({
    data: zGameCenterAppVersion,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion), z.object({
            type: z.literal('gameCenterAppVersions')
        }).and(zGameCenterAppVersion)]))),
    links: zDocumentLinks
});

/**
 * GameCenterEnabledVersion
 *
 * @deprecated
 */
export const zGameCenterEnabledVersion = z.object({
    type: z.enum(['gameCenterEnabledVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        platform: z.optional(zPlatform),
        versionString: z.optional(z.string()),
        iconAsset: z.optional(zImageAsset)
    })),
    relationships: z.optional(z.object({
        compatibleVersions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterEnabledVersions']),
                id: z.string()
            })))
        })),
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

export const zGameCenterMatchmakingTestRequestInlineCreate = z.object({
    type: z.enum(['gameCenterMatchmakingTestRequests']),
    id: z.optional(z.string()),
    attributes: z.object({
        requestName: z.string(),
        secondsInQueue: z.int(),
        locale: z.optional(z.enum([
            'AR-SA',
            'CA-ES',
            'CS-CZ',
            'DA-DK',
            'DE-DE',
            'EL-GR',
            'EN-AU',
            'EN-GB',
            'EN-US',
            'EN-KY',
            'ES-ES',
            'ES-MX',
            'FI-FI',
            'FR-CA',
            'FR-FR',
            'HI-IN',
            'HR-HR',
            'HU-HU',
            'ID-ID',
            'IT-IT',
            'IW-IL',
            'JA-JP',
            'KO-KR',
            'MS-MY',
            'NL-NL',
            'NO-NO',
            'PL-PL',
            'PT-BR',
            'PT-PT',
            'RO-RO',
            'RU-RU',
            'SK-SK',
            'SV-SE',
            'TH-TH',
            'TR-TR',
            'UK-UA',
            'ZH-CN',
            'ZH-TW',
            'ZH-HK'
        ])),
        location: z.optional(zLocation),
        minPlayers: z.optional(z.union([
            z.int(),
            z.null()
        ])),
        maxPlayers: z.optional(z.union([
            z.int(),
            z.null()
        ])),
        playerCount: z.optional(z.union([
            z.int(),
            z.null()
        ])),
        bundleId: z.string(),
        platform: zPlatform,
        appVersion: z.string()
    }),
    relationships: z.optional(z.object({
        matchmakingPlayerProperties: z.optional(z.object({
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterMatchmakingTestPlayerProperties']),
                id: z.string()
            })))
        }))
    }))
});

/**
 * PrereleaseVersion
 */
export const zPrereleaseVersion = z.object({
    type: z.enum(['preReleaseVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        version: z.optional(z.string()),
        platform: z.optional(zPlatform)
    })),
    relationships: z.optional(z.object({
        builds: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['builds']),
                id: z.string()
            })))
        })),
        app: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * ReviewSubmission
 */
export const zReviewSubmission = z.object({
    type: z.enum(['reviewSubmissions']),
    id: z.string(),
    attributes: z.optional(z.object({
        platform: z.optional(zPlatform),
        submittedDate: z.optional(z.iso.datetime()),
        state: z.optional(z.enum([
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'UNRESOLVED_ISSUES',
            'CANCELING',
            'COMPLETING',
            'COMPLETE'
        ]))
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        items: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['reviewSubmissionItems']),
                id: z.string()
            })))
        })),
        appStoreVersionForReview: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            }))
        })),
        submittedByActor: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['actors']),
                id: z.string()
            }))
        })),
        lastUpdatedByActor: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['actors']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * ReviewSubmissionCreateRequest
 */
export const zReviewSubmissionCreateRequest = z.object({
    data: z.object({
        type: z.enum(['reviewSubmissions']),
        attributes: z.optional(z.object({
            platform: z.optional(zPlatform)
        })),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * ReviewSubmissionUpdateRequest
 */
export const zReviewSubmissionUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['reviewSubmissions']),
        id: z.string(),
        attributes: z.optional(z.object({
            platform: z.optional(zPlatform),
            submitted: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            canceled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * AppCategoryWithoutIncludesResponse
 */
export const zAppCategoryWithoutIncludesResponse = z.object({
    data: zAppCategory,
    links: zDocumentLinks
});

/**
 * AppCategoriesWithoutIncludesResponse
 */
export const zAppCategoriesWithoutIncludesResponse = z.object({
    data: z.array(zAppCategory),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * PreReleaseVersionsWithoutIncludesResponse
 */
export const zPreReleaseVersionsWithoutIncludesResponse = z.object({
    data: z.array(zPrereleaseVersion),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppEncryptionDeclarationWithoutIncludesResponse
 */
export const zAppEncryptionDeclarationWithoutIncludesResponse = z.object({
    data: zAppEncryptionDeclaration,
    links: zDocumentLinks
});

/**
 * PrereleaseVersionWithoutIncludesResponse
 */
export const zPrereleaseVersionWithoutIncludesResponse = z.object({
    data: zPrereleaseVersion,
    links: zDocumentLinks
});

export const zPreviewFrameImage = z.object({
    image: z.optional(zImageAsset),
    state: z.optional(zAppMediaPreviewFrameImageState)
});

export const zPreviewType = z.enum([
    'IPHONE_67',
    'IPHONE_61',
    'IPHONE_65',
    'IPHONE_58',
    'IPHONE_55',
    'IPHONE_47',
    'IPHONE_40',
    'IPHONE_35',
    'IPAD_PRO_3GEN_129',
    'IPAD_PRO_3GEN_11',
    'IPAD_PRO_129',
    'IPAD_105',
    'IPAD_97',
    'DESKTOP',
    'APPLE_TV',
    'APPLE_VISION_PRO'
]);

/**
 * AppPreviewSet
 */
export const zAppPreviewSet = z.object({
    type: z.enum(['appPreviewSets']),
    id: z.string(),
    attributes: z.optional(z.object({
        previewType: z.optional(zPreviewType)
    })),
    relationships: z.optional(z.object({
        appStoreVersionLocalization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersionLocalizations']),
                id: z.string()
            }))
        })),
        appCustomProductPageLocalization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appCustomProductPageLocalizations']),
                id: z.string()
            }))
        })),
        appStoreVersionExperimentTreatmentLocalization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersionExperimentTreatmentLocalizations']),
                id: z.string()
            }))
        })),
        appPreviews: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appPreviews']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppPreviewSetCreateRequest
 */
export const zAppPreviewSetCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appPreviewSets']),
        attributes: z.object({
            previewType: zPreviewType
        }),
        relationships: z.optional(z.object({
            appStoreVersionLocalization: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appStoreVersionLocalizations']),
                    id: z.string()
                }))
            })),
            appCustomProductPageLocalization: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appCustomProductPageLocalizations']),
                    id: z.string()
                }))
            })),
            appStoreVersionExperimentTreatmentLocalization: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appStoreVersionExperimentTreatmentLocalizations']),
                    id: z.string()
                }))
            }))
        }))
    })
});

export const zProperty = z.object({
    key: z.optional(z.string()),
    value: z.optional(z.string())
});

export const zGameCenterMatchmakingTestPlayerPropertyInlineCreate = z.object({
    type: z.enum(['gameCenterMatchmakingTestPlayerProperties']),
    id: z.optional(z.string()),
    attributes: z.object({
        playerId: z.string(),
        properties: z.optional(z.union([
            z.array(zProperty),
            z.null()
        ]))
    })
});

/**
 * GameCenterMatchmakingRuleSetTestCreateRequest
 */
export const zGameCenterMatchmakingRuleSetTestCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterMatchmakingRuleSetTests']),
        relationships: z.object({
            matchmakingRuleSet: z.object({
                data: z.object({
                    type: z.enum(['gameCenterMatchmakingRuleSets']),
                    id: z.string()
                })
            }),
            matchmakingRequests: z.object({
                data: z.array(z.object({
                    type: z.enum(['gameCenterMatchmakingTestRequests']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(z.union([zGameCenterMatchmakingTestPlayerPropertyInlineCreate, zGameCenterMatchmakingTestRequestInlineCreate])))
});

export const zScmProviderType = z.object({
    kind: z.optional(z.enum([
        'BITBUCKET_CLOUD',
        'BITBUCKET_SERVER',
        'GITHUB_CLOUD',
        'GITHUB_ENTERPRISE',
        'GITLAB_CLOUD',
        'GITLAB_SELF_MANAGED'
    ])),
    displayName: z.optional(z.string()),
    isOnPremise: z.optional(z.boolean())
});

/**
 * ScmProvider
 */
export const zScmProvider = z.object({
    type: z.enum(['scmProviders']),
    id: z.string(),
    attributes: z.optional(z.object({
        scmProviderType: z.optional(zScmProviderType),
        url: z.optional(z.url())
    })),
    relationships: z.optional(z.object({
        repositories: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * ScmProvidersResponse
 */
export const zScmProvidersResponse = z.object({
    data: z.array(zScmProvider),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * ScmProviderResponse
 */
export const zScmProviderResponse = z.object({
    data: zScmProvider,
    links: zDocumentLinks
});

/**
 * ScmRepositoriesResponse
 */
export const zScmRepositoriesResponse = z.object({
    data: z.array(zScmRepository),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('scmGitReferences')
        }).and(zScmGitReference), z.object({
            type: z.literal('scmProviders')
        }).and(zScmProvider)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * ScmRepositoryResponse
 */
export const zScmRepositoryResponse = z.object({
    data: zScmRepository,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('scmGitReferences')
        }).and(zScmGitReference), z.object({
            type: z.literal('scmProviders')
        }).and(zScmProvider)]))),
    links: zDocumentLinks
});

export const zScreenshotDisplayType = z.enum([
    'APP_IPHONE_67',
    'APP_IPHONE_61',
    'APP_IPHONE_65',
    'APP_IPHONE_58',
    'APP_IPHONE_55',
    'APP_IPHONE_47',
    'APP_IPHONE_40',
    'APP_IPHONE_35',
    'APP_IPAD_PRO_3GEN_129',
    'APP_IPAD_PRO_3GEN_11',
    'APP_IPAD_PRO_129',
    'APP_IPAD_105',
    'APP_IPAD_97',
    'APP_DESKTOP',
    'APP_WATCH_ULTRA',
    'APP_WATCH_SERIES_10',
    'APP_WATCH_SERIES_7',
    'APP_WATCH_SERIES_4',
    'APP_WATCH_SERIES_3',
    'APP_APPLE_TV',
    'APP_APPLE_VISION_PRO',
    'IMESSAGE_APP_IPHONE_67',
    'IMESSAGE_APP_IPHONE_61',
    'IMESSAGE_APP_IPHONE_65',
    'IMESSAGE_APP_IPHONE_58',
    'IMESSAGE_APP_IPHONE_55',
    'IMESSAGE_APP_IPHONE_47',
    'IMESSAGE_APP_IPHONE_40',
    'IMESSAGE_APP_IPAD_PRO_3GEN_129',
    'IMESSAGE_APP_IPAD_PRO_3GEN_11',
    'IMESSAGE_APP_IPAD_PRO_129',
    'IMESSAGE_APP_IPAD_105',
    'IMESSAGE_APP_IPAD_97'
]);

/**
 * AppScreenshotSet
 */
export const zAppScreenshotSet = z.object({
    type: z.enum(['appScreenshotSets']),
    id: z.string(),
    attributes: z.optional(z.object({
        screenshotDisplayType: z.optional(zScreenshotDisplayType)
    })),
    relationships: z.optional(z.object({
        appStoreVersionLocalization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersionLocalizations']),
                id: z.string()
            }))
        })),
        appCustomProductPageLocalization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appCustomProductPageLocalizations']),
                id: z.string()
            }))
        })),
        appStoreVersionExperimentTreatmentLocalization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersionExperimentTreatmentLocalizations']),
                id: z.string()
            }))
        })),
        appScreenshots: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appScreenshots']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppCustomProductPageLocalizationsResponse
 */
export const zAppCustomProductPageLocalizationsResponse = z.object({
    data: z.array(zAppCustomProductPageLocalization),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appCustomProductPageVersions')
        }).and(zAppCustomProductPageVersion),
        z.object({
            type: z.literal('appKeywords')
        }).and(zAppKeyword),
        z.object({
            type: z.literal('appPreviewSets')
        }).and(zAppPreviewSet),
        z.object({
            type: z.literal('appScreenshotSets')
        }).and(zAppScreenshotSet)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppCustomProductPageLocalizationResponse
 */
export const zAppCustomProductPageLocalizationResponse = z.object({
    data: zAppCustomProductPageLocalization,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appCustomProductPageVersions')
        }).and(zAppCustomProductPageVersion),
        z.object({
            type: z.literal('appKeywords')
        }).and(zAppKeyword),
        z.object({
            type: z.literal('appPreviewSets')
        }).and(zAppPreviewSet),
        z.object({
            type: z.literal('appScreenshotSets')
        }).and(zAppScreenshotSet)
    ]))),
    links: zDocumentLinks
});

/**
 * AppScreenshotSetCreateRequest
 */
export const zAppScreenshotSetCreateRequest = z.object({
    data: z.object({
        type: z.enum(['appScreenshotSets']),
        attributes: z.object({
            screenshotDisplayType: zScreenshotDisplayType
        }),
        relationships: z.optional(z.object({
            appStoreVersionLocalization: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appStoreVersionLocalizations']),
                    id: z.string()
                }))
            })),
            appCustomProductPageLocalization: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appCustomProductPageLocalizations']),
                    id: z.string()
                }))
            })),
            appStoreVersionExperimentTreatmentLocalization: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['appStoreVersionExperimentTreatmentLocalizations']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * AppStoreVersionExperimentTreatmentLocalizationsResponse
 */
export const zAppStoreVersionExperimentTreatmentLocalizationsResponse = z.object({
    data: z.array(zAppStoreVersionExperimentTreatmentLocalization),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appPreviewSets')
        }).and(zAppPreviewSet),
        z.object({
            type: z.literal('appScreenshotSets')
        }).and(zAppScreenshotSet),
        z.object({
            type: z.literal('appStoreVersionExperimentTreatments')
        }).and(zAppStoreVersionExperimentTreatment)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppStoreVersionExperimentTreatmentLocalizationResponse
 */
export const zAppStoreVersionExperimentTreatmentLocalizationResponse = z.object({
    data: zAppStoreVersionExperimentTreatmentLocalization,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appPreviewSets')
        }).and(zAppPreviewSet),
        z.object({
            type: z.literal('appScreenshotSets')
        }).and(zAppScreenshotSet),
        z.object({
            type: z.literal('appStoreVersionExperimentTreatments')
        }).and(zAppStoreVersionExperimentTreatment)
    ]))),
    links: zDocumentLinks
});

/**
 * AppStoreVersionLocalizationsResponse
 */
export const zAppStoreVersionLocalizationsResponse = z.object({
    data: z.array(zAppStoreVersionLocalization),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appKeywords')
        }).and(zAppKeyword),
        z.object({
            type: z.literal('appPreviewSets')
        }).and(zAppPreviewSet),
        z.object({
            type: z.literal('appScreenshotSets')
        }).and(zAppScreenshotSet),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppStoreVersionLocalizationResponse
 */
export const zAppStoreVersionLocalizationResponse = z.object({
    data: zAppStoreVersionLocalization,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appKeywords')
        }).and(zAppKeyword),
        z.object({
            type: z.literal('appPreviewSets')
        }).and(zAppPreviewSet),
        z.object({
            type: z.literal('appScreenshotSets')
        }).and(zAppScreenshotSet),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion)
    ]))),
    links: zDocumentLinks
});

export const zStateDetail = z.object({
    code: z.optional(z.string()),
    description: z.optional(z.string())
});

/**
 * BackgroundAssetVersion
 */
export const zBackgroundAssetVersion = z.object({
    type: z.enum(['backgroundAssetVersions']),
    id: z.string(),
    attributes: z.optional(z.object({
        createdDate: z.optional(z.iso.datetime()),
        platforms: z.optional(z.array(zPlatform)),
        state: z.optional(zBackgroundAssetVersionState),
        stateDetails: z.optional(z.object({
            errors: z.optional(z.array(zStateDetail)),
            warnings: z.optional(z.array(zStateDetail)),
            infos: z.optional(z.array(zStateDetail))
        })),
        version: z.optional(z.string())
    })),
    relationships: z.optional(z.object({
        backgroundAsset: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssets']),
                id: z.string()
            }))
        })),
        internalBetaRelease: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssetVersionInternalBetaReleases']),
                id: z.string()
            }))
        })),
        externalBetaRelease: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssetVersionExternalBetaReleases']),
                id: z.string()
            }))
        })),
        appStoreRelease: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssetVersionAppStoreReleases']),
                id: z.string()
            }))
        })),
        assetFile: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssetUploadFiles']),
                id: z.string()
            }))
        })),
        manifestFile: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['backgroundAssetUploadFiles']),
                id: z.string()
            }))
        })),
        backgroundAssetUploadFiles: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BackgroundAssetVersionAppStoreReleaseResponse
 */
export const zBackgroundAssetVersionAppStoreReleaseResponse = z.object({
    data: zBackgroundAssetVersionAppStoreRelease,
    included: z.optional(z.array(zBackgroundAssetVersion)),
    links: zDocumentLinks
});

/**
 * BackgroundAssetVersionExternalBetaReleaseResponse
 */
export const zBackgroundAssetVersionExternalBetaReleaseResponse = z.object({
    data: zBackgroundAssetVersionExternalBetaRelease,
    included: z.optional(z.array(zBackgroundAssetVersion)),
    links: zDocumentLinks
});

/**
 * BackgroundAssetVersionInternalBetaReleaseResponse
 */
export const zBackgroundAssetVersionInternalBetaReleaseResponse = z.object({
    data: zBackgroundAssetVersionInternalBetaRelease,
    included: z.optional(z.array(zBackgroundAssetVersion)),
    links: zDocumentLinks
});

/**
 * BackgroundAssetVersionsResponse
 */
export const zBackgroundAssetVersionsResponse = z.object({
    data: z.array(zBackgroundAssetVersion),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('backgroundAssetUploadFiles')
        }).and(zBackgroundAssetUploadFile),
        z.object({
            type: z.literal('backgroundAssetVersionAppStoreReleases')
        }).and(zBackgroundAssetVersionAppStoreRelease),
        z.object({
            type: z.literal('backgroundAssetVersionExternalBetaReleases')
        }).and(zBackgroundAssetVersionExternalBetaRelease),
        z.object({
            type: z.literal('backgroundAssetVersionInternalBetaReleases')
        }).and(zBackgroundAssetVersionInternalBetaRelease),
        z.object({
            type: z.literal('backgroundAssets')
        }).and(zBackgroundAsset)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BackgroundAssetVersionResponse
 */
export const zBackgroundAssetVersionResponse = z.object({
    data: zBackgroundAssetVersion,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('backgroundAssetUploadFiles')
        }).and(zBackgroundAssetUploadFile),
        z.object({
            type: z.literal('backgroundAssetVersionAppStoreReleases')
        }).and(zBackgroundAssetVersionAppStoreRelease),
        z.object({
            type: z.literal('backgroundAssetVersionExternalBetaReleases')
        }).and(zBackgroundAssetVersionExternalBetaRelease),
        z.object({
            type: z.literal('backgroundAssetVersionInternalBetaReleases')
        }).and(zBackgroundAssetVersionInternalBetaRelease),
        z.object({
            type: z.literal('backgroundAssets')
        }).and(zBackgroundAsset)
    ]))),
    links: zDocumentLinks
});

/**
 * BuildUpload
 */
export const zBuildUpload = z.object({
    type: z.enum(['buildUploads']),
    id: z.string(),
    attributes: z.optional(z.object({
        cfBundleShortVersionString: z.optional(z.string()),
        cfBundleVersion: z.optional(z.string()),
        createdDate: z.optional(z.iso.datetime()),
        state: z.optional(z.object({
            errors: z.optional(z.array(zStateDetail)),
            warnings: z.optional(z.array(zStateDetail)),
            infos: z.optional(z.array(zStateDetail)),
            state: z.optional(zBuildUploadState)
        })),
        platform: z.optional(zPlatform),
        uploadedDate: z.optional(z.iso.datetime())
    })),
    relationships: z.optional(z.object({
        build: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['builds']),
                id: z.string()
            }))
        })),
        assetFile: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['buildUploadFiles']),
                id: z.string()
            }))
        })),
        assetDescriptionFile: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['buildUploadFiles']),
                id: z.string()
            }))
        })),
        assetSpiFile: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['buildUploadFiles']),
                id: z.string()
            }))
        })),
        buildUploadFiles: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * BuildUploadsResponse
 */
export const zBuildUploadsResponse = z.object({
    data: z.array(zBuildUpload),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('buildUploadFiles')
        }).and(zBuildUploadFile), z.object({
            type: z.literal('builds')
        }).and(zBuild)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BuildUploadResponse
 */
export const zBuildUploadResponse = z.object({
    data: zBuildUpload,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('buildUploadFiles')
        }).and(zBuildUploadFile), z.object({
            type: z.literal('builds')
        }).and(zBuild)]))),
    links: zDocumentLinks
});

/**
 * ReviewSubmissionItemsResponse
 */
export const zReviewSubmissionItemsResponse = z.object({
    data: z.array(zReviewSubmissionItem),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appCustomProductPageVersions')
        }).and(zAppCustomProductPageVersion),
        z.object({
            type: z.literal('appEvents')
        }).and(zAppEvent),
        z.object({
            type: z.literal('appStoreVersionExperiments')
        }).and(zAppStoreVersionExperiment),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion),
        z.object({
            type: z.literal('backgroundAssetVersions')
        }).and(zBackgroundAssetVersion),
        z.object({
            type: z.literal('gameCenterAchievementVersions')
        }).and(zGameCenterAchievementVersionV2),
        z.object({
            type: z.literal('gameCenterActivityVersions')
        }).and(zGameCenterActivityVersion),
        z.object({
            type: z.literal('gameCenterChallengeVersions')
        }).and(zGameCenterChallengeVersion),
        z.object({
            type: z.literal('gameCenterLeaderboardSetVersions')
        }).and(zGameCenterLeaderboardSetVersionV2),
        z.object({
            type: z.literal('gameCenterLeaderboardVersions')
        }).and(zGameCenterLeaderboardVersionV2)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * ReviewSubmissionItemResponse
 */
export const zReviewSubmissionItemResponse = z.object({
    data: zReviewSubmissionItem,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appCustomProductPageVersions')
        }).and(zAppCustomProductPageVersion),
        z.object({
            type: z.literal('appEvents')
        }).and(zAppEvent),
        z.object({
            type: z.literal('appStoreVersionExperiments')
        }).and(zAppStoreVersionExperiment),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion),
        z.object({
            type: z.literal('backgroundAssetVersions')
        }).and(zBackgroundAssetVersion),
        z.object({
            type: z.literal('gameCenterAchievementVersions')
        }).and(zGameCenterAchievementVersionV2),
        z.object({
            type: z.literal('gameCenterActivityVersions')
        }).and(zGameCenterActivityVersion),
        z.object({
            type: z.literal('gameCenterChallengeVersions')
        }).and(zGameCenterChallengeVersion),
        z.object({
            type: z.literal('gameCenterLeaderboardSetVersions')
        }).and(zGameCenterLeaderboardSetVersionV2),
        z.object({
            type: z.literal('gameCenterLeaderboardVersions')
        }).and(zGameCenterLeaderboardVersionV2)
    ]))),
    links: zDocumentLinks
});

export const zStringToStringMap = z.record(z.string(), z.string());

/**
 * GameCenterAchievementV2
 */
export const zGameCenterAchievementV2 = z.object({
    type: z.enum(['gameCenterAchievements']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        vendorIdentifier: z.optional(z.string()),
        points: z.optional(z.int()),
        showBeforeEarned: z.optional(z.boolean()),
        repeatable: z.optional(z.boolean()),
        archived: z.optional(z.boolean()),
        activityProperties: z.optional(zStringToStringMap)
    })),
    relationships: z.optional(z.object({
        gameCenterDetail: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            }))
        })),
        gameCenterGroup: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterGroups']),
                id: z.string()
            }))
        })),
        activity: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterActivities']),
                id: z.string()
            }))
        })),
        versions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAchievementVersions']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterAchievementVersionsV2Response
 */
export const zGameCenterAchievementVersionsV2Response = z.object({
    data: z.array(zGameCenterAchievementVersionV2),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterAchievementLocalizations')
        }).and(zGameCenterAchievementLocalizationV2), z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievementV2)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterAchievementVersionV2Response
 */
export const zGameCenterAchievementVersionV2Response = z.object({
    data: zGameCenterAchievementVersionV2,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterAchievementLocalizations')
        }).and(zGameCenterAchievementLocalizationV2), z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievementV2)]))),
    links: zDocumentLinks
});

/**
 * GameCenterAchievementV2CreateRequest
 */
export const zGameCenterAchievementV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievements']),
        attributes: z.object({
            referenceName: z.string(),
            vendorIdentifier: z.string(),
            points: z.int(),
            showBeforeEarned: z.boolean(),
            repeatable: z.boolean(),
            activityProperties: z.optional(zStringToStringMap)
        }),
        relationships: z.object({
            gameCenterDetail: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                }))
            })),
            gameCenterGroup: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterGroups']),
                    id: z.string()
                }))
            })),
            versions: z.object({
                data: z.array(z.object({
                    type: z.enum(['gameCenterAchievementVersions']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(zGameCenterAchievementVersionV2InlineCreate))
});

/**
 * GameCenterAchievementV2UpdateRequest
 */
export const zGameCenterAchievementV2UpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string(),
        attributes: z.optional(z.object({
            referenceName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            points: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            showBeforeEarned: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            repeatable: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            archived: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            activityProperties: z.optional(zStringToStringMap)
        }))
    })
});

/**
 * GameCenterAchievement
 */
export const zGameCenterAchievement = z.object({
    type: z.enum(['gameCenterAchievements']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        vendorIdentifier: z.optional(z.string()),
        points: z.optional(z.int()),
        showBeforeEarned: z.optional(z.boolean()),
        repeatable: z.optional(z.boolean()),
        archived: z.optional(z.boolean()),
        activityProperties: z.optional(zStringToStringMap)
    })),
    relationships: z.optional(z.object({
        gameCenterDetail: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            }))
        })),
        gameCenterGroup: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterGroups']),
                id: z.string()
            }))
        })),
        groupAchievement: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterAchievements']),
                id: z.string()
            }))
        })),
        localizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAchievementLocalizations']),
                id: z.string()
            })))
        })),
        releases: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAchievementReleases']),
                id: z.string()
            })))
        })),
        activity: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterActivities']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterAchievementReleasesResponse
 */
export const zGameCenterAchievementReleasesResponse = z.object({
    data: z.array(zGameCenterAchievementRelease),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievement), z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterAchievementReleaseResponse
 */
export const zGameCenterAchievementReleaseResponse = z.object({
    data: zGameCenterAchievementRelease,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievement), z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail)]))),
    links: zDocumentLinks
});

/**
 * GameCenterAchievementCreateRequest
 */
export const zGameCenterAchievementCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievements']),
        attributes: z.object({
            referenceName: z.string(),
            vendorIdentifier: z.string(),
            points: z.int(),
            showBeforeEarned: z.boolean(),
            repeatable: z.boolean(),
            activityProperties: z.optional(zStringToStringMap)
        }),
        relationships: z.optional(z.object({
            gameCenterDetail: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                }))
            })),
            gameCenterGroup: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterGroups']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * GameCenterAchievementUpdateRequest
 */
export const zGameCenterAchievementUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterAchievements']),
        id: z.string(),
        attributes: z.optional(z.object({
            referenceName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            points: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            showBeforeEarned: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            repeatable: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            archived: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            activityProperties: z.optional(zStringToStringMap)
        }))
    })
});

/**
 * GameCenterActivity
 */
export const zGameCenterActivity = z.object({
    type: z.enum(['gameCenterActivities']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        vendorIdentifier: z.optional(z.string()),
        playStyle: z.optional(z.enum(['ASYNCHRONOUS', 'SYNCHRONOUS'])),
        minimumPlayersCount: z.optional(z.int()),
        maximumPlayersCount: z.optional(z.int()),
        supportsPartyCode: z.optional(z.boolean()),
        archived: z.optional(z.boolean()),
        properties: z.optional(zStringToStringMap)
    })),
    relationships: z.optional(z.object({
        gameCenterDetail: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            }))
        })),
        gameCenterGroup: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterGroups']),
                id: z.string()
            }))
        })),
        achievements: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAchievements']),
                id: z.string()
            })))
        })),
        achievementsV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterAchievements']),
                id: z.string()
            })))
        })),
        leaderboards: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            })))
        })),
        leaderboardsV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            })))
        })),
        versions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterActivityVersions']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterAchievementsV2Response
 */
export const zGameCenterAchievementsV2Response = z.object({
    data: z.array(zGameCenterAchievementV2),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterAchievementVersions')
        }).and(zGameCenterAchievementVersionV2),
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterAchievementV2Response
 */
export const zGameCenterAchievementV2Response = z.object({
    data: zGameCenterAchievementV2,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterAchievementVersions')
        }).and(zGameCenterAchievementVersionV2),
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup)
    ]))),
    links: zDocumentLinks
});

/**
 * GameCenterAchievementsResponse
 */
export const zGameCenterAchievementsResponse = z.object({
    data: z.array(zGameCenterAchievement),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterAchievementLocalizations')
        }).and(zGameCenterAchievementLocalization),
        z.object({
            type: z.literal('gameCenterAchievementReleases')
        }).and(zGameCenterAchievementRelease),
        z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievement),
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterAchievementResponse
 */
export const zGameCenterAchievementResponse = z.object({
    data: zGameCenterAchievement,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterAchievementLocalizations')
        }).and(zGameCenterAchievementLocalization),
        z.object({
            type: z.literal('gameCenterAchievementReleases')
        }).and(zGameCenterAchievementRelease),
        z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievement),
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup)
    ]))),
    links: zDocumentLinks
});

/**
 * GameCenterActivityCreateRequest
 */
export const zGameCenterActivityCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivities']),
        attributes: z.object({
            referenceName: z.string(),
            vendorIdentifier: z.string(),
            playStyle: z.optional(z.enum(['ASYNCHRONOUS', 'SYNCHRONOUS'])),
            minimumPlayersCount: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            maximumPlayersCount: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            supportsPartyCode: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            properties: z.optional(zStringToStringMap)
        }),
        relationships: z.optional(z.object({
            gameCenterDetail: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                }))
            })),
            gameCenterGroup: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterGroups']),
                    id: z.string()
                }))
            }))
        }))
    })
});

/**
 * GameCenterActivityUpdateRequest
 */
export const zGameCenterActivityUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterActivities']),
        id: z.string(),
        attributes: z.optional(z.object({
            referenceName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            playStyle: z.optional(z.enum(['ASYNCHRONOUS', 'SYNCHRONOUS'])),
            minimumPlayersCount: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            maximumPlayersCount: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            supportsPartyCode: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            archived: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            properties: z.optional(zStringToStringMap)
        }))
    })
});

/**
 * GameCenterLeaderboard
 */
export const zGameCenterLeaderboard = z.object({
    type: z.enum(['gameCenterLeaderboards']),
    id: z.string(),
    attributes: z.optional(z.object({
        defaultFormatter: z.optional(zGameCenterLeaderboardFormatter),
        referenceName: z.optional(z.string()),
        vendorIdentifier: z.optional(z.string()),
        submissionType: z.optional(z.enum(['BEST_SCORE', 'MOST_RECENT_SCORE'])),
        scoreSortType: z.optional(z.enum(['ASC', 'DESC'])),
        scoreRangeStart: z.optional(z.string()),
        scoreRangeEnd: z.optional(z.string()),
        recurrenceStartDate: z.optional(z.iso.datetime()),
        recurrenceDuration: z.optional(z.string()),
        recurrenceRule: z.optional(z.string()),
        archived: z.optional(z.boolean()),
        activityProperties: z.optional(zStringToStringMap),
        visibility: z.optional(z.enum(['SHOW_FOR_ALL', 'HIDE_FOR_ALL']))
    })),
    relationships: z.optional(z.object({
        gameCenterDetail: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            }))
        })),
        gameCenterGroup: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterGroups']),
                id: z.string()
            }))
        })),
        groupLeaderboard: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboards']),
                id: z.string()
            }))
        })),
        gameCenterLeaderboardSets: z.optional(z.object({
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardSets']),
                id: z.string()
            })))
        })),
        localizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardLocalizations']),
                id: z.string()
            })))
        })),
        releases: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardReleases']),
                id: z.string()
            })))
        })),
        activity: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterActivities']),
                id: z.string()
            }))
        })),
        challenge: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterChallenges']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterActivitiesResponse
 */
export const zGameCenterActivitiesResponse = z.object({
    data: z.array(zGameCenterActivity),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievement),
        z.object({
            type: z.literal('gameCenterActivityVersions')
        }).and(zGameCenterActivityVersion),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterActivityResponse
 */
export const zGameCenterActivityResponse = z.object({
    data: zGameCenterActivity,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievement),
        z.object({
            type: z.literal('gameCenterActivityVersions')
        }).and(zGameCenterActivityVersion),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)
    ]))),
    links: zDocumentLinks
});

/**
 * GameCenterChallengesResponse
 */
export const zGameCenterChallengesResponse = z.object({
    data: z.array(zGameCenterChallenge),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterChallengeVersions')
        }).and(zGameCenterChallengeVersion),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterChallengeResponse
 */
export const zGameCenterChallengeResponse = z.object({
    data: zGameCenterChallenge,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterChallengeVersions')
        }).and(zGameCenterChallengeVersion),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)
    ]))),
    links: zDocumentLinks
});

/**
 * GameCenterGroupsResponse
 */
export const zGameCenterGroupsResponse = z.object({
    data: z.array(zGameCenterGroup),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievement),
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterChallenges')
        }).and(zGameCenterChallenge),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterGroupResponse
 */
export const zGameCenterGroupResponse = z.object({
    data: zGameCenterGroup,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievement),
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterChallenges')
        }).and(zGameCenterChallenge),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)
    ]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardReleasesResponse
 */
export const zGameCenterLeaderboardReleasesResponse = z.object({
    data: z.array(zGameCenterLeaderboardRelease),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail), z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardReleaseResponse
 */
export const zGameCenterLeaderboardReleaseResponse = z.object({
    data: zGameCenterLeaderboardRelease,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail), z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardSetMemberLocalizationsResponse
 */
export const zGameCenterLeaderboardSetMemberLocalizationsResponse = z.object({
    data: z.array(zGameCenterLeaderboardSetMemberLocalization),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet), z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardSetMemberLocalizationResponse
 */
export const zGameCenterLeaderboardSetMemberLocalizationResponse = z.object({
    data: zGameCenterLeaderboardSetMemberLocalization,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet), z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardSetsResponse
 */
export const zGameCenterLeaderboardSetsResponse = z.object({
    data: z.array(zGameCenterLeaderboardSet),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboardSetLocalizations')
        }).and(zGameCenterLeaderboardSetLocalization),
        z.object({
            type: z.literal('gameCenterLeaderboardSetReleases')
        }).and(zGameCenterLeaderboardSetRelease),
        z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardSetResponse
 */
export const zGameCenterLeaderboardSetResponse = z.object({
    data: zGameCenterLeaderboardSet,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboardSetLocalizations')
        }).and(zGameCenterLeaderboardSetLocalization),
        z.object({
            type: z.literal('gameCenterLeaderboardSetReleases')
        }).and(zGameCenterLeaderboardSetRelease),
        z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)
    ]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardsResponse
 */
export const zGameCenterLeaderboardsResponse = z.object({
    data: z.array(zGameCenterLeaderboard),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterChallenges')
        }).and(zGameCenterChallenge),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboardLocalizations')
        }).and(zGameCenterLeaderboardLocalization),
        z.object({
            type: z.literal('gameCenterLeaderboardReleases')
        }).and(zGameCenterLeaderboardRelease),
        z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardResponse
 */
export const zGameCenterLeaderboardResponse = z.object({
    data: zGameCenterLeaderboard,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterChallenges')
        }).and(zGameCenterChallenge),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboardLocalizations')
        }).and(zGameCenterLeaderboardLocalization),
        z.object({
            type: z.literal('gameCenterLeaderboardReleases')
        }).and(zGameCenterLeaderboardRelease),
        z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)
    ]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardCreateRequest
 */
export const zGameCenterLeaderboardCreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboards']),
        attributes: z.object({
            defaultFormatter: zGameCenterLeaderboardFormatter,
            referenceName: z.string(),
            vendorIdentifier: z.string(),
            submissionType: z.enum(['BEST_SCORE', 'MOST_RECENT_SCORE']),
            scoreSortType: z.enum(['ASC', 'DESC']),
            scoreRangeStart: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            scoreRangeEnd: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            recurrenceStartDate: z.optional(z.union([
                z.iso.datetime(),
                z.null()
            ])),
            recurrenceDuration: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            recurrenceRule: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            activityProperties: z.optional(zStringToStringMap),
            visibility: z.optional(z.enum(['SHOW_FOR_ALL', 'HIDE_FOR_ALL']))
        }),
        relationships: z.optional(z.object({
            gameCenterDetail: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                }))
            })),
            gameCenterGroup: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterGroups']),
                    id: z.string()
                }))
            })),
            gameCenterLeaderboardSets: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['gameCenterLeaderboardSets']),
                    id: z.string()
                })))
            }))
        }))
    })
});

/**
 * GameCenterLeaderboardUpdateRequest
 */
export const zGameCenterLeaderboardUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string(),
        attributes: z.optional(z.object({
            defaultFormatter: z.optional(zGameCenterLeaderboardFormatter),
            referenceName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            submissionType: z.optional(z.enum(['BEST_SCORE', 'MOST_RECENT_SCORE'])),
            scoreSortType: z.optional(z.enum(['ASC', 'DESC'])),
            scoreRangeStart: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            scoreRangeEnd: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            recurrenceStartDate: z.optional(z.union([
                z.iso.datetime(),
                z.null()
            ])),
            recurrenceDuration: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            recurrenceRule: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            archived: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            activityProperties: z.optional(zStringToStringMap),
            visibility: z.optional(z.enum(['SHOW_FOR_ALL', 'HIDE_FOR_ALL']))
        }))
    })
});

/**
 * GameCenterLeaderboardV2
 */
export const zGameCenterLeaderboardV2 = z.object({
    type: z.enum(['gameCenterLeaderboards']),
    id: z.string(),
    attributes: z.optional(z.object({
        defaultFormatter: z.optional(zGameCenterLeaderboardFormatter),
        referenceName: z.optional(z.string()),
        vendorIdentifier: z.optional(z.string()),
        submissionType: z.optional(z.enum(['BEST_SCORE', 'MOST_RECENT_SCORE'])),
        scoreSortType: z.optional(z.enum(['ASC', 'DESC'])),
        scoreRangeStart: z.optional(z.string()),
        scoreRangeEnd: z.optional(z.string()),
        recurrenceStartDate: z.optional(z.iso.datetime()),
        recurrenceDuration: z.optional(z.string()),
        recurrenceRule: z.optional(z.string()),
        archived: z.optional(z.boolean()),
        activityProperties: z.optional(zStringToStringMap),
        visibility: z.optional(z.enum(['SHOW_FOR_ALL', 'HIDE_FOR_ALL']))
    })),
    relationships: z.optional(z.object({
        gameCenterDetail: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            }))
        })),
        gameCenterGroup: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterGroups']),
                id: z.string()
            }))
        })),
        gameCenterLeaderboardSets: z.optional(z.object({
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardSets']),
                id: z.string()
            })))
        })),
        activity: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterActivities']),
                id: z.string()
            }))
        })),
        challenge: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterChallenges']),
                id: z.string()
            }))
        })),
        versions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterLeaderboardVersions']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardSetsV2Response
 */
export const zGameCenterLeaderboardSetsV2Response = z.object({
    data: z.array(zGameCenterLeaderboardSetV2),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboardSetVersions')
        }).and(zGameCenterLeaderboardSetVersionV2),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboardV2)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardSetV2Response
 */
export const zGameCenterLeaderboardSetV2Response = z.object({
    data: zGameCenterLeaderboardSetV2,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboardSetVersions')
        }).and(zGameCenterLeaderboardSetVersionV2),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboardV2)
    ]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardVersionsV2Response
 */
export const zGameCenterLeaderboardVersionsV2Response = z.object({
    data: z.array(zGameCenterLeaderboardVersionV2),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardLocalizations')
        }).and(zGameCenterLeaderboardLocalizationV2), z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboardV2)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardVersionV2Response
 */
export const zGameCenterLeaderboardVersionV2Response = z.object({
    data: zGameCenterLeaderboardVersionV2,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardLocalizations')
        }).and(zGameCenterLeaderboardLocalizationV2), z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboardV2)]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardsV2Response
 */
export const zGameCenterLeaderboardsV2Response = z.object({
    data: z.array(zGameCenterLeaderboardV2),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterChallenges')
        }).and(zGameCenterChallenge),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSetV2),
        z.object({
            type: z.literal('gameCenterLeaderboardVersions')
        }).and(zGameCenterLeaderboardVersionV2)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardV2Response
 */
export const zGameCenterLeaderboardV2Response = z.object({
    data: zGameCenterLeaderboardV2,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterChallenges')
        }).and(zGameCenterChallenge),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSetV2),
        z.object({
            type: z.literal('gameCenterLeaderboardVersions')
        }).and(zGameCenterLeaderboardVersionV2)
    ]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardV2CreateRequest
 */
export const zGameCenterLeaderboardV2CreateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboards']),
        attributes: z.object({
            defaultFormatter: zGameCenterLeaderboardFormatter,
            referenceName: z.string(),
            vendorIdentifier: z.string(),
            submissionType: z.enum(['BEST_SCORE', 'MOST_RECENT_SCORE']),
            scoreSortType: z.enum(['ASC', 'DESC']),
            scoreRangeStart: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            scoreRangeEnd: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            recurrenceStartDate: z.optional(z.union([
                z.iso.datetime(),
                z.null()
            ])),
            recurrenceDuration: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            recurrenceRule: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            activityProperties: z.optional(zStringToStringMap),
            visibility: z.optional(z.enum(['SHOW_FOR_ALL', 'HIDE_FOR_ALL']))
        }),
        relationships: z.object({
            gameCenterDetail: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterDetails']),
                    id: z.string()
                }))
            })),
            gameCenterGroup: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['gameCenterGroups']),
                    id: z.string()
                }))
            })),
            gameCenterLeaderboardSets: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['gameCenterLeaderboardSets']),
                    id: z.string()
                })))
            })),
            versions: z.object({
                data: z.array(z.object({
                    type: z.enum(['gameCenterLeaderboardVersions']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(zGameCenterLeaderboardVersionV2InlineCreate))
});

/**
 * GameCenterLeaderboardV2UpdateRequest
 */
export const zGameCenterLeaderboardV2UpdateRequest = z.object({
    data: z.object({
        type: z.enum(['gameCenterLeaderboards']),
        id: z.string(),
        attributes: z.optional(z.object({
            defaultFormatter: z.optional(zGameCenterLeaderboardFormatter),
            referenceName: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            submissionType: z.optional(z.enum(['BEST_SCORE', 'MOST_RECENT_SCORE'])),
            scoreSortType: z.optional(z.enum(['ASC', 'DESC'])),
            scoreRangeStart: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            scoreRangeEnd: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            recurrenceStartDate: z.optional(z.union([
                z.iso.datetime(),
                z.null()
            ])),
            recurrenceDuration: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            recurrenceRule: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            archived: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            activityProperties: z.optional(zStringToStringMap),
            visibility: z.optional(z.enum(['SHOW_FOR_ALL', 'HIDE_FOR_ALL']))
        }))
    })
});

export const zSubscriptionCustomerEligibility = z.enum([
    'NEW',
    'EXISTING',
    'EXPIRED'
]);

export const zSubscriptionGracePeriodDuration = z.enum([
    'THREE_DAYS',
    'SIXTEEN_DAYS',
    'TWENTY_EIGHT_DAYS'
]);

/**
 * SubscriptionGracePeriod
 */
export const zSubscriptionGracePeriod = z.object({
    type: z.enum(['subscriptionGracePeriods']),
    id: z.string(),
    attributes: z.optional(z.object({
        optIn: z.optional(z.boolean()),
        sandboxOptIn: z.optional(z.boolean()),
        duration: z.optional(zSubscriptionGracePeriodDuration),
        renewalType: z.optional(z.enum(['ALL_RENEWALS', 'PAID_TO_PAID_ONLY']))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionGracePeriodResponse
 */
export const zSubscriptionGracePeriodResponse = z.object({
    data: zSubscriptionGracePeriod,
    links: zDocumentLinks
});

/**
 * SubscriptionGracePeriodUpdateRequest
 */
export const zSubscriptionGracePeriodUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionGracePeriods']),
        id: z.string(),
        attributes: z.optional(z.object({
            optIn: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            sandboxOptIn: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            duration: z.optional(zSubscriptionGracePeriodDuration),
            renewalType: z.optional(z.enum(['ALL_RENEWALS', 'PAID_TO_PAID_ONLY']))
        }))
    })
});

export const zSubscriptionOfferDuration = z.enum([
    'THREE_DAYS',
    'ONE_WEEK',
    'TWO_WEEKS',
    'ONE_MONTH',
    'TWO_MONTHS',
    'THREE_MONTHS',
    'SIX_MONTHS',
    'ONE_YEAR'
]);

export const zSubscriptionOfferEligibility = z.enum(['STACK_WITH_INTRO_OFFERS', 'REPLACE_INTRO_OFFERS']);

export const zSubscriptionOfferMode = z.enum([
    'PAY_AS_YOU_GO',
    'PAY_UP_FRONT',
    'FREE_TRIAL'
]);

/**
 * SubscriptionIntroductoryOffer
 */
export const zSubscriptionIntroductoryOffer = z.object({
    type: z.enum(['subscriptionIntroductoryOffers']),
    id: z.string(),
    attributes: z.optional(z.object({
        startDate: z.optional(z.iso.date()),
        endDate: z.optional(z.iso.date()),
        duration: z.optional(zSubscriptionOfferDuration),
        offerMode: z.optional(zSubscriptionOfferMode),
        numberOfPeriods: z.optional(z.int())
    })),
    relationships: z.optional(z.object({
        subscription: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptions']),
                id: z.string()
            }))
        })),
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        subscriptionPricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionPricePoints']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

export const zSubscriptionIntroductoryOfferInlineCreate = z.object({
    type: z.enum(['subscriptionIntroductoryOffers']),
    id: z.optional(z.string()),
    attributes: z.object({
        startDate: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        endDate: z.optional(z.union([
            z.iso.date(),
            z.null()
        ])),
        duration: zSubscriptionOfferDuration,
        offerMode: zSubscriptionOfferMode,
        numberOfPeriods: z.int()
    }),
    relationships: z.optional(z.object({
        subscription: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptions']),
                id: z.string()
            }))
        })),
        territory: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['territories']),
                id: z.string()
            }))
        })),
        subscriptionPricePoint: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptionPricePoints']),
                id: z.string()
            }))
        }))
    }))
});

/**
 * SubscriptionIntroductoryOffersResponse
 */
export const zSubscriptionIntroductoryOffersResponse = z.object({
    data: z.array(zSubscriptionIntroductoryOffer),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('subscriptionPricePoints')
        }).and(zSubscriptionPricePoint),
        z.object({
            type: z.literal('subscriptions')
        }).and(zSubscription),
        z.object({
            type: z.literal('territories')
        }).and(zTerritory)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionIntroductoryOfferResponse
 */
export const zSubscriptionIntroductoryOfferResponse = z.object({
    data: zSubscriptionIntroductoryOffer,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('subscriptionPricePoints')
        }).and(zSubscriptionPricePoint),
        z.object({
            type: z.literal('subscriptions')
        }).and(zSubscription),
        z.object({
            type: z.literal('territories')
        }).and(zTerritory)
    ]))),
    links: zDocumentLinks
});

/**
 * SubscriptionIntroductoryOfferCreateRequest
 */
export const zSubscriptionIntroductoryOfferCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionIntroductoryOffers']),
        attributes: z.object({
            startDate: z.optional(z.union([
                z.iso.date(),
                z.null()
            ])),
            endDate: z.optional(z.union([
                z.iso.date(),
                z.null()
            ])),
            duration: zSubscriptionOfferDuration,
            offerMode: zSubscriptionOfferMode,
            numberOfPeriods: z.int()
        }),
        relationships: z.object({
            subscription: z.object({
                data: z.object({
                    type: z.enum(['subscriptions']),
                    id: z.string()
                })
            }),
            territory: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['territories']),
                    id: z.string()
                }))
            })),
            subscriptionPricePoint: z.optional(z.object({
                data: z.optional(z.object({
                    type: z.enum(['subscriptionPricePoints']),
                    id: z.string()
                }))
            }))
        })
    }),
    included: z.optional(z.array(zSubscriptionPricePointInlineCreate))
});

/**
 * SubscriptionOfferCode
 */
export const zSubscriptionOfferCode = z.object({
    type: z.enum(['subscriptionOfferCodes']),
    id: z.string(),
    attributes: z.optional(z.object({
        name: z.optional(z.string()),
        customerEligibilities: z.optional(z.array(zSubscriptionCustomerEligibility)),
        offerEligibility: z.optional(zSubscriptionOfferEligibility),
        duration: z.optional(zSubscriptionOfferDuration),
        offerMode: z.optional(zSubscriptionOfferMode),
        numberOfPeriods: z.optional(z.int()),
        totalNumberOfCodes: z.optional(z.int()),
        productionCodeCount: z.optional(z.int()),
        sandboxCodeCount: z.optional(z.int()),
        active: z.optional(z.boolean()),
        autoRenewEnabled: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        subscription: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptions']),
                id: z.string()
            }))
        })),
        oneTimeUseCodes: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionOfferCodeOneTimeUseCodes']),
                id: z.string()
            })))
        })),
        customCodes: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionOfferCodeCustomCodes']),
                id: z.string()
            })))
        })),
        prices: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionOfferCodePrices']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionOfferCodeCustomCodesResponse
 */
export const zSubscriptionOfferCodeCustomCodesResponse = z.object({
    data: z.array(zSubscriptionOfferCodeCustomCode),
    included: z.optional(z.array(zSubscriptionOfferCode)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionOfferCodeCustomCodeResponse
 */
export const zSubscriptionOfferCodeCustomCodeResponse = z.object({
    data: zSubscriptionOfferCodeCustomCode,
    included: z.optional(z.array(zSubscriptionOfferCode)),
    links: zDocumentLinks
});

/**
 * SubscriptionOfferCodeOneTimeUseCodesResponse
 */
export const zSubscriptionOfferCodeOneTimeUseCodesResponse = z.object({
    data: z.array(zSubscriptionOfferCodeOneTimeUseCode),
    included: z.optional(z.array(zSubscriptionOfferCode)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionOfferCodeOneTimeUseCodeResponse
 */
export const zSubscriptionOfferCodeOneTimeUseCodeResponse = z.object({
    data: zSubscriptionOfferCodeOneTimeUseCode,
    included: z.optional(z.array(zSubscriptionOfferCode)),
    links: zDocumentLinks
});

/**
 * SubscriptionOfferCodesResponse
 */
export const zSubscriptionOfferCodesResponse = z.object({
    data: z.array(zSubscriptionOfferCode),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('subscriptionOfferCodeCustomCodes')
        }).and(zSubscriptionOfferCodeCustomCode),
        z.object({
            type: z.literal('subscriptionOfferCodeOneTimeUseCodes')
        }).and(zSubscriptionOfferCodeOneTimeUseCode),
        z.object({
            type: z.literal('subscriptionOfferCodePrices')
        }).and(zSubscriptionOfferCodePrice),
        z.object({
            type: z.literal('subscriptions')
        }).and(zSubscription)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionOfferCodeResponse
 */
export const zSubscriptionOfferCodeResponse = z.object({
    data: zSubscriptionOfferCode,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('subscriptionOfferCodeCustomCodes')
        }).and(zSubscriptionOfferCodeCustomCode),
        z.object({
            type: z.literal('subscriptionOfferCodeOneTimeUseCodes')
        }).and(zSubscriptionOfferCodeOneTimeUseCode),
        z.object({
            type: z.literal('subscriptionOfferCodePrices')
        }).and(zSubscriptionOfferCodePrice),
        z.object({
            type: z.literal('subscriptions')
        }).and(zSubscription)
    ]))),
    links: zDocumentLinks
});

/**
 * SubscriptionOfferCodeCreateRequest
 */
export const zSubscriptionOfferCodeCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionOfferCodes']),
        attributes: z.object({
            name: z.string(),
            customerEligibilities: z.array(zSubscriptionCustomerEligibility),
            offerEligibility: zSubscriptionOfferEligibility,
            duration: zSubscriptionOfferDuration,
            offerMode: zSubscriptionOfferMode,
            numberOfPeriods: z.int(),
            autoRenewEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }),
        relationships: z.object({
            subscription: z.object({
                data: z.object({
                    type: z.enum(['subscriptions']),
                    id: z.string()
                })
            }),
            prices: z.object({
                data: z.array(z.object({
                    type: z.enum(['subscriptionOfferCodePrices']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(zSubscriptionOfferCodePriceInlineCreate))
});

/**
 * SubscriptionPromotionalOffer
 */
export const zSubscriptionPromotionalOffer = z.object({
    type: z.enum(['subscriptionPromotionalOffers']),
    id: z.string(),
    attributes: z.optional(z.object({
        duration: z.optional(zSubscriptionOfferDuration),
        name: z.optional(z.string()),
        numberOfPeriods: z.optional(z.int()),
        offerCode: z.optional(z.string()),
        offerMode: z.optional(zSubscriptionOfferMode)
    })),
    relationships: z.optional(z.object({
        subscription: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptions']),
                id: z.string()
            }))
        })),
        prices: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionPromotionalOfferPrices']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

export const zSubscriptionPromotionalOfferInlineCreate = z.object({
    type: z.enum(['subscriptionPromotionalOffers']),
    id: z.optional(z.string()),
    attributes: z.object({
        duration: zSubscriptionOfferDuration,
        name: z.string(),
        numberOfPeriods: z.int(),
        offerCode: z.string(),
        offerMode: zSubscriptionOfferMode
    }),
    relationships: z.optional(z.object({
        subscription: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptions']),
                id: z.string()
            }))
        })),
        prices: z.optional(z.object({
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionPromotionalOfferPrices']),
                id: z.string()
            })))
        }))
    }))
});

/**
 * SubscriptionPromotionalOffersResponse
 */
export const zSubscriptionPromotionalOffersResponse = z.object({
    data: z.array(zSubscriptionPromotionalOffer),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('subscriptionPromotionalOfferPrices')
        }).and(zSubscriptionPromotionalOfferPrice), z.object({
            type: z.literal('subscriptions')
        }).and(zSubscription)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionPromotionalOfferResponse
 */
export const zSubscriptionPromotionalOfferResponse = z.object({
    data: zSubscriptionPromotionalOffer,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('subscriptionPromotionalOfferPrices')
        }).and(zSubscriptionPromotionalOfferPrice), z.object({
            type: z.literal('subscriptions')
        }).and(zSubscription)]))),
    links: zDocumentLinks
});

/**
 * SubscriptionPromotionalOfferCreateRequest
 */
export const zSubscriptionPromotionalOfferCreateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptionPromotionalOffers']),
        attributes: z.object({
            duration: zSubscriptionOfferDuration,
            name: z.string(),
            numberOfPeriods: z.int(),
            offerCode: z.string(),
            offerMode: zSubscriptionOfferMode
        }),
        relationships: z.object({
            subscription: z.object({
                data: z.object({
                    type: z.enum(['subscriptions']),
                    id: z.string()
                })
            }),
            prices: z.object({
                data: z.array(z.object({
                    type: z.enum(['subscriptionPromotionalOfferPrices']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(zSubscriptionPromotionalOfferPriceInlineCreate))
});

/**
 * SubscriptionUpdateRequest
 */
export const zSubscriptionUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['subscriptions']),
        id: z.string(),
        attributes: z.optional(z.object({
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            familySharable: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            subscriptionPeriod: z.optional(z.enum([
                'ONE_WEEK',
                'ONE_MONTH',
                'TWO_MONTHS',
                'THREE_MONTHS',
                'SIX_MONTHS',
                'ONE_YEAR'
            ])),
            reviewNote: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            groupLevel: z.optional(z.union([
                z.int(),
                z.null()
            ]))
        })),
        relationships: z.optional(z.object({
            introductoryOffers: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['subscriptionIntroductoryOffers']),
                    id: z.string()
                })))
            })),
            promotionalOffers: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['subscriptionPromotionalOffers']),
                    id: z.string()
                })))
            })),
            prices: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['subscriptionPrices']),
                    id: z.string()
                })))
            }))
        }))
    }),
    included: z.optional(z.array(z.union([
        zSubscriptionPromotionalOfferInlineCreate,
        zSubscriptionPriceInlineCreate,
        zSubscriptionIntroductoryOfferInlineCreate
    ])))
});

/**
 * WinBackOffer
 */
export const zWinBackOffer = z.object({
    type: z.enum(['winBackOffers']),
    id: z.string(),
    attributes: z.optional(z.object({
        referenceName: z.optional(z.string()),
        offerId: z.optional(z.string()),
        duration: z.optional(zSubscriptionOfferDuration),
        offerMode: z.optional(zSubscriptionOfferMode),
        periodCount: z.optional(z.int()),
        customerEligibilityPaidSubscriptionDurationInMonths: z.optional(z.int()),
        customerEligibilityTimeSinceLastSubscribedInMonths: z.optional(zIntegerRange),
        customerEligibilityWaitBetweenOffersInMonths: z.optional(z.int()),
        startDate: z.optional(z.iso.date()),
        endDate: z.optional(z.iso.date()),
        priority: z.optional(z.enum(['HIGH', 'NORMAL'])),
        promotionIntent: z.optional(z.enum(['NOT_PROMOTED', 'USE_AUTO_GENERATED_ASSETS']))
    })),
    relationships: z.optional(z.object({
        prices: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['winBackOfferPrices']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * WinBackOffersResponse
 */
export const zWinBackOffersResponse = z.object({
    data: z.array(zWinBackOffer),
    included: z.optional(z.array(zWinBackOfferPrice)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * WinBackOfferResponse
 */
export const zWinBackOfferResponse = z.object({
    data: zWinBackOffer,
    included: z.optional(z.array(zWinBackOfferPrice)),
    links: zDocumentLinks
});

/**
 * WinBackOfferCreateRequest
 */
export const zWinBackOfferCreateRequest = z.object({
    data: z.object({
        type: z.enum(['winBackOffers']),
        attributes: z.object({
            referenceName: z.string(),
            offerId: z.string(),
            duration: zSubscriptionOfferDuration,
            offerMode: zSubscriptionOfferMode,
            periodCount: z.int(),
            customerEligibilityPaidSubscriptionDurationInMonths: z.int(),
            customerEligibilityTimeSinceLastSubscribedInMonths: zIntegerRange,
            customerEligibilityWaitBetweenOffersInMonths: z.optional(z.union([
                z.int(),
                z.null()
            ])),
            startDate: z.iso.date(),
            endDate: z.optional(z.union([
                z.iso.date(),
                z.null()
            ])),
            priority: z.enum(['HIGH', 'NORMAL']),
            promotionIntent: z.optional(z.enum(['NOT_PROMOTED', 'USE_AUTO_GENERATED_ASSETS']))
        }),
        relationships: z.object({
            subscription: z.object({
                data: z.object({
                    type: z.enum(['subscriptions']),
                    id: z.string()
                })
            }),
            prices: z.object({
                data: z.array(z.object({
                    type: z.enum(['winBackOfferPrices']),
                    id: z.string()
                }))
            })
        })
    }),
    included: z.optional(z.array(zWinBackOfferPriceInlineCreate))
});

export const zSubscriptionStatusUrlVersion = z.enum(['V1', 'V2']);

/**
 * App
 */
export const zApp = z.object({
    type: z.enum(['apps']),
    id: z.string(),
    attributes: z.optional(z.object({
        accessibilityUrl: z.optional(z.url()),
        name: z.optional(z.string()),
        bundleId: z.optional(z.string()),
        sku: z.optional(z.string()),
        primaryLocale: z.optional(z.string()),
        isOrEverWasMadeForKids: z.optional(z.boolean()),
        subscriptionStatusUrl: z.optional(z.url()),
        subscriptionStatusUrlVersion: z.optional(zSubscriptionStatusUrlVersion),
        subscriptionStatusUrlForSandbox: z.optional(z.url()),
        subscriptionStatusUrlVersionForSandbox: z.optional(zSubscriptionStatusUrlVersion),
        contentRightsDeclaration: z.optional(z.enum(['DOES_NOT_USE_THIRD_PARTY_CONTENT', 'USES_THIRD_PARTY_CONTENT'])),
        streamlinedPurchasingEnabled: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        accessibilityDeclarations: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        appEncryptionDeclarations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appEncryptionDeclarations']),
                id: z.string()
            })))
        })),
        appStoreIcon: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['buildIcons']),
                id: z.string()
            }))
        })),
        ciProduct: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['ciProducts']),
                id: z.string()
            }))
        })),
        betaTesters: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        betaGroups: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['betaGroups']),
                id: z.string()
            })))
        })),
        appStoreVersions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            })))
        })),
        appTags: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        preReleaseVersions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['preReleaseVersions']),
                id: z.string()
            })))
        })),
        betaAppLocalizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['betaAppLocalizations']),
                id: z.string()
            })))
        })),
        builds: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['builds']),
                id: z.string()
            })))
        })),
        betaLicenseAgreement: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['betaLicenseAgreements']),
                id: z.string()
            }))
        })),
        betaAppReviewDetail: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['betaAppReviewDetails']),
                id: z.string()
            }))
        })),
        appInfos: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appInfos']),
                id: z.string()
            })))
        })),
        appClips: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appClips']),
                id: z.string()
            })))
        })),
        appPricePoints: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        endUserLicenseAgreement: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['endUserLicenseAgreements']),
                id: z.string()
            }))
        })),
        appPriceSchedule: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        appAvailabilityV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        inAppPurchases: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['inAppPurchases']),
                id: z.string()
            })))
        })),
        subscriptionGroups: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['subscriptionGroups']),
                id: z.string()
            })))
        })),
        gameCenterEnabledVersions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['gameCenterEnabledVersions']),
                id: z.string()
            })))
        })),
        perfPowerMetrics: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        appCustomProductPages: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appCustomProductPages']),
                id: z.string()
            })))
        })),
        inAppPurchasesV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['inAppPurchases']),
                id: z.string()
            })))
        })),
        promotedPurchases: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['promotedPurchases']),
                id: z.string()
            })))
        })),
        appEvents: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appEvents']),
                id: z.string()
            })))
        })),
        reviewSubmissions: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['reviewSubmissions']),
                id: z.string()
            })))
        })),
        subscriptionGracePeriod: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['subscriptionGracePeriods']),
                id: z.string()
            }))
        })),
        customerReviews: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        customerReviewSummarizations: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        gameCenterDetail: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['gameCenterDetails']),
                id: z.string()
            }))
        })),
        appStoreVersionExperimentsV2: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['appStoreVersionExperiments']),
                id: z.string()
            })))
        })),
        alternativeDistributionKey: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        analyticsReportRequests: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        marketplaceSearchDetail: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        buildUploads: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        backgroundAssets: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        betaFeedbackScreenshotSubmissions: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        betaFeedbackCrashSubmissions: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        searchKeywords: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        webhooks: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        })),
        androidToIosAppMappingDetails: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['androidToIosAppMappingDetails']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppClipsResponse
 */
export const zAppClipsResponse = z.object({
    data: z.array(zAppClip),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appClipDefaultExperiences')
        }).and(zAppClipDefaultExperience), z.object({
            type: z.literal('apps')
        }).and(zApp)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppClipResponse
 */
export const zAppClipResponse = z.object({
    data: zAppClip,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appClipDefaultExperiences')
        }).and(zAppClipDefaultExperience), z.object({
            type: z.literal('apps')
        }).and(zApp)]))),
    links: zDocumentLinks
});

/**
 * AppCustomProductPagesResponse
 */
export const zAppCustomProductPagesResponse = z.object({
    data: z.array(zAppCustomProductPage),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appCustomProductPageLocalizations')
        }).and(zAppCustomProductPageLocalization),
        z.object({
            type: z.literal('appCustomProductPageVersions')
        }).and(zAppCustomProductPageVersion),
        z.object({
            type: z.literal('apps')
        }).and(zApp)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppCustomProductPageResponse
 */
export const zAppCustomProductPageResponse = z.object({
    data: zAppCustomProductPage,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appCustomProductPageLocalizations')
        }).and(zAppCustomProductPageLocalization),
        z.object({
            type: z.literal('appCustomProductPageVersions')
        }).and(zAppCustomProductPageVersion),
        z.object({
            type: z.literal('apps')
        }).and(zApp)
    ]))),
    links: zDocumentLinks
});

/**
 * AppInfosResponse
 */
export const zAppInfosResponse = z.object({
    data: z.array(zAppInfo),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('ageRatingDeclarations')
        }).and(zAgeRatingDeclaration),
        z.object({
            type: z.literal('appCategories')
        }).and(zAppCategory),
        z.object({
            type: z.literal('appInfoLocalizations')
        }).and(zAppInfoLocalization),
        z.object({
            type: z.literal('apps')
        }).and(zApp)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppInfoResponse
 */
export const zAppInfoResponse = z.object({
    data: zAppInfo,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('ageRatingDeclarations')
        }).and(zAgeRatingDeclaration),
        z.object({
            type: z.literal('appCategories')
        }).and(zAppCategory),
        z.object({
            type: z.literal('appInfoLocalizations')
        }).and(zAppInfoLocalization),
        z.object({
            type: z.literal('apps')
        }).and(zApp)
    ]))),
    links: zDocumentLinks
});

/**
 * AppPricePointsV3Response
 */
export const zAppPricePointsV3Response = z.object({
    data: z.array(zAppPricePointV3),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('apps')
        }).and(zApp), z.object({
            type: z.literal('territories')
        }).and(zTerritory)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppPricePointV3Response
 */
export const zAppPricePointV3Response = z.object({
    data: zAppPricePointV3,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('apps')
        }).and(zApp), z.object({
            type: z.literal('territories')
        }).and(zTerritory)]))),
    links: zDocumentLinks
});

/**
 * AppPriceScheduleResponse
 */
export const zAppPriceScheduleResponse = z.object({
    data: zAppPriceSchedule,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appPrices')
        }).and(zAppPriceV2),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('territories')
        }).and(zTerritory)
    ]))),
    links: zDocumentLinks
});

/**
 * AppStoreVersionExperimentsV2Response
 */
export const zAppStoreVersionExperimentsV2Response = z.object({
    data: z.array(zAppStoreVersionExperimentV2),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appStoreVersionExperimentTreatments')
        }).and(zAppStoreVersionExperimentTreatment),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion),
        z.object({
            type: z.literal('apps')
        }).and(zApp)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppStoreVersionExperimentV2Response
 */
export const zAppStoreVersionExperimentV2Response = z.object({
    data: zAppStoreVersionExperimentV2,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appStoreVersionExperimentTreatments')
        }).and(zAppStoreVersionExperimentTreatment),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion),
        z.object({
            type: z.literal('apps')
        }).and(zApp)
    ]))),
    links: zDocumentLinks
});

/**
 * AppsResponse
 */
export const zAppsResponse = z.object({
    data: z.array(zApp),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('androidToIosAppMappingDetails')
        }).and(zAndroidToIosAppMappingDetail),
        z.object({
            type: z.literal('appClips')
        }).and(zAppClip),
        z.object({
            type: z.literal('appCustomProductPages')
        }).and(zAppCustomProductPage),
        z.object({
            type: z.literal('appEncryptionDeclarations')
        }).and(zAppEncryptionDeclaration),
        z.object({
            type: z.literal('appEvents')
        }).and(zAppEvent),
        z.object({
            type: z.literal('appInfos')
        }).and(zAppInfo),
        z.object({
            type: z.literal('appStoreVersionExperiments')
        }).and(zAppStoreVersionExperimentV2),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion),
        z.object({
            type: z.literal('betaAppLocalizations')
        }).and(zBetaAppLocalization),
        z.object({
            type: z.literal('betaAppReviewDetails')
        }).and(zBetaAppReviewDetail),
        z.object({
            type: z.literal('betaGroups')
        }).and(zBetaGroup),
        z.object({
            type: z.literal('betaLicenseAgreements')
        }).and(zBetaLicenseAgreement),
        z.object({
            type: z.literal('buildIcons')
        }).and(zBuildIcon),
        z.object({
            type: z.literal('builds')
        }).and(zBuild),
        z.object({
            type: z.literal('ciProducts')
        }).and(zCiProduct),
        z.object({
            type: z.literal('endUserLicenseAgreements')
        }).and(zEndUserLicenseAgreement),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterEnabledVersions')
        }).and(zGameCenterEnabledVersion),
        z.object({
            type: z.literal('inAppPurchases')
        }).and(zInAppPurchase),
        z.object({
            type: z.literal('preReleaseVersions')
        }).and(zPrereleaseVersion),
        z.object({
            type: z.literal('promotedPurchases')
        }).and(zPromotedPurchase),
        z.object({
            type: z.literal('reviewSubmissions')
        }).and(zReviewSubmission),
        z.object({
            type: z.literal('subscriptionGracePeriods')
        }).and(zSubscriptionGracePeriod),
        z.object({
            type: z.literal('subscriptionGroups')
        }).and(zSubscriptionGroup)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppResponse
 */
export const zAppResponse = z.object({
    data: zApp,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('androidToIosAppMappingDetails')
        }).and(zAndroidToIosAppMappingDetail),
        z.object({
            type: z.literal('appClips')
        }).and(zAppClip),
        z.object({
            type: z.literal('appCustomProductPages')
        }).and(zAppCustomProductPage),
        z.object({
            type: z.literal('appEncryptionDeclarations')
        }).and(zAppEncryptionDeclaration),
        z.object({
            type: z.literal('appEvents')
        }).and(zAppEvent),
        z.object({
            type: z.literal('appInfos')
        }).and(zAppInfo),
        z.object({
            type: z.literal('appStoreVersionExperiments')
        }).and(zAppStoreVersionExperimentV2),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion),
        z.object({
            type: z.literal('betaAppLocalizations')
        }).and(zBetaAppLocalization),
        z.object({
            type: z.literal('betaAppReviewDetails')
        }).and(zBetaAppReviewDetail),
        z.object({
            type: z.literal('betaGroups')
        }).and(zBetaGroup),
        z.object({
            type: z.literal('betaLicenseAgreements')
        }).and(zBetaLicenseAgreement),
        z.object({
            type: z.literal('buildIcons')
        }).and(zBuildIcon),
        z.object({
            type: z.literal('builds')
        }).and(zBuild),
        z.object({
            type: z.literal('ciProducts')
        }).and(zCiProduct),
        z.object({
            type: z.literal('endUserLicenseAgreements')
        }).and(zEndUserLicenseAgreement),
        z.object({
            type: z.literal('gameCenterDetails')
        }).and(zGameCenterDetail),
        z.object({
            type: z.literal('gameCenterEnabledVersions')
        }).and(zGameCenterEnabledVersion),
        z.object({
            type: z.literal('inAppPurchases')
        }).and(zInAppPurchase),
        z.object({
            type: z.literal('preReleaseVersions')
        }).and(zPrereleaseVersion),
        z.object({
            type: z.literal('promotedPurchases')
        }).and(zPromotedPurchase),
        z.object({
            type: z.literal('reviewSubmissions')
        }).and(zReviewSubmission),
        z.object({
            type: z.literal('subscriptionGracePeriods')
        }).and(zSubscriptionGracePeriod),
        z.object({
            type: z.literal('subscriptionGroups')
        }).and(zSubscriptionGroup)
    ]))),
    links: zDocumentLinks
});

/**
 * AppUpdateRequest
 */
export const zAppUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['apps']),
        id: z.string(),
        attributes: z.optional(z.object({
            accessibilityUrl: z.optional(z.union([
                z.url(),
                z.null()
            ])),
            bundleId: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            primaryLocale: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            subscriptionStatusUrl: z.optional(z.union([
                z.url(),
                z.null()
            ])),
            subscriptionStatusUrlVersion: z.optional(zSubscriptionStatusUrlVersion),
            subscriptionStatusUrlForSandbox: z.optional(z.union([
                z.url(),
                z.null()
            ])),
            subscriptionStatusUrlVersionForSandbox: z.optional(zSubscriptionStatusUrlVersion),
            contentRightsDeclaration: z.optional(z.enum(['DOES_NOT_USE_THIRD_PARTY_CONTENT', 'USES_THIRD_PARTY_CONTENT'])),
            streamlinedPurchasingEnabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }))
    })
});

/**
 * BackgroundAssetsResponse
 */
export const zBackgroundAssetsResponse = z.object({
    data: z.array(zBackgroundAsset),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('apps')
        }).and(zApp), z.object({
            type: z.literal('backgroundAssetVersions')
        }).and(zBackgroundAssetVersion)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BackgroundAssetResponse
 */
export const zBackgroundAssetResponse = z.object({
    data: zBackgroundAsset,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('apps')
        }).and(zApp), z.object({
            type: z.literal('backgroundAssetVersions')
        }).and(zBackgroundAssetVersion)]))),
    links: zDocumentLinks
});

/**
 * BetaAppLocalizationsResponse
 */
export const zBetaAppLocalizationsResponse = z.object({
    data: z.array(zBetaAppLocalization),
    included: z.optional(z.array(zApp)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaAppLocalizationResponse
 */
export const zBetaAppLocalizationResponse = z.object({
    data: zBetaAppLocalization,
    included: z.optional(z.array(zApp)),
    links: zDocumentLinks
});

/**
 * BetaAppReviewDetailsResponse
 */
export const zBetaAppReviewDetailsResponse = z.object({
    data: z.array(zBetaAppReviewDetail),
    included: z.optional(z.array(zApp)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaAppReviewDetailResponse
 */
export const zBetaAppReviewDetailResponse = z.object({
    data: zBetaAppReviewDetail,
    included: z.optional(z.array(zApp)),
    links: zDocumentLinks
});

/**
 * BetaGroupsResponse
 */
export const zBetaGroupsResponse = z.object({
    data: z.array(zBetaGroup),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('betaRecruitmentCriteria')
        }).and(zBetaRecruitmentCriterion),
        z.object({
            type: z.literal('betaTesters')
        }).and(zBetaTester),
        z.object({
            type: z.literal('builds')
        }).and(zBuild)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaGroupResponse
 */
export const zBetaGroupResponse = z.object({
    data: zBetaGroup,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('betaRecruitmentCriteria')
        }).and(zBetaRecruitmentCriterion),
        z.object({
            type: z.literal('betaTesters')
        }).and(zBetaTester),
        z.object({
            type: z.literal('builds')
        }).and(zBuild)
    ]))),
    links: zDocumentLinks
});

/**
 * BetaLicenseAgreementsResponse
 */
export const zBetaLicenseAgreementsResponse = z.object({
    data: z.array(zBetaLicenseAgreement),
    included: z.optional(z.array(zApp)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaLicenseAgreementResponse
 */
export const zBetaLicenseAgreementResponse = z.object({
    data: zBetaLicenseAgreement,
    included: z.optional(z.array(zApp)),
    links: zDocumentLinks
});

/**
 * BetaTestersResponse
 */
export const zBetaTestersResponse = z.object({
    data: z.array(zBetaTester),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('betaGroups')
        }).and(zBetaGroup),
        z.object({
            type: z.literal('builds')
        }).and(zBuild)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BetaTesterResponse
 */
export const zBetaTesterResponse = z.object({
    data: zBetaTester,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('betaGroups')
        }).and(zBetaGroup),
        z.object({
            type: z.literal('builds')
        }).and(zBuild)
    ]))),
    links: zDocumentLinks
});

/**
 * BuildsResponse
 */
export const zBuildsResponse = z.object({
    data: z.array(zBuild),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appEncryptionDeclarations')
        }).and(zAppEncryptionDeclaration),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('betaAppReviewSubmissions')
        }).and(zBetaAppReviewSubmission),
        z.object({
            type: z.literal('betaBuildLocalizations')
        }).and(zBetaBuildLocalization),
        z.object({
            type: z.literal('betaGroups')
        }).and(zBetaGroup),
        z.object({
            type: z.literal('betaTesters')
        }).and(zBetaTester),
        z.object({
            type: z.literal('buildBetaDetails')
        }).and(zBuildBetaDetail),
        z.object({
            type: z.literal('buildBundles')
        }).and(zBuildBundle),
        z.object({
            type: z.literal('buildIcons')
        }).and(zBuildIcon),
        z.object({
            type: z.literal('buildUploads')
        }).and(zBuildUpload),
        z.object({
            type: z.literal('preReleaseVersions')
        }).and(zPrereleaseVersion)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BuildResponse
 */
export const zBuildResponse = z.object({
    data: zBuild,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appEncryptionDeclarations')
        }).and(zAppEncryptionDeclaration),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('betaAppReviewSubmissions')
        }).and(zBetaAppReviewSubmission),
        z.object({
            type: z.literal('betaBuildLocalizations')
        }).and(zBetaBuildLocalization),
        z.object({
            type: z.literal('betaGroups')
        }).and(zBetaGroup),
        z.object({
            type: z.literal('betaTesters')
        }).and(zBetaTester),
        z.object({
            type: z.literal('buildBetaDetails')
        }).and(zBuildBetaDetail),
        z.object({
            type: z.literal('buildBundles')
        }).and(zBuildBundle),
        z.object({
            type: z.literal('buildIcons')
        }).and(zBuildIcon),
        z.object({
            type: z.literal('buildUploads')
        }).and(zBuildUpload),
        z.object({
            type: z.literal('preReleaseVersions')
        }).and(zPrereleaseVersion)
    ]))),
    links: zDocumentLinks
});

/**
 * BundleIdsResponse
 */
export const zBundleIdsResponse = z.object({
    data: z.array(zBundleId),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('bundleIdCapabilities')
        }).and(zBundleIdCapability),
        z.object({
            type: z.literal('profiles')
        }).and(zProfile)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * BundleIdResponse
 */
export const zBundleIdResponse = z.object({
    data: zBundleId,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('bundleIdCapabilities')
        }).and(zBundleIdCapability),
        z.object({
            type: z.literal('profiles')
        }).and(zProfile)
    ]))),
    links: zDocumentLinks
});

/**
 * CiProductsResponse
 */
export const zCiProductsResponse = z.object({
    data: z.array(zCiProduct),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('bundleIds')
        }).and(zBundleId),
        z.object({
            type: z.literal('scmRepositories')
        }).and(zScmRepository)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * CiProductResponse
 */
export const zCiProductResponse = z.object({
    data: zCiProduct,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('bundleIds')
        }).and(zBundleId),
        z.object({
            type: z.literal('scmRepositories')
        }).and(zScmRepository)
    ]))),
    links: zDocumentLinks
});

/**
 * EndUserLicenseAgreementResponse
 */
export const zEndUserLicenseAgreementResponse = z.object({
    data: zEndUserLicenseAgreement,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('apps')
        }).and(zApp), z.object({
            type: z.literal('territories')
        }).and(zTerritory)]))),
    links: zDocumentLinks
});

/**
 * GameCenterDetailsResponse
 */
export const zGameCenterDetailsResponse = z.object({
    data: z.array(zGameCenterDetail),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('gameCenterAchievementReleases')
        }).and(zGameCenterAchievementRelease),
        z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievement),
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterActivityVersionReleases')
        }).and(zGameCenterActivityVersionRelease),
        z.object({
            type: z.literal('gameCenterAppVersions')
        }).and(zGameCenterAppVersion),
        z.object({
            type: z.literal('gameCenterChallengeVersionReleases')
        }).and(zGameCenterChallengeVersionRelease),
        z.object({
            type: z.literal('gameCenterChallenges')
        }).and(zGameCenterChallenge),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboardReleases')
        }).and(zGameCenterLeaderboardRelease),
        z.object({
            type: z.literal('gameCenterLeaderboardSetReleases')
        }).and(zGameCenterLeaderboardSetRelease),
        z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterDetailResponse
 */
export const zGameCenterDetailResponse = z.object({
    data: zGameCenterDetail,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('gameCenterAchievementReleases')
        }).and(zGameCenterAchievementRelease),
        z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievement),
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterActivityVersionReleases')
        }).and(zGameCenterActivityVersionRelease),
        z.object({
            type: z.literal('gameCenterAppVersions')
        }).and(zGameCenterAppVersion),
        z.object({
            type: z.literal('gameCenterChallengeVersionReleases')
        }).and(zGameCenterChallengeVersionRelease),
        z.object({
            type: z.literal('gameCenterChallenges')
        }).and(zGameCenterChallenge),
        z.object({
            type: z.literal('gameCenterGroups')
        }).and(zGameCenterGroup),
        z.object({
            type: z.literal('gameCenterLeaderboardReleases')
        }).and(zGameCenterLeaderboardRelease),
        z.object({
            type: z.literal('gameCenterLeaderboardSetReleases')
        }).and(zGameCenterLeaderboardSetRelease),
        z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet),
        z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)
    ]))),
    links: zDocumentLinks
});

/**
 * GameCenterEnabledVersionsResponse
 *
 * @deprecated
 */
export const zGameCenterEnabledVersionsResponse = z.object({
    data: z.array(zGameCenterEnabledVersion),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('apps')
        }).and(zApp), z.object({
            type: z.literal('gameCenterEnabledVersions')
        }).and(zGameCenterEnabledVersion)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * InAppPurchasesResponse
 *
 * @deprecated
 */
export const zInAppPurchasesResponse = z.object({
    data: z.array(zInAppPurchase),
    included: z.optional(z.array(zApp)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * InAppPurchaseResponse
 *
 * @deprecated
 */
export const zInAppPurchaseResponse = z.object({
    data: zInAppPurchase,
    included: z.optional(z.array(zApp)),
    links: zDocumentLinks
});

/**
 * NominationsResponse
 */
export const zNominationsResponse = z.object({
    data: z.array(zNomination),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('actors')
        }).and(zActor),
        z.object({
            type: z.literal('appEvents')
        }).and(zAppEvent),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('territories')
        }).and(zTerritory)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * NominationResponse
 */
export const zNominationResponse = z.object({
    data: zNomination,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('actors')
        }).and(zActor),
        z.object({
            type: z.literal('appEvents')
        }).and(zAppEvent),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('territories')
        }).and(zTerritory)
    ]))),
    links: zDocumentLinks
});

/**
 * PreReleaseVersionsResponse
 */
export const zPreReleaseVersionsResponse = z.object({
    data: z.array(zPrereleaseVersion),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('apps')
        }).and(zApp), z.object({
            type: z.literal('builds')
        }).and(zBuild)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * PrereleaseVersionResponse
 */
export const zPrereleaseVersionResponse = z.object({
    data: zPrereleaseVersion,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('apps')
        }).and(zApp), z.object({
            type: z.literal('builds')
        }).and(zBuild)]))),
    links: zDocumentLinks
});

/**
 * ReviewSubmissionsResponse
 */
export const zReviewSubmissionsResponse = z.object({
    data: z.array(zReviewSubmission),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('actors')
        }).and(zActor),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('reviewSubmissionItems')
        }).and(zReviewSubmissionItem)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * ReviewSubmissionResponse
 */
export const zReviewSubmissionResponse = z.object({
    data: zReviewSubmission,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('actors')
        }).and(zActor),
        z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('reviewSubmissionItems')
        }).and(zReviewSubmissionItem)
    ]))),
    links: zDocumentLinks
});

/**
 * AppWithoutIncludesResponse
 */
export const zAppWithoutIncludesResponse = z.object({
    data: zApp,
    links: zDocumentLinks
});

/**
 * AppsWithoutIncludesResponse
 */
export const zAppsWithoutIncludesResponse = z.object({
    data: z.array(zApp),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

export const zTerritoryCode = z.enum([
    'ABW',
    'AFG',
    'AGO',
    'AIA',
    'ALB',
    'AND',
    'ANT',
    'ARE',
    'ARG',
    'ARM',
    'ASM',
    'ATG',
    'AUS',
    'AUT',
    'AZE',
    'BDI',
    'BEL',
    'BEN',
    'BES',
    'BFA',
    'BGD',
    'BGR',
    'BHR',
    'BHS',
    'BIH',
    'BLR',
    'BLZ',
    'BMU',
    'BOL',
    'BRA',
    'BRB',
    'BRN',
    'BTN',
    'BWA',
    'CAF',
    'CAN',
    'CHE',
    'CHL',
    'CHN',
    'CIV',
    'CMR',
    'COD',
    'COG',
    'COK',
    'COL',
    'COM',
    'CPV',
    'CRI',
    'CUB',
    'CUW',
    'CXR',
    'CYM',
    'CYP',
    'CZE',
    'DEU',
    'DJI',
    'DMA',
    'DNK',
    'DOM',
    'DZA',
    'ECU',
    'EGY',
    'ERI',
    'ESP',
    'EST',
    'ETH',
    'FIN',
    'FJI',
    'FLK',
    'FRA',
    'FRO',
    'FSM',
    'GAB',
    'GBR',
    'GEO',
    'GGY',
    'GHA',
    'GIB',
    'GIN',
    'GLP',
    'GMB',
    'GNB',
    'GNQ',
    'GRC',
    'GRD',
    'GRL',
    'GTM',
    'GUF',
    'GUM',
    'GUY',
    'HKG',
    'HND',
    'HRV',
    'HTI',
    'HUN',
    'IDN',
    'IMN',
    'IND',
    'IRL',
    'IRQ',
    'ISL',
    'ISR',
    'ITA',
    'JAM',
    'JEY',
    'JOR',
    'JPN',
    'KAZ',
    'KEN',
    'KGZ',
    'KHM',
    'KIR',
    'KNA',
    'KOR',
    'KWT',
    'LAO',
    'LBN',
    'LBR',
    'LBY',
    'LCA',
    'LIE',
    'LKA',
    'LSO',
    'LTU',
    'LUX',
    'LVA',
    'MAC',
    'MAR',
    'MCO',
    'MDA',
    'MDG',
    'MDV',
    'MEX',
    'MHL',
    'MKD',
    'MLI',
    'MLT',
    'MMR',
    'MNE',
    'MNG',
    'MNP',
    'MOZ',
    'MRT',
    'MSR',
    'MTQ',
    'MUS',
    'MWI',
    'MYS',
    'MYT',
    'NAM',
    'NCL',
    'NER',
    'NFK',
    'NGA',
    'NIC',
    'NIU',
    'NLD',
    'NOR',
    'NPL',
    'NRU',
    'NZL',
    'OMN',
    'PAK',
    'PAN',
    'PER',
    'PHL',
    'PLW',
    'PNG',
    'POL',
    'PRI',
    'PRT',
    'PRY',
    'PSE',
    'PYF',
    'QAT',
    'REU',
    'ROU',
    'RUS',
    'RWA',
    'SAU',
    'SEN',
    'SGP',
    'SHN',
    'SLB',
    'SLE',
    'SLV',
    'SMR',
    'SOM',
    'SPM',
    'SRB',
    'SSD',
    'STP',
    'SUR',
    'SVK',
    'SVN',
    'SWE',
    'SWZ',
    'SXM',
    'SYC',
    'TCA',
    'TCD',
    'TGO',
    'THA',
    'TJK',
    'TKM',
    'TLS',
    'TON',
    'TTO',
    'TUN',
    'TUR',
    'TUV',
    'TWN',
    'TZA',
    'UGA',
    'UKR',
    'UMI',
    'URY',
    'USA',
    'UZB',
    'VAT',
    'VCT',
    'VEN',
    'VGB',
    'VIR',
    'VNM',
    'VUT',
    'WLF',
    'WSM',
    'XKS',
    'YEM',
    'ZAF',
    'ZMB',
    'ZWE'
]);

/**
 * CustomerReview
 */
export const zCustomerReview = z.object({
    type: z.enum(['customerReviews']),
    id: z.string(),
    attributes: z.optional(z.object({
        rating: z.optional(z.int().gte(1).lte(5)),
        title: z.optional(z.string()),
        body: z.optional(z.string()),
        reviewerNickname: z.optional(z.string()),
        createdDate: z.optional(z.iso.datetime()),
        territory: z.optional(zTerritoryCode)
    })),
    relationships: z.optional(z.object({
        response: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            data: z.optional(z.object({
                type: z.enum(['customerReviewResponses']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * CustomerReviewResponseV1Response
 */
export const zCustomerReviewResponseV1Response = z.object({
    data: zCustomerReviewResponseV1,
    included: z.optional(z.array(zCustomerReview)),
    links: zDocumentLinks
});

/**
 * CustomerReviewsResponse
 */
export const zCustomerReviewsResponse = z.object({
    data: z.array(zCustomerReview),
    included: z.optional(z.array(zCustomerReviewResponseV1)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * CustomerReviewResponse
 */
export const zCustomerReviewResponse = z.object({
    data: zCustomerReview,
    included: z.optional(z.array(zCustomerReviewResponseV1)),
    links: zDocumentLinks
});

/**
 * SandboxTesterV2
 */
export const zSandboxTesterV2 = z.object({
    type: z.enum(['sandboxTesters']),
    id: z.string(),
    attributes: z.optional(z.object({
        firstName: z.optional(z.string()),
        lastName: z.optional(z.string()),
        acAccountName: z.optional(z.string()),
        territory: z.optional(zTerritoryCode),
        applePayCompatible: z.optional(z.boolean()),
        interruptPurchases: z.optional(z.boolean()),
        subscriptionRenewalRate: z.optional(z.enum([
            'MONTHLY_RENEWAL_EVERY_ONE_HOUR',
            'MONTHLY_RENEWAL_EVERY_THIRTY_MINUTES',
            'MONTHLY_RENEWAL_EVERY_FIFTEEN_MINUTES',
            'MONTHLY_RENEWAL_EVERY_FIVE_MINUTES',
            'MONTHLY_RENEWAL_EVERY_THREE_MINUTES'
        ]))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SandboxTestersV2Response
 */
export const zSandboxTestersV2Response = z.object({
    data: z.array(zSandboxTesterV2),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SandboxTesterV2Response
 */
export const zSandboxTesterV2Response = z.object({
    data: zSandboxTesterV2,
    links: zDocumentLinks
});

/**
 * SandboxTesterV2UpdateRequest
 */
export const zSandboxTesterV2UpdateRequest = z.object({
    data: z.object({
        type: z.enum(['sandboxTesters']),
        id: z.string(),
        attributes: z.optional(z.object({
            territory: z.optional(zTerritoryCode),
            interruptPurchases: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            subscriptionRenewalRate: z.optional(z.enum([
                'MONTHLY_RENEWAL_EVERY_ONE_HOUR',
                'MONTHLY_RENEWAL_EVERY_THIRTY_MINUTES',
                'MONTHLY_RENEWAL_EVERY_FIFTEEN_MINUTES',
                'MONTHLY_RENEWAL_EVERY_FIVE_MINUTES',
                'MONTHLY_RENEWAL_EVERY_THREE_MINUTES'
            ]))
        }))
    })
});

export const zUploadOperation = z.object({
    method: z.optional(z.string()),
    url: z.optional(z.string()),
    length: z.optional(z.int()),
    offset: z.optional(z.int()),
    requestHeaders: z.optional(z.array(zHttpHeader))
});

/**
 * AppClipAdvancedExperienceImage
 */
export const zAppClipAdvancedExperienceImage = z.object({
    type: z.enum(['appClipAdvancedExperienceImages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        sourceFileChecksum: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppClipAdvancedExperienceImageResponse
 */
export const zAppClipAdvancedExperienceImageResponse = z.object({
    data: zAppClipAdvancedExperienceImage,
    links: zDocumentLinks
});

/**
 * AppClipAdvancedExperiencesResponse
 */
export const zAppClipAdvancedExperiencesResponse = z.object({
    data: z.array(zAppClipAdvancedExperience),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appClipAdvancedExperienceImages')
        }).and(zAppClipAdvancedExperienceImage),
        z.object({
            type: z.literal('appClipAdvancedExperienceLocalizations')
        }).and(zAppClipAdvancedExperienceLocalization),
        z.object({
            type: z.literal('appClips')
        }).and(zAppClip)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppClipAdvancedExperienceResponse
 */
export const zAppClipAdvancedExperienceResponse = z.object({
    data: zAppClipAdvancedExperience,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appClipAdvancedExperienceImages')
        }).and(zAppClipAdvancedExperienceImage),
        z.object({
            type: z.literal('appClipAdvancedExperienceLocalizations')
        }).and(zAppClipAdvancedExperienceLocalization),
        z.object({
            type: z.literal('appClips')
        }).and(zAppClip)
    ]))),
    links: zDocumentLinks
});

/**
 * AppClipHeaderImage
 */
export const zAppClipHeaderImage = z.object({
    type: z.enum(['appClipHeaderImages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        sourceFileChecksum: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    relationships: z.optional(z.object({
        appClipDefaultExperienceLocalization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appClipDefaultExperienceLocalizations']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppClipDefaultExperienceLocalizationsResponse
 */
export const zAppClipDefaultExperienceLocalizationsResponse = z.object({
    data: z.array(zAppClipDefaultExperienceLocalization),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appClipDefaultExperiences')
        }).and(zAppClipDefaultExperience), z.object({
            type: z.literal('appClipHeaderImages')
        }).and(zAppClipHeaderImage)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppClipDefaultExperienceLocalizationResponse
 */
export const zAppClipDefaultExperienceLocalizationResponse = z.object({
    data: zAppClipDefaultExperienceLocalization,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appClipDefaultExperiences')
        }).and(zAppClipDefaultExperience), z.object({
            type: z.literal('appClipHeaderImages')
        }).and(zAppClipHeaderImage)]))),
    links: zDocumentLinks
});

/**
 * AppClipHeaderImageResponse
 */
export const zAppClipHeaderImageResponse = z.object({
    data: zAppClipHeaderImage,
    included: z.optional(z.array(zAppClipDefaultExperienceLocalization)),
    links: zDocumentLinks
});

/**
 * AppEncryptionDeclarationDocument
 */
export const zAppEncryptionDeclarationDocument = z.object({
    type: z.enum(['appEncryptionDeclarationDocuments']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        assetToken: z.optional(z.string()),
        downloadUrl: z.optional(z.url()),
        sourceFileChecksum: z.optional(z.string()),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppEncryptionDeclarationDocumentResponse
 */
export const zAppEncryptionDeclarationDocumentResponse = z.object({
    data: zAppEncryptionDeclarationDocument,
    links: zDocumentLinks
});

/**
 * AppEncryptionDeclarationsResponse
 */
export const zAppEncryptionDeclarationsResponse = z.object({
    data: z.array(zAppEncryptionDeclaration),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appEncryptionDeclarationDocuments')
        }).and(zAppEncryptionDeclarationDocument),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('builds')
        }).and(zBuild)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppEncryptionDeclarationResponse
 */
export const zAppEncryptionDeclarationResponse = z.object({
    data: zAppEncryptionDeclaration,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appEncryptionDeclarationDocuments')
        }).and(zAppEncryptionDeclarationDocument),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('builds')
        }).and(zBuild)
    ]))),
    links: zDocumentLinks
});

/**
 * AppEventScreenshot
 */
export const zAppEventScreenshot = z.object({
    type: z.enum(['appEventScreenshots']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        assetToken: z.optional(z.string()),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState),
        appEventAssetType: z.optional(zAppEventAssetType)
    })),
    relationships: z.optional(z.object({
        appEventLocalization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appEventLocalizations']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppEventScreenshotsResponse
 */
export const zAppEventScreenshotsResponse = z.object({
    data: z.array(zAppEventScreenshot),
    included: z.optional(z.array(zAppEventLocalization)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppEventScreenshotResponse
 */
export const zAppEventScreenshotResponse = z.object({
    data: zAppEventScreenshot,
    included: z.optional(z.array(zAppEventLocalization)),
    links: zDocumentLinks
});

/**
 * AppEventVideoClip
 */
export const zAppEventVideoClip = z.object({
    type: z.enum(['appEventVideoClips']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        previewFrameTimeCode: z.optional(z.string()),
        videoUrl: z.optional(z.string()),
        previewFrameImage: z.optional(zPreviewFrameImage),
        previewImage: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState),
        videoDeliveryState: z.optional(zAppMediaVideoState),
        appEventAssetType: z.optional(zAppEventAssetType)
    })),
    relationships: z.optional(z.object({
        appEventLocalization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appEventLocalizations']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppEventLocalizationsResponse
 */
export const zAppEventLocalizationsResponse = z.object({
    data: z.array(zAppEventLocalization),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appEventScreenshots')
        }).and(zAppEventScreenshot),
        z.object({
            type: z.literal('appEventVideoClips')
        }).and(zAppEventVideoClip),
        z.object({
            type: z.literal('appEvents')
        }).and(zAppEvent)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppEventLocalizationResponse
 */
export const zAppEventLocalizationResponse = z.object({
    data: zAppEventLocalization,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appEventScreenshots')
        }).and(zAppEventScreenshot),
        z.object({
            type: z.literal('appEventVideoClips')
        }).and(zAppEventVideoClip),
        z.object({
            type: z.literal('appEvents')
        }).and(zAppEvent)
    ]))),
    links: zDocumentLinks
});

/**
 * AppEventVideoClipsResponse
 */
export const zAppEventVideoClipsResponse = z.object({
    data: z.array(zAppEventVideoClip),
    included: z.optional(z.array(zAppEventLocalization)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppEventVideoClipResponse
 */
export const zAppEventVideoClipResponse = z.object({
    data: zAppEventVideoClip,
    included: z.optional(z.array(zAppEventLocalization)),
    links: zDocumentLinks
});

/**
 * AppPreview
 */
export const zAppPreview = z.object({
    type: z.enum(['appPreviews']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        sourceFileChecksum: z.optional(z.string()),
        previewFrameTimeCode: z.optional(z.string()),
        mimeType: z.optional(z.string()),
        videoUrl: z.optional(z.string()),
        previewFrameImage: z.optional(zPreviewFrameImage),
        previewImage: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState),
        videoDeliveryState: z.optional(zAppMediaVideoState)
    })),
    relationships: z.optional(z.object({
        appPreviewSet: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appPreviewSets']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppPreviewSetsResponse
 */
export const zAppPreviewSetsResponse = z.object({
    data: z.array(zAppPreviewSet),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appCustomProductPageLocalizations')
        }).and(zAppCustomProductPageLocalization),
        z.object({
            type: z.literal('appPreviews')
        }).and(zAppPreview),
        z.object({
            type: z.literal('appStoreVersionExperimentTreatmentLocalizations')
        }).and(zAppStoreVersionExperimentTreatmentLocalization),
        z.object({
            type: z.literal('appStoreVersionLocalizations')
        }).and(zAppStoreVersionLocalization)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppPreviewSetResponse
 */
export const zAppPreviewSetResponse = z.object({
    data: zAppPreviewSet,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appCustomProductPageLocalizations')
        }).and(zAppCustomProductPageLocalization),
        z.object({
            type: z.literal('appPreviews')
        }).and(zAppPreview),
        z.object({
            type: z.literal('appStoreVersionExperimentTreatmentLocalizations')
        }).and(zAppStoreVersionExperimentTreatmentLocalization),
        z.object({
            type: z.literal('appStoreVersionLocalizations')
        }).and(zAppStoreVersionLocalization)
    ]))),
    links: zDocumentLinks
});

/**
 * AppPreviewsResponse
 */
export const zAppPreviewsResponse = z.object({
    data: z.array(zAppPreview),
    included: z.optional(z.array(zAppPreviewSet)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppPreviewResponse
 */
export const zAppPreviewResponse = z.object({
    data: zAppPreview,
    included: z.optional(z.array(zAppPreviewSet)),
    links: zDocumentLinks
});

/**
 * AppScreenshot
 */
export const zAppScreenshot = z.object({
    type: z.enum(['appScreenshots']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        sourceFileChecksum: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        assetToken: z.optional(z.string()),
        assetType: z.optional(z.string()),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    relationships: z.optional(z.object({
        appScreenshotSet: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appScreenshotSets']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppScreenshotSetsResponse
 */
export const zAppScreenshotSetsResponse = z.object({
    data: z.array(zAppScreenshotSet),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appCustomProductPageLocalizations')
        }).and(zAppCustomProductPageLocalization),
        z.object({
            type: z.literal('appScreenshots')
        }).and(zAppScreenshot),
        z.object({
            type: z.literal('appStoreVersionExperimentTreatmentLocalizations')
        }).and(zAppStoreVersionExperimentTreatmentLocalization),
        z.object({
            type: z.literal('appStoreVersionLocalizations')
        }).and(zAppStoreVersionLocalization)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppScreenshotSetResponse
 */
export const zAppScreenshotSetResponse = z.object({
    data: zAppScreenshotSet,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('appCustomProductPageLocalizations')
        }).and(zAppCustomProductPageLocalization),
        z.object({
            type: z.literal('appScreenshots')
        }).and(zAppScreenshot),
        z.object({
            type: z.literal('appStoreVersionExperimentTreatmentLocalizations')
        }).and(zAppStoreVersionExperimentTreatmentLocalization),
        z.object({
            type: z.literal('appStoreVersionLocalizations')
        }).and(zAppStoreVersionLocalization)
    ]))),
    links: zDocumentLinks
});

/**
 * AppScreenshotsResponse
 */
export const zAppScreenshotsResponse = z.object({
    data: z.array(zAppScreenshot),
    included: z.optional(z.array(zAppScreenshotSet)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppScreenshotResponse
 */
export const zAppScreenshotResponse = z.object({
    data: zAppScreenshot,
    included: z.optional(z.array(zAppScreenshotSet)),
    links: zDocumentLinks
});

/**
 * AppStoreReviewAttachment
 */
export const zAppStoreReviewAttachment = z.object({
    type: z.enum(['appStoreReviewAttachments']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        sourceFileChecksum: z.optional(z.string()),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    relationships: z.optional(z.object({
        appStoreReviewDetail: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreReviewDetails']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppStoreReviewAttachmentsResponse
 */
export const zAppStoreReviewAttachmentsResponse = z.object({
    data: z.array(zAppStoreReviewAttachment),
    included: z.optional(z.array(zAppStoreReviewDetail)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppStoreReviewAttachmentResponse
 */
export const zAppStoreReviewAttachmentResponse = z.object({
    data: zAppStoreReviewAttachment,
    included: z.optional(z.array(zAppStoreReviewDetail)),
    links: zDocumentLinks
});

/**
 * AppStoreReviewDetailResponse
 */
export const zAppStoreReviewDetailResponse = z.object({
    data: zAppStoreReviewDetail,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('appStoreReviewAttachments')
        }).and(zAppStoreReviewAttachment), z.object({
            type: z.literal('appStoreVersions')
        }).and(zAppStoreVersion)]))),
    links: zDocumentLinks
});

/**
 * GameCenterAchievementImage
 */
export const zGameCenterAchievementImage = z.object({
    type: z.enum(['gameCenterAchievementImages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    relationships: z.optional(z.object({
        gameCenterAchievementLocalization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterAchievementLocalizations']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterAchievementImageResponse
 */
export const zGameCenterAchievementImageResponse = z.object({
    data: zGameCenterAchievementImage,
    included: z.optional(z.array(zGameCenterAchievementLocalization)),
    links: zDocumentLinks
});

/**
 * GameCenterAchievementImageV2
 */
export const zGameCenterAchievementImageV2 = z.object({
    type: z.enum(['gameCenterAchievementImages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    relationships: z.optional(z.object({
        localization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterAchievementLocalizations']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterAchievementImageV2Response
 */
export const zGameCenterAchievementImageV2Response = z.object({
    data: zGameCenterAchievementImageV2,
    included: z.optional(z.array(zGameCenterAchievementLocalizationV2)),
    links: zDocumentLinks
});

/**
 * GameCenterAchievementLocalizationsV2Response
 */
export const zGameCenterAchievementLocalizationsV2Response = z.object({
    data: z.array(zGameCenterAchievementLocalizationV2),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterAchievementImages')
        }).and(zGameCenterAchievementImageV2), z.object({
            type: z.literal('gameCenterAchievementVersions')
        }).and(zGameCenterAchievementVersionV2)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterAchievementLocalizationV2Response
 */
export const zGameCenterAchievementLocalizationV2Response = z.object({
    data: zGameCenterAchievementLocalizationV2,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterAchievementImages')
        }).and(zGameCenterAchievementImageV2), z.object({
            type: z.literal('gameCenterAchievementVersions')
        }).and(zGameCenterAchievementVersionV2)]))),
    links: zDocumentLinks
});

/**
 * GameCenterAchievementLocalizationsResponse
 */
export const zGameCenterAchievementLocalizationsResponse = z.object({
    data: z.array(zGameCenterAchievementLocalization),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterAchievementImages')
        }).and(zGameCenterAchievementImage), z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievement)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterAchievementLocalizationResponse
 */
export const zGameCenterAchievementLocalizationResponse = z.object({
    data: zGameCenterAchievementLocalization,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterAchievementImages')
        }).and(zGameCenterAchievementImage), z.object({
            type: z.literal('gameCenterAchievements')
        }).and(zGameCenterAchievement)]))),
    links: zDocumentLinks
});

/**
 * GameCenterActivityImage
 */
export const zGameCenterActivityImage = z.object({
    type: z.enum(['gameCenterActivityImages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterActivityImageResponse
 */
export const zGameCenterActivityImageResponse = z.object({
    data: zGameCenterActivityImage,
    links: zDocumentLinks
});

/**
 * GameCenterActivityLocalizationsResponse
 */
export const zGameCenterActivityLocalizationsResponse = z.object({
    data: z.array(zGameCenterActivityLocalization),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterActivityImages')
        }).and(zGameCenterActivityImage), z.object({
            type: z.literal('gameCenterActivityVersions')
        }).and(zGameCenterActivityVersion)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterActivityLocalizationResponse
 */
export const zGameCenterActivityLocalizationResponse = z.object({
    data: zGameCenterActivityLocalization,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterActivityImages')
        }).and(zGameCenterActivityImage), z.object({
            type: z.literal('gameCenterActivityVersions')
        }).and(zGameCenterActivityVersion)]))),
    links: zDocumentLinks
});

/**
 * GameCenterActivityVersionsResponse
 */
export const zGameCenterActivityVersionsResponse = z.object({
    data: z.array(zGameCenterActivityVersion),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterActivityImages')
        }).and(zGameCenterActivityImage),
        z.object({
            type: z.literal('gameCenterActivityLocalizations')
        }).and(zGameCenterActivityLocalization),
        z.object({
            type: z.literal('gameCenterActivityVersionReleases')
        }).and(zGameCenterActivityVersionRelease)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterActivityVersionResponse
 */
export const zGameCenterActivityVersionResponse = z.object({
    data: zGameCenterActivityVersion,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterActivities')
        }).and(zGameCenterActivity),
        z.object({
            type: z.literal('gameCenterActivityImages')
        }).and(zGameCenterActivityImage),
        z.object({
            type: z.literal('gameCenterActivityLocalizations')
        }).and(zGameCenterActivityLocalization),
        z.object({
            type: z.literal('gameCenterActivityVersionReleases')
        }).and(zGameCenterActivityVersionRelease)
    ]))),
    links: zDocumentLinks
});

/**
 * GameCenterChallengeImage
 */
export const zGameCenterChallengeImage = z.object({
    type: z.enum(['gameCenterChallengeImages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterChallengeImageResponse
 */
export const zGameCenterChallengeImageResponse = z.object({
    data: zGameCenterChallengeImage,
    links: zDocumentLinks
});

/**
 * GameCenterChallengeLocalizationsResponse
 */
export const zGameCenterChallengeLocalizationsResponse = z.object({
    data: z.array(zGameCenterChallengeLocalization),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterChallengeImages')
        }).and(zGameCenterChallengeImage), z.object({
            type: z.literal('gameCenterChallengeVersions')
        }).and(zGameCenterChallengeVersion)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterChallengeLocalizationResponse
 */
export const zGameCenterChallengeLocalizationResponse = z.object({
    data: zGameCenterChallengeLocalization,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterChallengeImages')
        }).and(zGameCenterChallengeImage), z.object({
            type: z.literal('gameCenterChallengeVersions')
        }).and(zGameCenterChallengeVersion)]))),
    links: zDocumentLinks
});

/**
 * GameCenterChallengeVersionsResponse
 */
export const zGameCenterChallengeVersionsResponse = z.object({
    data: z.array(zGameCenterChallengeVersion),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterChallengeImages')
        }).and(zGameCenterChallengeImage),
        z.object({
            type: z.literal('gameCenterChallengeLocalizations')
        }).and(zGameCenterChallengeLocalization),
        z.object({
            type: z.literal('gameCenterChallengeVersionReleases')
        }).and(zGameCenterChallengeVersionRelease),
        z.object({
            type: z.literal('gameCenterChallenges')
        }).and(zGameCenterChallenge)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterChallengeVersionResponse
 */
export const zGameCenterChallengeVersionResponse = z.object({
    data: zGameCenterChallengeVersion,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('gameCenterChallengeImages')
        }).and(zGameCenterChallengeImage),
        z.object({
            type: z.literal('gameCenterChallengeLocalizations')
        }).and(zGameCenterChallengeLocalization),
        z.object({
            type: z.literal('gameCenterChallengeVersionReleases')
        }).and(zGameCenterChallengeVersionRelease),
        z.object({
            type: z.literal('gameCenterChallenges')
        }).and(zGameCenterChallenge)
    ]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardImage
 */
export const zGameCenterLeaderboardImage = z.object({
    type: z.enum(['gameCenterLeaderboardImages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    relationships: z.optional(z.object({
        gameCenterLeaderboardLocalization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardLocalizations']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardImageResponse
 */
export const zGameCenterLeaderboardImageResponse = z.object({
    data: zGameCenterLeaderboardImage,
    included: z.optional(z.array(zGameCenterLeaderboardLocalization)),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardImageV2
 */
export const zGameCenterLeaderboardImageV2 = z.object({
    type: z.enum(['gameCenterLeaderboardImages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    relationships: z.optional(z.object({
        localization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardLocalizations']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardImageV2Response
 */
export const zGameCenterLeaderboardImageV2Response = z.object({
    data: zGameCenterLeaderboardImageV2,
    included: z.optional(z.array(zGameCenterLeaderboardLocalizationV2)),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardLocalizationsResponse
 */
export const zGameCenterLeaderboardLocalizationsResponse = z.object({
    data: z.array(zGameCenterLeaderboardLocalization),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardImages')
        }).and(zGameCenterLeaderboardImage), z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardLocalizationResponse
 */
export const zGameCenterLeaderboardLocalizationResponse = z.object({
    data: zGameCenterLeaderboardLocalization,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardImages')
        }).and(zGameCenterLeaderboardImage), z.object({
            type: z.literal('gameCenterLeaderboards')
        }).and(zGameCenterLeaderboard)]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardLocalizationsV2Response
 */
export const zGameCenterLeaderboardLocalizationsV2Response = z.object({
    data: z.array(zGameCenterLeaderboardLocalizationV2),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardImages')
        }).and(zGameCenterLeaderboardImageV2), z.object({
            type: z.literal('gameCenterLeaderboardVersions')
        }).and(zGameCenterLeaderboardVersionV2)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardLocalizationV2Response
 */
export const zGameCenterLeaderboardLocalizationV2Response = z.object({
    data: zGameCenterLeaderboardLocalizationV2,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardImages')
        }).and(zGameCenterLeaderboardImageV2), z.object({
            type: z.literal('gameCenterLeaderboardVersions')
        }).and(zGameCenterLeaderboardVersionV2)]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardSetImage
 */
export const zGameCenterLeaderboardSetImage = z.object({
    type: z.enum(['gameCenterLeaderboardSetImages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    relationships: z.optional(z.object({
        gameCenterLeaderboardSetLocalization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardSetLocalizations']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardSetImageResponse
 */
export const zGameCenterLeaderboardSetImageResponse = z.object({
    data: zGameCenterLeaderboardSetImage,
    included: z.optional(z.array(zGameCenterLeaderboardSetLocalization)),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardSetImageV2
 */
export const zGameCenterLeaderboardSetImageV2 = z.object({
    type: z.enum(['gameCenterLeaderboardSetImages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    relationships: z.optional(z.object({
        localization: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['gameCenterLeaderboardSetLocalizations']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * GameCenterLeaderboardSetImageV2Response
 */
export const zGameCenterLeaderboardSetImageV2Response = z.object({
    data: zGameCenterLeaderboardSetImageV2,
    included: z.optional(z.array(zGameCenterLeaderboardSetLocalizationV2)),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardSetLocalizationsResponse
 */
export const zGameCenterLeaderboardSetLocalizationsResponse = z.object({
    data: z.array(zGameCenterLeaderboardSetLocalization),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardSetImages')
        }).and(zGameCenterLeaderboardSetImage), z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardSetLocalizationResponse
 */
export const zGameCenterLeaderboardSetLocalizationResponse = z.object({
    data: zGameCenterLeaderboardSetLocalization,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardSetImages')
        }).and(zGameCenterLeaderboardSetImage), z.object({
            type: z.literal('gameCenterLeaderboardSets')
        }).and(zGameCenterLeaderboardSet)]))),
    links: zDocumentLinks
});

/**
 * GameCenterLeaderboardSetLocalizationsV2Response
 */
export const zGameCenterLeaderboardSetLocalizationsV2Response = z.object({
    data: z.array(zGameCenterLeaderboardSetLocalizationV2),
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardSetImages')
        }).and(zGameCenterLeaderboardSetImageV2), z.object({
            type: z.literal('gameCenterLeaderboardSetVersions')
        }).and(zGameCenterLeaderboardSetVersionV2)]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * GameCenterLeaderboardSetLocalizationV2Response
 */
export const zGameCenterLeaderboardSetLocalizationV2Response = z.object({
    data: zGameCenterLeaderboardSetLocalizationV2,
    included: z.optional(z.array(z.union([z.object({
            type: z.literal('gameCenterLeaderboardSetImages')
        }).and(zGameCenterLeaderboardSetImageV2), z.object({
            type: z.literal('gameCenterLeaderboardSetVersions')
        }).and(zGameCenterLeaderboardSetVersionV2)]))),
    links: zDocumentLinks
});

/**
 * InAppPurchaseAppStoreReviewScreenshot
 */
export const zInAppPurchaseAppStoreReviewScreenshot = z.object({
    type: z.enum(['inAppPurchaseAppStoreReviewScreenshots']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        sourceFileChecksum: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        assetToken: z.optional(z.string()),
        assetType: z.optional(z.string()),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    relationships: z.optional(z.object({
        inAppPurchaseV2: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['inAppPurchases']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchaseAppStoreReviewScreenshotResponse
 */
export const zInAppPurchaseAppStoreReviewScreenshotResponse = z.object({
    data: zInAppPurchaseAppStoreReviewScreenshot,
    included: z.optional(z.array(zInAppPurchaseV2)),
    links: zDocumentLinks
});

/**
 * InAppPurchaseImage
 */
export const zInAppPurchaseImage = z.object({
    type: z.enum(['inAppPurchaseImages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        sourceFileChecksum: z.optional(z.string()),
        assetToken: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        state: z.optional(z.enum([
            'AWAITING_UPLOAD',
            'UPLOAD_COMPLETE',
            'FAILED',
            'PREPARE_FOR_SUBMISSION',
            'WAITING_FOR_REVIEW',
            'APPROVED',
            'REJECTED'
        ]))
    })),
    relationships: z.optional(z.object({
        inAppPurchase: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['inAppPurchases']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * InAppPurchaseImagesResponse
 */
export const zInAppPurchaseImagesResponse = z.object({
    data: z.array(zInAppPurchaseImage),
    included: z.optional(z.array(zInAppPurchaseV2)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * InAppPurchaseImageResponse
 */
export const zInAppPurchaseImageResponse = z.object({
    data: zInAppPurchaseImage,
    included: z.optional(z.array(zInAppPurchaseV2)),
    links: zDocumentLinks
});

/**
 * InAppPurchasesV2Response
 */
export const zInAppPurchasesV2Response = z.object({
    data: z.array(zInAppPurchaseV2),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('inAppPurchaseAppStoreReviewScreenshots')
        }).and(zInAppPurchaseAppStoreReviewScreenshot),
        z.object({
            type: z.literal('inAppPurchaseAvailabilities')
        }).and(zInAppPurchaseAvailability),
        z.object({
            type: z.literal('inAppPurchaseContents')
        }).and(zInAppPurchaseContent),
        z.object({
            type: z.literal('inAppPurchaseImages')
        }).and(zInAppPurchaseImage),
        z.object({
            type: z.literal('inAppPurchaseLocalizations')
        }).and(zInAppPurchaseLocalization),
        z.object({
            type: z.literal('inAppPurchaseOfferCodes')
        }).and(zInAppPurchaseOfferCode),
        z.object({
            type: z.literal('inAppPurchasePricePoints')
        }).and(zInAppPurchasePricePoint),
        z.object({
            type: z.literal('inAppPurchasePriceSchedules')
        }).and(zInAppPurchasePriceSchedule),
        z.object({
            type: z.literal('promotedPurchases')
        }).and(zPromotedPurchase)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * InAppPurchaseV2Response
 */
export const zInAppPurchaseV2Response = z.object({
    data: zInAppPurchaseV2,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('inAppPurchaseAppStoreReviewScreenshots')
        }).and(zInAppPurchaseAppStoreReviewScreenshot),
        z.object({
            type: z.literal('inAppPurchaseAvailabilities')
        }).and(zInAppPurchaseAvailability),
        z.object({
            type: z.literal('inAppPurchaseContents')
        }).and(zInAppPurchaseContent),
        z.object({
            type: z.literal('inAppPurchaseImages')
        }).and(zInAppPurchaseImage),
        z.object({
            type: z.literal('inAppPurchaseLocalizations')
        }).and(zInAppPurchaseLocalization),
        z.object({
            type: z.literal('inAppPurchaseOfferCodes')
        }).and(zInAppPurchaseOfferCode),
        z.object({
            type: z.literal('inAppPurchasePricePoints')
        }).and(zInAppPurchasePricePoint),
        z.object({
            type: z.literal('inAppPurchasePriceSchedules')
        }).and(zInAppPurchasePriceSchedule),
        z.object({
            type: z.literal('promotedPurchases')
        }).and(zPromotedPurchase)
    ]))),
    links: zDocumentLinks
});

/**
 * RoutingAppCoverage
 */
export const zRoutingAppCoverage = z.object({
    type: z.enum(['routingAppCoverages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        sourceFileChecksum: z.optional(z.string()),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    relationships: z.optional(z.object({
        appStoreVersion: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['appStoreVersions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * AppStoreVersionsResponse
 */
export const zAppStoreVersionsResponse = z.object({
    data: z.array(zAppStoreVersion),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('ageRatingDeclarations')
        }).and(zAgeRatingDeclaration),
        z.object({
            type: z.literal('alternativeDistributionPackages')
        }).and(zAlternativeDistributionPackage),
        z.object({
            type: z.literal('appClipDefaultExperiences')
        }).and(zAppClipDefaultExperience),
        z.object({
            type: z.literal('appStoreReviewDetails')
        }).and(zAppStoreReviewDetail),
        z.object({
            type: z.literal('appStoreVersionExperiments')
        }).and(zAppStoreVersionExperiment),
        z.object({
            type: z.literal('appStoreVersionLocalizations')
        }).and(zAppStoreVersionLocalization),
        z.object({
            type: z.literal('appStoreVersionPhasedReleases')
        }).and(zAppStoreVersionPhasedRelease),
        z.object({
            type: z.literal('appStoreVersionSubmissions')
        }).and(zAppStoreVersionSubmission),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('builds')
        }).and(zBuild),
        z.object({
            type: z.literal('gameCenterAppVersions')
        }).and(zGameCenterAppVersion),
        z.object({
            type: z.literal('routingAppCoverages')
        }).and(zRoutingAppCoverage)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * AppStoreVersionResponse
 */
export const zAppStoreVersionResponse = z.object({
    data: zAppStoreVersion,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('ageRatingDeclarations')
        }).and(zAgeRatingDeclaration),
        z.object({
            type: z.literal('alternativeDistributionPackages')
        }).and(zAlternativeDistributionPackage),
        z.object({
            type: z.literal('appClipDefaultExperiences')
        }).and(zAppClipDefaultExperience),
        z.object({
            type: z.literal('appStoreReviewDetails')
        }).and(zAppStoreReviewDetail),
        z.object({
            type: z.literal('appStoreVersionExperiments')
        }).and(zAppStoreVersionExperiment),
        z.object({
            type: z.literal('appStoreVersionLocalizations')
        }).and(zAppStoreVersionLocalization),
        z.object({
            type: z.literal('appStoreVersionPhasedReleases')
        }).and(zAppStoreVersionPhasedRelease),
        z.object({
            type: z.literal('appStoreVersionSubmissions')
        }).and(zAppStoreVersionSubmission),
        z.object({
            type: z.literal('apps')
        }).and(zApp),
        z.object({
            type: z.literal('builds')
        }).and(zBuild),
        z.object({
            type: z.literal('gameCenterAppVersions')
        }).and(zGameCenterAppVersion),
        z.object({
            type: z.literal('routingAppCoverages')
        }).and(zRoutingAppCoverage)
    ]))),
    links: zDocumentLinks
});

/**
 * RoutingAppCoverageResponse
 */
export const zRoutingAppCoverageResponse = z.object({
    data: zRoutingAppCoverage,
    included: z.optional(z.array(zAppStoreVersion)),
    links: zDocumentLinks
});

/**
 * SubscriptionAppStoreReviewScreenshot
 */
export const zSubscriptionAppStoreReviewScreenshot = z.object({
    type: z.enum(['subscriptionAppStoreReviewScreenshots']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        sourceFileChecksum: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        assetToken: z.optional(z.string()),
        assetType: z.optional(z.string()),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        assetDeliveryState: z.optional(zAppMediaAssetState)
    })),
    relationships: z.optional(z.object({
        subscription: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionAppStoreReviewScreenshotResponse
 */
export const zSubscriptionAppStoreReviewScreenshotResponse = z.object({
    data: zSubscriptionAppStoreReviewScreenshot,
    included: z.optional(z.array(zSubscription)),
    links: zDocumentLinks
});

/**
 * SubscriptionImage
 */
export const zSubscriptionImage = z.object({
    type: z.enum(['subscriptionImages']),
    id: z.string(),
    attributes: z.optional(z.object({
        fileSize: z.optional(z.int()),
        fileName: z.optional(z.string()),
        sourceFileChecksum: z.optional(z.string()),
        assetToken: z.optional(z.string()),
        imageAsset: z.optional(zImageAsset),
        uploadOperations: z.optional(z.array(zUploadOperation)),
        state: z.optional(z.enum([
            'AWAITING_UPLOAD',
            'UPLOAD_COMPLETE',
            'FAILED',
            'PREPARE_FOR_SUBMISSION',
            'WAITING_FOR_REVIEW',
            'APPROVED',
            'REJECTED'
        ]))
    })),
    relationships: z.optional(z.object({
        subscription: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['subscriptions']),
                id: z.string()
            }))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * SubscriptionImagesResponse
 */
export const zSubscriptionImagesResponse = z.object({
    data: z.array(zSubscriptionImage),
    included: z.optional(z.array(zSubscription)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionImageResponse
 */
export const zSubscriptionImageResponse = z.object({
    data: zSubscriptionImage,
    included: z.optional(z.array(zSubscription)),
    links: zDocumentLinks
});

/**
 * SubscriptionsResponse
 */
export const zSubscriptionsResponse = z.object({
    data: z.array(zSubscription),
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('promotedPurchases')
        }).and(zPromotedPurchase),
        z.object({
            type: z.literal('subscriptionAppStoreReviewScreenshots')
        }).and(zSubscriptionAppStoreReviewScreenshot),
        z.object({
            type: z.literal('subscriptionAvailabilities')
        }).and(zSubscriptionAvailability),
        z.object({
            type: z.literal('subscriptionGroups')
        }).and(zSubscriptionGroup),
        z.object({
            type: z.literal('subscriptionImages')
        }).and(zSubscriptionImage),
        z.object({
            type: z.literal('subscriptionIntroductoryOffers')
        }).and(zSubscriptionIntroductoryOffer),
        z.object({
            type: z.literal('subscriptionLocalizations')
        }).and(zSubscriptionLocalization),
        z.object({
            type: z.literal('subscriptionOfferCodes')
        }).and(zSubscriptionOfferCode),
        z.object({
            type: z.literal('subscriptionPrices')
        }).and(zSubscriptionPrice),
        z.object({
            type: z.literal('subscriptionPromotionalOffers')
        }).and(zSubscriptionPromotionalOffer),
        z.object({
            type: z.literal('winBackOffers')
        }).and(zWinBackOffer)
    ]))),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * SubscriptionResponse
 */
export const zSubscriptionResponse = z.object({
    data: zSubscription,
    included: z.optional(z.array(z.union([
        z.object({
            type: z.literal('promotedPurchases')
        }).and(zPromotedPurchase),
        z.object({
            type: z.literal('subscriptionAppStoreReviewScreenshots')
        }).and(zSubscriptionAppStoreReviewScreenshot),
        z.object({
            type: z.literal('subscriptionAvailabilities')
        }).and(zSubscriptionAvailability),
        z.object({
            type: z.literal('subscriptionGroups')
        }).and(zSubscriptionGroup),
        z.object({
            type: z.literal('subscriptionImages')
        }).and(zSubscriptionImage),
        z.object({
            type: z.literal('subscriptionIntroductoryOffers')
        }).and(zSubscriptionIntroductoryOffer),
        z.object({
            type: z.literal('subscriptionLocalizations')
        }).and(zSubscriptionLocalization),
        z.object({
            type: z.literal('subscriptionOfferCodes')
        }).and(zSubscriptionOfferCode),
        z.object({
            type: z.literal('subscriptionPrices')
        }).and(zSubscriptionPrice),
        z.object({
            type: z.literal('subscriptionPromotionalOffers')
        }).and(zSubscriptionPromotionalOffer),
        z.object({
            type: z.literal('winBackOffers')
        }).and(zWinBackOffer)
    ]))),
    links: zDocumentLinks
});

export const zUserRole = z.enum([
    'ADMIN',
    'FINANCE',
    'ACCOUNT_HOLDER',
    'SALES',
    'MARKETING',
    'APP_MANAGER',
    'DEVELOPER',
    'ACCESS_TO_REPORTS',
    'CUSTOMER_SUPPORT',
    'CREATE_APPS',
    'CLOUD_MANAGED_DEVELOPER_ID',
    'CLOUD_MANAGED_APP_DISTRIBUTION',
    'GENERATE_INDIVIDUAL_KEYS'
]);

/**
 * UserInvitation
 */
export const zUserInvitation = z.object({
    type: z.enum(['userInvitations']),
    id: z.string(),
    attributes: z.optional(z.object({
        email: z.optional(z.email()),
        firstName: z.optional(z.string()),
        lastName: z.optional(z.string()),
        expirationDate: z.optional(z.iso.datetime()),
        roles: z.optional(z.array(zUserRole)),
        allAppsVisible: z.optional(z.boolean()),
        provisioningAllowed: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        visibleApps: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['apps']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * UserInvitationsResponse
 */
export const zUserInvitationsResponse = z.object({
    data: z.array(zUserInvitation),
    included: z.optional(z.array(zApp)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * UserInvitationResponse
 */
export const zUserInvitationResponse = z.object({
    data: zUserInvitation,
    included: z.optional(z.array(zApp)),
    links: zDocumentLinks
});

/**
 * UserInvitationCreateRequest
 */
export const zUserInvitationCreateRequest = z.object({
    data: z.object({
        type: z.enum(['userInvitations']),
        attributes: z.object({
            email: z.email(),
            firstName: z.string(),
            lastName: z.string(),
            roles: z.array(zUserRole),
            allAppsVisible: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            provisioningAllowed: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        }),
        relationships: z.optional(z.object({
            visibleApps: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })))
            }))
        }))
    })
});

/**
 * User
 */
export const zUser = z.object({
    type: z.enum(['users']),
    id: z.string(),
    attributes: z.optional(z.object({
        username: z.optional(z.string()),
        firstName: z.optional(z.string()),
        lastName: z.optional(z.string()),
        roles: z.optional(z.array(zUserRole)),
        allAppsVisible: z.optional(z.boolean()),
        provisioningAllowed: z.optional(z.boolean())
    })),
    relationships: z.optional(z.object({
        visibleApps: z.optional(z.object({
            links: z.optional(zRelationshipLinks),
            meta: z.optional(zPagingInformation),
            data: z.optional(z.array(z.object({
                type: z.enum(['apps']),
                id: z.string()
            })))
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * UsersResponse
 */
export const zUsersResponse = z.object({
    data: z.array(zUser),
    included: z.optional(z.array(zApp)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * UserResponse
 */
export const zUserResponse = z.object({
    data: zUser,
    included: z.optional(z.array(zApp)),
    links: zDocumentLinks
});

/**
 * UserUpdateRequest
 */
export const zUserUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['users']),
        id: z.string(),
        attributes: z.optional(z.object({
            roles: z.optional(z.union([
                z.array(zUserRole),
                z.null()
            ])),
            allAppsVisible: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            provisioningAllowed: z.optional(z.union([
                z.boolean(),
                z.null()
            ]))
        })),
        relationships: z.optional(z.object({
            visibleApps: z.optional(z.object({
                data: z.optional(z.array(z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })))
            }))
        }))
    })
});

export const zWebhookEventType = z.enum([
    'ALTERNATIVE_DISTRIBUTION_PACKAGE_AVAILABLE_UPDATED',
    'ALTERNATIVE_DISTRIBUTION_PACKAGE_VERSION_CREATED',
    'ALTERNATIVE_DISTRIBUTION_TERRITORY_AVAILABILITY_UPDATED',
    'APP_STORE_VERSION_APP_VERSION_STATE_UPDATED',
    'BACKGROUND_ASSET_VERSION_APP_STORE_RELEASE_STATE_UPDATED',
    'BACKGROUND_ASSET_VERSION_EXTERNAL_BETA_RELEASE_STATE_UPDATED',
    'BACKGROUND_ASSET_VERSION_INTERNAL_BETA_RELEASE_CREATED',
    'BACKGROUND_ASSET_VERSION_STATE_UPDATED',
    'BETA_FEEDBACK_CRASH_SUBMISSION_CREATED',
    'BETA_FEEDBACK_SCREENSHOT_SUBMISSION_CREATED',
    'BUILD_BETA_DETAIL_EXTERNAL_BUILD_STATE_UPDATED',
    'BUILD_UPLOAD_STATE_UPDATED'
]);

/**
 * WebhookEvent
 */
export const zWebhookEvent = z.object({
    type: z.enum(['webhookEvents']),
    id: z.string(),
    attributes: z.optional(z.object({
        eventType: z.optional(zWebhookEventType),
        payload: z.optional(z.string()),
        ping: z.optional(z.boolean()),
        createdDate: z.optional(z.iso.datetime())
    })),
    links: z.optional(zResourceLinks)
});

/**
 * WebhookDeliveriesResponse
 */
export const zWebhookDeliveriesResponse = z.object({
    data: z.array(zWebhookDelivery),
    included: z.optional(z.array(zWebhookEvent)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * WebhookDeliveryResponse
 */
export const zWebhookDeliveryResponse = z.object({
    data: zWebhookDelivery,
    included: z.optional(z.array(zWebhookEvent)),
    links: zDocumentLinks
});

/**
 * Webhook
 */
export const zWebhook = z.object({
    type: z.enum(['webhooks']),
    id: z.string(),
    attributes: z.optional(z.object({
        enabled: z.optional(z.boolean()),
        eventTypes: z.optional(z.array(zWebhookEventType)),
        name: z.optional(z.string()),
        url: z.optional(z.url())
    })),
    relationships: z.optional(z.object({
        app: z.optional(z.object({
            data: z.optional(z.object({
                type: z.enum(['apps']),
                id: z.string()
            }))
        })),
        deliveries: z.optional(z.object({
            links: z.optional(zRelationshipLinks)
        }))
    })),
    links: z.optional(zResourceLinks)
});

/**
 * WebhooksResponse
 */
export const zWebhooksResponse = z.object({
    data: z.array(zWebhook),
    included: z.optional(z.array(zApp)),
    links: zPagedDocumentLinks,
    meta: z.optional(zPagingInformation)
});

/**
 * WebhookResponse
 */
export const zWebhookResponse = z.object({
    data: zWebhook,
    included: z.optional(z.array(zApp)),
    links: zDocumentLinks
});

/**
 * WebhookCreateRequest
 */
export const zWebhookCreateRequest = z.object({
    data: z.object({
        type: z.enum(['webhooks']),
        attributes: z.object({
            enabled: z.boolean(),
            eventTypes: z.array(zWebhookEventType),
            name: z.string(),
            secret: z.string(),
            url: z.url()
        }),
        relationships: z.object({
            app: z.object({
                data: z.object({
                    type: z.enum(['apps']),
                    id: z.string()
                })
            })
        })
    })
});

/**
 * WebhookUpdateRequest
 */
export const zWebhookUpdateRequest = z.object({
    data: z.object({
        type: z.enum(['webhooks']),
        id: z.string(),
        attributes: z.optional(z.object({
            enabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            eventTypes: z.optional(z.union([
                z.array(zWebhookEventType),
                z.null()
            ])),
            name: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            secret: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            url: z.optional(z.union([
                z.url(),
                z.null()
            ]))
        }))
    })
});

export const zCsv = z.string();

export const zDiagnosticLogs = z.object({
    productData: z.optional(z.array(z.object({
        signatureId: z.optional(z.string()),
        diagnosticInsights: z.optional(z.array(z.object({
            insightsURL: z.optional(z.string()),
            insightsCategory: z.optional(z.string()),
            insightsString: z.optional(z.string())
        }))),
        diagnosticLogs: z.optional(z.array(z.object({
            callStackTree: z.optional(z.array(z.object({
                callStackPerThread: z.optional(z.boolean()),
                callStacks: z.optional(z.array(z.object({
                    callStackRootFrames: z.optional(z.array(zDiagnosticLogCallStackNode))
                })))
            }))),
            diagnosticMetaData: z.optional(z.object({
                bundleId: z.optional(z.string()),
                event: z.optional(z.string()),
                osVersion: z.optional(z.string()),
                appVersion: z.optional(z.string()),
                writesCaused: z.optional(z.string()),
                deviceType: z.optional(z.string()),
                platformArchitecture: z.optional(z.string()),
                eventDetail: z.optional(z.string()),
                buildVersion: z.optional(z.string())
            }))
        })))
    }))),
    version: z.optional(z.string())
});

export const zGzip = z.string();

export const zXcodeMetrics = z.object({
    version: z.optional(z.string()),
    insights: z.optional(z.object({
        trendingUp: z.optional(z.array(zMetricsInsight)),
        regressions: z.optional(z.array(zMetricsInsight))
    })),
    productData: z.optional(z.array(z.object({
        platform: z.optional(z.string()),
        metricCategories: z.optional(z.array(z.object({
            identifier: z.optional(zMetricCategory),
            metrics: z.optional(z.array(z.object({
                identifier: z.optional(z.string()),
                goalKeys: z.optional(z.array(z.object({
                    goalKey: z.optional(z.string()),
                    lowerBound: z.optional(z.int()),
                    upperBound: z.optional(z.int())
                }))),
                unit: z.optional(z.object({
                    identifier: z.optional(z.string()),
                    displayName: z.optional(z.string())
                })),
                datasets: z.optional(z.array(z.object({
                    filterCriteria: z.optional(z.object({
                        percentile: z.optional(z.string()),
                        device: z.optional(z.string()),
                        deviceMarketingName: z.optional(z.string())
                    })),
                    points: z.optional(z.array(z.object({
                        version: z.optional(z.string()),
                        value: z.optional(z.number()),
                        errorMargin: z.optional(z.number()),
                        percentageBreakdown: z.optional(z.object({
                            value: z.optional(z.number()),
                            subSystemLabel: z.optional(z.string())
                        })),
                        goal: z.optional(z.string())
                    }))),
                    recommendedMetricGoal: z.optional(z.object({
                        value: z.optional(z.number()),
                        detail: z.optional(z.string())
                    }))
                })))
            })))
        })))
    })))
});

export const zAccessibilityDeclarationsCreateInstanceData = z.object({
    body: zAccessibilityDeclarationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AccessibilityDeclaration
 */
export const zAccessibilityDeclarationsCreateInstanceResponse = zAccessibilityDeclarationResponse;

export const zAccessibilityDeclarationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAccessibilityDeclarationsDeleteInstanceResponse = z.void();

export const zAccessibilityDeclarationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[accessibilityDeclarations]': z.optional(z.array(z.enum([
            'deviceFamily',
            'state',
            'supportsAudioDescriptions',
            'supportsCaptions',
            'supportsDarkInterface',
            'supportsDifferentiateWithoutColorAlone',
            'supportsLargerText',
            'supportsReducedMotion',
            'supportsSufficientContrast',
            'supportsVoiceControl',
            'supportsVoiceover'
        ])))
    }))
});

/**
 * Single AccessibilityDeclaration
 */
export const zAccessibilityDeclarationsGetInstanceResponse = zAccessibilityDeclarationResponse;

export const zAccessibilityDeclarationsUpdateInstanceData = z.object({
    body: zAccessibilityDeclarationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AccessibilityDeclaration
 */
export const zAccessibilityDeclarationsUpdateInstanceResponse = zAccessibilityDeclarationResponse;

export const zActorsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        'filter[id]': z.array(z.string()),
        'fields[actors]': z.optional(z.array(z.enum([
            'actorType',
            'userFirstName',
            'userLastName',
            'userEmail',
            'apiKeyId'
        ]))),
        limit: z.optional(z.int().lte(200))
    })
});

/**
 * List of Actors
 */
export const zActorsGetCollectionResponse = zActorsResponse;

export const zActorsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[actors]': z.optional(z.array(z.enum([
            'actorType',
            'userFirstName',
            'userLastName',
            'userEmail',
            'apiKeyId'
        ])))
    }))
});

/**
 * Single Actor
 */
export const zActorsGetInstanceResponse = zActorResponse;

export const zAgeRatingDeclarationsUpdateInstanceData = z.object({
    body: zAgeRatingDeclarationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AgeRatingDeclaration
 */
export const zAgeRatingDeclarationsUpdateInstanceResponse = zAgeRatingDeclarationResponse;

export const zAlternativeDistributionDomainsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'fields[alternativeDistributionDomains]': z.optional(z.array(z.enum([
            'domain',
            'referenceName',
            'createdDate'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AlternativeDistributionDomains
 */
export const zAlternativeDistributionDomainsGetCollectionResponse = zAlternativeDistributionDomainsResponse;

export const zAlternativeDistributionDomainsCreateInstanceData = z.object({
    body: zAlternativeDistributionDomainCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AlternativeDistributionDomain
 */
export const zAlternativeDistributionDomainsCreateInstanceResponse = zAlternativeDistributionDomainResponse;

export const zAlternativeDistributionDomainsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAlternativeDistributionDomainsDeleteInstanceResponse = z.void();

export const zAlternativeDistributionDomainsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[alternativeDistributionDomains]': z.optional(z.array(z.enum([
            'domain',
            'referenceName',
            'createdDate'
        ])))
    }))
});

/**
 * Single AlternativeDistributionDomain
 */
export const zAlternativeDistributionDomainsGetInstanceResponse = zAlternativeDistributionDomainResponse;

export const zAlternativeDistributionKeysGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'exists[app]': z.optional(z.boolean()),
        'fields[alternativeDistributionKeys]': z.optional(z.array(z.enum(['publicKey']))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AlternativeDistributionKeys
 */
export const zAlternativeDistributionKeysGetCollectionResponse = zAlternativeDistributionKeysResponse;

export const zAlternativeDistributionKeysCreateInstanceData = z.object({
    body: zAlternativeDistributionKeyCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AlternativeDistributionKey
 */
export const zAlternativeDistributionKeysCreateInstanceResponse = zAlternativeDistributionKeyResponse;

export const zAlternativeDistributionKeysDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAlternativeDistributionKeysDeleteInstanceResponse = z.void();

export const zAlternativeDistributionKeysGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[alternativeDistributionKeys]': z.optional(z.array(z.enum(['publicKey'])))
    }))
});

/**
 * Single AlternativeDistributionKey
 */
export const zAlternativeDistributionKeysGetInstanceResponse = zAlternativeDistributionKeyResponse;

export const zAlternativeDistributionPackageDeltasGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[alternativeDistributionPackageDeltas]': z.optional(z.array(z.enum([
            'url',
            'urlExpirationDate',
            'alternativeDistributionKeyBlob',
            'fileChecksum'
        ])))
    }))
});

/**
 * Single AlternativeDistributionPackageDelta
 */
export const zAlternativeDistributionPackageDeltasGetInstanceResponse = zAlternativeDistributionPackageDeltaResponse;

export const zAlternativeDistributionPackageVariantsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[alternativeDistributionPackageVariants]': z.optional(z.array(z.enum([
            'url',
            'urlExpirationDate',
            'alternativeDistributionKeyBlob',
            'fileChecksum'
        ])))
    }))
});

/**
 * Single AlternativeDistributionPackageVariant
 */
export const zAlternativeDistributionPackageVariantsGetInstanceResponse = zAlternativeDistributionPackageVariantResponse;

export const zAlternativeDistributionPackageVersionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[alternativeDistributionPackageVersions]': z.optional(z.array(z.enum([
            'url',
            'urlExpirationDate',
            'version',
            'fileChecksum',
            'state',
            'variants',
            'deltas',
            'alternativeDistributionPackage'
        ]))),
        'fields[alternativeDistributionPackageVariants]': z.optional(z.array(z.enum([
            'url',
            'urlExpirationDate',
            'alternativeDistributionKeyBlob',
            'fileChecksum'
        ]))),
        'fields[alternativeDistributionPackageDeltas]': z.optional(z.array(z.enum([
            'url',
            'urlExpirationDate',
            'alternativeDistributionKeyBlob',
            'fileChecksum'
        ]))),
        include: z.optional(z.array(z.enum([
            'variants',
            'deltas',
            'alternativeDistributionPackage'
        ]))),
        'limit[deltas]': z.optional(z.int().lte(50)),
        'limit[variants]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AlternativeDistributionPackageVersion
 */
export const zAlternativeDistributionPackageVersionsGetInstanceResponse = zAlternativeDistributionPackageVersionResponse;

export const zAlternativeDistributionPackagesCreateInstanceData = z.object({
    body: zAlternativeDistributionPackageCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AlternativeDistributionPackage
 */
export const zAlternativeDistributionPackagesCreateInstanceResponse = zAlternativeDistributionPackageResponse;

export const zAlternativeDistributionPackagesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[alternativeDistributionPackages]': z.optional(z.array(z.enum(['sourceFileChecksum', 'versions']))),
        'fields[alternativeDistributionPackageVersions]': z.optional(z.array(z.enum([
            'url',
            'urlExpirationDate',
            'version',
            'fileChecksum',
            'state',
            'variants',
            'deltas',
            'alternativeDistributionPackage'
        ]))),
        include: z.optional(z.array(z.enum(['versions']))),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AlternativeDistributionPackage
 */
export const zAlternativeDistributionPackagesGetInstanceResponse = zAlternativeDistributionPackageResponse;

export const zAnalyticsReportInstancesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[analyticsReportInstances]': z.optional(z.array(z.enum([
            'granularity',
            'processingDate',
            'segments'
        ])))
    }))
});

/**
 * Single AnalyticsReportInstance
 */
export const zAnalyticsReportInstancesGetInstanceResponse = zAnalyticsReportInstanceResponse;

export const zAnalyticsReportRequestsCreateInstanceData = z.object({
    body: zAnalyticsReportRequestCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AnalyticsReportRequest
 */
export const zAnalyticsReportRequestsCreateInstanceResponse = zAnalyticsReportRequestResponse;

export const zAnalyticsReportRequestsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAnalyticsReportRequestsDeleteInstanceResponse = z.void();

export const zAnalyticsReportRequestsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[analyticsReportRequests]': z.optional(z.array(z.enum([
            'accessType',
            'stoppedDueToInactivity',
            'reports'
        ]))),
        'fields[analyticsReports]': z.optional(z.array(z.enum([
            'name',
            'category',
            'instances'
        ]))),
        include: z.optional(z.array(z.enum(['reports']))),
        'limit[reports]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AnalyticsReportRequest
 */
export const zAnalyticsReportRequestsGetInstanceResponse = zAnalyticsReportRequestResponse;

export const zAnalyticsReportSegmentsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[analyticsReportSegments]': z.optional(z.array(z.enum([
            'checksum',
            'sizeInBytes',
            'url'
        ])))
    }))
});

/**
 * Single AnalyticsReportSegment
 */
export const zAnalyticsReportSegmentsGetInstanceResponse = zAnalyticsReportSegmentResponse;

export const zAnalyticsReportsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[analyticsReports]': z.optional(z.array(z.enum([
            'name',
            'category',
            'instances'
        ])))
    }))
});

/**
 * Single AnalyticsReport
 */
export const zAnalyticsReportsGetInstanceResponse = zAnalyticsReportResponse;

export const zAndroidToIosAppMappingDetailsCreateInstanceData = z.object({
    body: zAndroidToIosAppMappingDetailCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AndroidToIosAppMappingDetail
 */
export const zAndroidToIosAppMappingDetailsCreateInstanceResponse = zAndroidToIosAppMappingDetailResponse;

export const zAndroidToIosAppMappingDetailsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAndroidToIosAppMappingDetailsDeleteInstanceResponse = z.void();

export const zAndroidToIosAppMappingDetailsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[androidToIosAppMappingDetails]': z.optional(z.array(z.enum(['packageName', 'appSigningKeyPublicCertificateSha256Fingerprints'])))
    }))
});

/**
 * Single AndroidToIosAppMappingDetail
 */
export const zAndroidToIosAppMappingDetailsGetInstanceResponse = zAndroidToIosAppMappingDetailResponse;

export const zAndroidToIosAppMappingDetailsUpdateInstanceData = z.object({
    body: zAndroidToIosAppMappingDetailUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AndroidToIosAppMappingDetail
 */
export const zAndroidToIosAppMappingDetailsUpdateInstanceResponse = zAndroidToIosAppMappingDetailResponse;

export const zAppAvailabilitiesV2CreateInstanceData = z.object({
    body: zAppAvailabilityV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppAvailability
 */
export const zAppAvailabilitiesV2CreateInstanceResponse = zAppAvailabilityV2Response;

export const zAppAvailabilitiesV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appAvailabilities]': z.optional(z.array(z.enum(['availableInNewTerritories', 'territoryAvailabilities']))),
        'fields[territoryAvailabilities]': z.optional(z.array(z.enum([
            'available',
            'releaseDate',
            'preOrderEnabled',
            'preOrderPublishDate',
            'contentStatuses',
            'territory'
        ]))),
        include: z.optional(z.array(z.enum(['territoryAvailabilities']))),
        'limit[territoryAvailabilities]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppAvailability
 */
export const zAppAvailabilitiesV2GetInstanceResponse = zAppAvailabilityV2Response;

export const zAppCategoriesGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[platforms]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'exists[parent]': z.optional(z.boolean()),
        'fields[appCategories]': z.optional(z.array(z.enum([
            'platforms',
            'subcategories',
            'parent'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['subcategories', 'parent']))),
        'limit[subcategories]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppCategories
 */
export const zAppCategoriesGetCollectionResponse = zAppCategoriesResponse;

export const zAppCategoriesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appCategories]': z.optional(z.array(z.enum([
            'platforms',
            'subcategories',
            'parent'
        ]))),
        include: z.optional(z.array(z.enum(['subcategories', 'parent']))),
        'limit[subcategories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppCategory
 */
export const zAppCategoriesGetInstanceResponse = zAppCategoryResponse;

export const zAppClipAdvancedExperienceImagesCreateInstanceData = z.object({
    body: zAppClipAdvancedExperienceImageCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppClipAdvancedExperienceImage
 */
export const zAppClipAdvancedExperienceImagesCreateInstanceResponse = zAppClipAdvancedExperienceImageResponse;

export const zAppClipAdvancedExperienceImagesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appClipAdvancedExperienceImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ])))
    }))
});

/**
 * Single AppClipAdvancedExperienceImage
 */
export const zAppClipAdvancedExperienceImagesGetInstanceResponse = zAppClipAdvancedExperienceImageResponse;

export const zAppClipAdvancedExperienceImagesUpdateInstanceData = z.object({
    body: zAppClipAdvancedExperienceImageUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppClipAdvancedExperienceImage
 */
export const zAppClipAdvancedExperienceImagesUpdateInstanceResponse = zAppClipAdvancedExperienceImageResponse;

export const zAppClipAdvancedExperiencesCreateInstanceData = z.object({
    body: zAppClipAdvancedExperienceCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppClipAdvancedExperience
 */
export const zAppClipAdvancedExperiencesCreateInstanceResponse = zAppClipAdvancedExperienceResponse;

export const zAppClipAdvancedExperiencesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appClipAdvancedExperiences]': z.optional(z.array(z.enum([
            'link',
            'version',
            'status',
            'action',
            'isPoweredBy',
            'place',
            'placeStatus',
            'businessCategory',
            'defaultLanguage',
            'appClip',
            'headerImage',
            'localizations'
        ]))),
        include: z.optional(z.array(z.enum([
            'appClip',
            'headerImage',
            'localizations'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppClipAdvancedExperience
 */
export const zAppClipAdvancedExperiencesGetInstanceResponse = zAppClipAdvancedExperienceResponse;

export const zAppClipAdvancedExperiencesUpdateInstanceData = z.object({
    body: zAppClipAdvancedExperienceUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppClipAdvancedExperience
 */
export const zAppClipAdvancedExperiencesUpdateInstanceResponse = zAppClipAdvancedExperienceResponse;

export const zAppClipAppStoreReviewDetailsCreateInstanceData = z.object({
    body: zAppClipAppStoreReviewDetailCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppClipAppStoreReviewDetail
 */
export const zAppClipAppStoreReviewDetailsCreateInstanceResponse = zAppClipAppStoreReviewDetailResponse;

export const zAppClipAppStoreReviewDetailsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appClipAppStoreReviewDetails]': z.optional(z.array(z.enum(['invocationUrls', 'appClipDefaultExperience']))),
        include: z.optional(z.array(z.enum(['appClipDefaultExperience'])))
    }))
});

/**
 * Single AppClipAppStoreReviewDetail
 */
export const zAppClipAppStoreReviewDetailsGetInstanceResponse = zAppClipAppStoreReviewDetailResponse;

export const zAppClipAppStoreReviewDetailsUpdateInstanceData = z.object({
    body: zAppClipAppStoreReviewDetailUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppClipAppStoreReviewDetail
 */
export const zAppClipAppStoreReviewDetailsUpdateInstanceResponse = zAppClipAppStoreReviewDetailResponse;

export const zAppClipDefaultExperienceLocalizationsCreateInstanceData = z.object({
    body: zAppClipDefaultExperienceLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppClipDefaultExperienceLocalization
 */
export const zAppClipDefaultExperienceLocalizationsCreateInstanceResponse = zAppClipDefaultExperienceLocalizationResponse;

export const zAppClipDefaultExperienceLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppClipDefaultExperienceLocalizationsDeleteInstanceResponse = z.void();

export const zAppClipDefaultExperienceLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appClipDefaultExperienceLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'subtitle',
            'appClipDefaultExperience',
            'appClipHeaderImage'
        ]))),
        'fields[appClipHeaderImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'appClipDefaultExperienceLocalization'
        ]))),
        include: z.optional(z.array(z.enum(['appClipDefaultExperience', 'appClipHeaderImage'])))
    }))
});

/**
 * Single AppClipDefaultExperienceLocalization
 */
export const zAppClipDefaultExperienceLocalizationsGetInstanceResponse = zAppClipDefaultExperienceLocalizationResponse;

export const zAppClipDefaultExperienceLocalizationsUpdateInstanceData = z.object({
    body: zAppClipDefaultExperienceLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppClipDefaultExperienceLocalization
 */
export const zAppClipDefaultExperienceLocalizationsUpdateInstanceResponse = zAppClipDefaultExperienceLocalizationResponse;

export const zAppClipDefaultExperiencesCreateInstanceData = z.object({
    body: zAppClipDefaultExperienceCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppClipDefaultExperience
 */
export const zAppClipDefaultExperiencesCreateInstanceResponse = zAppClipDefaultExperienceResponse;

export const zAppClipDefaultExperiencesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppClipDefaultExperiencesDeleteInstanceResponse = z.void();

export const zAppClipDefaultExperiencesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appClipDefaultExperiences]': z.optional(z.array(z.enum([
            'action',
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[appClipDefaultExperienceLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'subtitle',
            'appClipDefaultExperience',
            'appClipHeaderImage'
        ]))),
        'fields[appClipAppStoreReviewDetails]': z.optional(z.array(z.enum(['invocationUrls', 'appClipDefaultExperience']))),
        include: z.optional(z.array(z.enum([
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        'limit[appClipDefaultExperienceLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppClipDefaultExperience
 */
export const zAppClipDefaultExperiencesGetInstanceResponse = zAppClipDefaultExperienceResponse;

export const zAppClipDefaultExperiencesUpdateInstanceData = z.object({
    body: zAppClipDefaultExperienceUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppClipDefaultExperience
 */
export const zAppClipDefaultExperiencesUpdateInstanceResponse = zAppClipDefaultExperienceResponse;

export const zAppClipHeaderImagesCreateInstanceData = z.object({
    body: zAppClipHeaderImageCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppClipHeaderImage
 */
export const zAppClipHeaderImagesCreateInstanceResponse = zAppClipHeaderImageResponse;

export const zAppClipHeaderImagesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppClipHeaderImagesDeleteInstanceResponse = z.void();

export const zAppClipHeaderImagesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appClipHeaderImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'appClipDefaultExperienceLocalization'
        ]))),
        include: z.optional(z.array(z.enum(['appClipDefaultExperienceLocalization'])))
    }))
});

/**
 * Single AppClipHeaderImage
 */
export const zAppClipHeaderImagesGetInstanceResponse = zAppClipHeaderImageResponse;

export const zAppClipHeaderImagesUpdateInstanceData = z.object({
    body: zAppClipHeaderImageUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppClipHeaderImage
 */
export const zAppClipHeaderImagesUpdateInstanceResponse = zAppClipHeaderImageResponse;

export const zAppClipsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appClips]': z.optional(z.array(z.enum([
            'bundleId',
            'app',
            'appClipDefaultExperiences',
            'appClipAdvancedExperiences'
        ]))),
        'fields[appClipDefaultExperiences]': z.optional(z.array(z.enum([
            'action',
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        include: z.optional(z.array(z.enum(['app', 'appClipDefaultExperiences']))),
        'limit[appClipDefaultExperiences]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppClip
 */
export const zAppClipsGetInstanceResponse = zAppClipResponse;

export const zAppCustomProductPageLocalizationsCreateInstanceData = z.object({
    body: zAppCustomProductPageLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppCustomProductPageLocalization
 */
export const zAppCustomProductPageLocalizationsCreateInstanceResponse = zAppCustomProductPageLocalizationResponse;

export const zAppCustomProductPageLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppCustomProductPageLocalizationsDeleteInstanceResponse = z.void();

export const zAppCustomProductPageLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appCustomProductPageLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'promotionalText',
            'appCustomProductPageVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appScreenshotSets]': z.optional(z.array(z.enum([
            'screenshotDisplayType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'fields[appPreviewSets]': z.optional(z.array(z.enum([
            'previewType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        include: z.optional(z.array(z.enum([
            'appCustomProductPageVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'limit[appPreviewSets]': z.optional(z.int().lte(50)),
        'limit[appScreenshotSets]': z.optional(z.int().lte(50)),
        'limit[searchKeywords]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppCustomProductPageLocalization
 */
export const zAppCustomProductPageLocalizationsGetInstanceResponse = zAppCustomProductPageLocalizationResponse;

export const zAppCustomProductPageLocalizationsUpdateInstanceData = z.object({
    body: zAppCustomProductPageLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppCustomProductPageLocalization
 */
export const zAppCustomProductPageLocalizationsUpdateInstanceResponse = zAppCustomProductPageLocalizationResponse;

export const zAppCustomProductPageVersionsCreateInstanceData = z.object({
    body: zAppCustomProductPageVersionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppCustomProductPageVersion
 */
export const zAppCustomProductPageVersionsCreateInstanceResponse = zAppCustomProductPageVersionResponse;

export const zAppCustomProductPageVersionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appCustomProductPageVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'deepLink',
            'appCustomProductPage',
            'appCustomProductPageLocalizations'
        ]))),
        'fields[appCustomProductPageLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'promotionalText',
            'appCustomProductPageVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        include: z.optional(z.array(z.enum(['appCustomProductPage', 'appCustomProductPageLocalizations']))),
        'limit[appCustomProductPageLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppCustomProductPageVersion
 */
export const zAppCustomProductPageVersionsGetInstanceResponse = zAppCustomProductPageVersionResponse;

export const zAppCustomProductPageVersionsUpdateInstanceData = z.object({
    body: zAppCustomProductPageVersionUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppCustomProductPageVersion
 */
export const zAppCustomProductPageVersionsUpdateInstanceResponse = zAppCustomProductPageVersionResponse;

export const zAppCustomProductPagesCreateInstanceData = z.object({
    body: zAppCustomProductPageCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppCustomProductPage
 */
export const zAppCustomProductPagesCreateInstanceResponse = zAppCustomProductPageResponse;

export const zAppCustomProductPagesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppCustomProductPagesDeleteInstanceResponse = z.void();

export const zAppCustomProductPagesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appCustomProductPages]': z.optional(z.array(z.enum([
            'name',
            'url',
            'visible',
            'app',
            'appCustomProductPageVersions'
        ]))),
        'fields[appCustomProductPageVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'deepLink',
            'appCustomProductPage',
            'appCustomProductPageLocalizations'
        ]))),
        include: z.optional(z.array(z.enum(['app', 'appCustomProductPageVersions']))),
        'limit[appCustomProductPageVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppCustomProductPage
 */
export const zAppCustomProductPagesGetInstanceResponse = zAppCustomProductPageResponse;

export const zAppCustomProductPagesUpdateInstanceData = z.object({
    body: zAppCustomProductPageUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppCustomProductPage
 */
export const zAppCustomProductPagesUpdateInstanceResponse = zAppCustomProductPageResponse;

export const zAppEncryptionDeclarationDocumentsCreateInstanceData = z.object({
    body: zAppEncryptionDeclarationDocumentCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppEncryptionDeclarationDocument
 */
export const zAppEncryptionDeclarationDocumentsCreateInstanceResponse = zAppEncryptionDeclarationDocumentResponse;

export const zAppEncryptionDeclarationDocumentsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appEncryptionDeclarationDocuments]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'assetToken',
            'downloadUrl',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState'
        ])))
    }))
});

/**
 * Single AppEncryptionDeclarationDocument
 */
export const zAppEncryptionDeclarationDocumentsGetInstanceResponse = zAppEncryptionDeclarationDocumentResponse;

export const zAppEncryptionDeclarationDocumentsUpdateInstanceData = z.object({
    body: zAppEncryptionDeclarationDocumentUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppEncryptionDeclarationDocument
 */
export const zAppEncryptionDeclarationDocumentsUpdateInstanceResponse = zAppEncryptionDeclarationDocumentResponse;

export const zAppEncryptionDeclarationsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[app]': z.optional(z.array(z.string())),
        'filter[builds]': z.optional(z.array(z.string())),
        'fields[appEncryptionDeclarations]': z.optional(z.array(z.enum([
            'appDescription',
            'createdDate',
            'usesEncryption',
            'exempt',
            'containsProprietaryCryptography',
            'containsThirdPartyCryptography',
            'availableOnFrenchStore',
            'platform',
            'uploadedDate',
            'documentUrl',
            'documentName',
            'documentType',
            'appEncryptionDeclarationState',
            'codeValue',
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[appEncryptionDeclarationDocuments]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'assetToken',
            'downloadUrl',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'limit[builds]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppEncryptionDeclarations
 */
export const zAppEncryptionDeclarationsGetCollectionResponse = zAppEncryptionDeclarationsResponse;

export const zAppEncryptionDeclarationsCreateInstanceData = z.object({
    body: zAppEncryptionDeclarationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppEncryptionDeclaration
 */
export const zAppEncryptionDeclarationsCreateInstanceResponse = zAppEncryptionDeclarationResponse;

export const zAppEncryptionDeclarationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appEncryptionDeclarations]': z.optional(z.array(z.enum([
            'appDescription',
            'createdDate',
            'usesEncryption',
            'exempt',
            'containsProprietaryCryptography',
            'containsThirdPartyCryptography',
            'availableOnFrenchStore',
            'platform',
            'uploadedDate',
            'documentUrl',
            'documentName',
            'documentType',
            'appEncryptionDeclarationState',
            'codeValue',
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[appEncryptionDeclarationDocuments]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'assetToken',
            'downloadUrl',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState'
        ]))),
        include: z.optional(z.array(z.enum([
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'limit[builds]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppEncryptionDeclaration
 */
export const zAppEncryptionDeclarationsGetInstanceResponse = zAppEncryptionDeclarationResponse;

export const zAppEventLocalizationsCreateInstanceData = z.object({
    body: zAppEventLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppEventLocalization
 */
export const zAppEventLocalizationsCreateInstanceResponse = zAppEventLocalizationResponse;

export const zAppEventLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppEventLocalizationsDeleteInstanceResponse = z.void();

export const zAppEventLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appEventLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'shortDescription',
            'longDescription',
            'appEvent',
            'appEventScreenshots',
            'appEventVideoClips'
        ]))),
        'fields[appEventScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'assetToken',
            'uploadOperations',
            'assetDeliveryState',
            'appEventAssetType',
            'appEventLocalization'
        ]))),
        'fields[appEventVideoClips]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'previewFrameTimeCode',
            'videoUrl',
            'previewFrameImage',
            'previewImage',
            'uploadOperations',
            'assetDeliveryState',
            'videoDeliveryState',
            'appEventAssetType',
            'appEventLocalization'
        ]))),
        include: z.optional(z.array(z.enum([
            'appEvent',
            'appEventScreenshots',
            'appEventVideoClips'
        ]))),
        'limit[appEventScreenshots]': z.optional(z.int().lte(50)),
        'limit[appEventVideoClips]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppEventLocalization
 */
export const zAppEventLocalizationsGetInstanceResponse = zAppEventLocalizationResponse;

export const zAppEventLocalizationsUpdateInstanceData = z.object({
    body: zAppEventLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppEventLocalization
 */
export const zAppEventLocalizationsUpdateInstanceResponse = zAppEventLocalizationResponse;

export const zAppEventScreenshotsCreateInstanceData = z.object({
    body: zAppEventScreenshotCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppEventScreenshot
 */
export const zAppEventScreenshotsCreateInstanceResponse = zAppEventScreenshotResponse;

export const zAppEventScreenshotsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppEventScreenshotsDeleteInstanceResponse = z.void();

export const zAppEventScreenshotsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appEventScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'assetToken',
            'uploadOperations',
            'assetDeliveryState',
            'appEventAssetType',
            'appEventLocalization'
        ]))),
        include: z.optional(z.array(z.enum(['appEventLocalization'])))
    }))
});

/**
 * Single AppEventScreenshot
 */
export const zAppEventScreenshotsGetInstanceResponse = zAppEventScreenshotResponse;

export const zAppEventScreenshotsUpdateInstanceData = z.object({
    body: zAppEventScreenshotUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppEventScreenshot
 */
export const zAppEventScreenshotsUpdateInstanceResponse = zAppEventScreenshotResponse;

export const zAppEventVideoClipsCreateInstanceData = z.object({
    body: zAppEventVideoClipCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppEventVideoClip
 */
export const zAppEventVideoClipsCreateInstanceResponse = zAppEventVideoClipResponse;

export const zAppEventVideoClipsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppEventVideoClipsDeleteInstanceResponse = z.void();

export const zAppEventVideoClipsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appEventVideoClips]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'previewFrameTimeCode',
            'videoUrl',
            'previewFrameImage',
            'previewImage',
            'uploadOperations',
            'assetDeliveryState',
            'videoDeliveryState',
            'appEventAssetType',
            'appEventLocalization'
        ]))),
        include: z.optional(z.array(z.enum(['appEventLocalization'])))
    }))
});

/**
 * Single AppEventVideoClip
 */
export const zAppEventVideoClipsGetInstanceResponse = zAppEventVideoClipResponse;

export const zAppEventVideoClipsUpdateInstanceData = z.object({
    body: zAppEventVideoClipUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppEventVideoClip
 */
export const zAppEventVideoClipsUpdateInstanceResponse = zAppEventVideoClipResponse;

export const zAppEventsCreateInstanceData = z.object({
    body: zAppEventCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppEvent
 */
export const zAppEventsCreateInstanceResponse = zAppEventResponse;

export const zAppEventsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppEventsDeleteInstanceResponse = z.void();

export const zAppEventsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appEvents]': z.optional(z.array(z.enum([
            'referenceName',
            'badge',
            'eventState',
            'deepLink',
            'purchaseRequirement',
            'primaryLocale',
            'priority',
            'purpose',
            'territorySchedules',
            'archivedTerritorySchedules',
            'localizations'
        ]))),
        'fields[appEventLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'shortDescription',
            'longDescription',
            'appEvent',
            'appEventScreenshots',
            'appEventVideoClips'
        ]))),
        include: z.optional(z.array(z.enum(['localizations']))),
        'limit[localizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppEvent
 */
export const zAppEventsGetInstanceResponse = zAppEventResponse;

export const zAppEventsUpdateInstanceData = z.object({
    body: zAppEventUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppEvent
 */
export const zAppEventsUpdateInstanceResponse = zAppEventResponse;

export const zAppInfoLocalizationsCreateInstanceData = z.object({
    body: zAppInfoLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppInfoLocalization
 */
export const zAppInfoLocalizationsCreateInstanceResponse = zAppInfoLocalizationResponse;

export const zAppInfoLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppInfoLocalizationsDeleteInstanceResponse = z.void();

export const zAppInfoLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appInfoLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'subtitle',
            'privacyPolicyUrl',
            'privacyChoicesUrl',
            'privacyPolicyText',
            'appInfo'
        ]))),
        include: z.optional(z.array(z.enum(['appInfo'])))
    }))
});

/**
 * Single AppInfoLocalization
 */
export const zAppInfoLocalizationsGetInstanceResponse = zAppInfoLocalizationResponse;

export const zAppInfoLocalizationsUpdateInstanceData = z.object({
    body: zAppInfoLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppInfoLocalization
 */
export const zAppInfoLocalizationsUpdateInstanceResponse = zAppInfoLocalizationResponse;

export const zAppInfosGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appInfos]': z.optional(z.array(z.enum([
            'appStoreState',
            'state',
            'appStoreAgeRating',
            'australiaAgeRating',
            'brazilAgeRating',
            'brazilAgeRatingV2',
            'franceAgeRating',
            'koreaAgeRating',
            'kidsAgeBand',
            'app',
            'ageRatingDeclaration',
            'appInfoLocalizations',
            'primaryCategory',
            'primarySubcategoryOne',
            'primarySubcategoryTwo',
            'secondaryCategory',
            'secondarySubcategoryOne',
            'secondarySubcategoryTwo',
            'territoryAgeRatings'
        ]))),
        'fields[ageRatingDeclarations]': z.optional(z.array(z.enum([
            'advertising',
            'alcoholTobaccoOrDrugUseOrReferences',
            'contests',
            'gambling',
            'gamblingSimulated',
            'gunsOrOtherWeapons',
            'healthOrWellnessTopics',
            'kidsAgeBand',
            'lootBox',
            'medicalOrTreatmentInformation',
            'messagingAndChat',
            'parentalControls',
            'profanityOrCrudeHumor',
            'ageAssurance',
            'sexualContentGraphicAndNudity',
            'sexualContentOrNudity',
            'horrorOrFearThemes',
            'matureOrSuggestiveThemes',
            'unrestrictedWebAccess',
            'userGeneratedContent',
            'violenceCartoonOrFantasy',
            'violenceRealisticProlongedGraphicOrSadistic',
            'violenceRealistic',
            'ageRatingOverride',
            'ageRatingOverrideV2',
            'koreaAgeRatingOverride',
            'developerAgeRatingInfoUrl'
        ]))),
        'fields[appInfoLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'subtitle',
            'privacyPolicyUrl',
            'privacyChoicesUrl',
            'privacyPolicyText',
            'appInfo'
        ]))),
        'fields[appCategories]': z.optional(z.array(z.enum([
            'platforms',
            'subcategories',
            'parent'
        ]))),
        include: z.optional(z.array(z.enum([
            'app',
            'ageRatingDeclaration',
            'appInfoLocalizations',
            'primaryCategory',
            'primarySubcategoryOne',
            'primarySubcategoryTwo',
            'secondaryCategory',
            'secondarySubcategoryOne',
            'secondarySubcategoryTwo'
        ]))),
        'limit[appInfoLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppInfo
 */
export const zAppInfosGetInstanceResponse = zAppInfoResponse;

export const zAppInfosUpdateInstanceData = z.object({
    body: zAppInfoUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppInfo
 */
export const zAppInfosUpdateInstanceResponse = zAppInfoResponse;

export const zAppPreviewSetsCreateInstanceData = z.object({
    body: zAppPreviewSetCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppPreviewSet
 */
export const zAppPreviewSetsCreateInstanceResponse = zAppPreviewSetResponse;

export const zAppPreviewSetsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppPreviewSetsDeleteInstanceResponse = z.void();

export const zAppPreviewSetsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appPreviewSets]': z.optional(z.array(z.enum([
            'previewType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        'fields[appPreviews]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'previewFrameTimeCode',
            'mimeType',
            'videoUrl',
            'previewFrameImage',
            'previewImage',
            'uploadOperations',
            'assetDeliveryState',
            'videoDeliveryState',
            'appPreviewSet'
        ]))),
        include: z.optional(z.array(z.enum([
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        'limit[appPreviews]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppPreviewSet
 */
export const zAppPreviewSetsGetInstanceResponse = zAppPreviewSetResponse;

export const zAppPreviewsCreateInstanceData = z.object({
    body: zAppPreviewCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppPreview
 */
export const zAppPreviewsCreateInstanceResponse = zAppPreviewResponse;

export const zAppPreviewsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppPreviewsDeleteInstanceResponse = z.void();

export const zAppPreviewsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appPreviews]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'previewFrameTimeCode',
            'mimeType',
            'videoUrl',
            'previewFrameImage',
            'previewImage',
            'uploadOperations',
            'assetDeliveryState',
            'videoDeliveryState',
            'appPreviewSet'
        ]))),
        include: z.optional(z.array(z.enum(['appPreviewSet'])))
    }))
});

/**
 * Single AppPreview
 */
export const zAppPreviewsGetInstanceResponse = zAppPreviewResponse;

export const zAppPreviewsUpdateInstanceData = z.object({
    body: zAppPreviewUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppPreview
 */
export const zAppPreviewsUpdateInstanceResponse = zAppPreviewResponse;

export const zAppPricePointsV3GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'app',
            'equalizations',
            'territory'
        ]))),
        include: z.optional(z.array(z.enum(['app', 'territory'])))
    }))
});

/**
 * Single AppPricePoint
 */
export const zAppPricePointsV3GetInstanceResponse = zAppPricePointV3Response;

export const zAppPriceSchedulesCreateInstanceData = z.object({
    body: zAppPriceScheduleCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppPriceSchedule
 */
export const zAppPriceSchedulesCreateInstanceResponse = zAppPriceScheduleResponse;

export const zAppPriceSchedulesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appPriceSchedules]': z.optional(z.array(z.enum([
            'app',
            'baseTerritory',
            'manualPrices',
            'automaticPrices'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        'fields[appPrices]': z.optional(z.array(z.enum([
            'manual',
            'startDate',
            'endDate',
            'appPricePoint',
            'territory'
        ]))),
        include: z.optional(z.array(z.enum([
            'app',
            'baseTerritory',
            'manualPrices',
            'automaticPrices'
        ]))),
        'limit[automaticPrices]': z.optional(z.int().lte(50)),
        'limit[manualPrices]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppPriceSchedule
 */
export const zAppPriceSchedulesGetInstanceResponse = zAppPriceScheduleResponse;

export const zAppScreenshotSetsCreateInstanceData = z.object({
    body: zAppScreenshotSetCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppScreenshotSet
 */
export const zAppScreenshotSetsCreateInstanceResponse = zAppScreenshotSetResponse;

export const zAppScreenshotSetsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppScreenshotSetsDeleteInstanceResponse = z.void();

export const zAppScreenshotSetsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appScreenshotSets]': z.optional(z.array(z.enum([
            'screenshotDisplayType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'fields[appScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'appScreenshotSet'
        ]))),
        include: z.optional(z.array(z.enum([
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'limit[appScreenshots]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppScreenshotSet
 */
export const zAppScreenshotSetsGetInstanceResponse = zAppScreenshotSetResponse;

export const zAppScreenshotsCreateInstanceData = z.object({
    body: zAppScreenshotCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppScreenshot
 */
export const zAppScreenshotsCreateInstanceResponse = zAppScreenshotResponse;

export const zAppScreenshotsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppScreenshotsDeleteInstanceResponse = z.void();

export const zAppScreenshotsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'appScreenshotSet'
        ]))),
        include: z.optional(z.array(z.enum(['appScreenshotSet'])))
    }))
});

/**
 * Single AppScreenshot
 */
export const zAppScreenshotsGetInstanceResponse = zAppScreenshotResponse;

export const zAppScreenshotsUpdateInstanceData = z.object({
    body: zAppScreenshotUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppScreenshot
 */
export const zAppScreenshotsUpdateInstanceResponse = zAppScreenshotResponse;

export const zAppStoreReviewAttachmentsCreateInstanceData = z.object({
    body: zAppStoreReviewAttachmentCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppStoreReviewAttachment
 */
export const zAppStoreReviewAttachmentsCreateInstanceResponse = zAppStoreReviewAttachmentResponse;

export const zAppStoreReviewAttachmentsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreReviewAttachmentsDeleteInstanceResponse = z.void();

export const zAppStoreReviewAttachmentsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreReviewAttachments]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState',
            'appStoreReviewDetail'
        ]))),
        include: z.optional(z.array(z.enum(['appStoreReviewDetail'])))
    }))
});

/**
 * Single AppStoreReviewAttachment
 */
export const zAppStoreReviewAttachmentsGetInstanceResponse = zAppStoreReviewAttachmentResponse;

export const zAppStoreReviewAttachmentsUpdateInstanceData = z.object({
    body: zAppStoreReviewAttachmentUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppStoreReviewAttachment
 */
export const zAppStoreReviewAttachmentsUpdateInstanceResponse = zAppStoreReviewAttachmentResponse;

export const zAppStoreReviewDetailsCreateInstanceData = z.object({
    body: zAppStoreReviewDetailCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppStoreReviewDetail
 */
export const zAppStoreReviewDetailsCreateInstanceResponse = zAppStoreReviewDetailResponse;

export const zAppStoreReviewDetailsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'appStoreVersion',
            'appStoreReviewAttachments'
        ]))),
        'fields[appStoreReviewAttachments]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState',
            'appStoreReviewDetail'
        ]))),
        include: z.optional(z.array(z.enum(['appStoreVersion', 'appStoreReviewAttachments']))),
        'limit[appStoreReviewAttachments]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppStoreReviewDetail
 */
export const zAppStoreReviewDetailsGetInstanceResponse = zAppStoreReviewDetailResponse;

export const zAppStoreReviewDetailsUpdateInstanceData = z.object({
    body: zAppStoreReviewDetailUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppStoreReviewDetail
 */
export const zAppStoreReviewDetailsUpdateInstanceResponse = zAppStoreReviewDetailResponse;

export const zAppStoreVersionExperimentTreatmentLocalizationsCreateInstanceData = z.object({
    body: zAppStoreVersionExperimentTreatmentLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionExperimentTreatmentLocalization
 */
export const zAppStoreVersionExperimentTreatmentLocalizationsCreateInstanceResponse = zAppStoreVersionExperimentTreatmentLocalizationResponse;

export const zAppStoreVersionExperimentTreatmentLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreVersionExperimentTreatmentLocalizationsDeleteInstanceResponse = z.void();

export const zAppStoreVersionExperimentTreatmentLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        'fields[appScreenshotSets]': z.optional(z.array(z.enum([
            'screenshotDisplayType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'fields[appPreviewSets]': z.optional(z.array(z.enum([
            'previewType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        include: z.optional(z.array(z.enum([
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        'limit[appPreviewSets]': z.optional(z.int().lte(50)),
        'limit[appScreenshotSets]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppStoreVersionExperimentTreatmentLocalization
 */
export const zAppStoreVersionExperimentTreatmentLocalizationsGetInstanceResponse = zAppStoreVersionExperimentTreatmentLocalizationResponse;

export const zAppStoreVersionExperimentTreatmentsCreateInstanceData = z.object({
    body: zAppStoreVersionExperimentTreatmentCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionExperimentTreatment
 */
export const zAppStoreVersionExperimentTreatmentsCreateInstanceResponse = zAppStoreVersionExperimentTreatmentResponse;

export const zAppStoreVersionExperimentTreatmentsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreVersionExperimentTreatmentsDeleteInstanceResponse = z.void();

export const zAppStoreVersionExperimentTreatmentsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersionExperimentTreatments]': z.optional(z.array(z.enum([
            'name',
            'appIcon',
            'appIconName',
            'promotedDate',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appStoreVersionExperimentTreatmentLocalizations'
        ]))),
        'fields[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        include: z.optional(z.array(z.enum([
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appStoreVersionExperimentTreatmentLocalizations'
        ]))),
        'limit[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppStoreVersionExperimentTreatment
 */
export const zAppStoreVersionExperimentTreatmentsGetInstanceResponse = zAppStoreVersionExperimentTreatmentResponse;

export const zAppStoreVersionExperimentTreatmentsUpdateInstanceData = z.object({
    body: zAppStoreVersionExperimentTreatmentUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionExperimentTreatment
 */
export const zAppStoreVersionExperimentTreatmentsUpdateInstanceResponse = zAppStoreVersionExperimentTreatmentResponse;

export const zAppStoreVersionExperimentsV2CreateInstanceData = z.object({
    body: zAppStoreVersionExperimentV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionExperiment
 */
export const zAppStoreVersionExperimentsV2CreateInstanceResponse = zAppStoreVersionExperimentV2Response;

export const zAppStoreVersionExperimentsV2DeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreVersionExperimentsV2DeleteInstanceResponse = z.void();

export const zAppStoreVersionExperimentsV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'app',
            'latestControlVersion',
            'controlVersions',
            'appStoreVersionExperimentTreatments'
        ]))),
        'fields[appStoreVersionExperimentTreatments]': z.optional(z.array(z.enum([
            'name',
            'appIcon',
            'appIconName',
            'promotedDate',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appStoreVersionExperimentTreatmentLocalizations'
        ]))),
        include: z.optional(z.array(z.enum([
            'app',
            'latestControlVersion',
            'controlVersions',
            'appStoreVersionExperimentTreatments'
        ]))),
        'limit[appStoreVersionExperimentTreatments]': z.optional(z.int().lte(50)),
        'limit[controlVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppStoreVersionExperiment
 */
export const zAppStoreVersionExperimentsV2GetInstanceResponse = zAppStoreVersionExperimentV2Response;

export const zAppStoreVersionExperimentsV2UpdateInstanceData = z.object({
    body: zAppStoreVersionExperimentV2UpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionExperiment
 */
export const zAppStoreVersionExperimentsV2UpdateInstanceResponse = zAppStoreVersionExperimentV2Response;

export const zAppStoreVersionExperimentsCreateInstanceData = z.object({
    body: zAppStoreVersionExperimentCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionExperiment
 */
export const zAppStoreVersionExperimentsCreateInstanceResponse = zAppStoreVersionExperimentResponse;

export const zAppStoreVersionExperimentsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreVersionExperimentsDeleteInstanceResponse = z.void();

export const zAppStoreVersionExperimentsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'appStoreVersion',
            'appStoreVersionExperimentTreatments'
        ]))),
        'fields[appStoreVersionExperimentTreatments]': z.optional(z.array(z.enum([
            'name',
            'appIcon',
            'appIconName',
            'promotedDate',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appStoreVersionExperimentTreatmentLocalizations'
        ]))),
        include: z.optional(z.array(z.enum(['appStoreVersion', 'appStoreVersionExperimentTreatments']))),
        'limit[appStoreVersionExperimentTreatments]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppStoreVersionExperiment
 */
export const zAppStoreVersionExperimentsGetInstanceResponse = zAppStoreVersionExperimentResponse;

export const zAppStoreVersionExperimentsUpdateInstanceData = z.object({
    body: zAppStoreVersionExperimentUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionExperiment
 */
export const zAppStoreVersionExperimentsUpdateInstanceResponse = zAppStoreVersionExperimentResponse;

export const zAppStoreVersionLocalizationsCreateInstanceData = z.object({
    body: zAppStoreVersionLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionLocalization
 */
export const zAppStoreVersionLocalizationsCreateInstanceResponse = zAppStoreVersionLocalizationResponse;

export const zAppStoreVersionLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreVersionLocalizationsDeleteInstanceResponse = z.void();

export const zAppStoreVersionLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appScreenshotSets]': z.optional(z.array(z.enum([
            'screenshotDisplayType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'fields[appPreviewSets]': z.optional(z.array(z.enum([
            'previewType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        include: z.optional(z.array(z.enum([
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'limit[appPreviewSets]': z.optional(z.int().lte(50)),
        'limit[appScreenshotSets]': z.optional(z.int().lte(50)),
        'limit[searchKeywords]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppStoreVersionLocalization
 */
export const zAppStoreVersionLocalizationsGetInstanceResponse = zAppStoreVersionLocalizationResponse;

export const zAppStoreVersionLocalizationsUpdateInstanceData = z.object({
    body: zAppStoreVersionLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionLocalization
 */
export const zAppStoreVersionLocalizationsUpdateInstanceResponse = zAppStoreVersionLocalizationResponse;

export const zAppStoreVersionPhasedReleasesCreateInstanceData = z.object({
    body: zAppStoreVersionPhasedReleaseCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionPhasedRelease
 */
export const zAppStoreVersionPhasedReleasesCreateInstanceResponse = zAppStoreVersionPhasedReleaseResponse;

export const zAppStoreVersionPhasedReleasesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreVersionPhasedReleasesDeleteInstanceResponse = z.void();

export const zAppStoreVersionPhasedReleasesUpdateInstanceData = z.object({
    body: zAppStoreVersionPhasedReleaseUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionPhasedRelease
 */
export const zAppStoreVersionPhasedReleasesUpdateInstanceResponse = zAppStoreVersionPhasedReleaseResponse;

export const zAppStoreVersionPromotionsCreateInstanceData = z.object({
    body: zAppStoreVersionPromotionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionPromotion
 */
export const zAppStoreVersionPromotionsCreateInstanceResponse = zAppStoreVersionPromotionResponse;

export const zAppStoreVersionReleaseRequestsCreateInstanceData = z.object({
    body: zAppStoreVersionReleaseRequestCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersionReleaseRequest
 */
export const zAppStoreVersionReleaseRequestsCreateInstanceResponse = zAppStoreVersionReleaseRequestResponse;

export const zAppStoreVersionSubmissionsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreVersionSubmissionsDeleteInstanceResponse = z.void();

export const zAppStoreVersionsCreateInstanceData = z.object({
    body: zAppStoreVersionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersion
 */
export const zAppStoreVersionsCreateInstanceResponse = zAppStoreVersionResponse;

export const zAppStoreVersionsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreVersionsDeleteInstanceResponse = z.void();

export const zAppStoreVersionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[ageRatingDeclarations]': z.optional(z.array(z.enum([
            'advertising',
            'alcoholTobaccoOrDrugUseOrReferences',
            'contests',
            'gambling',
            'gamblingSimulated',
            'gunsOrOtherWeapons',
            'healthOrWellnessTopics',
            'kidsAgeBand',
            'lootBox',
            'medicalOrTreatmentInformation',
            'messagingAndChat',
            'parentalControls',
            'profanityOrCrudeHumor',
            'ageAssurance',
            'sexualContentGraphicAndNudity',
            'sexualContentOrNudity',
            'horrorOrFearThemes',
            'matureOrSuggestiveThemes',
            'unrestrictedWebAccess',
            'userGeneratedContent',
            'violenceCartoonOrFantasy',
            'violenceRealisticProlongedGraphicOrSadistic',
            'violenceRealistic',
            'ageRatingOverride',
            'ageRatingOverrideV2',
            'koreaAgeRatingOverride',
            'developerAgeRatingInfoUrl'
        ]))),
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[appStoreVersionPhasedReleases]': z.optional(z.array(z.enum([
            'phasedReleaseState',
            'startDate',
            'totalPauseDuration',
            'currentDayNumber'
        ]))),
        'fields[gameCenterAppVersions]': z.optional(z.array(z.enum([
            'enabled',
            'compatibilityVersions',
            'appStoreVersion'
        ]))),
        'fields[routingAppCoverages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState',
            'appStoreVersion'
        ]))),
        'fields[appStoreReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'appStoreVersion',
            'appStoreReviewAttachments'
        ]))),
        'fields[appStoreVersionSubmissions]': z.optional(z.array(z.enum(['appStoreVersion']))),
        'fields[appClipDefaultExperiences]': z.optional(z.array(z.enum([
            'action',
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'appStoreVersion',
            'appStoreVersionExperimentTreatments',
            'platform',
            'app',
            'latestControlVersion',
            'controlVersions'
        ]))),
        'fields[alternativeDistributionPackages]': z.optional(z.array(z.enum(['sourceFileChecksum', 'versions']))),
        include: z.optional(z.array(z.enum([
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionPackage'
        ]))),
        'limit[appStoreVersionExperiments]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperimentsV2]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppStoreVersion
 */
export const zAppStoreVersionsGetInstanceResponse = zAppStoreVersionResponse;

export const zAppStoreVersionsUpdateInstanceData = z.object({
    body: zAppStoreVersionUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppStoreVersion
 */
export const zAppStoreVersionsUpdateInstanceResponse = zAppStoreVersionResponse;

export const zAppTagsUpdateInstanceData = z.object({
    body: zAppTagUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single AppTag
 */
export const zAppTagsUpdateInstanceResponse = zAppTagResponse;

export const zAppsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[name]': z.optional(z.array(z.string())),
        'filter[bundleId]': z.optional(z.array(z.string())),
        'filter[sku]': z.optional(z.array(z.string())),
        'filter[appStoreVersions.appStoreState]': z.optional(z.array(z.enum([
            'ACCEPTED',
            'DEVELOPER_REMOVED_FROM_SALE',
            'DEVELOPER_REJECTED',
            'IN_REVIEW',
            'INVALID_BINARY',
            'METADATA_REJECTED',
            'PENDING_APPLE_RELEASE',
            'PENDING_CONTRACT',
            'PENDING_DEVELOPER_RELEASE',
            'PREPARE_FOR_SUBMISSION',
            'PREORDER_READY_FOR_SALE',
            'PROCESSING_FOR_APP_STORE',
            'READY_FOR_REVIEW',
            'READY_FOR_SALE',
            'REJECTED',
            'REMOVED_FROM_SALE',
            'WAITING_FOR_EXPORT_COMPLIANCE',
            'WAITING_FOR_REVIEW',
            'REPLACED_WITH_NEW_VERSION',
            'NOT_APPLICABLE'
        ]))),
        'filter[appStoreVersions.platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[appStoreVersions.appVersionState]': z.optional(z.array(z.enum([
            'ACCEPTED',
            'DEVELOPER_REJECTED',
            'IN_REVIEW',
            'INVALID_BINARY',
            'METADATA_REJECTED',
            'PENDING_APPLE_RELEASE',
            'PENDING_DEVELOPER_RELEASE',
            'PREPARE_FOR_SUBMISSION',
            'PROCESSING_FOR_DISTRIBUTION',
            'READY_FOR_DISTRIBUTION',
            'READY_FOR_REVIEW',
            'REJECTED',
            'REPLACED_WITH_NEW_VERSION',
            'WAITING_FOR_EXPORT_COMPLIANCE',
            'WAITING_FOR_REVIEW'
        ]))),
        'filter[reviewSubmissions.state]': z.optional(z.array(z.enum([
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'UNRESOLVED_ISSUES',
            'CANCELING',
            'COMPLETING',
            'COMPLETE'
        ]))),
        'filter[reviewSubmissions.platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[appStoreVersions]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'exists[gameCenterEnabledVersions]': z.optional(z.boolean()),
        sort: z.optional(z.array(z.enum([
            'name',
            '-name',
            'bundleId',
            '-bundleId',
            'sku',
            '-sku'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[appEncryptionDeclarations]': z.optional(z.array(z.enum([
            'appDescription',
            'createdDate',
            'usesEncryption',
            'exempt',
            'containsProprietaryCryptography',
            'containsThirdPartyCryptography',
            'availableOnFrenchStore',
            'platform',
            'uploadedDate',
            'documentUrl',
            'documentName',
            'documentType',
            'appEncryptionDeclarationState',
            'codeValue',
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'fields[ciProducts]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'productType',
            'app',
            'bundleId',
            'workflows',
            'primaryRepositories',
            'additionalRepositories',
            'buildRuns'
        ]))),
        'fields[betaGroups]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'isInternalGroup',
            'hasAccessToAllBuilds',
            'publicLinkEnabled',
            'publicLinkId',
            'publicLinkLimitEnabled',
            'publicLinkLimit',
            'publicLink',
            'feedbackEnabled',
            'iosBuildsAvailableForAppleSiliconMac',
            'iosBuildsAvailableForAppleVision',
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria',
            'betaRecruitmentCriterionCompatibleBuildCheck'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[preReleaseVersions]': z.optional(z.array(z.enum([
            'version',
            'platform',
            'builds',
            'app'
        ]))),
        'fields[betaAppLocalizations]': z.optional(z.array(z.enum([
            'feedbackEmail',
            'marketingUrl',
            'privacyPolicyUrl',
            'tvOsPrivacyPolicy',
            'description',
            'locale',
            'app'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[betaLicenseAgreements]': z.optional(z.array(z.enum(['agreementText', 'app']))),
        'fields[betaAppReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'app'
        ]))),
        'fields[appInfos]': z.optional(z.array(z.enum([
            'appStoreState',
            'state',
            'appStoreAgeRating',
            'australiaAgeRating',
            'brazilAgeRating',
            'brazilAgeRatingV2',
            'franceAgeRating',
            'koreaAgeRating',
            'kidsAgeBand',
            'app',
            'ageRatingDeclaration',
            'appInfoLocalizations',
            'primaryCategory',
            'primarySubcategoryOne',
            'primarySubcategoryTwo',
            'secondaryCategory',
            'secondarySubcategoryOne',
            'secondarySubcategoryTwo',
            'territoryAgeRatings'
        ]))),
        'fields[appClips]': z.optional(z.array(z.enum([
            'bundleId',
            'app',
            'appClipDefaultExperiences',
            'appClipAdvancedExperiences'
        ]))),
        'fields[endUserLicenseAgreements]': z.optional(z.array(z.enum([
            'agreementText',
            'app',
            'territories'
        ]))),
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'referenceName',
            'productId',
            'inAppPurchaseType',
            'state',
            'apps',
            'name',
            'reviewNote',
            'familySharable',
            'contentHosting',
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        'fields[subscriptionGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'subscriptions',
            'subscriptionGroupLocalizations'
        ]))),
        'fields[gameCenterEnabledVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'iconAsset',
            'compatibleVersions',
            'app'
        ]))),
        'fields[appCustomProductPages]': z.optional(z.array(z.enum([
            'name',
            'url',
            'visible',
            'app',
            'appCustomProductPageVersions'
        ]))),
        'fields[promotedPurchases]': z.optional(z.array(z.enum([
            'visibleForAllUsers',
            'enabled',
            'state',
            'inAppPurchaseV2',
            'subscription'
        ]))),
        'fields[appEvents]': z.optional(z.array(z.enum([
            'referenceName',
            'badge',
            'eventState',
            'deepLink',
            'purchaseRequirement',
            'primaryLocale',
            'priority',
            'purpose',
            'territorySchedules',
            'archivedTerritorySchedules',
            'localizations'
        ]))),
        'fields[reviewSubmissions]': z.optional(z.array(z.enum([
            'platform',
            'submittedDate',
            'state',
            'app',
            'items',
            'appStoreVersionForReview',
            'submittedByActor',
            'lastUpdatedByActor'
        ]))),
        'fields[subscriptionGracePeriods]': z.optional(z.array(z.enum([
            'optIn',
            'sandboxOptIn',
            'duration',
            'renewalType'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'app',
            'latestControlVersion',
            'controlVersions',
            'appStoreVersionExperimentTreatments'
        ]))),
        'fields[androidToIosAppMappingDetails]': z.optional(z.array(z.enum(['packageName', 'appSigningKeyPublicCertificateSha256Fingerprints']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaGroups',
            'appStoreVersions',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'endUserLicenseAgreement',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'androidToIosAppMappingDetails'
        ]))),
        'limit[androidToIosAppMappingDetails]': z.optional(z.int().lte(50)),
        'limit[appClips]': z.optional(z.int().lte(50)),
        'limit[appCustomProductPages]': z.optional(z.int().lte(50)),
        'limit[appEncryptionDeclarations]': z.optional(z.int().lte(50)),
        'limit[appEvents]': z.optional(z.int().lte(50)),
        'limit[appInfos]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperimentsV2]': z.optional(z.int().lte(50)),
        'limit[appStoreVersions]': z.optional(z.int().lte(50)),
        'limit[betaAppLocalizations]': z.optional(z.int().lte(50)),
        'limit[betaGroups]': z.optional(z.int().lte(50)),
        'limit[builds]': z.optional(z.int().lte(50)),
        'limit[gameCenterEnabledVersions]': z.optional(z.int().lte(50)),
        'limit[inAppPurchases]': z.optional(z.int().lte(50)),
        'limit[inAppPurchasesV2]': z.optional(z.int().lte(50)),
        'limit[preReleaseVersions]': z.optional(z.int().lte(50)),
        'limit[promotedPurchases]': z.optional(z.int().lte(50)),
        'limit[reviewSubmissions]': z.optional(z.int().lte(50)),
        'limit[subscriptionGroups]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of Apps
 */
export const zAppsGetCollectionResponse = zAppsResponse;

export const zAppsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[appEncryptionDeclarations]': z.optional(z.array(z.enum([
            'appDescription',
            'createdDate',
            'usesEncryption',
            'exempt',
            'containsProprietaryCryptography',
            'containsThirdPartyCryptography',
            'availableOnFrenchStore',
            'platform',
            'uploadedDate',
            'documentUrl',
            'documentName',
            'documentType',
            'appEncryptionDeclarationState',
            'codeValue',
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'fields[ciProducts]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'productType',
            'app',
            'bundleId',
            'workflows',
            'primaryRepositories',
            'additionalRepositories',
            'buildRuns'
        ]))),
        'fields[betaGroups]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'isInternalGroup',
            'hasAccessToAllBuilds',
            'publicLinkEnabled',
            'publicLinkId',
            'publicLinkLimitEnabled',
            'publicLinkLimit',
            'publicLink',
            'feedbackEnabled',
            'iosBuildsAvailableForAppleSiliconMac',
            'iosBuildsAvailableForAppleVision',
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria',
            'betaRecruitmentCriterionCompatibleBuildCheck'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[preReleaseVersions]': z.optional(z.array(z.enum([
            'version',
            'platform',
            'builds',
            'app'
        ]))),
        'fields[betaAppLocalizations]': z.optional(z.array(z.enum([
            'feedbackEmail',
            'marketingUrl',
            'privacyPolicyUrl',
            'tvOsPrivacyPolicy',
            'description',
            'locale',
            'app'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[betaLicenseAgreements]': z.optional(z.array(z.enum(['agreementText', 'app']))),
        'fields[betaAppReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'app'
        ]))),
        'fields[appInfos]': z.optional(z.array(z.enum([
            'appStoreState',
            'state',
            'appStoreAgeRating',
            'australiaAgeRating',
            'brazilAgeRating',
            'brazilAgeRatingV2',
            'franceAgeRating',
            'koreaAgeRating',
            'kidsAgeBand',
            'app',
            'ageRatingDeclaration',
            'appInfoLocalizations',
            'primaryCategory',
            'primarySubcategoryOne',
            'primarySubcategoryTwo',
            'secondaryCategory',
            'secondarySubcategoryOne',
            'secondarySubcategoryTwo',
            'territoryAgeRatings'
        ]))),
        'fields[appClips]': z.optional(z.array(z.enum([
            'bundleId',
            'app',
            'appClipDefaultExperiences',
            'appClipAdvancedExperiences'
        ]))),
        'fields[endUserLicenseAgreements]': z.optional(z.array(z.enum([
            'agreementText',
            'app',
            'territories'
        ]))),
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'referenceName',
            'productId',
            'inAppPurchaseType',
            'state',
            'apps',
            'name',
            'reviewNote',
            'familySharable',
            'contentHosting',
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        'fields[subscriptionGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'subscriptions',
            'subscriptionGroupLocalizations'
        ]))),
        'fields[gameCenterEnabledVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'iconAsset',
            'compatibleVersions',
            'app'
        ]))),
        'fields[appCustomProductPages]': z.optional(z.array(z.enum([
            'name',
            'url',
            'visible',
            'app',
            'appCustomProductPageVersions'
        ]))),
        'fields[promotedPurchases]': z.optional(z.array(z.enum([
            'visibleForAllUsers',
            'enabled',
            'state',
            'inAppPurchaseV2',
            'subscription'
        ]))),
        'fields[appEvents]': z.optional(z.array(z.enum([
            'referenceName',
            'badge',
            'eventState',
            'deepLink',
            'purchaseRequirement',
            'primaryLocale',
            'priority',
            'purpose',
            'territorySchedules',
            'archivedTerritorySchedules',
            'localizations'
        ]))),
        'fields[reviewSubmissions]': z.optional(z.array(z.enum([
            'platform',
            'submittedDate',
            'state',
            'app',
            'items',
            'appStoreVersionForReview',
            'submittedByActor',
            'lastUpdatedByActor'
        ]))),
        'fields[subscriptionGracePeriods]': z.optional(z.array(z.enum([
            'optIn',
            'sandboxOptIn',
            'duration',
            'renewalType'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'app',
            'latestControlVersion',
            'controlVersions',
            'appStoreVersionExperimentTreatments'
        ]))),
        'fields[androidToIosAppMappingDetails]': z.optional(z.array(z.enum(['packageName', 'appSigningKeyPublicCertificateSha256Fingerprints']))),
        include: z.optional(z.array(z.enum([
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaGroups',
            'appStoreVersions',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'endUserLicenseAgreement',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'androidToIosAppMappingDetails'
        ]))),
        'limit[androidToIosAppMappingDetails]': z.optional(z.int().lte(50)),
        'limit[appClips]': z.optional(z.int().lte(50)),
        'limit[appCustomProductPages]': z.optional(z.int().lte(50)),
        'limit[appEncryptionDeclarations]': z.optional(z.int().lte(50)),
        'limit[appEvents]': z.optional(z.int().lte(50)),
        'limit[appInfos]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperimentsV2]': z.optional(z.int().lte(50)),
        'limit[appStoreVersions]': z.optional(z.int().lte(50)),
        'limit[betaAppLocalizations]': z.optional(z.int().lte(50)),
        'limit[betaGroups]': z.optional(z.int().lte(50)),
        'limit[builds]': z.optional(z.int().lte(50)),
        'limit[gameCenterEnabledVersions]': z.optional(z.int().lte(50)),
        'limit[inAppPurchases]': z.optional(z.int().lte(50)),
        'limit[inAppPurchasesV2]': z.optional(z.int().lte(50)),
        'limit[preReleaseVersions]': z.optional(z.int().lte(50)),
        'limit[promotedPurchases]': z.optional(z.int().lte(50)),
        'limit[reviewSubmissions]': z.optional(z.int().lte(50)),
        'limit[subscriptionGroups]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single App
 */
export const zAppsGetInstanceResponse = zAppResponse;

export const zAppsUpdateInstanceData = z.object({
    body: zAppUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single App
 */
export const zAppsUpdateInstanceResponse = zAppResponse;

export const zBackgroundAssetUploadFilesCreateInstanceData = z.object({
    body: zBackgroundAssetUploadFileCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BackgroundAssetUploadFile
 */
export const zBackgroundAssetUploadFilesCreateInstanceResponse = zBackgroundAssetUploadFileResponse;

export const zBackgroundAssetUploadFilesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[backgroundAssetUploadFiles]': z.optional(z.array(z.enum([
            'assetDeliveryState',
            'assetToken',
            'assetType',
            'fileName',
            'fileSize',
            'sourceFileChecksum',
            'sourceFileChecksums',
            'uploadOperations'
        ])))
    }))
});

/**
 * Single BackgroundAssetUploadFile
 */
export const zBackgroundAssetUploadFilesGetInstanceResponse = zBackgroundAssetUploadFileResponse;

export const zBackgroundAssetUploadFilesUpdateInstanceData = z.object({
    body: zBackgroundAssetUploadFileUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BackgroundAssetUploadFile
 */
export const zBackgroundAssetUploadFilesUpdateInstanceResponse = zBackgroundAssetUploadFileResponse;

export const zBackgroundAssetVersionAppStoreReleasesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[backgroundAssetVersionAppStoreReleases]': z.optional(z.array(z.enum(['state', 'backgroundAssetVersion']))),
        include: z.optional(z.array(z.enum(['backgroundAssetVersion'])))
    }))
});

/**
 * Single BackgroundAssetVersionAppStoreRelease
 */
export const zBackgroundAssetVersionAppStoreReleasesGetInstanceResponse = zBackgroundAssetVersionAppStoreReleaseResponse;

export const zBackgroundAssetVersionExternalBetaReleasesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[backgroundAssetVersionExternalBetaReleases]': z.optional(z.array(z.enum(['state', 'backgroundAssetVersion']))),
        include: z.optional(z.array(z.enum(['backgroundAssetVersion'])))
    }))
});

/**
 * Single BackgroundAssetVersionExternalBetaRelease
 */
export const zBackgroundAssetVersionExternalBetaReleasesGetInstanceResponse = zBackgroundAssetVersionExternalBetaReleaseResponse;

export const zBackgroundAssetVersionInternalBetaReleasesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[backgroundAssetVersionInternalBetaReleases]': z.optional(z.array(z.enum(['state', 'backgroundAssetVersion']))),
        include: z.optional(z.array(z.enum(['backgroundAssetVersion'])))
    }))
});

/**
 * Single BackgroundAssetVersionInternalBetaRelease
 */
export const zBackgroundAssetVersionInternalBetaReleasesGetInstanceResponse = zBackgroundAssetVersionInternalBetaReleaseResponse;

export const zBackgroundAssetVersionsCreateInstanceData = z.object({
    body: zBackgroundAssetVersionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BackgroundAssetVersion
 */
export const zBackgroundAssetVersionsCreateInstanceResponse = zBackgroundAssetVersionResponse;

export const zBackgroundAssetVersionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[backgroundAssetVersions]': z.optional(z.array(z.enum([
            'createdDate',
            'platforms',
            'state',
            'stateDetails',
            'version',
            'backgroundAsset',
            'internalBetaRelease',
            'externalBetaRelease',
            'appStoreRelease',
            'assetFile',
            'manifestFile',
            'backgroundAssetUploadFiles'
        ]))),
        include: z.optional(z.array(z.enum([
            'backgroundAsset',
            'internalBetaRelease',
            'externalBetaRelease',
            'appStoreRelease',
            'assetFile',
            'manifestFile'
        ])))
    }))
});

/**
 * Single BackgroundAssetVersion
 */
export const zBackgroundAssetVersionsGetInstanceResponse = zBackgroundAssetVersionResponse;

export const zBackgroundAssetsCreateInstanceData = z.object({
    body: zBackgroundAssetCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BackgroundAsset
 */
export const zBackgroundAssetsCreateInstanceResponse = zBackgroundAssetResponse;

export const zBackgroundAssetsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[backgroundAssets]': z.optional(z.array(z.enum([
            'archived',
            'assetPackIdentifier',
            'createdDate',
            'app',
            'versions',
            'appStoreVersion',
            'internalBetaVersion',
            'externalBetaVersion'
        ]))),
        include: z.optional(z.array(z.enum([
            'app',
            'appStoreVersion',
            'internalBetaVersion',
            'externalBetaVersion'
        ])))
    }))
});

/**
 * Single BackgroundAsset
 */
export const zBackgroundAssetsGetInstanceResponse = zBackgroundAssetResponse;

export const zBackgroundAssetsUpdateInstanceData = z.object({
    body: zBackgroundAssetUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BackgroundAsset
 */
export const zBackgroundAssetsUpdateInstanceResponse = zBackgroundAssetResponse;

export const zBetaAppClipInvocationLocalizationsCreateInstanceData = z.object({
    body: zBetaAppClipInvocationLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BetaAppClipInvocationLocalization
 */
export const zBetaAppClipInvocationLocalizationsCreateInstanceResponse = zBetaAppClipInvocationLocalizationResponse;

export const zBetaAppClipInvocationLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaAppClipInvocationLocalizationsDeleteInstanceResponse = z.void();

export const zBetaAppClipInvocationLocalizationsUpdateInstanceData = z.object({
    body: zBetaAppClipInvocationLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BetaAppClipInvocationLocalization
 */
export const zBetaAppClipInvocationLocalizationsUpdateInstanceResponse = zBetaAppClipInvocationLocalizationResponse;

export const zBetaAppClipInvocationsCreateInstanceData = z.object({
    body: zBetaAppClipInvocationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BetaAppClipInvocation
 */
export const zBetaAppClipInvocationsCreateInstanceResponse = zBetaAppClipInvocationResponse;

export const zBetaAppClipInvocationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaAppClipInvocationsDeleteInstanceResponse = z.void();

export const zBetaAppClipInvocationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaAppClipInvocations]': z.optional(z.array(z.enum(['url', 'betaAppClipInvocationLocalizations']))),
        include: z.optional(z.array(z.enum(['betaAppClipInvocationLocalizations']))),
        'limit[betaAppClipInvocationLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single BetaAppClipInvocation
 */
export const zBetaAppClipInvocationsGetInstanceResponse = zBetaAppClipInvocationResponse;

export const zBetaAppClipInvocationsUpdateInstanceData = z.object({
    body: zBetaAppClipInvocationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BetaAppClipInvocation
 */
export const zBetaAppClipInvocationsUpdateInstanceResponse = zBetaAppClipInvocationResponse;

export const zBetaAppLocalizationsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[locale]': z.optional(z.array(z.string())),
        'filter[app]': z.optional(z.array(z.string())),
        'fields[betaAppLocalizations]': z.optional(z.array(z.enum([
            'feedbackEmail',
            'marketingUrl',
            'privacyPolicyUrl',
            'tvOsPrivacyPolicy',
            'description',
            'locale',
            'app'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['app'])))
    }))
});

/**
 * List of BetaAppLocalizations
 */
export const zBetaAppLocalizationsGetCollectionResponse = zBetaAppLocalizationsResponse;

export const zBetaAppLocalizationsCreateInstanceData = z.object({
    body: zBetaAppLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BetaAppLocalization
 */
export const zBetaAppLocalizationsCreateInstanceResponse = zBetaAppLocalizationResponse;

export const zBetaAppLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaAppLocalizationsDeleteInstanceResponse = z.void();

export const zBetaAppLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaAppLocalizations]': z.optional(z.array(z.enum([
            'feedbackEmail',
            'marketingUrl',
            'privacyPolicyUrl',
            'tvOsPrivacyPolicy',
            'description',
            'locale',
            'app'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        include: z.optional(z.array(z.enum(['app'])))
    }))
});

/**
 * Single BetaAppLocalization
 */
export const zBetaAppLocalizationsGetInstanceResponse = zBetaAppLocalizationResponse;

export const zBetaAppLocalizationsUpdateInstanceData = z.object({
    body: zBetaAppLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BetaAppLocalization
 */
export const zBetaAppLocalizationsUpdateInstanceResponse = zBetaAppLocalizationResponse;

export const zBetaAppReviewDetailsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        'filter[app]': z.array(z.string()),
        'fields[betaAppReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'app'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['app'])))
    })
});

/**
 * List of BetaAppReviewDetails
 */
export const zBetaAppReviewDetailsGetCollectionResponse = zBetaAppReviewDetailsResponse;

export const zBetaAppReviewDetailsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaAppReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'app'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        include: z.optional(z.array(z.enum(['app'])))
    }))
});

/**
 * Single BetaAppReviewDetail
 */
export const zBetaAppReviewDetailsGetInstanceResponse = zBetaAppReviewDetailResponse;

export const zBetaAppReviewDetailsUpdateInstanceData = z.object({
    body: zBetaAppReviewDetailUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BetaAppReviewDetail
 */
export const zBetaAppReviewDetailsUpdateInstanceResponse = zBetaAppReviewDetailResponse;

export const zBetaAppReviewSubmissionsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        'filter[betaReviewState]': z.optional(z.array(z.enum([
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'REJECTED',
            'APPROVED'
        ]))),
        'filter[build]': z.array(z.string()),
        'fields[betaAppReviewSubmissions]': z.optional(z.array(z.enum([
            'betaReviewState',
            'submittedDate',
            'build'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['build'])))
    })
});

/**
 * List of BetaAppReviewSubmissions
 */
export const zBetaAppReviewSubmissionsGetCollectionResponse = zBetaAppReviewSubmissionsResponse;

export const zBetaAppReviewSubmissionsCreateInstanceData = z.object({
    body: zBetaAppReviewSubmissionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BetaAppReviewSubmission
 */
export const zBetaAppReviewSubmissionsCreateInstanceResponse = zBetaAppReviewSubmissionResponse;

export const zBetaAppReviewSubmissionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaAppReviewSubmissions]': z.optional(z.array(z.enum([
            'betaReviewState',
            'submittedDate',
            'build'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        include: z.optional(z.array(z.enum(['build'])))
    }))
});

/**
 * Single BetaAppReviewSubmission
 */
export const zBetaAppReviewSubmissionsGetInstanceResponse = zBetaAppReviewSubmissionResponse;

export const zBetaBuildLocalizationsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[locale]': z.optional(z.array(z.string())),
        'filter[build]': z.optional(z.array(z.string())),
        'fields[betaBuildLocalizations]': z.optional(z.array(z.enum([
            'whatsNew',
            'locale',
            'build'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['build'])))
    }))
});

/**
 * List of BetaBuildLocalizations
 */
export const zBetaBuildLocalizationsGetCollectionResponse = zBetaBuildLocalizationsResponse;

export const zBetaBuildLocalizationsCreateInstanceData = z.object({
    body: zBetaBuildLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BetaBuildLocalization
 */
export const zBetaBuildLocalizationsCreateInstanceResponse = zBetaBuildLocalizationResponse;

export const zBetaBuildLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaBuildLocalizationsDeleteInstanceResponse = z.void();

export const zBetaBuildLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaBuildLocalizations]': z.optional(z.array(z.enum([
            'whatsNew',
            'locale',
            'build'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        include: z.optional(z.array(z.enum(['build'])))
    }))
});

/**
 * Single BetaBuildLocalization
 */
export const zBetaBuildLocalizationsGetInstanceResponse = zBetaBuildLocalizationResponse;

export const zBetaBuildLocalizationsUpdateInstanceData = z.object({
    body: zBetaBuildLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BetaBuildLocalization
 */
export const zBetaBuildLocalizationsUpdateInstanceResponse = zBetaBuildLocalizationResponse;

export const zBetaCrashLogsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaCrashLogs]': z.optional(z.array(z.enum(['logText'])))
    }))
});

/**
 * Single BetaCrashLog
 */
export const zBetaCrashLogsGetInstanceResponse = zBetaCrashLogResponse;

export const zBetaFeedbackCrashSubmissionsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaFeedbackCrashSubmissionsDeleteInstanceResponse = z.void();

export const zBetaFeedbackCrashSubmissionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaFeedbackCrashSubmissions]': z.optional(z.array(z.enum([
            'createdDate',
            'comment',
            'email',
            'deviceModel',
            'osVersion',
            'locale',
            'timeZone',
            'architecture',
            'connectionType',
            'pairedAppleWatch',
            'appUptimeInMilliseconds',
            'diskBytesAvailable',
            'diskBytesTotal',
            'batteryPercentage',
            'screenWidthInPoints',
            'screenHeightInPoints',
            'appPlatform',
            'devicePlatform',
            'deviceFamily',
            'buildBundleId',
            'crashLog',
            'build',
            'tester'
        ]))),
        include: z.optional(z.array(z.enum(['build', 'tester'])))
    }))
});

/**
 * Single BetaFeedbackCrashSubmission
 */
export const zBetaFeedbackCrashSubmissionsGetInstanceResponse = zBetaFeedbackCrashSubmissionResponse;

export const zBetaFeedbackScreenshotSubmissionsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaFeedbackScreenshotSubmissionsDeleteInstanceResponse = z.void();

export const zBetaFeedbackScreenshotSubmissionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaFeedbackScreenshotSubmissions]': z.optional(z.array(z.enum([
            'createdDate',
            'comment',
            'email',
            'deviceModel',
            'osVersion',
            'locale',
            'timeZone',
            'architecture',
            'connectionType',
            'pairedAppleWatch',
            'appUptimeInMilliseconds',
            'diskBytesAvailable',
            'diskBytesTotal',
            'batteryPercentage',
            'screenWidthInPoints',
            'screenHeightInPoints',
            'appPlatform',
            'devicePlatform',
            'deviceFamily',
            'buildBundleId',
            'screenshots',
            'build',
            'tester'
        ]))),
        include: z.optional(z.array(z.enum(['build', 'tester'])))
    }))
});

/**
 * Single BetaFeedbackScreenshotSubmission
 */
export const zBetaFeedbackScreenshotSubmissionsGetInstanceResponse = zBetaFeedbackScreenshotSubmissionResponse;

export const zBetaGroupsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[name]': z.optional(z.array(z.string())),
        'filter[isInternalGroup]': z.optional(z.array(z.string())),
        'filter[publicLinkEnabled]': z.optional(z.array(z.string())),
        'filter[publicLinkLimitEnabled]': z.optional(z.array(z.string())),
        'filter[publicLink]': z.optional(z.array(z.string())),
        'filter[app]': z.optional(z.array(z.string())),
        'filter[builds]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'name',
            '-name',
            'createdDate',
            '-createdDate',
            'publicLinkEnabled',
            '-publicLinkEnabled',
            'publicLinkLimit',
            '-publicLinkLimit'
        ]))),
        'fields[betaGroups]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'isInternalGroup',
            'hasAccessToAllBuilds',
            'publicLinkEnabled',
            'publicLinkId',
            'publicLinkLimitEnabled',
            'publicLinkLimit',
            'publicLink',
            'feedbackEnabled',
            'iosBuildsAvailableForAppleSiliconMac',
            'iosBuildsAvailableForAppleVision',
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria',
            'betaRecruitmentCriterionCompatibleBuildCheck'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[betaTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'email',
            'inviteType',
            'state',
            'appDevices',
            'apps',
            'betaGroups',
            'builds'
        ]))),
        'fields[betaRecruitmentCriteria]': z.optional(z.array(z.enum(['lastModifiedDate', 'deviceFamilyOsVersionFilters']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria'
        ]))),
        'limit[betaTesters]': z.optional(z.int().lte(50)),
        'limit[builds]': z.optional(z.int().lte(1000))
    }))
});

/**
 * List of BetaGroups
 */
export const zBetaGroupsGetCollectionResponse = zBetaGroupsResponse;

export const zBetaGroupsCreateInstanceData = z.object({
    body: zBetaGroupCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BetaGroup
 */
export const zBetaGroupsCreateInstanceResponse = zBetaGroupResponse;

export const zBetaGroupsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaGroupsDeleteInstanceResponse = z.void();

export const zBetaGroupsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaGroups]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'isInternalGroup',
            'hasAccessToAllBuilds',
            'publicLinkEnabled',
            'publicLinkId',
            'publicLinkLimitEnabled',
            'publicLinkLimit',
            'publicLink',
            'feedbackEnabled',
            'iosBuildsAvailableForAppleSiliconMac',
            'iosBuildsAvailableForAppleVision',
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria',
            'betaRecruitmentCriterionCompatibleBuildCheck'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[betaTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'email',
            'inviteType',
            'state',
            'appDevices',
            'apps',
            'betaGroups',
            'builds'
        ]))),
        'fields[betaRecruitmentCriteria]': z.optional(z.array(z.enum(['lastModifiedDate', 'deviceFamilyOsVersionFilters']))),
        include: z.optional(z.array(z.enum([
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria'
        ]))),
        'limit[betaTesters]': z.optional(z.int().lte(50)),
        'limit[builds]': z.optional(z.int().lte(1000))
    }))
});

/**
 * Single BetaGroup
 */
export const zBetaGroupsGetInstanceResponse = zBetaGroupResponse;

export const zBetaGroupsUpdateInstanceData = z.object({
    body: zBetaGroupUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BetaGroup
 */
export const zBetaGroupsUpdateInstanceResponse = zBetaGroupResponse;

export const zBetaLicenseAgreementsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[app]': z.optional(z.array(z.string())),
        'fields[betaLicenseAgreements]': z.optional(z.array(z.enum(['agreementText', 'app']))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['app'])))
    }))
});

/**
 * List of BetaLicenseAgreements
 */
export const zBetaLicenseAgreementsGetCollectionResponse = zBetaLicenseAgreementsResponse;

export const zBetaLicenseAgreementsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaLicenseAgreements]': z.optional(z.array(z.enum(['agreementText', 'app']))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        include: z.optional(z.array(z.enum(['app'])))
    }))
});

/**
 * Single BetaLicenseAgreement
 */
export const zBetaLicenseAgreementsGetInstanceResponse = zBetaLicenseAgreementResponse;

export const zBetaLicenseAgreementsUpdateInstanceData = z.object({
    body: zBetaLicenseAgreementUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BetaLicenseAgreement
 */
export const zBetaLicenseAgreementsUpdateInstanceResponse = zBetaLicenseAgreementResponse;

export const zBetaRecruitmentCriteriaCreateInstanceData = z.object({
    body: zBetaRecruitmentCriterionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BetaRecruitmentCriterion
 */
export const zBetaRecruitmentCriteriaCreateInstanceResponse = zBetaRecruitmentCriterionResponse;

export const zBetaRecruitmentCriteriaDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaRecruitmentCriteriaDeleteInstanceResponse = z.void();

export const zBetaRecruitmentCriteriaUpdateInstanceData = z.object({
    body: zBetaRecruitmentCriterionUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BetaRecruitmentCriterion
 */
export const zBetaRecruitmentCriteriaUpdateInstanceResponse = zBetaRecruitmentCriterionResponse;

export const zBetaRecruitmentCriterionOptionsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'fields[betaRecruitmentCriterionOptions]': z.optional(z.array(z.enum(['deviceFamilyOsVersions']))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of BetaRecruitmentCriterionOptions
 */
export const zBetaRecruitmentCriterionOptionsGetCollectionResponse = zBetaRecruitmentCriterionOptionsResponse;

export const zBetaTesterInvitationsCreateInstanceData = z.object({
    body: zBetaTesterInvitationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BetaTesterInvitation
 */
export const zBetaTesterInvitationsCreateInstanceResponse = zBetaTesterInvitationResponse;

export const zBetaTestersGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[firstName]': z.optional(z.array(z.string())),
        'filter[lastName]': z.optional(z.array(z.string())),
        'filter[email]': z.optional(z.array(z.string())),
        'filter[inviteType]': z.optional(z.array(z.enum(['EMAIL', 'PUBLIC_LINK']))),
        'filter[apps]': z.optional(z.array(z.string())),
        'filter[betaGroups]': z.optional(z.array(z.string())),
        'filter[builds]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'firstName',
            '-firstName',
            'lastName',
            '-lastName',
            'email',
            '-email',
            'inviteType',
            '-inviteType',
            'state',
            '-state'
        ]))),
        'fields[betaTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'email',
            'inviteType',
            'state',
            'appDevices',
            'apps',
            'betaGroups',
            'builds'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[betaGroups]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'isInternalGroup',
            'hasAccessToAllBuilds',
            'publicLinkEnabled',
            'publicLinkId',
            'publicLinkLimitEnabled',
            'publicLinkLimit',
            'publicLink',
            'feedbackEnabled',
            'iosBuildsAvailableForAppleSiliconMac',
            'iosBuildsAvailableForAppleVision',
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria',
            'betaRecruitmentCriterionCompatibleBuildCheck'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'apps',
            'betaGroups',
            'builds'
        ]))),
        'limit[apps]': z.optional(z.int().lte(50)),
        'limit[betaGroups]': z.optional(z.int().lte(50)),
        'limit[builds]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of BetaTesters
 */
export const zBetaTestersGetCollectionResponse = zBetaTestersResponse;

export const zBetaTestersCreateInstanceData = z.object({
    body: zBetaTesterCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BetaTester
 */
export const zBetaTestersCreateInstanceResponse = zBetaTesterResponse;

export const zBetaTestersDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

export const zBetaTestersDeleteInstanceResponse = z.union([
    z.unknown(),
    z.void()
]);

export const zBetaTestersGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'email',
            'inviteType',
            'state',
            'appDevices',
            'apps',
            'betaGroups',
            'builds'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[betaGroups]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'isInternalGroup',
            'hasAccessToAllBuilds',
            'publicLinkEnabled',
            'publicLinkId',
            'publicLinkLimitEnabled',
            'publicLinkLimit',
            'publicLink',
            'feedbackEnabled',
            'iosBuildsAvailableForAppleSiliconMac',
            'iosBuildsAvailableForAppleVision',
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria',
            'betaRecruitmentCriterionCompatibleBuildCheck'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        include: z.optional(z.array(z.enum([
            'apps',
            'betaGroups',
            'builds'
        ]))),
        'limit[apps]': z.optional(z.int().lte(50)),
        'limit[betaGroups]': z.optional(z.int().lte(50)),
        'limit[builds]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single BetaTester
 */
export const zBetaTestersGetInstanceResponse = zBetaTesterResponse;

export const zBuildBetaDetailsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[build]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[buildBetaDetails]': z.optional(z.array(z.enum([
            'autoNotifyEnabled',
            'internalBuildState',
            'externalBuildState',
            'build'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['build'])))
    }))
});

/**
 * List of BuildBetaDetails
 */
export const zBuildBetaDetailsGetCollectionResponse = zBuildBetaDetailsResponse;

export const zBuildBetaDetailsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[buildBetaDetails]': z.optional(z.array(z.enum([
            'autoNotifyEnabled',
            'internalBuildState',
            'externalBuildState',
            'build'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        include: z.optional(z.array(z.enum(['build'])))
    }))
});

/**
 * Single BuildBetaDetail
 */
export const zBuildBetaDetailsGetInstanceResponse = zBuildBetaDetailResponse;

export const zBuildBetaDetailsUpdateInstanceData = z.object({
    body: zBuildBetaDetailUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BuildBetaDetail
 */
export const zBuildBetaDetailsUpdateInstanceResponse = zBuildBetaDetailResponse;

export const zBuildBetaNotificationsCreateInstanceData = z.object({
    body: zBuildBetaNotificationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BuildBetaNotification
 */
export const zBuildBetaNotificationsCreateInstanceResponse = zBuildBetaNotificationResponse;

export const zBuildUploadFilesCreateInstanceData = z.object({
    body: zBuildUploadFileCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BuildUploadFile
 */
export const zBuildUploadFilesCreateInstanceResponse = zBuildUploadFileResponse;

export const zBuildUploadFilesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[buildUploadFiles]': z.optional(z.array(z.enum([
            'assetDeliveryState',
            'assetToken',
            'assetType',
            'fileName',
            'fileSize',
            'sourceFileChecksums',
            'uploadOperations',
            'uti'
        ])))
    }))
});

/**
 * Single BuildUploadFile
 */
export const zBuildUploadFilesGetInstanceResponse = zBuildUploadFileResponse;

export const zBuildUploadFilesUpdateInstanceData = z.object({
    body: zBuildUploadFileUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BuildUploadFile
 */
export const zBuildUploadFilesUpdateInstanceResponse = zBuildUploadFileResponse;

export const zBuildUploadsCreateInstanceData = z.object({
    body: zBuildUploadCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BuildUpload
 */
export const zBuildUploadsCreateInstanceResponse = zBuildUploadResponse;

export const zBuildUploadsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBuildUploadsDeleteInstanceResponse = z.void();

export const zBuildUploadsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[buildUploads]': z.optional(z.array(z.enum([
            'cfBundleShortVersionString',
            'cfBundleVersion',
            'createdDate',
            'state',
            'platform',
            'uploadedDate',
            'build',
            'assetFile',
            'assetDescriptionFile',
            'assetSpiFile',
            'buildUploadFiles'
        ]))),
        include: z.optional(z.array(z.enum([
            'build',
            'assetFile',
            'assetDescriptionFile',
            'assetSpiFile'
        ])))
    }))
});

/**
 * Single BuildUpload
 */
export const zBuildUploadsGetInstanceResponse = zBuildUploadResponse;

export const zBuildsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[version]': z.optional(z.array(z.string())),
        'filter[expired]': z.optional(z.array(z.string())),
        'filter[processingState]': z.optional(z.array(z.enum([
            'PROCESSING',
            'FAILED',
            'INVALID',
            'VALID'
        ]))),
        'filter[betaAppReviewSubmission.betaReviewState]': z.optional(z.array(z.enum([
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'REJECTED',
            'APPROVED'
        ]))),
        'filter[usesNonExemptEncryption]': z.optional(z.array(z.string())),
        'filter[preReleaseVersion.version]': z.optional(z.array(z.string())),
        'filter[preReleaseVersion.platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[buildAudienceType]': z.optional(z.array(z.enum(['INTERNAL_ONLY', 'APP_STORE_ELIGIBLE']))),
        'filter[preReleaseVersion]': z.optional(z.array(z.string())),
        'filter[app]': z.optional(z.array(z.string())),
        'filter[betaGroups]': z.optional(z.array(z.string())),
        'filter[appStoreVersion]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'exists[usesNonExemptEncryption]': z.optional(z.boolean()),
        sort: z.optional(z.array(z.enum([
            'version',
            '-version',
            'uploadedDate',
            '-uploadedDate',
            'preReleaseVersion',
            '-preReleaseVersion'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[preReleaseVersions]': z.optional(z.array(z.enum([
            'version',
            'platform',
            'builds',
            'app'
        ]))),
        'fields[betaTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'email',
            'inviteType',
            'state',
            'appDevices',
            'apps',
            'betaGroups',
            'builds'
        ]))),
        'fields[betaBuildLocalizations]': z.optional(z.array(z.enum([
            'whatsNew',
            'locale',
            'build'
        ]))),
        'fields[appEncryptionDeclarations]': z.optional(z.array(z.enum([
            'appDescription',
            'createdDate',
            'usesEncryption',
            'exempt',
            'containsProprietaryCryptography',
            'containsThirdPartyCryptography',
            'availableOnFrenchStore',
            'platform',
            'uploadedDate',
            'documentUrl',
            'documentName',
            'documentType',
            'appEncryptionDeclarationState',
            'codeValue',
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'fields[betaAppReviewSubmissions]': z.optional(z.array(z.enum([
            'betaReviewState',
            'submittedDate',
            'build'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[buildBetaDetails]': z.optional(z.array(z.enum([
            'autoNotifyEnabled',
            'internalBuildState',
            'externalBuildState',
            'build'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[buildIcons]': z.optional(z.array(z.enum([
            'iconAsset',
            'iconType',
            'masked',
            'name'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload'
        ]))),
        'limit[betaBuildLocalizations]': z.optional(z.int().lte(50)),
        'limit[betaGroups]': z.optional(z.int().lte(50)),
        'limit[buildBundles]': z.optional(z.int().lte(50)),
        'limit[icons]': z.optional(z.int().lte(50)),
        'limit[individualTesters]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of Builds
 */
export const zBuildsGetCollectionResponse = zBuildsResponse;

export const zBuildsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[preReleaseVersions]': z.optional(z.array(z.enum([
            'version',
            'platform',
            'builds',
            'app'
        ]))),
        'fields[betaTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'email',
            'inviteType',
            'state',
            'appDevices',
            'apps',
            'betaGroups',
            'builds'
        ]))),
        'fields[betaBuildLocalizations]': z.optional(z.array(z.enum([
            'whatsNew',
            'locale',
            'build'
        ]))),
        'fields[appEncryptionDeclarations]': z.optional(z.array(z.enum([
            'appDescription',
            'createdDate',
            'usesEncryption',
            'exempt',
            'containsProprietaryCryptography',
            'containsThirdPartyCryptography',
            'availableOnFrenchStore',
            'platform',
            'uploadedDate',
            'documentUrl',
            'documentName',
            'documentType',
            'appEncryptionDeclarationState',
            'codeValue',
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'fields[betaAppReviewSubmissions]': z.optional(z.array(z.enum([
            'betaReviewState',
            'submittedDate',
            'build'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[buildBetaDetails]': z.optional(z.array(z.enum([
            'autoNotifyEnabled',
            'internalBuildState',
            'externalBuildState',
            'build'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[buildIcons]': z.optional(z.array(z.enum([
            'iconAsset',
            'iconType',
            'masked',
            'name'
        ]))),
        include: z.optional(z.array(z.enum([
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload'
        ]))),
        'limit[betaBuildLocalizations]': z.optional(z.int().lte(50)),
        'limit[betaGroups]': z.optional(z.int().lte(50)),
        'limit[buildBundles]': z.optional(z.int().lte(50)),
        'limit[icons]': z.optional(z.int().lte(50)),
        'limit[individualTesters]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single Build
 */
export const zBuildsGetInstanceResponse = zBuildResponse;

export const zBuildsUpdateInstanceData = z.object({
    body: zBuildUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single Build
 */
export const zBuildsUpdateInstanceResponse = zBuildResponse;

export const zBundleIdCapabilitiesCreateInstanceData = z.object({
    body: zBundleIdCapabilityCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BundleIdCapability
 */
export const zBundleIdCapabilitiesCreateInstanceResponse = zBundleIdCapabilityResponse;

export const zBundleIdCapabilitiesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBundleIdCapabilitiesDeleteInstanceResponse = z.void();

export const zBundleIdCapabilitiesUpdateInstanceData = z.object({
    body: zBundleIdCapabilityUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BundleIdCapability
 */
export const zBundleIdCapabilitiesUpdateInstanceResponse = zBundleIdCapabilityResponse;

export const zBundleIdsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[name]': z.optional(z.array(z.string())),
        'filter[platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'UNIVERSAL'
        ]))),
        'filter[identifier]': z.optional(z.array(z.string())),
        'filter[seedId]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'name',
            '-name',
            'platform',
            '-platform',
            'identifier',
            '-identifier',
            'seedId',
            '-seedId',
            'id',
            '-id'
        ]))),
        'fields[bundleIds]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'identifier',
            'seedId',
            'profiles',
            'bundleIdCapabilities',
            'app'
        ]))),
        'fields[profiles]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'profileType',
            'profileState',
            'profileContent',
            'uuid',
            'createdDate',
            'expirationDate',
            'bundleId',
            'devices',
            'certificates'
        ]))),
        'fields[bundleIdCapabilities]': z.optional(z.array(z.enum(['capabilityType', 'settings']))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'profiles',
            'bundleIdCapabilities',
            'app'
        ]))),
        'limit[bundleIdCapabilities]': z.optional(z.int().lte(50)),
        'limit[profiles]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of BundleIds
 */
export const zBundleIdsGetCollectionResponse = zBundleIdsResponse;

export const zBundleIdsCreateInstanceData = z.object({
    body: zBundleIdCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single BundleId
 */
export const zBundleIdsCreateInstanceResponse = zBundleIdResponse;

export const zBundleIdsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBundleIdsDeleteInstanceResponse = z.void();

export const zBundleIdsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[bundleIds]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'identifier',
            'seedId',
            'profiles',
            'bundleIdCapabilities',
            'app'
        ]))),
        'fields[profiles]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'profileType',
            'profileState',
            'profileContent',
            'uuid',
            'createdDate',
            'expirationDate',
            'bundleId',
            'devices',
            'certificates'
        ]))),
        'fields[bundleIdCapabilities]': z.optional(z.array(z.enum(['capabilityType', 'settings']))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        include: z.optional(z.array(z.enum([
            'profiles',
            'bundleIdCapabilities',
            'app'
        ]))),
        'limit[bundleIdCapabilities]': z.optional(z.int().lte(50)),
        'limit[profiles]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single BundleId
 */
export const zBundleIdsGetInstanceResponse = zBundleIdResponse;

export const zBundleIdsUpdateInstanceData = z.object({
    body: zBundleIdUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single BundleId
 */
export const zBundleIdsUpdateInstanceResponse = zBundleIdResponse;

export const zCertificatesGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[displayName]': z.optional(z.array(z.string())),
        'filter[certificateType]': z.optional(z.array(z.enum([
            'APPLE_PAY',
            'APPLE_PAY_MERCHANT_IDENTITY',
            'APPLE_PAY_PSP_IDENTITY',
            'APPLE_PAY_RSA',
            'DEVELOPER_ID_KEXT',
            'DEVELOPER_ID_KEXT_G2',
            'DEVELOPER_ID_APPLICATION',
            'DEVELOPER_ID_APPLICATION_G2',
            'DEVELOPMENT',
            'DISTRIBUTION',
            'IDENTITY_ACCESS',
            'IOS_DEVELOPMENT',
            'IOS_DISTRIBUTION',
            'MAC_APP_DISTRIBUTION',
            'MAC_INSTALLER_DISTRIBUTION',
            'MAC_APP_DEVELOPMENT',
            'PASS_TYPE_ID',
            'PASS_TYPE_ID_WITH_NFC'
        ]))),
        'filter[serialNumber]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'displayName',
            '-displayName',
            'certificateType',
            '-certificateType',
            'serialNumber',
            '-serialNumber',
            'id',
            '-id'
        ]))),
        'fields[certificates]': z.optional(z.array(z.enum([
            'name',
            'certificateType',
            'displayName',
            'serialNumber',
            'platform',
            'expirationDate',
            'certificateContent',
            'activated',
            'passTypeId'
        ]))),
        'fields[passTypeIds]': z.optional(z.array(z.enum([
            'name',
            'identifier',
            'certificates'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['passTypeId'])))
    }))
});

/**
 * List of Certificates
 */
export const zCertificatesGetCollectionResponse = zCertificatesResponse;

export const zCertificatesCreateInstanceData = z.object({
    body: zCertificateCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single Certificate
 */
export const zCertificatesCreateInstanceResponse = zCertificateResponse;

export const zCertificatesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zCertificatesDeleteInstanceResponse = z.void();

export const zCertificatesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[certificates]': z.optional(z.array(z.enum([
            'name',
            'certificateType',
            'displayName',
            'serialNumber',
            'platform',
            'expirationDate',
            'certificateContent',
            'activated',
            'passTypeId'
        ]))),
        'fields[passTypeIds]': z.optional(z.array(z.enum([
            'name',
            'identifier',
            'certificates'
        ]))),
        include: z.optional(z.array(z.enum(['passTypeId'])))
    }))
});

/**
 * Single Certificate
 */
export const zCertificatesGetInstanceResponse = zCertificateResponse;

export const zCertificatesUpdateInstanceData = z.object({
    body: zCertificateUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single Certificate
 */
export const zCertificatesUpdateInstanceResponse = zCertificateResponse;

export const zCiArtifactsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciArtifacts]': z.optional(z.array(z.enum([
            'fileType',
            'fileName',
            'fileSize',
            'downloadUrl'
        ])))
    }))
});

/**
 * Single CiArtifact
 */
export const zCiArtifactsGetInstanceResponse = zCiArtifactResponse;

export const zCiBuildActionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciBuildActions]': z.optional(z.array(z.enum([
            'name',
            'actionType',
            'startedDate',
            'finishedDate',
            'issueCounts',
            'executionProgress',
            'completionStatus',
            'isRequiredToPass',
            'buildRun',
            'artifacts',
            'issues',
            'testResults'
        ]))),
        'fields[ciBuildRuns]': z.optional(z.array(z.enum([
            'number',
            'createdDate',
            'startedDate',
            'finishedDate',
            'sourceCommit',
            'destinationCommit',
            'isPullRequestBuild',
            'issueCounts',
            'executionProgress',
            'completionStatus',
            'startReason',
            'cancelReason',
            'builds',
            'workflow',
            'product',
            'sourceBranchOrTag',
            'destinationBranch',
            'actions',
            'pullRequest'
        ]))),
        include: z.optional(z.array(z.enum(['buildRun'])))
    }))
});

/**
 * Single CiBuildAction
 */
export const zCiBuildActionsGetInstanceResponse = zCiBuildActionResponse;

export const zCiBuildRunsCreateInstanceData = z.object({
    body: zCiBuildRunCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single CiBuildRun
 */
export const zCiBuildRunsCreateInstanceResponse = zCiBuildRunResponse;

export const zCiBuildRunsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciBuildRuns]': z.optional(z.array(z.enum([
            'number',
            'createdDate',
            'startedDate',
            'finishedDate',
            'sourceCommit',
            'destinationCommit',
            'isPullRequestBuild',
            'issueCounts',
            'executionProgress',
            'completionStatus',
            'startReason',
            'cancelReason',
            'builds',
            'workflow',
            'product',
            'sourceBranchOrTag',
            'destinationBranch',
            'actions',
            'pullRequest'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        include: z.optional(z.array(z.enum([
            'builds',
            'workflow',
            'product',
            'sourceBranchOrTag',
            'destinationBranch',
            'pullRequest'
        ]))),
        'limit[builds]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single CiBuildRun
 */
export const zCiBuildRunsGetInstanceResponse = zCiBuildRunResponse;

export const zCiIssuesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciIssues]': z.optional(z.array(z.enum([
            'issueType',
            'message',
            'fileSource',
            'category'
        ])))
    }))
});

/**
 * Single CiIssue
 */
export const zCiIssuesGetInstanceResponse = zCiIssueResponse;

export const zCiMacOsVersionsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'fields[ciMacOsVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'xcodeVersions'
        ]))),
        'fields[ciXcodeVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'testDestinations',
            'macOsVersions'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['xcodeVersions']))),
        'limit[xcodeVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of CiMacOsVersions
 */
export const zCiMacOsVersionsGetCollectionResponse = zCiMacOsVersionsResponse;

export const zCiMacOsVersionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciMacOsVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'xcodeVersions'
        ]))),
        'fields[ciXcodeVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'testDestinations',
            'macOsVersions'
        ]))),
        include: z.optional(z.array(z.enum(['xcodeVersions']))),
        'limit[xcodeVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single CiMacOsVersion
 */
export const zCiMacOsVersionsGetInstanceResponse = zCiMacOsVersionResponse;

export const zCiProductsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[productType]': z.optional(z.array(z.enum(['APP', 'FRAMEWORK']))),
        'filter[app]': z.optional(z.array(z.string())),
        'fields[ciProducts]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'productType',
            'app',
            'bundleId',
            'workflows',
            'primaryRepositories',
            'additionalRepositories',
            'buildRuns'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'app',
            'bundleId',
            'primaryRepositories'
        ]))),
        'limit[primaryRepositories]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of CiProducts
 */
export const zCiProductsGetCollectionResponse = zCiProductsResponse;

export const zCiProductsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zCiProductsDeleteInstanceResponse = z.void();

export const zCiProductsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciProducts]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'productType',
            'app',
            'bundleId',
            'workflows',
            'primaryRepositories',
            'additionalRepositories',
            'buildRuns'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        include: z.optional(z.array(z.enum([
            'app',
            'bundleId',
            'primaryRepositories'
        ]))),
        'limit[primaryRepositories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single CiProduct
 */
export const zCiProductsGetInstanceResponse = zCiProductResponse;

export const zCiTestResultsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciTestResults]': z.optional(z.array(z.enum([
            'className',
            'name',
            'status',
            'fileSource',
            'message',
            'destinationTestResults'
        ])))
    }))
});

/**
 * Single CiTestResult
 */
export const zCiTestResultsGetInstanceResponse = zCiTestResultResponse;

export const zCiWorkflowsCreateInstanceData = z.object({
    body: zCiWorkflowCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single CiWorkflow
 */
export const zCiWorkflowsCreateInstanceResponse = zCiWorkflowResponse;

export const zCiWorkflowsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zCiWorkflowsDeleteInstanceResponse = z.void();

export const zCiWorkflowsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciWorkflows]': z.optional(z.array(z.enum([
            'name',
            'description',
            'branchStartCondition',
            'tagStartCondition',
            'pullRequestStartCondition',
            'scheduledStartCondition',
            'manualBranchStartCondition',
            'manualTagStartCondition',
            'manualPullRequestStartCondition',
            'actions',
            'isEnabled',
            'isLockedForEditing',
            'clean',
            'containerFilePath',
            'lastModifiedDate',
            'product',
            'repository',
            'xcodeVersion',
            'macOsVersion',
            'buildRuns'
        ]))),
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        include: z.optional(z.array(z.enum([
            'product',
            'repository',
            'xcodeVersion',
            'macOsVersion'
        ])))
    }))
});

/**
 * Single CiWorkflow
 */
export const zCiWorkflowsGetInstanceResponse = zCiWorkflowResponse;

export const zCiWorkflowsUpdateInstanceData = z.object({
    body: zCiWorkflowUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single CiWorkflow
 */
export const zCiWorkflowsUpdateInstanceResponse = zCiWorkflowResponse;

export const zCiXcodeVersionsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'fields[ciXcodeVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'testDestinations',
            'macOsVersions'
        ]))),
        'fields[ciMacOsVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'xcodeVersions'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['macOsVersions']))),
        'limit[macOsVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of CiXcodeVersions
 */
export const zCiXcodeVersionsGetCollectionResponse = zCiXcodeVersionsResponse;

export const zCiXcodeVersionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciXcodeVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'testDestinations',
            'macOsVersions'
        ]))),
        'fields[ciMacOsVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'xcodeVersions'
        ]))),
        include: z.optional(z.array(z.enum(['macOsVersions']))),
        'limit[macOsVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single CiXcodeVersion
 */
export const zCiXcodeVersionsGetInstanceResponse = zCiXcodeVersionResponse;

export const zCustomerReviewResponsesCreateInstanceData = z.object({
    body: zCustomerReviewResponseV1CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single CustomerReviewResponse
 */
export const zCustomerReviewResponsesCreateInstanceResponse = zCustomerReviewResponseV1Response;

export const zCustomerReviewResponsesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zCustomerReviewResponsesDeleteInstanceResponse = z.void();

export const zCustomerReviewResponsesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[customerReviewResponses]': z.optional(z.array(z.enum([
            'responseBody',
            'lastModifiedDate',
            'state',
            'review'
        ]))),
        include: z.optional(z.array(z.enum(['review'])))
    }))
});

/**
 * Single CustomerReviewResponse
 */
export const zCustomerReviewResponsesGetInstanceResponse = zCustomerReviewResponseV1Response;

export const zCustomerReviewsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[customerReviews]': z.optional(z.array(z.enum([
            'rating',
            'title',
            'body',
            'reviewerNickname',
            'createdDate',
            'territory',
            'response'
        ]))),
        'fields[customerReviewResponses]': z.optional(z.array(z.enum([
            'responseBody',
            'lastModifiedDate',
            'state',
            'review'
        ]))),
        include: z.optional(z.array(z.enum(['response'])))
    }))
});

/**
 * Single CustomerReview
 */
export const zCustomerReviewsGetInstanceResponse = zCustomerReviewResponse;

export const zDevicesGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[name]': z.optional(z.array(z.string())),
        'filter[platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'UNIVERSAL'
        ]))),
        'filter[udid]': z.optional(z.array(z.string())),
        'filter[status]': z.optional(z.array(z.enum(['ENABLED', 'DISABLED']))),
        'filter[id]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'name',
            '-name',
            'platform',
            '-platform',
            'udid',
            '-udid',
            'status',
            '-status',
            'id',
            '-id'
        ]))),
        'fields[devices]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'udid',
            'deviceClass',
            'status',
            'model',
            'addedDate'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Devices
 */
export const zDevicesGetCollectionResponse = zDevicesResponse;

export const zDevicesCreateInstanceData = z.object({
    body: zDeviceCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single Device
 */
export const zDevicesCreateInstanceResponse = zDeviceResponse;

export const zDevicesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[devices]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'udid',
            'deviceClass',
            'status',
            'model',
            'addedDate'
        ])))
    }))
});

/**
 * Single Device
 */
export const zDevicesGetInstanceResponse = zDeviceResponse;

export const zDevicesUpdateInstanceData = z.object({
    body: zDeviceUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single Device
 */
export const zDevicesUpdateInstanceResponse = zDeviceResponse;

export const zEndAppAvailabilityPreOrdersCreateInstanceData = z.object({
    body: zEndAppAvailabilityPreOrderCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single EndAppAvailabilityPreOrder
 */
export const zEndAppAvailabilityPreOrdersCreateInstanceResponse = zEndAppAvailabilityPreOrderResponse;

export const zEndUserLicenseAgreementsCreateInstanceData = z.object({
    body: zEndUserLicenseAgreementCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single EndUserLicenseAgreement
 */
export const zEndUserLicenseAgreementsCreateInstanceResponse = zEndUserLicenseAgreementResponse;

export const zEndUserLicenseAgreementsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zEndUserLicenseAgreementsDeleteInstanceResponse = z.void();

export const zEndUserLicenseAgreementsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[endUserLicenseAgreements]': z.optional(z.array(z.enum([
            'agreementText',
            'app',
            'territories'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        include: z.optional(z.array(z.enum(['app', 'territories']))),
        'limit[territories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single EndUserLicenseAgreement
 */
export const zEndUserLicenseAgreementsGetInstanceResponse = zEndUserLicenseAgreementResponse;

export const zEndUserLicenseAgreementsUpdateInstanceData = z.object({
    body: zEndUserLicenseAgreementUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single EndUserLicenseAgreement
 */
export const zEndUserLicenseAgreementsUpdateInstanceResponse = zEndUserLicenseAgreementResponse;

export const zFinanceReportsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        'filter[vendorNumber]': z.array(z.string()),
        'filter[reportType]': z.array(z.enum(['FINANCIAL', 'FINANCE_DETAIL'])),
        'filter[regionCode]': z.array(z.string()),
        'filter[reportDate]': z.array(z.string())
    })
});

/**
 * List of FinanceReports
 */
export const zFinanceReportsGetCollectionResponse = zGzip;

export const zGameCenterAchievementImagesCreateInstanceData = z.object({
    body: zGameCenterAchievementImageCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievementImage
 */
export const zGameCenterAchievementImagesCreateInstanceResponse = zGameCenterAchievementImageResponse;

export const zGameCenterAchievementImagesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterAchievementImagesDeleteInstanceResponse = z.void();

export const zGameCenterAchievementImagesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievementImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'gameCenterAchievementLocalization'
        ]))),
        include: z.optional(z.array(z.enum(['gameCenterAchievementLocalization'])))
    }))
});

/**
 * Single GameCenterAchievementImage
 */
export const zGameCenterAchievementImagesGetInstanceResponse = zGameCenterAchievementImageResponse;

export const zGameCenterAchievementImagesUpdateInstanceData = z.object({
    body: zGameCenterAchievementImageUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievementImage
 */
export const zGameCenterAchievementImagesUpdateInstanceResponse = zGameCenterAchievementImageResponse;

export const zGameCenterAchievementImagesV2CreateInstanceData = z.object({
    body: zGameCenterAchievementImageV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievementImage
 */
export const zGameCenterAchievementImagesV2CreateInstanceResponse = zGameCenterAchievementImageV2Response;

export const zGameCenterAchievementImagesV2DeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterAchievementImagesV2DeleteInstanceResponse = z.void();

export const zGameCenterAchievementImagesV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievementImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'localization'
        ]))),
        include: z.optional(z.array(z.enum(['localization'])))
    }))
});

/**
 * Single GameCenterAchievementImage
 */
export const zGameCenterAchievementImagesV2GetInstanceResponse = zGameCenterAchievementImageV2Response;

export const zGameCenterAchievementImagesV2UpdateInstanceData = z.object({
    body: zGameCenterAchievementImageV2UpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievementImage
 */
export const zGameCenterAchievementImagesV2UpdateInstanceResponse = zGameCenterAchievementImageV2Response;

export const zGameCenterAchievementLocalizationsV2CreateInstanceData = z.object({
    body: zGameCenterAchievementLocalizationV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievementLocalization
 */
export const zGameCenterAchievementLocalizationsV2CreateInstanceResponse = zGameCenterAchievementLocalizationV2Response;

export const zGameCenterAchievementLocalizationsV2DeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterAchievementLocalizationsV2DeleteInstanceResponse = z.void();

export const zGameCenterAchievementLocalizationsV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'version',
            'image'
        ]))),
        'fields[gameCenterAchievementImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'localization'
        ]))),
        include: z.optional(z.array(z.enum(['version', 'image'])))
    }))
});

/**
 * Single GameCenterAchievementLocalization
 */
export const zGameCenterAchievementLocalizationsV2GetInstanceResponse = zGameCenterAchievementLocalizationV2Response;

export const zGameCenterAchievementLocalizationsV2UpdateInstanceData = z.object({
    body: zGameCenterAchievementLocalizationV2UpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievementLocalization
 */
export const zGameCenterAchievementLocalizationsV2UpdateInstanceResponse = zGameCenterAchievementLocalizationV2Response;

export const zGameCenterAchievementLocalizationsCreateInstanceData = z.object({
    body: zGameCenterAchievementLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievementLocalization
 */
export const zGameCenterAchievementLocalizationsCreateInstanceResponse = zGameCenterAchievementLocalizationResponse;

export const zGameCenterAchievementLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterAchievementLocalizationsDeleteInstanceResponse = z.void();

export const zGameCenterAchievementLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'gameCenterAchievement',
            'gameCenterAchievementImage'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        'fields[gameCenterAchievementImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'gameCenterAchievementLocalization'
        ]))),
        include: z.optional(z.array(z.enum(['gameCenterAchievement', 'gameCenterAchievementImage'])))
    }))
});

/**
 * Single GameCenterAchievementLocalization
 */
export const zGameCenterAchievementLocalizationsGetInstanceResponse = zGameCenterAchievementLocalizationResponse;

export const zGameCenterAchievementLocalizationsUpdateInstanceData = z.object({
    body: zGameCenterAchievementLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievementLocalization
 */
export const zGameCenterAchievementLocalizationsUpdateInstanceResponse = zGameCenterAchievementLocalizationResponse;

export const zGameCenterAchievementReleasesCreateInstanceData = z.object({
    body: zGameCenterAchievementReleaseCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievementRelease
 */
export const zGameCenterAchievementReleasesCreateInstanceResponse = zGameCenterAchievementReleaseResponse;

export const zGameCenterAchievementReleasesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterAchievementReleasesDeleteInstanceResponse = z.void();

export const zGameCenterAchievementReleasesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievementReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterAchievement'
        ]))),
        include: z.optional(z.array(z.enum(['gameCenterDetail', 'gameCenterAchievement'])))
    }))
});

/**
 * Single GameCenterAchievementRelease
 */
export const zGameCenterAchievementReleasesGetInstanceResponse = zGameCenterAchievementReleaseResponse;

export const zGameCenterAchievementVersionsV2CreateInstanceData = z.object({
    body: zGameCenterAchievementVersionV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievementVersion
 */
export const zGameCenterAchievementVersionsV2CreateInstanceResponse = zGameCenterAchievementVersionV2Response;

export const zGameCenterAchievementVersionsV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievementVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'achievement',
            'localizations'
        ]))),
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'version',
            'image'
        ]))),
        include: z.optional(z.array(z.enum(['achievement', 'localizations']))),
        'limit[localizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterAchievementVersion
 */
export const zGameCenterAchievementVersionsV2GetInstanceResponse = zGameCenterAchievementVersionV2Response;

export const zGameCenterAchievementsV2CreateInstanceData = z.object({
    body: zGameCenterAchievementV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievement
 */
export const zGameCenterAchievementsV2CreateInstanceResponse = zGameCenterAchievementV2Response;

export const zGameCenterAchievementsV2DeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterAchievementsV2DeleteInstanceResponse = z.void();

export const zGameCenterAchievementsV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'activity',
            'versions'
        ]))),
        'fields[gameCenterAchievementVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'achievement',
            'localizations'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'activity',
            'versions'
        ]))),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterAchievement
 */
export const zGameCenterAchievementsV2GetInstanceResponse = zGameCenterAchievementV2Response;

export const zGameCenterAchievementsV2UpdateInstanceData = z.object({
    body: zGameCenterAchievementV2UpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievement
 */
export const zGameCenterAchievementsV2UpdateInstanceResponse = zGameCenterAchievementV2Response;

export const zGameCenterAchievementsCreateInstanceData = z.object({
    body: zGameCenterAchievementCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievement
 */
export const zGameCenterAchievementsCreateInstanceResponse = zGameCenterAchievementResponse;

export const zGameCenterAchievementsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterAchievementsDeleteInstanceResponse = z.void();

export const zGameCenterAchievementsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'gameCenterAchievement',
            'gameCenterAchievementImage'
        ]))),
        'fields[gameCenterAchievementReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterAchievement'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterAchievement
 */
export const zGameCenterAchievementsGetInstanceResponse = zGameCenterAchievementResponse;

export const zGameCenterAchievementsUpdateInstanceData = z.object({
    body: zGameCenterAchievementUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAchievement
 */
export const zGameCenterAchievementsUpdateInstanceResponse = zGameCenterAchievementResponse;

export const zGameCenterActivitiesCreateInstanceData = z.object({
    body: zGameCenterActivityCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterActivity
 */
export const zGameCenterActivitiesCreateInstanceResponse = zGameCenterActivityResponse;

export const zGameCenterActivitiesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterActivitiesDeleteInstanceResponse = z.void();

export const zGameCenterActivitiesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterActivityVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'fallbackUrl',
            'activity',
            'localizations',
            'defaultImage',
            'releases'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'limit[achievements]': z.optional(z.int().lte(50)),
        'limit[achievementsV2]': z.optional(z.int().lte(50)),
        'limit[leaderboards]': z.optional(z.int().lte(50)),
        'limit[leaderboardsV2]': z.optional(z.int().lte(50)),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterActivity
 */
export const zGameCenterActivitiesGetInstanceResponse = zGameCenterActivityResponse;

export const zGameCenterActivitiesUpdateInstanceData = z.object({
    body: zGameCenterActivityUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterActivity
 */
export const zGameCenterActivitiesUpdateInstanceResponse = zGameCenterActivityResponse;

export const zGameCenterActivityImagesCreateInstanceData = z.object({
    body: zGameCenterActivityImageCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterActivityImage
 */
export const zGameCenterActivityImagesCreateInstanceResponse = zGameCenterActivityImageResponse;

export const zGameCenterActivityImagesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterActivityImagesDeleteInstanceResponse = z.void();

export const zGameCenterActivityImagesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterActivityImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ])))
    }))
});

/**
 * Single GameCenterActivityImage
 */
export const zGameCenterActivityImagesGetInstanceResponse = zGameCenterActivityImageResponse;

export const zGameCenterActivityImagesUpdateInstanceData = z.object({
    body: zGameCenterActivityImageUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterActivityImage
 */
export const zGameCenterActivityImagesUpdateInstanceResponse = zGameCenterActivityImageResponse;

export const zGameCenterActivityLocalizationsCreateInstanceData = z.object({
    body: zGameCenterActivityLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterActivityLocalization
 */
export const zGameCenterActivityLocalizationsCreateInstanceResponse = zGameCenterActivityLocalizationResponse;

export const zGameCenterActivityLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterActivityLocalizationsDeleteInstanceResponse = z.void();

export const zGameCenterActivityLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterActivityLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'description',
            'version',
            'image'
        ]))),
        'fields[gameCenterActivityImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ]))),
        include: z.optional(z.array(z.enum(['version', 'image'])))
    }))
});

/**
 * Single GameCenterActivityLocalization
 */
export const zGameCenterActivityLocalizationsGetInstanceResponse = zGameCenterActivityLocalizationResponse;

export const zGameCenterActivityLocalizationsUpdateInstanceData = z.object({
    body: zGameCenterActivityLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterActivityLocalization
 */
export const zGameCenterActivityLocalizationsUpdateInstanceResponse = zGameCenterActivityLocalizationResponse;

export const zGameCenterActivityVersionReleasesCreateInstanceData = z.object({
    body: zGameCenterActivityVersionReleaseCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterActivityVersionRelease
 */
export const zGameCenterActivityVersionReleasesCreateInstanceResponse = zGameCenterActivityVersionReleaseResponse;

export const zGameCenterActivityVersionReleasesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterActivityVersionReleasesDeleteInstanceResponse = z.void();

export const zGameCenterActivityVersionReleasesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterActivityVersionReleases]': z.optional(z.array(z.enum(['version']))),
        include: z.optional(z.array(z.enum(['version'])))
    }))
});

/**
 * Single GameCenterActivityVersionRelease
 */
export const zGameCenterActivityVersionReleasesGetInstanceResponse = zGameCenterActivityVersionReleaseResponse;

export const zGameCenterActivityVersionsCreateInstanceData = z.object({
    body: zGameCenterActivityVersionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterActivityVersion
 */
export const zGameCenterActivityVersionsCreateInstanceResponse = zGameCenterActivityVersionResponse;

export const zGameCenterActivityVersionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterActivityVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'fallbackUrl',
            'activity',
            'localizations',
            'defaultImage',
            'releases'
        ]))),
        'fields[gameCenterActivityLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'description',
            'version',
            'image'
        ]))),
        'fields[gameCenterActivityImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ]))),
        include: z.optional(z.array(z.enum([
            'activity',
            'localizations',
            'defaultImage',
            'releases'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterActivityVersion
 */
export const zGameCenterActivityVersionsGetInstanceResponse = zGameCenterActivityVersionResponse;

export const zGameCenterActivityVersionsUpdateInstanceData = z.object({
    body: zGameCenterActivityVersionUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterActivityVersion
 */
export const zGameCenterActivityVersionsUpdateInstanceResponse = zGameCenterActivityVersionResponse;

export const zGameCenterAppVersionsCreateInstanceData = z.object({
    body: zGameCenterAppVersionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAppVersion
 */
export const zGameCenterAppVersionsCreateInstanceResponse = zGameCenterAppVersionResponse;

export const zGameCenterAppVersionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAppVersions]': z.optional(z.array(z.enum([
            'enabled',
            'compatibilityVersions',
            'appStoreVersion'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        include: z.optional(z.array(z.enum(['compatibilityVersions', 'appStoreVersion']))),
        'limit[compatibilityVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterAppVersion
 */
export const zGameCenterAppVersionsGetInstanceResponse = zGameCenterAppVersionResponse;

export const zGameCenterAppVersionsUpdateInstanceData = z.object({
    body: zGameCenterAppVersionUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterAppVersion
 */
export const zGameCenterAppVersionsUpdateInstanceResponse = zGameCenterAppVersionResponse;

export const zGameCenterChallengeImagesCreateInstanceData = z.object({
    body: zGameCenterChallengeImageCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterChallengeImage
 */
export const zGameCenterChallengeImagesCreateInstanceResponse = zGameCenterChallengeImageResponse;

export const zGameCenterChallengeImagesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterChallengeImagesDeleteInstanceResponse = z.void();

export const zGameCenterChallengeImagesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterChallengeImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ])))
    }))
});

/**
 * Single GameCenterChallengeImage
 */
export const zGameCenterChallengeImagesGetInstanceResponse = zGameCenterChallengeImageResponse;

export const zGameCenterChallengeImagesUpdateInstanceData = z.object({
    body: zGameCenterChallengeImageUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterChallengeImage
 */
export const zGameCenterChallengeImagesUpdateInstanceResponse = zGameCenterChallengeImageResponse;

export const zGameCenterChallengeLocalizationsCreateInstanceData = z.object({
    body: zGameCenterChallengeLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterChallengeLocalization
 */
export const zGameCenterChallengeLocalizationsCreateInstanceResponse = zGameCenterChallengeLocalizationResponse;

export const zGameCenterChallengeLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterChallengeLocalizationsDeleteInstanceResponse = z.void();

export const zGameCenterChallengeLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterChallengeLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'description',
            'version',
            'image'
        ]))),
        'fields[gameCenterChallengeImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ]))),
        include: z.optional(z.array(z.enum(['version', 'image'])))
    }))
});

/**
 * Single GameCenterChallengeLocalization
 */
export const zGameCenterChallengeLocalizationsGetInstanceResponse = zGameCenterChallengeLocalizationResponse;

export const zGameCenterChallengeLocalizationsUpdateInstanceData = z.object({
    body: zGameCenterChallengeLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterChallengeLocalization
 */
export const zGameCenterChallengeLocalizationsUpdateInstanceResponse = zGameCenterChallengeLocalizationResponse;

export const zGameCenterChallengeVersionReleasesCreateInstanceData = z.object({
    body: zGameCenterChallengeVersionReleaseCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterChallengeVersionRelease
 */
export const zGameCenterChallengeVersionReleasesCreateInstanceResponse = zGameCenterChallengeVersionReleaseResponse;

export const zGameCenterChallengeVersionReleasesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterChallengeVersionReleasesDeleteInstanceResponse = z.void();

export const zGameCenterChallengeVersionReleasesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterChallengeVersionReleases]': z.optional(z.array(z.enum(['version']))),
        include: z.optional(z.array(z.enum(['version'])))
    }))
});

/**
 * Single GameCenterChallengeVersionRelease
 */
export const zGameCenterChallengeVersionReleasesGetInstanceResponse = zGameCenterChallengeVersionReleaseResponse;

export const zGameCenterChallengeVersionsCreateInstanceData = z.object({
    body: zGameCenterChallengeVersionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterChallengeVersion
 */
export const zGameCenterChallengeVersionsCreateInstanceResponse = zGameCenterChallengeVersionResponse;

export const zGameCenterChallengeVersionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterChallengeVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'challenge',
            'localizations',
            'releases',
            'defaultImage'
        ]))),
        'fields[gameCenterChallengeLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'description',
            'version',
            'image'
        ]))),
        'fields[gameCenterChallengeImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ]))),
        include: z.optional(z.array(z.enum([
            'challenge',
            'localizations',
            'releases',
            'defaultImage'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterChallengeVersion
 */
export const zGameCenterChallengeVersionsGetInstanceResponse = zGameCenterChallengeVersionResponse;

export const zGameCenterChallengesCreateInstanceData = z.object({
    body: zGameCenterChallengeCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterChallenge
 */
export const zGameCenterChallengesCreateInstanceResponse = zGameCenterChallengeResponse;

export const zGameCenterChallengesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterChallengesDeleteInstanceResponse = z.void();

export const zGameCenterChallengesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'fields[gameCenterChallengeVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'challenge',
            'localizations',
            'releases',
            'defaultImage'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterChallenge
 */
export const zGameCenterChallengesGetInstanceResponse = zGameCenterChallengeResponse;

export const zGameCenterChallengesUpdateInstanceData = z.object({
    body: zGameCenterChallengeUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterChallenge
 */
export const zGameCenterChallengesUpdateInstanceResponse = zGameCenterChallengeResponse;

export const zGameCenterDetailsCreateInstanceData = z.object({
    body: zGameCenterDetailCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterDetail
 */
export const zGameCenterDetailsCreateInstanceResponse = zGameCenterDetailResponse;

export const zGameCenterDetailsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterAppVersions]': z.optional(z.array(z.enum([
            'enabled',
            'compatibilityVersions',
            'appStoreVersion'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases',
            'versions'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity',
            'versions'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'fields[gameCenterAchievementReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterAchievement'
        ]))),
        'fields[gameCenterActivityVersionReleases]': z.optional(z.array(z.enum(['version']))),
        'fields[gameCenterChallengeVersionReleases]': z.optional(z.array(z.enum(['version']))),
        'fields[gameCenterLeaderboardReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboard'
        ]))),
        'fields[gameCenterLeaderboardSetReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboardSet'
        ]))),
        include: z.optional(z.array(z.enum([
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'limit[achievementReleases]': z.optional(z.int().lte(50)),
        'limit[activityReleases]': z.optional(z.int().lte(50)),
        'limit[challengeReleases]': z.optional(z.int().lte(50)),
        'limit[challengesMinimumPlatformVersions]': z.optional(z.int().lte(50)),
        'limit[gameCenterAchievements]': z.optional(z.int().lte(50)),
        'limit[gameCenterAchievementsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterActivities]': z.optional(z.int().lte(50)),
        'limit[gameCenterAppVersions]': z.optional(z.int().lte(50)),
        'limit[gameCenterChallenges]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardSetsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardsV2]': z.optional(z.int().lte(50)),
        'limit[leaderboardReleases]': z.optional(z.int().lte(50)),
        'limit[leaderboardSetReleases]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterDetail
 */
export const zGameCenterDetailsGetInstanceResponse = zGameCenterDetailResponse;

export const zGameCenterDetailsUpdateInstanceData = z.object({
    body: zGameCenterDetailUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterDetail
 */
export const zGameCenterDetailsUpdateInstanceResponse = zGameCenterDetailResponse;

export const zGameCenterGroupsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[gameCenterDetails]': z.optional(z.array(z.string())),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases',
            'versions'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity',
            'versions'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'limit[gameCenterAchievements]': z.optional(z.int().lte(50)),
        'limit[gameCenterAchievementsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterActivities]': z.optional(z.int().lte(50)),
        'limit[gameCenterChallenges]': z.optional(z.int().lte(50)),
        'limit[gameCenterDetails]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardSetsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardsV2]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterGroups
 */
export const zGameCenterGroupsGetCollectionResponse = zGameCenterGroupsResponse;

export const zGameCenterGroupsCreateInstanceData = z.object({
    body: zGameCenterGroupCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterGroup
 */
export const zGameCenterGroupsCreateInstanceResponse = zGameCenterGroupResponse;

export const zGameCenterGroupsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterGroupsDeleteInstanceResponse = z.void();

export const zGameCenterGroupsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases',
            'versions'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity',
            'versions'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'limit[gameCenterAchievements]': z.optional(z.int().lte(50)),
        'limit[gameCenterAchievementsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterActivities]': z.optional(z.int().lte(50)),
        'limit[gameCenterChallenges]': z.optional(z.int().lte(50)),
        'limit[gameCenterDetails]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardSetsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardsV2]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterGroup
 */
export const zGameCenterGroupsGetInstanceResponse = zGameCenterGroupResponse;

export const zGameCenterGroupsUpdateInstanceData = z.object({
    body: zGameCenterGroupUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterGroup
 */
export const zGameCenterGroupsUpdateInstanceResponse = zGameCenterGroupResponse;

export const zGameCenterLeaderboardEntrySubmissionsCreateInstanceData = z.object({
    body: zGameCenterLeaderboardEntrySubmissionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardEntrySubmission
 */
export const zGameCenterLeaderboardEntrySubmissionsCreateInstanceResponse = zGameCenterLeaderboardEntrySubmissionResponse;

export const zGameCenterLeaderboardImagesCreateInstanceData = z.object({
    body: zGameCenterLeaderboardImageCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardImage
 */
export const zGameCenterLeaderboardImagesCreateInstanceResponse = zGameCenterLeaderboardImageResponse;

export const zGameCenterLeaderboardImagesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardImagesDeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardImagesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'gameCenterLeaderboardLocalization'
        ]))),
        include: z.optional(z.array(z.enum(['gameCenterLeaderboardLocalization'])))
    }))
});

/**
 * Single GameCenterLeaderboardImage
 */
export const zGameCenterLeaderboardImagesGetInstanceResponse = zGameCenterLeaderboardImageResponse;

export const zGameCenterLeaderboardImagesUpdateInstanceData = z.object({
    body: zGameCenterLeaderboardImageUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardImage
 */
export const zGameCenterLeaderboardImagesUpdateInstanceResponse = zGameCenterLeaderboardImageResponse;

export const zGameCenterLeaderboardImagesV2CreateInstanceData = z.object({
    body: zGameCenterLeaderboardImageV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardImage
 */
export const zGameCenterLeaderboardImagesV2CreateInstanceResponse = zGameCenterLeaderboardImageV2Response;

export const zGameCenterLeaderboardImagesV2DeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardImagesV2DeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardImagesV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'localization'
        ]))),
        include: z.optional(z.array(z.enum(['localization'])))
    }))
});

/**
 * Single GameCenterLeaderboardImage
 */
export const zGameCenterLeaderboardImagesV2GetInstanceResponse = zGameCenterLeaderboardImageV2Response;

export const zGameCenterLeaderboardImagesV2UpdateInstanceData = z.object({
    body: zGameCenterLeaderboardImageV2UpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardImage
 */
export const zGameCenterLeaderboardImagesV2UpdateInstanceResponse = zGameCenterLeaderboardImageV2Response;

export const zGameCenterLeaderboardLocalizationsCreateInstanceData = z.object({
    body: zGameCenterLeaderboardLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardLocalization
 */
export const zGameCenterLeaderboardLocalizationsCreateInstanceResponse = zGameCenterLeaderboardLocalizationResponse;

export const zGameCenterLeaderboardLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardLocalizationsDeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'gameCenterLeaderboard',
            'gameCenterLeaderboardImage'
        ]))),
        'fields[gameCenterLeaderboardImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'gameCenterLeaderboardLocalization'
        ]))),
        include: z.optional(z.array(z.enum(['gameCenterLeaderboard', 'gameCenterLeaderboardImage'])))
    }))
});

/**
 * Single GameCenterLeaderboardLocalization
 */
export const zGameCenterLeaderboardLocalizationsGetInstanceResponse = zGameCenterLeaderboardLocalizationResponse;

export const zGameCenterLeaderboardLocalizationsUpdateInstanceData = z.object({
    body: zGameCenterLeaderboardLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardLocalization
 */
export const zGameCenterLeaderboardLocalizationsUpdateInstanceResponse = zGameCenterLeaderboardLocalizationResponse;

export const zGameCenterLeaderboardLocalizationsV2CreateInstanceData = z.object({
    body: zGameCenterLeaderboardLocalizationV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardLocalization
 */
export const zGameCenterLeaderboardLocalizationsV2CreateInstanceResponse = zGameCenterLeaderboardLocalizationV2Response;

export const zGameCenterLeaderboardLocalizationsV2DeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardLocalizationsV2DeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardLocalizationsV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'version',
            'image'
        ]))),
        'fields[gameCenterLeaderboardImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'localization'
        ]))),
        include: z.optional(z.array(z.enum(['version', 'image'])))
    }))
});

/**
 * Single GameCenterLeaderboardLocalization
 */
export const zGameCenterLeaderboardLocalizationsV2GetInstanceResponse = zGameCenterLeaderboardLocalizationV2Response;

export const zGameCenterLeaderboardLocalizationsV2UpdateInstanceData = z.object({
    body: zGameCenterLeaderboardLocalizationV2UpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardLocalization
 */
export const zGameCenterLeaderboardLocalizationsV2UpdateInstanceResponse = zGameCenterLeaderboardLocalizationV2Response;

export const zGameCenterLeaderboardReleasesCreateInstanceData = z.object({
    body: zGameCenterLeaderboardReleaseCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardRelease
 */
export const zGameCenterLeaderboardReleasesCreateInstanceResponse = zGameCenterLeaderboardReleaseResponse;

export const zGameCenterLeaderboardReleasesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardReleasesDeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardReleasesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboard'
        ]))),
        include: z.optional(z.array(z.enum(['gameCenterDetail', 'gameCenterLeaderboard'])))
    }))
});

/**
 * Single GameCenterLeaderboardRelease
 */
export const zGameCenterLeaderboardReleasesGetInstanceResponse = zGameCenterLeaderboardReleaseResponse;

export const zGameCenterLeaderboardSetImagesCreateInstanceData = z.object({
    body: zGameCenterLeaderboardSetImageCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSetImage
 */
export const zGameCenterLeaderboardSetImagesCreateInstanceResponse = zGameCenterLeaderboardSetImageResponse;

export const zGameCenterLeaderboardSetImagesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetImagesDeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardSetImagesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSetImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'gameCenterLeaderboardSetLocalization'
        ]))),
        include: z.optional(z.array(z.enum(['gameCenterLeaderboardSetLocalization'])))
    }))
});

/**
 * Single GameCenterLeaderboardSetImage
 */
export const zGameCenterLeaderboardSetImagesGetInstanceResponse = zGameCenterLeaderboardSetImageResponse;

export const zGameCenterLeaderboardSetImagesUpdateInstanceData = z.object({
    body: zGameCenterLeaderboardSetImageUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSetImage
 */
export const zGameCenterLeaderboardSetImagesUpdateInstanceResponse = zGameCenterLeaderboardSetImageResponse;

export const zGameCenterLeaderboardSetImagesV2CreateInstanceData = z.object({
    body: zGameCenterLeaderboardSetImageV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSetImage
 */
export const zGameCenterLeaderboardSetImagesV2CreateInstanceResponse = zGameCenterLeaderboardSetImageV2Response;

export const zGameCenterLeaderboardSetImagesV2DeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetImagesV2DeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardSetImagesV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSetImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'localization'
        ]))),
        include: z.optional(z.array(z.enum(['localization'])))
    }))
});

/**
 * Single GameCenterLeaderboardSetImage
 */
export const zGameCenterLeaderboardSetImagesV2GetInstanceResponse = zGameCenterLeaderboardSetImageV2Response;

export const zGameCenterLeaderboardSetImagesV2UpdateInstanceData = z.object({
    body: zGameCenterLeaderboardSetImageV2UpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSetImage
 */
export const zGameCenterLeaderboardSetImagesV2UpdateInstanceResponse = zGameCenterLeaderboardSetImageV2Response;

export const zGameCenterLeaderboardSetLocalizationsCreateInstanceData = z.object({
    body: zGameCenterLeaderboardSetLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSetLocalization
 */
export const zGameCenterLeaderboardSetLocalizationsCreateInstanceResponse = zGameCenterLeaderboardSetLocalizationResponse;

export const zGameCenterLeaderboardSetLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetLocalizationsDeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardSetLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'gameCenterLeaderboardSet',
            'gameCenterLeaderboardSetImage'
        ]))),
        'fields[gameCenterLeaderboardSetImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'gameCenterLeaderboardSetLocalization'
        ]))),
        include: z.optional(z.array(z.enum(['gameCenterLeaderboardSet', 'gameCenterLeaderboardSetImage'])))
    }))
});

/**
 * Single GameCenterLeaderboardSetLocalization
 */
export const zGameCenterLeaderboardSetLocalizationsGetInstanceResponse = zGameCenterLeaderboardSetLocalizationResponse;

export const zGameCenterLeaderboardSetLocalizationsUpdateInstanceData = z.object({
    body: zGameCenterLeaderboardSetLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSetLocalization
 */
export const zGameCenterLeaderboardSetLocalizationsUpdateInstanceResponse = zGameCenterLeaderboardSetLocalizationResponse;

export const zGameCenterLeaderboardSetLocalizationsV2CreateInstanceData = z.object({
    body: zGameCenterLeaderboardSetLocalizationV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSetLocalization
 */
export const zGameCenterLeaderboardSetLocalizationsV2CreateInstanceResponse = zGameCenterLeaderboardSetLocalizationV2Response;

export const zGameCenterLeaderboardSetLocalizationsV2DeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetLocalizationsV2DeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardSetLocalizationsV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'version',
            'image'
        ]))),
        'fields[gameCenterLeaderboardSetImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'localization'
        ]))),
        include: z.optional(z.array(z.enum(['version', 'image'])))
    }))
});

/**
 * Single GameCenterLeaderboardSetLocalization
 */
export const zGameCenterLeaderboardSetLocalizationsV2GetInstanceResponse = zGameCenterLeaderboardSetLocalizationV2Response;

export const zGameCenterLeaderboardSetLocalizationsV2UpdateInstanceData = z.object({
    body: zGameCenterLeaderboardSetLocalizationV2UpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSetLocalization
 */
export const zGameCenterLeaderboardSetLocalizationsV2UpdateInstanceResponse = zGameCenterLeaderboardSetLocalizationV2Response;

export const zGameCenterLeaderboardSetMemberLocalizationsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        'filter[gameCenterLeaderboardSet]': z.array(z.string()),
        'filter[gameCenterLeaderboard]': z.array(z.string()),
        'fields[gameCenterLeaderboardSetMemberLocalizations]': z.optional(z.array(z.enum([
            'name',
            'locale',
            'gameCenterLeaderboardSet',
            'gameCenterLeaderboard'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['gameCenterLeaderboardSet', 'gameCenterLeaderboard'])))
    })
});

/**
 * List of GameCenterLeaderboardSetMemberLocalizations
 */
export const zGameCenterLeaderboardSetMemberLocalizationsGetCollectionResponse = zGameCenterLeaderboardSetMemberLocalizationsResponse;

export const zGameCenterLeaderboardSetMemberLocalizationsCreateInstanceData = z.object({
    body: zGameCenterLeaderboardSetMemberLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSetMemberLocalization
 */
export const zGameCenterLeaderboardSetMemberLocalizationsCreateInstanceResponse = zGameCenterLeaderboardSetMemberLocalizationResponse;

export const zGameCenterLeaderboardSetMemberLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetMemberLocalizationsDeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardSetMemberLocalizationsUpdateInstanceData = z.object({
    body: zGameCenterLeaderboardSetMemberLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSetMemberLocalization
 */
export const zGameCenterLeaderboardSetMemberLocalizationsUpdateInstanceResponse = zGameCenterLeaderboardSetMemberLocalizationResponse;

export const zGameCenterLeaderboardSetReleasesCreateInstanceData = z.object({
    body: zGameCenterLeaderboardSetReleaseCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSetRelease
 */
export const zGameCenterLeaderboardSetReleasesCreateInstanceResponse = zGameCenterLeaderboardSetReleaseResponse;

export const zGameCenterLeaderboardSetReleasesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetReleasesDeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardSetReleasesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSetReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboardSet'
        ]))),
        include: z.optional(z.array(z.enum(['gameCenterDetail', 'gameCenterLeaderboardSet'])))
    }))
});

/**
 * Single GameCenterLeaderboardSetRelease
 */
export const zGameCenterLeaderboardSetReleasesGetInstanceResponse = zGameCenterLeaderboardSetReleaseResponse;

export const zGameCenterLeaderboardSetVersionsV2CreateInstanceData = z.object({
    body: zGameCenterLeaderboardSetVersionV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSetVersion
 */
export const zGameCenterLeaderboardSetVersionsV2CreateInstanceResponse = zGameCenterLeaderboardSetVersionV2Response;

export const zGameCenterLeaderboardSetVersionsV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSetVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboardSet',
            'localizations'
        ]))),
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'version',
            'image'
        ]))),
        include: z.optional(z.array(z.enum(['leaderboardSet', 'localizations']))),
        'limit[localizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterLeaderboardSetVersion
 */
export const zGameCenterLeaderboardSetVersionsV2GetInstanceResponse = zGameCenterLeaderboardSetVersionV2Response;

export const zGameCenterLeaderboardSetsV2CreateInstanceData = z.object({
    body: zGameCenterLeaderboardSetV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSet
 */
export const zGameCenterLeaderboardSetsV2CreateInstanceResponse = zGameCenterLeaderboardSetV2Response;

export const zGameCenterLeaderboardSetsV2DeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetsV2DeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardSetsV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'versions'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboardSets',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterLeaderboardSetVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboardSet',
            'localizations'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'versions'
        ]))),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterLeaderboardSet
 */
export const zGameCenterLeaderboardSetsV2GetInstanceResponse = zGameCenterLeaderboardSetV2Response;

export const zGameCenterLeaderboardSetsV2UpdateInstanceData = z.object({
    body: zGameCenterLeaderboardSetV2UpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSet
 */
export const zGameCenterLeaderboardSetsV2UpdateInstanceResponse = zGameCenterLeaderboardSetV2Response;

export const zGameCenterLeaderboardSetsCreateInstanceData = z.object({
    body: zGameCenterLeaderboardSetCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSet
 */
export const zGameCenterLeaderboardSetsCreateInstanceResponse = zGameCenterLeaderboardSetResponse;

export const zGameCenterLeaderboardSetsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetsDeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardSetsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'gameCenterLeaderboardSet',
            'gameCenterLeaderboardSetImage'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'fields[gameCenterLeaderboardSetReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboardSet'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterLeaderboardSet
 */
export const zGameCenterLeaderboardSetsGetInstanceResponse = zGameCenterLeaderboardSetResponse;

export const zGameCenterLeaderboardSetsUpdateInstanceData = z.object({
    body: zGameCenterLeaderboardSetUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardSet
 */
export const zGameCenterLeaderboardSetsUpdateInstanceResponse = zGameCenterLeaderboardSetResponse;

export const zGameCenterLeaderboardVersionsV2CreateInstanceData = z.object({
    body: zGameCenterLeaderboardVersionV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboardVersion
 */
export const zGameCenterLeaderboardVersionsV2CreateInstanceResponse = zGameCenterLeaderboardVersionV2Response;

export const zGameCenterLeaderboardVersionsV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboard',
            'localizations'
        ]))),
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'version',
            'image'
        ]))),
        include: z.optional(z.array(z.enum(['leaderboard', 'localizations']))),
        'limit[localizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterLeaderboardVersion
 */
export const zGameCenterLeaderboardVersionsV2GetInstanceResponse = zGameCenterLeaderboardVersionV2Response;

export const zGameCenterLeaderboardsCreateInstanceData = z.object({
    body: zGameCenterLeaderboardCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboard
 */
export const zGameCenterLeaderboardsCreateInstanceResponse = zGameCenterLeaderboardResponse;

export const zGameCenterLeaderboardsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardsDeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'gameCenterLeaderboard',
            'gameCenterLeaderboardImage'
        ]))),
        'fields[gameCenterLeaderboardReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboard'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterLeaderboard
 */
export const zGameCenterLeaderboardsGetInstanceResponse = zGameCenterLeaderboardResponse;

export const zGameCenterLeaderboardsUpdateInstanceData = z.object({
    body: zGameCenterLeaderboardUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboard
 */
export const zGameCenterLeaderboardsUpdateInstanceResponse = zGameCenterLeaderboardResponse;

export const zGameCenterLeaderboardsV2CreateInstanceData = z.object({
    body: zGameCenterLeaderboardV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboard
 */
export const zGameCenterLeaderboardsV2CreateInstanceResponse = zGameCenterLeaderboardV2Response;

export const zGameCenterLeaderboardsV2DeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardsV2DeleteInstanceResponse = z.void();

export const zGameCenterLeaderboardsV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboardSets',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterLeaderboardVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboard',
            'localizations'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboardSets',
            'activity',
            'challenge',
            'versions'
        ]))),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterLeaderboard
 */
export const zGameCenterLeaderboardsV2GetInstanceResponse = zGameCenterLeaderboardV2Response;

export const zGameCenterLeaderboardsV2UpdateInstanceData = z.object({
    body: zGameCenterLeaderboardV2UpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterLeaderboard
 */
export const zGameCenterLeaderboardsV2UpdateInstanceResponse = zGameCenterLeaderboardV2Response;

export const zGameCenterMatchmakingQueuesGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'fields[gameCenterMatchmakingQueues]': z.optional(z.array(z.enum([
            'referenceName',
            'classicMatchmakingBundleIds',
            'ruleSet',
            'experimentRuleSet'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['ruleSet', 'experimentRuleSet'])))
    }))
});

/**
 * List of GameCenterMatchmakingQueues
 */
export const zGameCenterMatchmakingQueuesGetCollectionResponse = zGameCenterMatchmakingQueuesResponse;

export const zGameCenterMatchmakingQueuesCreateInstanceData = z.object({
    body: zGameCenterMatchmakingQueueCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterMatchmakingQueue
 */
export const zGameCenterMatchmakingQueuesCreateInstanceResponse = zGameCenterMatchmakingQueueResponse;

export const zGameCenterMatchmakingQueuesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterMatchmakingQueuesDeleteInstanceResponse = z.void();

export const zGameCenterMatchmakingQueuesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterMatchmakingQueues]': z.optional(z.array(z.enum([
            'referenceName',
            'classicMatchmakingBundleIds',
            'ruleSet',
            'experimentRuleSet'
        ]))),
        include: z.optional(z.array(z.enum(['ruleSet', 'experimentRuleSet'])))
    }))
});

/**
 * Single GameCenterMatchmakingQueue
 */
export const zGameCenterMatchmakingQueuesGetInstanceResponse = zGameCenterMatchmakingQueueResponse;

export const zGameCenterMatchmakingQueuesUpdateInstanceData = z.object({
    body: zGameCenterMatchmakingQueueUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterMatchmakingQueue
 */
export const zGameCenterMatchmakingQueuesUpdateInstanceResponse = zGameCenterMatchmakingQueueResponse;

export const zGameCenterMatchmakingRuleSetTestsCreateInstanceData = z.object({
    body: zGameCenterMatchmakingRuleSetTestCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterMatchmakingRuleSetTest
 */
export const zGameCenterMatchmakingRuleSetTestsCreateInstanceResponse = zGameCenterMatchmakingRuleSetTestResponse;

export const zGameCenterMatchmakingRuleSetsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'fields[gameCenterMatchmakingRuleSets]': z.optional(z.array(z.enum([
            'referenceName',
            'ruleLanguageVersion',
            'minPlayers',
            'maxPlayers',
            'teams',
            'rules',
            'matchmakingQueues'
        ]))),
        'fields[gameCenterMatchmakingTeams]': z.optional(z.array(z.enum([
            'referenceName',
            'minPlayers',
            'maxPlayers'
        ]))),
        'fields[gameCenterMatchmakingRules]': z.optional(z.array(z.enum([
            'referenceName',
            'description',
            'type',
            'expression',
            'weight'
        ]))),
        'fields[gameCenterMatchmakingQueues]': z.optional(z.array(z.enum([
            'referenceName',
            'classicMatchmakingBundleIds',
            'ruleSet',
            'experimentRuleSet'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'teams',
            'rules',
            'matchmakingQueues'
        ]))),
        'limit[matchmakingQueues]': z.optional(z.int().lte(50)),
        'limit[rules]': z.optional(z.int().lte(50)),
        'limit[teams]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterMatchmakingRuleSets
 */
export const zGameCenterMatchmakingRuleSetsGetCollectionResponse = zGameCenterMatchmakingRuleSetsResponse;

export const zGameCenterMatchmakingRuleSetsCreateInstanceData = z.object({
    body: zGameCenterMatchmakingRuleSetCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterMatchmakingRuleSet
 */
export const zGameCenterMatchmakingRuleSetsCreateInstanceResponse = zGameCenterMatchmakingRuleSetResponse;

export const zGameCenterMatchmakingRuleSetsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterMatchmakingRuleSetsDeleteInstanceResponse = z.void();

export const zGameCenterMatchmakingRuleSetsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterMatchmakingRuleSets]': z.optional(z.array(z.enum([
            'referenceName',
            'ruleLanguageVersion',
            'minPlayers',
            'maxPlayers',
            'teams',
            'rules',
            'matchmakingQueues'
        ]))),
        'fields[gameCenterMatchmakingTeams]': z.optional(z.array(z.enum([
            'referenceName',
            'minPlayers',
            'maxPlayers'
        ]))),
        'fields[gameCenterMatchmakingRules]': z.optional(z.array(z.enum([
            'referenceName',
            'description',
            'type',
            'expression',
            'weight'
        ]))),
        'fields[gameCenterMatchmakingQueues]': z.optional(z.array(z.enum([
            'referenceName',
            'classicMatchmakingBundleIds',
            'ruleSet',
            'experimentRuleSet'
        ]))),
        include: z.optional(z.array(z.enum([
            'teams',
            'rules',
            'matchmakingQueues'
        ]))),
        'limit[matchmakingQueues]': z.optional(z.int().lte(50)),
        'limit[rules]': z.optional(z.int().lte(50)),
        'limit[teams]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterMatchmakingRuleSet
 */
export const zGameCenterMatchmakingRuleSetsGetInstanceResponse = zGameCenterMatchmakingRuleSetResponse;

export const zGameCenterMatchmakingRuleSetsUpdateInstanceData = z.object({
    body: zGameCenterMatchmakingRuleSetUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterMatchmakingRuleSet
 */
export const zGameCenterMatchmakingRuleSetsUpdateInstanceResponse = zGameCenterMatchmakingRuleSetResponse;

export const zGameCenterMatchmakingRulesCreateInstanceData = z.object({
    body: zGameCenterMatchmakingRuleCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterMatchmakingRule
 */
export const zGameCenterMatchmakingRulesCreateInstanceResponse = zGameCenterMatchmakingRuleResponse;

export const zGameCenterMatchmakingRulesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterMatchmakingRulesDeleteInstanceResponse = z.void();

export const zGameCenterMatchmakingRulesUpdateInstanceData = z.object({
    body: zGameCenterMatchmakingRuleUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterMatchmakingRule
 */
export const zGameCenterMatchmakingRulesUpdateInstanceResponse = zGameCenterMatchmakingRuleResponse;

export const zGameCenterMatchmakingTeamsCreateInstanceData = z.object({
    body: zGameCenterMatchmakingTeamCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterMatchmakingTeam
 */
export const zGameCenterMatchmakingTeamsCreateInstanceResponse = zGameCenterMatchmakingTeamResponse;

export const zGameCenterMatchmakingTeamsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterMatchmakingTeamsDeleteInstanceResponse = z.void();

export const zGameCenterMatchmakingTeamsUpdateInstanceData = z.object({
    body: zGameCenterMatchmakingTeamUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single GameCenterMatchmakingTeam
 */
export const zGameCenterMatchmakingTeamsUpdateInstanceResponse = zGameCenterMatchmakingTeamResponse;

export const zGameCenterPlayerAchievementSubmissionsCreateInstanceData = z.object({
    body: zGameCenterPlayerAchievementSubmissionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single GameCenterPlayerAchievementSubmission
 */
export const zGameCenterPlayerAchievementSubmissionsCreateInstanceResponse = zGameCenterPlayerAchievementSubmissionResponse;

export const zInAppPurchaseAppStoreReviewScreenshotsCreateInstanceData = z.object({
    body: zInAppPurchaseAppStoreReviewScreenshotCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseAppStoreReviewScreenshot
 */
export const zInAppPurchaseAppStoreReviewScreenshotsCreateInstanceResponse = zInAppPurchaseAppStoreReviewScreenshotResponse;

export const zInAppPurchaseAppStoreReviewScreenshotsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zInAppPurchaseAppStoreReviewScreenshotsDeleteInstanceResponse = z.void();

export const zInAppPurchaseAppStoreReviewScreenshotsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseAppStoreReviewScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'inAppPurchaseV2'
        ]))),
        include: z.optional(z.array(z.enum(['inAppPurchaseV2'])))
    }))
});

/**
 * Single InAppPurchaseAppStoreReviewScreenshot
 */
export const zInAppPurchaseAppStoreReviewScreenshotsGetInstanceResponse = zInAppPurchaseAppStoreReviewScreenshotResponse;

export const zInAppPurchaseAppStoreReviewScreenshotsUpdateInstanceData = z.object({
    body: zInAppPurchaseAppStoreReviewScreenshotUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseAppStoreReviewScreenshot
 */
export const zInAppPurchaseAppStoreReviewScreenshotsUpdateInstanceResponse = zInAppPurchaseAppStoreReviewScreenshotResponse;

export const zInAppPurchaseAvailabilitiesCreateInstanceData = z.object({
    body: zInAppPurchaseAvailabilityCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseAvailability
 */
export const zInAppPurchaseAvailabilitiesCreateInstanceResponse = zInAppPurchaseAvailabilityResponse;

export const zInAppPurchaseAvailabilitiesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseAvailabilities]': z.optional(z.array(z.enum(['availableInNewTerritories', 'availableTerritories']))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        include: z.optional(z.array(z.enum(['availableTerritories']))),
        'limit[availableTerritories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single InAppPurchaseAvailability
 */
export const zInAppPurchaseAvailabilitiesGetInstanceResponse = zInAppPurchaseAvailabilityResponse;

export const zInAppPurchaseContentsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseContents]': z.optional(z.array(z.enum([
            'fileName',
            'fileSize',
            'url',
            'lastModifiedDate',
            'inAppPurchaseV2'
        ]))),
        include: z.optional(z.array(z.enum(['inAppPurchaseV2'])))
    }))
});

/**
 * Single InAppPurchaseContent
 */
export const zInAppPurchaseContentsGetInstanceResponse = zInAppPurchaseContentResponse;

export const zInAppPurchaseImagesCreateInstanceData = z.object({
    body: zInAppPurchaseImageCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseImage
 */
export const zInAppPurchaseImagesCreateInstanceResponse = zInAppPurchaseImageResponse;

export const zInAppPurchaseImagesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zInAppPurchaseImagesDeleteInstanceResponse = z.void();

export const zInAppPurchaseImagesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'assetToken',
            'imageAsset',
            'uploadOperations',
            'state',
            'inAppPurchase'
        ]))),
        include: z.optional(z.array(z.enum(['inAppPurchase'])))
    }))
});

/**
 * Single InAppPurchaseImage
 */
export const zInAppPurchaseImagesGetInstanceResponse = zInAppPurchaseImageResponse;

export const zInAppPurchaseImagesUpdateInstanceData = z.object({
    body: zInAppPurchaseImageUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseImage
 */
export const zInAppPurchaseImagesUpdateInstanceResponse = zInAppPurchaseImageResponse;

export const zInAppPurchaseLocalizationsCreateInstanceData = z.object({
    body: zInAppPurchaseLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseLocalization
 */
export const zInAppPurchaseLocalizationsCreateInstanceResponse = zInAppPurchaseLocalizationResponse;

export const zInAppPurchaseLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zInAppPurchaseLocalizationsDeleteInstanceResponse = z.void();

export const zInAppPurchaseLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseLocalizations]': z.optional(z.array(z.enum([
            'name',
            'locale',
            'description',
            'state',
            'inAppPurchaseV2'
        ]))),
        include: z.optional(z.array(z.enum(['inAppPurchaseV2'])))
    }))
});

/**
 * Single InAppPurchaseLocalization
 */
export const zInAppPurchaseLocalizationsGetInstanceResponse = zInAppPurchaseLocalizationResponse;

export const zInAppPurchaseLocalizationsUpdateInstanceData = z.object({
    body: zInAppPurchaseLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseLocalization
 */
export const zInAppPurchaseLocalizationsUpdateInstanceResponse = zInAppPurchaseLocalizationResponse;

export const zInAppPurchaseOfferCodeCustomCodesCreateInstanceData = z.object({
    body: zInAppPurchaseOfferCodeCustomCodeCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseOfferCodeCustomCode
 */
export const zInAppPurchaseOfferCodeCustomCodesCreateInstanceResponse = zInAppPurchaseOfferCodeCustomCodeResponse;

export const zInAppPurchaseOfferCodeCustomCodesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseOfferCodeCustomCodes]': z.optional(z.array(z.enum([
            'customCode',
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'createdByActor',
            'deactivatedByActor'
        ]))),
        include: z.optional(z.array(z.enum(['createdByActor', 'deactivatedByActor'])))
    }))
});

/**
 * Single InAppPurchaseOfferCodeCustomCode
 */
export const zInAppPurchaseOfferCodeCustomCodesGetInstanceResponse = zInAppPurchaseOfferCodeCustomCodeResponse;

export const zInAppPurchaseOfferCodeCustomCodesUpdateInstanceData = z.object({
    body: zInAppPurchaseOfferCodeCustomCodeUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseOfferCodeCustomCode
 */
export const zInAppPurchaseOfferCodeCustomCodesUpdateInstanceResponse = zInAppPurchaseOfferCodeCustomCodeResponse;

export const zInAppPurchaseOfferCodeOneTimeUseCodesCreateInstanceData = z.object({
    body: zInAppPurchaseOfferCodeOneTimeUseCodeCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseOfferCodeOneTimeUseCode
 */
export const zInAppPurchaseOfferCodeOneTimeUseCodesCreateInstanceResponse = zInAppPurchaseOfferCodeOneTimeUseCodeResponse;

export const zInAppPurchaseOfferCodeOneTimeUseCodesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseOfferCodeOneTimeUseCodes]': z.optional(z.array(z.enum([
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'environment',
            'values',
            'createdByActor',
            'deactivatedByActor'
        ]))),
        include: z.optional(z.array(z.enum(['createdByActor', 'deactivatedByActor'])))
    }))
});

/**
 * Single InAppPurchaseOfferCodeOneTimeUseCode
 */
export const zInAppPurchaseOfferCodeOneTimeUseCodesGetInstanceResponse = zInAppPurchaseOfferCodeOneTimeUseCodeResponse;

export const zInAppPurchaseOfferCodeOneTimeUseCodesUpdateInstanceData = z.object({
    body: zInAppPurchaseOfferCodeOneTimeUseCodeUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseOfferCodeOneTimeUseCode
 */
export const zInAppPurchaseOfferCodeOneTimeUseCodesUpdateInstanceResponse = zInAppPurchaseOfferCodeOneTimeUseCodeResponse;

export const zInAppPurchaseOfferCodesCreateInstanceData = z.object({
    body: zInAppPurchaseOfferCodeCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseOfferCode
 */
export const zInAppPurchaseOfferCodesCreateInstanceResponse = zInAppPurchaseOfferCodeResponse;

export const zInAppPurchaseOfferCodesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseOfferCodes]': z.optional(z.array(z.enum([
            'name',
            'customerEligibilities',
            'productionCodeCount',
            'sandboxCodeCount',
            'active',
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        'fields[inAppPurchaseOfferCodeOneTimeUseCodes]': z.optional(z.array(z.enum([
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'environment',
            'values',
            'createdByActor',
            'deactivatedByActor'
        ]))),
        'fields[inAppPurchaseOfferCodeCustomCodes]': z.optional(z.array(z.enum([
            'customCode',
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'createdByActor',
            'deactivatedByActor'
        ]))),
        'fields[inAppPurchaseOfferPrices]': z.optional(z.array(z.enum(['territory', 'pricePoint']))),
        include: z.optional(z.array(z.enum([
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        'limit[customCodes]': z.optional(z.int().lte(50)),
        'limit[oneTimeUseCodes]': z.optional(z.int().lte(50)),
        'limit[prices]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single InAppPurchaseOfferCode
 */
export const zInAppPurchaseOfferCodesGetInstanceResponse = zInAppPurchaseOfferCodeResponse;

export const zInAppPurchaseOfferCodesUpdateInstanceData = z.object({
    body: zInAppPurchaseOfferCodeUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseOfferCode
 */
export const zInAppPurchaseOfferCodesUpdateInstanceResponse = zInAppPurchaseOfferCodeResponse;

export const zInAppPurchasePriceSchedulesCreateInstanceData = z.object({
    body: zInAppPurchasePriceScheduleCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchasePriceSchedule
 */
export const zInAppPurchasePriceSchedulesCreateInstanceResponse = zInAppPurchasePriceScheduleResponse;

export const zInAppPurchasePriceSchedulesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchasePriceSchedules]': z.optional(z.array(z.enum([
            'baseTerritory',
            'manualPrices',
            'automaticPrices'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        'fields[inAppPurchasePrices]': z.optional(z.array(z.enum([
            'startDate',
            'endDate',
            'manual',
            'inAppPurchasePricePoint',
            'territory'
        ]))),
        include: z.optional(z.array(z.enum([
            'baseTerritory',
            'manualPrices',
            'automaticPrices'
        ]))),
        'limit[automaticPrices]': z.optional(z.int().lte(50)),
        'limit[manualPrices]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single InAppPurchasePriceSchedule
 */
export const zInAppPurchasePriceSchedulesGetInstanceResponse = zInAppPurchasePriceScheduleResponse;

export const zInAppPurchaseSubmissionsCreateInstanceData = z.object({
    body: zInAppPurchaseSubmissionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseSubmission
 */
export const zInAppPurchaseSubmissionsCreateInstanceResponse = zInAppPurchaseSubmissionResponse;

export const zInAppPurchasesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'referenceName',
            'productId',
            'inAppPurchaseType',
            'state',
            'apps'
        ]))),
        include: z.optional(z.array(z.enum(['apps']))),
        'limit[apps]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single InAppPurchase
 */
export const zInAppPurchasesGetInstanceResponse = zInAppPurchaseResponse;

export const zInAppPurchasesV2CreateInstanceData = z.object({
    body: zInAppPurchaseV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchase
 */
export const zInAppPurchasesV2CreateInstanceResponse = zInAppPurchaseV2Response;

export const zInAppPurchasesV2DeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zInAppPurchasesV2DeleteInstanceResponse = z.void();

export const zInAppPurchasesV2GetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'inAppPurchaseType',
            'state',
            'reviewNote',
            'familySharable',
            'contentHosting',
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        'fields[inAppPurchaseLocalizations]': z.optional(z.array(z.enum([
            'name',
            'locale',
            'description',
            'state',
            'inAppPurchaseV2'
        ]))),
        'fields[inAppPurchasePricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'territory',
            'equalizations'
        ]))),
        'fields[inAppPurchaseContents]': z.optional(z.array(z.enum([
            'fileName',
            'fileSize',
            'url',
            'lastModifiedDate',
            'inAppPurchaseV2'
        ]))),
        'fields[inAppPurchaseAppStoreReviewScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'inAppPurchaseV2'
        ]))),
        'fields[promotedPurchases]': z.optional(z.array(z.enum([
            'visibleForAllUsers',
            'enabled',
            'state',
            'inAppPurchaseV2',
            'subscription'
        ]))),
        'fields[inAppPurchasePriceSchedules]': z.optional(z.array(z.enum([
            'baseTerritory',
            'manualPrices',
            'automaticPrices'
        ]))),
        'fields[inAppPurchaseAvailabilities]': z.optional(z.array(z.enum(['availableInNewTerritories', 'availableTerritories']))),
        'fields[inAppPurchaseImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'assetToken',
            'imageAsset',
            'uploadOperations',
            'state',
            'inAppPurchase'
        ]))),
        'fields[inAppPurchaseOfferCodes]': z.optional(z.array(z.enum([
            'name',
            'customerEligibilities',
            'productionCodeCount',
            'sandboxCodeCount',
            'active',
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        include: z.optional(z.array(z.enum([
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        'limit[images]': z.optional(z.int().lte(50)),
        'limit[inAppPurchaseLocalizations]': z.optional(z.int().lte(50)),
        'limit[offerCodes]': z.optional(z.int().lte(50)),
        'limit[pricePoints]': z.optional(z.int().lte(8000))
    }))
});

/**
 * Single InAppPurchase
 */
export const zInAppPurchasesV2GetInstanceResponse = zInAppPurchaseV2Response;

export const zInAppPurchasesV2UpdateInstanceData = z.object({
    body: zInAppPurchaseV2UpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchase
 */
export const zInAppPurchasesV2UpdateInstanceResponse = zInAppPurchaseV2Response;

export const zMarketplaceSearchDetailsCreateInstanceData = z.object({
    body: zMarketplaceSearchDetailCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single MarketplaceSearchDetail
 */
export const zMarketplaceSearchDetailsCreateInstanceResponse = zMarketplaceSearchDetailResponse;

export const zMarketplaceSearchDetailsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zMarketplaceSearchDetailsDeleteInstanceResponse = z.void();

export const zMarketplaceSearchDetailsUpdateInstanceData = z.object({
    body: zMarketplaceSearchDetailUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single MarketplaceSearchDetail
 */
export const zMarketplaceSearchDetailsUpdateInstanceResponse = zMarketplaceSearchDetailResponse;

export const zMarketplaceWebhooksGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'fields[marketplaceWebhooks]': z.optional(z.array(z.enum(['endpointUrl']))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of MarketplaceWebhooks
 */
export const zMarketplaceWebhooksGetCollectionResponse = zMarketplaceWebhooksResponse;

export const zMarketplaceWebhooksCreateInstanceData = z.object({
    body: zMarketplaceWebhookCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single MarketplaceWebhook
 */
export const zMarketplaceWebhooksCreateInstanceResponse = zMarketplaceWebhookResponse;

export const zMarketplaceWebhooksDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zMarketplaceWebhooksDeleteInstanceResponse = z.void();

export const zMarketplaceWebhooksUpdateInstanceData = z.object({
    body: zMarketplaceWebhookUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single MarketplaceWebhook
 */
export const zMarketplaceWebhooksUpdateInstanceResponse = zMarketplaceWebhookResponse;

export const zMerchantIdsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[name]': z.optional(z.array(z.string())),
        'filter[identifier]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'name',
            '-name',
            'identifier',
            '-identifier'
        ]))),
        'fields[merchantIds]': z.optional(z.array(z.enum([
            'name',
            'identifier',
            'certificates'
        ]))),
        'fields[certificates]': z.optional(z.array(z.enum([
            'name',
            'certificateType',
            'displayName',
            'serialNumber',
            'platform',
            'expirationDate',
            'certificateContent',
            'activated',
            'passTypeId'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['certificates']))),
        'limit[certificates]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of MerchantIds
 */
export const zMerchantIdsGetCollectionResponse = zMerchantIdsResponse;

export const zMerchantIdsCreateInstanceData = z.object({
    body: zMerchantIdCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single MerchantId
 */
export const zMerchantIdsCreateInstanceResponse = zMerchantIdResponse;

export const zMerchantIdsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zMerchantIdsDeleteInstanceResponse = z.void();

export const zMerchantIdsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[merchantIds]': z.optional(z.array(z.enum([
            'name',
            'identifier',
            'certificates'
        ]))),
        'fields[certificates]': z.optional(z.array(z.enum([
            'name',
            'certificateType',
            'displayName',
            'serialNumber',
            'platform',
            'expirationDate',
            'certificateContent',
            'activated',
            'passTypeId'
        ]))),
        include: z.optional(z.array(z.enum(['certificates']))),
        'limit[certificates]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single MerchantId
 */
export const zMerchantIdsGetInstanceResponse = zMerchantIdResponse;

export const zMerchantIdsUpdateInstanceData = z.object({
    body: zMerchantIdUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single MerchantId
 */
export const zMerchantIdsUpdateInstanceResponse = zMerchantIdResponse;

export const zNominationsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        'filter[type]': z.optional(z.array(z.enum([
            'APP_LAUNCH',
            'APP_ENHANCEMENTS',
            'NEW_CONTENT'
        ]))),
        'filter[state]': z.array(z.enum([
            'DRAFT',
            'SUBMITTED',
            'ARCHIVED'
        ])),
        'filter[relatedApps]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'lastModifiedDate',
            '-lastModifiedDate',
            'publishStartDate',
            '-publishStartDate',
            'publishEndDate',
            '-publishEndDate',
            'name',
            '-name',
            'type',
            '-type'
        ]))),
        'fields[nominations]': z.optional(z.array(z.enum([
            'name',
            'type',
            'description',
            'createdDate',
            'lastModifiedDate',
            'submittedDate',
            'state',
            'publishStartDate',
            'publishEndDate',
            'deviceFamilies',
            'locales',
            'supplementalMaterialsUris',
            'hasInAppEvents',
            'launchInSelectMarketsFirst',
            'notes',
            'preOrderEnabled',
            'relatedApps',
            'createdByActor',
            'lastModifiedByActor',
            'submittedByActor',
            'inAppEvents',
            'supportedTerritories'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'relatedApps',
            'createdByActor',
            'lastModifiedByActor',
            'submittedByActor',
            'inAppEvents',
            'supportedTerritories'
        ]))),
        'limit[inAppEvents]': z.optional(z.int().lte(50)),
        'limit[relatedApps]': z.optional(z.int().lte(50)),
        'limit[supportedTerritories]': z.optional(z.int().lte(200))
    })
});

/**
 * List of Nominations
 */
export const zNominationsGetCollectionResponse = zNominationsResponse;

export const zNominationsCreateInstanceData = z.object({
    body: zNominationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single Nomination
 */
export const zNominationsCreateInstanceResponse = zNominationResponse;

export const zNominationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zNominationsDeleteInstanceResponse = z.void();

export const zNominationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[nominations]': z.optional(z.array(z.enum([
            'name',
            'type',
            'description',
            'createdDate',
            'lastModifiedDate',
            'submittedDate',
            'state',
            'publishStartDate',
            'publishEndDate',
            'deviceFamilies',
            'locales',
            'supplementalMaterialsUris',
            'hasInAppEvents',
            'launchInSelectMarketsFirst',
            'notes',
            'preOrderEnabled',
            'relatedApps',
            'createdByActor',
            'lastModifiedByActor',
            'submittedByActor',
            'inAppEvents',
            'supportedTerritories'
        ]))),
        include: z.optional(z.array(z.enum([
            'relatedApps',
            'createdByActor',
            'lastModifiedByActor',
            'submittedByActor',
            'inAppEvents',
            'supportedTerritories'
        ]))),
        'limit[inAppEvents]': z.optional(z.int().lte(50)),
        'limit[relatedApps]': z.optional(z.int().lte(50)),
        'limit[supportedTerritories]': z.optional(z.int().lte(200))
    }))
});

/**
 * Single Nomination
 */
export const zNominationsGetInstanceResponse = zNominationResponse;

export const zNominationsUpdateInstanceData = z.object({
    body: zNominationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single Nomination
 */
export const zNominationsUpdateInstanceResponse = zNominationResponse;

export const zPassTypeIdsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[name]': z.optional(z.array(z.string())),
        'filter[identifier]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'name',
            '-name',
            'identifier',
            '-identifier',
            'id',
            '-id'
        ]))),
        'fields[passTypeIds]': z.optional(z.array(z.enum([
            'name',
            'identifier',
            'certificates'
        ]))),
        'fields[certificates]': z.optional(z.array(z.enum([
            'name',
            'certificateType',
            'displayName',
            'serialNumber',
            'platform',
            'expirationDate',
            'certificateContent',
            'activated',
            'passTypeId'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['certificates']))),
        'limit[certificates]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of PassTypeIds
 */
export const zPassTypeIdsGetCollectionResponse = zPassTypeIdsResponse;

export const zPassTypeIdsCreateInstanceData = z.object({
    body: zPassTypeIdCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single PassTypeId
 */
export const zPassTypeIdsCreateInstanceResponse = zPassTypeIdResponse;

export const zPassTypeIdsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zPassTypeIdsDeleteInstanceResponse = z.void();

export const zPassTypeIdsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[passTypeIds]': z.optional(z.array(z.enum([
            'name',
            'identifier',
            'certificates'
        ]))),
        'fields[certificates]': z.optional(z.array(z.enum([
            'name',
            'certificateType',
            'displayName',
            'serialNumber',
            'platform',
            'expirationDate',
            'certificateContent',
            'activated',
            'passTypeId'
        ]))),
        include: z.optional(z.array(z.enum(['certificates']))),
        'limit[certificates]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single PassTypeId
 */
export const zPassTypeIdsGetInstanceResponse = zPassTypeIdResponse;

export const zPassTypeIdsUpdateInstanceData = z.object({
    body: zPassTypeIdUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single PassTypeId
 */
export const zPassTypeIdsUpdateInstanceResponse = zPassTypeIdResponse;

export const zPreReleaseVersionsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[builds.buildAudienceType]': z.optional(z.array(z.enum(['INTERNAL_ONLY', 'APP_STORE_ELIGIBLE']))),
        'filter[builds.expired]': z.optional(z.array(z.string())),
        'filter[builds.processingState]': z.optional(z.array(z.enum([
            'PROCESSING',
            'FAILED',
            'INVALID',
            'VALID'
        ]))),
        'filter[builds.version]': z.optional(z.array(z.string())),
        'filter[platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[version]': z.optional(z.array(z.string())),
        'filter[app]': z.optional(z.array(z.string())),
        'filter[builds]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum(['version', '-version']))),
        'fields[preReleaseVersions]': z.optional(z.array(z.enum([
            'version',
            'platform',
            'builds',
            'app'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['builds', 'app']))),
        'limit[builds]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of PreReleaseVersions
 */
export const zPreReleaseVersionsGetCollectionResponse = zPreReleaseVersionsResponse;

export const zPreReleaseVersionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[preReleaseVersions]': z.optional(z.array(z.enum([
            'version',
            'platform',
            'builds',
            'app'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        include: z.optional(z.array(z.enum(['builds', 'app']))),
        'limit[builds]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single PrereleaseVersion
 */
export const zPreReleaseVersionsGetInstanceResponse = zPrereleaseVersionResponse;

export const zProfilesGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[name]': z.optional(z.array(z.string())),
        'filter[profileType]': z.optional(z.array(z.enum([
            'IOS_APP_DEVELOPMENT',
            'IOS_APP_STORE',
            'IOS_APP_ADHOC',
            'IOS_APP_INHOUSE',
            'MAC_APP_DEVELOPMENT',
            'MAC_APP_STORE',
            'MAC_APP_DIRECT',
            'TVOS_APP_DEVELOPMENT',
            'TVOS_APP_STORE',
            'TVOS_APP_ADHOC',
            'TVOS_APP_INHOUSE',
            'MAC_CATALYST_APP_DEVELOPMENT',
            'MAC_CATALYST_APP_STORE',
            'MAC_CATALYST_APP_DIRECT'
        ]))),
        'filter[profileState]': z.optional(z.array(z.enum(['ACTIVE', 'INVALID']))),
        'filter[id]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'name',
            '-name',
            'profileType',
            '-profileType',
            'profileState',
            '-profileState',
            'id',
            '-id'
        ]))),
        'fields[profiles]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'profileType',
            'profileState',
            'profileContent',
            'uuid',
            'createdDate',
            'expirationDate',
            'bundleId',
            'devices',
            'certificates'
        ]))),
        'fields[bundleIds]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'identifier',
            'seedId',
            'profiles',
            'bundleIdCapabilities',
            'app'
        ]))),
        'fields[devices]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'udid',
            'deviceClass',
            'status',
            'model',
            'addedDate'
        ]))),
        'fields[certificates]': z.optional(z.array(z.enum([
            'name',
            'certificateType',
            'displayName',
            'serialNumber',
            'platform',
            'expirationDate',
            'certificateContent',
            'activated',
            'passTypeId'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'bundleId',
            'devices',
            'certificates'
        ]))),
        'limit[certificates]': z.optional(z.int().lte(50)),
        'limit[devices]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of Profiles
 */
export const zProfilesGetCollectionResponse = zProfilesResponse;

export const zProfilesCreateInstanceData = z.object({
    body: zProfileCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single Profile
 */
export const zProfilesCreateInstanceResponse = zProfileResponse;

export const zProfilesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zProfilesDeleteInstanceResponse = z.void();

export const zProfilesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[profiles]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'profileType',
            'profileState',
            'profileContent',
            'uuid',
            'createdDate',
            'expirationDate',
            'bundleId',
            'devices',
            'certificates'
        ]))),
        'fields[bundleIds]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'identifier',
            'seedId',
            'profiles',
            'bundleIdCapabilities',
            'app'
        ]))),
        'fields[devices]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'udid',
            'deviceClass',
            'status',
            'model',
            'addedDate'
        ]))),
        'fields[certificates]': z.optional(z.array(z.enum([
            'name',
            'certificateType',
            'displayName',
            'serialNumber',
            'platform',
            'expirationDate',
            'certificateContent',
            'activated',
            'passTypeId'
        ]))),
        include: z.optional(z.array(z.enum([
            'bundleId',
            'devices',
            'certificates'
        ]))),
        'limit[certificates]': z.optional(z.int().lte(50)),
        'limit[devices]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single Profile
 */
export const zProfilesGetInstanceResponse = zProfileResponse;

export const zPromotedPurchasesCreateInstanceData = z.object({
    body: zPromotedPurchaseCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single PromotedPurchase
 */
export const zPromotedPurchasesCreateInstanceResponse = zPromotedPurchaseResponse;

export const zPromotedPurchasesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zPromotedPurchasesDeleteInstanceResponse = z.void();

export const zPromotedPurchasesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[promotedPurchases]': z.optional(z.array(z.enum([
            'visibleForAllUsers',
            'enabled',
            'state',
            'inAppPurchaseV2',
            'subscription'
        ]))),
        include: z.optional(z.array(z.enum(['inAppPurchaseV2', 'subscription'])))
    }))
});

/**
 * Single PromotedPurchase
 */
export const zPromotedPurchasesGetInstanceResponse = zPromotedPurchaseResponse;

export const zPromotedPurchasesUpdateInstanceData = z.object({
    body: zPromotedPurchaseUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single PromotedPurchase
 */
export const zPromotedPurchasesUpdateInstanceResponse = zPromotedPurchaseResponse;

export const zReviewSubmissionItemsCreateInstanceData = z.object({
    body: zReviewSubmissionItemCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single ReviewSubmissionItem
 */
export const zReviewSubmissionItemsCreateInstanceResponse = zReviewSubmissionItemResponse;

export const zReviewSubmissionItemsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zReviewSubmissionItemsDeleteInstanceResponse = z.void();

export const zReviewSubmissionItemsUpdateInstanceData = z.object({
    body: zReviewSubmissionItemUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single ReviewSubmissionItem
 */
export const zReviewSubmissionItemsUpdateInstanceResponse = zReviewSubmissionItemResponse;

export const zReviewSubmissionsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        'filter[platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[state]': z.optional(z.array(z.enum([
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'UNRESOLVED_ISSUES',
            'CANCELING',
            'COMPLETING',
            'COMPLETE'
        ]))),
        'filter[app]': z.array(z.string()),
        'fields[reviewSubmissions]': z.optional(z.array(z.enum([
            'platform',
            'submittedDate',
            'state',
            'app',
            'items',
            'appStoreVersionForReview',
            'submittedByActor',
            'lastUpdatedByActor'
        ]))),
        'fields[reviewSubmissionItems]': z.optional(z.array(z.enum([
            'state',
            'appStoreVersion',
            'appCustomProductPageVersion',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appEvent',
            'backgroundAssetVersion',
            'gameCenterAchievementVersion',
            'gameCenterActivityVersion',
            'gameCenterChallengeVersion',
            'gameCenterLeaderboardSetVersion',
            'gameCenterLeaderboardVersion'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'app',
            'items',
            'appStoreVersionForReview',
            'submittedByActor',
            'lastUpdatedByActor'
        ]))),
        'limit[items]': z.optional(z.int().lte(50))
    })
});

/**
 * List of ReviewSubmissions
 */
export const zReviewSubmissionsGetCollectionResponse = zReviewSubmissionsResponse;

export const zReviewSubmissionsCreateInstanceData = z.object({
    body: zReviewSubmissionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single ReviewSubmission
 */
export const zReviewSubmissionsCreateInstanceResponse = zReviewSubmissionResponse;

export const zReviewSubmissionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[reviewSubmissions]': z.optional(z.array(z.enum([
            'platform',
            'submittedDate',
            'state',
            'app',
            'items',
            'appStoreVersionForReview',
            'submittedByActor',
            'lastUpdatedByActor'
        ]))),
        'fields[reviewSubmissionItems]': z.optional(z.array(z.enum([
            'state',
            'appStoreVersion',
            'appCustomProductPageVersion',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appEvent',
            'backgroundAssetVersion',
            'gameCenterAchievementVersion',
            'gameCenterActivityVersion',
            'gameCenterChallengeVersion',
            'gameCenterLeaderboardSetVersion',
            'gameCenterLeaderboardVersion'
        ]))),
        include: z.optional(z.array(z.enum([
            'app',
            'items',
            'appStoreVersionForReview',
            'submittedByActor',
            'lastUpdatedByActor'
        ]))),
        'limit[items]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single ReviewSubmission
 */
export const zReviewSubmissionsGetInstanceResponse = zReviewSubmissionResponse;

export const zReviewSubmissionsUpdateInstanceData = z.object({
    body: zReviewSubmissionUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single ReviewSubmission
 */
export const zReviewSubmissionsUpdateInstanceResponse = zReviewSubmissionResponse;

export const zRoutingAppCoveragesCreateInstanceData = z.object({
    body: zRoutingAppCoverageCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single RoutingAppCoverage
 */
export const zRoutingAppCoveragesCreateInstanceResponse = zRoutingAppCoverageResponse;

export const zRoutingAppCoveragesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zRoutingAppCoveragesDeleteInstanceResponse = z.void();

export const zRoutingAppCoveragesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[routingAppCoverages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState',
            'appStoreVersion'
        ]))),
        include: z.optional(z.array(z.enum(['appStoreVersion'])))
    }))
});

/**
 * Single RoutingAppCoverage
 */
export const zRoutingAppCoveragesGetInstanceResponse = zRoutingAppCoverageResponse;

export const zRoutingAppCoveragesUpdateInstanceData = z.object({
    body: zRoutingAppCoverageUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single RoutingAppCoverage
 */
export const zRoutingAppCoveragesUpdateInstanceResponse = zRoutingAppCoverageResponse;

export const zSalesReportsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        'filter[vendorNumber]': z.array(z.string()),
        'filter[reportType]': z.array(z.enum([
            'SALES',
            'PRE_ORDER',
            'NEWSSTAND',
            'SUBSCRIPTION',
            'SUBSCRIPTION_EVENT',
            'SUBSCRIBER',
            'SUBSCRIPTION_OFFER_CODE_REDEMPTION',
            'INSTALLS',
            'FIRST_ANNUAL',
            'WIN_BACK_ELIGIBILITY'
        ])),
        'filter[reportSubType]': z.array(z.enum([
            'SUMMARY',
            'DETAILED',
            'SUMMARY_INSTALL_TYPE',
            'SUMMARY_TERRITORY',
            'SUMMARY_CHANNEL'
        ])),
        'filter[frequency]': z.array(z.enum([
            'DAILY',
            'WEEKLY',
            'MONTHLY',
            'YEARLY'
        ])),
        'filter[reportDate]': z.optional(z.array(z.string())),
        'filter[version]': z.optional(z.array(z.string()))
    })
});

/**
 * List of SalesReports
 */
export const zSalesReportsGetCollectionResponse = zGzip;

export const zSandboxTestersV2GetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'fields[sandboxTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'acAccountName',
            'territory',
            'applePayCompatible',
            'interruptPurchases',
            'subscriptionRenewalRate'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of SandboxTesters
 */
export const zSandboxTestersV2GetCollectionResponse = zSandboxTestersV2Response;

export const zSandboxTestersV2UpdateInstanceData = z.object({
    body: zSandboxTesterV2UpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SandboxTester
 */
export const zSandboxTestersV2UpdateInstanceResponse = zSandboxTesterV2Response;

export const zSandboxTestersClearPurchaseHistoryRequestV2CreateInstanceData = z.object({
    body: zSandboxTestersClearPurchaseHistoryRequestV2CreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SandboxTestersClearPurchaseHistoryRequest
 */
export const zSandboxTestersClearPurchaseHistoryRequestV2CreateInstanceResponse = zSandboxTestersClearPurchaseHistoryRequestV2Response;

export const zScmGitReferencesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[scmGitReferences]': z.optional(z.array(z.enum([
            'name',
            'canonicalName',
            'isDeleted',
            'kind',
            'repository'
        ]))),
        include: z.optional(z.array(z.enum(['repository'])))
    }))
});

/**
 * Single ScmGitReference
 */
export const zScmGitReferencesGetInstanceResponse = zScmGitReferenceResponse;

export const zScmProvidersGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'fields[scmProviders]': z.optional(z.array(z.enum([
            'scmProviderType',
            'url',
            'repositories'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of ScmProviders
 */
export const zScmProvidersGetCollectionResponse = zScmProvidersResponse;

export const zScmProvidersGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[scmProviders]': z.optional(z.array(z.enum([
            'scmProviderType',
            'url',
            'repositories'
        ])))
    }))
});

/**
 * Single ScmProvider
 */
export const zScmProvidersGetInstanceResponse = zScmProviderResponse;

export const zScmPullRequestsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[scmPullRequests]': z.optional(z.array(z.enum([
            'title',
            'number',
            'webUrl',
            'sourceRepositoryOwner',
            'sourceRepositoryName',
            'sourceBranchName',
            'destinationRepositoryOwner',
            'destinationRepositoryName',
            'destinationBranchName',
            'isClosed',
            'isCrossRepository',
            'repository'
        ]))),
        include: z.optional(z.array(z.enum(['repository'])))
    }))
});

/**
 * Single ScmPullRequest
 */
export const zScmPullRequestsGetInstanceResponse = zScmPullRequestResponse;

export const zScmRepositoriesGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[id]': z.optional(z.array(z.string())),
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['scmProvider', 'defaultBranch'])))
    }))
});

/**
 * List of ScmRepositories
 */
export const zScmRepositoriesGetCollectionResponse = zScmRepositoriesResponse;

export const zScmRepositoriesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        include: z.optional(z.array(z.enum(['scmProvider', 'defaultBranch'])))
    }))
});

/**
 * Single ScmRepository
 */
export const zScmRepositoriesGetInstanceResponse = zScmRepositoryResponse;

export const zSubscriptionAppStoreReviewScreenshotsCreateInstanceData = z.object({
    body: zSubscriptionAppStoreReviewScreenshotCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionAppStoreReviewScreenshot
 */
export const zSubscriptionAppStoreReviewScreenshotsCreateInstanceResponse = zSubscriptionAppStoreReviewScreenshotResponse;

export const zSubscriptionAppStoreReviewScreenshotsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zSubscriptionAppStoreReviewScreenshotsDeleteInstanceResponse = z.void();

export const zSubscriptionAppStoreReviewScreenshotsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionAppStoreReviewScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'subscription'
        ]))),
        include: z.optional(z.array(z.enum(['subscription'])))
    }))
});

/**
 * Single SubscriptionAppStoreReviewScreenshot
 */
export const zSubscriptionAppStoreReviewScreenshotsGetInstanceResponse = zSubscriptionAppStoreReviewScreenshotResponse;

export const zSubscriptionAppStoreReviewScreenshotsUpdateInstanceData = z.object({
    body: zSubscriptionAppStoreReviewScreenshotUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionAppStoreReviewScreenshot
 */
export const zSubscriptionAppStoreReviewScreenshotsUpdateInstanceResponse = zSubscriptionAppStoreReviewScreenshotResponse;

export const zSubscriptionAvailabilitiesCreateInstanceData = z.object({
    body: zSubscriptionAvailabilityCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionAvailability
 */
export const zSubscriptionAvailabilitiesCreateInstanceResponse = zSubscriptionAvailabilityResponse;

export const zSubscriptionAvailabilitiesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionAvailabilities]': z.optional(z.array(z.enum(['availableInNewTerritories', 'availableTerritories']))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        include: z.optional(z.array(z.enum(['availableTerritories']))),
        'limit[availableTerritories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single SubscriptionAvailability
 */
export const zSubscriptionAvailabilitiesGetInstanceResponse = zSubscriptionAvailabilityResponse;

export const zSubscriptionGracePeriodsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionGracePeriods]': z.optional(z.array(z.enum([
            'optIn',
            'sandboxOptIn',
            'duration',
            'renewalType'
        ])))
    }))
});

/**
 * Single SubscriptionGracePeriod
 */
export const zSubscriptionGracePeriodsGetInstanceResponse = zSubscriptionGracePeriodResponse;

export const zSubscriptionGracePeriodsUpdateInstanceData = z.object({
    body: zSubscriptionGracePeriodUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionGracePeriod
 */
export const zSubscriptionGracePeriodsUpdateInstanceResponse = zSubscriptionGracePeriodResponse;

export const zSubscriptionGroupLocalizationsCreateInstanceData = z.object({
    body: zSubscriptionGroupLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionGroupLocalization
 */
export const zSubscriptionGroupLocalizationsCreateInstanceResponse = zSubscriptionGroupLocalizationResponse;

export const zSubscriptionGroupLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zSubscriptionGroupLocalizationsDeleteInstanceResponse = z.void();

export const zSubscriptionGroupLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionGroupLocalizations]': z.optional(z.array(z.enum([
            'name',
            'customAppName',
            'locale',
            'state',
            'subscriptionGroup'
        ]))),
        include: z.optional(z.array(z.enum(['subscriptionGroup'])))
    }))
});

/**
 * Single SubscriptionGroupLocalization
 */
export const zSubscriptionGroupLocalizationsGetInstanceResponse = zSubscriptionGroupLocalizationResponse;

export const zSubscriptionGroupLocalizationsUpdateInstanceData = z.object({
    body: zSubscriptionGroupLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionGroupLocalization
 */
export const zSubscriptionGroupLocalizationsUpdateInstanceResponse = zSubscriptionGroupLocalizationResponse;

export const zSubscriptionGroupSubmissionsCreateInstanceData = z.object({
    body: zSubscriptionGroupSubmissionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionGroupSubmission
 */
export const zSubscriptionGroupSubmissionsCreateInstanceResponse = zSubscriptionGroupSubmissionResponse;

export const zSubscriptionGroupsCreateInstanceData = z.object({
    body: zSubscriptionGroupCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionGroup
 */
export const zSubscriptionGroupsCreateInstanceResponse = zSubscriptionGroupResponse;

export const zSubscriptionGroupsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zSubscriptionGroupsDeleteInstanceResponse = z.void();

export const zSubscriptionGroupsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'subscriptions',
            'subscriptionGroupLocalizations'
        ]))),
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        'fields[subscriptionGroupLocalizations]': z.optional(z.array(z.enum([
            'name',
            'customAppName',
            'locale',
            'state',
            'subscriptionGroup'
        ]))),
        include: z.optional(z.array(z.enum(['subscriptions', 'subscriptionGroupLocalizations']))),
        'limit[subscriptionGroupLocalizations]': z.optional(z.int().lte(50)),
        'limit[subscriptions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single SubscriptionGroup
 */
export const zSubscriptionGroupsGetInstanceResponse = zSubscriptionGroupResponse;

export const zSubscriptionGroupsUpdateInstanceData = z.object({
    body: zSubscriptionGroupUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionGroup
 */
export const zSubscriptionGroupsUpdateInstanceResponse = zSubscriptionGroupResponse;

export const zSubscriptionImagesCreateInstanceData = z.object({
    body: zSubscriptionImageCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionImage
 */
export const zSubscriptionImagesCreateInstanceResponse = zSubscriptionImageResponse;

export const zSubscriptionImagesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zSubscriptionImagesDeleteInstanceResponse = z.void();

export const zSubscriptionImagesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'assetToken',
            'imageAsset',
            'uploadOperations',
            'state',
            'subscription'
        ]))),
        include: z.optional(z.array(z.enum(['subscription'])))
    }))
});

/**
 * Single SubscriptionImage
 */
export const zSubscriptionImagesGetInstanceResponse = zSubscriptionImageResponse;

export const zSubscriptionImagesUpdateInstanceData = z.object({
    body: zSubscriptionImageUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionImage
 */
export const zSubscriptionImagesUpdateInstanceResponse = zSubscriptionImageResponse;

export const zSubscriptionIntroductoryOffersCreateInstanceData = z.object({
    body: zSubscriptionIntroductoryOfferCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionIntroductoryOffer
 */
export const zSubscriptionIntroductoryOffersCreateInstanceResponse = zSubscriptionIntroductoryOfferResponse;

export const zSubscriptionIntroductoryOffersDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zSubscriptionIntroductoryOffersDeleteInstanceResponse = z.void();

export const zSubscriptionIntroductoryOffersUpdateInstanceData = z.object({
    body: zSubscriptionIntroductoryOfferUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionIntroductoryOffer
 */
export const zSubscriptionIntroductoryOffersUpdateInstanceResponse = zSubscriptionIntroductoryOfferResponse;

export const zSubscriptionLocalizationsCreateInstanceData = z.object({
    body: zSubscriptionLocalizationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionLocalization
 */
export const zSubscriptionLocalizationsCreateInstanceResponse = zSubscriptionLocalizationResponse;

export const zSubscriptionLocalizationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zSubscriptionLocalizationsDeleteInstanceResponse = z.void();

export const zSubscriptionLocalizationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionLocalizations]': z.optional(z.array(z.enum([
            'name',
            'locale',
            'description',
            'state',
            'subscription'
        ]))),
        include: z.optional(z.array(z.enum(['subscription'])))
    }))
});

/**
 * Single SubscriptionLocalization
 */
export const zSubscriptionLocalizationsGetInstanceResponse = zSubscriptionLocalizationResponse;

export const zSubscriptionLocalizationsUpdateInstanceData = z.object({
    body: zSubscriptionLocalizationUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionLocalization
 */
export const zSubscriptionLocalizationsUpdateInstanceResponse = zSubscriptionLocalizationResponse;

export const zSubscriptionOfferCodeCustomCodesCreateInstanceData = z.object({
    body: zSubscriptionOfferCodeCustomCodeCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionOfferCodeCustomCode
 */
export const zSubscriptionOfferCodeCustomCodesCreateInstanceResponse = zSubscriptionOfferCodeCustomCodeResponse;

export const zSubscriptionOfferCodeCustomCodesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionOfferCodeCustomCodes]': z.optional(z.array(z.enum([
            'customCode',
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'offerCode'
        ]))),
        include: z.optional(z.array(z.enum(['offerCode'])))
    }))
});

/**
 * Single SubscriptionOfferCodeCustomCode
 */
export const zSubscriptionOfferCodeCustomCodesGetInstanceResponse = zSubscriptionOfferCodeCustomCodeResponse;

export const zSubscriptionOfferCodeCustomCodesUpdateInstanceData = z.object({
    body: zSubscriptionOfferCodeCustomCodeUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionOfferCodeCustomCode
 */
export const zSubscriptionOfferCodeCustomCodesUpdateInstanceResponse = zSubscriptionOfferCodeCustomCodeResponse;

export const zSubscriptionOfferCodeOneTimeUseCodesCreateInstanceData = z.object({
    body: zSubscriptionOfferCodeOneTimeUseCodeCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionOfferCodeOneTimeUseCode
 */
export const zSubscriptionOfferCodeOneTimeUseCodesCreateInstanceResponse = zSubscriptionOfferCodeOneTimeUseCodeResponse;

export const zSubscriptionOfferCodeOneTimeUseCodesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionOfferCodeOneTimeUseCodes]': z.optional(z.array(z.enum([
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'environment',
            'offerCode',
            'values'
        ]))),
        include: z.optional(z.array(z.enum(['offerCode'])))
    }))
});

/**
 * Single SubscriptionOfferCodeOneTimeUseCode
 */
export const zSubscriptionOfferCodeOneTimeUseCodesGetInstanceResponse = zSubscriptionOfferCodeOneTimeUseCodeResponse;

export const zSubscriptionOfferCodeOneTimeUseCodesUpdateInstanceData = z.object({
    body: zSubscriptionOfferCodeOneTimeUseCodeUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionOfferCodeOneTimeUseCode
 */
export const zSubscriptionOfferCodeOneTimeUseCodesUpdateInstanceResponse = zSubscriptionOfferCodeOneTimeUseCodeResponse;

export const zSubscriptionOfferCodesCreateInstanceData = z.object({
    body: zSubscriptionOfferCodeCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionOfferCode
 */
export const zSubscriptionOfferCodesCreateInstanceResponse = zSubscriptionOfferCodeResponse;

export const zSubscriptionOfferCodesGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionOfferCodes]': z.optional(z.array(z.enum([
            'name',
            'customerEligibilities',
            'offerEligibility',
            'duration',
            'offerMode',
            'numberOfPeriods',
            'totalNumberOfCodes',
            'productionCodeCount',
            'sandboxCodeCount',
            'active',
            'autoRenewEnabled',
            'subscription',
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        'fields[subscriptionOfferCodeOneTimeUseCodes]': z.optional(z.array(z.enum([
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'environment',
            'offerCode',
            'values'
        ]))),
        'fields[subscriptionOfferCodeCustomCodes]': z.optional(z.array(z.enum([
            'customCode',
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'offerCode'
        ]))),
        'fields[subscriptionOfferCodePrices]': z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint']))),
        include: z.optional(z.array(z.enum([
            'subscription',
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        'limit[customCodes]': z.optional(z.int().lte(50)),
        'limit[oneTimeUseCodes]': z.optional(z.int().lte(50)),
        'limit[prices]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single SubscriptionOfferCode
 */
export const zSubscriptionOfferCodesGetInstanceResponse = zSubscriptionOfferCodeResponse;

export const zSubscriptionOfferCodesUpdateInstanceData = z.object({
    body: zSubscriptionOfferCodeUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionOfferCode
 */
export const zSubscriptionOfferCodesUpdateInstanceResponse = zSubscriptionOfferCodeResponse;

export const zSubscriptionPricePointsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'proceedsYear2',
            'territory',
            'equalizations'
        ]))),
        include: z.optional(z.array(z.enum(['territory'])))
    }))
});

/**
 * Single SubscriptionPricePoint
 */
export const zSubscriptionPricePointsGetInstanceResponse = zSubscriptionPricePointResponse;

export const zSubscriptionPricesCreateInstanceData = z.object({
    body: zSubscriptionPriceCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionPrice
 */
export const zSubscriptionPricesCreateInstanceResponse = zSubscriptionPriceResponse;

export const zSubscriptionPricesDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zSubscriptionPricesDeleteInstanceResponse = z.void();

export const zSubscriptionPromotionalOffersCreateInstanceData = z.object({
    body: zSubscriptionPromotionalOfferCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionPromotionalOffer
 */
export const zSubscriptionPromotionalOffersCreateInstanceResponse = zSubscriptionPromotionalOfferResponse;

export const zSubscriptionPromotionalOffersDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zSubscriptionPromotionalOffersDeleteInstanceResponse = z.void();

export const zSubscriptionPromotionalOffersGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionPromotionalOffers]': z.optional(z.array(z.enum([
            'duration',
            'name',
            'numberOfPeriods',
            'offerCode',
            'offerMode',
            'subscription',
            'prices'
        ]))),
        'fields[subscriptionPromotionalOfferPrices]': z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint']))),
        include: z.optional(z.array(z.enum(['subscription', 'prices']))),
        'limit[prices]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single SubscriptionPromotionalOffer
 */
export const zSubscriptionPromotionalOffersGetInstanceResponse = zSubscriptionPromotionalOfferResponse;

export const zSubscriptionPromotionalOffersUpdateInstanceData = z.object({
    body: zSubscriptionPromotionalOfferUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionPromotionalOffer
 */
export const zSubscriptionPromotionalOffersUpdateInstanceResponse = zSubscriptionPromotionalOfferResponse;

export const zSubscriptionSubmissionsCreateInstanceData = z.object({
    body: zSubscriptionSubmissionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionSubmission
 */
export const zSubscriptionSubmissionsCreateInstanceResponse = zSubscriptionSubmissionResponse;

export const zSubscriptionsCreateInstanceData = z.object({
    body: zSubscriptionCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single Subscription
 */
export const zSubscriptionsCreateInstanceResponse = zSubscriptionResponse;

export const zSubscriptionsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zSubscriptionsDeleteInstanceResponse = z.void();

export const zSubscriptionsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        'fields[subscriptionLocalizations]': z.optional(z.array(z.enum([
            'name',
            'locale',
            'description',
            'state',
            'subscription'
        ]))),
        'fields[subscriptionAppStoreReviewScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'subscription'
        ]))),
        'fields[subscriptionIntroductoryOffers]': z.optional(z.array(z.enum([
            'startDate',
            'endDate',
            'duration',
            'offerMode',
            'numberOfPeriods',
            'subscription',
            'territory',
            'subscriptionPricePoint'
        ]))),
        'fields[subscriptionPromotionalOffers]': z.optional(z.array(z.enum([
            'duration',
            'name',
            'numberOfPeriods',
            'offerCode',
            'offerMode',
            'subscription',
            'prices'
        ]))),
        'fields[subscriptionOfferCodes]': z.optional(z.array(z.enum([
            'name',
            'customerEligibilities',
            'offerEligibility',
            'duration',
            'offerMode',
            'numberOfPeriods',
            'totalNumberOfCodes',
            'productionCodeCount',
            'sandboxCodeCount',
            'active',
            'autoRenewEnabled',
            'subscription',
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        'fields[subscriptionPrices]': z.optional(z.array(z.enum([
            'startDate',
            'preserved',
            'territory',
            'subscriptionPricePoint'
        ]))),
        'fields[promotedPurchases]': z.optional(z.array(z.enum([
            'visibleForAllUsers',
            'enabled',
            'state',
            'inAppPurchaseV2',
            'subscription'
        ]))),
        'fields[subscriptionAvailabilities]': z.optional(z.array(z.enum(['availableInNewTerritories', 'availableTerritories']))),
        'fields[winBackOffers]': z.optional(z.array(z.enum([
            'referenceName',
            'offerId',
            'duration',
            'offerMode',
            'periodCount',
            'customerEligibilityPaidSubscriptionDurationInMonths',
            'customerEligibilityTimeSinceLastSubscribedInMonths',
            'customerEligibilityWaitBetweenOffersInMonths',
            'startDate',
            'endDate',
            'priority',
            'promotionIntent',
            'prices'
        ]))),
        'fields[subscriptionImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'assetToken',
            'imageAsset',
            'uploadOperations',
            'state',
            'subscription'
        ]))),
        include: z.optional(z.array(z.enum([
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        'limit[images]': z.optional(z.int().lte(50)),
        'limit[introductoryOffers]': z.optional(z.int().lte(50)),
        'limit[offerCodes]': z.optional(z.int().lte(50)),
        'limit[prices]': z.optional(z.int().lte(50)),
        'limit[promotionalOffers]': z.optional(z.int().lte(50)),
        'limit[subscriptionLocalizations]': z.optional(z.int().lte(50)),
        'limit[winBackOffers]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single Subscription
 */
export const zSubscriptionsGetInstanceResponse = zSubscriptionResponse;

export const zSubscriptionsUpdateInstanceData = z.object({
    body: zSubscriptionUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single Subscription
 */
export const zSubscriptionsUpdateInstanceResponse = zSubscriptionResponse;

export const zTerritoriesGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Territories
 */
export const zTerritoriesGetCollectionResponse = zTerritoriesResponse;

export const zTerritoryAvailabilitiesUpdateInstanceData = z.object({
    body: zTerritoryAvailabilityUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single TerritoryAvailability
 */
export const zTerritoryAvailabilitiesUpdateInstanceResponse = zTerritoryAvailabilityResponse;

export const zUserInvitationsGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[email]': z.optional(z.array(z.string())),
        'filter[roles]': z.optional(z.array(z.enum([
            'ADMIN',
            'FINANCE',
            'ACCOUNT_HOLDER',
            'SALES',
            'MARKETING',
            'APP_MANAGER',
            'DEVELOPER',
            'ACCESS_TO_REPORTS',
            'CUSTOMER_SUPPORT',
            'CREATE_APPS',
            'CLOUD_MANAGED_DEVELOPER_ID',
            'CLOUD_MANAGED_APP_DISTRIBUTION',
            'GENERATE_INDIVIDUAL_KEYS'
        ]))),
        'filter[visibleApps]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'email',
            '-email',
            'lastName',
            '-lastName'
        ]))),
        'fields[userInvitations]': z.optional(z.array(z.enum([
            'email',
            'firstName',
            'lastName',
            'expirationDate',
            'roles',
            'allAppsVisible',
            'provisioningAllowed',
            'visibleApps'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['visibleApps']))),
        'limit[visibleApps]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of UserInvitations
 */
export const zUserInvitationsGetCollectionResponse = zUserInvitationsResponse;

export const zUserInvitationsCreateInstanceData = z.object({
    body: zUserInvitationCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single UserInvitation
 */
export const zUserInvitationsCreateInstanceResponse = zUserInvitationResponse;

export const zUserInvitationsDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zUserInvitationsDeleteInstanceResponse = z.void();

export const zUserInvitationsGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[userInvitations]': z.optional(z.array(z.enum([
            'email',
            'firstName',
            'lastName',
            'expirationDate',
            'roles',
            'allAppsVisible',
            'provisioningAllowed',
            'visibleApps'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        include: z.optional(z.array(z.enum(['visibleApps']))),
        'limit[visibleApps]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single UserInvitation
 */
export const zUserInvitationsGetInstanceResponse = zUserInvitationResponse;

export const zUsersGetCollectionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        'filter[username]': z.optional(z.array(z.string())),
        'filter[roles]': z.optional(z.array(z.enum([
            'ADMIN',
            'FINANCE',
            'ACCOUNT_HOLDER',
            'SALES',
            'MARKETING',
            'APP_MANAGER',
            'DEVELOPER',
            'ACCESS_TO_REPORTS',
            'CUSTOMER_SUPPORT',
            'CREATE_APPS',
            'CLOUD_MANAGED_DEVELOPER_ID',
            'CLOUD_MANAGED_APP_DISTRIBUTION',
            'GENERATE_INDIVIDUAL_KEYS'
        ]))),
        'filter[visibleApps]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'username',
            '-username',
            'lastName',
            '-lastName'
        ]))),
        'fields[users]': z.optional(z.array(z.enum([
            'username',
            'firstName',
            'lastName',
            'roles',
            'allAppsVisible',
            'provisioningAllowed',
            'visibleApps'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['visibleApps']))),
        'limit[visibleApps]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of Users
 */
export const zUsersGetCollectionResponse = zUsersResponse;

export const zUsersDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zUsersDeleteInstanceResponse = z.void();

export const zUsersGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[users]': z.optional(z.array(z.enum([
            'username',
            'firstName',
            'lastName',
            'roles',
            'allAppsVisible',
            'provisioningAllowed',
            'visibleApps'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        include: z.optional(z.array(z.enum(['visibleApps']))),
        'limit[visibleApps]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single User
 */
export const zUsersGetInstanceResponse = zUserResponse;

export const zUsersUpdateInstanceData = z.object({
    body: zUserUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single User
 */
export const zUsersUpdateInstanceResponse = zUserResponse;

export const zWebhookDeliveriesCreateInstanceData = z.object({
    body: zWebhookDeliveryCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single WebhookDelivery
 */
export const zWebhookDeliveriesCreateInstanceResponse = zWebhookDeliveryResponse;

export const zWebhookPingsCreateInstanceData = z.object({
    body: zWebhookPingCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single WebhookPing
 */
export const zWebhookPingsCreateInstanceResponse = zWebhookPingResponse;

export const zWebhooksCreateInstanceData = z.object({
    body: zWebhookCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single Webhook
 */
export const zWebhooksCreateInstanceResponse = zWebhookResponse;

export const zWebhooksDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zWebhooksDeleteInstanceResponse = z.void();

export const zWebhooksGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[webhooks]': z.optional(z.array(z.enum([
            'enabled',
            'eventTypes',
            'name',
            'url',
            'app',
            'deliveries'
        ]))),
        include: z.optional(z.array(z.enum(['app'])))
    }))
});

/**
 * Single Webhook
 */
export const zWebhooksGetInstanceResponse = zWebhookResponse;

export const zWebhooksUpdateInstanceData = z.object({
    body: zWebhookUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single Webhook
 */
export const zWebhooksUpdateInstanceResponse = zWebhookResponse;

export const zWinBackOffersCreateInstanceData = z.object({
    body: zWinBackOfferCreateRequest,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Single WinBackOffer
 */
export const zWinBackOffersCreateInstanceResponse = zWinBackOfferResponse;

export const zWinBackOffersDeleteInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zWinBackOffersDeleteInstanceResponse = z.void();

export const zWinBackOffersGetInstanceData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[winBackOffers]': z.optional(z.array(z.enum([
            'referenceName',
            'offerId',
            'duration',
            'offerMode',
            'periodCount',
            'customerEligibilityPaidSubscriptionDurationInMonths',
            'customerEligibilityTimeSinceLastSubscribedInMonths',
            'customerEligibilityWaitBetweenOffersInMonths',
            'startDate',
            'endDate',
            'priority',
            'promotionIntent',
            'prices'
        ]))),
        'fields[winBackOfferPrices]': z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint']))),
        include: z.optional(z.array(z.enum(['prices']))),
        'limit[prices]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single WinBackOffer
 */
export const zWinBackOffersGetInstanceResponse = zWinBackOfferResponse;

export const zWinBackOffersUpdateInstanceData = z.object({
    body: zWinBackOfferUpdateRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single WinBackOffer
 */
export const zWinBackOffersUpdateInstanceResponse = zWinBackOfferResponse;

export const zAlternativeDistributionPackageVersionsDeltasGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAlternativeDistributionPackageVersionsDeltasGetToManyRelationshipResponse = zAlternativeDistributionPackageVersionDeltasLinkagesResponse;

export const zAlternativeDistributionPackageVersionsDeltasGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[alternativeDistributionPackageDeltas]': z.optional(z.array(z.enum([
            'url',
            'urlExpirationDate',
            'alternativeDistributionKeyBlob',
            'fileChecksum'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AlternativeDistributionPackageDeltas
 */
export const zAlternativeDistributionPackageVersionsDeltasGetToManyRelatedResponse = zAlternativeDistributionPackageDeltasResponse;

export const zAlternativeDistributionPackageVersionsVariantsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAlternativeDistributionPackageVersionsVariantsGetToManyRelationshipResponse = zAlternativeDistributionPackageVersionVariantsLinkagesResponse;

export const zAlternativeDistributionPackageVersionsVariantsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[alternativeDistributionPackageVariants]': z.optional(z.array(z.enum([
            'url',
            'urlExpirationDate',
            'alternativeDistributionKeyBlob',
            'fileChecksum'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AlternativeDistributionPackageVariants
 */
export const zAlternativeDistributionPackageVersionsVariantsGetToManyRelatedResponse = zAlternativeDistributionPackageVariantsResponse;

export const zAlternativeDistributionPackagesVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAlternativeDistributionPackagesVersionsGetToManyRelationshipResponse = zAlternativeDistributionPackageVersionsLinkagesResponse;

export const zAlternativeDistributionPackagesVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[state]': z.optional(z.array(z.enum(['COMPLETED', 'REPLACED']))),
        'fields[alternativeDistributionPackageVersions]': z.optional(z.array(z.enum([
            'url',
            'urlExpirationDate',
            'version',
            'fileChecksum',
            'state',
            'variants',
            'deltas',
            'alternativeDistributionPackage'
        ]))),
        'fields[alternativeDistributionPackageVariants]': z.optional(z.array(z.enum([
            'url',
            'urlExpirationDate',
            'alternativeDistributionKeyBlob',
            'fileChecksum'
        ]))),
        'fields[alternativeDistributionPackageDeltas]': z.optional(z.array(z.enum([
            'url',
            'urlExpirationDate',
            'alternativeDistributionKeyBlob',
            'fileChecksum'
        ]))),
        'fields[alternativeDistributionPackages]': z.optional(z.array(z.enum(['sourceFileChecksum', 'versions']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'variants',
            'deltas',
            'alternativeDistributionPackage'
        ]))),
        'limit[variants]': z.optional(z.int().lte(50)),
        'limit[deltas]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AlternativeDistributionPackageVersions
 */
export const zAlternativeDistributionPackagesVersionsGetToManyRelatedResponse = zAlternativeDistributionPackageVersionsResponse;

export const zAnalyticsReportInstancesSegmentsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAnalyticsReportInstancesSegmentsGetToManyRelationshipResponse = zAnalyticsReportInstanceSegmentsLinkagesResponse;

export const zAnalyticsReportInstancesSegmentsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[analyticsReportSegments]': z.optional(z.array(z.enum([
            'checksum',
            'sizeInBytes',
            'url'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AnalyticsReportSegments
 */
export const zAnalyticsReportInstancesSegmentsGetToManyRelatedResponse = zAnalyticsReportSegmentsResponse;

export const zAnalyticsReportRequestsReportsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAnalyticsReportRequestsReportsGetToManyRelationshipResponse = zAnalyticsReportRequestReportsLinkagesResponse;

export const zAnalyticsReportRequestsReportsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[name]': z.optional(z.array(z.string())),
        'filter[category]': z.optional(z.array(z.enum([
            'APP_USAGE',
            'APP_STORE_ENGAGEMENT',
            'COMMERCE',
            'FRAMEWORK_USAGE',
            'PERFORMANCE'
        ]))),
        'fields[analyticsReports]': z.optional(z.array(z.enum([
            'name',
            'category',
            'instances'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AnalyticsReports
 */
export const zAnalyticsReportRequestsReportsGetToManyRelatedResponse = zAnalyticsReportsResponse;

export const zAnalyticsReportsInstancesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAnalyticsReportsInstancesGetToManyRelationshipResponse = zAnalyticsReportInstancesLinkagesResponse;

export const zAnalyticsReportsInstancesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[granularity]': z.optional(z.array(z.enum([
            'DAILY',
            'WEEKLY',
            'MONTHLY'
        ]))),
        'filter[processingDate]': z.optional(z.array(z.string())),
        'fields[analyticsReportInstances]': z.optional(z.array(z.enum([
            'granularity',
            'processingDate',
            'segments'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AnalyticsReportInstances
 */
export const zAnalyticsReportsInstancesGetToManyRelatedResponse = zAnalyticsReportInstancesResponse;

export const zAppAvailabilitiesV2TerritoryAvailabilitiesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppAvailabilitiesV2TerritoryAvailabilitiesGetToManyRelationshipResponse = zAppAvailabilityV2TerritoryAvailabilitiesLinkagesResponse;

export const zAppAvailabilitiesV2TerritoryAvailabilitiesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[territoryAvailabilities]': z.optional(z.array(z.enum([
            'available',
            'releaseDate',
            'preOrderEnabled',
            'preOrderPublishDate',
            'contentStatuses',
            'territory'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['territory'])))
    }))
});

/**
 * List of TerritoryAvailabilities
 */
export const zAppAvailabilitiesV2TerritoryAvailabilitiesGetToManyRelatedResponse = zTerritoryAvailabilitiesResponse;

export const zAppCategoriesParentGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppCategoriesParentGetToOneRelationshipResponse = zAppCategoryParentLinkageResponse;

export const zAppCategoriesParentGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appCategories]': z.optional(z.array(z.enum([
            'platforms',
            'subcategories',
            'parent'
        ])))
    }))
});

/**
 * Single AppCategory with get
 */
export const zAppCategoriesParentGetToOneRelatedResponse = zAppCategoryWithoutIncludesResponse;

export const zAppCategoriesSubcategoriesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppCategoriesSubcategoriesGetToManyRelationshipResponse = zAppCategorySubcategoriesLinkagesResponse;

export const zAppCategoriesSubcategoriesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appCategories]': z.optional(z.array(z.enum([
            'platforms',
            'subcategories',
            'parent'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AppCategories with get
 */
export const zAppCategoriesSubcategoriesGetToManyRelatedResponse = zAppCategoriesWithoutIncludesResponse;

export const zAppClipDefaultExperienceLocalizationsAppClipHeaderImageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppClipDefaultExperienceLocalizationsAppClipHeaderImageGetToOneRelationshipResponse = zAppClipDefaultExperienceLocalizationAppClipHeaderImageLinkageResponse;

export const zAppClipDefaultExperienceLocalizationsAppClipHeaderImageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appClipHeaderImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'appClipDefaultExperienceLocalization'
        ]))),
        'fields[appClipDefaultExperienceLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'subtitle',
            'appClipDefaultExperience',
            'appClipHeaderImage'
        ]))),
        include: z.optional(z.array(z.enum(['appClipDefaultExperienceLocalization'])))
    }))
});

/**
 * Single AppClipHeaderImage
 */
export const zAppClipDefaultExperienceLocalizationsAppClipHeaderImageGetToOneRelatedResponse = zAppClipHeaderImageResponse;

export const zAppClipDefaultExperiencesAppClipAppStoreReviewDetailGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppClipDefaultExperiencesAppClipAppStoreReviewDetailGetToOneRelationshipResponse = zAppClipDefaultExperienceAppClipAppStoreReviewDetailLinkageResponse;

export const zAppClipDefaultExperiencesAppClipAppStoreReviewDetailGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appClipAppStoreReviewDetails]': z.optional(z.array(z.enum(['invocationUrls', 'appClipDefaultExperience']))),
        'fields[appClipDefaultExperiences]': z.optional(z.array(z.enum([
            'action',
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        include: z.optional(z.array(z.enum(['appClipDefaultExperience'])))
    }))
});

/**
 * Single AppClipAppStoreReviewDetail
 */
export const zAppClipDefaultExperiencesAppClipAppStoreReviewDetailGetToOneRelatedResponse = zAppClipAppStoreReviewDetailResponse;

export const zAppClipDefaultExperiencesAppClipDefaultExperienceLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppClipDefaultExperiencesAppClipDefaultExperienceLocalizationsGetToManyRelationshipResponse = zAppClipDefaultExperienceAppClipDefaultExperienceLocalizationsLinkagesResponse;

export const zAppClipDefaultExperiencesAppClipDefaultExperienceLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[locale]': z.optional(z.array(z.string())),
        'fields[appClipDefaultExperienceLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'subtitle',
            'appClipDefaultExperience',
            'appClipHeaderImage'
        ]))),
        'fields[appClipDefaultExperiences]': z.optional(z.array(z.enum([
            'action',
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        'fields[appClipHeaderImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'appClipDefaultExperienceLocalization'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['appClipDefaultExperience', 'appClipHeaderImage'])))
    }))
});

/**
 * List of AppClipDefaultExperienceLocalizations
 */
export const zAppClipDefaultExperiencesAppClipDefaultExperienceLocalizationsGetToManyRelatedResponse = zAppClipDefaultExperienceLocalizationsResponse;

export const zAppClipDefaultExperiencesReleaseWithAppStoreVersionGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppClipDefaultExperiencesReleaseWithAppStoreVersionGetToOneRelationshipResponse = zAppClipDefaultExperienceReleaseWithAppStoreVersionLinkageResponse;

export const zAppClipDefaultExperiencesReleaseWithAppStoreVersionUpdateToOneRelationshipData = z.object({
    body: zAppClipDefaultExperienceReleaseWithAppStoreVersionLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppClipDefaultExperiencesReleaseWithAppStoreVersionUpdateToOneRelationshipResponse = z.void();

export const zAppClipDefaultExperiencesReleaseWithAppStoreVersionGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[ageRatingDeclarations]': z.optional(z.array(z.enum([
            'advertising',
            'alcoholTobaccoOrDrugUseOrReferences',
            'contests',
            'gambling',
            'gamblingSimulated',
            'gunsOrOtherWeapons',
            'healthOrWellnessTopics',
            'kidsAgeBand',
            'lootBox',
            'medicalOrTreatmentInformation',
            'messagingAndChat',
            'parentalControls',
            'profanityOrCrudeHumor',
            'ageAssurance',
            'sexualContentGraphicAndNudity',
            'sexualContentOrNudity',
            'horrorOrFearThemes',
            'matureOrSuggestiveThemes',
            'unrestrictedWebAccess',
            'userGeneratedContent',
            'violenceCartoonOrFantasy',
            'violenceRealisticProlongedGraphicOrSadistic',
            'violenceRealistic',
            'ageRatingOverride',
            'ageRatingOverrideV2',
            'koreaAgeRatingOverride',
            'developerAgeRatingInfoUrl'
        ]))),
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[appStoreVersionPhasedReleases]': z.optional(z.array(z.enum([
            'phasedReleaseState',
            'startDate',
            'totalPauseDuration',
            'currentDayNumber'
        ]))),
        'fields[gameCenterAppVersions]': z.optional(z.array(z.enum([
            'enabled',
            'compatibilityVersions',
            'appStoreVersion'
        ]))),
        'fields[routingAppCoverages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState',
            'appStoreVersion'
        ]))),
        'fields[appStoreReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'appStoreVersion',
            'appStoreReviewAttachments'
        ]))),
        'fields[appStoreVersionSubmissions]': z.optional(z.array(z.enum(['appStoreVersion']))),
        'fields[appClipDefaultExperiences]': z.optional(z.array(z.enum([
            'action',
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'appStoreVersion',
            'appStoreVersionExperimentTreatments',
            'platform',
            'app',
            'latestControlVersion',
            'controlVersions'
        ]))),
        'fields[alternativeDistributionPackages]': z.optional(z.array(z.enum(['sourceFileChecksum', 'versions']))),
        include: z.optional(z.array(z.enum([
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionPackage'
        ]))),
        'limit[appStoreVersionLocalizations]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperiments]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperimentsV2]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppStoreVersion
 */
export const zAppClipDefaultExperiencesReleaseWithAppStoreVersionGetToOneRelatedResponse = zAppStoreVersionResponse;

export const zAppClipsAppClipAdvancedExperiencesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppClipsAppClipAdvancedExperiencesGetToManyRelationshipResponse = zAppClipAppClipAdvancedExperiencesLinkagesResponse;

export const zAppClipsAppClipAdvancedExperiencesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[status]': z.optional(z.array(z.enum([
            'RECEIVED',
            'DEACTIVATED',
            'APP_TRANSFER_IN_PROGRESS'
        ]))),
        'filter[placeStatus]': z.optional(z.array(z.enum([
            'PENDING',
            'MATCHED',
            'NO_MATCH'
        ]))),
        'filter[action]': z.optional(z.array(z.enum([
            'OPEN',
            'VIEW',
            'PLAY'
        ]))),
        'fields[appClipAdvancedExperiences]': z.optional(z.array(z.enum([
            'link',
            'version',
            'status',
            'action',
            'isPoweredBy',
            'place',
            'placeStatus',
            'businessCategory',
            'defaultLanguage',
            'appClip',
            'headerImage',
            'localizations'
        ]))),
        'fields[appClips]': z.optional(z.array(z.enum([
            'bundleId',
            'app',
            'appClipDefaultExperiences',
            'appClipAdvancedExperiences'
        ]))),
        'fields[appClipAdvancedExperienceImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ]))),
        'fields[appClipAdvancedExperienceLocalizations]': z.optional(z.array(z.enum([
            'language',
            'title',
            'subtitle'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appClip',
            'headerImage',
            'localizations'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppClipAdvancedExperiences
 */
export const zAppClipsAppClipAdvancedExperiencesGetToManyRelatedResponse = zAppClipAdvancedExperiencesResponse;

export const zAppClipsAppClipDefaultExperiencesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppClipsAppClipDefaultExperiencesGetToManyRelationshipResponse = zAppClipAppClipDefaultExperiencesLinkagesResponse;

export const zAppClipsAppClipDefaultExperiencesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'exists[releaseWithAppStoreVersion]': z.optional(z.boolean()),
        'fields[appClipDefaultExperiences]': z.optional(z.array(z.enum([
            'action',
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        'fields[appClips]': z.optional(z.array(z.enum([
            'bundleId',
            'app',
            'appClipDefaultExperiences',
            'appClipAdvancedExperiences'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[appClipDefaultExperienceLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'subtitle',
            'appClipDefaultExperience',
            'appClipHeaderImage'
        ]))),
        'fields[appClipAppStoreReviewDetails]': z.optional(z.array(z.enum(['invocationUrls', 'appClipDefaultExperience']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        'limit[appClipDefaultExperienceLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppClipDefaultExperiences
 */
export const zAppClipsAppClipDefaultExperiencesGetToManyRelatedResponse = zAppClipDefaultExperiencesResponse;

export const zAppCustomProductPageLocalizationsAppPreviewSetsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppCustomProductPageLocalizationsAppPreviewSetsGetToManyRelationshipResponse = zAppCustomProductPageLocalizationAppPreviewSetsLinkagesResponse;

export const zAppCustomProductPageLocalizationsAppPreviewSetsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[previewType]': z.optional(z.array(z.enum([
            'IPHONE_67',
            'IPHONE_61',
            'IPHONE_65',
            'IPHONE_58',
            'IPHONE_55',
            'IPHONE_47',
            'IPHONE_40',
            'IPHONE_35',
            'IPAD_PRO_3GEN_129',
            'IPAD_PRO_3GEN_11',
            'IPAD_PRO_129',
            'IPAD_105',
            'IPAD_97',
            'DESKTOP',
            'APPLE_TV',
            'APPLE_VISION_PRO'
        ]))),
        'filter[appStoreVersionLocalization]': z.optional(z.array(z.string())),
        'filter[appStoreVersionExperimentTreatmentLocalization]': z.optional(z.array(z.string())),
        'fields[appPreviewSets]': z.optional(z.array(z.enum([
            'previewType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appCustomProductPageLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'promotionalText',
            'appCustomProductPageVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        'fields[appPreviews]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'previewFrameTimeCode',
            'mimeType',
            'videoUrl',
            'previewFrameImage',
            'previewImage',
            'uploadOperations',
            'assetDeliveryState',
            'videoDeliveryState',
            'appPreviewSet'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        'limit[appPreviews]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppPreviewSets
 */
export const zAppCustomProductPageLocalizationsAppPreviewSetsGetToManyRelatedResponse = zAppPreviewSetsResponse;

export const zAppCustomProductPageLocalizationsAppScreenshotSetsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppCustomProductPageLocalizationsAppScreenshotSetsGetToManyRelationshipResponse = zAppCustomProductPageLocalizationAppScreenshotSetsLinkagesResponse;

export const zAppCustomProductPageLocalizationsAppScreenshotSetsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[screenshotDisplayType]': z.optional(z.array(z.enum([
            'APP_IPHONE_67',
            'APP_IPHONE_61',
            'APP_IPHONE_65',
            'APP_IPHONE_58',
            'APP_IPHONE_55',
            'APP_IPHONE_47',
            'APP_IPHONE_40',
            'APP_IPHONE_35',
            'APP_IPAD_PRO_3GEN_129',
            'APP_IPAD_PRO_3GEN_11',
            'APP_IPAD_PRO_129',
            'APP_IPAD_105',
            'APP_IPAD_97',
            'APP_DESKTOP',
            'APP_WATCH_ULTRA',
            'APP_WATCH_SERIES_10',
            'APP_WATCH_SERIES_7',
            'APP_WATCH_SERIES_4',
            'APP_WATCH_SERIES_3',
            'APP_APPLE_TV',
            'APP_APPLE_VISION_PRO',
            'IMESSAGE_APP_IPHONE_67',
            'IMESSAGE_APP_IPHONE_61',
            'IMESSAGE_APP_IPHONE_65',
            'IMESSAGE_APP_IPHONE_58',
            'IMESSAGE_APP_IPHONE_55',
            'IMESSAGE_APP_IPHONE_47',
            'IMESSAGE_APP_IPHONE_40',
            'IMESSAGE_APP_IPAD_PRO_3GEN_129',
            'IMESSAGE_APP_IPAD_PRO_3GEN_11',
            'IMESSAGE_APP_IPAD_PRO_129',
            'IMESSAGE_APP_IPAD_105',
            'IMESSAGE_APP_IPAD_97'
        ]))),
        'filter[appStoreVersionLocalization]': z.optional(z.array(z.string())),
        'filter[appStoreVersionExperimentTreatmentLocalization]': z.optional(z.array(z.string())),
        'fields[appScreenshotSets]': z.optional(z.array(z.enum([
            'screenshotDisplayType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appCustomProductPageLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'promotionalText',
            'appCustomProductPageVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        'fields[appScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'appScreenshotSet'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'limit[appScreenshots]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppScreenshotSets
 */
export const zAppCustomProductPageLocalizationsAppScreenshotSetsGetToManyRelatedResponse = zAppScreenshotSetsResponse;

export const zAppCustomProductPageLocalizationsSearchKeywordsDeleteToManyRelationshipData = z.object({
    body: zAppCustomProductPageLocalizationSearchKeywordsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppCustomProductPageLocalizationsSearchKeywordsDeleteToManyRelationshipResponse = z.void();

export const zAppCustomProductPageLocalizationsSearchKeywordsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppCustomProductPageLocalizationsSearchKeywordsGetToManyRelationshipResponse = zAppCustomProductPageLocalizationSearchKeywordsLinkagesResponse;

export const zAppCustomProductPageLocalizationsSearchKeywordsCreateToManyRelationshipData = z.object({
    body: zAppCustomProductPageLocalizationSearchKeywordsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppCustomProductPageLocalizationsSearchKeywordsCreateToManyRelationshipResponse = z.void();

export const zAppCustomProductPageLocalizationsSearchKeywordsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[platform]': z.optional(z.array(z.string())),
        'filter[locale]': z.optional(z.array(z.string())),
        'fields[appKeywords]': z.optional(z.array(z.unknown())),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AppKeywords
 */
export const zAppCustomProductPageLocalizationsSearchKeywordsGetToManyRelatedResponse = zAppKeywordsResponse;

export const zAppCustomProductPageVersionsAppCustomProductPageLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppCustomProductPageVersionsAppCustomProductPageLocalizationsGetToManyRelationshipResponse = zAppCustomProductPageVersionAppCustomProductPageLocalizationsLinkagesResponse;

export const zAppCustomProductPageVersionsAppCustomProductPageLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[locale]': z.optional(z.array(z.string())),
        'fields[appCustomProductPageLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'promotionalText',
            'appCustomProductPageVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appCustomProductPageVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'deepLink',
            'appCustomProductPage',
            'appCustomProductPageLocalizations'
        ]))),
        'fields[appScreenshotSets]': z.optional(z.array(z.enum([
            'screenshotDisplayType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'fields[appPreviewSets]': z.optional(z.array(z.enum([
            'previewType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        'fields[appKeywords]': z.optional(z.array(z.unknown())),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appCustomProductPageVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'limit[appScreenshotSets]': z.optional(z.int().lte(50)),
        'limit[appPreviewSets]': z.optional(z.int().lte(50)),
        'limit[searchKeywords]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppCustomProductPageLocalizations
 */
export const zAppCustomProductPageVersionsAppCustomProductPageLocalizationsGetToManyRelatedResponse = zAppCustomProductPageLocalizationsResponse;

export const zAppCustomProductPagesAppCustomProductPageVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppCustomProductPagesAppCustomProductPageVersionsGetToManyRelationshipResponse = zAppCustomProductPageAppCustomProductPageVersionsLinkagesResponse;

export const zAppCustomProductPagesAppCustomProductPageVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[state]': z.optional(z.array(z.enum([
            'PREPARE_FOR_SUBMISSION',
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'ACCEPTED',
            'APPROVED',
            'REPLACED_WITH_NEW_VERSION',
            'REJECTED'
        ]))),
        'fields[appCustomProductPageVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'deepLink',
            'appCustomProductPage',
            'appCustomProductPageLocalizations'
        ]))),
        'fields[appCustomProductPages]': z.optional(z.array(z.enum([
            'name',
            'url',
            'visible',
            'app',
            'appCustomProductPageVersions'
        ]))),
        'fields[appCustomProductPageLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'promotionalText',
            'appCustomProductPageVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['appCustomProductPage', 'appCustomProductPageLocalizations']))),
        'limit[appCustomProductPageLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppCustomProductPageVersions
 */
export const zAppCustomProductPagesAppCustomProductPageVersionsGetToManyRelatedResponse = zAppCustomProductPageVersionsResponse;

export const zAppEncryptionDeclarationsAppGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppEncryptionDeclarationsAppGetToOneRelationshipResponse = zAppEncryptionDeclarationAppLinkageResponse;

export const zAppEncryptionDeclarationsAppGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ])))
    }))
});

/**
 * Single App with get
 */
export const zAppEncryptionDeclarationsAppGetToOneRelatedResponse = zAppWithoutIncludesResponse;

export const zAppEncryptionDeclarationsAppEncryptionDeclarationDocumentGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppEncryptionDeclarationsAppEncryptionDeclarationDocumentGetToOneRelationshipResponse = zAppEncryptionDeclarationAppEncryptionDeclarationDocumentLinkageResponse;

export const zAppEncryptionDeclarationsAppEncryptionDeclarationDocumentGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appEncryptionDeclarationDocuments]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'assetToken',
            'downloadUrl',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState'
        ])))
    }))
});

/**
 * Single AppEncryptionDeclarationDocument
 */
export const zAppEncryptionDeclarationsAppEncryptionDeclarationDocumentGetToOneRelatedResponse = zAppEncryptionDeclarationDocumentResponse;

export const zAppEncryptionDeclarationsBuildsCreateToManyRelationshipData = z.object({
    body: zAppEncryptionDeclarationBuildsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppEncryptionDeclarationsBuildsCreateToManyRelationshipResponse = z.void();

export const zAppEventLocalizationsAppEventScreenshotsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppEventLocalizationsAppEventScreenshotsGetToManyRelationshipResponse = zAppEventLocalizationAppEventScreenshotsLinkagesResponse;

export const zAppEventLocalizationsAppEventScreenshotsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appEventScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'assetToken',
            'uploadOperations',
            'assetDeliveryState',
            'appEventAssetType',
            'appEventLocalization'
        ]))),
        'fields[appEventLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'shortDescription',
            'longDescription',
            'appEvent',
            'appEventScreenshots',
            'appEventVideoClips'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['appEventLocalization'])))
    }))
});

/**
 * List of AppEventScreenshots
 */
export const zAppEventLocalizationsAppEventScreenshotsGetToManyRelatedResponse = zAppEventScreenshotsResponse;

export const zAppEventLocalizationsAppEventVideoClipsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppEventLocalizationsAppEventVideoClipsGetToManyRelationshipResponse = zAppEventLocalizationAppEventVideoClipsLinkagesResponse;

export const zAppEventLocalizationsAppEventVideoClipsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appEventVideoClips]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'previewFrameTimeCode',
            'videoUrl',
            'previewFrameImage',
            'previewImage',
            'uploadOperations',
            'assetDeliveryState',
            'videoDeliveryState',
            'appEventAssetType',
            'appEventLocalization'
        ]))),
        'fields[appEventLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'shortDescription',
            'longDescription',
            'appEvent',
            'appEventScreenshots',
            'appEventVideoClips'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['appEventLocalization'])))
    }))
});

/**
 * List of AppEventVideoClips
 */
export const zAppEventLocalizationsAppEventVideoClipsGetToManyRelatedResponse = zAppEventVideoClipsResponse;

export const zAppEventsLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppEventsLocalizationsGetToManyRelationshipResponse = zAppEventLocalizationsLinkagesResponse;

export const zAppEventsLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appEventLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'shortDescription',
            'longDescription',
            'appEvent',
            'appEventScreenshots',
            'appEventVideoClips'
        ]))),
        'fields[appEvents]': z.optional(z.array(z.enum([
            'referenceName',
            'badge',
            'eventState',
            'deepLink',
            'purchaseRequirement',
            'primaryLocale',
            'priority',
            'purpose',
            'territorySchedules',
            'archivedTerritorySchedules',
            'localizations'
        ]))),
        'fields[appEventScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'assetToken',
            'uploadOperations',
            'assetDeliveryState',
            'appEventAssetType',
            'appEventLocalization'
        ]))),
        'fields[appEventVideoClips]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'previewFrameTimeCode',
            'videoUrl',
            'previewFrameImage',
            'previewImage',
            'uploadOperations',
            'assetDeliveryState',
            'videoDeliveryState',
            'appEventAssetType',
            'appEventLocalization'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appEvent',
            'appEventScreenshots',
            'appEventVideoClips'
        ]))),
        'limit[appEventScreenshots]': z.optional(z.int().lte(50)),
        'limit[appEventVideoClips]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppEventLocalizations
 */
export const zAppEventsLocalizationsGetToManyRelatedResponse = zAppEventLocalizationsResponse;

export const zAppInfosAgeRatingDeclarationGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppInfosAgeRatingDeclarationGetToOneRelationshipResponse = zAppInfoAgeRatingDeclarationLinkageResponse;

export const zAppInfosAgeRatingDeclarationGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ageRatingDeclarations]': z.optional(z.array(z.enum([
            'advertising',
            'alcoholTobaccoOrDrugUseOrReferences',
            'contests',
            'gambling',
            'gamblingSimulated',
            'gunsOrOtherWeapons',
            'healthOrWellnessTopics',
            'kidsAgeBand',
            'lootBox',
            'medicalOrTreatmentInformation',
            'messagingAndChat',
            'parentalControls',
            'profanityOrCrudeHumor',
            'ageAssurance',
            'sexualContentGraphicAndNudity',
            'sexualContentOrNudity',
            'horrorOrFearThemes',
            'matureOrSuggestiveThemes',
            'unrestrictedWebAccess',
            'userGeneratedContent',
            'violenceCartoonOrFantasy',
            'violenceRealisticProlongedGraphicOrSadistic',
            'violenceRealistic',
            'ageRatingOverride',
            'ageRatingOverrideV2',
            'koreaAgeRatingOverride',
            'developerAgeRatingInfoUrl'
        ])))
    }))
});

/**
 * Single AgeRatingDeclaration
 */
export const zAppInfosAgeRatingDeclarationGetToOneRelatedResponse = zAgeRatingDeclarationResponse;

export const zAppInfosAppInfoLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppInfosAppInfoLocalizationsGetToManyRelationshipResponse = zAppInfoAppInfoLocalizationsLinkagesResponse;

export const zAppInfosAppInfoLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[locale]': z.optional(z.array(z.string())),
        'fields[appInfoLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'subtitle',
            'privacyPolicyUrl',
            'privacyChoicesUrl',
            'privacyPolicyText',
            'appInfo'
        ]))),
        'fields[appInfos]': z.optional(z.array(z.enum([
            'appStoreState',
            'state',
            'appStoreAgeRating',
            'australiaAgeRating',
            'brazilAgeRating',
            'brazilAgeRatingV2',
            'franceAgeRating',
            'koreaAgeRating',
            'kidsAgeBand',
            'app',
            'ageRatingDeclaration',
            'appInfoLocalizations',
            'primaryCategory',
            'primarySubcategoryOne',
            'primarySubcategoryTwo',
            'secondaryCategory',
            'secondarySubcategoryOne',
            'secondarySubcategoryTwo',
            'territoryAgeRatings'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['appInfo'])))
    }))
});

/**
 * List of AppInfoLocalizations
 */
export const zAppInfosAppInfoLocalizationsGetToManyRelatedResponse = zAppInfoLocalizationsResponse;

export const zAppInfosPrimaryCategoryGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppInfosPrimaryCategoryGetToOneRelationshipResponse = zAppInfoPrimaryCategoryLinkageResponse;

export const zAppInfosPrimaryCategoryGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appCategories]': z.optional(z.array(z.enum([
            'platforms',
            'subcategories',
            'parent'
        ]))),
        include: z.optional(z.array(z.enum(['subcategories', 'parent']))),
        'limit[subcategories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppCategory
 */
export const zAppInfosPrimaryCategoryGetToOneRelatedResponse = zAppCategoryResponse;

export const zAppInfosPrimarySubcategoryOneGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppInfosPrimarySubcategoryOneGetToOneRelationshipResponse = zAppInfoPrimarySubcategoryOneLinkageResponse;

export const zAppInfosPrimarySubcategoryOneGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appCategories]': z.optional(z.array(z.enum([
            'platforms',
            'subcategories',
            'parent'
        ]))),
        include: z.optional(z.array(z.enum(['subcategories', 'parent']))),
        'limit[subcategories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppCategory
 */
export const zAppInfosPrimarySubcategoryOneGetToOneRelatedResponse = zAppCategoryResponse;

export const zAppInfosPrimarySubcategoryTwoGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppInfosPrimarySubcategoryTwoGetToOneRelationshipResponse = zAppInfoPrimarySubcategoryTwoLinkageResponse;

export const zAppInfosPrimarySubcategoryTwoGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appCategories]': z.optional(z.array(z.enum([
            'platforms',
            'subcategories',
            'parent'
        ]))),
        include: z.optional(z.array(z.enum(['subcategories', 'parent']))),
        'limit[subcategories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppCategory
 */
export const zAppInfosPrimarySubcategoryTwoGetToOneRelatedResponse = zAppCategoryResponse;

export const zAppInfosSecondaryCategoryGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppInfosSecondaryCategoryGetToOneRelationshipResponse = zAppInfoSecondaryCategoryLinkageResponse;

export const zAppInfosSecondaryCategoryGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appCategories]': z.optional(z.array(z.enum([
            'platforms',
            'subcategories',
            'parent'
        ]))),
        include: z.optional(z.array(z.enum(['subcategories', 'parent']))),
        'limit[subcategories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppCategory
 */
export const zAppInfosSecondaryCategoryGetToOneRelatedResponse = zAppCategoryResponse;

export const zAppInfosSecondarySubcategoryOneGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppInfosSecondarySubcategoryOneGetToOneRelationshipResponse = zAppInfoSecondarySubcategoryOneLinkageResponse;

export const zAppInfosSecondarySubcategoryOneGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appCategories]': z.optional(z.array(z.enum([
            'platforms',
            'subcategories',
            'parent'
        ]))),
        include: z.optional(z.array(z.enum(['subcategories', 'parent']))),
        'limit[subcategories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppCategory
 */
export const zAppInfosSecondarySubcategoryOneGetToOneRelatedResponse = zAppCategoryResponse;

export const zAppInfosSecondarySubcategoryTwoGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppInfosSecondarySubcategoryTwoGetToOneRelationshipResponse = zAppInfoSecondarySubcategoryTwoLinkageResponse;

export const zAppInfosSecondarySubcategoryTwoGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appCategories]': z.optional(z.array(z.enum([
            'platforms',
            'subcategories',
            'parent'
        ]))),
        include: z.optional(z.array(z.enum(['subcategories', 'parent']))),
        'limit[subcategories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppCategory
 */
export const zAppInfosSecondarySubcategoryTwoGetToOneRelatedResponse = zAppCategoryResponse;

export const zAppInfosTerritoryAgeRatingsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppInfosTerritoryAgeRatingsGetToManyRelationshipResponse = zAppInfoTerritoryAgeRatingsLinkagesResponse;

export const zAppInfosTerritoryAgeRatingsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[territoryAgeRatings]': z.optional(z.array(z.enum(['appStoreAgeRating', 'territory']))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['territory'])))
    }))
});

/**
 * List of TerritoryAgeRatings
 */
export const zAppInfosTerritoryAgeRatingsGetToManyRelatedResponse = zTerritoryAgeRatingsResponse;

export const zAppPreviewSetsAppPreviewsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppPreviewSetsAppPreviewsGetToManyRelationshipResponse = zAppPreviewSetAppPreviewsLinkagesResponse;

export const zAppPreviewSetsAppPreviewsReplaceToManyRelationshipData = z.object({
    body: zAppPreviewSetAppPreviewsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppPreviewSetsAppPreviewsReplaceToManyRelationshipResponse = z.void();

export const zAppPreviewSetsAppPreviewsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appPreviews]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'previewFrameTimeCode',
            'mimeType',
            'videoUrl',
            'previewFrameImage',
            'previewImage',
            'uploadOperations',
            'assetDeliveryState',
            'videoDeliveryState',
            'appPreviewSet'
        ]))),
        'fields[appPreviewSets]': z.optional(z.array(z.enum([
            'previewType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['appPreviewSet'])))
    }))
});

/**
 * List of AppPreviews
 */
export const zAppPreviewSetsAppPreviewsGetToManyRelatedResponse = zAppPreviewsResponse;

export const zAppPricePointsV3EqualizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppPricePointsV3EqualizationsGetToManyRelationshipResponse = zAppPricePointV3EqualizationsLinkagesResponse;

export const zAppPricePointsV3EqualizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[appPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'app',
            'equalizations',
            'territory'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['app', 'territory'])))
    }))
});

/**
 * List of AppPricePoints
 */
export const zAppPricePointsV3EqualizationsGetToManyRelatedResponse = zAppPricePointsV3Response;

export const zAppPriceSchedulesAutomaticPricesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppPriceSchedulesAutomaticPricesGetToManyRelationshipResponse = zAppPriceScheduleAutomaticPricesLinkagesResponse;

export const zAppPriceSchedulesAutomaticPricesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[startDate]': z.optional(z.array(z.string())),
        'filter[endDate]': z.optional(z.array(z.string())),
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[appPrices]': z.optional(z.array(z.enum([
            'manual',
            'startDate',
            'endDate',
            'appPricePoint',
            'territory'
        ]))),
        'fields[appPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'app',
            'equalizations',
            'territory'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['appPricePoint', 'territory'])))
    }))
});

/**
 * List of AppPrices
 */
export const zAppPriceSchedulesAutomaticPricesGetToManyRelatedResponse = zAppPricesV2Response;

export const zAppPriceSchedulesBaseTerritoryGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppPriceSchedulesBaseTerritoryGetToOneRelationshipResponse = zAppPriceScheduleBaseTerritoryLinkageResponse;

export const zAppPriceSchedulesBaseTerritoryGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[territories]': z.optional(z.array(z.enum(['currency'])))
    }))
});

/**
 * Single Territory
 */
export const zAppPriceSchedulesBaseTerritoryGetToOneRelatedResponse = zTerritoryResponse;

export const zAppPriceSchedulesManualPricesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppPriceSchedulesManualPricesGetToManyRelationshipResponse = zAppPriceScheduleManualPricesLinkagesResponse;

export const zAppPriceSchedulesManualPricesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[startDate]': z.optional(z.array(z.string())),
        'filter[endDate]': z.optional(z.array(z.string())),
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[appPrices]': z.optional(z.array(z.enum([
            'manual',
            'startDate',
            'endDate',
            'appPricePoint',
            'territory'
        ]))),
        'fields[appPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'app',
            'equalizations',
            'territory'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['appPricePoint', 'territory'])))
    }))
});

/**
 * List of AppPrices
 */
export const zAppPriceSchedulesManualPricesGetToManyRelatedResponse = zAppPricesV2Response;

export const zAppScreenshotSetsAppScreenshotsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppScreenshotSetsAppScreenshotsGetToManyRelationshipResponse = zAppScreenshotSetAppScreenshotsLinkagesResponse;

export const zAppScreenshotSetsAppScreenshotsReplaceToManyRelationshipData = z.object({
    body: zAppScreenshotSetAppScreenshotsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppScreenshotSetsAppScreenshotsReplaceToManyRelationshipResponse = z.void();

export const zAppScreenshotSetsAppScreenshotsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'appScreenshotSet'
        ]))),
        'fields[appScreenshotSets]': z.optional(z.array(z.enum([
            'screenshotDisplayType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['appScreenshotSet'])))
    }))
});

/**
 * List of AppScreenshots
 */
export const zAppScreenshotSetsAppScreenshotsGetToManyRelatedResponse = zAppScreenshotsResponse;

export const zAppStoreReviewDetailsAppStoreReviewAttachmentsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreReviewDetailsAppStoreReviewAttachmentsGetToManyRelationshipResponse = zAppStoreReviewDetailAppStoreReviewAttachmentsLinkagesResponse;

export const zAppStoreReviewDetailsAppStoreReviewAttachmentsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreReviewAttachments]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState',
            'appStoreReviewDetail'
        ]))),
        'fields[appStoreReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'appStoreVersion',
            'appStoreReviewAttachments'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['appStoreReviewDetail'])))
    }))
});

/**
 * List of AppStoreReviewAttachments
 */
export const zAppStoreReviewDetailsAppStoreReviewAttachmentsGetToManyRelatedResponse = zAppStoreReviewAttachmentsResponse;

export const zAppStoreVersionExperimentTreatmentLocalizationsAppPreviewSetsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreVersionExperimentTreatmentLocalizationsAppPreviewSetsGetToManyRelationshipResponse = zAppStoreVersionExperimentTreatmentLocalizationAppPreviewSetsLinkagesResponse;

export const zAppStoreVersionExperimentTreatmentLocalizationsAppPreviewSetsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[previewType]': z.optional(z.array(z.enum([
            'IPHONE_67',
            'IPHONE_61',
            'IPHONE_65',
            'IPHONE_58',
            'IPHONE_55',
            'IPHONE_47',
            'IPHONE_40',
            'IPHONE_35',
            'IPAD_PRO_3GEN_129',
            'IPAD_PRO_3GEN_11',
            'IPAD_PRO_129',
            'IPAD_105',
            'IPAD_97',
            'DESKTOP',
            'APPLE_TV',
            'APPLE_VISION_PRO'
        ]))),
        'filter[appStoreVersionLocalization]': z.optional(z.array(z.string())),
        'filter[appCustomProductPageLocalization]': z.optional(z.array(z.string())),
        'fields[appPreviewSets]': z.optional(z.array(z.enum([
            'previewType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appCustomProductPageLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'promotionalText',
            'appCustomProductPageVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        'fields[appPreviews]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'previewFrameTimeCode',
            'mimeType',
            'videoUrl',
            'previewFrameImage',
            'previewImage',
            'uploadOperations',
            'assetDeliveryState',
            'videoDeliveryState',
            'appPreviewSet'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        'limit[appPreviews]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppPreviewSets
 */
export const zAppStoreVersionExperimentTreatmentLocalizationsAppPreviewSetsGetToManyRelatedResponse = zAppPreviewSetsResponse;

export const zAppStoreVersionExperimentTreatmentLocalizationsAppScreenshotSetsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreVersionExperimentTreatmentLocalizationsAppScreenshotSetsGetToManyRelationshipResponse = zAppStoreVersionExperimentTreatmentLocalizationAppScreenshotSetsLinkagesResponse;

export const zAppStoreVersionExperimentTreatmentLocalizationsAppScreenshotSetsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[screenshotDisplayType]': z.optional(z.array(z.enum([
            'APP_IPHONE_67',
            'APP_IPHONE_61',
            'APP_IPHONE_65',
            'APP_IPHONE_58',
            'APP_IPHONE_55',
            'APP_IPHONE_47',
            'APP_IPHONE_40',
            'APP_IPHONE_35',
            'APP_IPAD_PRO_3GEN_129',
            'APP_IPAD_PRO_3GEN_11',
            'APP_IPAD_PRO_129',
            'APP_IPAD_105',
            'APP_IPAD_97',
            'APP_DESKTOP',
            'APP_WATCH_ULTRA',
            'APP_WATCH_SERIES_10',
            'APP_WATCH_SERIES_7',
            'APP_WATCH_SERIES_4',
            'APP_WATCH_SERIES_3',
            'APP_APPLE_TV',
            'APP_APPLE_VISION_PRO',
            'IMESSAGE_APP_IPHONE_67',
            'IMESSAGE_APP_IPHONE_61',
            'IMESSAGE_APP_IPHONE_65',
            'IMESSAGE_APP_IPHONE_58',
            'IMESSAGE_APP_IPHONE_55',
            'IMESSAGE_APP_IPHONE_47',
            'IMESSAGE_APP_IPHONE_40',
            'IMESSAGE_APP_IPAD_PRO_3GEN_129',
            'IMESSAGE_APP_IPAD_PRO_3GEN_11',
            'IMESSAGE_APP_IPAD_PRO_129',
            'IMESSAGE_APP_IPAD_105',
            'IMESSAGE_APP_IPAD_97'
        ]))),
        'filter[appStoreVersionLocalization]': z.optional(z.array(z.string())),
        'filter[appCustomProductPageLocalization]': z.optional(z.array(z.string())),
        'fields[appScreenshotSets]': z.optional(z.array(z.enum([
            'screenshotDisplayType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appCustomProductPageLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'promotionalText',
            'appCustomProductPageVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        'fields[appScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'appScreenshotSet'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'limit[appScreenshots]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppScreenshotSets
 */
export const zAppStoreVersionExperimentTreatmentLocalizationsAppScreenshotSetsGetToManyRelatedResponse = zAppScreenshotSetsResponse;

export const zAppStoreVersionExperimentTreatmentsAppStoreVersionExperimentTreatmentLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreVersionExperimentTreatmentsAppStoreVersionExperimentTreatmentLocalizationsGetToManyRelationshipResponse = zAppStoreVersionExperimentTreatmentAppStoreVersionExperimentTreatmentLocalizationsLinkagesResponse;

export const zAppStoreVersionExperimentTreatmentsAppStoreVersionExperimentTreatmentLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[locale]': z.optional(z.array(z.string())),
        'fields[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        'fields[appStoreVersionExperimentTreatments]': z.optional(z.array(z.enum([
            'name',
            'appIcon',
            'appIconName',
            'promotedDate',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appStoreVersionExperimentTreatmentLocalizations'
        ]))),
        'fields[appScreenshotSets]': z.optional(z.array(z.enum([
            'screenshotDisplayType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'fields[appPreviewSets]': z.optional(z.array(z.enum([
            'previewType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        'limit[appScreenshotSets]': z.optional(z.int().lte(50)),
        'limit[appPreviewSets]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppStoreVersionExperimentTreatmentLocalizations
 */
export const zAppStoreVersionExperimentTreatmentsAppStoreVersionExperimentTreatmentLocalizationsGetToManyRelatedResponse = zAppStoreVersionExperimentTreatmentLocalizationsResponse;

export const zAppStoreVersionExperimentsV2AppStoreVersionExperimentTreatmentsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreVersionExperimentsV2AppStoreVersionExperimentTreatmentsGetToManyRelationshipResponse = zAppStoreVersionExperimentV2AppStoreVersionExperimentTreatmentsLinkagesResponse;

export const zAppStoreVersionExperimentsV2AppStoreVersionExperimentTreatmentsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersionExperimentTreatments]': z.optional(z.array(z.enum([
            'name',
            'appIcon',
            'appIconName',
            'promotedDate',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appStoreVersionExperimentTreatmentLocalizations'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'appStoreVersion',
            'appStoreVersionExperimentTreatments',
            'platform',
            'app',
            'latestControlVersion',
            'controlVersions'
        ]))),
        'fields[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appStoreVersionExperimentTreatmentLocalizations'
        ]))),
        'limit[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppStoreVersionExperimentTreatments
 */
export const zAppStoreVersionExperimentsV2AppStoreVersionExperimentTreatmentsGetToManyRelatedResponse = zAppStoreVersionExperimentTreatmentsResponse;

export const zAppStoreVersionExperimentsAppStoreVersionExperimentTreatmentsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreVersionExperimentsAppStoreVersionExperimentTreatmentsGetToManyRelationshipResponse = zAppStoreVersionExperimentAppStoreVersionExperimentTreatmentsLinkagesResponse;

export const zAppStoreVersionExperimentsAppStoreVersionExperimentTreatmentsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersionExperimentTreatments]': z.optional(z.array(z.enum([
            'name',
            'appIcon',
            'appIconName',
            'promotedDate',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appStoreVersionExperimentTreatmentLocalizations'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'appStoreVersion',
            'appStoreVersionExperimentTreatments',
            'platform',
            'app',
            'latestControlVersion',
            'controlVersions'
        ]))),
        'fields[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appStoreVersionExperimentTreatmentLocalizations'
        ]))),
        'limit[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppStoreVersionExperimentTreatments
 */
export const zAppStoreVersionExperimentsAppStoreVersionExperimentTreatmentsGetToManyRelatedResponse = zAppStoreVersionExperimentTreatmentsResponse;

export const zAppStoreVersionLocalizationsAppPreviewSetsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreVersionLocalizationsAppPreviewSetsGetToManyRelationshipResponse = zAppStoreVersionLocalizationAppPreviewSetsLinkagesResponse;

export const zAppStoreVersionLocalizationsAppPreviewSetsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[previewType]': z.optional(z.array(z.enum([
            'IPHONE_67',
            'IPHONE_61',
            'IPHONE_65',
            'IPHONE_58',
            'IPHONE_55',
            'IPHONE_47',
            'IPHONE_40',
            'IPHONE_35',
            'IPAD_PRO_3GEN_129',
            'IPAD_PRO_3GEN_11',
            'IPAD_PRO_129',
            'IPAD_105',
            'IPAD_97',
            'DESKTOP',
            'APPLE_TV',
            'APPLE_VISION_PRO'
        ]))),
        'filter[appCustomProductPageLocalization]': z.optional(z.array(z.string())),
        'filter[appStoreVersionExperimentTreatmentLocalization]': z.optional(z.array(z.string())),
        'fields[appPreviewSets]': z.optional(z.array(z.enum([
            'previewType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appCustomProductPageLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'promotionalText',
            'appCustomProductPageVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        'fields[appPreviews]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'previewFrameTimeCode',
            'mimeType',
            'videoUrl',
            'previewFrameImage',
            'previewImage',
            'uploadOperations',
            'assetDeliveryState',
            'videoDeliveryState',
            'appPreviewSet'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        'limit[appPreviews]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppPreviewSets
 */
export const zAppStoreVersionLocalizationsAppPreviewSetsGetToManyRelatedResponse = zAppPreviewSetsResponse;

export const zAppStoreVersionLocalizationsAppScreenshotSetsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreVersionLocalizationsAppScreenshotSetsGetToManyRelationshipResponse = zAppStoreVersionLocalizationAppScreenshotSetsLinkagesResponse;

export const zAppStoreVersionLocalizationsAppScreenshotSetsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[screenshotDisplayType]': z.optional(z.array(z.enum([
            'APP_IPHONE_67',
            'APP_IPHONE_61',
            'APP_IPHONE_65',
            'APP_IPHONE_58',
            'APP_IPHONE_55',
            'APP_IPHONE_47',
            'APP_IPHONE_40',
            'APP_IPHONE_35',
            'APP_IPAD_PRO_3GEN_129',
            'APP_IPAD_PRO_3GEN_11',
            'APP_IPAD_PRO_129',
            'APP_IPAD_105',
            'APP_IPAD_97',
            'APP_DESKTOP',
            'APP_WATCH_ULTRA',
            'APP_WATCH_SERIES_10',
            'APP_WATCH_SERIES_7',
            'APP_WATCH_SERIES_4',
            'APP_WATCH_SERIES_3',
            'APP_APPLE_TV',
            'APP_APPLE_VISION_PRO',
            'IMESSAGE_APP_IPHONE_67',
            'IMESSAGE_APP_IPHONE_61',
            'IMESSAGE_APP_IPHONE_65',
            'IMESSAGE_APP_IPHONE_58',
            'IMESSAGE_APP_IPHONE_55',
            'IMESSAGE_APP_IPHONE_47',
            'IMESSAGE_APP_IPHONE_40',
            'IMESSAGE_APP_IPAD_PRO_3GEN_129',
            'IMESSAGE_APP_IPAD_PRO_3GEN_11',
            'IMESSAGE_APP_IPAD_PRO_129',
            'IMESSAGE_APP_IPAD_105',
            'IMESSAGE_APP_IPAD_97'
        ]))),
        'filter[appCustomProductPageLocalization]': z.optional(z.array(z.string())),
        'filter[appStoreVersionExperimentTreatmentLocalization]': z.optional(z.array(z.string())),
        'fields[appScreenshotSets]': z.optional(z.array(z.enum([
            'screenshotDisplayType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appCustomProductPageLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'promotionalText',
            'appCustomProductPageVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appStoreVersionExperimentTreatmentLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'appStoreVersionExperimentTreatment',
            'appScreenshotSets',
            'appPreviewSets'
        ]))),
        'fields[appScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'appScreenshotSet'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'limit[appScreenshots]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppScreenshotSets
 */
export const zAppStoreVersionLocalizationsAppScreenshotSetsGetToManyRelatedResponse = zAppScreenshotSetsResponse;

export const zAppStoreVersionLocalizationsSearchKeywordsDeleteToManyRelationshipData = z.object({
    body: zAppStoreVersionLocalizationSearchKeywordsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreVersionLocalizationsSearchKeywordsDeleteToManyRelationshipResponse = z.void();

export const zAppStoreVersionLocalizationsSearchKeywordsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreVersionLocalizationsSearchKeywordsGetToManyRelationshipResponse = zAppStoreVersionLocalizationSearchKeywordsLinkagesResponse;

export const zAppStoreVersionLocalizationsSearchKeywordsCreateToManyRelationshipData = z.object({
    body: zAppStoreVersionLocalizationSearchKeywordsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreVersionLocalizationsSearchKeywordsCreateToManyRelationshipResponse = z.void();

export const zAppStoreVersionLocalizationsSearchKeywordsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[platform]': z.optional(z.array(z.string())),
        'filter[locale]': z.optional(z.array(z.string())),
        'fields[appKeywords]': z.optional(z.array(z.unknown())),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AppKeywords
 */
export const zAppStoreVersionLocalizationsSearchKeywordsGetToManyRelatedResponse = zAppKeywordsResponse;

export const zAppStoreVersionsAgeRatingDeclarationGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppStoreVersionsAgeRatingDeclarationGetToOneRelationshipResponse = zAppStoreVersionAgeRatingDeclarationLinkageResponse;

export const zAppStoreVersionsAgeRatingDeclarationGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ageRatingDeclarations]': z.optional(z.array(z.enum([
            'advertising',
            'alcoholTobaccoOrDrugUseOrReferences',
            'contests',
            'gambling',
            'gamblingSimulated',
            'gunsOrOtherWeapons',
            'healthOrWellnessTopics',
            'kidsAgeBand',
            'lootBox',
            'medicalOrTreatmentInformation',
            'messagingAndChat',
            'parentalControls',
            'profanityOrCrudeHumor',
            'ageAssurance',
            'sexualContentGraphicAndNudity',
            'sexualContentOrNudity',
            'horrorOrFearThemes',
            'matureOrSuggestiveThemes',
            'unrestrictedWebAccess',
            'userGeneratedContent',
            'violenceCartoonOrFantasy',
            'violenceRealisticProlongedGraphicOrSadistic',
            'violenceRealistic',
            'ageRatingOverride',
            'ageRatingOverrideV2',
            'koreaAgeRatingOverride',
            'developerAgeRatingInfoUrl'
        ])))
    }))
});

/**
 * Single AgeRatingDeclaration with get
 */
export const zAppStoreVersionsAgeRatingDeclarationGetToOneRelatedResponse = zAgeRatingDeclarationWithoutIncludesResponse;

export const zAppStoreVersionsAlternativeDistributionPackageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppStoreVersionsAlternativeDistributionPackageGetToOneRelationshipResponse = zAppStoreVersionAlternativeDistributionPackageLinkageResponse;

export const zAppStoreVersionsAlternativeDistributionPackageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[alternativeDistributionPackages]': z.optional(z.array(z.enum(['sourceFileChecksum', 'versions']))),
        'fields[alternativeDistributionPackageVersions]': z.optional(z.array(z.enum([
            'url',
            'urlExpirationDate',
            'version',
            'fileChecksum',
            'state',
            'variants',
            'deltas',
            'alternativeDistributionPackage'
        ]))),
        include: z.optional(z.array(z.enum(['versions']))),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AlternativeDistributionPackage
 */
export const zAppStoreVersionsAlternativeDistributionPackageGetToOneRelatedResponse = zAlternativeDistributionPackageResponse;

export const zAppStoreVersionsAppClipDefaultExperienceGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppStoreVersionsAppClipDefaultExperienceGetToOneRelationshipResponse = zAppStoreVersionAppClipDefaultExperienceLinkageResponse;

export const zAppStoreVersionsAppClipDefaultExperienceUpdateToOneRelationshipData = z.object({
    body: zAppStoreVersionAppClipDefaultExperienceLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreVersionsAppClipDefaultExperienceUpdateToOneRelationshipResponse = z.void();

export const zAppStoreVersionsAppClipDefaultExperienceGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appClipDefaultExperiences]': z.optional(z.array(z.enum([
            'action',
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        'fields[appClips]': z.optional(z.array(z.enum([
            'bundleId',
            'app',
            'appClipDefaultExperiences',
            'appClipAdvancedExperiences'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[appClipDefaultExperienceLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'subtitle',
            'appClipDefaultExperience',
            'appClipHeaderImage'
        ]))),
        'fields[appClipAppStoreReviewDetails]': z.optional(z.array(z.enum(['invocationUrls', 'appClipDefaultExperience']))),
        include: z.optional(z.array(z.enum([
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        'limit[appClipDefaultExperienceLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppClipDefaultExperience
 */
export const zAppStoreVersionsAppClipDefaultExperienceGetToOneRelatedResponse = zAppClipDefaultExperienceResponse;

export const zAppStoreVersionsAppStoreReviewDetailGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppStoreVersionsAppStoreReviewDetailGetToOneRelationshipResponse = zAppStoreVersionAppStoreReviewDetailLinkageResponse;

export const zAppStoreVersionsAppStoreReviewDetailGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'appStoreVersion',
            'appStoreReviewAttachments'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[appStoreReviewAttachments]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState',
            'appStoreReviewDetail'
        ]))),
        include: z.optional(z.array(z.enum(['appStoreVersion', 'appStoreReviewAttachments']))),
        'limit[appStoreReviewAttachments]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppStoreReviewDetail
 */
export const zAppStoreVersionsAppStoreReviewDetailGetToOneRelatedResponse = zAppStoreReviewDetailResponse;

export const zAppStoreVersionsAppStoreVersionExperimentsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreVersionsAppStoreVersionExperimentsGetToManyRelationshipResponse = zAppStoreVersionAppStoreVersionExperimentsLinkagesResponse;

export const zAppStoreVersionsAppStoreVersionExperimentsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[state]': z.optional(z.array(z.enum([
            'PREPARE_FOR_SUBMISSION',
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'ACCEPTED',
            'APPROVED',
            'REJECTED',
            'COMPLETED',
            'STOPPED'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'appStoreVersion',
            'appStoreVersionExperimentTreatments'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[appStoreVersionExperimentTreatments]': z.optional(z.array(z.enum([
            'name',
            'appIcon',
            'appIconName',
            'promotedDate',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appStoreVersionExperimentTreatmentLocalizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['appStoreVersion', 'appStoreVersionExperimentTreatments']))),
        'limit[appStoreVersionExperimentTreatments]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppStoreVersionExperiments
 */
export const zAppStoreVersionsAppStoreVersionExperimentsGetToManyRelatedResponse = zAppStoreVersionExperimentsResponse;

export const zAppStoreVersionsAppStoreVersionExperimentsV2GetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreVersionsAppStoreVersionExperimentsV2GetToManyRelationshipResponse = zAppStoreVersionAppStoreVersionExperimentsV2LinkagesResponse;

export const zAppStoreVersionsAppStoreVersionExperimentsV2GetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[state]': z.optional(z.array(z.enum([
            'PREPARE_FOR_SUBMISSION',
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'ACCEPTED',
            'APPROVED',
            'REJECTED',
            'COMPLETED',
            'STOPPED'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'app',
            'latestControlVersion',
            'controlVersions',
            'appStoreVersionExperimentTreatments'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[appStoreVersionExperimentTreatments]': z.optional(z.array(z.enum([
            'name',
            'appIcon',
            'appIconName',
            'promotedDate',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appStoreVersionExperimentTreatmentLocalizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'app',
            'latestControlVersion',
            'controlVersions',
            'appStoreVersionExperimentTreatments'
        ]))),
        'limit[controlVersions]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperimentTreatments]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppStoreVersionExperiments
 */
export const zAppStoreVersionsAppStoreVersionExperimentsV2GetToManyRelatedResponse = zAppStoreVersionExperimentsV2Response;

export const zAppStoreVersionsAppStoreVersionLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreVersionsAppStoreVersionLocalizationsGetToManyRelationshipResponse = zAppStoreVersionAppStoreVersionLocalizationsLinkagesResponse;

export const zAppStoreVersionsAppStoreVersionLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[locale]': z.optional(z.array(z.string())),
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[appScreenshotSets]': z.optional(z.array(z.enum([
            'screenshotDisplayType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appScreenshots'
        ]))),
        'fields[appPreviewSets]': z.optional(z.array(z.enum([
            'previewType',
            'appStoreVersionLocalization',
            'appCustomProductPageLocalization',
            'appStoreVersionExperimentTreatmentLocalization',
            'appPreviews'
        ]))),
        'fields[appKeywords]': z.optional(z.array(z.unknown())),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'limit[appScreenshotSets]': z.optional(z.int().lte(50)),
        'limit[appPreviewSets]': z.optional(z.int().lte(50)),
        'limit[searchKeywords]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppStoreVersionLocalizations
 */
export const zAppStoreVersionsAppStoreVersionLocalizationsGetToManyRelatedResponse = zAppStoreVersionLocalizationsResponse;

export const zAppStoreVersionsAppStoreVersionPhasedReleaseGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppStoreVersionsAppStoreVersionPhasedReleaseGetToOneRelationshipResponse = zAppStoreVersionAppStoreVersionPhasedReleaseLinkageResponse;

export const zAppStoreVersionsAppStoreVersionPhasedReleaseGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersionPhasedReleases]': z.optional(z.array(z.enum([
            'phasedReleaseState',
            'startDate',
            'totalPauseDuration',
            'currentDayNumber'
        ])))
    }))
});

/**
 * Single AppStoreVersionPhasedRelease with get
 */
export const zAppStoreVersionsAppStoreVersionPhasedReleaseGetToOneRelatedResponse = zAppStoreVersionPhasedReleaseWithoutIncludesResponse;

export const zAppStoreVersionsAppStoreVersionSubmissionGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppStoreVersionsAppStoreVersionSubmissionGetToOneRelationshipResponse = zAppStoreVersionAppStoreVersionSubmissionLinkageResponse;

export const zAppStoreVersionsAppStoreVersionSubmissionGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersionSubmissions]': z.optional(z.array(z.enum(['appStoreVersion']))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        include: z.optional(z.array(z.enum(['appStoreVersion'])))
    }))
});

/**
 * Single AppStoreVersionSubmission
 */
export const zAppStoreVersionsAppStoreVersionSubmissionGetToOneRelatedResponse = zAppStoreVersionSubmissionResponse;

export const zAppStoreVersionsBuildGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppStoreVersionsBuildGetToOneRelationshipResponse = zAppStoreVersionBuildLinkageResponse;

export const zAppStoreVersionsBuildUpdateToOneRelationshipData = z.object({
    body: zAppStoreVersionBuildLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppStoreVersionsBuildUpdateToOneRelationshipResponse = z.void();

export const zAppStoreVersionsBuildGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ])))
    }))
});

/**
 * Single Build with get
 */
export const zAppStoreVersionsBuildGetToOneRelatedResponse = zBuildWithoutIncludesResponse;

export const zAppStoreVersionsCustomerReviewsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppStoreVersionsCustomerReviewsGetToManyRelationshipResponse = zAppStoreVersionCustomerReviewsLinkagesResponse;

export const zAppStoreVersionsCustomerReviewsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.enum([
            'ABW',
            'AFG',
            'AGO',
            'AIA',
            'ALB',
            'AND',
            'ANT',
            'ARE',
            'ARG',
            'ARM',
            'ASM',
            'ATG',
            'AUS',
            'AUT',
            'AZE',
            'BDI',
            'BEL',
            'BEN',
            'BES',
            'BFA',
            'BGD',
            'BGR',
            'BHR',
            'BHS',
            'BIH',
            'BLR',
            'BLZ',
            'BMU',
            'BOL',
            'BRA',
            'BRB',
            'BRN',
            'BTN',
            'BWA',
            'CAF',
            'CAN',
            'CHE',
            'CHL',
            'CHN',
            'CIV',
            'CMR',
            'COD',
            'COG',
            'COK',
            'COL',
            'COM',
            'CPV',
            'CRI',
            'CUB',
            'CUW',
            'CXR',
            'CYM',
            'CYP',
            'CZE',
            'DEU',
            'DJI',
            'DMA',
            'DNK',
            'DOM',
            'DZA',
            'ECU',
            'EGY',
            'ERI',
            'ESP',
            'EST',
            'ETH',
            'FIN',
            'FJI',
            'FLK',
            'FRA',
            'FRO',
            'FSM',
            'GAB',
            'GBR',
            'GEO',
            'GGY',
            'GHA',
            'GIB',
            'GIN',
            'GLP',
            'GMB',
            'GNB',
            'GNQ',
            'GRC',
            'GRD',
            'GRL',
            'GTM',
            'GUF',
            'GUM',
            'GUY',
            'HKG',
            'HND',
            'HRV',
            'HTI',
            'HUN',
            'IDN',
            'IMN',
            'IND',
            'IRL',
            'IRQ',
            'ISL',
            'ISR',
            'ITA',
            'JAM',
            'JEY',
            'JOR',
            'JPN',
            'KAZ',
            'KEN',
            'KGZ',
            'KHM',
            'KIR',
            'KNA',
            'KOR',
            'KWT',
            'LAO',
            'LBN',
            'LBR',
            'LBY',
            'LCA',
            'LIE',
            'LKA',
            'LSO',
            'LTU',
            'LUX',
            'LVA',
            'MAC',
            'MAR',
            'MCO',
            'MDA',
            'MDG',
            'MDV',
            'MEX',
            'MHL',
            'MKD',
            'MLI',
            'MLT',
            'MMR',
            'MNE',
            'MNG',
            'MNP',
            'MOZ',
            'MRT',
            'MSR',
            'MTQ',
            'MUS',
            'MWI',
            'MYS',
            'MYT',
            'NAM',
            'NCL',
            'NER',
            'NFK',
            'NGA',
            'NIC',
            'NIU',
            'NLD',
            'NOR',
            'NPL',
            'NRU',
            'NZL',
            'OMN',
            'PAK',
            'PAN',
            'PER',
            'PHL',
            'PLW',
            'PNG',
            'POL',
            'PRI',
            'PRT',
            'PRY',
            'PSE',
            'PYF',
            'QAT',
            'REU',
            'ROU',
            'RUS',
            'RWA',
            'SAU',
            'SEN',
            'SGP',
            'SHN',
            'SLB',
            'SLE',
            'SLV',
            'SMR',
            'SOM',
            'SPM',
            'SRB',
            'SSD',
            'STP',
            'SUR',
            'SVK',
            'SVN',
            'SWE',
            'SWZ',
            'SXM',
            'SYC',
            'TCA',
            'TCD',
            'TGO',
            'THA',
            'TJK',
            'TKM',
            'TLS',
            'TON',
            'TTO',
            'TUN',
            'TUR',
            'TUV',
            'TWN',
            'TZA',
            'UGA',
            'UKR',
            'UMI',
            'URY',
            'USA',
            'UZB',
            'VAT',
            'VCT',
            'VEN',
            'VGB',
            'VIR',
            'VNM',
            'VUT',
            'WLF',
            'WSM',
            'XKS',
            'YEM',
            'ZAF',
            'ZMB',
            'ZWE'
        ]))),
        'filter[rating]': z.optional(z.array(z.string())),
        'exists[publishedResponse]': z.optional(z.boolean()),
        sort: z.optional(z.array(z.enum([
            'rating',
            '-rating',
            'createdDate',
            '-createdDate'
        ]))),
        'fields[customerReviews]': z.optional(z.array(z.enum([
            'rating',
            'title',
            'body',
            'reviewerNickname',
            'createdDate',
            'territory',
            'response'
        ]))),
        'fields[customerReviewResponses]': z.optional(z.array(z.enum([
            'responseBody',
            'lastModifiedDate',
            'state',
            'review'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['response'])))
    }))
});

/**
 * List of CustomerReviews
 */
export const zAppStoreVersionsCustomerReviewsGetToManyRelatedResponse = zCustomerReviewsResponse;

export const zAppStoreVersionsGameCenterAppVersionGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppStoreVersionsGameCenterAppVersionGetToOneRelationshipResponse = zAppStoreVersionGameCenterAppVersionLinkageResponse;

export const zAppStoreVersionsGameCenterAppVersionGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAppVersions]': z.optional(z.array(z.enum([
            'enabled',
            'compatibilityVersions',
            'appStoreVersion'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        include: z.optional(z.array(z.enum(['compatibilityVersions', 'appStoreVersion']))),
        'limit[compatibilityVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterAppVersion
 */
export const zAppStoreVersionsGameCenterAppVersionGetToOneRelatedResponse = zGameCenterAppVersionResponse;

export const zAppStoreVersionsRoutingAppCoverageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppStoreVersionsRoutingAppCoverageGetToOneRelationshipResponse = zAppStoreVersionRoutingAppCoverageLinkageResponse;

export const zAppStoreVersionsRoutingAppCoverageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[routingAppCoverages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState',
            'appStoreVersion'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        include: z.optional(z.array(z.enum(['appStoreVersion'])))
    }))
});

/**
 * Single RoutingAppCoverage
 */
export const zAppStoreVersionsRoutingAppCoverageGetToOneRelatedResponse = zRoutingAppCoverageResponse;

export const zAppTagsTerritoriesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppTagsTerritoriesGetToManyRelationshipResponse = zAppTagTerritoriesLinkagesResponse;

export const zAppTagsTerritoriesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Territories
 */
export const zAppTagsTerritoriesGetToManyRelatedResponse = zTerritoriesResponse;

export const zAppsAccessibilityDeclarationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsAccessibilityDeclarationsGetToManyRelationshipResponse = zAppAccessibilityDeclarationsLinkagesResponse;

export const zAppsAccessibilityDeclarationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[deviceFamily]': z.optional(z.array(z.enum([
            'IPHONE',
            'IPAD',
            'APPLE_TV',
            'APPLE_WATCH',
            'MAC',
            'VISION'
        ]))),
        'filter[state]': z.optional(z.array(z.enum([
            'DRAFT',
            'PUBLISHED',
            'REPLACED'
        ]))),
        'fields[accessibilityDeclarations]': z.optional(z.array(z.enum([
            'deviceFamily',
            'state',
            'supportsAudioDescriptions',
            'supportsCaptions',
            'supportsDarkInterface',
            'supportsDifferentiateWithoutColorAlone',
            'supportsLargerText',
            'supportsReducedMotion',
            'supportsSufficientContrast',
            'supportsVoiceControl',
            'supportsVoiceover'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AccessibilityDeclarations
 */
export const zAppsAccessibilityDeclarationsGetToManyRelatedResponse = zAccessibilityDeclarationsResponse;

export const zAppsAlternativeDistributionKeyGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppsAlternativeDistributionKeyGetToOneRelationshipResponse = zAppAlternativeDistributionKeyLinkageResponse;

export const zAppsAlternativeDistributionKeyGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[alternativeDistributionKeys]': z.optional(z.array(z.enum(['publicKey'])))
    }))
});

/**
 * Single AlternativeDistributionKey
 */
export const zAppsAlternativeDistributionKeyGetToOneRelatedResponse = zAlternativeDistributionKeyResponse;

export const zAppsAnalyticsReportRequestsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsAnalyticsReportRequestsGetToManyRelationshipResponse = zAppAnalyticsReportRequestsLinkagesResponse;

export const zAppsAnalyticsReportRequestsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[accessType]': z.optional(z.array(z.enum(['ONE_TIME_SNAPSHOT', 'ONGOING']))),
        'fields[analyticsReportRequests]': z.optional(z.array(z.enum([
            'accessType',
            'stoppedDueToInactivity',
            'reports'
        ]))),
        'fields[analyticsReports]': z.optional(z.array(z.enum([
            'name',
            'category',
            'instances'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['reports']))),
        'limit[reports]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AnalyticsReportRequests
 */
export const zAppsAnalyticsReportRequestsGetToManyRelatedResponse = zAnalyticsReportRequestsResponse;

export const zAppsAndroidToIosAppMappingDetailsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsAndroidToIosAppMappingDetailsGetToManyRelationshipResponse = zAppAndroidToIosAppMappingDetailsLinkagesResponse;

export const zAppsAndroidToIosAppMappingDetailsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[androidToIosAppMappingDetails]': z.optional(z.array(z.enum(['packageName', 'appSigningKeyPublicCertificateSha256Fingerprints']))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AndroidToIosAppMappingDetails
 */
export const zAppsAndroidToIosAppMappingDetailsGetToManyRelatedResponse = zAndroidToIosAppMappingDetailsResponse;

export const zAppsAppAvailabilityV2GetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppsAppAvailabilityV2GetToOneRelationshipResponse = zAppAppAvailabilityV2LinkageResponse;

export const zAppsAppAvailabilityV2GetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appAvailabilities]': z.optional(z.array(z.enum(['availableInNewTerritories', 'territoryAvailabilities']))),
        'fields[territoryAvailabilities]': z.optional(z.array(z.enum([
            'available',
            'releaseDate',
            'preOrderEnabled',
            'preOrderPublishDate',
            'contentStatuses',
            'territory'
        ]))),
        include: z.optional(z.array(z.enum(['territoryAvailabilities']))),
        'limit[territoryAvailabilities]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppAvailability
 */
export const zAppsAppAvailabilityV2GetToOneRelatedResponse = zAppAvailabilityV2Response;

export const zAppsAppClipsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsAppClipsGetToManyRelationshipResponse = zAppAppClipsLinkagesResponse;

export const zAppsAppClipsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[bundleId]': z.optional(z.array(z.string())),
        'fields[appClips]': z.optional(z.array(z.enum([
            'bundleId',
            'app',
            'appClipDefaultExperiences',
            'appClipAdvancedExperiences'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[appClipDefaultExperiences]': z.optional(z.array(z.enum([
            'action',
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['app', 'appClipDefaultExperiences']))),
        'limit[appClipDefaultExperiences]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppClips
 */
export const zAppsAppClipsGetToManyRelatedResponse = zAppClipsResponse;

export const zAppsAppCustomProductPagesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsAppCustomProductPagesGetToManyRelationshipResponse = zAppAppCustomProductPagesLinkagesResponse;

export const zAppsAppCustomProductPagesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[visible]': z.optional(z.array(z.string())),
        'fields[appCustomProductPages]': z.optional(z.array(z.enum([
            'name',
            'url',
            'visible',
            'app',
            'appCustomProductPageVersions'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[appCustomProductPageVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'deepLink',
            'appCustomProductPage',
            'appCustomProductPageLocalizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['app', 'appCustomProductPageVersions']))),
        'limit[appCustomProductPageVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppCustomProductPages
 */
export const zAppsAppCustomProductPagesGetToManyRelatedResponse = zAppCustomProductPagesResponse;

export const zAppsAppEncryptionDeclarationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsAppEncryptionDeclarationsGetToManyRelationshipResponse = zAppAppEncryptionDeclarationsLinkagesResponse;

export const zAppsAppEncryptionDeclarationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[builds]': z.optional(z.array(z.string())),
        'fields[appEncryptionDeclarations]': z.optional(z.array(z.enum([
            'appDescription',
            'createdDate',
            'usesEncryption',
            'exempt',
            'containsProprietaryCryptography',
            'containsThirdPartyCryptography',
            'availableOnFrenchStore',
            'platform',
            'uploadedDate',
            'documentUrl',
            'documentName',
            'documentType',
            'appEncryptionDeclarationState',
            'codeValue',
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[appEncryptionDeclarationDocuments]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'assetToken',
            'downloadUrl',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'limit[builds]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppEncryptionDeclarations
 */
export const zAppsAppEncryptionDeclarationsGetToManyRelatedResponse = zAppEncryptionDeclarationsResponse;

export const zAppsAppEventsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsAppEventsGetToManyRelationshipResponse = zAppAppEventsLinkagesResponse;

export const zAppsAppEventsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[eventState]': z.optional(z.array(z.enum([
            'DRAFT',
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'REJECTED',
            'ACCEPTED',
            'APPROVED',
            'PUBLISHED',
            'PAST',
            'ARCHIVED'
        ]))),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[appEvents]': z.optional(z.array(z.enum([
            'referenceName',
            'badge',
            'eventState',
            'deepLink',
            'purchaseRequirement',
            'primaryLocale',
            'priority',
            'purpose',
            'territorySchedules',
            'archivedTerritorySchedules',
            'localizations'
        ]))),
        'fields[appEventLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'shortDescription',
            'longDescription',
            'appEvent',
            'appEventScreenshots',
            'appEventVideoClips'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['localizations']))),
        'limit[localizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppEvents
 */
export const zAppsAppEventsGetToManyRelatedResponse = zAppEventsResponse;

export const zAppsAppInfosGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsAppInfosGetToManyRelationshipResponse = zAppAppInfosLinkagesResponse;

export const zAppsAppInfosGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appInfos]': z.optional(z.array(z.enum([
            'appStoreState',
            'state',
            'appStoreAgeRating',
            'australiaAgeRating',
            'brazilAgeRating',
            'brazilAgeRatingV2',
            'franceAgeRating',
            'koreaAgeRating',
            'kidsAgeBand',
            'app',
            'ageRatingDeclaration',
            'appInfoLocalizations',
            'primaryCategory',
            'primarySubcategoryOne',
            'primarySubcategoryTwo',
            'secondaryCategory',
            'secondarySubcategoryOne',
            'secondarySubcategoryTwo',
            'territoryAgeRatings'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[ageRatingDeclarations]': z.optional(z.array(z.enum([
            'advertising',
            'alcoholTobaccoOrDrugUseOrReferences',
            'contests',
            'gambling',
            'gamblingSimulated',
            'gunsOrOtherWeapons',
            'healthOrWellnessTopics',
            'kidsAgeBand',
            'lootBox',
            'medicalOrTreatmentInformation',
            'messagingAndChat',
            'parentalControls',
            'profanityOrCrudeHumor',
            'ageAssurance',
            'sexualContentGraphicAndNudity',
            'sexualContentOrNudity',
            'horrorOrFearThemes',
            'matureOrSuggestiveThemes',
            'unrestrictedWebAccess',
            'userGeneratedContent',
            'violenceCartoonOrFantasy',
            'violenceRealisticProlongedGraphicOrSadistic',
            'violenceRealistic',
            'ageRatingOverride',
            'ageRatingOverrideV2',
            'koreaAgeRatingOverride',
            'developerAgeRatingInfoUrl'
        ]))),
        'fields[appInfoLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'subtitle',
            'privacyPolicyUrl',
            'privacyChoicesUrl',
            'privacyPolicyText',
            'appInfo'
        ]))),
        'fields[appCategories]': z.optional(z.array(z.enum([
            'platforms',
            'subcategories',
            'parent'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'app',
            'ageRatingDeclaration',
            'appInfoLocalizations',
            'primaryCategory',
            'primarySubcategoryOne',
            'primarySubcategoryTwo',
            'secondaryCategory',
            'secondarySubcategoryOne',
            'secondarySubcategoryTwo'
        ]))),
        'limit[appInfoLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppInfos
 */
export const zAppsAppInfosGetToManyRelatedResponse = zAppInfosResponse;

export const zAppsAppPricePointsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsAppPricePointsGetToManyRelationshipResponse = zAppAppPricePointsLinkagesResponse;

export const zAppsAppPricePointsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[appPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'app',
            'equalizations',
            'territory'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['app', 'territory'])))
    }))
});

/**
 * List of AppPricePoints
 */
export const zAppsAppPricePointsGetToManyRelatedResponse = zAppPricePointsV3Response;

export const zAppsAppPriceScheduleGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppsAppPriceScheduleGetToOneRelationshipResponse = zAppAppPriceScheduleLinkageResponse;

export const zAppsAppPriceScheduleGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appPriceSchedules]': z.optional(z.array(z.enum([
            'app',
            'baseTerritory',
            'manualPrices',
            'automaticPrices'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        'fields[appPrices]': z.optional(z.array(z.enum([
            'manual',
            'startDate',
            'endDate',
            'appPricePoint',
            'territory'
        ]))),
        include: z.optional(z.array(z.enum([
            'app',
            'baseTerritory',
            'manualPrices',
            'automaticPrices'
        ]))),
        'limit[manualPrices]': z.optional(z.int().lte(50)),
        'limit[automaticPrices]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppPriceSchedule
 */
export const zAppsAppPriceScheduleGetToOneRelatedResponse = zAppPriceScheduleResponse;

export const zAppsAppStoreVersionExperimentsV2GetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsAppStoreVersionExperimentsV2GetToManyRelationshipResponse = zAppAppStoreVersionExperimentsV2LinkagesResponse;

export const zAppsAppStoreVersionExperimentsV2GetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[state]': z.optional(z.array(z.enum([
            'PREPARE_FOR_SUBMISSION',
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'ACCEPTED',
            'APPROVED',
            'REJECTED',
            'COMPLETED',
            'STOPPED'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'app',
            'latestControlVersion',
            'controlVersions',
            'appStoreVersionExperimentTreatments'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[appStoreVersionExperimentTreatments]': z.optional(z.array(z.enum([
            'name',
            'appIcon',
            'appIconName',
            'promotedDate',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appStoreVersionExperimentTreatmentLocalizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'app',
            'latestControlVersion',
            'controlVersions',
            'appStoreVersionExperimentTreatments'
        ]))),
        'limit[controlVersions]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperimentTreatments]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppStoreVersionExperiments
 */
export const zAppsAppStoreVersionExperimentsV2GetToManyRelatedResponse = zAppStoreVersionExperimentsV2Response;

export const zAppsAppStoreVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsAppStoreVersionsGetToManyRelationshipResponse = zAppAppStoreVersionsLinkagesResponse;

export const zAppsAppStoreVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[versionString]': z.optional(z.array(z.string())),
        'filter[appStoreState]': z.optional(z.array(z.enum([
            'ACCEPTED',
            'DEVELOPER_REMOVED_FROM_SALE',
            'DEVELOPER_REJECTED',
            'IN_REVIEW',
            'INVALID_BINARY',
            'METADATA_REJECTED',
            'PENDING_APPLE_RELEASE',
            'PENDING_CONTRACT',
            'PENDING_DEVELOPER_RELEASE',
            'PREPARE_FOR_SUBMISSION',
            'PREORDER_READY_FOR_SALE',
            'PROCESSING_FOR_APP_STORE',
            'READY_FOR_REVIEW',
            'READY_FOR_SALE',
            'REJECTED',
            'REMOVED_FROM_SALE',
            'WAITING_FOR_EXPORT_COMPLIANCE',
            'WAITING_FOR_REVIEW',
            'REPLACED_WITH_NEW_VERSION',
            'NOT_APPLICABLE'
        ]))),
        'filter[appVersionState]': z.optional(z.array(z.enum([
            'ACCEPTED',
            'DEVELOPER_REJECTED',
            'IN_REVIEW',
            'INVALID_BINARY',
            'METADATA_REJECTED',
            'PENDING_APPLE_RELEASE',
            'PENDING_DEVELOPER_RELEASE',
            'PREPARE_FOR_SUBMISSION',
            'PROCESSING_FOR_DISTRIBUTION',
            'READY_FOR_DISTRIBUTION',
            'READY_FOR_REVIEW',
            'REJECTED',
            'REPLACED_WITH_NEW_VERSION',
            'WAITING_FOR_EXPORT_COMPLIANCE',
            'WAITING_FOR_REVIEW'
        ]))),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[ageRatingDeclarations]': z.optional(z.array(z.enum([
            'advertising',
            'alcoholTobaccoOrDrugUseOrReferences',
            'contests',
            'gambling',
            'gamblingSimulated',
            'gunsOrOtherWeapons',
            'healthOrWellnessTopics',
            'kidsAgeBand',
            'lootBox',
            'medicalOrTreatmentInformation',
            'messagingAndChat',
            'parentalControls',
            'profanityOrCrudeHumor',
            'ageAssurance',
            'sexualContentGraphicAndNudity',
            'sexualContentOrNudity',
            'horrorOrFearThemes',
            'matureOrSuggestiveThemes',
            'unrestrictedWebAccess',
            'userGeneratedContent',
            'violenceCartoonOrFantasy',
            'violenceRealisticProlongedGraphicOrSadistic',
            'violenceRealistic',
            'ageRatingOverride',
            'ageRatingOverrideV2',
            'koreaAgeRatingOverride',
            'developerAgeRatingInfoUrl'
        ]))),
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[appStoreVersionPhasedReleases]': z.optional(z.array(z.enum([
            'phasedReleaseState',
            'startDate',
            'totalPauseDuration',
            'currentDayNumber'
        ]))),
        'fields[gameCenterAppVersions]': z.optional(z.array(z.enum([
            'enabled',
            'compatibilityVersions',
            'appStoreVersion'
        ]))),
        'fields[routingAppCoverages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState',
            'appStoreVersion'
        ]))),
        'fields[appStoreReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'appStoreVersion',
            'appStoreReviewAttachments'
        ]))),
        'fields[appStoreVersionSubmissions]': z.optional(z.array(z.enum(['appStoreVersion']))),
        'fields[appClipDefaultExperiences]': z.optional(z.array(z.enum([
            'action',
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'appStoreVersion',
            'appStoreVersionExperimentTreatments',
            'platform',
            'app',
            'latestControlVersion',
            'controlVersions'
        ]))),
        'fields[alternativeDistributionPackages]': z.optional(z.array(z.enum(['sourceFileChecksum', 'versions']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionPackage'
        ]))),
        'limit[appStoreVersionLocalizations]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperiments]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperimentsV2]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppStoreVersions
 */
export const zAppsAppStoreVersionsGetToManyRelatedResponse = zAppStoreVersionsResponse;

export const zAppsAppTagsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsAppTagsGetToManyRelationshipResponse = zAppAppTagsLinkagesResponse;

export const zAppsAppTagsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[visibleInAppStore]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum(['name', '-name']))),
        'fields[appTags]': z.optional(z.array(z.enum([
            'name',
            'visibleInAppStore',
            'territories'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['territories']))),
        'limit[territories]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of AppTags
 */
export const zAppsAppTagsGetToManyRelatedResponse = zAppTagsResponse;

export const zAppsBackgroundAssetsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsBackgroundAssetsGetToManyRelationshipResponse = zAppBackgroundAssetsLinkagesResponse;

export const zAppsBackgroundAssetsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[assetPackIdentifier]': z.optional(z.array(z.string())),
        'fields[backgroundAssets]': z.optional(z.array(z.enum([
            'archived',
            'assetPackIdentifier',
            'createdDate',
            'app',
            'versions',
            'appStoreVersion',
            'internalBetaVersion',
            'externalBetaVersion'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[backgroundAssetVersions]': z.optional(z.array(z.enum([
            'createdDate',
            'platforms',
            'state',
            'stateDetails',
            'version',
            'backgroundAsset',
            'internalBetaRelease',
            'externalBetaRelease',
            'appStoreRelease',
            'assetFile',
            'manifestFile',
            'backgroundAssetUploadFiles'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'app',
            'appStoreVersion',
            'internalBetaVersion',
            'externalBetaVersion'
        ])))
    }))
});

/**
 * List of BackgroundAssets
 */
export const zAppsBackgroundAssetsGetToManyRelatedResponse = zBackgroundAssetsResponse;

export const zAppsBetaAppLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsBetaAppLocalizationsGetToManyRelationshipResponse = zAppBetaAppLocalizationsLinkagesResponse;

export const zAppsBetaAppLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaAppLocalizations]': z.optional(z.array(z.enum([
            'feedbackEmail',
            'marketingUrl',
            'privacyPolicyUrl',
            'tvOsPrivacyPolicy',
            'description',
            'locale',
            'app'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of BetaAppLocalizations with get
 */
export const zAppsBetaAppLocalizationsGetToManyRelatedResponse = zBetaAppLocalizationsWithoutIncludesResponse;

export const zAppsBetaAppReviewDetailGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppsBetaAppReviewDetailGetToOneRelationshipResponse = zAppBetaAppReviewDetailLinkageResponse;

export const zAppsBetaAppReviewDetailGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaAppReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'app'
        ])))
    }))
});

/**
 * Single BetaAppReviewDetail with get
 */
export const zAppsBetaAppReviewDetailGetToOneRelatedResponse = zBetaAppReviewDetailWithoutIncludesResponse;

export const zAppsBetaFeedbackCrashSubmissionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsBetaFeedbackCrashSubmissionsGetToManyRelationshipResponse = zAppBetaFeedbackCrashSubmissionsLinkagesResponse;

export const zAppsBetaFeedbackCrashSubmissionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[deviceModel]': z.optional(z.array(z.string())),
        'filter[osVersion]': z.optional(z.array(z.string())),
        'filter[appPlatform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[devicePlatform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[build]': z.optional(z.array(z.string())),
        'filter[build.preReleaseVersion]': z.optional(z.array(z.string())),
        'filter[tester]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum(['createdDate', '-createdDate']))),
        'fields[betaFeedbackCrashSubmissions]': z.optional(z.array(z.enum([
            'createdDate',
            'comment',
            'email',
            'deviceModel',
            'osVersion',
            'locale',
            'timeZone',
            'architecture',
            'connectionType',
            'pairedAppleWatch',
            'appUptimeInMilliseconds',
            'diskBytesAvailable',
            'diskBytesTotal',
            'batteryPercentage',
            'screenWidthInPoints',
            'screenHeightInPoints',
            'appPlatform',
            'devicePlatform',
            'deviceFamily',
            'buildBundleId',
            'crashLog',
            'build',
            'tester'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[betaTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'email',
            'inviteType',
            'state',
            'appDevices',
            'apps',
            'betaGroups',
            'builds'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['build', 'tester'])))
    }))
});

/**
 * List of BetaFeedbackCrashSubmissions
 */
export const zAppsBetaFeedbackCrashSubmissionsGetToManyRelatedResponse = zBetaFeedbackCrashSubmissionsResponse;

export const zAppsBetaFeedbackScreenshotSubmissionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsBetaFeedbackScreenshotSubmissionsGetToManyRelationshipResponse = zAppBetaFeedbackScreenshotSubmissionsLinkagesResponse;

export const zAppsBetaFeedbackScreenshotSubmissionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[deviceModel]': z.optional(z.array(z.string())),
        'filter[osVersion]': z.optional(z.array(z.string())),
        'filter[appPlatform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[devicePlatform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[build]': z.optional(z.array(z.string())),
        'filter[build.preReleaseVersion]': z.optional(z.array(z.string())),
        'filter[tester]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum(['createdDate', '-createdDate']))),
        'fields[betaFeedbackScreenshotSubmissions]': z.optional(z.array(z.enum([
            'createdDate',
            'comment',
            'email',
            'deviceModel',
            'osVersion',
            'locale',
            'timeZone',
            'architecture',
            'connectionType',
            'pairedAppleWatch',
            'appUptimeInMilliseconds',
            'diskBytesAvailable',
            'diskBytesTotal',
            'batteryPercentage',
            'screenWidthInPoints',
            'screenHeightInPoints',
            'appPlatform',
            'devicePlatform',
            'deviceFamily',
            'buildBundleId',
            'screenshots',
            'build',
            'tester'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[betaTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'email',
            'inviteType',
            'state',
            'appDevices',
            'apps',
            'betaGroups',
            'builds'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['build', 'tester'])))
    }))
});

/**
 * List of BetaFeedbackScreenshotSubmissions
 */
export const zAppsBetaFeedbackScreenshotSubmissionsGetToManyRelatedResponse = zBetaFeedbackScreenshotSubmissionsResponse;

export const zAppsBetaGroupsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsBetaGroupsGetToManyRelationshipResponse = zAppBetaGroupsLinkagesResponse;

export const zAppsBetaGroupsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaGroups]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'isInternalGroup',
            'hasAccessToAllBuilds',
            'publicLinkEnabled',
            'publicLinkId',
            'publicLinkLimitEnabled',
            'publicLinkLimit',
            'publicLink',
            'feedbackEnabled',
            'iosBuildsAvailableForAppleSiliconMac',
            'iosBuildsAvailableForAppleVision',
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria',
            'betaRecruitmentCriterionCompatibleBuildCheck'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of BetaGroups with get
 */
export const zAppsBetaGroupsGetToManyRelatedResponse = zBetaGroupsWithoutIncludesResponse;

export const zAppsBetaLicenseAgreementGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppsBetaLicenseAgreementGetToOneRelationshipResponse = zAppBetaLicenseAgreementLinkageResponse;

export const zAppsBetaLicenseAgreementGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaLicenseAgreements]': z.optional(z.array(z.enum(['agreementText', 'app'])))
    }))
});

/**
 * Single BetaLicenseAgreement with get
 */
export const zAppsBetaLicenseAgreementGetToOneRelatedResponse = zBetaLicenseAgreementWithoutIncludesResponse;

export const zAppsBetaTestersDeleteToManyRelationshipData = z.object({
    body: zAppBetaTestersLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

export const zAppsBetaTestersDeleteToManyRelationshipResponse = z.union([
    z.unknown(),
    z.void()
]);

export const zAppsBuildUploadsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsBuildUploadsGetToManyRelationshipResponse = zAppBuildUploadsLinkagesResponse;

export const zAppsBuildUploadsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[cfBundleShortVersionString]': z.optional(z.array(z.string())),
        'filter[cfBundleVersion]': z.optional(z.array(z.string())),
        'filter[platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[state]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'cfBundleVersion',
            '-cfBundleVersion',
            'uploadedDate',
            '-uploadedDate'
        ]))),
        'fields[buildUploads]': z.optional(z.array(z.enum([
            'cfBundleShortVersionString',
            'cfBundleVersion',
            'createdDate',
            'state',
            'platform',
            'uploadedDate',
            'build',
            'assetFile',
            'assetDescriptionFile',
            'assetSpiFile',
            'buildUploadFiles'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[buildUploadFiles]': z.optional(z.array(z.enum([
            'assetDeliveryState',
            'assetToken',
            'assetType',
            'fileName',
            'fileSize',
            'sourceFileChecksums',
            'uploadOperations',
            'uti'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'build',
            'assetFile',
            'assetDescriptionFile',
            'assetSpiFile'
        ])))
    }))
});

/**
 * List of BuildUploads
 */
export const zAppsBuildUploadsGetToManyRelatedResponse = zBuildUploadsResponse;

export const zAppsBuildsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsBuildsGetToManyRelationshipResponse = zAppBuildsLinkagesResponse;

export const zAppsBuildsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Builds with get
 */
export const zAppsBuildsGetToManyRelatedResponse = zBuildsWithoutIncludesResponse;

export const zAppsCiProductGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppsCiProductGetToOneRelationshipResponse = zAppCiProductLinkageResponse;

export const zAppsCiProductGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciProducts]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'productType',
            'app',
            'bundleId',
            'workflows',
            'primaryRepositories',
            'additionalRepositories',
            'buildRuns'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[bundleIds]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'identifier',
            'seedId',
            'profiles',
            'bundleIdCapabilities',
            'app'
        ]))),
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        include: z.optional(z.array(z.enum([
            'app',
            'bundleId',
            'primaryRepositories'
        ]))),
        'limit[primaryRepositories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single CiProduct
 */
export const zAppsCiProductGetToOneRelatedResponse = zCiProductResponse;

export const zAppsCustomerReviewSummarizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.object({
        'filter[platform]': z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ])),
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[customerReviewSummarizations]': z.optional(z.array(z.enum([
            'createdDate',
            'locale',
            'platform',
            'text',
            'territory'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['territory'])))
    })
});

/**
 * List of CustomerReviewSummarizations
 */
export const zAppsCustomerReviewSummarizationsGetToManyRelatedResponse = zCustomerReviewSummarizationsResponse;

export const zAppsCustomerReviewsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsCustomerReviewsGetToManyRelationshipResponse = zAppCustomerReviewsLinkagesResponse;

export const zAppsCustomerReviewsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.enum([
            'ABW',
            'AFG',
            'AGO',
            'AIA',
            'ALB',
            'AND',
            'ANT',
            'ARE',
            'ARG',
            'ARM',
            'ASM',
            'ATG',
            'AUS',
            'AUT',
            'AZE',
            'BDI',
            'BEL',
            'BEN',
            'BES',
            'BFA',
            'BGD',
            'BGR',
            'BHR',
            'BHS',
            'BIH',
            'BLR',
            'BLZ',
            'BMU',
            'BOL',
            'BRA',
            'BRB',
            'BRN',
            'BTN',
            'BWA',
            'CAF',
            'CAN',
            'CHE',
            'CHL',
            'CHN',
            'CIV',
            'CMR',
            'COD',
            'COG',
            'COK',
            'COL',
            'COM',
            'CPV',
            'CRI',
            'CUB',
            'CUW',
            'CXR',
            'CYM',
            'CYP',
            'CZE',
            'DEU',
            'DJI',
            'DMA',
            'DNK',
            'DOM',
            'DZA',
            'ECU',
            'EGY',
            'ERI',
            'ESP',
            'EST',
            'ETH',
            'FIN',
            'FJI',
            'FLK',
            'FRA',
            'FRO',
            'FSM',
            'GAB',
            'GBR',
            'GEO',
            'GGY',
            'GHA',
            'GIB',
            'GIN',
            'GLP',
            'GMB',
            'GNB',
            'GNQ',
            'GRC',
            'GRD',
            'GRL',
            'GTM',
            'GUF',
            'GUM',
            'GUY',
            'HKG',
            'HND',
            'HRV',
            'HTI',
            'HUN',
            'IDN',
            'IMN',
            'IND',
            'IRL',
            'IRQ',
            'ISL',
            'ISR',
            'ITA',
            'JAM',
            'JEY',
            'JOR',
            'JPN',
            'KAZ',
            'KEN',
            'KGZ',
            'KHM',
            'KIR',
            'KNA',
            'KOR',
            'KWT',
            'LAO',
            'LBN',
            'LBR',
            'LBY',
            'LCA',
            'LIE',
            'LKA',
            'LSO',
            'LTU',
            'LUX',
            'LVA',
            'MAC',
            'MAR',
            'MCO',
            'MDA',
            'MDG',
            'MDV',
            'MEX',
            'MHL',
            'MKD',
            'MLI',
            'MLT',
            'MMR',
            'MNE',
            'MNG',
            'MNP',
            'MOZ',
            'MRT',
            'MSR',
            'MTQ',
            'MUS',
            'MWI',
            'MYS',
            'MYT',
            'NAM',
            'NCL',
            'NER',
            'NFK',
            'NGA',
            'NIC',
            'NIU',
            'NLD',
            'NOR',
            'NPL',
            'NRU',
            'NZL',
            'OMN',
            'PAK',
            'PAN',
            'PER',
            'PHL',
            'PLW',
            'PNG',
            'POL',
            'PRI',
            'PRT',
            'PRY',
            'PSE',
            'PYF',
            'QAT',
            'REU',
            'ROU',
            'RUS',
            'RWA',
            'SAU',
            'SEN',
            'SGP',
            'SHN',
            'SLB',
            'SLE',
            'SLV',
            'SMR',
            'SOM',
            'SPM',
            'SRB',
            'SSD',
            'STP',
            'SUR',
            'SVK',
            'SVN',
            'SWE',
            'SWZ',
            'SXM',
            'SYC',
            'TCA',
            'TCD',
            'TGO',
            'THA',
            'TJK',
            'TKM',
            'TLS',
            'TON',
            'TTO',
            'TUN',
            'TUR',
            'TUV',
            'TWN',
            'TZA',
            'UGA',
            'UKR',
            'UMI',
            'URY',
            'USA',
            'UZB',
            'VAT',
            'VCT',
            'VEN',
            'VGB',
            'VIR',
            'VNM',
            'VUT',
            'WLF',
            'WSM',
            'XKS',
            'YEM',
            'ZAF',
            'ZMB',
            'ZWE'
        ]))),
        'filter[rating]': z.optional(z.array(z.string())),
        'exists[publishedResponse]': z.optional(z.boolean()),
        sort: z.optional(z.array(z.enum([
            'rating',
            '-rating',
            'createdDate',
            '-createdDate'
        ]))),
        'fields[customerReviews]': z.optional(z.array(z.enum([
            'rating',
            'title',
            'body',
            'reviewerNickname',
            'createdDate',
            'territory',
            'response'
        ]))),
        'fields[customerReviewResponses]': z.optional(z.array(z.enum([
            'responseBody',
            'lastModifiedDate',
            'state',
            'review'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['response'])))
    }))
});

/**
 * List of CustomerReviews
 */
export const zAppsCustomerReviewsGetToManyRelatedResponse = zCustomerReviewsResponse;

export const zAppsEndUserLicenseAgreementGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppsEndUserLicenseAgreementGetToOneRelationshipResponse = zAppEndUserLicenseAgreementLinkageResponse;

export const zAppsEndUserLicenseAgreementGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[endUserLicenseAgreements]': z.optional(z.array(z.enum([
            'agreementText',
            'app',
            'territories'
        ])))
    }))
});

/**
 * Single EndUserLicenseAgreement with get
 */
export const zAppsEndUserLicenseAgreementGetToOneRelatedResponse = zEndUserLicenseAgreementWithoutIncludesResponse;

export const zAppsGameCenterDetailGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppsGameCenterDetailGetToOneRelationshipResponse = zAppGameCenterDetailLinkageResponse;

export const zAppsGameCenterDetailGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[gameCenterAppVersions]': z.optional(z.array(z.enum([
            'enabled',
            'compatibilityVersions',
            'appStoreVersion'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases',
            'versions'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity',
            'versions'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'fields[gameCenterAchievementReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterAchievement'
        ]))),
        'fields[gameCenterActivityVersionReleases]': z.optional(z.array(z.enum(['version']))),
        'fields[gameCenterChallengeVersionReleases]': z.optional(z.array(z.enum(['version']))),
        'fields[gameCenterLeaderboardReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboard'
        ]))),
        'fields[gameCenterLeaderboardSetReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboardSet'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        include: z.optional(z.array(z.enum([
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'limit[gameCenterAppVersions]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardSetsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterAchievements]': z.optional(z.int().lte(50)),
        'limit[gameCenterAchievementsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterActivities]': z.optional(z.int().lte(50)),
        'limit[gameCenterChallenges]': z.optional(z.int().lte(50)),
        'limit[achievementReleases]': z.optional(z.int().lte(50)),
        'limit[activityReleases]': z.optional(z.int().lte(50)),
        'limit[challengeReleases]': z.optional(z.int().lte(50)),
        'limit[leaderboardReleases]': z.optional(z.int().lte(50)),
        'limit[leaderboardSetReleases]': z.optional(z.int().lte(50)),
        'limit[challengesMinimumPlatformVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterDetail
 */
export const zAppsGameCenterDetailGetToOneRelatedResponse = zGameCenterDetailResponse;

export const zAppsGameCenterEnabledVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsGameCenterEnabledVersionsGetToManyRelationshipResponse = zAppGameCenterEnabledVersionsLinkagesResponse;

export const zAppsGameCenterEnabledVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[versionString]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum(['versionString', '-versionString']))),
        'fields[gameCenterEnabledVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'iconAsset',
            'compatibleVersions',
            'app'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['compatibleVersions', 'app']))),
        'limit[compatibleVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterEnabledVersions
 */
export const zAppsGameCenterEnabledVersionsGetToManyRelatedResponse = zGameCenterEnabledVersionsResponse;

export const zAppsInAppPurchasesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsInAppPurchasesGetToManyRelationshipResponse = zAppInAppPurchasesLinkagesResponse;

export const zAppsInAppPurchasesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[inAppPurchaseType]': z.optional(z.array(z.enum([
            'AUTOMATICALLY_RENEWABLE_SUBSCRIPTION',
            'NON_CONSUMABLE',
            'CONSUMABLE',
            'NON_RENEWING_SUBSCRIPTION',
            'FREE_SUBSCRIPTION'
        ]))),
        'filter[canBeSubmitted]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'referenceName',
            '-referenceName',
            'productId',
            '-productId',
            'inAppPurchaseType',
            '-inAppPurchaseType'
        ]))),
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'referenceName',
            'productId',
            'inAppPurchaseType',
            'state',
            'apps'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['apps']))),
        'limit[apps]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of InAppPurchases
 */
export const zAppsInAppPurchasesGetToManyRelatedResponse = zInAppPurchasesResponse;

export const zAppsInAppPurchasesV2GetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsInAppPurchasesV2GetToManyRelationshipResponse = zAppInAppPurchasesV2LinkagesResponse;

export const zAppsInAppPurchasesV2GetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[productId]': z.optional(z.array(z.string())),
        'filter[name]': z.optional(z.array(z.string())),
        'filter[state]': z.optional(z.array(z.enum([
            'MISSING_METADATA',
            'WAITING_FOR_UPLOAD',
            'PROCESSING_CONTENT',
            'READY_TO_SUBMIT',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'DEVELOPER_ACTION_NEEDED',
            'PENDING_BINARY_APPROVAL',
            'APPROVED',
            'DEVELOPER_REMOVED_FROM_SALE',
            'REMOVED_FROM_SALE',
            'REJECTED'
        ]))),
        'filter[inAppPurchaseType]': z.optional(z.array(z.enum([
            'CONSUMABLE',
            'NON_CONSUMABLE',
            'NON_RENEWING_SUBSCRIPTION'
        ]))),
        sort: z.optional(z.array(z.enum([
            'name',
            '-name',
            'inAppPurchaseType',
            '-inAppPurchaseType'
        ]))),
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'inAppPurchaseType',
            'state',
            'reviewNote',
            'familySharable',
            'contentHosting',
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        'fields[inAppPurchaseLocalizations]': z.optional(z.array(z.enum([
            'name',
            'locale',
            'description',
            'state',
            'inAppPurchaseV2'
        ]))),
        'fields[inAppPurchaseContents]': z.optional(z.array(z.enum([
            'fileName',
            'fileSize',
            'url',
            'lastModifiedDate',
            'inAppPurchaseV2'
        ]))),
        'fields[inAppPurchaseAppStoreReviewScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'inAppPurchaseV2'
        ]))),
        'fields[promotedPurchases]': z.optional(z.array(z.enum([
            'visibleForAllUsers',
            'enabled',
            'state',
            'inAppPurchaseV2',
            'subscription'
        ]))),
        'fields[inAppPurchasePriceSchedules]': z.optional(z.array(z.enum([
            'baseTerritory',
            'manualPrices',
            'automaticPrices'
        ]))),
        'fields[inAppPurchaseAvailabilities]': z.optional(z.array(z.enum(['availableInNewTerritories', 'availableTerritories']))),
        'fields[inAppPurchaseImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'assetToken',
            'imageAsset',
            'uploadOperations',
            'state',
            'inAppPurchase'
        ]))),
        'fields[inAppPurchaseOfferCodes]': z.optional(z.array(z.enum([
            'name',
            'customerEligibilities',
            'productionCodeCount',
            'sandboxCodeCount',
            'active',
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'inAppPurchaseLocalizations',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        'limit[inAppPurchaseLocalizations]': z.optional(z.int().lte(50)),
        'limit[images]': z.optional(z.int().lte(50)),
        'limit[offerCodes]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of InAppPurchases
 */
export const zAppsInAppPurchasesV2GetToManyRelatedResponse = zInAppPurchasesV2Response;

export const zAppsMarketplaceSearchDetailGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppsMarketplaceSearchDetailGetToOneRelationshipResponse = zAppMarketplaceSearchDetailLinkageResponse;

export const zAppsMarketplaceSearchDetailGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[marketplaceSearchDetails]': z.optional(z.array(z.enum(['catalogUrl'])))
    }))
});

/**
 * Single MarketplaceSearchDetail
 */
export const zAppsMarketplaceSearchDetailGetToOneRelatedResponse = zMarketplaceSearchDetailResponse;

export const zAppsPerfPowerMetricsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[platform]': z.optional(z.array(z.enum(['IOS']))),
        'filter[metricType]': z.optional(z.array(z.enum([
            'DISK',
            'HANG',
            'BATTERY',
            'LAUNCH',
            'MEMORY',
            'ANIMATION',
            'TERMINATION'
        ]))),
        'filter[deviceType]': z.optional(z.array(z.string()))
    }))
});

/**
 * List of PerfPowerMetrics
 */
export const zAppsPerfPowerMetricsGetToManyRelatedResponse = zXcodeMetrics;

export const zAppsPreReleaseVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsPreReleaseVersionsGetToManyRelationshipResponse = zAppPreReleaseVersionsLinkagesResponse;

export const zAppsPreReleaseVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[preReleaseVersions]': z.optional(z.array(z.enum([
            'version',
            'platform',
            'builds',
            'app'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of PreReleaseVersions with get
 */
export const zAppsPreReleaseVersionsGetToManyRelatedResponse = zPreReleaseVersionsWithoutIncludesResponse;

export const zAppsPromotedPurchasesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsPromotedPurchasesGetToManyRelationshipResponse = zAppPromotedPurchasesLinkagesResponse;

export const zAppsPromotedPurchasesReplaceToManyRelationshipData = z.object({
    body: zAppPromotedPurchasesLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zAppsPromotedPurchasesReplaceToManyRelationshipResponse = z.void();

export const zAppsPromotedPurchasesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[promotedPurchases]': z.optional(z.array(z.enum([
            'visibleForAllUsers',
            'enabled',
            'state',
            'inAppPurchaseV2',
            'subscription'
        ]))),
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'inAppPurchaseType',
            'state',
            'reviewNote',
            'familySharable',
            'contentHosting',
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['inAppPurchaseV2', 'subscription'])))
    }))
});

/**
 * List of PromotedPurchases
 */
export const zAppsPromotedPurchasesGetToManyRelatedResponse = zPromotedPurchasesResponse;

export const zAppsReviewSubmissionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsReviewSubmissionsGetToManyRelationshipResponse = zAppReviewSubmissionsLinkagesResponse;

export const zAppsReviewSubmissionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[state]': z.optional(z.array(z.enum([
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'UNRESOLVED_ISSUES',
            'CANCELING',
            'COMPLETING',
            'COMPLETE'
        ]))),
        'fields[reviewSubmissions]': z.optional(z.array(z.enum([
            'platform',
            'submittedDate',
            'state',
            'app',
            'items',
            'appStoreVersionForReview',
            'submittedByActor',
            'lastUpdatedByActor'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[reviewSubmissionItems]': z.optional(z.array(z.enum([
            'state',
            'appStoreVersion',
            'appCustomProductPageVersion',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appEvent',
            'backgroundAssetVersion',
            'gameCenterAchievementVersion',
            'gameCenterActivityVersion',
            'gameCenterChallengeVersion',
            'gameCenterLeaderboardSetVersion',
            'gameCenterLeaderboardVersion'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[actors]': z.optional(z.array(z.enum([
            'actorType',
            'userFirstName',
            'userLastName',
            'userEmail',
            'apiKeyId'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'app',
            'items',
            'appStoreVersionForReview',
            'submittedByActor',
            'lastUpdatedByActor'
        ]))),
        'limit[items]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of ReviewSubmissions
 */
export const zAppsReviewSubmissionsGetToManyRelatedResponse = zReviewSubmissionsResponse;

export const zAppsSearchKeywordsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsSearchKeywordsGetToManyRelationshipResponse = zAppSearchKeywordsLinkagesResponse;

export const zAppsSearchKeywordsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[platform]': z.optional(z.array(z.string())),
        'filter[locale]': z.optional(z.array(z.string())),
        'fields[appKeywords]': z.optional(z.array(z.unknown())),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of AppKeywords
 */
export const zAppsSearchKeywordsGetToManyRelatedResponse = zAppKeywordsResponse;

export const zAppsSubscriptionGracePeriodGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zAppsSubscriptionGracePeriodGetToOneRelationshipResponse = zAppSubscriptionGracePeriodLinkageResponse;

export const zAppsSubscriptionGracePeriodGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionGracePeriods]': z.optional(z.array(z.enum([
            'optIn',
            'sandboxOptIn',
            'duration',
            'renewalType'
        ])))
    }))
});

/**
 * Single SubscriptionGracePeriod
 */
export const zAppsSubscriptionGracePeriodGetToOneRelatedResponse = zSubscriptionGracePeriodResponse;

export const zAppsSubscriptionGroupsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsSubscriptionGroupsGetToManyRelationshipResponse = zAppSubscriptionGroupsLinkagesResponse;

export const zAppsSubscriptionGroupsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[subscriptions.state]': z.optional(z.array(z.enum([
            'MISSING_METADATA',
            'READY_TO_SUBMIT',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'DEVELOPER_ACTION_NEEDED',
            'PENDING_BINARY_APPROVAL',
            'APPROVED',
            'DEVELOPER_REMOVED_FROM_SALE',
            'REMOVED_FROM_SALE',
            'REJECTED'
        ]))),
        sort: z.optional(z.array(z.enum(['referenceName', '-referenceName']))),
        'fields[subscriptionGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'subscriptions',
            'subscriptionGroupLocalizations'
        ]))),
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        'fields[subscriptionGroupLocalizations]': z.optional(z.array(z.enum([
            'name',
            'customAppName',
            'locale',
            'state',
            'subscriptionGroup'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['subscriptions', 'subscriptionGroupLocalizations']))),
        'limit[subscriptions]': z.optional(z.int().lte(50)),
        'limit[subscriptionGroupLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of SubscriptionGroups
 */
export const zAppsSubscriptionGroupsGetToManyRelatedResponse = zSubscriptionGroupsResponse;

export const zAppsWebhooksGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zAppsWebhooksGetToManyRelationshipResponse = zAppWebhooksLinkagesResponse;

export const zAppsWebhooksGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[webhooks]': z.optional(z.array(z.enum([
            'enabled',
            'eventTypes',
            'name',
            'url',
            'app',
            'deliveries'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['app'])))
    }))
});

/**
 * List of Webhooks
 */
export const zAppsWebhooksGetToManyRelatedResponse = zWebhooksResponse;

export const zBackgroundAssetVersionsBackgroundAssetUploadFilesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBackgroundAssetVersionsBackgroundAssetUploadFilesGetToManyRelationshipResponse = zBackgroundAssetVersionBackgroundAssetUploadFilesLinkagesResponse;

export const zBackgroundAssetVersionsBackgroundAssetUploadFilesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[backgroundAssetUploadFiles]': z.optional(z.array(z.enum([
            'assetDeliveryState',
            'assetToken',
            'assetType',
            'fileName',
            'fileSize',
            'sourceFileChecksum',
            'sourceFileChecksums',
            'uploadOperations'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of BackgroundAssetUploadFiles
 */
export const zBackgroundAssetVersionsBackgroundAssetUploadFilesGetToManyRelatedResponse = zBackgroundAssetUploadFilesResponse;

export const zBackgroundAssetsVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBackgroundAssetsVersionsGetToManyRelationshipResponse = zBackgroundAssetVersionsLinkagesResponse;

export const zBackgroundAssetsVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[state]': z.optional(z.array(z.enum([
            'AWAITING_UPLOAD',
            'PROCESSING',
            'FAILED',
            'COMPLETE'
        ]))),
        'filter[version]': z.optional(z.array(z.string())),
        'filter[internalBetaRelease.state]': z.optional(z.array(z.enum(['READY_FOR_TESTING', 'SUPERSEDED']))),
        'filter[externalBetaRelease.state]': z.optional(z.array(z.enum([
            'READY_FOR_BETA_SUBMISSION',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'REJECTED',
            'PROCESSING_FOR_TESTING',
            'READY_FOR_TESTING',
            'SUPERSEDED'
        ]))),
        'filter[appStoreRelease.state]': z.optional(z.array(z.enum([
            'PREPARE_FOR_SUBMISSION',
            'READY_FOR_REVIEW',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'ACCEPTED',
            'REJECTED',
            'PROCESSING_FOR_DISTRIBUTION',
            'READY_FOR_DISTRIBUTION',
            'SUPERSEDED'
        ]))),
        sort: z.optional(z.array(z.enum(['version', '-version']))),
        'fields[backgroundAssetVersions]': z.optional(z.array(z.enum([
            'createdDate',
            'platforms',
            'state',
            'stateDetails',
            'version',
            'backgroundAsset',
            'internalBetaRelease',
            'externalBetaRelease',
            'appStoreRelease',
            'assetFile',
            'manifestFile',
            'backgroundAssetUploadFiles'
        ]))),
        'fields[backgroundAssets]': z.optional(z.array(z.enum([
            'archived',
            'assetPackIdentifier',
            'createdDate',
            'app',
            'versions',
            'appStoreVersion',
            'internalBetaVersion',
            'externalBetaVersion'
        ]))),
        'fields[backgroundAssetVersionInternalBetaReleases]': z.optional(z.array(z.enum(['state', 'backgroundAssetVersion']))),
        'fields[backgroundAssetVersionExternalBetaReleases]': z.optional(z.array(z.enum(['state', 'backgroundAssetVersion']))),
        'fields[backgroundAssetVersionAppStoreReleases]': z.optional(z.array(z.enum(['state', 'backgroundAssetVersion']))),
        'fields[backgroundAssetUploadFiles]': z.optional(z.array(z.enum([
            'assetDeliveryState',
            'assetToken',
            'assetType',
            'fileName',
            'fileSize',
            'sourceFileChecksum',
            'sourceFileChecksums',
            'uploadOperations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'backgroundAsset',
            'internalBetaRelease',
            'externalBetaRelease',
            'appStoreRelease',
            'assetFile',
            'manifestFile'
        ])))
    }))
});

/**
 * List of BackgroundAssetVersions
 */
export const zBackgroundAssetsVersionsGetToManyRelatedResponse = zBackgroundAssetVersionsResponse;

export const zBetaAppLocalizationsAppGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBetaAppLocalizationsAppGetToOneRelationshipResponse = zBetaAppLocalizationAppLinkageResponse;

export const zBetaAppLocalizationsAppGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ])))
    }))
});

/**
 * Single App with get
 */
export const zBetaAppLocalizationsAppGetToOneRelatedResponse = zAppWithoutIncludesResponse;

export const zBetaAppReviewDetailsAppGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBetaAppReviewDetailsAppGetToOneRelationshipResponse = zBetaAppReviewDetailAppLinkageResponse;

export const zBetaAppReviewDetailsAppGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ])))
    }))
});

/**
 * Single App with get
 */
export const zBetaAppReviewDetailsAppGetToOneRelatedResponse = zAppWithoutIncludesResponse;

export const zBetaAppReviewSubmissionsBuildGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBetaAppReviewSubmissionsBuildGetToOneRelationshipResponse = zBetaAppReviewSubmissionBuildLinkageResponse;

export const zBetaAppReviewSubmissionsBuildGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ])))
    }))
});

/**
 * Single Build with get
 */
export const zBetaAppReviewSubmissionsBuildGetToOneRelatedResponse = zBuildWithoutIncludesResponse;

export const zBetaBuildLocalizationsBuildGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBetaBuildLocalizationsBuildGetToOneRelationshipResponse = zBetaBuildLocalizationBuildLinkageResponse;

export const zBetaBuildLocalizationsBuildGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ])))
    }))
});

/**
 * Single Build with get
 */
export const zBetaBuildLocalizationsBuildGetToOneRelatedResponse = zBuildWithoutIncludesResponse;

export const zBetaFeedbackCrashSubmissionsCrashLogGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBetaFeedbackCrashSubmissionsCrashLogGetToOneRelationshipResponse = zBetaFeedbackCrashSubmissionCrashLogLinkageResponse;

export const zBetaFeedbackCrashSubmissionsCrashLogGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaCrashLogs]': z.optional(z.array(z.enum(['logText'])))
    }))
});

/**
 * Single BetaCrashLog
 */
export const zBetaFeedbackCrashSubmissionsCrashLogGetToOneRelatedResponse = zBetaCrashLogResponse;

export const zBetaGroupsAppGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBetaGroupsAppGetToOneRelationshipResponse = zBetaGroupAppLinkageResponse;

export const zBetaGroupsAppGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ])))
    }))
});

/**
 * Single App with get
 */
export const zBetaGroupsAppGetToOneRelatedResponse = zAppWithoutIncludesResponse;

export const zBetaGroupsBetaRecruitmentCriteriaGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBetaGroupsBetaRecruitmentCriteriaGetToOneRelationshipResponse = zBetaGroupBetaRecruitmentCriteriaLinkageResponse;

export const zBetaGroupsBetaRecruitmentCriteriaGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaRecruitmentCriteria]': z.optional(z.array(z.enum(['lastModifiedDate', 'deviceFamilyOsVersionFilters'])))
    }))
});

/**
 * Single BetaRecruitmentCriterion
 */
export const zBetaGroupsBetaRecruitmentCriteriaGetToOneRelatedResponse = zBetaRecruitmentCriterionResponse;

export const zBetaGroupsBetaRecruitmentCriterionCompatibleBuildCheckGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBetaGroupsBetaRecruitmentCriterionCompatibleBuildCheckGetToOneRelationshipResponse = zBetaGroupBetaRecruitmentCriterionCompatibleBuildCheckLinkageResponse;

export const zBetaGroupsBetaRecruitmentCriterionCompatibleBuildCheckGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaRecruitmentCriterionCompatibleBuildChecks]': z.optional(z.array(z.enum(['hasCompatibleBuild'])))
    }))
});

/**
 * Single BetaRecruitmentCriterionCompatibleBuildCheck
 */
export const zBetaGroupsBetaRecruitmentCriterionCompatibleBuildCheckGetToOneRelatedResponse = zBetaRecruitmentCriterionCompatibleBuildCheckResponse;

export const zBetaGroupsBetaTestersDeleteToManyRelationshipData = z.object({
    body: zBetaGroupBetaTestersLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaGroupsBetaTestersDeleteToManyRelationshipResponse = z.void();

export const zBetaGroupsBetaTestersGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBetaGroupsBetaTestersGetToManyRelationshipResponse = zBetaGroupBetaTestersLinkagesResponse;

export const zBetaGroupsBetaTestersCreateToManyRelationshipData = z.object({
    body: zBetaGroupBetaTestersLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaGroupsBetaTestersCreateToManyRelationshipResponse = z.void();

export const zBetaGroupsBetaTestersGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'email',
            'inviteType',
            'state',
            'appDevices',
            'apps',
            'betaGroups',
            'builds'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of BetaTesters with get
 */
export const zBetaGroupsBetaTestersGetToManyRelatedResponse = zBetaTestersWithoutIncludesResponse;

export const zBetaGroupsBuildsDeleteToManyRelationshipData = z.object({
    body: zBetaGroupBuildsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaGroupsBuildsDeleteToManyRelationshipResponse = z.void();

export const zBetaGroupsBuildsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBetaGroupsBuildsGetToManyRelationshipResponse = zBetaGroupBuildsLinkagesResponse;

export const zBetaGroupsBuildsCreateToManyRelationshipData = z.object({
    body: zBetaGroupBuildsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaGroupsBuildsCreateToManyRelationshipResponse = z.void();

export const zBetaGroupsBuildsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Builds with get
 */
export const zBetaGroupsBuildsGetToManyRelatedResponse = zBuildsWithoutIncludesResponse;

export const zBetaLicenseAgreementsAppGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBetaLicenseAgreementsAppGetToOneRelationshipResponse = zBetaLicenseAgreementAppLinkageResponse;

export const zBetaLicenseAgreementsAppGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ])))
    }))
});

/**
 * Single App with get
 */
export const zBetaLicenseAgreementsAppGetToOneRelatedResponse = zAppWithoutIncludesResponse;

export const zBetaTestersAppsDeleteToManyRelationshipData = z.object({
    body: zBetaTesterAppsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

export const zBetaTestersAppsDeleteToManyRelationshipResponse = z.union([
    z.unknown(),
    z.void()
]);

export const zBetaTestersAppsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBetaTestersAppsGetToManyRelationshipResponse = zBetaTesterAppsLinkagesResponse;

export const zBetaTestersAppsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Apps with get
 */
export const zBetaTestersAppsGetToManyRelatedResponse = zAppsWithoutIncludesResponse;

export const zBetaTestersBetaGroupsDeleteToManyRelationshipData = z.object({
    body: zBetaTesterBetaGroupsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaTestersBetaGroupsDeleteToManyRelationshipResponse = z.void();

export const zBetaTestersBetaGroupsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBetaTestersBetaGroupsGetToManyRelationshipResponse = zBetaTesterBetaGroupsLinkagesResponse;

export const zBetaTestersBetaGroupsCreateToManyRelationshipData = z.object({
    body: zBetaTesterBetaGroupsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaTestersBetaGroupsCreateToManyRelationshipResponse = z.void();

export const zBetaTestersBetaGroupsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaGroups]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'isInternalGroup',
            'hasAccessToAllBuilds',
            'publicLinkEnabled',
            'publicLinkId',
            'publicLinkLimitEnabled',
            'publicLinkLimit',
            'publicLink',
            'feedbackEnabled',
            'iosBuildsAvailableForAppleSiliconMac',
            'iosBuildsAvailableForAppleVision',
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria',
            'betaRecruitmentCriterionCompatibleBuildCheck'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of BetaGroups with get
 */
export const zBetaTestersBetaGroupsGetToManyRelatedResponse = zBetaGroupsWithoutIncludesResponse;

export const zBetaTestersBuildsDeleteToManyRelationshipData = z.object({
    body: zBetaTesterBuildsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaTestersBuildsDeleteToManyRelationshipResponse = z.void();

export const zBetaTestersBuildsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBetaTestersBuildsGetToManyRelationshipResponse = zBetaTesterBuildsLinkagesResponse;

export const zBetaTestersBuildsCreateToManyRelationshipData = z.object({
    body: zBetaTesterBuildsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBetaTestersBuildsCreateToManyRelationshipResponse = z.void();

export const zBetaTestersBuildsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Builds with get
 */
export const zBetaTestersBuildsGetToManyRelatedResponse = zBuildsWithoutIncludesResponse;

export const zBuildBetaDetailsBuildGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBuildBetaDetailsBuildGetToOneRelationshipResponse = zBuildBetaDetailBuildLinkageResponse;

export const zBuildBetaDetailsBuildGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[preReleaseVersions]': z.optional(z.array(z.enum([
            'version',
            'platform',
            'builds',
            'app'
        ]))),
        'fields[betaTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'email',
            'inviteType',
            'state',
            'appDevices',
            'apps',
            'betaGroups',
            'builds'
        ]))),
        'fields[betaGroups]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'isInternalGroup',
            'hasAccessToAllBuilds',
            'publicLinkEnabled',
            'publicLinkId',
            'publicLinkLimitEnabled',
            'publicLinkLimit',
            'publicLink',
            'feedbackEnabled',
            'iosBuildsAvailableForAppleSiliconMac',
            'iosBuildsAvailableForAppleVision',
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria',
            'betaRecruitmentCriterionCompatibleBuildCheck'
        ]))),
        'fields[betaBuildLocalizations]': z.optional(z.array(z.enum([
            'whatsNew',
            'locale',
            'build'
        ]))),
        'fields[appEncryptionDeclarations]': z.optional(z.array(z.enum([
            'appDescription',
            'createdDate',
            'usesEncryption',
            'exempt',
            'containsProprietaryCryptography',
            'containsThirdPartyCryptography',
            'availableOnFrenchStore',
            'platform',
            'uploadedDate',
            'documentUrl',
            'documentName',
            'documentType',
            'appEncryptionDeclarationState',
            'codeValue',
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'fields[betaAppReviewSubmissions]': z.optional(z.array(z.enum([
            'betaReviewState',
            'submittedDate',
            'build'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[buildBetaDetails]': z.optional(z.array(z.enum([
            'autoNotifyEnabled',
            'internalBuildState',
            'externalBuildState',
            'build'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[buildIcons]': z.optional(z.array(z.enum([
            'iconAsset',
            'iconType',
            'masked',
            'name'
        ]))),
        'fields[buildBundles]': z.optional(z.array(z.enum([
            'bundleId',
            'bundleType',
            'sdkBuild',
            'platformBuild',
            'fileName',
            'hasSirikit',
            'hasOnDemandResources',
            'hasPrerenderedIcon',
            'usesLocationServices',
            'isIosBuildMacAppStoreCompatible',
            'includesSymbols',
            'dSYMUrl',
            'supportedArchitectures',
            'requiredCapabilities',
            'deviceProtocols',
            'locales',
            'entitlements',
            'baDownloadAllowance',
            'baMaxInstallSize',
            'appClipDomainCacheStatus',
            'appClipDomainDebugStatus',
            'betaAppClipInvocations',
            'buildBundleFileSizes'
        ]))),
        'fields[buildUploads]': z.optional(z.array(z.enum([
            'cfBundleShortVersionString',
            'cfBundleVersion',
            'createdDate',
            'state',
            'platform',
            'uploadedDate',
            'build',
            'assetFile',
            'assetDescriptionFile',
            'assetSpiFile',
            'buildUploadFiles'
        ]))),
        include: z.optional(z.array(z.enum([
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload'
        ]))),
        'limit[individualTesters]': z.optional(z.int().lte(50)),
        'limit[betaGroups]': z.optional(z.int().lte(50)),
        'limit[betaBuildLocalizations]': z.optional(z.int().lte(50)),
        'limit[icons]': z.optional(z.int().lte(50)),
        'limit[buildBundles]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single Build
 */
export const zBuildBetaDetailsBuildGetToOneRelatedResponse = zBuildResponse;

export const zBuildBundlesAppClipDomainCacheStatusGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBuildBundlesAppClipDomainCacheStatusGetToOneRelationshipResponse = zBuildBundleAppClipDomainCacheStatusLinkageResponse;

export const zBuildBundlesAppClipDomainCacheStatusGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appClipDomainStatuses]': z.optional(z.array(z.enum(['domains', 'lastUpdatedDate'])))
    }))
});

/**
 * Single AppClipDomainStatus
 */
export const zBuildBundlesAppClipDomainCacheStatusGetToOneRelatedResponse = zAppClipDomainStatusResponse;

export const zBuildBundlesAppClipDomainDebugStatusGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBuildBundlesAppClipDomainDebugStatusGetToOneRelationshipResponse = zBuildBundleAppClipDomainDebugStatusLinkageResponse;

export const zBuildBundlesAppClipDomainDebugStatusGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appClipDomainStatuses]': z.optional(z.array(z.enum(['domains', 'lastUpdatedDate'])))
    }))
});

/**
 * Single AppClipDomainStatus
 */
export const zBuildBundlesAppClipDomainDebugStatusGetToOneRelatedResponse = zAppClipDomainStatusResponse;

export const zBuildBundlesBetaAppClipInvocationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBuildBundlesBetaAppClipInvocationsGetToManyRelationshipResponse = zBuildBundleBetaAppClipInvocationsLinkagesResponse;

export const zBuildBundlesBetaAppClipInvocationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaAppClipInvocations]': z.optional(z.array(z.enum(['url', 'betaAppClipInvocationLocalizations']))),
        'fields[betaAppClipInvocationLocalizations]': z.optional(z.array(z.enum(['title', 'locale']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['betaAppClipInvocationLocalizations']))),
        'limit[betaAppClipInvocationLocalizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of BetaAppClipInvocations
 */
export const zBuildBundlesBetaAppClipInvocationsGetToManyRelatedResponse = zBetaAppClipInvocationsResponse;

export const zBuildBundlesBuildBundleFileSizesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBuildBundlesBuildBundleFileSizesGetToManyRelationshipResponse = zBuildBundleBuildBundleFileSizesLinkagesResponse;

export const zBuildBundlesBuildBundleFileSizesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[buildBundleFileSizes]': z.optional(z.array(z.enum([
            'deviceModel',
            'osVersion',
            'downloadBytes',
            'installBytes'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of BuildBundleFileSizes
 */
export const zBuildBundlesBuildBundleFileSizesGetToManyRelatedResponse = zBuildBundleFileSizesResponse;

export const zBuildUploadsBuildUploadFilesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBuildUploadsBuildUploadFilesGetToManyRelationshipResponse = zBuildUploadBuildUploadFilesLinkagesResponse;

export const zBuildUploadsBuildUploadFilesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[buildUploadFiles]': z.optional(z.array(z.enum([
            'assetDeliveryState',
            'assetToken',
            'assetType',
            'fileName',
            'fileSize',
            'sourceFileChecksums',
            'uploadOperations',
            'uti'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of BuildUploadFiles
 */
export const zBuildUploadsBuildUploadFilesGetToManyRelatedResponse = zBuildUploadFilesResponse;

export const zBuildsAppGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBuildsAppGetToOneRelationshipResponse = zBuildAppLinkageResponse;

export const zBuildsAppGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ])))
    }))
});

/**
 * Single App with get
 */
export const zBuildsAppGetToOneRelatedResponse = zAppWithoutIncludesResponse;

export const zBuildsAppEncryptionDeclarationGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBuildsAppEncryptionDeclarationGetToOneRelationshipResponse = zBuildAppEncryptionDeclarationLinkageResponse;

export const zBuildsAppEncryptionDeclarationUpdateToOneRelationshipData = z.object({
    body: zBuildAppEncryptionDeclarationLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBuildsAppEncryptionDeclarationUpdateToOneRelationshipResponse = z.void();

export const zBuildsAppEncryptionDeclarationGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appEncryptionDeclarations]': z.optional(z.array(z.enum([
            'appDescription',
            'createdDate',
            'usesEncryption',
            'exempt',
            'containsProprietaryCryptography',
            'containsThirdPartyCryptography',
            'availableOnFrenchStore',
            'platform',
            'uploadedDate',
            'documentUrl',
            'documentName',
            'documentType',
            'appEncryptionDeclarationState',
            'codeValue',
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ])))
    }))
});

/**
 * Single AppEncryptionDeclaration with get
 */
export const zBuildsAppEncryptionDeclarationGetToOneRelatedResponse = zAppEncryptionDeclarationWithoutIncludesResponse;

export const zBuildsAppStoreVersionGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBuildsAppStoreVersionGetToOneRelationshipResponse = zBuildAppStoreVersionLinkageResponse;

export const zBuildsAppStoreVersionGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[ageRatingDeclarations]': z.optional(z.array(z.enum([
            'advertising',
            'alcoholTobaccoOrDrugUseOrReferences',
            'contests',
            'gambling',
            'gamblingSimulated',
            'gunsOrOtherWeapons',
            'healthOrWellnessTopics',
            'kidsAgeBand',
            'lootBox',
            'medicalOrTreatmentInformation',
            'messagingAndChat',
            'parentalControls',
            'profanityOrCrudeHumor',
            'ageAssurance',
            'sexualContentGraphicAndNudity',
            'sexualContentOrNudity',
            'horrorOrFearThemes',
            'matureOrSuggestiveThemes',
            'unrestrictedWebAccess',
            'userGeneratedContent',
            'violenceCartoonOrFantasy',
            'violenceRealisticProlongedGraphicOrSadistic',
            'violenceRealistic',
            'ageRatingOverride',
            'ageRatingOverrideV2',
            'koreaAgeRatingOverride',
            'developerAgeRatingInfoUrl'
        ]))),
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[appStoreVersionPhasedReleases]': z.optional(z.array(z.enum([
            'phasedReleaseState',
            'startDate',
            'totalPauseDuration',
            'currentDayNumber'
        ]))),
        'fields[gameCenterAppVersions]': z.optional(z.array(z.enum([
            'enabled',
            'compatibilityVersions',
            'appStoreVersion'
        ]))),
        'fields[routingAppCoverages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState',
            'appStoreVersion'
        ]))),
        'fields[appStoreReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'appStoreVersion',
            'appStoreReviewAttachments'
        ]))),
        'fields[appStoreVersionSubmissions]': z.optional(z.array(z.enum(['appStoreVersion']))),
        'fields[appClipDefaultExperiences]': z.optional(z.array(z.enum([
            'action',
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'appStoreVersion',
            'appStoreVersionExperimentTreatments',
            'platform',
            'app',
            'latestControlVersion',
            'controlVersions'
        ]))),
        'fields[alternativeDistributionPackages]': z.optional(z.array(z.enum(['sourceFileChecksum', 'versions']))),
        include: z.optional(z.array(z.enum([
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionPackage'
        ]))),
        'limit[appStoreVersionLocalizations]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperiments]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperimentsV2]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppStoreVersion
 */
export const zBuildsAppStoreVersionGetToOneRelatedResponse = zAppStoreVersionResponse;

export const zBuildsBetaAppReviewSubmissionGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBuildsBetaAppReviewSubmissionGetToOneRelationshipResponse = zBuildBetaAppReviewSubmissionLinkageResponse;

export const zBuildsBetaAppReviewSubmissionGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaAppReviewSubmissions]': z.optional(z.array(z.enum([
            'betaReviewState',
            'submittedDate',
            'build'
        ])))
    }))
});

/**
 * Single BetaAppReviewSubmission with get
 */
export const zBuildsBetaAppReviewSubmissionGetToOneRelatedResponse = zBetaAppReviewSubmissionWithoutIncludesResponse;

export const zBuildsBetaBuildLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBuildsBetaBuildLocalizationsGetToManyRelationshipResponse = zBuildBetaBuildLocalizationsLinkagesResponse;

export const zBuildsBetaBuildLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaBuildLocalizations]': z.optional(z.array(z.enum([
            'whatsNew',
            'locale',
            'build'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of BetaBuildLocalizations with get
 */
export const zBuildsBetaBuildLocalizationsGetToManyRelatedResponse = zBetaBuildLocalizationsWithoutIncludesResponse;

export const zBuildsBetaGroupsDeleteToManyRelationshipData = z.object({
    body: zBuildBetaGroupsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBuildsBetaGroupsDeleteToManyRelationshipResponse = z.void();

export const zBuildsBetaGroupsCreateToManyRelationshipData = z.object({
    body: zBuildBetaGroupsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBuildsBetaGroupsCreateToManyRelationshipResponse = z.void();

export const zBuildsBuildBetaDetailGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBuildsBuildBetaDetailGetToOneRelationshipResponse = zBuildBuildBetaDetailLinkageResponse;

export const zBuildsBuildBetaDetailGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[buildBetaDetails]': z.optional(z.array(z.enum([
            'autoNotifyEnabled',
            'internalBuildState',
            'externalBuildState',
            'build'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        include: z.optional(z.array(z.enum(['build'])))
    }))
});

/**
 * Single BuildBetaDetail
 */
export const zBuildsBuildBetaDetailGetToOneRelatedResponse = zBuildBetaDetailResponse;

export const zBuildsDiagnosticSignaturesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBuildsDiagnosticSignaturesGetToManyRelationshipResponse = zBuildDiagnosticSignaturesLinkagesResponse;

export const zBuildsDiagnosticSignaturesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[diagnosticType]': z.optional(z.array(z.enum([
            'DISK_WRITES',
            'HANGS',
            'LAUNCHES'
        ]))),
        'fields[diagnosticSignatures]': z.optional(z.array(z.enum([
            'diagnosticType',
            'signature',
            'weight',
            'insight',
            'logs'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of DiagnosticSignatures
 */
export const zBuildsDiagnosticSignaturesGetToManyRelatedResponse = zDiagnosticSignaturesResponse;

export const zBuildsIconsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBuildsIconsGetToManyRelationshipResponse = zBuildIconsLinkagesResponse;

export const zBuildsIconsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[buildIcons]': z.optional(z.array(z.enum([
            'iconAsset',
            'iconType',
            'masked',
            'name'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of BuildIcons with get
 */
export const zBuildsIconsGetToManyRelatedResponse = zBuildIconsWithoutIncludesResponse;

export const zBuildsIndividualTestersDeleteToManyRelationshipData = z.object({
    body: zBuildIndividualTestersLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBuildsIndividualTestersDeleteToManyRelationshipResponse = z.void();

export const zBuildsIndividualTestersGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBuildsIndividualTestersGetToManyRelationshipResponse = zBuildIndividualTestersLinkagesResponse;

export const zBuildsIndividualTestersCreateToManyRelationshipData = z.object({
    body: zBuildIndividualTestersLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zBuildsIndividualTestersCreateToManyRelationshipResponse = z.void();

export const zBuildsIndividualTestersGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[betaTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'email',
            'inviteType',
            'state',
            'appDevices',
            'apps',
            'betaGroups',
            'builds'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of BetaTesters with get
 */
export const zBuildsIndividualTestersGetToManyRelatedResponse = zBetaTestersWithoutIncludesResponse;

export const zBuildsPerfPowerMetricsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[platform]': z.optional(z.array(z.enum(['IOS']))),
        'filter[metricType]': z.optional(z.array(z.enum([
            'DISK',
            'HANG',
            'BATTERY',
            'LAUNCH',
            'MEMORY',
            'ANIMATION',
            'TERMINATION'
        ]))),
        'filter[deviceType]': z.optional(z.array(z.string()))
    }))
});

/**
 * List of PerfPowerMetrics
 */
export const zBuildsPerfPowerMetricsGetToManyRelatedResponse = zXcodeMetrics;

export const zBuildsPreReleaseVersionGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBuildsPreReleaseVersionGetToOneRelationshipResponse = zBuildPreReleaseVersionLinkageResponse;

export const zBuildsPreReleaseVersionGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[preReleaseVersions]': z.optional(z.array(z.enum([
            'version',
            'platform',
            'builds',
            'app'
        ])))
    }))
});

/**
 * Single PrereleaseVersion with get
 */
export const zBuildsPreReleaseVersionGetToOneRelatedResponse = zPrereleaseVersionWithoutIncludesResponse;

export const zBundleIdsAppGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zBundleIdsAppGetToOneRelationshipResponse = zBundleIdAppLinkageResponse;

export const zBundleIdsAppGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ])))
    }))
});

/**
 * Single App with get
 */
export const zBundleIdsAppGetToOneRelatedResponse = zAppWithoutIncludesResponse;

export const zBundleIdsBundleIdCapabilitiesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBundleIdsBundleIdCapabilitiesGetToManyRelationshipResponse = zBundleIdBundleIdCapabilitiesLinkagesResponse;

export const zBundleIdsBundleIdCapabilitiesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[bundleIdCapabilities]': z.optional(z.array(z.enum(['capabilityType', 'settings']))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of BundleIdCapabilities with get
 */
export const zBundleIdsBundleIdCapabilitiesGetToManyRelatedResponse = zBundleIdCapabilitiesWithoutIncludesResponse;

export const zBundleIdsProfilesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zBundleIdsProfilesGetToManyRelationshipResponse = zBundleIdProfilesLinkagesResponse;

export const zBundleIdsProfilesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[profiles]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'profileType',
            'profileState',
            'profileContent',
            'uuid',
            'createdDate',
            'expirationDate',
            'bundleId',
            'devices',
            'certificates'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Profiles with get
 */
export const zBundleIdsProfilesGetToManyRelatedResponse = zProfilesWithoutIncludesResponse;

export const zCertificatesPassTypeIdGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zCertificatesPassTypeIdGetToOneRelationshipResponse = zCertificatePassTypeIdLinkageResponse;

export const zCertificatesPassTypeIdGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[passTypeIds]': z.optional(z.array(z.enum([
            'name',
            'identifier',
            'certificates'
        ]))),
        'fields[certificates]': z.optional(z.array(z.enum([
            'name',
            'certificateType',
            'displayName',
            'serialNumber',
            'platform',
            'expirationDate',
            'certificateContent',
            'activated',
            'passTypeId'
        ]))),
        include: z.optional(z.array(z.enum(['certificates']))),
        'limit[certificates]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single PassTypeId
 */
export const zCertificatesPassTypeIdGetToOneRelatedResponse = zPassTypeIdResponse;

export const zCiBuildActionsArtifactsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zCiBuildActionsArtifactsGetToManyRelationshipResponse = zCiBuildActionArtifactsLinkagesResponse;

export const zCiBuildActionsArtifactsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciArtifacts]': z.optional(z.array(z.enum([
            'fileType',
            'fileName',
            'fileSize',
            'downloadUrl'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of CiArtifacts
 */
export const zCiBuildActionsArtifactsGetToManyRelatedResponse = zCiArtifactsResponse;

export const zCiBuildActionsBuildRunGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zCiBuildActionsBuildRunGetToOneRelationshipResponse = zCiBuildActionBuildRunLinkageResponse;

export const zCiBuildActionsBuildRunGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciBuildRuns]': z.optional(z.array(z.enum([
            'number',
            'createdDate',
            'startedDate',
            'finishedDate',
            'sourceCommit',
            'destinationCommit',
            'isPullRequestBuild',
            'issueCounts',
            'executionProgress',
            'completionStatus',
            'startReason',
            'cancelReason',
            'builds',
            'workflow',
            'product',
            'sourceBranchOrTag',
            'destinationBranch',
            'actions',
            'pullRequest'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[ciWorkflows]': z.optional(z.array(z.enum([
            'name',
            'description',
            'branchStartCondition',
            'tagStartCondition',
            'pullRequestStartCondition',
            'scheduledStartCondition',
            'manualBranchStartCondition',
            'manualTagStartCondition',
            'manualPullRequestStartCondition',
            'actions',
            'isEnabled',
            'isLockedForEditing',
            'clean',
            'containerFilePath',
            'lastModifiedDate',
            'product',
            'repository',
            'xcodeVersion',
            'macOsVersion',
            'buildRuns'
        ]))),
        'fields[ciProducts]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'productType',
            'app',
            'bundleId',
            'workflows',
            'primaryRepositories',
            'additionalRepositories',
            'buildRuns'
        ]))),
        'fields[scmGitReferences]': z.optional(z.array(z.enum([
            'name',
            'canonicalName',
            'isDeleted',
            'kind',
            'repository'
        ]))),
        'fields[scmPullRequests]': z.optional(z.array(z.enum([
            'title',
            'number',
            'webUrl',
            'sourceRepositoryOwner',
            'sourceRepositoryName',
            'sourceBranchName',
            'destinationRepositoryOwner',
            'destinationRepositoryName',
            'destinationBranchName',
            'isClosed',
            'isCrossRepository',
            'repository'
        ]))),
        include: z.optional(z.array(z.enum([
            'builds',
            'workflow',
            'product',
            'sourceBranchOrTag',
            'destinationBranch',
            'pullRequest'
        ]))),
        'limit[builds]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single CiBuildRun
 */
export const zCiBuildActionsBuildRunGetToOneRelatedResponse = zCiBuildRunResponse;

export const zCiBuildActionsIssuesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zCiBuildActionsIssuesGetToManyRelationshipResponse = zCiBuildActionIssuesLinkagesResponse;

export const zCiBuildActionsIssuesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciIssues]': z.optional(z.array(z.enum([
            'issueType',
            'message',
            'fileSource',
            'category'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of CiIssues
 */
export const zCiBuildActionsIssuesGetToManyRelatedResponse = zCiIssuesResponse;

export const zCiBuildActionsTestResultsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zCiBuildActionsTestResultsGetToManyRelationshipResponse = zCiBuildActionTestResultsLinkagesResponse;

export const zCiBuildActionsTestResultsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciTestResults]': z.optional(z.array(z.enum([
            'className',
            'name',
            'status',
            'fileSource',
            'message',
            'destinationTestResults'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of CiTestResults
 */
export const zCiBuildActionsTestResultsGetToManyRelatedResponse = zCiTestResultsResponse;

export const zCiBuildRunsActionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zCiBuildRunsActionsGetToManyRelationshipResponse = zCiBuildRunActionsLinkagesResponse;

export const zCiBuildRunsActionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciBuildActions]': z.optional(z.array(z.enum([
            'name',
            'actionType',
            'startedDate',
            'finishedDate',
            'issueCounts',
            'executionProgress',
            'completionStatus',
            'isRequiredToPass',
            'buildRun',
            'artifacts',
            'issues',
            'testResults'
        ]))),
        'fields[ciBuildRuns]': z.optional(z.array(z.enum([
            'number',
            'createdDate',
            'startedDate',
            'finishedDate',
            'sourceCommit',
            'destinationCommit',
            'isPullRequestBuild',
            'issueCounts',
            'executionProgress',
            'completionStatus',
            'startReason',
            'cancelReason',
            'builds',
            'workflow',
            'product',
            'sourceBranchOrTag',
            'destinationBranch',
            'actions',
            'pullRequest'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['buildRun'])))
    }))
});

/**
 * List of CiBuildActions
 */
export const zCiBuildRunsActionsGetToManyRelatedResponse = zCiBuildActionsResponse;

export const zCiBuildRunsBuildsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zCiBuildRunsBuildsGetToManyRelationshipResponse = zCiBuildRunBuildsLinkagesResponse;

export const zCiBuildRunsBuildsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[version]': z.optional(z.array(z.string())),
        'filter[expired]': z.optional(z.array(z.string())),
        'filter[processingState]': z.optional(z.array(z.enum([
            'PROCESSING',
            'FAILED',
            'INVALID',
            'VALID'
        ]))),
        'filter[betaAppReviewSubmission.betaReviewState]': z.optional(z.array(z.enum([
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'REJECTED',
            'APPROVED'
        ]))),
        'filter[usesNonExemptEncryption]': z.optional(z.array(z.string())),
        'filter[preReleaseVersion.version]': z.optional(z.array(z.string())),
        'filter[preReleaseVersion.platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[buildAudienceType]': z.optional(z.array(z.enum(['INTERNAL_ONLY', 'APP_STORE_ELIGIBLE']))),
        'filter[preReleaseVersion]': z.optional(z.array(z.string())),
        'filter[app]': z.optional(z.array(z.string())),
        'filter[betaGroups]': z.optional(z.array(z.string())),
        'filter[appStoreVersion]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'exists[usesNonExemptEncryption]': z.optional(z.boolean()),
        sort: z.optional(z.array(z.enum([
            'version',
            '-version',
            'uploadedDate',
            '-uploadedDate',
            'preReleaseVersion',
            '-preReleaseVersion'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[preReleaseVersions]': z.optional(z.array(z.enum([
            'version',
            'platform',
            'builds',
            'app'
        ]))),
        'fields[betaTesters]': z.optional(z.array(z.enum([
            'firstName',
            'lastName',
            'email',
            'inviteType',
            'state',
            'appDevices',
            'apps',
            'betaGroups',
            'builds'
        ]))),
        'fields[betaGroups]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'isInternalGroup',
            'hasAccessToAllBuilds',
            'publicLinkEnabled',
            'publicLinkId',
            'publicLinkLimitEnabled',
            'publicLinkLimit',
            'publicLink',
            'feedbackEnabled',
            'iosBuildsAvailableForAppleSiliconMac',
            'iosBuildsAvailableForAppleVision',
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria',
            'betaRecruitmentCriterionCompatibleBuildCheck'
        ]))),
        'fields[betaBuildLocalizations]': z.optional(z.array(z.enum([
            'whatsNew',
            'locale',
            'build'
        ]))),
        'fields[appEncryptionDeclarations]': z.optional(z.array(z.enum([
            'appDescription',
            'createdDate',
            'usesEncryption',
            'exempt',
            'containsProprietaryCryptography',
            'containsThirdPartyCryptography',
            'availableOnFrenchStore',
            'platform',
            'uploadedDate',
            'documentUrl',
            'documentName',
            'documentType',
            'appEncryptionDeclarationState',
            'codeValue',
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'fields[betaAppReviewSubmissions]': z.optional(z.array(z.enum([
            'betaReviewState',
            'submittedDate',
            'build'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[buildBetaDetails]': z.optional(z.array(z.enum([
            'autoNotifyEnabled',
            'internalBuildState',
            'externalBuildState',
            'build'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[buildIcons]': z.optional(z.array(z.enum([
            'iconAsset',
            'iconType',
            'masked',
            'name'
        ]))),
        'fields[buildBundles]': z.optional(z.array(z.enum([
            'bundleId',
            'bundleType',
            'sdkBuild',
            'platformBuild',
            'fileName',
            'hasSirikit',
            'hasOnDemandResources',
            'hasPrerenderedIcon',
            'usesLocationServices',
            'isIosBuildMacAppStoreCompatible',
            'includesSymbols',
            'dSYMUrl',
            'supportedArchitectures',
            'requiredCapabilities',
            'deviceProtocols',
            'locales',
            'entitlements',
            'baDownloadAllowance',
            'baMaxInstallSize',
            'appClipDomainCacheStatus',
            'appClipDomainDebugStatus',
            'betaAppClipInvocations',
            'buildBundleFileSizes'
        ]))),
        'fields[buildUploads]': z.optional(z.array(z.enum([
            'cfBundleShortVersionString',
            'cfBundleVersion',
            'createdDate',
            'state',
            'platform',
            'uploadedDate',
            'build',
            'assetFile',
            'assetDescriptionFile',
            'assetSpiFile',
            'buildUploadFiles'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload'
        ]))),
        'limit[individualTesters]': z.optional(z.int().lte(50)),
        'limit[betaGroups]': z.optional(z.int().lte(50)),
        'limit[betaBuildLocalizations]': z.optional(z.int().lte(50)),
        'limit[icons]': z.optional(z.int().lte(50)),
        'limit[buildBundles]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of Builds
 */
export const zCiBuildRunsBuildsGetToManyRelatedResponse = zBuildsResponse;

export const zCiMacOsVersionsXcodeVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zCiMacOsVersionsXcodeVersionsGetToManyRelationshipResponse = zCiMacOsVersionXcodeVersionsLinkagesResponse;

export const zCiMacOsVersionsXcodeVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciXcodeVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'testDestinations',
            'macOsVersions'
        ]))),
        'fields[ciMacOsVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'xcodeVersions'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['macOsVersions']))),
        'limit[macOsVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of CiXcodeVersions
 */
export const zCiMacOsVersionsXcodeVersionsGetToManyRelatedResponse = zCiXcodeVersionsResponse;

export const zCiProductsAdditionalRepositoriesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zCiProductsAdditionalRepositoriesGetToManyRelationshipResponse = zCiProductAdditionalRepositoriesLinkagesResponse;

export const zCiProductsAdditionalRepositoriesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[id]': z.optional(z.array(z.string())),
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        'fields[scmProviders]': z.optional(z.array(z.enum([
            'scmProviderType',
            'url',
            'repositories'
        ]))),
        'fields[scmGitReferences]': z.optional(z.array(z.enum([
            'name',
            'canonicalName',
            'isDeleted',
            'kind',
            'repository'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['scmProvider', 'defaultBranch'])))
    }))
});

/**
 * List of ScmRepositories
 */
export const zCiProductsAdditionalRepositoriesGetToManyRelatedResponse = zScmRepositoriesResponse;

export const zCiProductsAppGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zCiProductsAppGetToOneRelationshipResponse = zCiProductAppLinkageResponse;

export const zCiProductsAppGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[appEncryptionDeclarations]': z.optional(z.array(z.enum([
            'appDescription',
            'createdDate',
            'usesEncryption',
            'exempt',
            'containsProprietaryCryptography',
            'containsThirdPartyCryptography',
            'availableOnFrenchStore',
            'platform',
            'uploadedDate',
            'documentUrl',
            'documentName',
            'documentType',
            'appEncryptionDeclarationState',
            'codeValue',
            'app',
            'builds',
            'appEncryptionDeclarationDocument'
        ]))),
        'fields[buildIcons]': z.optional(z.array(z.enum([
            'iconAsset',
            'iconType',
            'masked',
            'name'
        ]))),
        'fields[ciProducts]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'productType',
            'app',
            'bundleId',
            'workflows',
            'primaryRepositories',
            'additionalRepositories',
            'buildRuns'
        ]))),
        'fields[betaGroups]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'isInternalGroup',
            'hasAccessToAllBuilds',
            'publicLinkEnabled',
            'publicLinkId',
            'publicLinkLimitEnabled',
            'publicLinkLimit',
            'publicLink',
            'feedbackEnabled',
            'iosBuildsAvailableForAppleSiliconMac',
            'iosBuildsAvailableForAppleVision',
            'app',
            'builds',
            'betaTesters',
            'betaRecruitmentCriteria',
            'betaRecruitmentCriterionCompatibleBuildCheck'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[preReleaseVersions]': z.optional(z.array(z.enum([
            'version',
            'platform',
            'builds',
            'app'
        ]))),
        'fields[betaAppLocalizations]': z.optional(z.array(z.enum([
            'feedbackEmail',
            'marketingUrl',
            'privacyPolicyUrl',
            'tvOsPrivacyPolicy',
            'description',
            'locale',
            'app'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[betaLicenseAgreements]': z.optional(z.array(z.enum(['agreementText', 'app']))),
        'fields[betaAppReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'app'
        ]))),
        'fields[appInfos]': z.optional(z.array(z.enum([
            'appStoreState',
            'state',
            'appStoreAgeRating',
            'australiaAgeRating',
            'brazilAgeRating',
            'brazilAgeRatingV2',
            'franceAgeRating',
            'koreaAgeRating',
            'kidsAgeBand',
            'app',
            'ageRatingDeclaration',
            'appInfoLocalizations',
            'primaryCategory',
            'primarySubcategoryOne',
            'primarySubcategoryTwo',
            'secondaryCategory',
            'secondarySubcategoryOne',
            'secondarySubcategoryTwo',
            'territoryAgeRatings'
        ]))),
        'fields[appClips]': z.optional(z.array(z.enum([
            'bundleId',
            'app',
            'appClipDefaultExperiences',
            'appClipAdvancedExperiences'
        ]))),
        'fields[endUserLicenseAgreements]': z.optional(z.array(z.enum([
            'agreementText',
            'app',
            'territories'
        ]))),
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'referenceName',
            'productId',
            'inAppPurchaseType',
            'state',
            'apps',
            'name',
            'reviewNote',
            'familySharable',
            'contentHosting',
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        'fields[subscriptionGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'subscriptions',
            'subscriptionGroupLocalizations'
        ]))),
        'fields[gameCenterEnabledVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'iconAsset',
            'compatibleVersions',
            'app'
        ]))),
        'fields[appCustomProductPages]': z.optional(z.array(z.enum([
            'name',
            'url',
            'visible',
            'app',
            'appCustomProductPageVersions'
        ]))),
        'fields[promotedPurchases]': z.optional(z.array(z.enum([
            'visibleForAllUsers',
            'enabled',
            'state',
            'inAppPurchaseV2',
            'subscription'
        ]))),
        'fields[appEvents]': z.optional(z.array(z.enum([
            'referenceName',
            'badge',
            'eventState',
            'deepLink',
            'purchaseRequirement',
            'primaryLocale',
            'priority',
            'purpose',
            'territorySchedules',
            'archivedTerritorySchedules',
            'localizations'
        ]))),
        'fields[reviewSubmissions]': z.optional(z.array(z.enum([
            'platform',
            'submittedDate',
            'state',
            'app',
            'items',
            'appStoreVersionForReview',
            'submittedByActor',
            'lastUpdatedByActor'
        ]))),
        'fields[subscriptionGracePeriods]': z.optional(z.array(z.enum([
            'optIn',
            'sandboxOptIn',
            'duration',
            'renewalType'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'app',
            'latestControlVersion',
            'controlVersions',
            'appStoreVersionExperimentTreatments'
        ]))),
        'fields[androidToIosAppMappingDetails]': z.optional(z.array(z.enum(['packageName', 'appSigningKeyPublicCertificateSha256Fingerprints']))),
        include: z.optional(z.array(z.enum([
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaGroups',
            'appStoreVersions',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'endUserLicenseAgreement',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'androidToIosAppMappingDetails'
        ]))),
        'limit[appEncryptionDeclarations]': z.optional(z.int().lte(50)),
        'limit[betaGroups]': z.optional(z.int().lte(50)),
        'limit[appStoreVersions]': z.optional(z.int().lte(50)),
        'limit[preReleaseVersions]': z.optional(z.int().lte(50)),
        'limit[betaAppLocalizations]': z.optional(z.int().lte(50)),
        'limit[builds]': z.optional(z.int().lte(50)),
        'limit[appInfos]': z.optional(z.int().lte(50)),
        'limit[appClips]': z.optional(z.int().lte(50)),
        'limit[inAppPurchases]': z.optional(z.int().lte(50)),
        'limit[subscriptionGroups]': z.optional(z.int().lte(50)),
        'limit[gameCenterEnabledVersions]': z.optional(z.int().lte(50)),
        'limit[appCustomProductPages]': z.optional(z.int().lte(50)),
        'limit[inAppPurchasesV2]': z.optional(z.int().lte(50)),
        'limit[promotedPurchases]': z.optional(z.int().lte(50)),
        'limit[appEvents]': z.optional(z.int().lte(50)),
        'limit[reviewSubmissions]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperimentsV2]': z.optional(z.int().lte(50)),
        'limit[androidToIosAppMappingDetails]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single App
 */
export const zCiProductsAppGetToOneRelatedResponse = zAppResponse;

export const zCiProductsBuildRunsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zCiProductsBuildRunsGetToManyRelationshipResponse = zCiProductBuildRunsLinkagesResponse;

export const zCiProductsBuildRunsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[builds]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum(['number', '-number']))),
        'fields[ciBuildRuns]': z.optional(z.array(z.enum([
            'number',
            'createdDate',
            'startedDate',
            'finishedDate',
            'sourceCommit',
            'destinationCommit',
            'isPullRequestBuild',
            'issueCounts',
            'executionProgress',
            'completionStatus',
            'startReason',
            'cancelReason',
            'builds',
            'workflow',
            'product',
            'sourceBranchOrTag',
            'destinationBranch',
            'actions',
            'pullRequest'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[ciWorkflows]': z.optional(z.array(z.enum([
            'name',
            'description',
            'branchStartCondition',
            'tagStartCondition',
            'pullRequestStartCondition',
            'scheduledStartCondition',
            'manualBranchStartCondition',
            'manualTagStartCondition',
            'manualPullRequestStartCondition',
            'actions',
            'isEnabled',
            'isLockedForEditing',
            'clean',
            'containerFilePath',
            'lastModifiedDate',
            'product',
            'repository',
            'xcodeVersion',
            'macOsVersion',
            'buildRuns'
        ]))),
        'fields[ciProducts]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'productType',
            'app',
            'bundleId',
            'workflows',
            'primaryRepositories',
            'additionalRepositories',
            'buildRuns'
        ]))),
        'fields[scmGitReferences]': z.optional(z.array(z.enum([
            'name',
            'canonicalName',
            'isDeleted',
            'kind',
            'repository'
        ]))),
        'fields[scmPullRequests]': z.optional(z.array(z.enum([
            'title',
            'number',
            'webUrl',
            'sourceRepositoryOwner',
            'sourceRepositoryName',
            'sourceBranchName',
            'destinationRepositoryOwner',
            'destinationRepositoryName',
            'destinationBranchName',
            'isClosed',
            'isCrossRepository',
            'repository'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'builds',
            'workflow',
            'product',
            'sourceBranchOrTag',
            'destinationBranch',
            'pullRequest'
        ]))),
        'limit[builds]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of CiBuildRuns
 */
export const zCiProductsBuildRunsGetToManyRelatedResponse = zCiBuildRunsResponse;

export const zCiProductsPrimaryRepositoriesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zCiProductsPrimaryRepositoriesGetToManyRelationshipResponse = zCiProductPrimaryRepositoriesLinkagesResponse;

export const zCiProductsPrimaryRepositoriesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[id]': z.optional(z.array(z.string())),
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        'fields[scmProviders]': z.optional(z.array(z.enum([
            'scmProviderType',
            'url',
            'repositories'
        ]))),
        'fields[scmGitReferences]': z.optional(z.array(z.enum([
            'name',
            'canonicalName',
            'isDeleted',
            'kind',
            'repository'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['scmProvider', 'defaultBranch'])))
    }))
});

/**
 * List of ScmRepositories
 */
export const zCiProductsPrimaryRepositoriesGetToManyRelatedResponse = zScmRepositoriesResponse;

export const zCiProductsWorkflowsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zCiProductsWorkflowsGetToManyRelationshipResponse = zCiProductWorkflowsLinkagesResponse;

export const zCiProductsWorkflowsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciWorkflows]': z.optional(z.array(z.enum([
            'name',
            'description',
            'branchStartCondition',
            'tagStartCondition',
            'pullRequestStartCondition',
            'scheduledStartCondition',
            'manualBranchStartCondition',
            'manualTagStartCondition',
            'manualPullRequestStartCondition',
            'actions',
            'isEnabled',
            'isLockedForEditing',
            'clean',
            'containerFilePath',
            'lastModifiedDate',
            'product',
            'repository',
            'xcodeVersion',
            'macOsVersion',
            'buildRuns'
        ]))),
        'fields[ciProducts]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'productType',
            'app',
            'bundleId',
            'workflows',
            'primaryRepositories',
            'additionalRepositories',
            'buildRuns'
        ]))),
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        'fields[ciXcodeVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'testDestinations',
            'macOsVersions'
        ]))),
        'fields[ciMacOsVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'xcodeVersions'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'product',
            'repository',
            'xcodeVersion',
            'macOsVersion'
        ])))
    }))
});

/**
 * List of CiWorkflows
 */
export const zCiProductsWorkflowsGetToManyRelatedResponse = zCiWorkflowsResponse;

export const zCiWorkflowsBuildRunsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zCiWorkflowsBuildRunsGetToManyRelationshipResponse = zCiWorkflowBuildRunsLinkagesResponse;

export const zCiWorkflowsBuildRunsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[builds]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum(['number', '-number']))),
        'fields[ciBuildRuns]': z.optional(z.array(z.enum([
            'number',
            'createdDate',
            'startedDate',
            'finishedDate',
            'sourceCommit',
            'destinationCommit',
            'isPullRequestBuild',
            'issueCounts',
            'executionProgress',
            'completionStatus',
            'startReason',
            'cancelReason',
            'builds',
            'workflow',
            'product',
            'sourceBranchOrTag',
            'destinationBranch',
            'actions',
            'pullRequest'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[ciWorkflows]': z.optional(z.array(z.enum([
            'name',
            'description',
            'branchStartCondition',
            'tagStartCondition',
            'pullRequestStartCondition',
            'scheduledStartCondition',
            'manualBranchStartCondition',
            'manualTagStartCondition',
            'manualPullRequestStartCondition',
            'actions',
            'isEnabled',
            'isLockedForEditing',
            'clean',
            'containerFilePath',
            'lastModifiedDate',
            'product',
            'repository',
            'xcodeVersion',
            'macOsVersion',
            'buildRuns'
        ]))),
        'fields[ciProducts]': z.optional(z.array(z.enum([
            'name',
            'createdDate',
            'productType',
            'app',
            'bundleId',
            'workflows',
            'primaryRepositories',
            'additionalRepositories',
            'buildRuns'
        ]))),
        'fields[scmGitReferences]': z.optional(z.array(z.enum([
            'name',
            'canonicalName',
            'isDeleted',
            'kind',
            'repository'
        ]))),
        'fields[scmPullRequests]': z.optional(z.array(z.enum([
            'title',
            'number',
            'webUrl',
            'sourceRepositoryOwner',
            'sourceRepositoryName',
            'sourceBranchName',
            'destinationRepositoryOwner',
            'destinationRepositoryName',
            'destinationBranchName',
            'isClosed',
            'isCrossRepository',
            'repository'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'builds',
            'workflow',
            'product',
            'sourceBranchOrTag',
            'destinationBranch',
            'pullRequest'
        ]))),
        'limit[builds]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of CiBuildRuns
 */
export const zCiWorkflowsBuildRunsGetToManyRelatedResponse = zCiBuildRunsResponse;

export const zCiWorkflowsRepositoryGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zCiWorkflowsRepositoryGetToOneRelationshipResponse = zCiWorkflowRepositoryLinkageResponse;

export const zCiWorkflowsRepositoryGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        'fields[scmProviders]': z.optional(z.array(z.enum([
            'scmProviderType',
            'url',
            'repositories'
        ]))),
        'fields[scmGitReferences]': z.optional(z.array(z.enum([
            'name',
            'canonicalName',
            'isDeleted',
            'kind',
            'repository'
        ]))),
        include: z.optional(z.array(z.enum(['scmProvider', 'defaultBranch'])))
    }))
});

/**
 * Single ScmRepository
 */
export const zCiWorkflowsRepositoryGetToOneRelatedResponse = zScmRepositoryResponse;

export const zCiXcodeVersionsMacOsVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zCiXcodeVersionsMacOsVersionsGetToManyRelationshipResponse = zCiXcodeVersionMacOsVersionsLinkagesResponse;

export const zCiXcodeVersionsMacOsVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[ciMacOsVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'xcodeVersions'
        ]))),
        'fields[ciXcodeVersions]': z.optional(z.array(z.enum([
            'version',
            'name',
            'testDestinations',
            'macOsVersions'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['xcodeVersions']))),
        'limit[xcodeVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of CiMacOsVersions
 */
export const zCiXcodeVersionsMacOsVersionsGetToManyRelatedResponse = zCiMacOsVersionsResponse;

export const zCustomerReviewsResponseGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zCustomerReviewsResponseGetToOneRelationshipResponse = zCustomerReviewResponseLinkageResponse;

export const zCustomerReviewsResponseGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[customerReviewResponses]': z.optional(z.array(z.enum([
            'responseBody',
            'lastModifiedDate',
            'state',
            'review'
        ]))),
        'fields[customerReviews]': z.optional(z.array(z.enum([
            'rating',
            'title',
            'body',
            'reviewerNickname',
            'createdDate',
            'territory',
            'response'
        ]))),
        include: z.optional(z.array(z.enum(['review'])))
    }))
});

/**
 * Single CustomerReviewResponse
 */
export const zCustomerReviewsResponseGetToOneRelatedResponse = zCustomerReviewResponseV1Response;

export const zDiagnosticSignaturesLogsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of DiagnosticLogs
 */
export const zDiagnosticSignaturesLogsGetToManyRelatedResponse = zDiagnosticLogs;

export const zEndUserLicenseAgreementsTerritoriesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zEndUserLicenseAgreementsTerritoriesGetToManyRelationshipResponse = zEndUserLicenseAgreementTerritoriesLinkagesResponse;

export const zEndUserLicenseAgreementsTerritoriesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Territories with get
 */
export const zEndUserLicenseAgreementsTerritoriesGetToManyRelatedResponse = zTerritoriesWithoutIncludesResponse;

export const zGameCenterAchievementLocalizationsV2ImageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterAchievementLocalizationsV2ImageGetToOneRelationshipResponse = zGameCenterAchievementLocalizationV2ImageLinkageResponse;

export const zGameCenterAchievementLocalizationsV2ImageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievementImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'localization'
        ]))),
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'version',
            'image'
        ]))),
        include: z.optional(z.array(z.enum(['localization'])))
    }))
});

/**
 * Single GameCenterAchievementImage
 */
export const zGameCenterAchievementLocalizationsV2ImageGetToOneRelatedResponse = zGameCenterAchievementImageV2Response;

export const zGameCenterAchievementLocalizationsGameCenterAchievementGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterAchievementLocalizationsGameCenterAchievementGetToOneRelationshipResponse = zGameCenterAchievementLocalizationGameCenterAchievementLinkageResponse;

export const zGameCenterAchievementLocalizationsGameCenterAchievementGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'gameCenterAchievement',
            'gameCenterAchievementImage'
        ]))),
        'fields[gameCenterAchievementReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterAchievement'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterAchievement
 */
export const zGameCenterAchievementLocalizationsGameCenterAchievementGetToOneRelatedResponse = zGameCenterAchievementResponse;

export const zGameCenterAchievementLocalizationsGameCenterAchievementImageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterAchievementLocalizationsGameCenterAchievementImageGetToOneRelationshipResponse = zGameCenterAchievementLocalizationGameCenterAchievementImageLinkageResponse;

export const zGameCenterAchievementLocalizationsGameCenterAchievementImageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievementImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'gameCenterAchievementLocalization'
        ]))),
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'gameCenterAchievement',
            'gameCenterAchievementImage'
        ]))),
        include: z.optional(z.array(z.enum(['gameCenterAchievementLocalization'])))
    }))
});

/**
 * Single GameCenterAchievementImage
 */
export const zGameCenterAchievementLocalizationsGameCenterAchievementImageGetToOneRelatedResponse = zGameCenterAchievementImageResponse;

export const zGameCenterAchievementVersionsV2LocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterAchievementVersionsV2LocalizationsGetToManyRelationshipResponse = zGameCenterAchievementVersionV2LocalizationsLinkagesResponse;

export const zGameCenterAchievementVersionsV2LocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'version',
            'image'
        ]))),
        'fields[gameCenterAchievementVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'achievement',
            'localizations'
        ]))),
        'fields[gameCenterAchievementImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'localization'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['version', 'image'])))
    }))
});

/**
 * List of GameCenterAchievementLocalizations
 */
export const zGameCenterAchievementVersionsV2LocalizationsGetToManyRelatedResponse = zGameCenterAchievementLocalizationsV2Response;

export const zGameCenterAchievementsV2ActivityUpdateToOneRelationshipData = z.object({
    body: zGameCenterAchievementV2ActivityLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterAchievementsV2ActivityUpdateToOneRelationshipResponse = z.void();

export const zGameCenterAchievementsV2VersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterAchievementsV2VersionsGetToManyRelationshipResponse = zGameCenterAchievementV2VersionsLinkagesResponse;

export const zGameCenterAchievementsV2VersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievementVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'achievement',
            'localizations'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'activity',
            'versions'
        ]))),
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'version',
            'image'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['achievement', 'localizations']))),
        'limit[localizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterAchievementVersions
 */
export const zGameCenterAchievementsV2VersionsGetToManyRelatedResponse = zGameCenterAchievementVersionsV2Response;

export const zGameCenterAchievementsActivityUpdateToOneRelationshipData = z.object({
    body: zGameCenterAchievementActivityLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterAchievementsActivityUpdateToOneRelationshipResponse = z.void();

export const zGameCenterAchievementsGroupAchievementGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterAchievementsGroupAchievementGetToOneRelationshipResponse = zGameCenterAchievementGroupAchievementLinkageResponse;

export const zGameCenterAchievementsGroupAchievementUpdateToOneRelationshipData = z.object({
    body: zGameCenterAchievementGroupAchievementLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterAchievementsGroupAchievementUpdateToOneRelationshipResponse = z.void();

export const zGameCenterAchievementsGroupAchievementGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'gameCenterAchievement',
            'gameCenterAchievementImage'
        ]))),
        'fields[gameCenterAchievementReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterAchievement'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterAchievement
 */
export const zGameCenterAchievementsGroupAchievementGetToOneRelatedResponse = zGameCenterAchievementResponse;

export const zGameCenterAchievementsLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterAchievementsLocalizationsGetToManyRelationshipResponse = zGameCenterAchievementLocalizationsLinkagesResponse;

export const zGameCenterAchievementsLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'gameCenterAchievement',
            'gameCenterAchievementImage'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        'fields[gameCenterAchievementImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'gameCenterAchievementLocalization'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['gameCenterAchievement', 'gameCenterAchievementImage'])))
    }))
});

/**
 * List of GameCenterAchievementLocalizations
 */
export const zGameCenterAchievementsLocalizationsGetToManyRelatedResponse = zGameCenterAchievementLocalizationsResponse;

export const zGameCenterAchievementsReleasesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterAchievementsReleasesGetToManyRelationshipResponse = zGameCenterAchievementReleasesLinkagesResponse;

export const zGameCenterAchievementsReleasesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[live]': z.optional(z.array(z.string())),
        'filter[gameCenterDetail]': z.optional(z.array(z.string())),
        'fields[gameCenterAchievementReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterAchievement'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['gameCenterDetail', 'gameCenterAchievement'])))
    }))
});

/**
 * List of GameCenterAchievementReleases
 */
export const zGameCenterAchievementsReleasesGetToManyRelatedResponse = zGameCenterAchievementReleasesResponse;

export const zGameCenterActivitiesAchievementsDeleteToManyRelationshipData = z.object({
    body: zGameCenterActivityAchievementsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterActivitiesAchievementsDeleteToManyRelationshipResponse = z.void();

export const zGameCenterActivitiesAchievementsCreateToManyRelationshipData = z.object({
    body: zGameCenterActivityAchievementsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterActivitiesAchievementsCreateToManyRelationshipResponse = z.void();

export const zGameCenterActivitiesAchievementsV2DeleteToManyRelationshipData = z.object({
    body: zGameCenterActivityAchievementsV2LinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterActivitiesAchievementsV2DeleteToManyRelationshipResponse = z.void();

export const zGameCenterActivitiesAchievementsV2CreateToManyRelationshipData = z.object({
    body: zGameCenterActivityAchievementsV2LinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterActivitiesAchievementsV2CreateToManyRelationshipResponse = z.void();

export const zGameCenterActivitiesLeaderboardsDeleteToManyRelationshipData = z.object({
    body: zGameCenterActivityLeaderboardsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterActivitiesLeaderboardsDeleteToManyRelationshipResponse = z.void();

export const zGameCenterActivitiesLeaderboardsCreateToManyRelationshipData = z.object({
    body: zGameCenterActivityLeaderboardsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterActivitiesLeaderboardsCreateToManyRelationshipResponse = z.void();

export const zGameCenterActivitiesLeaderboardsV2DeleteToManyRelationshipData = z.object({
    body: zGameCenterActivityLeaderboardsV2LinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterActivitiesLeaderboardsV2DeleteToManyRelationshipResponse = z.void();

export const zGameCenterActivitiesLeaderboardsV2CreateToManyRelationshipData = z.object({
    body: zGameCenterActivityLeaderboardsV2LinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterActivitiesLeaderboardsV2CreateToManyRelationshipResponse = z.void();

export const zGameCenterActivitiesVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterActivitiesVersionsGetToManyRelationshipResponse = zGameCenterActivityVersionsLinkagesResponse;

export const zGameCenterActivitiesVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterActivityVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'fallbackUrl',
            'activity',
            'localizations',
            'defaultImage',
            'releases'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterActivityLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'description',
            'version',
            'image'
        ]))),
        'fields[gameCenterActivityImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ]))),
        'fields[gameCenterActivityVersionReleases]': z.optional(z.array(z.enum(['version']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'activity',
            'localizations',
            'defaultImage',
            'releases'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterActivityVersions
 */
export const zGameCenterActivitiesVersionsGetToManyRelatedResponse = zGameCenterActivityVersionsResponse;

export const zGameCenterActivityLocalizationsImageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterActivityLocalizationsImageGetToOneRelationshipResponse = zGameCenterActivityLocalizationImageLinkageResponse;

export const zGameCenterActivityLocalizationsImageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterActivityImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ])))
    }))
});

/**
 * Single GameCenterActivityImage
 */
export const zGameCenterActivityLocalizationsImageGetToOneRelatedResponse = zGameCenterActivityImageResponse;

export const zGameCenterActivityVersionsDefaultImageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterActivityVersionsDefaultImageGetToOneRelationshipResponse = zGameCenterActivityVersionDefaultImageLinkageResponse;

export const zGameCenterActivityVersionsDefaultImageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterActivityImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ])))
    }))
});

/**
 * Single GameCenterActivityImage
 */
export const zGameCenterActivityVersionsDefaultImageGetToOneRelatedResponse = zGameCenterActivityImageResponse;

export const zGameCenterActivityVersionsLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterActivityVersionsLocalizationsGetToManyRelationshipResponse = zGameCenterActivityVersionLocalizationsLinkagesResponse;

export const zGameCenterActivityVersionsLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterActivityLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'description',
            'version',
            'image'
        ]))),
        'fields[gameCenterActivityVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'fallbackUrl',
            'activity',
            'localizations',
            'defaultImage',
            'releases'
        ]))),
        'fields[gameCenterActivityImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['version', 'image'])))
    }))
});

/**
 * List of GameCenterActivityLocalizations
 */
export const zGameCenterActivityVersionsLocalizationsGetToManyRelatedResponse = zGameCenterActivityLocalizationsResponse;

export const zGameCenterAppVersionsAppStoreVersionGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterAppVersionsAppStoreVersionGetToOneRelationshipResponse = zGameCenterAppVersionAppStoreVersionLinkageResponse;

export const zGameCenterAppVersionsAppStoreVersionGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[ageRatingDeclarations]': z.optional(z.array(z.enum([
            'advertising',
            'alcoholTobaccoOrDrugUseOrReferences',
            'contests',
            'gambling',
            'gamblingSimulated',
            'gunsOrOtherWeapons',
            'healthOrWellnessTopics',
            'kidsAgeBand',
            'lootBox',
            'medicalOrTreatmentInformation',
            'messagingAndChat',
            'parentalControls',
            'profanityOrCrudeHumor',
            'ageAssurance',
            'sexualContentGraphicAndNudity',
            'sexualContentOrNudity',
            'horrorOrFearThemes',
            'matureOrSuggestiveThemes',
            'unrestrictedWebAccess',
            'userGeneratedContent',
            'violenceCartoonOrFantasy',
            'violenceRealisticProlongedGraphicOrSadistic',
            'violenceRealistic',
            'ageRatingOverride',
            'ageRatingOverrideV2',
            'koreaAgeRatingOverride',
            'developerAgeRatingInfoUrl'
        ]))),
        'fields[appStoreVersionLocalizations]': z.optional(z.array(z.enum([
            'description',
            'locale',
            'keywords',
            'marketingUrl',
            'promotionalText',
            'supportUrl',
            'whatsNew',
            'appStoreVersion',
            'appScreenshotSets',
            'appPreviewSets',
            'searchKeywords'
        ]))),
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        'fields[appStoreVersionPhasedReleases]': z.optional(z.array(z.enum([
            'phasedReleaseState',
            'startDate',
            'totalPauseDuration',
            'currentDayNumber'
        ]))),
        'fields[gameCenterAppVersions]': z.optional(z.array(z.enum([
            'enabled',
            'compatibilityVersions',
            'appStoreVersion'
        ]))),
        'fields[routingAppCoverages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'uploadOperations',
            'assetDeliveryState',
            'appStoreVersion'
        ]))),
        'fields[appStoreReviewDetails]': z.optional(z.array(z.enum([
            'contactFirstName',
            'contactLastName',
            'contactPhone',
            'contactEmail',
            'demoAccountName',
            'demoAccountPassword',
            'demoAccountRequired',
            'notes',
            'appStoreVersion',
            'appStoreReviewAttachments'
        ]))),
        'fields[appStoreVersionSubmissions]': z.optional(z.array(z.enum(['appStoreVersion']))),
        'fields[appClipDefaultExperiences]': z.optional(z.array(z.enum([
            'action',
            'appClip',
            'releaseWithAppStoreVersion',
            'appClipDefaultExperienceLocalizations',
            'appClipAppStoreReviewDetail'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'appStoreVersion',
            'appStoreVersionExperimentTreatments',
            'platform',
            'app',
            'latestControlVersion',
            'controlVersions'
        ]))),
        'fields[alternativeDistributionPackages]': z.optional(z.array(z.enum(['sourceFileChecksum', 'versions']))),
        include: z.optional(z.array(z.enum([
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionPackage'
        ]))),
        'limit[appStoreVersionLocalizations]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperiments]': z.optional(z.int().lte(50)),
        'limit[appStoreVersionExperimentsV2]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single AppStoreVersion
 */
export const zGameCenterAppVersionsAppStoreVersionGetToOneRelatedResponse = zAppStoreVersionResponse;

export const zGameCenterAppVersionsCompatibilityVersionsDeleteToManyRelationshipData = z.object({
    body: zGameCenterAppVersionCompatibilityVersionsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterAppVersionsCompatibilityVersionsDeleteToManyRelationshipResponse = z.void();

export const zGameCenterAppVersionsCompatibilityVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterAppVersionsCompatibilityVersionsGetToManyRelationshipResponse = zGameCenterAppVersionCompatibilityVersionsLinkagesResponse;

export const zGameCenterAppVersionsCompatibilityVersionsCreateToManyRelationshipData = z.object({
    body: zGameCenterAppVersionCompatibilityVersionsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterAppVersionsCompatibilityVersionsCreateToManyRelationshipResponse = z.void();

export const zGameCenterAppVersionsCompatibilityVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[enabled]': z.optional(z.array(z.string())),
        'fields[gameCenterAppVersions]': z.optional(z.array(z.enum([
            'enabled',
            'compatibilityVersions',
            'appStoreVersion'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['compatibilityVersions', 'appStoreVersion']))),
        'limit[compatibilityVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterAppVersions
 */
export const zGameCenterAppVersionsCompatibilityVersionsGetToManyRelatedResponse = zGameCenterAppVersionsResponse;

export const zGameCenterChallengeLocalizationsImageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterChallengeLocalizationsImageGetToOneRelationshipResponse = zGameCenterChallengeLocalizationImageLinkageResponse;

export const zGameCenterChallengeLocalizationsImageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterChallengeImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ])))
    }))
});

/**
 * Single GameCenterChallengeImage
 */
export const zGameCenterChallengeLocalizationsImageGetToOneRelatedResponse = zGameCenterChallengeImageResponse;

export const zGameCenterChallengeVersionsDefaultImageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterChallengeVersionsDefaultImageGetToOneRelationshipResponse = zGameCenterChallengeVersionDefaultImageLinkageResponse;

export const zGameCenterChallengeVersionsDefaultImageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterChallengeImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ])))
    }))
});

/**
 * Single GameCenterChallengeImage
 */
export const zGameCenterChallengeVersionsDefaultImageGetToOneRelatedResponse = zGameCenterChallengeImageResponse;

export const zGameCenterChallengeVersionsLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterChallengeVersionsLocalizationsGetToManyRelationshipResponse = zGameCenterChallengeVersionLocalizationsLinkagesResponse;

export const zGameCenterChallengeVersionsLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterChallengeLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'description',
            'version',
            'image'
        ]))),
        'fields[gameCenterChallengeVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'challenge',
            'localizations',
            'releases',
            'defaultImage'
        ]))),
        'fields[gameCenterChallengeImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['version', 'image'])))
    }))
});

/**
 * List of GameCenterChallengeLocalizations
 */
export const zGameCenterChallengeVersionsLocalizationsGetToManyRelatedResponse = zGameCenterChallengeLocalizationsResponse;

export const zGameCenterChallengesLeaderboardUpdateToOneRelationshipData = z.object({
    body: zGameCenterChallengeLeaderboardLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterChallengesLeaderboardUpdateToOneRelationshipResponse = z.void();

export const zGameCenterChallengesLeaderboardV2UpdateToOneRelationshipData = z.object({
    body: zGameCenterChallengeLeaderboardV2LinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterChallengesLeaderboardV2UpdateToOneRelationshipResponse = z.void();

export const zGameCenterChallengesVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterChallengesVersionsGetToManyRelationshipResponse = zGameCenterChallengeVersionsLinkagesResponse;

export const zGameCenterChallengesVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterChallengeVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'challenge',
            'localizations',
            'releases',
            'defaultImage'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'fields[gameCenterChallengeLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'description',
            'version',
            'image'
        ]))),
        'fields[gameCenterChallengeVersionReleases]': z.optional(z.array(z.enum(['version']))),
        'fields[gameCenterChallengeImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'challenge',
            'localizations',
            'releases',
            'defaultImage'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterChallengeVersions
 */
export const zGameCenterChallengesVersionsGetToManyRelatedResponse = zGameCenterChallengeVersionsResponse;

export const zGameCenterDetailsAchievementReleasesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsAchievementReleasesGetToManyRelationshipResponse = zGameCenterDetailAchievementReleasesLinkagesResponse;

export const zGameCenterDetailsAchievementReleasesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[live]': z.optional(z.array(z.string())),
        'filter[gameCenterAchievement]': z.optional(z.array(z.string())),
        'fields[gameCenterAchievementReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterAchievement'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['gameCenterDetail', 'gameCenterAchievement'])))
    }))
});

/**
 * List of GameCenterAchievementReleases
 */
export const zGameCenterDetailsAchievementReleasesGetToManyRelatedResponse = zGameCenterAchievementReleasesResponse;

export const zGameCenterDetailsActivityReleasesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsActivityReleasesGetToManyRelationshipResponse = zGameCenterDetailActivityReleasesLinkagesResponse;

export const zGameCenterDetailsActivityReleasesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterActivityVersionReleases]': z.optional(z.array(z.enum(['version']))),
        'fields[gameCenterActivityVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'fallbackUrl',
            'activity',
            'localizations',
            'defaultImage',
            'releases'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['version'])))
    }))
});

/**
 * List of GameCenterActivityVersionReleases
 */
export const zGameCenterDetailsActivityReleasesGetToManyRelatedResponse = zGameCenterActivityVersionReleasesResponse;

export const zGameCenterDetailsChallengeReleasesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsChallengeReleasesGetToManyRelationshipResponse = zGameCenterDetailChallengeReleasesLinkagesResponse;

export const zGameCenterDetailsChallengeReleasesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterChallengeVersionReleases]': z.optional(z.array(z.enum(['version']))),
        'fields[gameCenterChallengeVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'challenge',
            'localizations',
            'releases',
            'defaultImage'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['version'])))
    }))
});

/**
 * List of GameCenterChallengeVersionReleases
 */
export const zGameCenterDetailsChallengeReleasesGetToManyRelatedResponse = zGameCenterChallengeVersionReleasesResponse;

export const zGameCenterDetailsChallengesMinimumPlatformVersionsReplaceToManyRelationshipData = z.object({
    body: zGameCenterDetailChallengesMinimumPlatformVersionsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterDetailsChallengesMinimumPlatformVersionsReplaceToManyRelationshipResponse = z.void();

export const zGameCenterDetailsGameCenterAchievementsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsGameCenterAchievementsGetToManyRelationshipResponse = zGameCenterDetailGameCenterAchievementsLinkagesResponse;

export const zGameCenterDetailsGameCenterAchievementsReplaceToManyRelationshipData = z.object({
    body: zGameCenterDetailGameCenterAchievementsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterDetailsGameCenterAchievementsReplaceToManyRelationshipResponse = z.void();

export const zGameCenterDetailsGameCenterAchievementsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'gameCenterAchievement',
            'gameCenterAchievementImage'
        ]))),
        'fields[gameCenterAchievementReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterAchievement'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterAchievements
 */
export const zGameCenterDetailsGameCenterAchievementsGetToManyRelatedResponse = zGameCenterAchievementsResponse;

export const zGameCenterDetailsGameCenterAchievementsV2GetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsGameCenterAchievementsV2GetToManyRelationshipResponse = zGameCenterDetailGameCenterAchievementsV2LinkagesResponse;

export const zGameCenterDetailsGameCenterAchievementsV2ReplaceToManyRelationshipData = z.object({
    body: zGameCenterDetailGameCenterAchievementsV2LinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterDetailsGameCenterAchievementsV2ReplaceToManyRelationshipResponse = z.void();

export const zGameCenterDetailsGameCenterAchievementsV2GetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'activity',
            'versions'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterAchievementVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'achievement',
            'localizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'activity',
            'versions'
        ]))),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterAchievements
 */
export const zGameCenterDetailsGameCenterAchievementsV2GetToManyRelatedResponse = zGameCenterAchievementsV2Response;

export const zGameCenterDetailsGameCenterActivitiesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsGameCenterActivitiesGetToManyRelationshipResponse = zGameCenterDetailGameCenterActivitiesLinkagesResponse;

export const zGameCenterDetailsGameCenterActivitiesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity',
            'versions'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterActivityVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'fallbackUrl',
            'activity',
            'localizations',
            'defaultImage',
            'releases'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'limit[achievements]': z.optional(z.int().lte(50)),
        'limit[achievementsV2]': z.optional(z.int().lte(50)),
        'limit[leaderboards]': z.optional(z.int().lte(50)),
        'limit[leaderboardsV2]': z.optional(z.int().lte(50)),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterActivities
 */
export const zGameCenterDetailsGameCenterActivitiesGetToManyRelatedResponse = zGameCenterActivitiesResponse;

export const zGameCenterDetailsGameCenterAppVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsGameCenterAppVersionsGetToManyRelationshipResponse = zGameCenterDetailGameCenterAppVersionsLinkagesResponse;

export const zGameCenterDetailsGameCenterAppVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[enabled]': z.optional(z.array(z.string())),
        'fields[gameCenterAppVersions]': z.optional(z.array(z.enum([
            'enabled',
            'compatibilityVersions',
            'appStoreVersion'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['compatibilityVersions', 'appStoreVersion']))),
        'limit[compatibilityVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterAppVersions
 */
export const zGameCenterDetailsGameCenterAppVersionsGetToManyRelatedResponse = zGameCenterAppVersionsResponse;

export const zGameCenterDetailsGameCenterChallengesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsGameCenterChallengesGetToManyRelationshipResponse = zGameCenterDetailGameCenterChallengesLinkagesResponse;

export const zGameCenterDetailsGameCenterChallengesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterChallengeVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'challenge',
            'localizations',
            'releases',
            'defaultImage'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge',
            'versions'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterChallenges
 */
export const zGameCenterDetailsGameCenterChallengesGetToManyRelatedResponse = zGameCenterChallengesResponse;

export const zGameCenterDetailsGameCenterGroupGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterDetailsGameCenterGroupGetToOneRelationshipResponse = zGameCenterDetailGameCenterGroupLinkageResponse;

export const zGameCenterDetailsGameCenterGroupGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases',
            'versions'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity',
            'versions'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'limit[gameCenterDetails]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardSetsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterAchievements]': z.optional(z.int().lte(50)),
        'limit[gameCenterAchievementsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterActivities]': z.optional(z.int().lte(50)),
        'limit[gameCenterChallenges]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterGroup
 */
export const zGameCenterDetailsGameCenterGroupGetToOneRelatedResponse = zGameCenterGroupResponse;

export const zGameCenterDetailsGameCenterLeaderboardSetsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsGameCenterLeaderboardSetsGetToManyRelationshipResponse = zGameCenterDetailGameCenterLeaderboardSetsLinkagesResponse;

export const zGameCenterDetailsGameCenterLeaderboardSetsReplaceToManyRelationshipData = z.object({
    body: zGameCenterDetailGameCenterLeaderboardSetsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterDetailsGameCenterLeaderboardSetsReplaceToManyRelationshipResponse = z.void();

export const zGameCenterDetailsGameCenterLeaderboardSetsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'gameCenterLeaderboardSet',
            'gameCenterLeaderboardSetImage'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'fields[gameCenterLeaderboardSetReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboardSet'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterLeaderboardSets
 */
export const zGameCenterDetailsGameCenterLeaderboardSetsGetToManyRelatedResponse = zGameCenterLeaderboardSetsResponse;

export const zGameCenterDetailsGameCenterLeaderboardSetsV2GetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsGameCenterLeaderboardSetsV2GetToManyRelationshipResponse = zGameCenterDetailGameCenterLeaderboardSetsV2LinkagesResponse;

export const zGameCenterDetailsGameCenterLeaderboardSetsV2ReplaceToManyRelationshipData = z.object({
    body: zGameCenterDetailGameCenterLeaderboardSetsV2LinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterDetailsGameCenterLeaderboardSetsV2ReplaceToManyRelationshipResponse = z.void();

export const zGameCenterDetailsGameCenterLeaderboardSetsV2GetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'versions'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboardSets',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterLeaderboardSetVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboardSet',
            'localizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'versions'
        ]))),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterLeaderboardSets
 */
export const zGameCenterDetailsGameCenterLeaderboardSetsV2GetToManyRelatedResponse = zGameCenterLeaderboardSetsV2Response;

export const zGameCenterDetailsGameCenterLeaderboardsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsGameCenterLeaderboardsGetToManyRelationshipResponse = zGameCenterDetailGameCenterLeaderboardsLinkagesResponse;

export const zGameCenterDetailsGameCenterLeaderboardsReplaceToManyRelationshipData = z.object({
    body: zGameCenterDetailGameCenterLeaderboardsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterDetailsGameCenterLeaderboardsReplaceToManyRelationshipResponse = z.void();

export const zGameCenterDetailsGameCenterLeaderboardsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'gameCenterLeaderboard',
            'gameCenterLeaderboardImage'
        ]))),
        'fields[gameCenterLeaderboardReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboard'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterLeaderboards
 */
export const zGameCenterDetailsGameCenterLeaderboardsGetToManyRelatedResponse = zGameCenterLeaderboardsResponse;

export const zGameCenterDetailsGameCenterLeaderboardsV2GetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsGameCenterLeaderboardsV2GetToManyRelationshipResponse = zGameCenterDetailGameCenterLeaderboardsV2LinkagesResponse;

export const zGameCenterDetailsGameCenterLeaderboardsV2ReplaceToManyRelationshipData = z.object({
    body: zGameCenterDetailGameCenterLeaderboardsV2LinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterDetailsGameCenterLeaderboardsV2ReplaceToManyRelationshipResponse = z.void();

export const zGameCenterDetailsGameCenterLeaderboardsV2GetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboardSets',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'versions'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'fields[gameCenterLeaderboardVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboard',
            'localizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboardSets',
            'activity',
            'challenge',
            'versions'
        ]))),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterLeaderboards
 */
export const zGameCenterDetailsGameCenterLeaderboardsV2GetToManyRelatedResponse = zGameCenterLeaderboardsV2Response;

export const zGameCenterDetailsLeaderboardReleasesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsLeaderboardReleasesGetToManyRelationshipResponse = zGameCenterDetailLeaderboardReleasesLinkagesResponse;

export const zGameCenterDetailsLeaderboardReleasesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[live]': z.optional(z.array(z.string())),
        'filter[gameCenterLeaderboard]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboardReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboard'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['gameCenterDetail', 'gameCenterLeaderboard'])))
    }))
});

/**
 * List of GameCenterLeaderboardReleases
 */
export const zGameCenterDetailsLeaderboardReleasesGetToManyRelatedResponse = zGameCenterLeaderboardReleasesResponse;

export const zGameCenterDetailsLeaderboardSetReleasesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterDetailsLeaderboardSetReleasesGetToManyRelationshipResponse = zGameCenterDetailLeaderboardSetReleasesLinkagesResponse;

export const zGameCenterDetailsLeaderboardSetReleasesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[live]': z.optional(z.array(z.string())),
        'filter[gameCenterLeaderboardSet]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboardSetReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboardSet'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['gameCenterDetail', 'gameCenterLeaderboardSet'])))
    }))
});

/**
 * List of GameCenterLeaderboardSetReleases
 */
export const zGameCenterDetailsLeaderboardSetReleasesGetToManyRelatedResponse = zGameCenterLeaderboardSetReleasesResponse;

export const zGameCenterEnabledVersionsCompatibleVersionsDeleteToManyRelationshipData = z.object({
    body: zGameCenterEnabledVersionCompatibleVersionsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterEnabledVersionsCompatibleVersionsDeleteToManyRelationshipResponse = z.void();

export const zGameCenterEnabledVersionsCompatibleVersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterEnabledVersionsCompatibleVersionsGetToManyRelationshipResponse = zGameCenterEnabledVersionCompatibleVersionsLinkagesResponse;

export const zGameCenterEnabledVersionsCompatibleVersionsReplaceToManyRelationshipData = z.object({
    body: zGameCenterEnabledVersionCompatibleVersionsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterEnabledVersionsCompatibleVersionsReplaceToManyRelationshipResponse = z.void();

export const zGameCenterEnabledVersionsCompatibleVersionsCreateToManyRelationshipData = z.object({
    body: zGameCenterEnabledVersionCompatibleVersionsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterEnabledVersionsCompatibleVersionsCreateToManyRelationshipResponse = z.void();

export const zGameCenterEnabledVersionsCompatibleVersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[platform]': z.optional(z.array(z.enum([
            'IOS',
            'MAC_OS',
            'TV_OS',
            'VISION_OS'
        ]))),
        'filter[versionString]': z.optional(z.array(z.string())),
        'filter[app]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum(['versionString', '-versionString']))),
        'fields[gameCenterEnabledVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'iconAsset',
            'compatibleVersions',
            'app'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['compatibleVersions', 'app']))),
        'limit[compatibleVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterEnabledVersions
 */
export const zGameCenterEnabledVersionsCompatibleVersionsGetToManyRelatedResponse = zGameCenterEnabledVersionsResponse;

export const zGameCenterGroupsGameCenterAchievementsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterGroupsGameCenterAchievementsGetToManyRelationshipResponse = zGameCenterGroupGameCenterAchievementsLinkagesResponse;

export const zGameCenterGroupsGameCenterAchievementsReplaceToManyRelationshipData = z.object({
    body: zGameCenterGroupGameCenterAchievementsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterGroupsGameCenterAchievementsReplaceToManyRelationshipResponse = z.void();

export const zGameCenterGroupsGameCenterAchievementsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterAchievementLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'beforeEarnedDescription',
            'afterEarnedDescription',
            'gameCenterAchievement',
            'gameCenterAchievementImage'
        ]))),
        'fields[gameCenterAchievementReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterAchievement'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterAchievements
 */
export const zGameCenterGroupsGameCenterAchievementsGetToManyRelatedResponse = zGameCenterAchievementsResponse;

export const zGameCenterGroupsGameCenterAchievementsV2GetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterGroupsGameCenterAchievementsV2GetToManyRelationshipResponse = zGameCenterGroupGameCenterAchievementsV2LinkagesResponse;

export const zGameCenterGroupsGameCenterAchievementsV2ReplaceToManyRelationshipData = z.object({
    body: zGameCenterGroupGameCenterAchievementsV2LinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterGroupsGameCenterAchievementsV2ReplaceToManyRelationshipResponse = z.void();

export const zGameCenterGroupsGameCenterAchievementsV2GetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'activity',
            'versions'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterAchievementVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'achievement',
            'localizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'activity',
            'versions'
        ]))),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterAchievements
 */
export const zGameCenterGroupsGameCenterAchievementsV2GetToManyRelatedResponse = zGameCenterAchievementsV2Response;

export const zGameCenterGroupsGameCenterActivitiesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterGroupsGameCenterActivitiesGetToManyRelationshipResponse = zGameCenterGroupGameCenterActivitiesLinkagesResponse;

export const zGameCenterGroupsGameCenterActivitiesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity',
            'versions'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterActivityVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'fallbackUrl',
            'activity',
            'localizations',
            'defaultImage',
            'releases'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'limit[achievements]': z.optional(z.int().lte(50)),
        'limit[achievementsV2]': z.optional(z.int().lte(50)),
        'limit[leaderboards]': z.optional(z.int().lte(50)),
        'limit[leaderboardsV2]': z.optional(z.int().lte(50)),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterActivities
 */
export const zGameCenterGroupsGameCenterActivitiesGetToManyRelatedResponse = zGameCenterActivitiesResponse;

export const zGameCenterGroupsGameCenterChallengesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterGroupsGameCenterChallengesGetToManyRelationshipResponse = zGameCenterGroupGameCenterChallengesLinkagesResponse;

export const zGameCenterGroupsGameCenterChallengesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterChallengeVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'challenge',
            'localizations',
            'releases',
            'defaultImage'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge',
            'versions'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterChallenges
 */
export const zGameCenterGroupsGameCenterChallengesGetToManyRelatedResponse = zGameCenterChallengesResponse;

export const zGameCenterGroupsGameCenterDetailsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterGroupsGameCenterDetailsGetToManyRelationshipResponse = zGameCenterGroupGameCenterDetailsLinkagesResponse;

export const zGameCenterGroupsGameCenterDetailsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[gameCenterAppVersions.enabled]': z.optional(z.array(z.string())),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        'fields[gameCenterAppVersions]': z.optional(z.array(z.enum([
            'enabled',
            'compatibilityVersions',
            'appStoreVersion'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases',
            'versions'
        ]))),
        'fields[gameCenterAchievements]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'points',
            'showBeforeEarned',
            'repeatable',
            'archived',
            'activityProperties',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupAchievement',
            'localizations',
            'releases',
            'activity',
            'versions'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'fields[gameCenterAchievementReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterAchievement'
        ]))),
        'fields[gameCenterActivityVersionReleases]': z.optional(z.array(z.enum(['version']))),
        'fields[gameCenterChallengeVersionReleases]': z.optional(z.array(z.enum(['version']))),
        'fields[gameCenterLeaderboardReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboard'
        ]))),
        'fields[gameCenterLeaderboardSetReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboardSet'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'limit[gameCenterAppVersions]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboardSetsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterAchievements]': z.optional(z.int().lte(50)),
        'limit[gameCenterAchievementsV2]': z.optional(z.int().lte(50)),
        'limit[gameCenterActivities]': z.optional(z.int().lte(50)),
        'limit[gameCenterChallenges]': z.optional(z.int().lte(50)),
        'limit[achievementReleases]': z.optional(z.int().lte(50)),
        'limit[activityReleases]': z.optional(z.int().lte(50)),
        'limit[challengeReleases]': z.optional(z.int().lte(50)),
        'limit[leaderboardReleases]': z.optional(z.int().lte(50)),
        'limit[leaderboardSetReleases]': z.optional(z.int().lte(50)),
        'limit[challengesMinimumPlatformVersions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterDetails
 */
export const zGameCenterGroupsGameCenterDetailsGetToManyRelatedResponse = zGameCenterDetailsResponse;

export const zGameCenterGroupsGameCenterLeaderboardSetsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterGroupsGameCenterLeaderboardSetsGetToManyRelationshipResponse = zGameCenterGroupGameCenterLeaderboardSetsLinkagesResponse;

export const zGameCenterGroupsGameCenterLeaderboardSetsReplaceToManyRelationshipData = z.object({
    body: zGameCenterGroupGameCenterLeaderboardSetsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterGroupsGameCenterLeaderboardSetsReplaceToManyRelationshipResponse = z.void();

export const zGameCenterGroupsGameCenterLeaderboardSetsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'gameCenterLeaderboardSet',
            'gameCenterLeaderboardSetImage'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'fields[gameCenterLeaderboardSetReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboardSet'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterLeaderboardSets
 */
export const zGameCenterGroupsGameCenterLeaderboardSetsGetToManyRelatedResponse = zGameCenterLeaderboardSetsResponse;

export const zGameCenterGroupsGameCenterLeaderboardSetsV2GetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterGroupsGameCenterLeaderboardSetsV2GetToManyRelationshipResponse = zGameCenterGroupGameCenterLeaderboardSetsV2LinkagesResponse;

export const zGameCenterGroupsGameCenterLeaderboardSetsV2ReplaceToManyRelationshipData = z.object({
    body: zGameCenterGroupGameCenterLeaderboardSetsV2LinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterGroupsGameCenterLeaderboardSetsV2ReplaceToManyRelationshipResponse = z.void();

export const zGameCenterGroupsGameCenterLeaderboardSetsV2GetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'versions'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboardSets',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterLeaderboardSetVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboardSet',
            'localizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'versions'
        ]))),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterLeaderboardSets
 */
export const zGameCenterGroupsGameCenterLeaderboardSetsV2GetToManyRelatedResponse = zGameCenterLeaderboardSetsV2Response;

export const zGameCenterGroupsGameCenterLeaderboardsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterGroupsGameCenterLeaderboardsGetToManyRelationshipResponse = zGameCenterGroupGameCenterLeaderboardsLinkagesResponse;

export const zGameCenterGroupsGameCenterLeaderboardsReplaceToManyRelationshipData = z.object({
    body: zGameCenterGroupGameCenterLeaderboardsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterGroupsGameCenterLeaderboardsReplaceToManyRelationshipResponse = z.void();

export const zGameCenterGroupsGameCenterLeaderboardsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'gameCenterLeaderboard',
            'gameCenterLeaderboardImage'
        ]))),
        'fields[gameCenterLeaderboardReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboard'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterLeaderboards
 */
export const zGameCenterGroupsGameCenterLeaderboardsGetToManyRelatedResponse = zGameCenterLeaderboardsResponse;

export const zGameCenterGroupsGameCenterLeaderboardsV2GetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterGroupsGameCenterLeaderboardsV2GetToManyRelationshipResponse = zGameCenterGroupGameCenterLeaderboardsV2LinkagesResponse;

export const zGameCenterGroupsGameCenterLeaderboardsV2ReplaceToManyRelationshipData = z.object({
    body: zGameCenterGroupGameCenterLeaderboardsV2LinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterGroupsGameCenterLeaderboardsV2ReplaceToManyRelationshipResponse = z.void();

export const zGameCenterGroupsGameCenterLeaderboardsV2GetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboardSets',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'versions'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'fields[gameCenterLeaderboardVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboard',
            'localizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboardSets',
            'activity',
            'challenge',
            'versions'
        ]))),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterLeaderboards
 */
export const zGameCenterGroupsGameCenterLeaderboardsV2GetToManyRelatedResponse = zGameCenterLeaderboardsV2Response;

export const zGameCenterLeaderboardLocalizationsGameCenterLeaderboardImageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterLeaderboardLocalizationsGameCenterLeaderboardImageGetToOneRelationshipResponse = zGameCenterLeaderboardLocalizationGameCenterLeaderboardImageLinkageResponse;

export const zGameCenterLeaderboardLocalizationsGameCenterLeaderboardImageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'gameCenterLeaderboardLocalization'
        ]))),
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'gameCenterLeaderboard',
            'gameCenterLeaderboardImage'
        ]))),
        include: z.optional(z.array(z.enum(['gameCenterLeaderboardLocalization'])))
    }))
});

/**
 * Single GameCenterLeaderboardImage
 */
export const zGameCenterLeaderboardLocalizationsGameCenterLeaderboardImageGetToOneRelatedResponse = zGameCenterLeaderboardImageResponse;

export const zGameCenterLeaderboardLocalizationsV2ImageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterLeaderboardLocalizationsV2ImageGetToOneRelationshipResponse = zGameCenterLeaderboardLocalizationV2ImageLinkageResponse;

export const zGameCenterLeaderboardLocalizationsV2ImageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'localization'
        ]))),
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'version',
            'image'
        ]))),
        include: z.optional(z.array(z.enum(['localization'])))
    }))
});

/**
 * Single GameCenterLeaderboardImage
 */
export const zGameCenterLeaderboardLocalizationsV2ImageGetToOneRelatedResponse = zGameCenterLeaderboardImageV2Response;

export const zGameCenterLeaderboardSetLocalizationsGameCenterLeaderboardSetImageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterLeaderboardSetLocalizationsGameCenterLeaderboardSetImageGetToOneRelationshipResponse = zGameCenterLeaderboardSetLocalizationGameCenterLeaderboardSetImageLinkageResponse;

export const zGameCenterLeaderboardSetLocalizationsGameCenterLeaderboardSetImageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSetImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'gameCenterLeaderboardSetLocalization'
        ]))),
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'gameCenterLeaderboardSet',
            'gameCenterLeaderboardSetImage'
        ]))),
        include: z.optional(z.array(z.enum(['gameCenterLeaderboardSetLocalization'])))
    }))
});

/**
 * Single GameCenterLeaderboardSetImage
 */
export const zGameCenterLeaderboardSetLocalizationsGameCenterLeaderboardSetImageGetToOneRelatedResponse = zGameCenterLeaderboardSetImageResponse;

export const zGameCenterLeaderboardSetLocalizationsV2ImageGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterLeaderboardSetLocalizationsV2ImageGetToOneRelationshipResponse = zGameCenterLeaderboardSetLocalizationV2ImageLinkageResponse;

export const zGameCenterLeaderboardSetLocalizationsV2ImageGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSetImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'localization'
        ]))),
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'version',
            'image'
        ]))),
        include: z.optional(z.array(z.enum(['localization'])))
    }))
});

/**
 * Single GameCenterLeaderboardSetImage
 */
export const zGameCenterLeaderboardSetLocalizationsV2ImageGetToOneRelatedResponse = zGameCenterLeaderboardSetImageV2Response;

export const zGameCenterLeaderboardSetMemberLocalizationsGameCenterLeaderboardGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterLeaderboardSetMemberLocalizationsGameCenterLeaderboardGetToOneRelationshipResponse = zGameCenterLeaderboardSetMemberLocalizationGameCenterLeaderboardLinkageResponse;

export const zGameCenterLeaderboardSetMemberLocalizationsGameCenterLeaderboardGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'gameCenterLeaderboard',
            'gameCenterLeaderboardImage'
        ]))),
        'fields[gameCenterLeaderboardReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboard'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterLeaderboard
 */
export const zGameCenterLeaderboardSetMemberLocalizationsGameCenterLeaderboardGetToOneRelatedResponse = zGameCenterLeaderboardResponse;

export const zGameCenterLeaderboardSetMemberLocalizationsGameCenterLeaderboardSetGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterLeaderboardSetMemberLocalizationsGameCenterLeaderboardSetGetToOneRelationshipResponse = zGameCenterLeaderboardSetMemberLocalizationGameCenterLeaderboardSetLinkageResponse;

export const zGameCenterLeaderboardSetMemberLocalizationsGameCenterLeaderboardSetGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'gameCenterLeaderboardSet',
            'gameCenterLeaderboardSetImage'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'fields[gameCenterLeaderboardSetReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboardSet'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterLeaderboardSet
 */
export const zGameCenterLeaderboardSetMemberLocalizationsGameCenterLeaderboardSetGetToOneRelatedResponse = zGameCenterLeaderboardSetResponse;

export const zGameCenterLeaderboardSetVersionsV2LocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterLeaderboardSetVersionsV2LocalizationsGetToManyRelationshipResponse = zGameCenterLeaderboardSetVersionV2LocalizationsLinkagesResponse;

export const zGameCenterLeaderboardSetVersionsV2LocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'version',
            'image'
        ]))),
        'fields[gameCenterLeaderboardSetVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboardSet',
            'localizations'
        ]))),
        'fields[gameCenterLeaderboardSetImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'localization'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['version', 'image'])))
    }))
});

/**
 * List of GameCenterLeaderboardSetLocalizations
 */
export const zGameCenterLeaderboardSetVersionsV2LocalizationsGetToManyRelatedResponse = zGameCenterLeaderboardSetLocalizationsV2Response;

export const zGameCenterLeaderboardSetsV2GameCenterLeaderboardsDeleteToManyRelationshipData = z.object({
    body: zGameCenterLeaderboardSetV2GameCenterLeaderboardsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetsV2GameCenterLeaderboardsDeleteToManyRelationshipResponse = z.void();

export const zGameCenterLeaderboardSetsV2GameCenterLeaderboardsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterLeaderboardSetsV2GameCenterLeaderboardsGetToManyRelationshipResponse = zGameCenterLeaderboardSetV2GameCenterLeaderboardsLinkagesResponse;

export const zGameCenterLeaderboardSetsV2GameCenterLeaderboardsReplaceToManyRelationshipData = z.object({
    body: zGameCenterLeaderboardSetV2GameCenterLeaderboardsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetsV2GameCenterLeaderboardsReplaceToManyRelationshipResponse = z.void();

export const zGameCenterLeaderboardSetsV2GameCenterLeaderboardsCreateToManyRelationshipData = z.object({
    body: zGameCenterLeaderboardSetV2GameCenterLeaderboardsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetsV2GameCenterLeaderboardsCreateToManyRelationshipResponse = z.void();

export const zGameCenterLeaderboardSetsV2GameCenterLeaderboardsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboardSets',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'versions'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        'fields[gameCenterLeaderboardVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboard',
            'localizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboardSets',
            'activity',
            'challenge',
            'versions'
        ]))),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[versions]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterLeaderboards
 */
export const zGameCenterLeaderboardSetsV2GameCenterLeaderboardsGetToManyRelatedResponse = zGameCenterLeaderboardsV2Response;

export const zGameCenterLeaderboardSetsV2VersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterLeaderboardSetsV2VersionsGetToManyRelationshipResponse = zGameCenterLeaderboardSetV2VersionsLinkagesResponse;

export const zGameCenterLeaderboardSetsV2VersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSetVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboardSet',
            'localizations'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'versions'
        ]))),
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'version',
            'image'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['leaderboardSet', 'localizations']))),
        'limit[localizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterLeaderboardSetVersions
 */
export const zGameCenterLeaderboardSetsV2VersionsGetToManyRelatedResponse = zGameCenterLeaderboardSetVersionsV2Response;

export const zGameCenterLeaderboardSetsGameCenterLeaderboardsDeleteToManyRelationshipData = z.object({
    body: zGameCenterLeaderboardSetGameCenterLeaderboardsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetsGameCenterLeaderboardsDeleteToManyRelationshipResponse = z.void();

export const zGameCenterLeaderboardSetsGameCenterLeaderboardsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterLeaderboardSetsGameCenterLeaderboardsGetToManyRelationshipResponse = zGameCenterLeaderboardSetGameCenterLeaderboardsLinkagesResponse;

export const zGameCenterLeaderboardSetsGameCenterLeaderboardsReplaceToManyRelationshipData = z.object({
    body: zGameCenterLeaderboardSetGameCenterLeaderboardsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetsGameCenterLeaderboardsReplaceToManyRelationshipResponse = z.void();

export const zGameCenterLeaderboardSetsGameCenterLeaderboardsCreateToManyRelationshipData = z.object({
    body: zGameCenterLeaderboardSetGameCenterLeaderboardsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetsGameCenterLeaderboardsCreateToManyRelationshipResponse = z.void();

export const zGameCenterLeaderboardSetsGameCenterLeaderboardsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[referenceName]': z.optional(z.array(z.string())),
        'filter[archived]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'gameCenterLeaderboard',
            'gameCenterLeaderboardImage'
        ]))),
        'fields[gameCenterLeaderboardReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboard'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterLeaderboards
 */
export const zGameCenterLeaderboardSetsGameCenterLeaderboardsGetToManyRelatedResponse = zGameCenterLeaderboardsResponse;

export const zGameCenterLeaderboardSetsGroupLeaderboardSetGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterLeaderboardSetsGroupLeaderboardSetGetToOneRelationshipResponse = zGameCenterLeaderboardSetGroupLeaderboardSetLinkageResponse;

export const zGameCenterLeaderboardSetsGroupLeaderboardSetUpdateToOneRelationshipData = z.object({
    body: zGameCenterLeaderboardSetGroupLeaderboardSetLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardSetsGroupLeaderboardSetUpdateToOneRelationshipResponse = z.void();

export const zGameCenterLeaderboardSetsGroupLeaderboardSetGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'gameCenterLeaderboardSet',
            'gameCenterLeaderboardSetImage'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'fields[gameCenterLeaderboardSetReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboardSet'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[gameCenterLeaderboards]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterLeaderboardSet
 */
export const zGameCenterLeaderboardSetsGroupLeaderboardSetGetToOneRelatedResponse = zGameCenterLeaderboardSetResponse;

export const zGameCenterLeaderboardSetsLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterLeaderboardSetsLocalizationsGetToManyRelationshipResponse = zGameCenterLeaderboardSetLocalizationsLinkagesResponse;

export const zGameCenterLeaderboardSetsLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardSetLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'gameCenterLeaderboardSet',
            'gameCenterLeaderboardSetImage'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'fields[gameCenterLeaderboardSetImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'gameCenterLeaderboardSetLocalization'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['gameCenterLeaderboardSet', 'gameCenterLeaderboardSetImage'])))
    }))
});

/**
 * List of GameCenterLeaderboardSetLocalizations
 */
export const zGameCenterLeaderboardSetsLocalizationsGetToManyRelatedResponse = zGameCenterLeaderboardSetLocalizationsResponse;

export const zGameCenterLeaderboardSetsReleasesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterLeaderboardSetsReleasesGetToManyRelationshipResponse = zGameCenterLeaderboardSetReleasesLinkagesResponse;

export const zGameCenterLeaderboardSetsReleasesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[live]': z.optional(z.array(z.string())),
        'filter[gameCenterDetail]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboardSetReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboardSet'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['gameCenterDetail', 'gameCenterLeaderboardSet'])))
    }))
});

/**
 * List of GameCenterLeaderboardSetReleases
 */
export const zGameCenterLeaderboardSetsReleasesGetToManyRelatedResponse = zGameCenterLeaderboardSetReleasesResponse;

export const zGameCenterLeaderboardVersionsV2LocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterLeaderboardVersionsV2LocalizationsGetToManyRelationshipResponse = zGameCenterLeaderboardVersionV2LocalizationsLinkagesResponse;

export const zGameCenterLeaderboardVersionsV2LocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'version',
            'image'
        ]))),
        'fields[gameCenterLeaderboardVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboard',
            'localizations'
        ]))),
        'fields[gameCenterLeaderboardImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'localization'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['version', 'image'])))
    }))
});

/**
 * List of GameCenterLeaderboardLocalizations
 */
export const zGameCenterLeaderboardVersionsV2LocalizationsGetToManyRelatedResponse = zGameCenterLeaderboardLocalizationsV2Response;

export const zGameCenterLeaderboardsActivityUpdateToOneRelationshipData = z.object({
    body: zGameCenterLeaderboardActivityLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardsActivityUpdateToOneRelationshipResponse = z.void();

export const zGameCenterLeaderboardsChallengeUpdateToOneRelationshipData = z.object({
    body: zGameCenterLeaderboardChallengeLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardsChallengeUpdateToOneRelationshipResponse = z.void();

export const zGameCenterLeaderboardsGroupLeaderboardGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zGameCenterLeaderboardsGroupLeaderboardGetToOneRelationshipResponse = zGameCenterLeaderboardGroupLeaderboardLinkageResponse;

export const zGameCenterLeaderboardsGroupLeaderboardUpdateToOneRelationshipData = z.object({
    body: zGameCenterLeaderboardGroupLeaderboardLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardsGroupLeaderboardUpdateToOneRelationshipResponse = z.void();

export const zGameCenterLeaderboardsGroupLeaderboardGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'gameCenterDetails',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges'
        ]))),
        'fields[gameCenterLeaderboardSets]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboardSet',
            'localizations',
            'gameCenterLeaderboards',
            'releases'
        ]))),
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'gameCenterLeaderboard',
            'gameCenterLeaderboardImage'
        ]))),
        'fields[gameCenterLeaderboardReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboard'
        ]))),
        'fields[gameCenterActivities]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'playStyle',
            'minimumPlayersCount',
            'maximumPlayersCount',
            'supportsPartyCode',
            'archived',
            'properties',
            'gameCenterDetail',
            'gameCenterGroup',
            'achievements',
            'achievementsV2',
            'leaderboards',
            'leaderboardsV2',
            'versions'
        ]))),
        'fields[gameCenterChallenges]': z.optional(z.array(z.enum([
            'referenceName',
            'vendorIdentifier',
            'archived',
            'challengeType',
            'repeatable',
            'gameCenterDetail',
            'gameCenterGroup',
            'versions',
            'leaderboard',
            'leaderboardV2'
        ]))),
        include: z.optional(z.array(z.enum([
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'limit[gameCenterLeaderboardSets]': z.optional(z.int().lte(50)),
        'limit[localizations]': z.optional(z.int().lte(50)),
        'limit[releases]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single GameCenterLeaderboard
 */
export const zGameCenterLeaderboardsGroupLeaderboardGetToOneRelatedResponse = zGameCenterLeaderboardResponse;

export const zGameCenterLeaderboardsLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterLeaderboardsLocalizationsGetToManyRelationshipResponse = zGameCenterLeaderboardLocalizationsLinkagesResponse;

export const zGameCenterLeaderboardsLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'gameCenterLeaderboard',
            'gameCenterLeaderboardImage'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        'fields[gameCenterLeaderboardImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'imageAsset',
            'uploadOperations',
            'assetDeliveryState',
            'gameCenterLeaderboardLocalization'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['gameCenterLeaderboard', 'gameCenterLeaderboardImage'])))
    }))
});

/**
 * List of GameCenterLeaderboardLocalizations
 */
export const zGameCenterLeaderboardsLocalizationsGetToManyRelatedResponse = zGameCenterLeaderboardLocalizationsResponse;

export const zGameCenterLeaderboardsReleasesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterLeaderboardsReleasesGetToManyRelationshipResponse = zGameCenterLeaderboardReleasesLinkagesResponse;

export const zGameCenterLeaderboardsReleasesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[live]': z.optional(z.array(z.string())),
        'filter[gameCenterDetail]': z.optional(z.array(z.string())),
        'fields[gameCenterLeaderboardReleases]': z.optional(z.array(z.enum([
            'live',
            'gameCenterDetail',
            'gameCenterLeaderboard'
        ]))),
        'fields[gameCenterDetails]': z.optional(z.array(z.enum([
            'arcadeEnabled',
            'challengeEnabled',
            'app',
            'gameCenterAppVersions',
            'gameCenterGroup',
            'gameCenterLeaderboards',
            'gameCenterLeaderboardsV2',
            'gameCenterLeaderboardSets',
            'gameCenterLeaderboardSetsV2',
            'gameCenterAchievements',
            'gameCenterAchievementsV2',
            'gameCenterActivities',
            'gameCenterChallenges',
            'defaultLeaderboard',
            'defaultLeaderboardV2',
            'defaultGroupLeaderboard',
            'defaultGroupLeaderboardV2',
            'achievementReleases',
            'activityReleases',
            'challengeReleases',
            'leaderboardReleases',
            'leaderboardSetReleases',
            'challengesMinimumPlatformVersions'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'groupLeaderboard',
            'gameCenterLeaderboardSets',
            'localizations',
            'releases',
            'activity',
            'challenge'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['gameCenterDetail', 'gameCenterLeaderboard'])))
    }))
});

/**
 * List of GameCenterLeaderboardReleases
 */
export const zGameCenterLeaderboardsReleasesGetToManyRelatedResponse = zGameCenterLeaderboardReleasesResponse;

export const zGameCenterLeaderboardsV2ActivityUpdateToOneRelationshipData = z.object({
    body: zGameCenterLeaderboardV2ActivityLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardsV2ActivityUpdateToOneRelationshipResponse = z.void();

export const zGameCenterLeaderboardsV2ChallengeUpdateToOneRelationshipData = z.object({
    body: zGameCenterLeaderboardV2ChallengeLinkageRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zGameCenterLeaderboardsV2ChallengeUpdateToOneRelationshipResponse = z.void();

export const zGameCenterLeaderboardsV2VersionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterLeaderboardsV2VersionsGetToManyRelationshipResponse = zGameCenterLeaderboardV2VersionsLinkagesResponse;

export const zGameCenterLeaderboardsV2VersionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterLeaderboardVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboard',
            'localizations'
        ]))),
        'fields[gameCenterLeaderboards]': z.optional(z.array(z.enum([
            'defaultFormatter',
            'referenceName',
            'vendorIdentifier',
            'submissionType',
            'scoreSortType',
            'scoreRangeStart',
            'scoreRangeEnd',
            'recurrenceStartDate',
            'recurrenceDuration',
            'recurrenceRule',
            'archived',
            'activityProperties',
            'visibility',
            'gameCenterDetail',
            'gameCenterGroup',
            'gameCenterLeaderboardSets',
            'activity',
            'challenge',
            'versions'
        ]))),
        'fields[gameCenterLeaderboardLocalizations]': z.optional(z.array(z.enum([
            'locale',
            'name',
            'formatterOverride',
            'formatterSuffix',
            'formatterSuffixSingular',
            'description',
            'version',
            'image'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['leaderboard', 'localizations']))),
        'limit[localizations]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of GameCenterLeaderboardVersions
 */
export const zGameCenterLeaderboardsV2VersionsGetToManyRelatedResponse = zGameCenterLeaderboardVersionsV2Response;

export const zGameCenterMatchmakingRuleSetsMatchmakingQueuesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterMatchmakingRuleSetsMatchmakingQueuesGetToManyRelationshipResponse = zGameCenterMatchmakingRuleSetMatchmakingQueuesLinkagesResponse;

export const zGameCenterMatchmakingRuleSetsMatchmakingQueuesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterMatchmakingQueues]': z.optional(z.array(z.enum([
            'referenceName',
            'classicMatchmakingBundleIds',
            'ruleSet',
            'experimentRuleSet'
        ]))),
        'fields[gameCenterMatchmakingRuleSets]': z.optional(z.array(z.enum([
            'referenceName',
            'ruleLanguageVersion',
            'minPlayers',
            'maxPlayers',
            'teams',
            'rules',
            'matchmakingQueues'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['ruleSet', 'experimentRuleSet'])))
    }))
});

/**
 * List of GameCenterMatchmakingQueues
 */
export const zGameCenterMatchmakingRuleSetsMatchmakingQueuesGetToManyRelatedResponse = zGameCenterMatchmakingQueuesResponse;

export const zGameCenterMatchmakingRuleSetsRulesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterMatchmakingRuleSetsRulesGetToManyRelationshipResponse = zGameCenterMatchmakingRuleSetRulesLinkagesResponse;

export const zGameCenterMatchmakingRuleSetsRulesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterMatchmakingRules]': z.optional(z.array(z.enum([
            'referenceName',
            'description',
            'type',
            'expression',
            'weight'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of GameCenterMatchmakingRules
 */
export const zGameCenterMatchmakingRuleSetsRulesGetToManyRelatedResponse = zGameCenterMatchmakingRulesResponse;

export const zGameCenterMatchmakingRuleSetsTeamsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zGameCenterMatchmakingRuleSetsTeamsGetToManyRelationshipResponse = zGameCenterMatchmakingRuleSetTeamsLinkagesResponse;

export const zGameCenterMatchmakingRuleSetsTeamsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[gameCenterMatchmakingTeams]': z.optional(z.array(z.enum([
            'referenceName',
            'minPlayers',
            'maxPlayers'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of GameCenterMatchmakingTeams
 */
export const zGameCenterMatchmakingRuleSetsTeamsGetToManyRelatedResponse = zGameCenterMatchmakingTeamsResponse;

export const zInAppPurchaseAvailabilitiesAvailableTerritoriesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zInAppPurchaseAvailabilitiesAvailableTerritoriesGetToManyRelationshipResponse = zInAppPurchaseAvailabilityAvailableTerritoriesLinkagesResponse;

export const zInAppPurchaseAvailabilitiesAvailableTerritoriesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Territories
 */
export const zInAppPurchaseAvailabilitiesAvailableTerritoriesGetToManyRelatedResponse = zTerritoriesResponse;

export const zInAppPurchaseOfferCodeOneTimeUseCodesValuesGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single InAppPurchaseOfferCodeOneTimeUseCodeValue
 */
export const zInAppPurchaseOfferCodeOneTimeUseCodesValuesGetToOneRelatedResponse = zCsv;

export const zInAppPurchaseOfferCodesCustomCodesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zInAppPurchaseOfferCodesCustomCodesGetToManyRelationshipResponse = zInAppPurchaseOfferCodeCustomCodesLinkagesResponse;

export const zInAppPurchaseOfferCodesCustomCodesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseOfferCodeCustomCodes]': z.optional(z.array(z.enum([
            'customCode',
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'createdByActor',
            'deactivatedByActor'
        ]))),
        'fields[actors]': z.optional(z.array(z.enum([
            'actorType',
            'userFirstName',
            'userLastName',
            'userEmail',
            'apiKeyId'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['createdByActor', 'deactivatedByActor'])))
    }))
});

/**
 * List of InAppPurchaseOfferCodeCustomCodes
 */
export const zInAppPurchaseOfferCodesCustomCodesGetToManyRelatedResponse = zInAppPurchaseOfferCodeCustomCodesResponse;

export const zInAppPurchaseOfferCodesOneTimeUseCodesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zInAppPurchaseOfferCodesOneTimeUseCodesGetToManyRelationshipResponse = zInAppPurchaseOfferCodeOneTimeUseCodesLinkagesResponse;

export const zInAppPurchaseOfferCodesOneTimeUseCodesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseOfferCodeOneTimeUseCodes]': z.optional(z.array(z.enum([
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'environment',
            'values',
            'createdByActor',
            'deactivatedByActor'
        ]))),
        'fields[actors]': z.optional(z.array(z.enum([
            'actorType',
            'userFirstName',
            'userLastName',
            'userEmail',
            'apiKeyId'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['createdByActor', 'deactivatedByActor'])))
    }))
});

/**
 * List of InAppPurchaseOfferCodeOneTimeUseCodes
 */
export const zInAppPurchaseOfferCodesOneTimeUseCodesGetToManyRelatedResponse = zInAppPurchaseOfferCodeOneTimeUseCodesResponse;

export const zInAppPurchaseOfferCodesPricesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zInAppPurchaseOfferCodesPricesGetToManyRelationshipResponse = zInAppPurchaseOfferCodePricesLinkagesResponse;

export const zInAppPurchaseOfferCodesPricesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[inAppPurchaseOfferPrices]': z.optional(z.array(z.enum(['territory', 'pricePoint']))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        'fields[inAppPurchasePricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'territory',
            'equalizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['territory', 'pricePoint'])))
    }))
});

/**
 * List of InAppPurchaseOfferPrices
 */
export const zInAppPurchaseOfferCodesPricesGetToManyRelatedResponse = zInAppPurchaseOfferPricesResponse;

export const zInAppPurchasePricePointsEqualizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(8000))
    }))
});

/**
 * List of related linkages
 */
export const zInAppPurchasePricePointsEqualizationsGetToManyRelationshipResponse = zInAppPurchasePricePointEqualizationsLinkagesResponse;

export const zInAppPurchasePricePointsEqualizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'filter[inAppPurchaseV2]': z.optional(z.array(z.string())),
        'fields[inAppPurchasePricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'territory',
            'equalizations'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(8000)),
        include: z.optional(z.array(z.enum(['territory'])))
    }))
});

/**
 * List of InAppPurchasePricePoints
 */
export const zInAppPurchasePricePointsEqualizationsGetToManyRelatedResponse = zInAppPurchasePricePointsResponse;

export const zInAppPurchasePriceSchedulesAutomaticPricesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zInAppPurchasePriceSchedulesAutomaticPricesGetToManyRelationshipResponse = zInAppPurchasePriceScheduleAutomaticPricesLinkagesResponse;

export const zInAppPurchasePriceSchedulesAutomaticPricesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[inAppPurchasePrices]': z.optional(z.array(z.enum([
            'startDate',
            'endDate',
            'manual',
            'inAppPurchasePricePoint',
            'territory'
        ]))),
        'fields[inAppPurchasePricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'territory',
            'equalizations'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['inAppPurchasePricePoint', 'territory'])))
    }))
});

/**
 * List of InAppPurchasePrices
 */
export const zInAppPurchasePriceSchedulesAutomaticPricesGetToManyRelatedResponse = zInAppPurchasePricesResponse;

export const zInAppPurchasePriceSchedulesBaseTerritoryGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zInAppPurchasePriceSchedulesBaseTerritoryGetToOneRelationshipResponse = zInAppPurchasePriceScheduleBaseTerritoryLinkageResponse;

export const zInAppPurchasePriceSchedulesBaseTerritoryGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[territories]': z.optional(z.array(z.enum(['currency'])))
    }))
});

/**
 * Single Territory
 */
export const zInAppPurchasePriceSchedulesBaseTerritoryGetToOneRelatedResponse = zTerritoryResponse;

export const zInAppPurchasePriceSchedulesManualPricesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zInAppPurchasePriceSchedulesManualPricesGetToManyRelationshipResponse = zInAppPurchasePriceScheduleManualPricesLinkagesResponse;

export const zInAppPurchasePriceSchedulesManualPricesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[inAppPurchasePrices]': z.optional(z.array(z.enum([
            'startDate',
            'endDate',
            'manual',
            'inAppPurchasePricePoint',
            'territory'
        ]))),
        'fields[inAppPurchasePricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'territory',
            'equalizations'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['inAppPurchasePricePoint', 'territory'])))
    }))
});

/**
 * List of InAppPurchasePrices
 */
export const zInAppPurchasePriceSchedulesManualPricesGetToManyRelatedResponse = zInAppPurchasePricesResponse;

export const zInAppPurchasesV2AppStoreReviewScreenshotGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zInAppPurchasesV2AppStoreReviewScreenshotGetToOneRelationshipResponse = zInAppPurchaseV2AppStoreReviewScreenshotLinkageResponse;

export const zInAppPurchasesV2AppStoreReviewScreenshotGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseAppStoreReviewScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'inAppPurchaseV2'
        ]))),
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'inAppPurchaseType',
            'state',
            'reviewNote',
            'familySharable',
            'contentHosting',
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        include: z.optional(z.array(z.enum(['inAppPurchaseV2'])))
    }))
});

/**
 * Single InAppPurchaseAppStoreReviewScreenshot
 */
export const zInAppPurchasesV2AppStoreReviewScreenshotGetToOneRelatedResponse = zInAppPurchaseAppStoreReviewScreenshotResponse;

export const zInAppPurchasesV2ContentGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zInAppPurchasesV2ContentGetToOneRelationshipResponse = zInAppPurchaseV2ContentLinkageResponse;

export const zInAppPurchasesV2ContentGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseContents]': z.optional(z.array(z.enum([
            'fileName',
            'fileSize',
            'url',
            'lastModifiedDate',
            'inAppPurchaseV2'
        ]))),
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'inAppPurchaseType',
            'state',
            'reviewNote',
            'familySharable',
            'contentHosting',
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        include: z.optional(z.array(z.enum(['inAppPurchaseV2'])))
    }))
});

/**
 * Single InAppPurchaseContent
 */
export const zInAppPurchasesV2ContentGetToOneRelatedResponse = zInAppPurchaseContentResponse;

export const zInAppPurchasesV2IapPriceScheduleGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zInAppPurchasesV2IapPriceScheduleGetToOneRelationshipResponse = zInAppPurchaseV2IapPriceScheduleLinkageResponse;

export const zInAppPurchasesV2IapPriceScheduleGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchasePriceSchedules]': z.optional(z.array(z.enum([
            'baseTerritory',
            'manualPrices',
            'automaticPrices'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        'fields[inAppPurchasePrices]': z.optional(z.array(z.enum([
            'startDate',
            'endDate',
            'manual',
            'inAppPurchasePricePoint',
            'territory'
        ]))),
        include: z.optional(z.array(z.enum([
            'baseTerritory',
            'manualPrices',
            'automaticPrices'
        ]))),
        'limit[manualPrices]': z.optional(z.int().lte(50)),
        'limit[automaticPrices]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single InAppPurchasePriceSchedule
 */
export const zInAppPurchasesV2IapPriceScheduleGetToOneRelatedResponse = zInAppPurchasePriceScheduleResponse;

export const zInAppPurchasesV2ImagesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zInAppPurchasesV2ImagesGetToManyRelationshipResponse = zInAppPurchaseV2ImagesLinkagesResponse;

export const zInAppPurchasesV2ImagesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'assetToken',
            'imageAsset',
            'uploadOperations',
            'state',
            'inAppPurchase'
        ]))),
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'inAppPurchaseType',
            'state',
            'reviewNote',
            'familySharable',
            'contentHosting',
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['inAppPurchase'])))
    }))
});

/**
 * List of InAppPurchaseImages
 */
export const zInAppPurchasesV2ImagesGetToManyRelatedResponse = zInAppPurchaseImagesResponse;

export const zInAppPurchasesV2InAppPurchaseAvailabilityGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zInAppPurchasesV2InAppPurchaseAvailabilityGetToOneRelationshipResponse = zInAppPurchaseV2InAppPurchaseAvailabilityLinkageResponse;

export const zInAppPurchasesV2InAppPurchaseAvailabilityGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseAvailabilities]': z.optional(z.array(z.enum(['availableInNewTerritories', 'availableTerritories']))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        include: z.optional(z.array(z.enum(['availableTerritories']))),
        'limit[availableTerritories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single InAppPurchaseAvailability
 */
export const zInAppPurchasesV2InAppPurchaseAvailabilityGetToOneRelatedResponse = zInAppPurchaseAvailabilityResponse;

export const zInAppPurchasesV2InAppPurchaseLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zInAppPurchasesV2InAppPurchaseLocalizationsGetToManyRelationshipResponse = zInAppPurchaseV2InAppPurchaseLocalizationsLinkagesResponse;

export const zInAppPurchasesV2InAppPurchaseLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[inAppPurchaseLocalizations]': z.optional(z.array(z.enum([
            'name',
            'locale',
            'description',
            'state',
            'inAppPurchaseV2'
        ]))),
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'inAppPurchaseType',
            'state',
            'reviewNote',
            'familySharable',
            'contentHosting',
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['inAppPurchaseV2'])))
    }))
});

/**
 * List of InAppPurchaseLocalizations
 */
export const zInAppPurchasesV2InAppPurchaseLocalizationsGetToManyRelatedResponse = zInAppPurchaseLocalizationsResponse;

export const zInAppPurchasesV2OfferCodesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zInAppPurchasesV2OfferCodesGetToManyRelationshipResponse = zInAppPurchaseV2OfferCodesLinkagesResponse;

export const zInAppPurchasesV2OfferCodesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[inAppPurchaseOfferCodes]': z.optional(z.array(z.enum([
            'name',
            'customerEligibilities',
            'productionCodeCount',
            'sandboxCodeCount',
            'active',
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        'fields[inAppPurchaseOfferCodeOneTimeUseCodes]': z.optional(z.array(z.enum([
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'environment',
            'values',
            'createdByActor',
            'deactivatedByActor'
        ]))),
        'fields[inAppPurchaseOfferCodeCustomCodes]': z.optional(z.array(z.enum([
            'customCode',
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'createdByActor',
            'deactivatedByActor'
        ]))),
        'fields[inAppPurchaseOfferPrices]': z.optional(z.array(z.enum(['territory', 'pricePoint']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        'limit[oneTimeUseCodes]': z.optional(z.int().lte(50)),
        'limit[customCodes]': z.optional(z.int().lte(50)),
        'limit[prices]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of InAppPurchaseOfferCodes
 */
export const zInAppPurchasesV2OfferCodesGetToManyRelatedResponse = zInAppPurchaseOfferCodesResponse;

export const zInAppPurchasesV2PricePointsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(8000))
    }))
});

/**
 * List of related linkages
 */
export const zInAppPurchasesV2PricePointsGetToManyRelationshipResponse = zInAppPurchaseV2PricePointsLinkagesResponse;

export const zInAppPurchasesV2PricePointsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[inAppPurchasePricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'territory',
            'equalizations'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(8000)),
        include: z.optional(z.array(z.enum(['territory'])))
    }))
});

/**
 * List of InAppPurchasePricePoints
 */
export const zInAppPurchasesV2PricePointsGetToManyRelatedResponse = zInAppPurchasePricePointsResponse;

export const zInAppPurchasesV2PromotedPurchaseGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zInAppPurchasesV2PromotedPurchaseGetToOneRelationshipResponse = zInAppPurchaseV2PromotedPurchaseLinkageResponse;

export const zInAppPurchasesV2PromotedPurchaseGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[promotedPurchases]': z.optional(z.array(z.enum([
            'visibleForAllUsers',
            'enabled',
            'state',
            'inAppPurchaseV2',
            'subscription'
        ]))),
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'inAppPurchaseType',
            'state',
            'reviewNote',
            'familySharable',
            'contentHosting',
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        include: z.optional(z.array(z.enum(['inAppPurchaseV2', 'subscription'])))
    }))
});

/**
 * Single PromotedPurchase
 */
export const zInAppPurchasesV2PromotedPurchaseGetToOneRelatedResponse = zPromotedPurchaseResponse;

export const zMerchantIdsCertificatesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zMerchantIdsCertificatesGetToManyRelationshipResponse = zMerchantIdCertificatesLinkagesResponse;

export const zMerchantIdsCertificatesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[displayName]': z.optional(z.array(z.string())),
        'filter[certificateType]': z.optional(z.array(z.enum([
            'APPLE_PAY',
            'APPLE_PAY_MERCHANT_IDENTITY',
            'APPLE_PAY_PSP_IDENTITY',
            'APPLE_PAY_RSA',
            'DEVELOPER_ID_KEXT',
            'DEVELOPER_ID_KEXT_G2',
            'DEVELOPER_ID_APPLICATION',
            'DEVELOPER_ID_APPLICATION_G2',
            'DEVELOPMENT',
            'DISTRIBUTION',
            'IDENTITY_ACCESS',
            'IOS_DEVELOPMENT',
            'IOS_DISTRIBUTION',
            'MAC_APP_DISTRIBUTION',
            'MAC_INSTALLER_DISTRIBUTION',
            'MAC_APP_DEVELOPMENT',
            'PASS_TYPE_ID',
            'PASS_TYPE_ID_WITH_NFC'
        ]))),
        'filter[serialNumber]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'displayName',
            '-displayName',
            'certificateType',
            '-certificateType',
            'serialNumber',
            '-serialNumber',
            'id',
            '-id'
        ]))),
        'fields[certificates]': z.optional(z.array(z.enum([
            'name',
            'certificateType',
            'displayName',
            'serialNumber',
            'platform',
            'expirationDate',
            'certificateContent',
            'activated',
            'passTypeId'
        ]))),
        'fields[passTypeIds]': z.optional(z.array(z.enum([
            'name',
            'identifier',
            'certificates'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['passTypeId'])))
    }))
});

/**
 * List of Certificates
 */
export const zMerchantIdsCertificatesGetToManyRelatedResponse = zCertificatesResponse;

export const zPassTypeIdsCertificatesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zPassTypeIdsCertificatesGetToManyRelationshipResponse = zPassTypeIdCertificatesLinkagesResponse;

export const zPassTypeIdsCertificatesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[displayName]': z.optional(z.array(z.string())),
        'filter[certificateType]': z.optional(z.array(z.enum([
            'APPLE_PAY',
            'APPLE_PAY_MERCHANT_IDENTITY',
            'APPLE_PAY_PSP_IDENTITY',
            'APPLE_PAY_RSA',
            'DEVELOPER_ID_KEXT',
            'DEVELOPER_ID_KEXT_G2',
            'DEVELOPER_ID_APPLICATION',
            'DEVELOPER_ID_APPLICATION_G2',
            'DEVELOPMENT',
            'DISTRIBUTION',
            'IDENTITY_ACCESS',
            'IOS_DEVELOPMENT',
            'IOS_DISTRIBUTION',
            'MAC_APP_DISTRIBUTION',
            'MAC_INSTALLER_DISTRIBUTION',
            'MAC_APP_DEVELOPMENT',
            'PASS_TYPE_ID',
            'PASS_TYPE_ID_WITH_NFC'
        ]))),
        'filter[serialNumber]': z.optional(z.array(z.string())),
        'filter[id]': z.optional(z.array(z.string())),
        sort: z.optional(z.array(z.enum([
            'displayName',
            '-displayName',
            'certificateType',
            '-certificateType',
            'serialNumber',
            '-serialNumber',
            'id',
            '-id'
        ]))),
        'fields[certificates]': z.optional(z.array(z.enum([
            'name',
            'certificateType',
            'displayName',
            'serialNumber',
            'platform',
            'expirationDate',
            'certificateContent',
            'activated',
            'passTypeId'
        ]))),
        'fields[passTypeIds]': z.optional(z.array(z.enum([
            'name',
            'identifier',
            'certificates'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['passTypeId'])))
    }))
});

/**
 * List of Certificates
 */
export const zPassTypeIdsCertificatesGetToManyRelatedResponse = zCertificatesResponse;

export const zPreReleaseVersionsAppGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zPreReleaseVersionsAppGetToOneRelationshipResponse = zPrereleaseVersionAppLinkageResponse;

export const zPreReleaseVersionsAppGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ])))
    }))
});

/**
 * Single App with get
 */
export const zPreReleaseVersionsAppGetToOneRelatedResponse = zAppWithoutIncludesResponse;

export const zPreReleaseVersionsBuildsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zPreReleaseVersionsBuildsGetToManyRelationshipResponse = zPrereleaseVersionBuildsLinkagesResponse;

export const zPreReleaseVersionsBuildsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[builds]': z.optional(z.array(z.enum([
            'version',
            'uploadedDate',
            'expirationDate',
            'expired',
            'minOsVersion',
            'lsMinimumSystemVersion',
            'computedMinMacOsVersion',
            'computedMinVisionOsVersion',
            'iconAssetToken',
            'processingState',
            'buildAudienceType',
            'usesNonExemptEncryption',
            'preReleaseVersion',
            'individualTesters',
            'betaGroups',
            'betaBuildLocalizations',
            'appEncryptionDeclaration',
            'betaAppReviewSubmission',
            'app',
            'buildBetaDetail',
            'appStoreVersion',
            'icons',
            'buildBundles',
            'buildUpload',
            'perfPowerMetrics',
            'diagnosticSignatures'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Builds with get
 */
export const zPreReleaseVersionsBuildsGetToManyRelatedResponse = zBuildsWithoutIncludesResponse;

export const zProfilesBundleIdGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zProfilesBundleIdGetToOneRelationshipResponse = zProfileBundleIdLinkageResponse;

export const zProfilesBundleIdGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[bundleIds]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'identifier',
            'seedId',
            'profiles',
            'bundleIdCapabilities',
            'app'
        ])))
    }))
});

/**
 * Single BundleId with get
 */
export const zProfilesBundleIdGetToOneRelatedResponse = zBundleIdWithoutIncludesResponse;

export const zProfilesCertificatesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zProfilesCertificatesGetToManyRelationshipResponse = zProfileCertificatesLinkagesResponse;

export const zProfilesCertificatesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[certificates]': z.optional(z.array(z.enum([
            'name',
            'certificateType',
            'displayName',
            'serialNumber',
            'platform',
            'expirationDate',
            'certificateContent',
            'activated',
            'passTypeId'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Certificates with get
 */
export const zProfilesCertificatesGetToManyRelatedResponse = zCertificatesWithoutIncludesResponse;

export const zProfilesDevicesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zProfilesDevicesGetToManyRelationshipResponse = zProfileDevicesLinkagesResponse;

export const zProfilesDevicesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[devices]': z.optional(z.array(z.enum([
            'name',
            'platform',
            'udid',
            'deviceClass',
            'status',
            'model',
            'addedDate'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Devices with get
 */
export const zProfilesDevicesGetToManyRelatedResponse = zDevicesWithoutIncludesResponse;

export const zReviewSubmissionsItemsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zReviewSubmissionsItemsGetToManyRelationshipResponse = zReviewSubmissionItemsLinkagesResponse;

export const zReviewSubmissionsItemsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[reviewSubmissionItems]': z.optional(z.array(z.enum([
            'state',
            'appStoreVersion',
            'appCustomProductPageVersion',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appEvent',
            'backgroundAssetVersion',
            'gameCenterAchievementVersion',
            'gameCenterActivityVersion',
            'gameCenterChallengeVersion',
            'gameCenterLeaderboardSetVersion',
            'gameCenterLeaderboardVersion'
        ]))),
        'fields[appStoreVersions]': z.optional(z.array(z.enum([
            'platform',
            'versionString',
            'appStoreState',
            'appVersionState',
            'copyright',
            'reviewType',
            'releaseType',
            'earliestReleaseDate',
            'usesIdfa',
            'downloadable',
            'createdDate',
            'app',
            'ageRatingDeclaration',
            'appStoreVersionLocalizations',
            'build',
            'appStoreVersionPhasedRelease',
            'gameCenterAppVersion',
            'routingAppCoverage',
            'appStoreReviewDetail',
            'appStoreVersionSubmission',
            'appClipDefaultExperience',
            'appStoreVersionExperiments',
            'appStoreVersionExperimentsV2',
            'customerReviews',
            'alternativeDistributionPackage'
        ]))),
        'fields[appCustomProductPageVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'deepLink',
            'appCustomProductPage',
            'appCustomProductPageLocalizations'
        ]))),
        'fields[appStoreVersionExperiments]': z.optional(z.array(z.enum([
            'name',
            'trafficProportion',
            'state',
            'reviewRequired',
            'startDate',
            'endDate',
            'appStoreVersion',
            'appStoreVersionExperimentTreatments',
            'platform',
            'app',
            'latestControlVersion',
            'controlVersions'
        ]))),
        'fields[appEvents]': z.optional(z.array(z.enum([
            'referenceName',
            'badge',
            'eventState',
            'deepLink',
            'purchaseRequirement',
            'primaryLocale',
            'priority',
            'purpose',
            'territorySchedules',
            'archivedTerritorySchedules',
            'localizations'
        ]))),
        'fields[backgroundAssetVersions]': z.optional(z.array(z.enum([
            'createdDate',
            'platforms',
            'state',
            'stateDetails',
            'version',
            'backgroundAsset',
            'internalBetaRelease',
            'externalBetaRelease',
            'appStoreRelease',
            'assetFile',
            'manifestFile',
            'backgroundAssetUploadFiles'
        ]))),
        'fields[gameCenterAchievementVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'achievement',
            'localizations'
        ]))),
        'fields[gameCenterActivityVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'fallbackUrl',
            'activity',
            'localizations',
            'defaultImage',
            'releases'
        ]))),
        'fields[gameCenterChallengeVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'challenge',
            'localizations',
            'releases',
            'defaultImage'
        ]))),
        'fields[gameCenterLeaderboardSetVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboardSet',
            'localizations'
        ]))),
        'fields[gameCenterLeaderboardVersions]': z.optional(z.array(z.enum([
            'version',
            'state',
            'leaderboard',
            'localizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'appStoreVersion',
            'appCustomProductPageVersion',
            'appStoreVersionExperiment',
            'appStoreVersionExperimentV2',
            'appEvent',
            'backgroundAssetVersion',
            'gameCenterAchievementVersion',
            'gameCenterActivityVersion',
            'gameCenterChallengeVersion',
            'gameCenterLeaderboardSetVersion',
            'gameCenterLeaderboardVersion'
        ])))
    }))
});

/**
 * List of ReviewSubmissionItems
 */
export const zReviewSubmissionsItemsGetToManyRelatedResponse = zReviewSubmissionItemsResponse;

export const zScmProvidersRepositoriesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zScmProvidersRepositoriesGetToManyRelationshipResponse = zScmProviderRepositoriesLinkagesResponse;

export const zScmProvidersRepositoriesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[id]': z.optional(z.array(z.string())),
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        'fields[scmProviders]': z.optional(z.array(z.enum([
            'scmProviderType',
            'url',
            'repositories'
        ]))),
        'fields[scmGitReferences]': z.optional(z.array(z.enum([
            'name',
            'canonicalName',
            'isDeleted',
            'kind',
            'repository'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['scmProvider', 'defaultBranch'])))
    }))
});

/**
 * List of ScmRepositories
 */
export const zScmProvidersRepositoriesGetToManyRelatedResponse = zScmRepositoriesResponse;

export const zScmRepositoriesGitReferencesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zScmRepositoriesGitReferencesGetToManyRelationshipResponse = zScmRepositoryGitReferencesLinkagesResponse;

export const zScmRepositoriesGitReferencesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[scmGitReferences]': z.optional(z.array(z.enum([
            'name',
            'canonicalName',
            'isDeleted',
            'kind',
            'repository'
        ]))),
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['repository'])))
    }))
});

/**
 * List of ScmGitReferences
 */
export const zScmRepositoriesGitReferencesGetToManyRelatedResponse = zScmGitReferencesResponse;

export const zScmRepositoriesPullRequestsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zScmRepositoriesPullRequestsGetToManyRelationshipResponse = zScmRepositoryPullRequestsLinkagesResponse;

export const zScmRepositoriesPullRequestsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[scmPullRequests]': z.optional(z.array(z.enum([
            'title',
            'number',
            'webUrl',
            'sourceRepositoryOwner',
            'sourceRepositoryName',
            'sourceBranchName',
            'destinationRepositoryOwner',
            'destinationRepositoryName',
            'destinationBranchName',
            'isClosed',
            'isCrossRepository',
            'repository'
        ]))),
        'fields[scmRepositories]': z.optional(z.array(z.enum([
            'lastAccessedDate',
            'httpCloneUrl',
            'sshCloneUrl',
            'ownerName',
            'repositoryName',
            'scmProvider',
            'defaultBranch',
            'gitReferences',
            'pullRequests'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['repository'])))
    }))
});

/**
 * List of ScmPullRequests
 */
export const zScmRepositoriesPullRequestsGetToManyRelatedResponse = zScmPullRequestsResponse;

export const zSubscriptionAvailabilitiesAvailableTerritoriesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionAvailabilitiesAvailableTerritoriesGetToManyRelationshipResponse = zSubscriptionAvailabilityAvailableTerritoriesLinkagesResponse;

export const zSubscriptionAvailabilitiesAvailableTerritoriesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Territories
 */
export const zSubscriptionAvailabilitiesAvailableTerritoriesGetToManyRelatedResponse = zTerritoriesResponse;

export const zSubscriptionGroupsSubscriptionGroupLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionGroupsSubscriptionGroupLocalizationsGetToManyRelationshipResponse = zSubscriptionGroupSubscriptionGroupLocalizationsLinkagesResponse;

export const zSubscriptionGroupsSubscriptionGroupLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionGroupLocalizations]': z.optional(z.array(z.enum([
            'name',
            'customAppName',
            'locale',
            'state',
            'subscriptionGroup'
        ]))),
        'fields[subscriptionGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'subscriptions',
            'subscriptionGroupLocalizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['subscriptionGroup'])))
    }))
});

/**
 * List of SubscriptionGroupLocalizations
 */
export const zSubscriptionGroupsSubscriptionGroupLocalizationsGetToManyRelatedResponse = zSubscriptionGroupLocalizationsResponse;

export const zSubscriptionGroupsSubscriptionsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionGroupsSubscriptionsGetToManyRelationshipResponse = zSubscriptionGroupSubscriptionsLinkagesResponse;

export const zSubscriptionGroupsSubscriptionsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[productId]': z.optional(z.array(z.string())),
        'filter[name]': z.optional(z.array(z.string())),
        'filter[state]': z.optional(z.array(z.enum([
            'MISSING_METADATA',
            'READY_TO_SUBMIT',
            'WAITING_FOR_REVIEW',
            'IN_REVIEW',
            'DEVELOPER_ACTION_NEEDED',
            'PENDING_BINARY_APPROVAL',
            'APPROVED',
            'DEVELOPER_REMOVED_FROM_SALE',
            'REMOVED_FROM_SALE',
            'REJECTED'
        ]))),
        sort: z.optional(z.array(z.enum(['name', '-name']))),
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        'fields[subscriptionLocalizations]': z.optional(z.array(z.enum([
            'name',
            'locale',
            'description',
            'state',
            'subscription'
        ]))),
        'fields[subscriptionAppStoreReviewScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'subscription'
        ]))),
        'fields[subscriptionGroups]': z.optional(z.array(z.enum([
            'referenceName',
            'subscriptions',
            'subscriptionGroupLocalizations'
        ]))),
        'fields[subscriptionIntroductoryOffers]': z.optional(z.array(z.enum([
            'startDate',
            'endDate',
            'duration',
            'offerMode',
            'numberOfPeriods',
            'subscription',
            'territory',
            'subscriptionPricePoint'
        ]))),
        'fields[subscriptionPromotionalOffers]': z.optional(z.array(z.enum([
            'duration',
            'name',
            'numberOfPeriods',
            'offerCode',
            'offerMode',
            'subscription',
            'prices'
        ]))),
        'fields[subscriptionOfferCodes]': z.optional(z.array(z.enum([
            'name',
            'customerEligibilities',
            'offerEligibility',
            'duration',
            'offerMode',
            'numberOfPeriods',
            'totalNumberOfCodes',
            'productionCodeCount',
            'sandboxCodeCount',
            'active',
            'autoRenewEnabled',
            'subscription',
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        'fields[subscriptionPrices]': z.optional(z.array(z.enum([
            'startDate',
            'preserved',
            'territory',
            'subscriptionPricePoint'
        ]))),
        'fields[promotedPurchases]': z.optional(z.array(z.enum([
            'visibleForAllUsers',
            'enabled',
            'state',
            'inAppPurchaseV2',
            'subscription'
        ]))),
        'fields[subscriptionAvailabilities]': z.optional(z.array(z.enum(['availableInNewTerritories', 'availableTerritories']))),
        'fields[winBackOffers]': z.optional(z.array(z.enum([
            'referenceName',
            'offerId',
            'duration',
            'offerMode',
            'periodCount',
            'customerEligibilityPaidSubscriptionDurationInMonths',
            'customerEligibilityTimeSinceLastSubscribedInMonths',
            'customerEligibilityWaitBetweenOffersInMonths',
            'startDate',
            'endDate',
            'priority',
            'promotionIntent',
            'prices'
        ]))),
        'fields[subscriptionImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'assetToken',
            'imageAsset',
            'uploadOperations',
            'state',
            'subscription'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        'limit[subscriptionLocalizations]': z.optional(z.int().lte(50)),
        'limit[introductoryOffers]': z.optional(z.int().lte(50)),
        'limit[promotionalOffers]': z.optional(z.int().lte(50)),
        'limit[offerCodes]': z.optional(z.int().lte(50)),
        'limit[prices]': z.optional(z.int().lte(50)),
        'limit[winBackOffers]': z.optional(z.int().lte(50)),
        'limit[images]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of Subscriptions
 */
export const zSubscriptionGroupsSubscriptionsGetToManyRelatedResponse = zSubscriptionsResponse;

export const zSubscriptionOfferCodeOneTimeUseCodesValuesGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Single SubscriptionOfferCodeOneTimeUseCodeValue
 */
export const zSubscriptionOfferCodeOneTimeUseCodesValuesGetToOneRelatedResponse = zCsv;

export const zSubscriptionOfferCodesCustomCodesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionOfferCodesCustomCodesGetToManyRelationshipResponse = zSubscriptionOfferCodeCustomCodesLinkagesResponse;

export const zSubscriptionOfferCodesCustomCodesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionOfferCodeCustomCodes]': z.optional(z.array(z.enum([
            'customCode',
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'offerCode'
        ]))),
        'fields[subscriptionOfferCodes]': z.optional(z.array(z.enum([
            'name',
            'customerEligibilities',
            'offerEligibility',
            'duration',
            'offerMode',
            'numberOfPeriods',
            'totalNumberOfCodes',
            'productionCodeCount',
            'sandboxCodeCount',
            'active',
            'autoRenewEnabled',
            'subscription',
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['offerCode'])))
    }))
});

/**
 * List of SubscriptionOfferCodeCustomCodes
 */
export const zSubscriptionOfferCodesCustomCodesGetToManyRelatedResponse = zSubscriptionOfferCodeCustomCodesResponse;

export const zSubscriptionOfferCodesOneTimeUseCodesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionOfferCodesOneTimeUseCodesGetToManyRelationshipResponse = zSubscriptionOfferCodeOneTimeUseCodesLinkagesResponse;

export const zSubscriptionOfferCodesOneTimeUseCodesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionOfferCodeOneTimeUseCodes]': z.optional(z.array(z.enum([
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'environment',
            'offerCode',
            'values'
        ]))),
        'fields[subscriptionOfferCodes]': z.optional(z.array(z.enum([
            'name',
            'customerEligibilities',
            'offerEligibility',
            'duration',
            'offerMode',
            'numberOfPeriods',
            'totalNumberOfCodes',
            'productionCodeCount',
            'sandboxCodeCount',
            'active',
            'autoRenewEnabled',
            'subscription',
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['offerCode'])))
    }))
});

/**
 * List of SubscriptionOfferCodeOneTimeUseCodes
 */
export const zSubscriptionOfferCodesOneTimeUseCodesGetToManyRelatedResponse = zSubscriptionOfferCodeOneTimeUseCodesResponse;

export const zSubscriptionOfferCodesPricesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionOfferCodesPricesGetToManyRelationshipResponse = zSubscriptionOfferCodePricesLinkagesResponse;

export const zSubscriptionOfferCodesPricesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[subscriptionOfferCodePrices]': z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint']))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        'fields[subscriptionPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'proceedsYear2',
            'territory',
            'equalizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint'])))
    }))
});

/**
 * List of SubscriptionOfferCodePrices
 */
export const zSubscriptionOfferCodesPricesGetToManyRelatedResponse = zSubscriptionOfferCodePricesResponse;

export const zSubscriptionPricePointsEqualizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(8000))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionPricePointsEqualizationsGetToManyRelationshipResponse = zSubscriptionPricePointEqualizationsLinkagesResponse;

export const zSubscriptionPricePointsEqualizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'filter[subscription]': z.optional(z.array(z.string())),
        'fields[subscriptionPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'proceedsYear2',
            'territory',
            'equalizations'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(8000)),
        include: z.optional(z.array(z.enum(['territory'])))
    }))
});

/**
 * List of SubscriptionPricePoints
 */
export const zSubscriptionPricePointsEqualizationsGetToManyRelatedResponse = zSubscriptionPricePointsResponse;

export const zSubscriptionPromotionalOffersPricesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionPromotionalOffersPricesGetToManyRelationshipResponse = zSubscriptionPromotionalOfferPricesLinkagesResponse;

export const zSubscriptionPromotionalOffersPricesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[subscriptionPromotionalOfferPrices]': z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint']))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        'fields[subscriptionPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'proceedsYear2',
            'territory',
            'equalizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint'])))
    }))
});

/**
 * List of SubscriptionPromotionalOfferPrices
 */
export const zSubscriptionPromotionalOffersPricesGetToManyRelatedResponse = zSubscriptionPromotionalOfferPricesResponse;

export const zSubscriptionsAppStoreReviewScreenshotGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zSubscriptionsAppStoreReviewScreenshotGetToOneRelationshipResponse = zSubscriptionAppStoreReviewScreenshotLinkageResponse;

export const zSubscriptionsAppStoreReviewScreenshotGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionAppStoreReviewScreenshots]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'imageAsset',
            'assetToken',
            'assetType',
            'uploadOperations',
            'assetDeliveryState',
            'subscription'
        ]))),
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        include: z.optional(z.array(z.enum(['subscription'])))
    }))
});

/**
 * Single SubscriptionAppStoreReviewScreenshot
 */
export const zSubscriptionsAppStoreReviewScreenshotGetToOneRelatedResponse = zSubscriptionAppStoreReviewScreenshotResponse;

export const zSubscriptionsImagesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionsImagesGetToManyRelationshipResponse = zSubscriptionImagesLinkagesResponse;

export const zSubscriptionsImagesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionImages]': z.optional(z.array(z.enum([
            'fileSize',
            'fileName',
            'sourceFileChecksum',
            'assetToken',
            'imageAsset',
            'uploadOperations',
            'state',
            'subscription'
        ]))),
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['subscription'])))
    }))
});

/**
 * List of SubscriptionImages
 */
export const zSubscriptionsImagesGetToManyRelatedResponse = zSubscriptionImagesResponse;

export const zSubscriptionsIntroductoryOffersDeleteToManyRelationshipData = z.object({
    body: zSubscriptionIntroductoryOffersLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zSubscriptionsIntroductoryOffersDeleteToManyRelationshipResponse = z.void();

export const zSubscriptionsIntroductoryOffersGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionsIntroductoryOffersGetToManyRelationshipResponse = zSubscriptionIntroductoryOffersLinkagesResponse;

export const zSubscriptionsIntroductoryOffersGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[subscriptionIntroductoryOffers]': z.optional(z.array(z.enum([
            'startDate',
            'endDate',
            'duration',
            'offerMode',
            'numberOfPeriods',
            'subscription',
            'territory',
            'subscriptionPricePoint'
        ]))),
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        'fields[subscriptionPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'proceedsYear2',
            'territory',
            'equalizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'subscription',
            'territory',
            'subscriptionPricePoint'
        ])))
    }))
});

/**
 * List of SubscriptionIntroductoryOffers
 */
export const zSubscriptionsIntroductoryOffersGetToManyRelatedResponse = zSubscriptionIntroductoryOffersResponse;

export const zSubscriptionsOfferCodesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionsOfferCodesGetToManyRelationshipResponse = zSubscriptionOfferCodesLinkagesResponse;

export const zSubscriptionsOfferCodesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[subscriptionOfferCodes]': z.optional(z.array(z.enum([
            'name',
            'customerEligibilities',
            'offerEligibility',
            'duration',
            'offerMode',
            'numberOfPeriods',
            'totalNumberOfCodes',
            'productionCodeCount',
            'sandboxCodeCount',
            'active',
            'autoRenewEnabled',
            'subscription',
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        'fields[subscriptionOfferCodeOneTimeUseCodes]': z.optional(z.array(z.enum([
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'environment',
            'offerCode',
            'values'
        ]))),
        'fields[subscriptionOfferCodeCustomCodes]': z.optional(z.array(z.enum([
            'customCode',
            'numberOfCodes',
            'createdDate',
            'expirationDate',
            'active',
            'offerCode'
        ]))),
        'fields[subscriptionOfferCodePrices]': z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum([
            'subscription',
            'oneTimeUseCodes',
            'customCodes',
            'prices'
        ]))),
        'limit[oneTimeUseCodes]': z.optional(z.int().lte(50)),
        'limit[customCodes]': z.optional(z.int().lte(50)),
        'limit[prices]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of SubscriptionOfferCodes
 */
export const zSubscriptionsOfferCodesGetToManyRelatedResponse = zSubscriptionOfferCodesResponse;

export const zSubscriptionsPricePointsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(8000))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionsPricePointsGetToManyRelationshipResponse = zSubscriptionPricePointsLinkagesResponse;

export const zSubscriptionsPricePointsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[subscriptionPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'proceedsYear2',
            'territory',
            'equalizations'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        limit: z.optional(z.int().lte(8000)),
        include: z.optional(z.array(z.enum(['territory'])))
    }))
});

/**
 * List of SubscriptionPricePoints
 */
export const zSubscriptionsPricePointsGetToManyRelatedResponse = zSubscriptionPricePointsResponse;

export const zSubscriptionsPricesDeleteToManyRelationshipData = z.object({
    body: zSubscriptionPricesLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zSubscriptionsPricesDeleteToManyRelationshipResponse = z.void();

export const zSubscriptionsPricesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionsPricesGetToManyRelationshipResponse = zSubscriptionPricesLinkagesResponse;

export const zSubscriptionsPricesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[subscriptionPricePoint]': z.optional(z.array(z.string())),
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[subscriptionPrices]': z.optional(z.array(z.enum([
            'startDate',
            'preserved',
            'territory',
            'subscriptionPricePoint'
        ]))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        'fields[subscriptionPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'proceedsYear2',
            'territory',
            'equalizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint'])))
    }))
});

/**
 * List of SubscriptionPrices
 */
export const zSubscriptionsPricesGetToManyRelatedResponse = zSubscriptionPricesResponse;

export const zSubscriptionsPromotedPurchaseGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zSubscriptionsPromotedPurchaseGetToOneRelationshipResponse = zSubscriptionPromotedPurchaseLinkageResponse;

export const zSubscriptionsPromotedPurchaseGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[promotedPurchases]': z.optional(z.array(z.enum([
            'visibleForAllUsers',
            'enabled',
            'state',
            'inAppPurchaseV2',
            'subscription'
        ]))),
        'fields[inAppPurchases]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'inAppPurchaseType',
            'state',
            'reviewNote',
            'familySharable',
            'contentHosting',
            'inAppPurchaseLocalizations',
            'pricePoints',
            'content',
            'appStoreReviewScreenshot',
            'promotedPurchase',
            'iapPriceSchedule',
            'inAppPurchaseAvailability',
            'images',
            'offerCodes'
        ]))),
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        include: z.optional(z.array(z.enum(['inAppPurchaseV2', 'subscription'])))
    }))
});

/**
 * Single PromotedPurchase
 */
export const zSubscriptionsPromotedPurchaseGetToOneRelatedResponse = zPromotedPurchaseResponse;

export const zSubscriptionsPromotionalOffersGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionsPromotionalOffersGetToManyRelationshipResponse = zSubscriptionPromotionalOffersLinkagesResponse;

export const zSubscriptionsPromotionalOffersGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[subscriptionPromotionalOffers]': z.optional(z.array(z.enum([
            'duration',
            'name',
            'numberOfPeriods',
            'offerCode',
            'offerMode',
            'subscription',
            'prices'
        ]))),
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        'fields[subscriptionPromotionalOfferPrices]': z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['subscription', 'prices']))),
        'limit[prices]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of SubscriptionPromotionalOffers
 */
export const zSubscriptionsPromotionalOffersGetToManyRelatedResponse = zSubscriptionPromotionalOffersResponse;

export const zSubscriptionsSubscriptionAvailabilityGetToOneRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Related linkage
 */
export const zSubscriptionsSubscriptionAvailabilityGetToOneRelationshipResponse = zSubscriptionSubscriptionAvailabilityLinkageResponse;

export const zSubscriptionsSubscriptionAvailabilityGetToOneRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionAvailabilities]': z.optional(z.array(z.enum(['availableInNewTerritories', 'availableTerritories']))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        include: z.optional(z.array(z.enum(['availableTerritories']))),
        'limit[availableTerritories]': z.optional(z.int().lte(50))
    }))
});

/**
 * Single SubscriptionAvailability
 */
export const zSubscriptionsSubscriptionAvailabilityGetToOneRelatedResponse = zSubscriptionAvailabilityResponse;

export const zSubscriptionsSubscriptionLocalizationsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionsSubscriptionLocalizationsGetToManyRelationshipResponse = zSubscriptionSubscriptionLocalizationsLinkagesResponse;

export const zSubscriptionsSubscriptionLocalizationsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[subscriptionLocalizations]': z.optional(z.array(z.enum([
            'name',
            'locale',
            'description',
            'state',
            'subscription'
        ]))),
        'fields[subscriptions]': z.optional(z.array(z.enum([
            'name',
            'productId',
            'familySharable',
            'state',
            'subscriptionPeriod',
            'reviewNote',
            'groupLevel',
            'subscriptionLocalizations',
            'appStoreReviewScreenshot',
            'group',
            'introductoryOffers',
            'promotionalOffers',
            'offerCodes',
            'prices',
            'pricePoints',
            'promotedPurchase',
            'subscriptionAvailability',
            'winBackOffers',
            'images'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['subscription'])))
    }))
});

/**
 * List of SubscriptionLocalizations
 */
export const zSubscriptionsSubscriptionLocalizationsGetToManyRelatedResponse = zSubscriptionLocalizationsResponse;

export const zSubscriptionsWinBackOffersGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zSubscriptionsWinBackOffersGetToManyRelationshipResponse = zSubscriptionWinBackOffersLinkagesResponse;

export const zSubscriptionsWinBackOffersGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[winBackOffers]': z.optional(z.array(z.enum([
            'referenceName',
            'offerId',
            'duration',
            'offerMode',
            'periodCount',
            'customerEligibilityPaidSubscriptionDurationInMonths',
            'customerEligibilityTimeSinceLastSubscribedInMonths',
            'customerEligibilityWaitBetweenOffersInMonths',
            'startDate',
            'endDate',
            'priority',
            'promotionIntent',
            'prices'
        ]))),
        'fields[winBackOfferPrices]': z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint']))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['prices']))),
        'limit[prices]': z.optional(z.int().lte(50))
    }))
});

/**
 * List of WinBackOffers
 */
export const zSubscriptionsWinBackOffersGetToManyRelatedResponse = zWinBackOffersResponse;

export const zUserInvitationsVisibleAppsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zUserInvitationsVisibleAppsGetToManyRelationshipResponse = zUserInvitationVisibleAppsLinkagesResponse;

export const zUserInvitationsVisibleAppsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Apps with get
 */
export const zUserInvitationsVisibleAppsGetToManyRelatedResponse = zAppsWithoutIncludesResponse;

export const zUsersVisibleAppsDeleteToManyRelationshipData = z.object({
    body: zUserVisibleAppsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zUsersVisibleAppsDeleteToManyRelationshipResponse = z.void();

export const zUsersVisibleAppsGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zUsersVisibleAppsGetToManyRelationshipResponse = zUserVisibleAppsLinkagesResponse;

export const zUsersVisibleAppsReplaceToManyRelationshipData = z.object({
    body: zUserVisibleAppsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zUsersVisibleAppsReplaceToManyRelationshipResponse = z.void();

export const zUsersVisibleAppsCreateToManyRelationshipData = z.object({
    body: zUserVisibleAppsLinkagesRequest,
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Success (no content)
 */
export const zUsersVisibleAppsCreateToManyRelationshipResponse = z.void();

export const zUsersVisibleAppsGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'fields[apps]': z.optional(z.array(z.enum([
            'accessibilityUrl',
            'name',
            'bundleId',
            'sku',
            'primaryLocale',
            'isOrEverWasMadeForKids',
            'subscriptionStatusUrl',
            'subscriptionStatusUrlVersion',
            'subscriptionStatusUrlForSandbox',
            'subscriptionStatusUrlVersionForSandbox',
            'contentRightsDeclaration',
            'streamlinedPurchasingEnabled',
            'accessibilityDeclarations',
            'appEncryptionDeclarations',
            'appStoreIcon',
            'ciProduct',
            'betaTesters',
            'betaGroups',
            'appStoreVersions',
            'appTags',
            'preReleaseVersions',
            'betaAppLocalizations',
            'builds',
            'betaLicenseAgreement',
            'betaAppReviewDetail',
            'appInfos',
            'appClips',
            'appPricePoints',
            'endUserLicenseAgreement',
            'appPriceSchedule',
            'appAvailabilityV2',
            'inAppPurchases',
            'subscriptionGroups',
            'gameCenterEnabledVersions',
            'perfPowerMetrics',
            'appCustomProductPages',
            'inAppPurchasesV2',
            'promotedPurchases',
            'appEvents',
            'reviewSubmissions',
            'subscriptionGracePeriod',
            'customerReviews',
            'customerReviewSummarizations',
            'gameCenterDetail',
            'appStoreVersionExperimentsV2',
            'alternativeDistributionKey',
            'analyticsReportRequests',
            'marketplaceSearchDetail',
            'buildUploads',
            'backgroundAssets',
            'betaFeedbackScreenshotSubmissions',
            'betaFeedbackCrashSubmissions',
            'searchKeywords',
            'webhooks',
            'androidToIosAppMappingDetails'
        ]))),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of Apps with get
 */
export const zUsersVisibleAppsGetToManyRelatedResponse = zAppsWithoutIncludesResponse;

export const zWebhooksDeliveriesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zWebhooksDeliveriesGetToManyRelationshipResponse = zWebhookDeliveriesLinkagesResponse;

export const zWebhooksDeliveriesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[deliveryState]': z.optional(z.array(z.enum([
            'SUCCEEDED',
            'FAILED',
            'PENDING'
        ]))),
        'filter[createdDateGreaterThanOrEqualTo]': z.optional(z.array(z.string())),
        'filter[createdDateLessThan]': z.optional(z.array(z.string())),
        'fields[webhookDeliveries]': z.optional(z.array(z.enum([
            'createdDate',
            'deliveryState',
            'errorMessage',
            'redelivery',
            'sentDate',
            'request',
            'response',
            'event'
        ]))),
        'fields[webhookEvents]': z.optional(z.array(z.enum([
            'eventType',
            'payload',
            'ping',
            'createdDate'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['event'])))
    }))
});

/**
 * List of WebhookDeliveries
 */
export const zWebhooksDeliveriesGetToManyRelatedResponse = zWebhookDeliveriesResponse;

export const zWinBackOffersPricesGetToManyRelationshipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * List of related linkages
 */
export const zWinBackOffersPricesGetToManyRelationshipResponse = zWinBackOfferPricesLinkagesResponse;

export const zWinBackOffersPricesGetToManyRelatedData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        'filter[territory]': z.optional(z.array(z.string())),
        'fields[winBackOfferPrices]': z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint']))),
        'fields[territories]': z.optional(z.array(z.enum(['currency']))),
        'fields[subscriptionPricePoints]': z.optional(z.array(z.enum([
            'customerPrice',
            'proceeds',
            'proceedsYear2',
            'territory',
            'equalizations'
        ]))),
        limit: z.optional(z.int().lte(200)),
        include: z.optional(z.array(z.enum(['territory', 'subscriptionPricePoint'])))
    }))
});

/**
 * List of WinBackOfferPrices
 */
export const zWinBackOffersPricesGetToManyRelatedResponse = zWinBackOfferPricesResponse;

export const zAppsBetaTesterUsagesGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        period: z.optional(z.enum([
            'P7D',
            'P30D',
            'P90D',
            'P365D'
        ])),
        groupBy: z.optional(z.array(z.enum(['betaTesters']))),
        'filter[betaTesters]': z.optional(z.string()),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * Metrics data response
 */
export const zAppsBetaTesterUsagesGetMetricsResponse = zAppsBetaTesterUsagesV1MetricResponse;

export const zBetaGroupsBetaTesterUsagesGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        period: z.optional(z.enum([
            'P7D',
            'P30D',
            'P90D',
            'P365D'
        ])),
        groupBy: z.optional(z.array(z.enum(['betaTesters']))),
        'filter[betaTesters]': z.optional(z.string()),
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * Metrics data response
 */
export const zBetaGroupsBetaTesterUsagesGetMetricsResponse = zAppsBetaTesterUsagesV1MetricResponse;

export const zBetaGroupsPublicLinkUsagesGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * Metrics data response
 */
export const zBetaGroupsPublicLinkUsagesGetMetricsResponse = zBetaPublicLinkUsagesV1MetricResponse;

export const zBetaTestersBetaTesterUsagesGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.object({
        period: z.optional(z.enum([
            'P7D',
            'P30D',
            'P90D',
            'P365D'
        ])),
        'filter[apps]': z.string(),
        limit: z.optional(z.int().lte(200))
    })
});

/**
 * Metrics data response
 */
export const zBetaTestersBetaTesterUsagesGetMetricsResponse = zBetaTesterUsagesV1MetricResponse;

export const zBuildsBetaBuildUsagesGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        limit: z.optional(z.int().lte(200))
    }))
});

/**
 * Metrics data response
 */
export const zBuildsBetaBuildUsagesGetMetricsResponse = zBetaBuildUsagesV1MetricResponse;

export const zGameCenterDetailsClassicMatchmakingRequestsGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.object({
        granularity: z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]),
        groupBy: z.optional(z.array(z.enum(['result']))),
        'filter[result]': z.optional(z.enum([
            'MATCHED',
            'CANCELED',
            'EXPIRED'
        ])),
        sort: z.optional(z.array(z.enum([
            'count',
            '-count',
            'averageSecondsInQueue',
            '-averageSecondsInQueue',
            'p50SecondsInQueue',
            '-p50SecondsInQueue',
            'p95SecondsInQueue',
            '-p95SecondsInQueue'
        ]))),
        limit: z.optional(z.int().lte(200))
    })
});

/**
 * Metrics data response
 */
export const zGameCenterDetailsClassicMatchmakingRequestsGetMetricsResponse = zGameCenterMatchmakingAppRequestsV1MetricResponse;

export const zGameCenterDetailsRuleBasedMatchmakingRequestsGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.object({
        granularity: z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]),
        groupBy: z.optional(z.array(z.enum(['result']))),
        'filter[result]': z.optional(z.enum([
            'MATCHED',
            'CANCELED',
            'EXPIRED'
        ])),
        sort: z.optional(z.array(z.enum([
            'count',
            '-count',
            'averageSecondsInQueue',
            '-averageSecondsInQueue',
            'p50SecondsInQueue',
            '-p50SecondsInQueue',
            'p95SecondsInQueue',
            '-p95SecondsInQueue'
        ]))),
        limit: z.optional(z.int().lte(200))
    })
});

/**
 * Metrics data response
 */
export const zGameCenterDetailsRuleBasedMatchmakingRequestsGetMetricsResponse = zGameCenterMatchmakingAppRequestsV1MetricResponse;

export const zGameCenterMatchmakingQueuesExperimentMatchmakingQueueSizesGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.object({
        granularity: z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]),
        sort: z.optional(z.array(z.enum([
            'count',
            '-count',
            'averageNumberOfRequests',
            '-averageNumberOfRequests',
            'p50NumberOfRequests',
            '-p50NumberOfRequests',
            'p95NumberOfRequests',
            '-p95NumberOfRequests'
        ]))),
        limit: z.optional(z.int().lte(200))
    })
});

/**
 * Metrics data response
 */
export const zGameCenterMatchmakingQueuesExperimentMatchmakingQueueSizesGetMetricsResponse = zGameCenterMatchmakingQueueSizesV1MetricResponse;

export const zGameCenterMatchmakingQueuesExperimentMatchmakingRequestsGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.object({
        granularity: z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]),
        groupBy: z.optional(z.array(z.enum(['result', 'gameCenterDetail']))),
        'filter[result]': z.optional(z.enum([
            'MATCHED',
            'CANCELED',
            'EXPIRED'
        ])),
        'filter[gameCenterDetail]': z.optional(z.string()),
        sort: z.optional(z.array(z.enum([
            'count',
            '-count',
            'averageSecondsInQueue',
            '-averageSecondsInQueue',
            'p50SecondsInQueue',
            '-p50SecondsInQueue',
            'p95SecondsInQueue',
            '-p95SecondsInQueue'
        ]))),
        limit: z.optional(z.int().lte(200))
    })
});

/**
 * Metrics data response
 */
export const zGameCenterMatchmakingQueuesExperimentMatchmakingRequestsGetMetricsResponse = zGameCenterMatchmakingQueueRequestsV1MetricResponse;

export const zGameCenterMatchmakingQueuesMatchmakingQueueSizesGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.object({
        granularity: z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]),
        sort: z.optional(z.array(z.enum([
            'count',
            '-count',
            'averageNumberOfRequests',
            '-averageNumberOfRequests',
            'p50NumberOfRequests',
            '-p50NumberOfRequests',
            'p95NumberOfRequests',
            '-p95NumberOfRequests'
        ]))),
        limit: z.optional(z.int().lte(200))
    })
});

/**
 * Metrics data response
 */
export const zGameCenterMatchmakingQueuesMatchmakingQueueSizesGetMetricsResponse = zGameCenterMatchmakingQueueSizesV1MetricResponse;

export const zGameCenterMatchmakingQueuesMatchmakingRequestsGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.object({
        granularity: z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]),
        groupBy: z.optional(z.array(z.enum(['result', 'gameCenterDetail']))),
        'filter[result]': z.optional(z.enum([
            'MATCHED',
            'CANCELED',
            'EXPIRED'
        ])),
        'filter[gameCenterDetail]': z.optional(z.string()),
        sort: z.optional(z.array(z.enum([
            'count',
            '-count',
            'averageSecondsInQueue',
            '-averageSecondsInQueue',
            'p50SecondsInQueue',
            '-p50SecondsInQueue',
            'p95SecondsInQueue',
            '-p95SecondsInQueue'
        ]))),
        limit: z.optional(z.int().lte(200))
    })
});

/**
 * Metrics data response
 */
export const zGameCenterMatchmakingQueuesMatchmakingRequestsGetMetricsResponse = zGameCenterMatchmakingQueueRequestsV1MetricResponse;

export const zGameCenterMatchmakingQueuesMatchmakingSessionsGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.object({
        granularity: z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]),
        sort: z.optional(z.array(z.enum([
            'count',
            '-count',
            'averagePlayerCount',
            '-averagePlayerCount',
            'p50PlayerCount',
            '-p50PlayerCount',
            'p95PlayerCount',
            '-p95PlayerCount'
        ]))),
        limit: z.optional(z.int().lte(200))
    })
});

/**
 * Metrics data response
 */
export const zGameCenterMatchmakingQueuesMatchmakingSessionsGetMetricsResponse = zGameCenterMatchmakingSessionsV1MetricResponse;

export const zGameCenterMatchmakingRulesMatchmakingBooleanRuleResultsGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.object({
        granularity: z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]),
        groupBy: z.optional(z.array(z.enum(['result', 'gameCenterMatchmakingQueue']))),
        'filter[result]': z.optional(z.string()),
        'filter[gameCenterMatchmakingQueue]': z.optional(z.string()),
        sort: z.optional(z.array(z.enum(['count', '-count']))),
        limit: z.optional(z.int().lte(200))
    })
});

/**
 * Metrics data response
 */
export const zGameCenterMatchmakingRulesMatchmakingBooleanRuleResultsGetMetricsResponse = zGameCenterMatchmakingBooleanRuleResultsV1MetricResponse;

export const zGameCenterMatchmakingRulesMatchmakingNumberRuleResultsGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.object({
        granularity: z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]),
        groupBy: z.optional(z.array(z.enum(['gameCenterMatchmakingQueue']))),
        'filter[gameCenterMatchmakingQueue]': z.optional(z.string()),
        sort: z.optional(z.array(z.enum([
            'count',
            '-count',
            'averageResult',
            '-averageResult',
            'p50Result',
            '-p50Result',
            'p95Result',
            '-p95Result'
        ]))),
        limit: z.optional(z.int().lte(200))
    })
});

/**
 * Metrics data response
 */
export const zGameCenterMatchmakingRulesMatchmakingNumberRuleResultsGetMetricsResponse = zGameCenterMatchmakingNumberRuleResultsV1MetricResponse;

export const zGameCenterMatchmakingRulesMatchmakingRuleErrorsGetMetricsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.object({
        granularity: z.enum([
            'P1D',
            'PT1H',
            'PT15M'
        ]),
        groupBy: z.optional(z.array(z.enum(['gameCenterMatchmakingQueue']))),
        'filter[gameCenterMatchmakingQueue]': z.optional(z.string()),
        sort: z.optional(z.array(z.enum(['count', '-count']))),
        limit: z.optional(z.int().lte(200))
    })
});

/**
 * Metrics data response
 */
export const zGameCenterMatchmakingRulesMatchmakingRuleErrorsGetMetricsResponse = zGameCenterMatchmakingRuleErrorsV1MetricResponse;
